import sportsImg1 from '../../src/assets/sport-img1.png';
import archeryIcon from '../../src/assets/ServiceIcons/archery.png';
import baseballIcon from '../../src/assets/ServiceIcons/baseball.png';
import badmintonIcon from '../../src/assets/ServiceIcons/badminton.png';
import basketballIcon from '../../src/assets/ServiceIcons/basketball.png';
import bowlingIcon from '../../src/assets/ServiceIcons/bowling.png';
import coachIcon from '../../src/assets/ServiceIcons/coach.svg';
import canoeingKayakingIcon from '../../src/assets/ServiceIcons/canoeingkayaking.png';
import cheerleadingIcon from '../../src/assets/ServiceIcons/cheerleading.png';
import cornholeIcon from '../../src/assets/ServiceIcons/cornhole.png';
import crossCountryIcon from '../../src/assets/ServiceIcons/crossCountry.png';
import cyclingIcon from '../../src/assets/ServiceIcons/cycling.png';
import dartIcon from '../../src/assets/ServiceIcons/darts.svg';
import danceIcon from '../../src/assets/ServiceIcons/dance.png';
import dodgeballIcon from '../../src/assets/ServiceIcons/dodgeball.png';
import dragonBoatRacingIcon from '../../src/assets/ServiceIcons/dragonboatracing.png';
import equestrianIcon from '../../src/assets/ServiceIcons/equestrian.png';
import esportsIcon from '../../src/assets/ServiceIcons/esports.png';
import fencingIcon from '../../src/assets/ServiceIcons/fencing.png';
import flagfootballIcon from '../../src/assets/ServiceIcons/flagfootball.png';
import footballIcon from '../../src/assets/ServiceIcons/football.png';
import frisbeeGolfIcon from '../../src/assets/ServiceIcons/frisbeegolf.png';
import golfIcon from '../../src/assets/ServiceIcons/golf.png';
import gymnasticsIcon from '../../src/assets/ServiceIcons/gymnastics.png';
import iceHockeyIcon from '../../src/assets/ServiceIcons/iceHockey.png';
import influencerIcon from '../../src/assets/ServiceIcons/influencer.png';
import actorsIcon from '../../src/assets/ServiceIcons/actors.png';
import tvPersonalitiesIcon from '../../src/assets/ServiceIcons/TVpersonalities1.svg';
import businesspeopleIcon from '../../src/assets/ServiceIcons/businesspeople1.svg';
import politiciansIcon from '../../src/assets/ServiceIcons/politician1.svg';
import writersProducersIcon from '../../src/assets/ServiceIcons/writersproducers.svg';
import authorsIcon from '../../src/assets/ServiceIcons/author1.svg';
import modelsIcon from '../../src/assets/ServiceIcons/model1.svg';

import judoIcon from '../../src/assets/ServiceIcons/judo.png';
import karateIcon from '../../src/assets/ServiceIcons/karate.png';
import kickballIcon from '../../src/assets/ServiceIcons/kickball.png';
import swimmingIcon from '../../src/assets/ServiceIcons/swimming.png';
import lacrosseIcon from '../../src/assets/ServiceIcons/lacrosse.png';
import musiciansIcon from '../../src/assets/ServiceIcons/musicians.png';
import paddleballIcon from '../../src/assets/ServiceIcons/paddleball.png';
import pickleballIcon from '../../src/assets/ServiceIcons/pickleball.png';
import quadballQuidditchIcon from '../../src/assets/ServiceIcons/quadballquidditch.png';
import racquetballIcon from '../../src/assets/ServiceIcons/racquetball.png';
import rifleIcon from '../../src/assets/ServiceIcons/rifle.png';
import rockClimbingIcon from '../../src/assets/ServiceIcons/rockClimbing.png';
import rowingIcon from '../../src/assets/ServiceIcons/rowing.png';
import rugbyIcon from '../../src/assets/ServiceIcons/rugby.png';
import sailingIcon from '../../src/assets/ServiceIcons/sailing.png';
import squashIcon from '../../src/assets/ServiceIcons/icons8-squash-480.png';
import skiingIcon from '../../src/assets/ServiceIcons/skiing.png';
import snowboardingIcon from '../../src/assets/ServiceIcons/snowboarding.png';
import soccerIcon from '../../src/assets/ServiceIcons/Soccer.png';
import softballIcon from '../../src/assets/ServiceIcons/softball.png';
import spikeballIcon from '../../src/assets/ServiceIcons/spikeball.png';
import synchronizedSwimmingIcon from '../../src/assets/ServiceIcons/synchronizedswimming.png';
import tableTennisIcon from '../../src/assets/ServiceIcons/tableTennis.png';
import taekwondoIcon from '../../src/assets/ServiceIcons/taekwondo.png';
import tennisIcon from '../../src/assets/ServiceIcons/tennis.png';
import trackAndFieldIcon from '../../src/assets/ServiceIcons/trackAndField.png';
import triathlonIcon from '../../src/assets/ServiceIcons/triathlon.png';
import ultimateFrisbeeIcon from '../../src/assets/ServiceIcons/ultimatefrisbee.png';
import volleyballIcon from '../../src/assets/ServiceIcons/volleyball.png';
import waterpoloIcon from '../../src/assets/ServiceIcons/waterpolo.png';
import weightliftingIcon from '../../src/assets/ServiceIcons/weightlifting.png';
import wiffleballIcon from '../../src/assets/ServiceIcons/wiffleball.png';
import wrestlingIcon from '../../src/assets/ServiceIcons/wrestling.png';
import fieldHockey2Icon from '../../src/assets/ServiceIcons/fieldhockey2.png';
import boxingIcon from '../../src/assets/ServiceIcons/boxing.png';
import bmxIcon from '../../src/assets/ServiceIcons/bmx.png';
import cricketIcon from '../../src/assets/ServiceIcons/cricket.png';
import curlingIcon from '../../src/assets/ServiceIcons/curling.png';
import carracingIcon from '../../src/assets/ServiceIcons/carracing.png';
import handballIcon from '../../src/assets/ServiceIcons/handball.png';
import iceskatingIcon from '../../src/assets/ServiceIcons/iceskating.png';
import mmaIcon from '../../src/assets/ServiceIcons/mma.png';
import slapfightingIcon from '../../src/assets/ServiceIcons/slapfighting.png';
import motosportsIcon from '../../src/assets/ServiceIcons/motosports.png';
import raftingIcon from '../../src/assets/ServiceIcons/rafting.png';
import rollerskatingIcon from '../../src/assets/ServiceIcons/rollerskating.png';
import skateboardingIcon from '../../src/assets/ServiceIcons/skateboarding1.png';
import surfingIcon from '../../src/assets/ServiceIcons/surfing.png';
import waterskiingIcon from '../../src/assets/ServiceIcons/waterskiings.png';
import billiardsIcon from '../../src/assets/ServiceIcons/billiards.png';
import womensWrestlingIcon from '../../src/assets/ServiceIcons/womensWrestling.png';
import rollerDerbyIcon from '../../src/assets/ServiceIcons/rollerDerby.png';

export const browseTalentFilters = [
  { key: 'viewall', label: 'View all' },
  { key: 'acting', label: 'Acting' },
  { key: 'astronomy', label: 'Astronomy' },
  { key: 'football', label: 'Football' },
  { key: 'dance', label: 'Dance' },
  { key: 'basketball', label: 'Basketball' },
  { key: 'diving', label: 'Diving' },
];

export const talentOptions = [
  { key: 'musician', label: 'Musician', isFeatured: true },
  { key: 'influencer', label: 'Influencer', isFeatured: true },
];

// Define the desired order of sports keys
export const sportsOrder = [
  'football',
  'mens-basketball',
  'womens-basketball',
  'womens-soccer',
  'baseball',
  'softball',
  'mens-soccer',
  'womens-gymnastics',
  'womens-volleyball',
  'mens-volleyball',
  'womens-swimming-and-diving',
  'mens-swimming-and-diving',
];

export const sportsOptions = [
  { key: 'influencers-creators', label: 'Influencers/ Creators', banner: influencerIcon },
  { key: 'e-sports-gamers', label: 'E-Sports/ Gamers', banner: esportsIcon },
  { key: 'actors-actresses', label: 'Actors/ Actresses', banner: actorsIcon },
  { key: 'tv-personalities', label: 'TV Personalities', banner: tvPersonalitiesIcon },
  { key: 'businesspeople', label: 'Business People', banner: businesspeopleIcon },
  { key: 'politicians', label: 'Politicians', banner: politiciansIcon },
  { key: 'writers-producers', label: 'Writers/ Producers', banner: writersProducersIcon },
  { key: 'authors', label: 'Authors', banner: authorsIcon },
  { key: 'models', label: 'Models', banner: modelsIcon },
  { key: 'musicians', label: 'Musicians', banner: musiciansIcon },
  {
    key: 'baseball',
    label: 'Baseball',
    isFeatured: true,
    banner: baseballIcon,
    isMens: true,
  },
  {
    key: 'mens-basketball',
    label: "Men's Basketball",
    isFeatured: true,
    banner: basketballIcon,
  },
  { key: 'mens-boxing', label: "Men's Boxing", banner: boxingIcon, isMens: true },
  { key: 'womens-boxing', label: "Women's Boxing", banner: boxingIcon, isWomens: true },
  { key: 'bmx', label: 'BMX', banner: bmxIcon },
  { key: 'cricket', label: 'Cricket', banner: cricketIcon },
  { key: 'curling', label: 'Curling', banner: curlingIcon },
  { key: 'car-racing', label: 'Car Racing', banner: carracingIcon },
  { key: 'handball', label: 'Handball', banner: handballIcon },
  { key: 'ice-skating', label: 'Ice Skating', banner: iceskatingIcon },
  { key: 'mma-ufc', label: 'MMA/UFC', banner: mmaIcon },
  { key: 'slap-fighting', label: 'Slap Fighting', banner: slapfightingIcon },
  { key: 'motosports', label: 'Motosports', banner: motosportsIcon },
  { key: 'rafting', label: 'Rafting', banner: raftingIcon },
  { key: 'rollerskating', label: 'Rollerskating', banner: rollerskatingIcon },
  { key: 'skateboarding', label: 'Skateboarding', banner: skateboardingIcon },
  { key: 'surfing', label: 'Surfing', banner: surfingIcon },
  { key: 'waterskiing', label: 'Waterskiing', banner: waterskiingIcon },
  { key: 'pool-billiards', label: 'Pool/Billiards', banner: billiardsIcon },
  {
    key: 'womens-wrestling',
    label: "Women's Wrestling",
    banner: womensWrestlingIcon,
    isWomens: true,
  },
  { key: 'roller-derby', label: 'Roller Derby', banner: rollerDerbyIcon },
  { key: 'mens-cross-country', label: "Men's Cross Country", banner: crossCountryIcon },
  { key: 'mens-fencing', label: "Men's Fencing", banner: fencingIcon },
  {
    key: 'mens-football',
    label: 'Football',
    isFeatured: true,
    banner: footballIcon,
    isMens: true,
  },
  { key: 'mens-golf', label: "Men's Golf", banner: golfIcon },
  { key: 'mens-gymnastics', label: "Men's Gymnastics", banner: gymnasticsIcon },
  { key: 'mens-ice-hockey', label: "Men's Ice Hockey", banner: iceHockeyIcon },
  { key: 'mens-lacrosse', label: "Men's Lacrosse", banner: lacrosseIcon },
  { key: 'mens-rifle', label: "Men's Rifle", banner: rifleIcon },
  { key: 'mens-rowing', label: "Men's Rowing", banner: rowingIcon },
  { key: 'mens-skiing', label: "Men's Skiing", banner: skiingIcon },
  { key: 'mens-soccer', label: "Men's Soccer", isFeatured: true, banner: soccerIcon },
  {
    key: 'mens-swimming-and-diving',
    label: "Men's Swimming & Diving",
    isFeatured: true,
    banner: swimmingIcon,
  },
  { key: 'mens-tennis', label: "Men's Tennis", banner: tennisIcon },
  { key: 'mens-track-and-field', label: "Men's Track and Field", banner: trackAndFieldIcon },
  {
    key: 'mens-volleyball',
    label: "Men's Volleyball",
    isFeatured: true,
    banner: volleyballIcon,
  },
  { key: 'mens-water-polo', label: "Men's Water Polo", banner: waterpoloIcon },
  { key: 'mens-wrestling', label: "Men's Wrestling", banner: wrestlingIcon },
  {
    key: 'womens-basketball',
    label: "Women's Basketball",
    isFeatured: true,
    banner: basketballIcon,
  },
  {
    key: 'womens-beach-volleyball',
    label: "Women's Beach Volleyball",
    banner: volleyballIcon,
  },
  { key: 'womens-bowling', label: "Women's Bowling", banner: bowlingIcon },
  { key: 'womens-cross-country', label: "Women's Cross Country", banner: crossCountryIcon },
  { key: 'womens-fencing', label: "Women's Fencing", banner: fencingIcon },
  { key: 'womens-field-hockey', label: "Women's Field Hockey", banner: fieldHockey2Icon },
  { key: 'womens-golf', label: "Women's Golf", banner: golfIcon },
  {
    key: 'womens-gymnastics',
    label: "Women's Gymnastics",
    isFeatured: true,
    banner: gymnasticsIcon,
  },
  { key: 'womens-ice-hockey', label: "Women's Ice Hockey", banner: iceHockeyIcon },
  { key: 'womens-lacrosse', label: "Women's Lacrosse", banner: lacrosseIcon },
  { key: 'womens-rifle', label: "Women's Rifle", banner: rifleIcon },
  { key: 'womens-rowing', label: "Women's Rowing", banner: rowingIcon },
  { key: 'womens-skiing', label: "Women's Skiing", banner: skiingIcon },
  { key: 'womens-soccer', label: "Women's Soccer", isFeatured: true, banner: soccerIcon },
  { key: 'softball', label: 'Softball', isFeatured: true, banner: softballIcon },
  {
    key: 'womens-swimming-and-diving',
    label: "Women's Swimming & Diving",
    isFeatured: true,
    isWomens: true,
    banner: swimmingIcon,
  },
  {
    key: 'synchronized-swimming',
    label: 'Synchronized Swimming',
    isWomens: true,
    banner: synchronizedSwimmingIcon,
  },
  { key: 'womens-tennis', label: "Women's Tennis", banner: tennisIcon },
  {
    key: 'womens-track-and-field',
    label: "Women's Track and Field",
    banner: trackAndFieldIcon,
  },
  { key: 'triathlon', label: 'Triathlon', banner: triathlonIcon },
  {
    key: 'womens-volleyball',
    label: "Women's Volleyball",
    isFeatured: true,
    banner: volleyballIcon,
  },
  { key: 'womens-water-polo', label: "Women's Water Polo", banner: waterpoloIcon },
  { key: 'equestrian', label: 'Equestrian', banner: equestrianIcon },
  { key: 'sailing', label: 'Sailing', banner: sailingIcon },
  { key: 'archery', label: 'Archery', banner: archeryIcon },
  { key: 'badminton', label: 'Badminton', banner: badmintonIcon },
  { key: 'bowling', label: 'Bowling', banner: bowlingIcon },
  { key: 'cheerleading', label: 'Cheerleading', banner: cheerleadingIcon },
  { key: 'cycling', label: 'Cycling', banner: cyclingIcon },
  { key: 'coaches', label: 'Coaches', banner: coachIcon },
  { key: 'dart', label: 'Darts', banner: dartIcon },
  { key: 'dance', label: 'Dance', banner: danceIcon },
  { key: 'fencing', label: 'Fencing', banner: fencingIcon },
  { key: 'judo', label: 'Judo', banner: judoIcon },
  { key: 'karate', label: 'Karate', banner: karateIcon },
  { key: 'racquetball', label: 'Racquetball', banner: racquetballIcon },
  { key: 'rock-climbing', label: 'Rock Climbing', banner: rockClimbingIcon },
  { key: 'rugby', label: 'Rugby', banner: rugbyIcon },
  { key: 'squash', label: 'Squash', banner: squashIcon },
  { key: 'table-tennis', label: 'Table Tennis', banner: tableTennisIcon },
  { key: 'taekwondo', label: 'Taekwondo', banner: taekwondoIcon },
  { key: 'ultimate-frisbee', label: 'Ultimate Frisbee', banner: ultimateFrisbeeIcon },
  { key: 'weightlifting', label: 'Weightlifting', banner: weightliftingIcon },
  { key: 'spikeball', label: 'Spikeball', banner: spikeballIcon },
  { key: 'quadball-quidditch', label: 'Quadball/ Quidditch', banner: quadballQuidditchIcon },
  { key: 'cornhole', label: 'Cornhole', banner: cornholeIcon },
  {
    key: 'frisbee-golf-disc-golf',
    label: 'Frisbee Golf (Disc Golf)',
    banner: frisbeeGolfIcon,
  },
  { key: 'paddle-tennis', label: 'Paddle Tennis', banner: paddleballIcon },
  { key: 'pickleball', label: 'Pickleball', banner: pickleballIcon },
  { key: 'snowboarding', label: 'Snowboarding', banner: snowboardingIcon },
  { key: 'dodgeball', label: 'Dodgeball', banner: dodgeballIcon },
  { key: 'kickball', label: 'Kickball', banner: kickballIcon },
  { key: 'flag-football', label: 'Flag Football', banner: flagfootballIcon },
  { key: 'indoor-soccer', label: 'Indoor Soccer', banner: soccerIcon },
  { key: '3-on-3-basketball', label: '3-on-3 Basketball', banner: basketballIcon },
  { key: 'wiffle-ball', label: 'Wiffle Ball', banner: wiffleballIcon },
  { key: 'canoeing-kayaking', label: 'Canoeing/Kayaking', banner: canoeingKayakingIcon },
  { key: 'dragon-boat-racing', label: 'Dragon Boat Racing', banner: dragonBoatRacingIcon },
].sort((a, b) => a.label.localeCompare(b.label));

export const extraUserTypeOptions = [
  { userType: 'talent', labelId: 'FieldSelectUserType.talent.description' },
  { userType: 'brand', labelId: 'FieldSelectUserType.brand.description' },
  { userType: 'agency', labelId: 'FieldSelectUserType.agency.description' },
  { userType: 'school', labelId: 'FieldSelectUserType.school.description' },
  { userType: 'fan', labelId: 'FieldSelectUserType.fan.description' },
];

export const stateTerritoryOptions = [
  { key: 'AL', label: 'Alabama' },
  { key: 'AK', label: 'Alaska' },
  { key: 'AZ', label: 'Arizona' },
  { key: 'AR', label: 'Arkansas' },
  { key: 'CA', label: 'California' },
  { key: 'CO', label: 'Colorado' },
  { key: 'CT', label: 'Connecticut' },
  { key: 'DE', label: 'Delaware' },
  { key: 'FL', label: 'Florida' },
  { key: 'GA', label: 'Georgia' },
  { key: 'HI', label: 'Hawaii' },
  { key: 'ID', label: 'Idaho' },
  { key: 'IL', label: 'Illinois' },
  { key: 'IN', label: 'Indiana' },
  { key: 'IA', label: 'Iowa' },
  { key: 'KS', label: 'Kansas' },
  { key: 'KY', label: 'Kentucky' },
  { key: 'LA', label: 'Louisiana' },
  { key: 'ME', label: 'Maine' },
  { key: 'MD', label: 'Maryland' },
  { key: 'MA', label: 'Massachusetts' },
  { key: 'MI', label: 'Michigan' },
  { key: 'MN', label: 'Minnesota' },
  { key: 'MS', label: 'Mississippi' },
  { key: 'MO', label: 'Missouri' },
  { key: 'MT', label: 'Montana' },
  { key: 'NE', label: 'Nebraska' },
  { key: 'NV', label: 'Nevada' },
  { key: 'NH', label: 'New Hampshire' },
  { key: 'NJ', label: 'New Jersey' },
  { key: 'NM', label: 'New Mexico' },
  { key: 'NY', label: 'New York' },
  { key: 'NC', label: 'North Carolina' },
  { key: 'ND', label: 'North Dakota' },
  { key: 'OH', label: 'Ohio' },
  { key: 'OK', label: 'Oklahoma' },
  { key: 'OR', label: 'Oregon' },
  { key: 'PA', label: 'Pennsylvania' },
  { key: 'RI', label: 'Rhode Island' },
  { key: 'SC', label: 'South Carolina' },
  { key: 'SD', label: 'South Dakota' },
  { key: 'TN', label: 'Tennessee' },
  { key: 'TX', label: 'Texas' },
  { key: 'UT', label: 'Utah' },
  { key: 'VT', label: 'Vermont' },
  { key: 'VA', label: 'Virginia' },
  { key: 'WA', label: 'Washington' },
  { key: 'WV', label: 'West Virginia' },
  { key: 'WI', label: 'Wisconsin' },
  { key: 'WY', label: 'Wyoming' },
  { key: 'AS', label: 'American Samoa' },
  { key: 'GU', label: 'Guam' },
  { key: 'MP', label: 'Northern Mariana Islands' },
  { key: 'PR', label: 'Puerto Rico' },
  { key: 'VI', label: 'U.S. Virgin Islands' },
];

export const pubSportsObject = {
  key: 'pub_sports',
  name: 'pub_sports',
  fieldConfig: {
    key: 'sport',
    enumOptions: sportsOptions,
    saveConfig: {
      label: 'Sport(s)',
      placeholderMessage: undefined,
      isRequired: true,
      displayInSingleLine: true,
    },
    schemaType: 'multi-enum',
    scope: 'public',
    showConfig: {
      label: 'Sport(s)',
      displayInProfile: true,
      unselectedOptions: false,
    },
    userTypeConfig: {
      limitToUserTypeIds: false,
    },
  },
  defaultRequiredMessage: 'Required',
};
export const pubStateOptions = {
  key: 'pub_state',
  name: 'pub_state',
  fieldConfig: {
    key: 'state_or_territory',
    enumOptions: stateTerritoryOptions,
    saveConfig: {
      label: 'State/Territory',
      placeholderMessage: undefined,
      isRequired: true,
      displayInSingleLine: true,
    },
    schemaType: 'enum',
    scope: 'public',
    showConfig: {
      label: 'Sports',
      displayInProfile: true,
      unselectedOptions: false,
    },
    userTypeConfig: {
      limitToUserTypeIds: false,
    },
  },
  defaultRequiredMessage: 'Required',
};

export const divisionOptions = [
  { key: 'division1FBS', value: 'Division 1 FBS' },
  { key: 'division1FCS', value: 'Division 1 FCS' },
  { key: 'division2', value: 'Division 2' },
  { key: 'division3', value: 'Division 3' },
  { key: 'naia', value: 'NAIA' },
  { key: 'njcaa', value: 'NJCAA' },
  { key: 'uscaa', value: 'USCAA' },
  { key: 'nccaa', value: 'NCCAA' },
];

export const divisionSchoolOptions = [
  {
    school: 'Abraham Baldwin Agricultural College',
    nickname: 'Golden Stallions',
    city: 'Tifton',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Alice Lloyd College',
    nickname: 'Eagles',
    city: 'Pippa Passes',
    state: 'Kentucky',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Aquinas College',
    nickname: 'Saints',
    city: 'Grand Rapids',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Arizona Christian University',
    nickname: 'Firestorm',
    city: 'Phoenix',
    state: 'Arizona',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Arkansas Baptist College',
    nickname: 'Buffaloes',
    city: 'Little Rock',
    state: 'Arkansas',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Ave Maria University',
    nickname: 'Gyrenes',
    city: 'Ave Maria',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Avila University',
    nickname: 'Eagles',
    city: 'Kansas City',
    state: 'Missouri',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Baker University',
    nickname: 'Wildcats',
    city: 'Baldwin City',
    state: 'Kansas',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bellevue University',
    nickname: 'Bruins',
    city: 'Bellevue',
    state: 'Nebraska',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Benedictine College',
    nickname: 'Ravens',
    city: 'Atchison',
    state: 'Kansas',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Benedictine University at Mesa',
    nickname: 'Redhawks',
    city: 'Mesa',
    state: 'Arizona',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bethany College',
    nickname: 'Swedes',
    city: 'Lindsborg',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bethel College (KS)',
    nickname: 'Threshers',
    city: 'North Newton',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bethel University (IN)',
    nickname: 'Pilots',
    city: 'Mishawaka',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Bethel University (TN)',
    nickname: 'Wildcats',
    city: 'McKenzie',
    state: 'Tennessee',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Blue Mountain Christian University',
    nickname: 'Toppers',
    city: 'Blue Mountain',
    state: 'Mississippi',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bluefield University',
    nickname: 'Rams',
    city: 'Bluefield',
    state: 'Virginia',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Brenau University',
    nickname: 'Golden Tigers',
    city: 'Gainesville',
    state: 'Georgia',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Brescia University',
    nickname: 'Bearcats',
    city: 'Owensboro',
    state: 'Kentucky',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Brewton\u2013Parker College',
    nickname: 'Barons',
    city: 'Mount Vernon',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Briar Cliff University',
    nickname: 'Chargers',
    city: 'Sioux City',
    state: 'Iowa',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of British Columbia',
    nickname: 'Thunderbirds',
    city: 'Vancouver',
    state: 'British Columbia',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Bryan College',
    nickname: 'Lions',
    city: 'Dayton',
    state: 'Tennessee',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Bushnell University',
    nickname: 'Beacons',
    city: 'Eugene',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'California State University Maritime Academy (Cal Maritime)',
    nickname: 'Keelhaulers',
    city: 'Vallejo',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'University of California, Merced (UC Merced)',
    nickname: 'Golden Bobcats',
    city: 'Merced',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'Calumet College of St. Joseph',
    nickname: 'Crimson Wave',
    city: 'Whiting',
    state: 'Indiana',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Campbellsville University',
    nickname: 'Tigers',
    city: 'Campbellsville',
    state: 'Kentucky',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Carolina University',
    nickname: 'Bruins',
    city: 'Winston-Salem',
    state: 'North Carolina',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Carroll College',
    nickname: 'Fighting Saints',
    city: 'Helena',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Central Baptist College',
    nickname: 'Mustangs',
    city: 'Conway',
    state: 'Arkansas',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Central Christian College of Kansas',
    nickname: 'Tigers',
    city: 'McPherson',
    state: 'Kansas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Central Methodist University',
    nickname: 'Eagles',
    city: 'Fayette',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Clarke University',
    nickname: 'Crusaders',
    city: 'Dubuque',
    state: 'Iowa',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Cleary University',
    nickname: 'Cougars',
    city: 'Howell',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'College of Coastal Georgia',
    nickname: 'Mariners',
    city: 'Brunswick',
    state: 'Georgia',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Columbia College (MO)',
    nickname: 'Cougars',
    city: 'Columbia',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Columbia College (SC)',
    nickname: 'Koalas',
    city: 'Columbia',
    state: 'South Carolina',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Columbia International University',
    nickname: 'Rams',
    city: 'Columbia',
    state: 'South Carolina',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Concordia University\u2013Michigan',
    nickname: 'Cardinals',
    city: 'Ann Arbor',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Concordia University\u2013Nebraska',
    nickname: 'Bulldogs',
    city: 'Seward',
    state: 'Nebraska',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Corban University',
    nickname: 'Warriors',
    city: 'Salem',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Cornerstone University',
    nickname: 'Golden Eagles',
    city: 'Grand Rapids',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Cottey College',
    nickname: 'Comets',
    city: 'Nevada',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: "Crowley's Ridge College",
    nickname: 'Pioneers',
    city: 'Paragould',
    state: 'Arkansas',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Culver\u2013Stockton College',
    nickname: 'Wildcats',
    city: 'Canton',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Cumberland University',
    nickname: 'Phoenix',
    city: 'Lebanon',
    state: 'Tennessee',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'University of the Cumberlands',
    nickname: 'Patriots',
    city: 'Williamsburg',
    state: 'Kentucky',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Dakota State University',
    nickname: 'Trojans',
    city: 'Madison',
    state: 'South Dakota',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Dakota Wesleyan University',
    nickname: 'Tigers',
    city: 'Mitchell',
    state: 'South Dakota',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Dalton State College',
    nickname: 'Roadrunners',
    city: 'Dalton',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Defiance College',
    nickname: 'Yellow Jackets and Lady Jackets',
    city: 'Defiance',
    state: 'Ohio',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Dickinson State University',
    nickname: 'Blue Hawks',
    city: 'Dickinson',
    state: 'North Dakota',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Dillard University',
    nickname: 'Bleu Devils & Lady Bleu Devils',
    city: 'New Orleans',
    state: 'Louisiana',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Doane College',
    nickname: 'Tigers',
    city: 'Crete',
    state: 'Nebraska',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Dordt University',
    nickname: 'Defenders',
    city: 'Sioux Center',
    state: 'Iowa',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Eastern Oregon University',
    nickname: 'Mountaineers',
    city: 'La Grande',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Embry\u2013Riddle Aeronautical University, Prescott',
    nickname: 'Eagles',
    city: 'Prescott',
    state: 'Arizona',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Evangel University',
    nickname: 'Valor',
    city: 'Springfield',
    state: 'Missouri',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'The Evergreen State College',
    nickname: 'Geoducks',
    city: 'Olympia',
    state: 'Washington',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Faulkner University',
    nickname: 'Eagles',
    city: 'Montgomery',
    state: 'Alabama',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Fisher College',
    nickname: 'Falcons',
    city: 'Boston',
    state: 'Massachusetts',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Fisk University',
    nickname: 'Bulldogs',
    city: 'Nashville',
    state: 'Tennessee',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Florida College',
    nickname: 'Falcons',
    city: 'Temple Terrace',
    state: 'Florida',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Florida Memorial University',
    nickname: 'Lions',
    city: 'Miami Gardens',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Florida National University',
    nickname: 'Conquistadors',
    city: 'Miami',
    state: 'Florida',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Freed\u2013Hardeman University',
    nickname: 'Lions',
    city: 'Henderson',
    state: 'Tennessee',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Friends University',
    nickname: 'Falcons',
    city: 'Wichita',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Georgetown College',
    nickname: 'Tigers',
    city: 'Georgetown',
    state: 'Kentucky',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Georgia Gwinnett College',
    nickname: 'Grizzlies',
    city: 'Lawrenceville',
    state: 'Georgia',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Goshen College',
    nickname: 'Maple Leafs',
    city: 'Goshen',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Governors State University',
    nickname: 'Jaguars',
    city: 'University Park',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Grace College & Seminary',
    nickname: 'Lancers',
    city: 'Winona Lake',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Graceland University',
    nickname: 'Yellowjackets',
    city: 'Lamoni',
    state: 'Iowa',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Grand View University',
    nickname: 'Vikings',
    city: 'Des Moines',
    state: 'Iowa',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Hannibal\u2013LaGrange University',
    nickname: 'Trojans',
    city: 'Hannibal',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Harris\u2013Stowe State University',
    nickname: 'Hornets',
    city: 'St. Louis',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Haskell Indian Nations University',
    nickname: 'Indians',
    city: 'Lawrence',
    state: 'Kansas',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Hastings College',
    nickname: 'Broncos',
    city: 'Hastings',
    state: 'Nebraska',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Health Sciences and Pharmacy in St. Louis',
    nickname: 'Eutectics',
    city: 'St. Louis',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Holy Cross College',
    nickname: 'Saints',
    city: 'Notre Dame',
    state: 'Indiana',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Hope International University',
    nickname: 'Royals',
    city: 'Fullerton',
    state: 'California',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Houston\u2013Victoria*',
    nickname: 'Jaguars',
    city: 'Victoria',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Huntington University',
    nickname: 'Foresters',
    city: 'Huntington',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Huston\u2013Tillotson University',
    nickname: 'Rams',
    city: 'Austin',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'College of Idaho',
    nickname: 'Coyotes',
    city: 'Caldwell',
    state: 'Idaho',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Indiana Institute of Technology (Indiana Tech)',
    nickname: 'Warriors',
    city: 'Fort Wayne',
    state: 'Indiana',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University Columbus',
    nickname: 'Crimson Pride',
    city: 'Columbus',
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University East',
    nickname: 'Red Wolves',
    city: 'Richmond',
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University Kokomo',
    nickname: 'Cougars',
    city: 'Kokomo',
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University Northwest',
    nickname: 'Redhawks',
    city: 'Gary',
    state: 'Indiana',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University South Bend',
    nickname: 'Titans',
    city: 'South Bend',
    state: 'Indiana',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Indiana University Southeast',
    nickname: 'Grenadiers',
    city: 'New Albany',
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Indiana Wesleyan University',
    nickname: 'Wildcats',
    city: 'Marion',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'University of Jamestown',
    nickname: 'Jimmies',
    city: 'Jamestown',
    state: 'North Dakota',
    conference: 'North Star Athletic Association',
    division: 'naia',
  },
  {
    school: 'Jarvis Christian University',
    nickname: 'Bulldogs',
    city: 'Hawkins',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'John Brown University',
    nickname: 'Golden Eagles',
    city: 'Siloam Springs',
    state: 'Arkansas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Johnson University',
    nickname: 'Royals',
    city: 'Kimberlin Heights',
    state: 'Tennessee',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Judson University',
    nickname: 'Eagles',
    city: 'Elgin',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Kansas Wesleyan University',
    nickname: 'Coyotes',
    city: 'Salina',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Keiser University',
    nickname: 'Seahawks',
    city: 'West Palm Beach',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Kentucky Christian University',
    nickname: 'Knights',
    city: 'Grayson',
    state: 'Kentucky',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'La Sierra University',
    nickname: 'Golden Eagles',
    city: 'Riverside',
    state: 'California',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Langston University',
    nickname: 'Lions',
    city: 'Langston',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Lawrence Technological University (Lawrence Tech)',
    nickname: 'Blue Devils',
    city: 'Southfield',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Lewis\u2013Clark State College',
    nickname: 'Warriors',
    city: 'Lewiston',
    state: 'Idaho',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Life University',
    nickname: 'Eagles',
    city: 'Marietta',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Life Pacific University',
    nickname: 'Warriors',
    city: 'San Dimas',
    state: 'California',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Lindsey Wilson College',
    nickname: 'Blue Raiders',
    city: 'Columbia',
    state: 'Kentucky',
    conference: 'Mid-South Conference',
    division: 'naia',
  },
  {
    school: 'Louisiana Christian University',
    nickname: 'Wildcats',
    city: 'Pineville',
    state: 'Louisiana',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Louisiana State University at Alexandria (LSU Alexandria)',
    nickname: 'Generals',
    city: 'Alexandria',
    state: 'Louisiana',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Louisiana State University in Shreveport (LSU Shreveport)',
    nickname: 'Pilots & Lady Pilots',
    city: 'Shreveport',
    state: 'Louisiana',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Lourdes University',
    nickname: 'Gray Wolves',
    city: 'Sylvania',
    state: 'Ohio',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Loyola University New Orleans',
    nickname: 'Wolfpack',
    city: 'New Orleans',
    state: 'Louisiana',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Madonna University',
    nickname: 'Crusaders',
    city: 'Livonia',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Marian University',
    nickname: 'Knights',
    city: 'Indianapolis',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: "The Master's University",
    nickname: 'Mustangs',
    city: 'Santa Clarita',
    state: 'California',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mayville State University',
    nickname: 'Comets',
    city: 'Mayville',
    state: 'North Dakota',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'McPherson College',
    nickname: 'Bulldogs',
    city: 'McPherson',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Michigan\u2013Dearborn',
    nickname: 'Wolverines',
    city: 'Dearborn',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mid-America Christian University',
    nickname: 'Evangels',
    city: 'Oklahoma City',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'MidAmerica Nazarene University',
    nickname: 'Pioneers',
    city: 'Olathe',
    state: 'Kansas',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Middle Georgia State University',
    nickname: 'Knights',
    city: 'Cochran/Macon',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Midland University',
    nickname: 'Warriors',
    city: 'Fremont',
    state: 'Nebraska',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Midway University',
    nickname: 'Eagles',
    city: 'Midway',
    state: 'Kentucky',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Milligan University',
    nickname: 'Buffaloes',
    city: 'Elizabethton',
    state: 'Tennessee',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mission University',
    nickname: 'Patriots',
    city: 'Springfield',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Missouri Baptist University',
    nickname: 'Spartans',
    city: 'St. Louis',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Missouri Valley College',
    nickname: 'Vikings',
    city: 'Marshall',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Mobile',
    nickname: 'Rams',
    city: 'Prichard',
    state: 'Alabama',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Montana State University\u2013Northern',
    nickname: 'Lights',
    city: 'Havre',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Montana Technological University (Montana Tech)',
    nickname: 'Orediggers',
    city: 'Butte',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'University of Montana\u2013Western',
    nickname: 'Bulldogs',
    city: 'Dillon',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Montreat College',
    nickname: 'Cavaliers',
    city: 'Montreat',
    state: 'North Carolina',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Morningside University',
    nickname: 'Mustangs',
    city: 'Sioux City',
    state: 'Iowa',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Morris College',
    nickname: 'Hornets',
    city: 'Sumter',
    state: 'South Carolina',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mount Marty University',
    nickname: 'Lancers',
    city: 'Yankton',
    state: 'South Dakota',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mount Mercy University',
    nickname: 'Mustangs',
    city: 'Cedar Rapids',
    state: 'Iowa',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Mount Vernon Nazarene University',
    nickname: 'Cougars',
    city: 'Mount Vernon',
    state: 'Ohio',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Multnomah University',
    nickname: 'Lions',
    city: 'Portland',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Nelson University',
    nickname: 'Lions',
    city: 'Waxahachie',
    state: 'Texas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'New College of Florida',
    nickname: 'Mighty Banyans',
    city: 'Sarasota',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'North American University',
    nickname: 'Stallions',
    city: 'Stafford',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of North Texas at Dallas',
    nickname: 'Trailblazers',
    city: 'Dallas',
    state: 'Texas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Northern New Mexico College',
    nickname: 'Eagles',
    city: 'Espa\u00f1ola',
    state: 'New Mexico',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Northwest University',
    nickname: 'Eagles',
    city: 'Kirkland',
    state: 'Washington',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Northwestern College',
    nickname: 'Red Raiders',
    city: 'Orange City',
    state: 'Iowa',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Northwestern Ohio (UNOH)',
    nickname: 'Racers',
    city: 'Lima',
    state: 'Ohio',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oakland City University',
    nickname: 'Mighty Oaks',
    city: 'Oakland City',
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Oakwood University',
    nickname: 'Ambassadors & Lady Ambassadors',
    city: 'Huntsville',
    state: 'Alabama',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oklahoma City University',
    nickname: 'Stars',
    city: 'Oklahoma City',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oklahoma Panhandle State University',
    nickname: 'Aggies',
    city: 'Goodwell',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oklahoma Wesleyan University',
    nickname: 'Eagles',
    city: 'Bartlesville',
    state: 'Oklahoma',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Olivet Nazarene University',
    nickname: 'Tigers',
    city: 'Bourbonnais',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oregon Institute of Technology (Oregon Tech)',
    nickname: 'Owls',
    city: 'Klamath Falls',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Ottawa University',
    nickname: 'Braves',
    city: 'Ottawa',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Ottawa University Arizona',
    nickname: 'Spirit',
    city: 'Surprise',
    state: 'Arizona',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Our Lady of the Lake University',
    nickname: 'Saints',
    city: 'San Antonio',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'College of the Ozarks',
    nickname: 'Bobcats',
    city: 'Point Lookout',
    state: 'Missouri',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Pacific Union College',
    nickname: 'Pioneers',
    city: 'Angwin',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'Park University',
    nickname: 'Pirates',
    city: 'Parkville',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Park University Gilbert',
    nickname: 'Buccaneers',
    city: 'Gilbert',
    state: 'Arizona',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Paul Quinn College',
    nickname: 'Tigers',
    city: 'Dallas',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Peru State College',
    nickname: 'Bobcats',
    city: 'Peru',
    state: 'Nebraska',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Philander Smith University',
    nickname: 'Panthers',
    city: 'Little Rock',
    state: 'Arkansas',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Pikeville',
    nickname: 'Bears',
    city: 'Pikeville',
    state: 'Kentucky',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Point University',
    nickname: 'Skyhawks',
    city: 'West Point',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Providence',
    nickname: 'Argonauts',
    city: 'Great Falls',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Providence Christian College*',
    nickname: 'Sea Beggars',
    city: 'Pasadena',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'Reinhardt University',
    nickname: 'Eagles',
    city: 'Waleska',
    state: 'Georgia',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Rio Grande',
    nickname: 'RedStorm',
    city: 'Rio Grande',
    state: 'Ohio',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Rochester Christian University',
    nickname: 'Warriors',
    city: 'Rochester',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Rocky Mountain College',
    nickname: "Battlin' Bears",
    city: 'Billings',
    state: 'Montana',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'Rust College',
    nickname: 'Bearcats',
    city: 'Holly Springs',
    state: 'Mississippi',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'St. Ambrose University',
    nickname: 'Fighting Bees & Queen Bees',
    city: 'Davenport',
    state: 'Iowa',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'St. Andrews University',
    nickname: 'Knights',
    city: 'Laurinburg',
    state: 'North Carolina',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of St. Francis',
    nickname: 'Fighting Saints',
    city: 'Joliet',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Saint Francis',
    nickname: 'Cougars',
    city: 'Fort Wayne',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'University of Saint Mary',
    nickname: 'Spires',
    city: 'Leavenworth',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'College of Saint Mary',
    nickname: 'Flames',
    city: 'Omaha',
    state: 'Nebraska',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Saint Mary-of-the-Woods College',
    nickname: 'Pomeroys',
    city: "Saint Mary's",
    state: 'Indiana',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'St. Thomas University',
    nickname: 'Bobcats',
    city: 'Miami Gardens',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Saint Xavier University',
    nickname: 'Cougars',
    city: 'Chicago',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Savannah College of Art and Design*',
    nickname: 'Bees',
    city: 'Savannah',
    state: 'Georgia',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Savannah College of Art and Design\u2013Atlanta*',
    nickname: 'Atlanta',
    city: 'Appalachian Athletic Conference',
    state: 'N/A',
    conference: 'N/A',
    division: 'naia',
  },
  {
    school: 'University of Science and Arts of Oklahoma',
    nickname: 'Drovers',
    city: 'Chickasha',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Shawnee State University',
    nickname: 'Bears',
    city: 'Portsmouth',
    state: 'Ohio',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Siena Heights University',
    nickname: 'Saints',
    city: 'Adrian',
    state: 'Michigan',
    conference: 'Wolverine\u2013Hoosier Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Simpson University',
    nickname: 'Red Hawks',
    city: 'Redding',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'Soka University of America*',
    nickname: 'Lions',
    city: 'Aliso Viejo',
    state: 'California',
    conference: 'Great Southwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Southeastern University',
    nickname: 'Fire',
    city: 'Lakeland',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Southern University at New Orleans (SUNO)',
    nickname: 'Knights and Lady Knights',
    city: 'New Orleans',
    state: 'Louisiana',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Southern Oregon University',
    nickname: 'Raiders',
    city: 'Ashland',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'University of the Southwest',
    nickname: 'Mustangs',
    city: 'Hobbs',
    state: 'New Mexico',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Southwestern College',
    nickname: 'Moundbuilders',
    city: 'Winfield',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Southwestern Christian University',
    nickname: 'Eagles',
    city: 'Bethany',
    state: 'Oklahoma',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Spartanburg Methodist College',
    nickname: 'Pioneers',
    city: 'Saxon',
    state: 'South Carolina',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Spring Arbor University',
    nickname: 'Cougars',
    city: 'Spring Arbor',
    state: 'Michigan',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'Stephens College',
    nickname: 'Stars',
    city: 'Columbia',
    state: 'Missouri',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Sterling College',
    nickname: 'Warriors',
    city: 'Sterling',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Stillman College',
    nickname: 'Tigers',
    city: 'Tuscaloosa',
    state: 'Alabama',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Tabor College',
    nickname: 'Bluejays',
    city: 'Hillsboro',
    state: 'Kansas',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Talladega College',
    nickname: 'Tornadoes',
    city: 'Talladega',
    state: 'Alabama',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Taylor University',
    nickname: 'Trojans',
    city: 'Upland',
    state: 'Indiana',
    conference: 'Crossroads League',
    division: 'naia',
  },
  {
    school: 'University of Tennessee Southern (UT Southern)',
    nickname: 'FireHawks',
    city: 'Pulaski',
    state: 'Tennessee',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Tennessee Wesleyan University',
    nickname: 'Bulldogs',
    city: 'Athens',
    state: 'Tennessee',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Texas A&M University\u2013San Antonio',
    nickname: 'Jaguars',
    city: 'San Antonio',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Texas A&M University\u2013Texarkana',
    nickname: 'Eagles',
    city: 'Texarkana',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Texas College',
    nickname: 'Steers',
    city: 'Tyler',
    state: 'Texas',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Texas Wesleyan University',
    nickname: 'Rams',
    city: 'Fort Worth',
    state: 'Texas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Thomas University',
    nickname: 'Night Hawks',
    city: 'Thomasville',
    state: 'Georgia',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Tougaloo College',
    nickname: 'Bulldogs',
    city: 'Tougaloo',
    state: 'Mississippi',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Trinity Christian College',
    nickname: 'Trolls',
    city: 'Palos Heights',
    state: 'Illinois',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Truett McConnell University',
    nickname: 'Bears',
    city: 'Cleveland',
    state: 'Georgia',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Union Commonwealth University',
    nickname: 'Bulldogs',
    city: 'Barbourville',
    state: 'Kentucky',
    conference: 'Appalachian Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Valley City State University',
    nickname: 'Vikings',
    city: 'Valley City',
    state: 'North Dakota',
    conference: 'Frontier Conference',
    division: 'naia',
  },
  {
    school: 'University of Victoria',
    nickname: 'Vikes',
    city: 'Victoria',
    state: 'British Columbia',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of the Virgin Islands',
    nickname: 'Buccaneers',
    city: 'Saint Thomas',
    state: 'US Virgin Islands',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Viterbo University',
    nickname: 'V-Hawks',
    city: 'La Crosse',
    state: 'Wisconsin',
    conference: 'Chicagoland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Voorhees University',
    nickname: 'Tigers',
    city: 'Denmark',
    state: 'South Carolina',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Waldorf University',
    nickname: 'Warriors',
    city: 'Forest City',
    state: 'Iowa',
    conference: 'Great Plains Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Walla Walla University',
    nickname: 'Wolves',
    city: 'College Place',
    state: 'Washington',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Warner University',
    nickname: 'Royals',
    city: 'Lake Wales',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'Warner Pacific University',
    nickname: 'Knights',
    city: 'Portland',
    state: 'Oregon',
    conference: 'Cascade Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Washington Adventist University',
    nickname: 'Shock',
    city: 'Takoma Park',
    state: 'Maryland',
    conference: 'Continental Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wayland Baptist University',
    nickname: 'Pioneers & Flying Queens',
    city: 'Plainview',
    state: 'Texas',
    conference: 'Sooner Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Webber International University',
    nickname: 'Warriors',
    city: 'Babson Park',
    state: 'Florida',
    conference: 'Sun Conference',
    division: 'naia',
  },
  {
    school: 'West Virginia University Institute of Technology (WVU Tech)',
    nickname: 'Golden Bears',
    city: 'Beckley',
    state: 'West Virginia',
    conference: 'River States Conference',
    division: 'naia',
  },
  {
    school: 'Westcliff University',
    nickname: 'Warriors',
    city: 'Irvine',
    state: 'California',
    conference: 'California Pacific Conference',
    division: 'naia',
  },
  {
    school: 'Wilberforce University',
    nickname: 'Bulldogs',
    city: 'Wilberforce',
    state: 'Ohio',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wiley University',
    nickname: 'Wildcats',
    city: 'Marshall',
    state: 'Texas',
    conference: 'HBCU Athletic Conference',
    division: 'naia',
  },
  {
    school: 'William Carey University',
    nickname: 'Crusaders',
    city: 'Hattiesburg',
    state: 'Mississippi',
    conference: 'Southern States Athletic Conference',
    division: 'naia',
  },
  {
    school: 'William Penn University',
    nickname: 'Statesmen',
    city: 'Oskaloosa',
    state: 'Iowa',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'William Woods University',
    nickname: 'Owls',
    city: 'Fulton',
    state: 'Missouri',
    conference: 'Heart of America Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Williams Baptist University',
    nickname: 'Eagles',
    city: 'Walnut Ridge',
    state: 'Arkansas',
    conference: 'American Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Xavier University of Louisiana',
    nickname: 'Gold Rush & Gold Nuggets',
    city: 'New Orleans',
    state: 'Louisiana',
    conference: 'Red River Athletic Conference',
    division: 'naia',
  },
  {
    school: 'York University',
    nickname: 'Panthers',
    city: 'York',
    state: 'Nebraska',
    conference: 'Kansas Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Muskingum University',
    nickname: 'Fighting Muskies',
    city: 'New Concord',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Nazareth University',
    nickname: 'Golden Flyers',
    city: 'Pittsford',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'Nebraska Wesleyan University',
    nickname: 'Prairie Wolves',
    city: 'Lincoln',
    state: 'NE',
    conference: 'American Rivers Conference',
    division: 'naia',
  },
  {
    school: 'Neumann University',
    nickname: 'Knights',
    city: 'Aston',
    state: 'PA',
    conference: 'Atlantic East Conference',
    division: 'naia',
  },
  {
    school: 'New England College',
    nickname: 'Pilgrims',
    city: 'Henniker',
    state: 'NH',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of New England',
    nickname: "Nor'easters",
    city: 'Biddeford',
    state: 'ME',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'The College of New Jersey',
    nickname: 'Lions',
    city: 'Ewing',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'New Jersey City University',
    nickname: 'Gothic Knights',
    city: 'Jersey City',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Brockport',
    nickname: 'Golden Eagles',
    city: 'Brockport',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'State University of New York at Canton',
    nickname: 'Kangaroos',
    city: 'Canton',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Cobleskill',
    nickname: 'Fighting Tigers',
    city: 'Cobleskill',
    state: 'NY',
    conference: 'North Atlantic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Cortland',
    nickname: 'Red Dragons',
    city: 'Cortland',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Delhi',
    nickname: 'Broncos',
    city: 'Delhi',
    state: 'NY',
    conference: 'North Atlantic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Fredonia',
    nickname: 'Blue Devils',
    city: 'Fredonia',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Geneseo',
    nickname: 'Knights',
    city: 'Geneseo',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'State University of New York Maritime College',
    nickname: 'Privateers',
    city: 'The Bronx',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Morrisville',
    nickname: 'Mustangs',
    city: 'Morrisville',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York Polytechnic Institute',
    nickname: 'Wildcats',
    city: 'Marcy',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'State University of New York at New Paltz',
    nickname: 'Hawks',
    city: 'New Paltz',
    state: 'NY',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Old Westbury',
    nickname: 'Panthers',
    city: 'Old Westbury',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Oneonta',
    nickname: 'Red Dragons',
    city: 'Oneonta',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Oswego',
    nickname: 'Lakers',
    city: 'Oswego',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Plattsburgh',
    nickname: 'Cardinals',
    city: 'Plattsburgh',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Potsdam',
    nickname: 'Bears',
    city: 'Potsdam',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'State University of New York at Purchase',
    nickname: 'Panthers',
    city: 'Purchase',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'New York University',
    nickname: 'Violets',
    city: 'New York',
    state: 'NY',
    conference: 'University Athletic Association',
    division: 'naia',
  },
  {
    school: 'Nichols College',
    nickname: 'Bison',
    city: 'Dudley',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'North Carolina Wesleyan University',
    nickname: 'Bishops',
    city: 'Rocky Mount',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'naia',
  },
  {
    school: 'North Central College',
    nickname: 'Cardinals',
    city: 'Naperville',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'naia',
  },
  {
    school: 'North Central University',
    nickname: 'Rams',
    city: 'Minneapolis',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'North Park University',
    nickname: 'Vikings',
    city: 'Chicago',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'naia',
  },
  {
    school: 'Northland College',
    nickname: 'Lumberjacks and Lumberjills',
    city: 'Ashland',
    state: 'WI',
    conference: 'Upper Midwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Northwestern - St. Paul',
    nickname: 'Eagles',
    city: 'Roseville',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Norwich University',
    nickname: 'Cadets',
    city: 'Northfield',
    state: 'VT',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Notre Dame of Maryland University',
    nickname: 'Gators',
    city: 'Baltimore',
    state: 'MD',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Oberlin College',
    nickname: 'Yeomen and Yeowomen',
    city: 'Oberlin',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Occidental College',
    nickname: 'Tigers',
    city: 'Los Angeles',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Oglethorpe University',
    nickname: 'Stormy Petrels',
    city: 'Atlanta',
    state: 'GA',
    conference: 'Southern Athletic Association',
    division: 'naia',
  },
  {
    school: 'Ohio Northern University',
    nickname: 'Polar Bears',
    city: 'Ada',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Ohio Wesleyan University',
    nickname: 'Battling Bishops',
    city: 'Delaware',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Olivet',
    nickname: 'Comets',
    city: 'Olivet',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'naia',
  },
  {
    school: 'Otterbein University',
    nickname: 'Cardinals',
    city: 'Westerville',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of the Ozarks',
    nickname: 'Eagles',
    city: 'Clarksville',
    state: 'AR',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Pacific Lutheran University',
    nickname: 'Lutes',
    city: 'Tacoma',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'Pacific University',
    nickname: 'Boxers',
    city: 'Forest Grove',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania College of Technology',
    nickname: 'Wildcats',
    city: 'Williamsport',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Abington',
    nickname: 'Nittany Lions',
    city: 'Abington',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Altoona',
    nickname: 'Lions',
    city: 'Altoona',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Berks College',
    nickname: 'Nittany Lions',
    city: 'Reading',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Behrend',
    nickname: 'Lions',
    city: 'Erie',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Brandywine',
    nickname: 'Lions',
    city: 'Media',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Pennsylvania State University, Harrisburg',
    nickname: 'Lions',
    city: 'Harrisburg',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Pfeiffer University',
    nickname: 'Falcons',
    city: 'Misenheimer',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Piedmont University',
    nickname: 'Lions',
    city: 'Demorest',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'naia',
  },
  {
    school: 'University of Pittsburgh at Bradford',
    nickname: 'Panthers',
    city: 'Bradford',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'University of Pittsburgh at Greensburg',
    nickname: 'Bobcats',
    city: 'Greensburg',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Plymouth State University',
    nickname: 'Panthers',
    city: 'Plymouth',
    state: 'NH',
    conference: 'Little East Conference',
    division: 'naia',
  },
  {
    school: 'Pomona College and Pitzer College',
    nickname: 'Sagehens',
    city: 'Claremont',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Pratt Institute',
    nickname: 'Cannoneers',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'Atlantic East Conference',
    division: 'naia',
  },
  {
    school: 'Principia College',
    nickname: 'Panthers',
    city: 'Elsah',
    state: 'IL',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Puget Sound',
    nickname: 'Loggers',
    city: 'Tacoma',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'Ramapo College',
    nickname: 'Roadrunners',
    city: 'Mahwah',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Randolph College',
    nickname: 'WildCats',
    city: 'Lynchburg',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Randolph\u2013Macon College',
    nickname: 'Yellow Jackets',
    city: 'Ashland',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Redlands',
    nickname: 'Bulldogs',
    city: 'Redlands',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Regis College',
    nickname: 'Pride',
    city: 'Weston',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Rensselaer Polytechnic Institute',
    nickname: 'Engineers',
    city: 'Troy',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'Rhode Island College',
    nickname: 'Anchormen',
    city: 'Providence',
    state: 'RI',
    conference: 'Little East Conference',
    division: 'naia',
  },
  {
    school: 'Rhodes College',
    nickname: 'Lynx',
    city: 'Memphis',
    state: 'TN',
    conference: 'Southern Athletic Association',
    division: 'naia',
  },
  {
    school: 'Ripon College',
    nickname: 'Red Hawks',
    city: 'Ripon',
    state: 'WI',
    conference: 'Midwest Conference',
    division: 'naia',
  },
  {
    school: 'Rivier University',
    nickname: 'Raiders',
    city: 'Nashua',
    state: 'NH',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Roanoke College',
    nickname: 'Maroons',
    city: 'Salem',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Rochester',
    nickname: 'Yellowjackets',
    city: 'Rochester',
    state: 'NY',
    conference: 'University Athletic Association',
    division: 'naia',
  },
  {
    school: 'Rochester Institute of Technology',
    nickname: 'Tigers',
    city: 'Rochester',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'Rockford University',
    nickname: 'Regents',
    city: 'Rockford',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'Roger Williams University',
    nickname: 'Hawks',
    city: 'Bristol',
    state: 'RI',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'Rose-Hulman Institute of Technology',
    nickname: "Fightin' Engineers",
    city: 'Terre Haute',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Rosemont College',
    nickname: 'Ravens',
    city: 'Rosemont',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Rowan University',
    nickname: 'Profs',
    city: 'Glassboro',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Rutgers University\u2013Camden',
    nickname: 'Scarlet Raptors',
    city: 'Camden',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Rutgers University\u2013Newark',
    nickname: 'Scarlet Raiders',
    city: 'Newark',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Russell Sage College',
    nickname: 'Gators',
    city: 'Albany & Troy',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'College of Saint Benedict',
    nickname: 'Bennies',
    city: 'St. Joseph',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'St. Catherine University',
    nickname: 'Wildcats',
    city: 'St. Paul',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Saint Elizabeth University',
    nickname: 'Screaming Eagles',
    city: 'Convent Station',
    state: 'NJ',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'St. John Fisher University',
    nickname: 'Cardinals',
    city: 'Pittsford',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: "Saint John's University",
    nickname: 'Johnnies',
    city: 'Collegeville',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Saint Joseph',
    nickname: 'Blue Jays',
    city: 'West Hartford',
    state: 'CT',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: "St. Joseph's University",
    nickname: 'Bears',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: "St. Joseph's University",
    nickname: 'Golden Eagles',
    city: 'Long Island',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: "Saint Joseph's College of Maine",
    nickname: 'Monks',
    city: 'Standish',
    state: 'ME',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'St. Lawrence University',
    nickname: 'Saints',
    city: 'Canton',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: "Saint Mary's College",
    nickname: 'Belles',
    city: 'Notre Dame',
    state: 'IN',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'naia',
  },
  {
    school: "St. Mary's College of Maryland",
    nickname: 'Seahawks',
    city: "St. Mary's City",
    state: 'MD',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: "Saint Mary's University of Minnesota",
    nickname: 'Cardinals',
    city: 'Winona',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'St. Norbert College',
    nickname: 'Green Knights',
    city: 'De Pere',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'St. Olaf College',
    nickname: 'Oles',
    city: 'Northfield',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'The College of St. Scholastica',
    nickname: 'Saints',
    city: 'Duluth',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of St. Thomas (Texas)',
    nickname: 'Celts',
    city: 'Houston',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Saint Vincent College',
    nickname: 'Bearcats',
    city: 'Latrobe',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Salem College',
    nickname: 'Spirits',
    city: 'Winston-Salem',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Salem State University',
    nickname: 'Vikings',
    city: 'Salem',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Salisbury University',
    nickname: 'Sea Gulls',
    city: 'Salisbury',
    state: 'MD',
    conference: 'Coast to Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Salve Regina University',
    nickname: 'Seahawks',
    city: 'Newport',
    state: 'RI',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Sarah Lawrence College',
    nickname: 'Gryphons',
    city: 'Yonkers',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'Schreiner University',
    nickname: 'Mountaineers',
    city: 'Kerrville',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Scranton',
    nickname: 'Royals',
    city: 'Scranton',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'naia',
  },
  {
    school: 'University of the South',
    nickname: 'Tigers',
    city: 'Sewanee',
    state: 'TN',
    conference: 'Southern Athletic Association',
    division: 'naia',
  },
  {
    school: 'Shenandoah University',
    nickname: 'Hornets',
    city: 'Winchester',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Simmons University',
    nickname: 'Sharks',
    city: 'Boston',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Simpson College',
    nickname: 'Storm',
    city: 'Indianola',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'naia',
  },
  {
    school: 'Skidmore College',
    nickname: 'Thoroughbreds',
    city: 'Saratoga Springs',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'Smith College',
    nickname: 'Pioneers',
    city: 'Northampton',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'University of Southern Maine',
    nickname: 'Huskies',
    city: 'Portland',
    state: 'ME',
    conference: 'Little East Conference',
    division: 'naia',
  },
  {
    school: 'Southern Virginia University',
    nickname: 'Knights',
    city: 'Buena Vista',
    state: 'VA',
    conference: 'USA South Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Southwestern University',
    nickname: 'Pirates',
    city: 'Georgetown',
    state: 'TX',
    conference: 'Southern Athletic Association',
    division: 'naia',
  },
  {
    school: 'Spalding University',
    nickname: 'Golden Eagles',
    city: 'Louisville',
    state: 'KY',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Springfield College',
    nickname: 'Pride',
    city: 'Springfield',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Stevens Institute of Technology',
    nickname: 'Ducks',
    city: 'Hoboken',
    state: 'NJ',
    conference: 'MAC Freedom',
    division: 'naia',
  },
  {
    school: 'Stevenson University',
    nickname: 'Mustangs',
    city: 'Stevenson',
    state: 'MD',
    conference: 'MAC Commonwealth',
    division: 'naia',
  },
  {
    school: 'Stockton University',
    nickname: 'Ospreys',
    city: 'Pomona',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Suffolk University',
    nickname: 'Rams',
    city: 'Boston',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'Susquehanna University',
    nickname: 'River Hawks',
    city: 'Selinsgrove',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'naia',
  },
  {
    school: 'Swarthmore College',
    nickname: 'Garnet',
    city: 'Swarthmore',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'naia',
  },
  {
    school: 'Sweet Briar College',
    nickname: 'Vixens',
    city: 'Sweet Briar',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Texas at Dallas',
    nickname: 'Comets',
    city: 'Dallas',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'naia',
  },
  {
    school: 'Texas Lutheran University',
    nickname: 'Bulldogs',
    city: 'Seguin',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Thiel College',
    nickname: 'Tomcats',
    city: 'Greenville',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Thomas College',
    nickname: 'Terriers',
    city: 'Waterville',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'naia',
  },
  {
    school: 'Transylvania University',
    nickname: 'Pioneers',
    city: 'Lexington',
    state: 'KY',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Trine University',
    nickname: 'Thunder',
    city: 'Angola',
    state: 'IN',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'naia',
  },
  {
    school: 'Trinity College',
    nickname: 'Bantams',
    city: 'Hartford',
    state: 'CT',
    conference: 'New England Small College Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Trinity University',
    nickname: 'Tigers',
    city: 'San Antonio',
    state: 'TX',
    conference: 'Southern Athletic Association',
    division: 'naia',
  },
  {
    school: 'Trinity Washington University',
    nickname: 'Tigers',
    city: 'Washington',
    state: 'DC',
    conference: 'Independent',
    division: 'naia',
  },
  {
    school: 'Tufts University',
    nickname: 'Jumbos',
    city: 'Medford',
    state: 'MA',
    conference: 'New England Small College Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Union College',
    nickname: 'Garnet Chargers',
    city: 'Schenectady',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'United States Coast Guard Academy',
    nickname: 'Bears',
    city: 'New London',
    state: 'CT',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'United States Merchant Marine Academy',
    nickname: 'Mariners',
    city: 'Kings Point',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'Ursinus College',
    nickname: 'Bears',
    city: 'Collegeville',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'naia',
  },
  {
    school: 'Utica University',
    nickname: 'Pioneers',
    city: 'Utica',
    state: 'NY',
    conference: 'Empire 8',
    division: 'naia',
  },
  {
    school: 'University of Valley Forge',
    nickname: 'Patriots',
    city: 'Phoenixville',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'Vassar College',
    nickname: 'Brewers',
    city: 'Poughkeepsie',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'Vermont State University\u2013Castleton',
    nickname: 'Spartans',
    city: 'Castleton',
    state: 'VT',
    conference: 'Little East Conference',
    division: 'naia',
  },
  {
    school: 'Vermont State University\u2013Johnson',
    nickname: 'Badgers',
    city: 'Johnson',
    state: 'VT',
    conference: 'North Atlantic Conference',
    division: 'naia',
  },
  {
    school: 'Vermont State University\u2013Lyndon',
    nickname: 'Hornets',
    city: 'Lyndonville',
    state: 'VT',
    conference: 'North Atlantic Conference',
    division: 'naia',
  },
  {
    school: 'Virginia Wesleyan University',
    nickname: 'Marlins',
    city: 'Virginia Beach',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wabash College',
    nickname: 'Little Giants',
    city: 'Crawfordsville',
    state: 'IN',
    conference: 'North Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Warren Wilson College',
    nickname: 'Owls',
    city: 'Swannanoa',
    state: 'NC',
    conference: 'Coast to Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wartburg College',
    nickname: 'Knights',
    city: 'Waverly',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'naia',
  },
  {
    school: 'Washington & Jefferson College',
    nickname: 'Presidents',
    city: 'Washington',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Washington and Lee University',
    nickname: 'Generals',
    city: 'Lexington',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Washington College',
    nickname: 'Shoremen',
    city: 'Chestertown',
    state: 'MD',
    conference: 'Centennial Conference',
    division: 'naia',
  },
  {
    school: 'Washington University in St. Louis',
    nickname: 'Bears',
    city: 'St. Louis',
    state: 'MO',
    conference: 'University Athletic Association',
    division: 'naia',
  },
  {
    school: 'Waynesburg University',
    nickname: 'Yellow Jackets',
    city: 'Waynesburg',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Webster University',
    nickname: 'Gorloks',
    city: 'St. Louis',
    state: 'MO',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wellesley College',
    nickname: 'Blue',
    city: 'Wellesley',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Wentworth Institute of Technology',
    nickname: 'Leopards',
    city: 'Boston',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'Wesleyan College',
    nickname: 'Wolves',
    city: 'Macon',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'naia',
  },
  {
    school: 'Wesleyan University',
    nickname: 'Cardinals',
    city: 'Middletown',
    state: 'CT',
    conference: 'New England Small College Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Western Connecticut State University',
    nickname: 'Wolves',
    city: 'Danbury',
    state: 'CT',
    conference: 'Little East Conference',
    division: 'naia',
  },
  {
    school: 'Western New England University',
    nickname: 'Golden Bears',
    city: 'Springfield',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'naia',
  },
  {
    school: 'Westfield State University',
    nickname: 'Owls',
    city: 'Westfield',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Westminster College',
    nickname: 'Blue Jays',
    city: 'Fulton',
    state: 'MO',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Westminster College',
    nickname: 'Titans',
    city: 'New Wilmington',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Wheaton College',
    nickname: 'Thunder',
    city: 'Wheaton',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'naia',
  },
  {
    school: 'Wheaton College',
    nickname: 'Lyons',
    city: 'Norton',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Whitman College',
    nickname: 'Blues',
    city: 'Walla Walla',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'Whittier College',
    nickname: 'Poets',
    city: 'Whittier',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Whitworth University',
    nickname: 'Pirates',
    city: 'Spokane',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'Widener University',
    nickname: 'Pride',
    city: 'Chester',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'naia',
  },
  {
    school: 'Wilkes University',
    nickname: 'Colonels',
    city: 'Wilkes-Barre',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'naia',
  },
  {
    school: 'Willamette University',
    nickname: 'Bearcats',
    city: 'Salem',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'naia',
  },
  {
    school: 'William Paterson University',
    nickname: 'Pioneers',
    city: 'Wayne',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'naia',
  },
  {
    school: 'William Peace University',
    nickname: 'Pacers',
    city: 'Raleigh',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'naia',
  },
  {
    school: 'William Smith College',
    nickname: 'Herons',
    city: 'Geneva',
    state: 'NY',
    conference: 'Liberty League',
    division: 'naia',
  },
  {
    school: 'Williams College',
    nickname: 'Ephs',
    city: 'Williamstown',
    state: 'MA',
    conference: 'New England Small College Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wilmington College',
    nickname: 'Quakers',
    city: 'Wilmington',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wilson College',
    nickname: 'Phoenix',
    city: 'Chambersburg',
    state: 'PA',
    conference: 'United East Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Eau Claire',
    nickname: 'Blugolds',
    city: 'Eau Claire',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013La Crosse',
    nickname: 'Eagles',
    city: 'La Crosse',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wisconsin Lutheran College',
    nickname: 'Warriors',
    city: 'Milwaukee',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Oshkosh',
    nickname: 'Titans',
    city: 'Oshkosh',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Platteville',
    nickname: 'Pioneers',
    city: 'Platteville',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013River Falls',
    nickname: 'Falcons',
    city: 'River Falls',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Stevens Point',
    nickname: 'Pointers',
    city: 'Stevens Point',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Stout',
    nickname: 'Blue Devils',
    city: 'Menomonie',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Superior',
    nickname: 'Yellow Jackets',
    city: 'Superior',
    state: 'WI',
    conference: 'Upper Midwest Athletic Conference',
    division: 'naia',
  },
  {
    school: 'University of Wisconsin\u2013Whitewater',
    nickname: 'Warhawks',
    city: 'Whitewater',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Wittenberg University',
    nickname: 'Tigers',
    city: 'Springfield',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'College of Wooster',
    nickname: 'Fighting Scots',
    city: 'Wooster',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Worcester Polytechnic Institute',
    nickname: 'Engineers',
    city: 'Worcester',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'naia',
  },
  {
    school: 'Worcester State University',
    nickname: 'Lancers',
    city: 'Worcester',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'naia',
  },
  {
    school: 'Yeshiva University',
    nickname: 'Maccabees',
    city: 'New York',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'naia',
  },
  {
    school: 'York College, City University of New York',
    nickname: 'Cardinals',
    city: 'Queens',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'naia',
  },
  {
    school: 'York College of Pennsylvania',
    nickname: 'Spartans',
    city: 'York',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'naia',
  },
  {
    school: 'Adrian College',
    nickname: 'Bulldogs',
    city: 'Adrian',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Agnes Scott College',
    nickname: 'Scotties',
    city: 'Decatur',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Albertus Magnus College',
    nickname: 'Falcons',
    city: 'New Haven',
    state: 'CT',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Albion College',
    nickname: 'Britons',
    city: 'Albion',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Albright College',
    nickname: 'Lions',
    city: 'Reading',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Alfred University',
    nickname: 'Saxons',
    city: 'Alfred',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Alfred State College',
    nickname: 'Pioneers',
    city: 'Alfred',
    state: 'NY',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Allegheny College',
    nickname: 'Gators',
    city: 'Meadville',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Alma College',
    nickname: 'Scots',
    city: 'Alma',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Alvernia University',
    nickname: 'Golden Wolves',
    city: 'Reading',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Alverno College',
    nickname: 'Inferno',
    city: 'Milwaukee',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Amherst College',
    nickname: 'Mammoths',
    city: 'Amherst',
    state: 'MA',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Anderson University',
    nickname: 'Ravens and Lady Ravens',
    city: 'Anderson',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Anna Maria College',
    nickname: 'Amcats',
    city: 'Paxton',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Arcadia University',
    nickname: 'Knights',
    city: 'Glenside',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Asbury University',
    nickname: 'Eagles',
    city: 'Wilmore',
    state: 'KY',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Augsburg University',
    nickname: 'Auggies',
    city: 'Minneapolis',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Augustana College',
    nickname: 'Vikings',
    city: 'Rock Island',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Aurora University',
    nickname: 'Spartans',
    city: 'Aurora',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Austin College',
    nickname: 'Kangaroos',
    city: 'Sherman',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Averett University',
    nickname: 'Cougars',
    city: 'Danville',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Babson College',
    nickname: 'Beavers',
    city: 'Wellesley',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Baldwin Wallace University',
    nickname: 'Yellow Jackets',
    city: 'Berea',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bard College',
    nickname: 'Raptors',
    city: 'Annandale-on-Hudson',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Baruch College',
    nickname: 'Bearcats',
    city: 'New York',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bates College',
    nickname: 'Bobcats',
    city: 'Lewiston',
    state: 'ME',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Belhaven University',
    nickname: 'Blazers',
    city: 'Jackson',
    state: 'MS',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Beloit College',
    nickname: 'Buccaneers',
    city: 'Beloit',
    state: 'WI',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Benedictine University',
    nickname: 'Eagles',
    city: 'Lisle',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Berea College',
    nickname: 'Mountaineers',
    city: 'Berea',
    state: 'KY',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Berry College',
    nickname: 'Vikings',
    city: 'Mount Berry',
    state: 'GA',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Bethany College',
    nickname: 'Bison',
    city: 'Bethany',
    state: 'WV',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Bethany Lutheran College',
    nickname: 'Vikings',
    city: 'Mankato',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bethel University',
    nickname: 'Royals',
    city: 'Arden Hills',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Blackburn College',
    nickname: 'Beavers',
    city: 'Carlinville',
    state: 'IL',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bluffton University',
    nickname: 'Beavers',
    city: 'Bluffton',
    state: 'OH',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bowdoin College',
    nickname: 'Polar Bears',
    city: 'Brunswick',
    state: 'ME',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Brandeis University',
    nickname: 'Judges',
    city: 'Waltham',
    state: 'MA',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Brevard College',
    nickname: 'Tornados',
    city: 'Brevard',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bridgewater College',
    nickname: 'Eagles',
    city: 'Bridgewater',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bridgewater State University',
    nickname: 'Bears',
    city: 'Bridgewater',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Brooklyn College',
    nickname: 'Bulldogs',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Bryn Athyn College',
    nickname: 'Lions',
    city: 'Bryn Athyn',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Bryn Mawr College',
    nickname: 'Owls',
    city: 'Bryn Mawr',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Buena Vista University',
    nickname: 'Beavers',
    city: 'Storm Lake',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Buffalo State University',
    nickname: 'Bengals',
    city: 'Buffalo',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Cairn University',
    nickname: 'Highlanders',
    city: 'Langhorne',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'California Institute of Technology',
    nickname: 'Beavers',
    city: 'Pasadena',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'California Lutheran University',
    nickname: 'Kingsmen and Regals',
    city: 'Thousand Oaks',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of California, Santa Cruz',
    nickname: 'Banana Slugs',
    city: 'Santa Cruz',
    state: 'CA',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Calvin University',
    nickname: 'Knights',
    city: 'Grand Rapids',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Capital University',
    nickname: 'Crusaders',
    city: 'Bexley',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Carleton College',
    nickname: 'Knights',
    city: 'Northfield',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Carlow University',
    nickname: 'Celtics',
    city: 'Pittsburgh',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Carnegie Mellon University',
    nickname: 'Tartans',
    city: 'Pittsburgh',
    state: 'PA',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Carroll University',
    nickname: 'Pioneers',
    city: 'Waukesha',
    state: 'WI',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Carthage College',
    nickname: 'Firebirds',
    city: 'Kenosha',
    state: 'WI',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Case Western Reserve University',
    nickname: 'Spartans',
    city: 'Cleveland',
    state: 'OH',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Catholic University of America',
    nickname: 'Cardinals',
    city: 'Washington',
    state: 'DC',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Cedar Crest College',
    nickname: 'Falcons',
    city: 'Allentown',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Centenary College of Louisiana',
    nickname: 'Gents and Ladies',
    city: 'Shreveport',
    state: 'LA',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Centenary University',
    nickname: 'Cyclones',
    city: 'Hackettstown',
    state: 'NJ',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'Central College',
    nickname: 'Dutch',
    city: 'Pella',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Centre College',
    nickname: 'Colonels',
    city: 'Danville',
    state: 'KY',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Chapman University',
    nickname: 'Panthers',
    city: 'Orange',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Chatham University',
    nickname: 'Cougars',
    city: 'Pittsburgh',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'University of Chicago',
    nickname: 'Maroons',
    city: 'Chicago',
    state: 'IL',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Christopher Newport University',
    nickname: 'Captains',
    city: 'Newport News',
    state: 'VA',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'City College of New York',
    nickname: 'Beavers',
    city: 'New York',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Claremont McKenna College, Harvey Mudd College, and Scripps College',
    nickname: 'Stags and Athenas',
    city: 'Claremont',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Clark University',
    nickname: 'Cougars',
    city: 'Worcester',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Clarkson University',
    nickname: 'Golden Knights',
    city: 'Potsdam',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Coe College',
    nickname: 'Kohawks',
    city: 'Cedar Rapids',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Colby College',
    nickname: 'Mules',
    city: 'Waterville',
    state: 'ME',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Colby\u2013Sawyer College',
    nickname: 'Chargers',
    city: 'New London',
    state: 'NH',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Colorado College',
    nickname: 'Tigers',
    city: 'Colorado Springs',
    state: 'CO',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Concordia College',
    nickname: 'Cobbers',
    city: 'Moorhead',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Concordia University Chicago',
    nickname: 'Cougars',
    city: 'River Forest',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Concordia University Texas',
    nickname: 'Tornados',
    city: 'Austin',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Concordia University Wisconsin',
    nickname: 'Falcons',
    city: 'Mequon',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Connecticut College',
    nickname: 'Camels',
    city: 'New London',
    state: 'CT',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Cornell College',
    nickname: 'Rams',
    city: 'Mount Vernon',
    state: 'IA',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Covenant College',
    nickname: 'Scots',
    city: 'Lookout Mountain',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Crown College',
    nickname: 'Polars',
    city: 'St. Bonifacius',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Curry College',
    nickname: 'Colonels',
    city: 'Milton',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'University of Dallas',
    nickname: 'Crusaders',
    city: 'Irving',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Dean College',
    nickname: 'Bulldogs',
    city: 'Franklin',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Delaware Valley University',
    nickname: 'Aggies',
    city: 'Doylestown',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Denison University',
    nickname: 'Big Red',
    city: 'Granville',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'DePauw University',
    nickname: 'Tigers',
    city: 'Greencastle',
    state: 'IN',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'DeSales University',
    nickname: 'Bulldogs',
    city: 'Center Valley',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Dickinson College',
    nickname: 'Red Devils',
    city: 'Carlisle',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Dominican University',
    nickname: 'Stars',
    city: 'River Forest',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Drew University',
    nickname: 'Rangers',
    city: 'Madison',
    state: 'NJ',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'University of Dubuque',
    nickname: 'Spartans',
    city: 'Dubuque',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Earlham College',
    nickname: 'Quakers',
    city: 'Richmond',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'East Texas Baptist University',
    nickname: 'Tigers',
    city: 'Marshall',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'division3',
  },
  {
    school: 'Eastern Connecticut State University',
    nickname: 'Warriors',
    city: 'Willimantic',
    state: 'CT',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Eastern Mennonite University',
    nickname: 'Royals',
    city: 'Harrisonburg',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Eastern Nazarene College',
    nickname: 'Lions',
    city: 'Quincy',
    state: 'MA',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Eastern University',
    nickname: 'Eagles',
    city: 'St. Davids',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Edgewood College',
    nickname: 'Eagles',
    city: 'Madison',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Elizabethtown College',
    nickname: 'Blue Jays',
    city: 'Elizabethtown',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Elmhurst University',
    nickname: 'Bluejays',
    city: 'Elmhurst',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Elmira College',
    nickname: 'Soaring Eagles',
    city: 'Elmira',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Elms College',
    nickname: 'Blazers',
    city: 'Chicopee',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Emerson College',
    nickname: 'Lions',
    city: 'Boston',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Emmanuel College',
    nickname: 'Saints',
    city: 'Boston',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Emory University',
    nickname: 'Eagles',
    city: 'Atlanta',
    state: 'GA',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Endicott College',
    nickname: 'Gulls',
    city: 'Beverly',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Eureka College',
    nickname: 'Red Devils',
    city: 'Eureka',
    state: 'IL',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Fairleigh Dickinson University, Florham',
    nickname: 'Devils',
    city: 'Madison/Florham Park',
    state: 'NJ',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Farmingdale State College',
    nickname: 'Rams',
    city: 'Farmingdale',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'Ferrum College',
    nickname: 'Panthers',
    city: 'Ferrum',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Fitchburg State University',
    nickname: 'Falcons',
    city: 'Fitchburg',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Fontbonne University',
    nickname: 'Griffins',
    city: 'St. Louis',
    state: 'MO',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Framingham State University',
    nickname: 'Rams',
    city: 'Framingham',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Franciscan University of Steubenville',
    nickname: 'Barons',
    city: 'Steubenville',
    state: 'OH',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Franklin & Marshall College',
    nickname: 'Diplomats',
    city: 'Lancaster',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Franklin College',
    nickname: 'Grizzlies',
    city: 'Franklin',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Gallaudet University',
    nickname: 'Bison',
    city: 'Washington',
    state: 'DC',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Geneva College',
    nickname: 'Golden Tornadoes',
    city: 'Beaver Falls',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'George Fox University',
    nickname: 'Bruins',
    city: 'Newberg',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Gettysburg College',
    nickname: 'Bullets',
    city: 'Gettysburg',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Gordon College',
    nickname: 'Fighting Scots',
    city: 'Wenham',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Goucher College',
    nickname: 'Gophers',
    city: 'Towson',
    state: 'MD',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Greensboro College',
    nickname: 'Pride',
    city: 'Greensboro',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Greenville University',
    nickname: 'Panthers',
    city: 'Greenville',
    state: 'IL',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Grinnell College',
    nickname: 'Pioneers',
    city: 'Grinnell',
    state: 'IA',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Grove City College',
    nickname: 'Wolverines',
    city: 'Grove City',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Guilford College',
    nickname: 'Quakers',
    city: 'Greensboro',
    state: 'NC',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Gustavus Adolphus College',
    nickname: 'Gusties',
    city: 'St. Peter',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Gwynedd Mercy University',
    nickname: 'Griffins',
    city: 'Lower Gwynedd Township',
    state: 'PA',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'Hamilton College',
    nickname: 'Continentals',
    city: 'Clinton',
    state: 'NY',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hamline University',
    nickname: 'Pipers',
    city: 'St. Paul',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hampden\u2013Sydney College',
    nickname: 'Tigers',
    city: 'Hampden Sydney',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hanover College',
    nickname: 'Panthers',
    city: 'Hanover',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hardin\u2013Simmons University',
    nickname: 'Cowboys and Cowgirls',
    city: 'Abilene',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'division3',
  },
  {
    school: 'University of Hartford',
    nickname: 'Hawks',
    city: 'West Hartford',
    state: 'CT',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Hartwick College',
    nickname: 'Hawks',
    city: 'Oneonta',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Haverford College',
    nickname: 'Fords',
    city: 'Haverford',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Heidelberg University',
    nickname: 'Student Princes',
    city: 'Tiffin',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hendrix College',
    nickname: 'Warriors',
    city: 'Conway',
    state: 'AR',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hilbert College',
    nickname: 'Hawks',
    city: 'Hamburg',
    state: 'NY',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Hiram College',
    nickname: 'Terriers',
    city: 'Hiram',
    state: 'OH',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Hobart College',
    nickname: 'Statesmen',
    city: 'Geneva',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Hollins University',
    nickname: 'None',
    city: 'Roanoke',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Hood College',
    nickname: 'Blazers',
    city: 'Frederick',
    state: 'MD',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Hope College',
    nickname: 'Flying Dutchmen',
    city: 'Holland',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Houghton University',
    nickname: 'Highlanders',
    city: 'Houghton',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Howard Payne University',
    nickname: 'Yellow Jackets',
    city: 'Brownwood',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'division3',
  },
  {
    school: 'Hunter College',
    nickname: 'Hawks',
    city: 'New York',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Huntingdon College',
    nickname: 'Hawks',
    city: 'Montgomery',
    state: 'AL',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Husson University',
    nickname: 'Eagles',
    city: 'Bangor',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Illinois College',
    nickname: 'Blueboys and Lady Blues',
    city: 'Jacksonville',
    state: 'IL',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Illinois Institute of Technology',
    nickname: 'Scarlet Hawks',
    city: 'Chicago',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Illinois Wesleyan University',
    nickname: 'Titans',
    city: 'Bloomington',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Immaculata University',
    nickname: 'Mighty Macs',
    city: 'Immaculata',
    state: 'PA',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'Ithaca College',
    nickname: 'Bombers',
    city: 'Ithaca',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'John Carroll University',
    nickname: 'Blue Streaks',
    city: 'University Heights',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'John Jay College of Criminal Justice',
    nickname: 'Bloodhounds',
    city: 'New York',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Johns Hopkins University',
    nickname: 'Blue Jays',
    city: 'Baltimore',
    state: 'MD',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Johnson & Wales University',
    nickname: 'Wildcats',
    city: 'Providence',
    state: 'RI',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Juniata College',
    nickname: 'Eagles',
    city: 'Huntingdon',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Kalamazoo College',
    nickname: 'Hornets',
    city: 'Kalamazoo',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Kean University',
    nickname: 'Cougars',
    city: 'Union Township',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Keene State College',
    nickname: 'Owls',
    city: 'Keene',
    state: 'NH',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Kenyon College',
    nickname: 'Owls',
    city: 'Gambier',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Keuka College',
    nickname: 'Wolves',
    city: 'Keuka Park',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Keystone College',
    nickname: 'Giants',
    city: 'La Plume Township',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: "King's College",
    nickname: 'Monarchs',
    city: 'Wilkes-Barre',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Knox College',
    nickname: 'Prairie Fire',
    city: 'Galesburg',
    state: 'IL',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'La Roche University',
    nickname: 'Redhawks',
    city: 'Pittsburgh',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'University of La Verne',
    nickname: 'Leopards',
    city: 'La Verne',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'LaGrange College',
    nickname: 'Panthers',
    city: 'LaGrange',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Lake Forest College',
    nickname: 'Foresters',
    city: 'Lake Forest',
    state: 'IL',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Lakeland University',
    nickname: 'Muskies',
    city: 'Sheboygan',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Lancaster Bible College',
    nickname: 'Chargers',
    city: 'Lancaster',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Lasell University',
    nickname: 'Lasers',
    city: 'Newton',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Lawrence University',
    nickname: 'Vikings',
    city: 'Appleton',
    state: 'WI',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Lebanon Valley College',
    nickname: 'Flying Dutchmen',
    city: 'Annville',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Lehman College',
    nickname: 'Lightning',
    city: 'The Bronx',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Lesley University',
    nickname: 'Lynx',
    city: 'Boston',
    state: 'MA',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'LeTourneau University',
    nickname: 'Yellow Jackets',
    city: 'Longview',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Lewis & Clark College',
    nickname: 'Pioneers',
    city: 'Portland',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Linfield University',
    nickname: 'Wildcats',
    city: 'McMinnville',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Loras College',
    nickname: 'Duhawks',
    city: 'Dubuque',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Luther College',
    nickname: 'Norse',
    city: 'Decorah',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Lycoming College',
    nickname: 'Warriors',
    city: 'Williamsport',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'University of Lynchburg',
    nickname: 'Hornets',
    city: 'Lynchburg',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Lyon College',
    nickname: 'Scots',
    city: 'Batesville',
    state: 'AR',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Macalester College',
    nickname: 'Scots',
    city: 'St. Paul',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Maine at Farmington',
    nickname: 'Beavers',
    city: 'Farmington',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Maine Maritime Academy',
    nickname: 'Mariners',
    city: 'Castine',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'University of Maine at Presque Isle',
    nickname: 'Owls',
    city: 'Presque Isle',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Manchester University',
    nickname: 'Spartans',
    city: 'North Manchester',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Manhattanville University',
    nickname: 'Valiants',
    city: 'Purchase',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'Maranatha Baptist University',
    nickname: 'Sabercats',
    city: 'Watertown',
    state: 'WI',
    conference: 'Independent',
    division: 'division3',
  },
  {
    school: 'Marian University',
    nickname: 'Sabres',
    city: 'Fond du Lac',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Marietta College',
    nickname: 'Pioneers',
    city: 'Marietta',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Martin Luther College',
    nickname: 'Knights',
    city: 'New Ulm',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Mary Baldwin University',
    nickname: 'Fighting Squirrels',
    city: 'Staunton',
    state: 'VA',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Mary Hardin\u2013Baylor',
    nickname: 'Crusaders',
    city: 'Belton',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'division3',
  },
  {
    school: 'University of Mary Washington',
    nickname: 'Eagles',
    city: 'Fredericksburg',
    state: 'VA',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Marymount University',
    nickname: 'Saints',
    city: 'Arlington',
    state: 'VA',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'Maryville College',
    nickname: 'Scots',
    city: 'Maryville',
    state: 'TN',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Marywood University',
    nickname: 'Pacers',
    city: 'Scranton',
    state: 'PA',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'University of Massachusetts Boston',
    nickname: 'Beacons',
    city: 'Boston',
    state: 'MA',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Massachusetts College of Liberal Arts',
    nickname: 'Trailblazers',
    city: 'North Adams',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Massachusetts Dartmouth',
    nickname: 'Corsairs',
    city: 'Dartmouth',
    state: 'MA',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Massachusetts Institute of Technology',
    nickname: 'Engineers',
    city: 'Cambridge',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Massachusetts Maritime Academy',
    nickname: 'Buccaneers',
    city: 'Buzzards Bay',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'McDaniel College',
    nickname: 'Green Terror',
    city: 'Westminster',
    state: 'MD',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'McMurry University',
    nickname: 'War Hawks',
    city: 'Abilene',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Medgar Evers College',
    nickname: 'Cougars',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Meredith College',
    nickname: 'Angels',
    city: 'Raleigh',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Messiah University',
    nickname: 'Falcons',
    city: 'Grantham',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Methodist University',
    nickname: 'Monarchs',
    city: 'Fayetteville',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Middlebury College',
    nickname: 'Panthers',
    city: 'Middlebury',
    state: 'VT',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Millikin University',
    nickname: 'Big Blue',
    city: 'Decatur',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Millsaps College',
    nickname: 'Majors and Lady Majors',
    city: 'Jackson',
    state: 'MS',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Milwaukee School of Engineering',
    nickname: 'Raiders',
    city: 'Milwaukee',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'University of Minnesota Morris',
    nickname: 'Cougars',
    city: 'Morris',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Misericordia University',
    nickname: 'Cougars',
    city: 'Dallas',
    state: 'PA',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Mississippi University for Women',
    nickname: 'Owls',
    city: 'Columbus',
    state: 'MS',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Mitchell College',
    nickname: 'Mariners',
    city: 'New London',
    state: 'CT',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Monmouth College',
    nickname: 'Scots',
    city: 'Monmouth',
    state: 'IL',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Montclair State University',
    nickname: 'Red Hawks',
    city: 'Montclair',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Moravian University',
    nickname: 'Greyhounds',
    city: 'Bethlehem',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Mount Aloysius College',
    nickname: 'Mounties',
    city: 'Cresson',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Mount Holyoke College',
    nickname: 'Lyons',
    city: 'South Hadley',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Mount Mary University',
    nickname: 'Blue Angels',
    city: 'Milwaukee',
    state: 'WI',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Mount St. Joseph University',
    nickname: 'Lions',
    city: 'Cincinnati',
    state: 'OH',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Mount Saint Mary College',
    nickname: 'Knights',
    city: 'Newburgh',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'University of Mount Saint Vincent',
    nickname: 'Dolphins',
    city: 'The Bronx',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'University of Mount Union',
    nickname: 'Purple Raiders',
    city: 'Alliance',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Muhlenberg College',
    nickname: 'Mules',
    city: 'Allentown',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Muskingum University',
    nickname: 'Fighting Muskies',
    city: 'New Concord',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Nazareth University',
    nickname: 'Golden Flyers',
    city: 'Pittsford',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'Nebraska Wesleyan University',
    nickname: 'Prairie Wolves',
    city: 'Lincoln',
    state: 'NE',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Neumann University',
    nickname: 'Knights',
    city: 'Aston',
    state: 'PA',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'New England College',
    nickname: 'Pilgrims',
    city: 'Henniker',
    state: 'NH',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of New England',
    nickname: "Nor'easters",
    city: 'Biddeford',
    state: 'ME',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'The College of New Jersey',
    nickname: 'Lions',
    city: 'Ewing',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'New Jersey City University',
    nickname: 'Gothic Knights',
    city: 'Jersey City',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Brockport',
    nickname: 'Golden Eagles',
    city: 'Brockport',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'State University of New York at Canton',
    nickname: 'Kangaroos',
    city: 'Canton',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Cobleskill',
    nickname: 'Fighting Tigers',
    city: 'Cobleskill',
    state: 'NY',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Cortland',
    nickname: 'Red Dragons',
    city: 'Cortland',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Delhi',
    nickname: 'Broncos',
    city: 'Delhi',
    state: 'NY',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Fredonia',
    nickname: 'Blue Devils',
    city: 'Fredonia',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Geneseo',
    nickname: 'Knights',
    city: 'Geneseo',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'State University of New York Maritime College',
    nickname: 'Privateers',
    city: 'The Bronx',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Morrisville',
    nickname: 'Mustangs',
    city: 'Morrisville',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York Polytechnic Institute',
    nickname: 'Wildcats',
    city: 'Marcy',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'State University of New York at New Paltz',
    nickname: 'Hawks',
    city: 'New Paltz',
    state: 'NY',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Old Westbury',
    nickname: 'Panthers',
    city: 'Old Westbury',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Oneonta',
    nickname: 'Red Dragons',
    city: 'Oneonta',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Oswego',
    nickname: 'Lakers',
    city: 'Oswego',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Plattsburgh',
    nickname: 'Cardinals',
    city: 'Plattsburgh',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Potsdam',
    nickname: 'Bears',
    city: 'Potsdam',
    state: 'NY',
    conference: 'State University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'State University of New York at Purchase',
    nickname: 'Panthers',
    city: 'Purchase',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'New York University',
    nickname: 'Violets',
    city: 'New York',
    state: 'NY',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Nichols College',
    nickname: 'Bison',
    city: 'Dudley',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'North Carolina Wesleyan University',
    nickname: 'Bishops',
    city: 'Rocky Mount',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'North Central College',
    nickname: 'Cardinals',
    city: 'Naperville',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'North Central University',
    nickname: 'Rams',
    city: 'Minneapolis',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'North Park University',
    nickname: 'Vikings',
    city: 'Chicago',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Northland College',
    nickname: 'Lumberjacks and Lumberjills',
    city: 'Ashland',
    state: 'WI',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Northwestern - St. Paul',
    nickname: 'Eagles',
    city: 'Roseville',
    state: 'MN',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Norwich University',
    nickname: 'Cadets',
    city: 'Northfield',
    state: 'VT',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Notre Dame of Maryland University',
    nickname: 'Gators',
    city: 'Baltimore',
    state: 'MD',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Oberlin College',
    nickname: 'Yeomen and Yeowomen',
    city: 'Oberlin',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Occidental College',
    nickname: 'Tigers',
    city: 'Los Angeles',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Oglethorpe University',
    nickname: 'Stormy Petrels',
    city: 'Atlanta',
    state: 'GA',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Ohio Northern University',
    nickname: 'Polar Bears',
    city: 'Ada',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Ohio Wesleyan University',
    nickname: 'Battling Bishops',
    city: 'Delaware',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Olivet',
    nickname: 'Comets',
    city: 'Olivet',
    state: 'MI',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Otterbein University',
    nickname: 'Cardinals',
    city: 'Westerville',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of the Ozarks',
    nickname: 'Eagles',
    city: 'Clarksville',
    state: 'AR',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Pacific Lutheran University',
    nickname: 'Lutes',
    city: 'Tacoma',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Pacific University',
    nickname: 'Boxers',
    city: 'Forest Grove',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania College of Technology',
    nickname: 'Wildcats',
    city: 'Williamsport',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Abington',
    nickname: 'Nittany Lions',
    city: 'Abington',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Altoona',
    nickname: 'Lions',
    city: 'Altoona',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Berks College',
    nickname: 'Nittany Lions',
    city: 'Reading',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Behrend',
    nickname: 'Lions',
    city: 'Erie',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Brandywine',
    nickname: 'Lions',
    city: 'Media',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Pennsylvania State University, Harrisburg',
    nickname: 'Lions',
    city: 'Harrisburg',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Pfeiffer University',
    nickname: 'Falcons',
    city: 'Misenheimer',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Piedmont University',
    nickname: 'Lions',
    city: 'Demorest',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'University of Pittsburgh at Bradford',
    nickname: 'Panthers',
    city: 'Bradford',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'University of Pittsburgh at Greensburg',
    nickname: 'Bobcats',
    city: 'Greensburg',
    state: 'PA',
    conference: 'Allegheny Mountain Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Plymouth State University',
    nickname: 'Panthers',
    city: 'Plymouth',
    state: 'NH',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Pomona College and Pitzer College',
    nickname: 'Sagehens',
    city: 'Claremont',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Pratt Institute',
    nickname: 'Cannoneers',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'Atlantic East Conference',
    division: 'division3',
  },
  {
    school: 'Principia College',
    nickname: 'Panthers',
    city: 'Elsah',
    state: 'IL',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Puget Sound',
    nickname: 'Loggers',
    city: 'Tacoma',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Ramapo College',
    nickname: 'Roadrunners',
    city: 'Mahwah',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Randolph College',
    nickname: 'WildCats',
    city: 'Lynchburg',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Randolph\u2013Macon College',
    nickname: 'Yellow Jackets',
    city: 'Ashland',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Redlands',
    nickname: 'Bulldogs',
    city: 'Redlands',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Regis College',
    nickname: 'Pride',
    city: 'Weston',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Rensselaer Polytechnic Institute',
    nickname: 'Engineers',
    city: 'Troy',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Rhode Island College',
    nickname: 'Anchormen',
    city: 'Providence',
    state: 'RI',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Rhodes College',
    nickname: 'Lynx',
    city: 'Memphis',
    state: 'TN',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Ripon College',
    nickname: 'Red Hawks',
    city: 'Ripon',
    state: 'WI',
    conference: 'Midwest Conference',
    division: 'division3',
  },
  {
    school: 'Rivier University',
    nickname: 'Raiders',
    city: 'Nashua',
    state: 'NH',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Roanoke College',
    nickname: 'Maroons',
    city: 'Salem',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Rochester',
    nickname: 'Yellowjackets',
    city: 'Rochester',
    state: 'NY',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Rochester Institute of Technology',
    nickname: 'Tigers',
    city: 'Rochester',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Rockford University',
    nickname: 'Regents',
    city: 'Rockford',
    state: 'IL',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'Roger Williams University',
    nickname: 'Hawks',
    city: 'Bristol',
    state: 'RI',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Rose-Hulman Institute of Technology',
    nickname: "Fightin' Engineers",
    city: 'Terre Haute',
    state: 'IN',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Rosemont College',
    nickname: 'Ravens',
    city: 'Rosemont',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Rowan University',
    nickname: 'Profs',
    city: 'Glassboro',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Rutgers University\u2013Camden',
    nickname: 'Scarlet Raptors',
    city: 'Camden',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Rutgers University\u2013Newark',
    nickname: 'Scarlet Raiders',
    city: 'Newark',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Russell Sage College',
    nickname: 'Gators',
    city: 'Albany & Troy',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'College of Saint Benedict',
    nickname: 'Bennies',
    city: 'St. Joseph',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'St. Catherine University',
    nickname: 'Wildcats',
    city: 'St. Paul',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Saint Elizabeth University',
    nickname: 'Screaming Eagles',
    city: 'Convent Station',
    state: 'NJ',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'St. John Fisher University',
    nickname: 'Cardinals',
    city: 'Pittsford',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: "Saint John's University",
    nickname: 'Johnnies',
    city: 'Collegeville',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Saint Joseph',
    nickname: 'Blue Jays',
    city: 'West Hartford',
    state: 'CT',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: "St. Joseph's University",
    nickname: 'Bears',
    city: 'Brooklyn',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: "St. Joseph's University",
    nickname: 'Golden Eagles',
    city: 'Long Island',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: "Saint Joseph's College of Maine",
    nickname: 'Monks',
    city: 'Standish',
    state: 'ME',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'St. Lawrence University',
    nickname: 'Saints',
    city: 'Canton',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: "Saint Mary's College",
    nickname: 'Belles',
    city: 'Notre Dame',
    state: 'IN',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: "St. Mary's College of Maryland",
    nickname: 'Seahawks',
    city: "St. Mary's City",
    state: 'MD',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: "Saint Mary's University of Minnesota",
    nickname: 'Cardinals',
    city: 'Winona',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'St. Norbert College',
    nickname: 'Green Knights',
    city: 'De Pere',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'St. Olaf College',
    nickname: 'Oles',
    city: 'Northfield',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'The College of St. Scholastica',
    nickname: 'Saints',
    city: 'Duluth',
    state: 'MN',
    conference: 'Minnesota Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of St. Thomas (Texas)',
    nickname: 'Celts',
    city: 'Houston',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Saint Vincent College',
    nickname: 'Bearcats',
    city: 'Latrobe',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Salem College',
    nickname: 'Spirits',
    city: 'Winston-Salem',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Salem State University',
    nickname: 'Vikings',
    city: 'Salem',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Salisbury University',
    nickname: 'Sea Gulls',
    city: 'Salisbury',
    state: 'MD',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Salve Regina University',
    nickname: 'Seahawks',
    city: 'Newport',
    state: 'RI',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Sarah Lawrence College',
    nickname: 'Gryphons',
    city: 'Yonkers',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'Schreiner University',
    nickname: 'Mountaineers',
    city: 'Kerrville',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Scranton',
    nickname: 'Royals',
    city: 'Scranton',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'University of the South',
    nickname: 'Tigers',
    city: 'Sewanee',
    state: 'TN',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Shenandoah University',
    nickname: 'Hornets',
    city: 'Winchester',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Simmons University',
    nickname: 'Sharks',
    city: 'Boston',
    state: 'MA',
    conference: 'Great Northeast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Simpson College',
    nickname: 'Storm',
    city: 'Indianola',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Skidmore College',
    nickname: 'Thoroughbreds',
    city: 'Saratoga Springs',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Smith College',
    nickname: 'Pioneers',
    city: 'Northampton',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'University of Southern Maine',
    nickname: 'Huskies',
    city: 'Portland',
    state: 'ME',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Southern Virginia University',
    nickname: 'Knights',
    city: 'Buena Vista',
    state: 'VA',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Southwestern University',
    nickname: 'Pirates',
    city: 'Georgetown',
    state: 'TX',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Spalding University',
    nickname: 'Golden Eagles',
    city: 'Louisville',
    state: 'KY',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Springfield College',
    nickname: 'Pride',
    city: 'Springfield',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Stevens Institute of Technology',
    nickname: 'Ducks',
    city: 'Hoboken',
    state: 'NJ',
    conference: 'MAC Freedom',
    division: 'division3',
  },
  {
    school: 'Stevenson University',
    nickname: 'Mustangs',
    city: 'Stevenson',
    state: 'MD',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Stockton University',
    nickname: 'Ospreys',
    city: 'Pomona',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Suffolk University',
    nickname: 'Rams',
    city: 'Boston',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Susquehanna University',
    nickname: 'River Hawks',
    city: 'Selinsgrove',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Swarthmore College',
    nickname: 'Garnet',
    city: 'Swarthmore',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Sweet Briar College',
    nickname: 'Vixens',
    city: 'Sweet Briar',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Texas at Dallas',
    nickname: 'Comets',
    city: 'Dallas',
    state: 'TX',
    conference: 'American Southwest Conference',
    division: 'division3',
  },
  {
    school: 'Texas Lutheran University',
    nickname: 'Bulldogs',
    city: 'Seguin',
    state: 'TX',
    conference: 'Southern Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Thiel College',
    nickname: 'Tomcats',
    city: 'Greenville',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Thomas College',
    nickname: 'Terriers',
    city: 'Waterville',
    state: 'ME',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Transylvania University',
    nickname: 'Pioneers',
    city: 'Lexington',
    state: 'KY',
    conference: 'Heartland Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Trine University',
    nickname: 'Thunder',
    city: 'Angola',
    state: 'IN',
    conference: 'Michigan Intercollegiate Athletic Association',
    division: 'division3',
  },
  {
    school: 'Trinity College',
    nickname: 'Bantams',
    city: 'Hartford',
    state: 'CT',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Trinity University',
    nickname: 'Tigers',
    city: 'San Antonio',
    state: 'TX',
    conference: 'Southern Athletic Association',
    division: 'division3',
  },
  {
    school: 'Trinity Washington University',
    nickname: 'Tigers',
    city: 'Washington',
    state: 'DC',
    conference: 'Independent',
    division: 'division3',
  },
  {
    school: 'Tufts University',
    nickname: 'Jumbos',
    city: 'Medford',
    state: 'MA',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Union College',
    nickname: 'Garnet Chargers',
    city: 'Schenectady',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'United States Coast Guard Academy',
    nickname: 'Bears',
    city: 'New London',
    state: 'CT',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'United States Merchant Marine Academy',
    nickname: 'Mariners',
    city: 'Kings Point',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'Ursinus College',
    nickname: 'Bears',
    city: 'Collegeville',
    state: 'PA',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Utica University',
    nickname: 'Pioneers',
    city: 'Utica',
    state: 'NY',
    conference: 'Empire 8',
    division: 'division3',
  },
  {
    school: 'University of Valley Forge',
    nickname: 'Patriots',
    city: 'Phoenixville',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'Vassar College',
    nickname: 'Brewers',
    city: 'Poughkeepsie',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Vermont State University\u2013Castleton',
    nickname: 'Spartans',
    city: 'Castleton',
    state: 'VT',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Vermont State University\u2013Johnson',
    nickname: 'Badgers',
    city: 'Johnson',
    state: 'VT',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Vermont State University\u2013Lyndon',
    nickname: 'Hornets',
    city: 'Lyndonville',
    state: 'VT',
    conference: 'North Atlantic Conference',
    division: 'division3',
  },
  {
    school: 'Virginia Wesleyan University',
    nickname: 'Marlins',
    city: 'Virginia Beach',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wabash College',
    nickname: 'Little Giants',
    city: 'Crawfordsville',
    state: 'IN',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Warren Wilson College',
    nickname: 'Owls',
    city: 'Swannanoa',
    state: 'NC',
    conference: 'Coast to Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wartburg College',
    nickname: 'Knights',
    city: 'Waverly',
    state: 'IA',
    conference: 'American Rivers Conference',
    division: 'division3',
  },
  {
    school: 'Washington & Jefferson College',
    nickname: 'Presidents',
    city: 'Washington',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Washington and Lee University',
    nickname: 'Generals',
    city: 'Lexington',
    state: 'VA',
    conference: 'Old Dominion Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Washington College',
    nickname: 'Shoremen',
    city: 'Chestertown',
    state: 'MD',
    conference: 'Centennial Conference',
    division: 'division3',
  },
  {
    school: 'Washington University in St. Louis',
    nickname: 'Bears',
    city: 'St. Louis',
    state: 'MO',
    conference: 'University Athletic Association',
    division: 'division3',
  },
  {
    school: 'Waynesburg University',
    nickname: 'Yellow Jackets',
    city: 'Waynesburg',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Webster University',
    nickname: 'Gorloks',
    city: 'St. Louis',
    state: 'MO',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wellesley College',
    nickname: 'Blue',
    city: 'Wellesley',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Wentworth Institute of Technology',
    nickname: 'Leopards',
    city: 'Boston',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Wesleyan College',
    nickname: 'Wolves',
    city: 'Macon',
    state: 'GA',
    conference: 'Collegiate Conference of the South',
    division: 'division3',
  },
  {
    school: 'Wesleyan University',
    nickname: 'Cardinals',
    city: 'Middletown',
    state: 'CT',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Western Connecticut State University',
    nickname: 'Wolves',
    city: 'Danbury',
    state: 'CT',
    conference: 'Little East Conference',
    division: 'division3',
  },
  {
    school: 'Western New England University',
    nickname: 'Golden Bears',
    city: 'Springfield',
    state: 'MA',
    conference: 'Conference of New England',
    division: 'division3',
  },
  {
    school: 'Westfield State University',
    nickname: 'Owls',
    city: 'Westfield',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Westminster College',
    nickname: 'Blue Jays',
    city: 'Fulton',
    state: 'MO',
    conference: 'St. Louis Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Westminster College',
    nickname: 'Titans',
    city: 'New Wilmington',
    state: 'PA',
    conference: "Presidents' Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Wheaton College',
    nickname: 'Thunder',
    city: 'Wheaton',
    state: 'IL',
    conference: 'College Conference of Illinois and Wisconsin',
    division: 'division3',
  },
  {
    school: 'Wheaton College',
    nickname: 'Lyons',
    city: 'Norton',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Whitman College',
    nickname: 'Blues',
    city: 'Walla Walla',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Whittier College',
    nickname: 'Poets',
    city: 'Whittier',
    state: 'CA',
    conference: 'Southern California Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Whitworth University',
    nickname: 'Pirates',
    city: 'Spokane',
    state: 'WA',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'Widener University',
    nickname: 'Pride',
    city: 'Chester',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Wilkes University',
    nickname: 'Colonels',
    city: 'Wilkes-Barre',
    state: 'PA',
    conference: 'Landmark Conference',
    division: 'division3',
  },
  {
    school: 'Willamette University',
    nickname: 'Bearcats',
    city: 'Salem',
    state: 'OR',
    conference: 'Northwest Conference',
    division: 'division3',
  },
  {
    school: 'William Paterson University',
    nickname: 'Pioneers',
    city: 'Wayne',
    state: 'NJ',
    conference: 'New Jersey Athletic Conference',
    division: 'division3',
  },
  {
    school: 'William Peace University',
    nickname: 'Pacers',
    city: 'Raleigh',
    state: 'NC',
    conference: 'USA South Athletic Conference',
    division: 'division3',
  },
  {
    school: 'William Smith College',
    nickname: 'Herons',
    city: 'Geneva',
    state: 'NY',
    conference: 'Liberty League',
    division: 'division3',
  },
  {
    school: 'Williams College',
    nickname: 'Ephs',
    city: 'Williamstown',
    state: 'MA',
    conference: 'New England Small College Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wilmington College',
    nickname: 'Quakers',
    city: 'Wilmington',
    state: 'OH',
    conference: 'Ohio Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wilson College',
    nickname: 'Phoenix',
    city: 'Chambersburg',
    state: 'PA',
    conference: 'United East Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Eau Claire',
    nickname: 'Blugolds',
    city: 'Eau Claire',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013La Crosse',
    nickname: 'Eagles',
    city: 'La Crosse',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wisconsin Lutheran College',
    nickname: 'Warriors',
    city: 'Milwaukee',
    state: 'WI',
    conference: 'Northern Athletics Collegiate Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Oshkosh',
    nickname: 'Titans',
    city: 'Oshkosh',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Platteville',
    nickname: 'Pioneers',
    city: 'Platteville',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013River Falls',
    nickname: 'Falcons',
    city: 'River Falls',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Stevens Point',
    nickname: 'Pointers',
    city: 'Stevens Point',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Stout',
    nickname: 'Blue Devils',
    city: 'Menomonie',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Superior',
    nickname: 'Yellow Jackets',
    city: 'Superior',
    state: 'WI',
    conference: 'Upper Midwest Athletic Conference',
    division: 'division3',
  },
  {
    school: 'University of Wisconsin\u2013Whitewater',
    nickname: 'Warhawks',
    city: 'Whitewater',
    state: 'WI',
    conference: 'Wisconsin Intercollegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Wittenberg University',
    nickname: 'Tigers',
    city: 'Springfield',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'College of Wooster',
    nickname: 'Fighting Scots',
    city: 'Wooster',
    state: 'OH',
    conference: 'North Coast Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Worcester Polytechnic Institute',
    nickname: 'Engineers',
    city: 'Worcester',
    state: 'MA',
    conference: "New England Women's and Men's Athletic Conference",
    division: 'division3',
  },
  {
    school: 'Worcester State University',
    nickname: 'Lancers',
    city: 'Worcester',
    state: 'MA',
    conference: 'Massachusetts State Collegiate Athletic Conference',
    division: 'division3',
  },
  {
    school: 'Yeshiva University',
    nickname: 'Maccabees',
    city: 'New York',
    state: 'NY',
    conference: 'Skyline Conference',
    division: 'division3',
  },
  {
    school: 'York College, City University of New York',
    nickname: 'Cardinals',
    city: 'Queens',
    state: 'NY',
    conference: 'City University of New York Athletic Conference',
    division: 'division3',
  },
  {
    school: 'York College of Pennsylvania',
    nickname: 'Spartans',
    city: 'York',
    state: 'PA',
    conference: 'MAC Commonwealth',
    division: 'division3',
  },
  {
    school: 'Academy of Art University',
    nickname: 'Urban Knights',
    city: 'San Francisco',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Adams State University',
    nickname: 'Grizzlies',
    city: 'Alamosa',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Adelphi University',
    nickname: 'Panthers',
    city: 'Garden City',
    state: 'NY',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'University of Alabama in Huntsville',
    nickname: 'Chargers',
    city: 'Huntsville',
    state: 'AL',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'University of Alaska Anchorage',
    nickname: 'Seawolves',
    city: 'Anchorage',
    state: 'AK',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Alaska Fairbanks',
    nickname: 'Nanooks',
    city: 'Fairbanks',
    state: 'AK',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Albany State University',
    nickname: 'Golden Rams',
    city: 'Albany',
    state: 'GA',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Allen University',
    nickname: 'Yellow Jackets',
    city: 'Columbia',
    state: 'SC',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'American International College',
    nickname: 'Yellow Jackets',
    city: 'Springfield',
    state: 'MA',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Anderson University',
    nickname: 'Trojans',
    city: 'Anderson',
    state: 'SC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Angelo State University',
    nickname: 'Rams & Rambelles',
    city: 'San Angelo',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Arkansas Tech University',
    nickname: 'Wonder Boys & Golden Suns',
    city: 'Russellville',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'University of Arkansas\u2013Fort Smith',
    nickname: 'Lions',
    city: 'Fort Smith',
    state: 'AR',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of Arkansas at Monticello',
    nickname: 'Boll Weevils & Cotton Blossoms',
    city: 'Monticello',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Ashland University',
    nickname: 'Eagles',
    city: 'Ashland',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Assumption University',
    nickname: 'Greyhounds',
    city: 'Worcester',
    state: 'MA',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Auburn University at Montgomery',
    nickname: 'Warhawks',
    city: 'Montgomery',
    state: 'AL',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Augusta University',
    nickname: 'Jaguars',
    city: 'Augusta',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Augustana University',
    nickname: 'Vikings',
    city: 'Sioux Falls',
    state: 'SD',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Azusa Pacific University',
    nickname: 'Cougars',
    city: 'Azusa',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Barry University',
    nickname: 'Buccaneers',
    city: 'Miami Shores',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Barton College',
    nickname: 'Bulldogs',
    city: 'Wilson',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Belmont Abbey College',
    nickname: 'Crusaders',
    city: 'Belmont',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Bemidji State University',
    nickname: 'Beavers',
    city: 'Bemidji',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Benedict College',
    nickname: 'Tigers',
    city: 'Columbia',
    state: 'SC',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Bentley University',
    nickname: 'Falcons',
    city: 'Waltham',
    state: 'MA',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Biola University',
    nickname: 'Eagles',
    city: 'La Mirada',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Black Hills State University',
    nickname: 'Yellow Jackets',
    city: 'Spearfish',
    state: 'SD',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Bloomfield College',
    nickname: 'Bears',
    city: 'Bloomfield',
    state: 'NJ',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Bloomsburg University of Pennsylvania',
    nickname: 'Huskies',
    city: 'Bloomsburg',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Bluefield State University',
    nickname: 'Big Blues & Lady Blues',
    city: 'Bluefield',
    state: 'WV',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Bowie State University',
    nickname: 'Bulldogs',
    city: 'Bowie',
    state: 'MD',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'University of Bridgeport',
    nickname: 'Purple Knights',
    city: 'Bridgeport',
    state: 'CT',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Caldwell University',
    nickname: 'Cougars',
    city: 'Caldwell',
    state: 'NJ',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Pennsylvania Western University California (California)',
    nickname: 'Vulcans',
    city: 'California',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'California State Polytechnic University, Humboldt',
    nickname: 'Lumberjacks',
    city: 'Arcata',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State Polytechnic University, Pomona',
    nickname: 'Broncos',
    city: 'Pomona',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, Chico',
    nickname: 'Wildcats',
    city: 'Chico',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, Dominguez Hills',
    nickname: 'Toros',
    city: 'Carson',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, East Bay',
    nickname: 'Pioneers',
    city: 'Hayward',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, Los Angeles',
    nickname: 'Golden Eagles',
    city: 'Los Angeles',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, Monterey Bay',
    nickname: 'Otters',
    city: 'Seaside',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, San Bernardino',
    nickname: 'Coyotes',
    city: 'San Bernardino',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University San Marcos',
    nickname: 'Cougars',
    city: 'San Marcos',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'California State University, Stanislaus',
    nickname: 'Warriors',
    city: 'Turlock',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Cameron University',
    nickname: 'Aggies',
    city: 'Lawton',
    state: 'OK',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Carson\u2013Newman University',
    nickname: 'Eagles',
    city: 'Jefferson City',
    state: 'TN',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Catawba College',
    nickname: 'Indians',
    city: 'Salisbury',
    state: 'NC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Cedarville University',
    nickname: 'Yellow Jackets',
    city: 'Cedarville',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Central Missouri',
    nickname: 'Mules & Jennies',
    city: 'Warrensburg',
    state: 'MO',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of Central Oklahoma',
    nickname: 'Bronchos',
    city: 'Edmond',
    state: 'OK',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Central State University',
    nickname: 'Marauders & Lady Marauders',
    city: 'Wilberforce',
    state: 'OH',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Central Washington University',
    nickname: 'Wildcats',
    city: 'Ellensburg',
    state: 'WA',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Chadron State College',
    nickname: 'Eagles',
    city: 'Chadron',
    state: 'NE',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Chaminade University of Honolulu',
    nickname: 'Silverswords',
    city: 'Honolulu',
    state: 'HI',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'University of Charleston',
    nickname: 'Golden Eagles',
    city: 'Charleston',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Chestnut Hill College',
    nickname: 'Griffins',
    city: 'Philadelphia',
    state: 'PA',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Chowan University',
    nickname: 'Hawks',
    city: 'Murfreesboro',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Christian Brothers University',
    nickname: 'Buccaneers & Lady Buccaneers',
    city: 'Memphis',
    state: 'TN',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Claflin University',
    nickname: 'Panthers',
    city: 'Orangeburg',
    state: 'SC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Pennsylvania Western University Clarion (Clarion)',
    nickname: 'Golden Eagles',
    city: 'Clarion',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Clark Atlanta University',
    nickname: 'Panthers',
    city: 'Atlanta',
    state: 'GA',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Clayton State University',
    nickname: 'Lakers',
    city: 'Morrow',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Coker University',
    nickname: 'Cobras',
    city: 'Hartsville',
    state: 'SC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Colorado Christian University',
    nickname: 'Cougars',
    city: 'Lakewood',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Colorado Mesa University',
    nickname: 'Mavericks',
    city: 'Grand Junction',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Colorado School of Mines',
    nickname: 'Orediggers',
    city: 'Golden',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Colorado State University\u2013Pueblo',
    nickname: 'ThunderWolves',
    city: 'Pueblo',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Colorado Colorado Springs (UCCS)',
    nickname: 'Mountain Lions',
    city: 'Colorado Springs',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Columbus State University',
    nickname: 'Cougars',
    city: 'Columbus',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Concord University',
    nickname: 'Mountain Lions',
    city: 'Athens',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Concordia University\u2013Irvine',
    nickname: 'Golden Eagles',
    city: 'Irvine',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Concordia University\u2013St. Paul',
    nickname: 'Golden Bears',
    city: 'St. Paul',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Converse University',
    nickname: 'Valkyries',
    city: 'Spartanburg',
    state: 'SC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Daemen University',
    nickname: 'Wildcats',
    city: 'Amherst',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Dallas Baptist University',
    nickname: 'Patriots',
    city: 'Dallas',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Davenport University',
    nickname: 'Panthers',
    city: 'Grand Rapids',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Davis & Elkins College',
    nickname: 'Senators',
    city: 'Elkins',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Delta State University',
    nickname: 'Statesmen & Lady Statesmen',
    city: 'Cleveland',
    state: 'MS',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'University of the District of Columbia',
    nickname: 'Firebirds',
    city: 'Washington',
    state: 'DC',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Dominican University of California',
    nickname: 'Penguins',
    city: 'San Rafael',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Dominican University New York',
    nickname: 'Chargers',
    city: 'Orangeburg',
    state: 'NY',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Drury University',
    nickname: 'Panthers',
    city: 'Springfield',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: "D'Youville University",
    nickname: 'Saints',
    city: 'Buffalo',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'East Central University',
    nickname: 'Tigers',
    city: 'Ada',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'East Stroudsburg University of Pennsylvania',
    nickname: 'Warriors',
    city: 'East Stroudsburg',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Eastern New Mexico University',
    nickname: 'Greyhounds',
    city: 'Portales',
    state: 'NM',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Eckerd College',
    nickname: 'Tritons',
    city: 'St. Petersburg',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Pennsylvania Western University Edinboro (Edinboro)',
    nickname: 'Fighting Scots',
    city: 'Edinboro',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Edward Waters University',
    nickname: 'Tigers',
    city: 'Jacksonville',
    state: 'FL',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Elizabeth City State University',
    nickname: 'Vikings',
    city: 'Elizabeth City',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Embry\u2013Riddle Aeronautical University',
    nickname: 'Eagles',
    city: 'Daytona Beach',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Emmanuel University',
    nickname: 'Lions',
    city: 'Franklin Springs',
    state: 'GA',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Emporia State University',
    nickname: 'Hornets',
    city: 'Emporia',
    state: 'KS',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Emory & Henry University',
    nickname: 'Wasps',
    city: 'Emory',
    state: 'VA',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Erskine College',
    nickname: 'Flying Fleet',
    city: 'Due West',
    state: 'SC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Fairmont State University',
    nickname: 'Fighting Falcons',
    city: 'Fairmont',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Fayetteville State University',
    nickname: 'Broncos & Lady Broncos',
    city: 'Fayetteville',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Felician University',
    nickname: 'Golden Falcons',
    city: 'Rutherford',
    state: 'NJ',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Ferris State University',
    nickname: 'Bulldogs',
    city: 'Big Rapids',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Findlay',
    nickname: 'Oilers',
    city: 'Findlay',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Flagler College',
    nickname: 'Saints',
    city: 'St. Augustine',
    state: 'FL',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Florida Southern College',
    nickname: 'Moccasins',
    city: 'Lakeland',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Florida Institute of Technology (Florida Tech)',
    nickname: 'Panthers',
    city: 'Melbourne',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Fort Hays State University',
    nickname: 'Tigers',
    city: 'Hays',
    state: 'KS',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Fort Lewis College',
    nickname: 'Skyhawks',
    city: 'Durango',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Fort Valley State University',
    nickname: 'Wildcats',
    city: 'Fort Valley',
    state: 'GA',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Francis Marion University',
    nickname: 'Patriots',
    city: 'Florence',
    state: 'SC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Franklin Pierce University',
    nickname: 'Ravens',
    city: 'Rindge',
    state: 'NH',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Fresno Pacific University',
    nickname: 'Sunbirds',
    city: 'Fresno',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Frostburg State University',
    nickname: 'Bobcats',
    city: 'Frostburg',
    state: 'MD',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Gannon University',
    nickname: 'Golden Knights',
    city: 'Erie',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Georgia College & State University',
    nickname: 'Bobcats',
    city: 'Milledgeville',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Georgia Southwestern State University',
    nickname: 'Hurricanes',
    city: 'Americus',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Georgian Court University',
    nickname: 'Lions',
    city: 'Lakewood',
    state: 'NJ',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Glenville State University',
    nickname: 'Pioneers',
    city: 'Glenville',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Goldey\u2013Beacom College',
    nickname: 'Lightning',
    city: 'Pike Creek Valley',
    state: 'DE',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Grand Valley State University',
    nickname: 'Lakers',
    city: 'Allendale',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Harding University',
    nickname: 'Bisons & Lady Bisons',
    city: 'Searcy',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: "Hawai'i Pacific University",
    nickname: 'Sharks',
    city: 'Honolulu',
    state: 'HI',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: "University of Hawai'i at Hilo",
    nickname: 'Vulcans',
    city: 'Hilo',
    state: 'HI',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Henderson State University',
    nickname: 'Reddies',
    city: 'Arkadelphia',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Hillsdale College',
    nickname: 'Chargers',
    city: 'Hillsdale',
    state: 'MI',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Holy Family University',
    nickname: 'Tigers',
    city: 'Philadelphia',
    state: 'PA',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'University of Illinois at Springfield',
    nickname: 'Prairie Stars',
    city: 'Springfield',
    state: 'IL',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Indiana University of Pennsylvania',
    nickname: 'Crimson Hawks',
    city: 'Indiana',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Indianapolis',
    nickname: 'Greyhounds',
    city: 'Indianapolis',
    state: 'IN',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Thomas Jefferson University (Jefferson)',
    nickname: 'Rams',
    city: 'Philadelphia',
    state: 'PA',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Johnson C. Smith University',
    nickname: 'Golden Bulls',
    city: 'Charlotte',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Kentucky State University',
    nickname: 'Thorobreds & Thorobrettes',
    city: 'Frankfort',
    state: 'KY',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Kentucky Wesleyan College',
    nickname: 'Panthers',
    city: 'Owensboro',
    state: 'KY',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'King University',
    nickname: 'Tornados',
    city: 'Bristol',
    state: 'TN',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Kutztown University of Pennsylvania',
    nickname: 'Golden Bears',
    city: 'Kutztown',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lake Erie College',
    nickname: 'Storm',
    city: 'Painesville',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lake Superior State University',
    nickname: 'Lakers',
    city: 'Sault Ste. Marie',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lander University',
    nickname: 'Bearcats',
    city: 'Greenwood',
    state: 'SC',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'Lane College',
    nickname: 'Dragons',
    city: 'Jackson',
    state: 'TN',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lee University',
    nickname: 'Flames',
    city: 'Cleveland',
    state: 'TN',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Lees\u2013McRae College',
    nickname: 'Bobcats',
    city: 'Banner Elk',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'LeMoyne\u2013Owen College',
    nickname: 'Magicians',
    city: 'Memphis',
    state: 'TN',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lenoir\u2013Rhyne University',
    nickname: 'Bears',
    city: 'Hickory',
    state: 'NC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Lewis University',
    nickname: 'Flyers',
    city: 'Romeoville',
    state: 'IL',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Limestone University',
    nickname: 'Saints',
    city: 'Gaffney',
    state: 'SC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Lincoln University (MO)',
    nickname: 'Blue Tigers',
    city: 'Jefferson City',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Lincoln University (PA)',
    nickname: 'Lions',
    city: 'Lincoln University',
    state: 'PA',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Lincoln Memorial University',
    nickname: 'Railsplitters',
    city: 'Harrogate',
    state: 'TN',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Livingstone College',
    nickname: 'Blue Bears',
    city: 'Salisbury',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Lock Haven University of Pennsylvania',
    nickname: 'Bald Eagles',
    city: 'Lock Haven',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Lubbock Christian University',
    nickname: 'Chaparrals & Lady Chaps',
    city: 'Lubbock',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Lynn University',
    nickname: 'Fighting Knights',
    city: 'Boca Raton',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Malone University',
    nickname: 'Pioneers',
    city: 'Canton',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Mansfield University of Pennsylvania',
    nickname: 'Mountaineers',
    city: 'Mansfield',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Mars Hill University',
    nickname: 'Lions',
    city: 'Mars Hill',
    state: 'NC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'University of Mary',
    nickname: 'Marauders',
    city: 'Bismarck',
    state: 'ND',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Maryville University',
    nickname: 'Saints',
    city: 'Town and Country',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'McKendree University',
    nickname: 'Bearcats',
    city: 'Lebanon',
    state: 'IL',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Mercy University',
    nickname: 'Mavericks',
    city: 'Dobbs Ferry',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Metropolitan State University of Denver',
    nickname: 'Roadrunners',
    city: 'Denver',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Michigan Technological University (Michigan Tech)',
    nickname: 'Huskies',
    city: 'Houghton',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Midwestern State University',
    nickname: 'Mustangs',
    city: 'Wichita Falls',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Miles College',
    nickname: 'Golden Bears',
    city: 'Fairfield',
    state: 'AL',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Millersville University of Pennsylvania',
    nickname: 'Marauders',
    city: 'Millersville',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Minnesota State University, Mankato (Minnesota State)',
    nickname: 'Mavericks',
    city: 'Mankato',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Minnesota State University Moorhead (Minnesota State\u2013Moorhead)',
    nickname: 'Dragons',
    city: 'Moorhead',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'University of Minnesota Crookston',
    nickname: 'Golden Eagles',
    city: 'Crookston',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'University of Minnesota Duluth',
    nickname: 'Bulldogs',
    city: 'Duluth',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Minot State University',
    nickname: 'Beavers',
    city: 'Minot',
    state: 'ND',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Mississippi College',
    nickname: 'Choctaws',
    city: 'Clinton',
    state: 'MS',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Missouri University of Science and Technology (Missouri S&T)',
    nickname: 'Miners',
    city: 'Rolla',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Missouri Southern State University',
    nickname: 'Lions',
    city: 'Joplin',
    state: 'MO',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Missouri Western State University',
    nickname: 'Griffons',
    city: 'St. Joseph',
    state: 'MO',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of Missouri\u2013St. Louis',
    nickname: 'Tritons',
    city: 'St. Louis',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Molloy University',
    nickname: 'Lions',
    city: 'Rockville Centre',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Montana State University Billings',
    nickname: 'Yellowjackets',
    city: 'Billings',
    state: 'MT',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Montevallo',
    nickname: 'Falcons',
    city: 'Montevallo',
    state: 'AL',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Morehouse College',
    nickname: 'Maroon Tigers',
    city: 'Atlanta',
    state: 'GA',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Mount Olive',
    nickname: 'Trojans',
    city: 'Mount Olive',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'University of Nebraska at Kearney',
    nickname: 'Lopers',
    city: 'Kearney',
    state: 'NE',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of New Haven',
    nickname: 'Chargers',
    city: 'West Haven',
    state: 'CT',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'New Mexico Highlands University',
    nickname: 'Cowboys & Cowgirls',
    city: 'Las Vegas',
    state: 'NM',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Newberry College',
    nickname: 'Wolves',
    city: 'Newberry',
    state: 'SC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Newman University',
    nickname: 'Jets',
    city: 'Wichita',
    state: 'KS',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of North Georgia',
    nickname: 'Nighthawks',
    city: 'Dahlonega',
    state: 'GA',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'North Greenville University',
    nickname: 'Crusaders',
    city: 'Tigerville',
    state: 'SC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Northeastern State University',
    nickname: 'RiverHawks',
    city: 'Tahlequah',
    state: 'OK',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Northern Michigan University',
    nickname: 'Wildcats',
    city: 'Marquette',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Northern State University',
    nickname: 'Wolves',
    city: 'Aberdeen',
    state: 'SD',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Northwest Missouri State University',
    nickname: 'Bearcats',
    city: 'Maryville',
    state: 'MO',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Northwest Nazarene University',
    nickname: 'Nighthawks',
    city: 'Nampa',
    state: 'ID',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Northwestern Oklahoma State University',
    nickname: 'Rangers',
    city: 'Alva',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Northwood University',
    nickname: 'Timberwolves',
    city: 'Midland',
    state: 'MI',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Nova Southeastern University',
    nickname: 'Sharks',
    city: 'Davie',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Ohio Dominican University',
    nickname: 'Panthers',
    city: 'Columbus',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Oklahoma Baptist University',
    nickname: 'Bison',
    city: 'Shawnee',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Oklahoma Christian University',
    nickname: 'Eagles & Lady Eagles',
    city: 'Oklahoma City',
    state: 'OK',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Ouachita Baptist University',
    nickname: 'Tigers',
    city: 'Arkadelphia',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Pace University',
    nickname: 'Setters',
    city: 'Pleasantville',
    state: 'NY',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Palm Beach Atlantic University',
    nickname: 'Sailfish',
    city: 'West Palm Beach',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'University of Wisconsin\u2013Parkside (Parkside)',
    nickname: 'Rangers',
    city: 'Kenosha',
    state: 'WI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Pittsburg State University',
    nickname: 'Gorillas',
    city: 'Pittsburg',
    state: 'KS',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'University of Pittsburgh at Johnstown',
    nickname: 'Mountain Cats',
    city: 'Johnstown',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Point Loma Nazarene University',
    nickname: 'Sea Lions',
    city: 'San Diego',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Post University',
    nickname: 'Eagles',
    city: 'Waterbury',
    state: 'CT',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'University of Puerto Rico at Bayam\u00f3n',
    nickname: 'Cowboys',
    city: 'Bayam\u00f3n',
    state: 'PR',
    conference: 'Independent',
    division: 'division2',
  },
  {
    school: 'University of Puerto Rico at Mayag\u00fcez',
    nickname: 'Bulldogs',
    city: 'Mayag\u00fcez',
    state: 'PR',
    conference: 'Independent',
    division: 'division2',
  },
  {
    school: 'University of Puerto Rico at R\u00edo Piedras',
    nickname: 'Gallitos',
    city: 'San Juan',
    state: 'PR',
    conference: 'Independent',
    division: 'division2',
  },
  {
    school: 'Purdue University Northwest',
    nickname: 'Pride',
    city: 'Hammond',
    state: 'IN',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Queens College',
    nickname: 'Knights',
    city: 'Flushing',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Quincy University',
    nickname: 'Hawks',
    city: 'Quincy',
    state: 'IL',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Regis University',
    nickname: 'Rangers',
    city: 'Denver',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Roberts Wesleyan University',
    nickname: 'Redhawks',
    city: 'North Chili',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Rockhurst University',
    nickname: 'Hawks',
    city: 'Kansas City',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Rogers State University',
    nickname: 'Hillcats',
    city: 'Claremore',
    state: 'OK',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Rollins College',
    nickname: 'Tars',
    city: 'Winter Park',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Saginaw Valley State University',
    nickname: 'Cardinals',
    city: 'University Center',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Saint Anselm College',
    nickname: 'Hawks',
    city: 'Goffstown',
    state: 'NH',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: "Saint Augustine's University",
    nickname: 'Falcons',
    city: 'Raleigh',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'St. Cloud State University',
    nickname: 'Huskies',
    city: 'St. Cloud',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: "St. Edward's University",
    nickname: 'Hilltoppers',
    city: 'Austin',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Saint Leo University',
    nickname: 'Lions',
    city: 'St. Leo',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: "Saint Martin's University",
    nickname: 'Saints',
    city: 'Lacey',
    state: 'WA',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: "St. Mary's University",
    nickname: 'Rattlers',
    city: 'San Antonio',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: "Saint Michael's College",
    nickname: 'Purple Knights',
    city: 'Colchester',
    state: 'VT',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'St. Thomas Aquinas College',
    nickname: 'Spartans',
    city: 'Sparkill',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'Salem University',
    nickname: 'Tigers',
    city: 'Salem',
    state: 'WV',
    conference: 'Independent',
    division: 'division2',
  },
  {
    school: 'San Francisco State University',
    nickname: 'Gators',
    city: 'San Francisco',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Savannah State University',
    nickname: 'Tigers',
    city: 'Savannah',
    state: 'GA',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Seattle Pacific University',
    nickname: 'Falcons',
    city: 'Seattle',
    state: 'WA',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Seton Hill University',
    nickname: 'Griffins',
    city: 'Greensburg',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Shaw University',
    nickname: 'Bears',
    city: 'Raleigh',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Shepherd University',
    nickname: 'Rams',
    city: 'Shepherdstown',
    state: 'WV',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Shippensburg University of Pennsylvania',
    nickname: 'Raiders',
    city: 'Shippensburg',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Shorter University',
    nickname: 'Hawks',
    city: 'Rome',
    state: 'GA',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Simon Fraser University',
    nickname: 'Red Leafs',
    city: 'Burnaby',
    state: 'BC',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of Sioux Falls',
    nickname: 'Cougars',
    city: 'Sioux Falls',
    state: 'SD',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Slippery Rock University of Pennsylvania',
    nickname: 'The Rock',
    city: 'Slippery Rock',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Sonoma State University',
    nickname: 'Seawolves',
    city: 'Rohnert Park',
    state: 'CA',
    conference: 'California Collegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'University of South Carolina Aiken',
    nickname: 'Pacers',
    city: 'Aiken',
    state: 'SC',
    conference: 'Peach Belt Conference',
    division: 'division2',
  },
  {
    school: 'South Dakota School of Mines and Technology (South Dakota Mines)',
    nickname: 'Hardrockers',
    city: 'Rapid City',
    state: 'SD',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Southeastern Oklahoma State University',
    nickname: 'Savage Storm',
    city: 'Durant',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Southern Arkansas University',
    nickname: 'Muleriders',
    city: 'Magnolia',
    state: 'AR',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Southern Connecticut State University',
    nickname: 'Owls',
    city: 'New Haven',
    state: 'CT',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Southern Nazarene University',
    nickname: 'Crimson Storm',
    city: 'Bethany',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Southern New Hampshire University',
    nickname: 'Penmen',
    city: 'Manchester and Hooksett',
    state: 'NH',
    conference: 'Northeast-10 Conference',
    division: 'division2',
  },
  {
    school: 'Southern Wesleyan University',
    nickname: 'Warriors',
    city: 'Central',
    state: 'SC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Southwest Baptist University',
    nickname: 'Bearcats',
    city: 'Bolivar',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Southwest Minnesota State University',
    nickname: 'Mustangs',
    city: 'Marshall',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Southwestern Oklahoma State University',
    nickname: 'Bulldogs',
    city: 'Weatherford',
    state: 'OK',
    conference: 'Great American Conference',
    division: 'division2',
  },
  {
    school: 'Spring Hill College',
    nickname: 'Badgers',
    city: 'Mobile',
    state: 'AL',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'College of Staten Island',
    nickname: 'Dolphins',
    city: 'Staten Island',
    state: 'NY',
    conference: 'East Coast Conference',
    division: 'division2',
  },
  {
    school: 'University of Tampa',
    nickname: 'Spartans',
    city: 'Tampa',
    state: 'FL',
    conference: 'Sunshine State Conference',
    division: 'division2',
  },
  {
    school: 'Texas A&M University\u2013Kingsville',
    nickname: 'Javelinas',
    city: 'Kingsville',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Texas A&M International University',
    nickname: 'Dustdevils',
    city: 'Laredo',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: "Texas Woman's University",
    nickname: 'Pioneers',
    city: 'Denton',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'University of Texas Permian Basin',
    nickname: 'Falcons',
    city: 'Odessa',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'University of Texas at Tyler',
    nickname: 'Patriots',
    city: 'Tyler',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Tiffin University',
    nickname: 'Dragons',
    city: 'Tiffin',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Trevecca Nazarene University',
    nickname: 'Trojans',
    city: 'Nashville',
    state: 'TN',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Truman State University',
    nickname: 'Bulldogs',
    city: 'Kirksville',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Tusculum University',
    nickname: 'Pioneers',
    city: 'Greeneville',
    state: 'TN',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Tuskegee University',
    nickname: 'Golden Tigers',
    city: 'Tuskegee',
    state: 'AL',
    conference: 'Southern Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of North Carolina at Pembroke (UNC Pembroke)',
    nickname: 'Braves',
    city: 'Pembroke',
    state: 'NC',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Union University',
    nickname: 'Bulldogs',
    city: 'Jackson',
    state: 'TN',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Upper Iowa University',
    nickname: 'Peacocks',
    city: 'Fayette',
    state: 'IA',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Ursuline College',
    nickname: 'Arrows',
    city: 'Pepper Pike',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Valdosta State University',
    nickname: 'Blazers',
    city: 'Valdosta',
    state: 'GA',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'Virginia State University',
    nickname: 'Trojans',
    city: 'Ettrick',
    state: 'VA',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Virginia Union University',
    nickname: 'Panthers',
    city: 'Richmond',
    state: 'VA',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: "University of Virginia's College at Wise (UVA Wise)",
    nickname: 'Cavaliers',
    city: 'Wise',
    state: 'VA',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Walsh University',
    nickname: 'Cavaliers',
    city: 'North Canton',
    state: 'OH',
    conference: 'Great Midwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Washburn University',
    nickname: 'Ichabods',
    city: 'Topeka',
    state: 'KS',
    conference: 'Mid-America Intercollegiate Athletics Association',
    division: 'division2',
  },
  {
    school: 'Wayne State University',
    nickname: 'Warriors',
    city: 'Detroit',
    state: 'MI',
    conference: 'Great Lakes Intercollegiate Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Wayne State College',
    nickname: 'Wildcats',
    city: 'Wayne',
    state: 'NE',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'University of West Alabama',
    nickname: 'Tigers',
    city: 'Livingston',
    state: 'AL',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'West Chester University of Pennsylvania',
    nickname: 'Golden Rams',
    city: 'West Chester',
    state: 'PA',
    conference: 'Pennsylvania State Athletic Conference',
    division: 'division2',
  },
  {
    school: 'University of West Florida',
    nickname: 'Argonauts',
    city: 'Pensacola',
    state: 'FL',
    conference: 'Gulf South Conference',
    division: 'division2',
  },
  {
    school: 'West Liberty University',
    nickname: 'Hilltoppers',
    city: 'West Liberty',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'West Texas A&M University',
    nickname: 'Buffaloes',
    city: 'Canyon',
    state: 'TX',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'West Virginia State University',
    nickname: 'Yellow Jackets',
    city: 'Institute',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'West Virginia Wesleyan College',
    nickname: 'Bobcats',
    city: 'Buckhannon',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'Western Colorado University',
    nickname: 'Mountaineers',
    city: 'Gunnison',
    state: 'CO',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Western New Mexico University',
    nickname: 'Mustangs',
    city: 'Silver City',
    state: 'NM',
    conference: 'Lone Star Conference',
    division: 'division2',
  },
  {
    school: 'Western Oregon University',
    nickname: 'Wolves',
    city: 'Monmouth',
    state: 'OR',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Western Washington University',
    nickname: 'Vikings',
    city: 'Bellingham',
    state: 'WA',
    conference: 'Great Northwest Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Westminster University',
    nickname: 'Griffins',
    city: 'Salt Lake City',
    state: 'UT',
    conference: 'Rocky Mountain Athletic Conference',
    division: 'division2',
  },
  {
    school: 'Westmont College',
    nickname: 'Warriors',
    city: 'Santa Barbara',
    state: 'CA',
    conference: 'Pacific West Conference',
    division: 'division2',
  },
  {
    school: 'Wheeling University',
    nickname: 'Cardinals',
    city: 'Wheeling',
    state: 'WV',
    conference: 'Mountain East Conference',
    division: 'division2',
  },
  {
    school: 'William Jewell College',
    nickname: 'Cardinals',
    city: 'Liberty',
    state: 'MO',
    conference: 'Great Lakes Valley Conference',
    division: 'division2',
  },
  {
    school: 'Wilmington University',
    nickname: 'Wildcats',
    city: 'New Castle',
    state: 'DE',
    conference: 'Central Atlantic Collegiate Conference',
    division: 'division2',
  },
  {
    school: 'Wingate University',
    nickname: 'Bulldogs',
    city: 'Wingate',
    state: 'NC',
    conference: 'South Atlantic Conference',
    division: 'division2',
  },
  {
    school: 'Winona State University',
    nickname: 'Warriors',
    city: 'Winona',
    state: 'MN',
    conference: 'Northern Sun Intercollegiate Conference',
    division: 'division2',
  },
  {
    school: 'Winston\u2013Salem State University',
    nickname: 'Rams',
    city: 'Winston\u2013Salem',
    state: 'NC',
    conference: 'Central Intercollegiate Athletic Association',
    division: 'division2',
  },
  {
    school: 'Young Harris College',
    nickname: 'Mountain Lions',
    city: 'Young Harris',
    state: 'GA',
    conference: 'Conference Carolinas',
    division: 'division2',
  },
  {
    school: 'Abilene Christian University',
    nickname: 'Wildcats',
    city: 'Abilene',
    state: 'Texas',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Alabama A&M University',
    nickname: 'Bulldogs',
    city: 'Normal',
    state: 'Alabama',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Alabama State University',
    nickname: 'Hornets',
    city: 'Montgomery',
    state: 'Alabama',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'State University of New York at Albany',
    nickname: 'Great Danes',
    city: 'Albany',
    state: 'New York',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Alcorn State University',
    nickname: 'Braves',
    city: 'Lorman',
    state: 'Mississippi',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'University of Arkansas at Pine Bluff',
    nickname: 'Golden Lions',
    city: 'Pine Bluff',
    state: 'Arkansas',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Austin Peay State University',
    nickname: 'Governors',
    city: 'Clarksville',
    state: 'Tennessee',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Bethune\u2013Cookman University',
    nickname: 'Wildcats',
    city: 'Daytona Beach',
    state: 'Florida',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Brown University',
    nickname: 'Bears',
    city: 'Providence',
    state: 'Rhode Island',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Bryant University',
    nickname: 'Bulldogs',
    city: 'Smithfield',
    state: 'Rhode Island',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Bucknell University',
    nickname: 'Bison',
    city: 'Lewisburg',
    state: 'Pennsylvania',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Butler University',
    nickname: 'Bulldogs',
    city: 'Indianapolis',
    state: 'Indiana',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'California Polytechnic State University',
    nickname: 'Mustangs',
    city: 'San Luis Obispo',
    state: 'California',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Campbell University',
    nickname: 'Fighting Camels',
    city: 'Buies Creek',
    state: 'North Carolina',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'University of Central Arkansas',
    nickname: 'Bears',
    city: 'Conway',
    state: 'Arkansas',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Central Connecticut State University',
    nickname: 'Blue Devils',
    city: 'New Britain',
    state: 'Connecticut',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'Charleston Southern University',
    nickname: 'Buccaneers',
    city: 'North Charleston',
    state: 'South Carolina',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'University of Tennessee at Chattanooga',
    nickname: 'Mocs',
    city: 'Chattanooga',
    state: 'Tennessee',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'The Citadel, The Military College of South Carolina',
    nickname: 'Bulldogs',
    city: 'Charleston',
    state: 'South Carolina',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Colgate University',
    nickname: 'Raiders',
    city: 'Hamilton',
    state: 'New York',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Columbia University',
    nickname: 'Lions',
    city: 'New York',
    state: 'New York',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Cornell University',
    nickname: 'Big Red',
    city: 'Ithaca',
    state: 'New York',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Dartmouth College',
    nickname: 'Big Green',
    city: 'Hanover',
    state: 'New Hampshire',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Davidson College',
    nickname: 'Wildcats',
    city: 'Davidson',
    state: 'North Carolina',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'University of Dayton',
    nickname: 'Flyers',
    city: 'Dayton',
    state: 'Ohio',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'University of Delaware',
    nickname: "Fightin' Blue Hens",
    city: 'Newark',
    state: 'Delaware',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Delaware State University',
    nickname: 'Hornets',
    city: 'Dover',
    state: 'Delaware',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'Drake University',
    nickname: 'Bulldogs',
    city: 'Des Moines',
    state: 'Iowa',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'Duquesne University',
    nickname: 'Dukes',
    city: 'Pittsburgh',
    state: 'Pennsylvania',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'East Tennessee State University',
    nickname: 'Buccaneers',
    city: 'Johnson City',
    state: 'Tennessee',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Eastern Illinois University',
    nickname: 'Panthers',
    city: 'Charleston',
    state: 'Illinois',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Eastern Kentucky University',
    nickname: 'Colonels',
    city: 'Richmond',
    state: 'Kentucky',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Eastern Washington University',
    nickname: 'Eagles',
    city: 'Cheney',
    state: 'Washington',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Elon University',
    nickname: 'Phoenix',
    city: 'Elon',
    state: 'North Carolina',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Florida A&M University',
    nickname: 'Rattlers',
    city: 'Tallahassee',
    state: 'Florida',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Fordham University',
    nickname: 'Rams',
    city: 'New York',
    state: 'New York',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Furman University',
    nickname: 'Paladins',
    city: 'Greenville',
    state: 'South Carolina',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Gardner\u2013Webb University',
    nickname: "Runnin' Bulldogs",
    city: 'Boiling Springs',
    state: 'North Carolina',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Georgetown University',
    nickname: 'Hoyas',
    city: 'Washington',
    state: 'District of Columbia',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Grambling State University',
    nickname: 'Tigers',
    city: 'Grambling',
    state: 'Louisiana',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Hampton University',
    nickname: 'Pirates',
    city: 'Hampton',
    state: 'Virginia',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Harvard University',
    nickname: 'Crimson',
    city: 'Lorman',
    state: 'Massachusetts',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'College of the Holy Cross',
    nickname: 'Crusaders',
    city: 'Worcester',
    state: 'Massachusetts',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Houston Christian University',
    nickname: 'Huskies',
    city: 'Houston',
    state: 'Texas',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Howard University',
    nickname: 'Bison',
    city: 'Washington',
    state: 'District of Columbia',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'University of Idaho',
    nickname: 'Vandals',
    city: 'Moscow',
    state: 'Idaho',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Idaho State University',
    nickname: 'Bengals',
    city: 'Pocatello',
    state: 'Idaho',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Illinois State University',
    nickname: 'Redbirds',
    city: 'Normal',
    state: 'Illinois',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'University of the Incarnate Word',
    nickname: 'Cardinals',
    city: 'San Antonio',
    state: 'Texas',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Indiana State University',
    nickname: 'Sycamores',
    city: 'Terre Haute',
    state: 'Indiana',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Jackson State University',
    nickname: 'Tigers',
    city: 'Jackson',
    state: 'Mississippi',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Lafayette College',
    nickname: 'Leopards',
    city: 'Easton',
    state: 'Pennsylvania',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Lamar University',
    nickname: 'Cardinals',
    city: 'Beaumont',
    state: 'Texas',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Lehigh University',
    nickname: 'Mountain Hawks',
    city: 'Bethlehem',
    state: 'Pennsylvania',
    conference: 'Patriot',
    division: 'division1FCS',
  },
  {
    school: 'Long Island University',
    nickname: 'Sharks',
    city: 'Brookville',
    state: 'New York',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'University of Maine',
    nickname: 'Black Bears',
    city: 'Orono',
    state: 'Maine',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Marist College',
    nickname: 'Red Foxes',
    city: 'Poughkeepsie',
    state: 'New York',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'McNeese State University',
    nickname: 'Cowboys',
    city: 'Lake Charles',
    state: 'Louisiana',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Mercer University',
    nickname: 'Bears',
    city: 'Macon',
    state: 'Georgia',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Merrimack College',
    nickname: 'Warriors',
    city: 'North Andover',
    state: 'Massachusetts',
    conference: 'Independent',
    division: 'division1FCS',
  },
  {
    school: 'Mississippi Valley State University',
    nickname: 'Delta Devils',
    city: 'Itta Bena',
    state: 'Mississippi',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Missouri State University',
    nickname: 'Bears',
    city: 'Springfield',
    state: 'Missouri',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Monmouth University',
    nickname: 'Hawks',
    city: 'West Long Branch',
    state: 'New Jersey',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'University of Montana',
    nickname: 'Grizzlies',
    city: 'Missoula',
    state: 'Montana',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Montana State University',
    nickname: 'Bobcats',
    city: 'Bozeman',
    state: 'Montana',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Morehead State University',
    nickname: 'Eagles',
    city: 'Morehead',
    state: 'Kentucky',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'Morgan State University',
    nickname: 'Bears',
    city: 'Baltimore',
    state: 'Maryland',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'Murray State University',
    nickname: 'Racers',
    city: 'Murray',
    state: 'Kentucky',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'University of New Hampshire',
    nickname: 'Wildcats',
    city: 'Durham',
    state: 'New Hampshire',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Nicholls State University',
    nickname: 'Colonels',
    city: 'Thibodaux',
    state: 'Louisiana',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Norfolk State University',
    nickname: 'Spartans',
    city: 'Norfolk',
    state: 'Virginia',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'University of North Alabama',
    nickname: 'Lions',
    city: 'Florence',
    state: 'Alabama',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'North Carolina A&T State University',
    nickname: 'Aggies',
    city: 'Greensboro',
    state: 'North Carolina',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'North Carolina Central University',
    nickname: 'Eagles',
    city: 'Durham',
    state: 'North Carolina',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'University of North Dakota',
    nickname: 'Fighting Hawks',
    city: 'Grand Forks',
    state: 'North Dakota',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'North Dakota State University',
    nickname: 'Bison',
    city: 'Fargo',
    state: 'North Dakota',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Northern Arizona University',
    nickname: 'Lumberjacks',
    city: 'Flagstaff',
    state: 'Arizona',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'University of Northern Colorado',
    nickname: 'Bears',
    city: 'Greeley',
    state: 'Colorado',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'University of Northern Iowa',
    nickname: 'Panthers',
    city: 'Cedar Falls',
    state: 'Iowa',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Northwestern State University',
    nickname: 'Demons',
    city: 'Natchitoches',
    state: 'Louisiana',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'University of Pennsylvania',
    nickname: 'Quakers',
    city: 'Philadelphia',
    state: 'Pennsylvania',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Portland State University',
    nickname: 'Vikings',
    city: 'Portland',
    state: 'Oregon',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Prairie View A&M University',
    nickname: 'Panthers',
    city: 'Prairie View',
    state: 'Texas',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Presbyterian College',
    nickname: 'Blue Hose',
    city: 'Clinton',
    state: 'South Carolina',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'Princeton University',
    nickname: 'Tigers',
    city: 'Princeton',
    state: 'New Jersey',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'University of Rhode Island',
    nickname: 'Rams',
    city: 'Kingston',
    state: 'Rhode Island',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'University of Richmond',
    nickname: 'Spiders',
    city: 'Richmond',
    state: 'Virginia',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Robert Morris University',
    nickname: 'Colonials',
    city: 'Moon Township',
    state: 'Pennsylvania',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'California State University, Sacramento',
    nickname: 'Hornets',
    city: 'Sacramento',
    state: 'California',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Sacred Heart University',
    nickname: 'Pioneers',
    city: 'Fairfield',
    state: 'Connecticut',
    conference: 'Independent',
    division: 'division1FCS',
  },
  {
    school: 'Saint Francis University',
    nickname: 'Red Flash',
    city: 'Loretto',
    state: 'Pennsylvania',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'Samford University',
    nickname: 'Bulldogs',
    city: 'Birmingham',
    state: 'Alabama',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'University of San Diego',
    nickname: 'Toreros',
    city: 'San Diego',
    state: 'California',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'South Carolina State University',
    nickname: 'Bulldogs',
    city: 'Orangeburg',
    state: 'South Carolina',
    conference: 'MEAC',
    division: 'division1FCS',
  },
  {
    school: 'University of South Dakota',
    nickname: 'Coyotes',
    city: 'Vermillion',
    state: 'South Dakota',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'South Dakota State University',
    nickname: 'Jackrabbits',
    city: 'Brookings',
    state: 'South Dakota',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Southeast Missouri State University',
    nickname: 'Redhawks',
    city: 'Cape Girardeau',
    state: 'Missouri',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Southeastern Louisiana University',
    nickname: 'Lions',
    city: 'Hammond',
    state: 'Louisiana',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Southern University',
    nickname: 'Jaguars',
    city: 'Baton Rouge',
    state: 'Louisiana',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Southern Illinois University Carbondale',
    nickname: 'Salukis',
    city: 'Carbondale',
    state: 'Illinois',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'Southern Utah University',
    nickname: 'Thunderbirds',
    city: 'Cedar City',
    state: 'Utah',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Stephen F. Austin State University',
    nickname: 'Lumberjacks',
    city: 'Nacogdoches',
    state: 'Texas',
    conference: 'Southland',
    division: 'division1FCS',
  },
  {
    school: 'Stetson University',
    nickname: 'Hatters',
    city: 'DeLand',
    state: 'Florida',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'Stony Brook University',
    nickname: 'Seawolves',
    city: 'Stony Brook',
    state: 'New York',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Tarleton State University',
    nickname: 'Texans',
    city: 'Stephenville',
    state: 'Texas',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Tennessee State University',
    nickname: 'Tigers',
    city: 'Nashville',
    state: 'Tennessee',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Tennessee Technological University',
    nickname: 'Golden Eagles',
    city: 'Cookeville',
    state: 'Tennessee',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Texas Southern University',
    nickname: 'Tigers',
    city: 'Houston',
    state: 'Texas',
    conference: 'SWAC',
    division: 'division1FCS',
  },
  {
    school: 'Towson University',
    nickname: 'Tigers',
    city: 'Towson',
    state: 'Maryland',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'University of California, Davis',
    nickname: 'Aggies',
    city: 'Davis',
    state: 'California',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'University of Tennessee at Martin',
    nickname: 'Skyhawks',
    city: 'Martin',
    state: 'Tennessee',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'Utah Tech University',
    nickname: 'Trailblazers',
    city: 'St. George',
    state: 'Utah',
    conference: 'UAC',
    division: 'division1FCS',
  },
  {
    school: 'Valparaiso University',
    nickname: 'Beacons',
    city: 'Valparaiso',
    state: 'Indiana',
    conference: 'Pioneer',
    division: 'division1FCS',
  },
  {
    school: 'Villanova University',
    nickname: 'Wildcats',
    city: 'Villanova',
    state: 'Pennsylvania',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Virginia Military Institute',
    nickname: 'Keydets',
    city: 'Lexington',
    state: 'Virginia',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Wagner College',
    nickname: 'Seahawks',
    city: 'New York',
    state: 'New York',
    conference: 'Northeast',
    division: 'division1FCS',
  },
  {
    school: 'Weber State University',
    nickname: 'Wildcats',
    city: 'Ogden',
    state: 'Utah',
    conference: 'Big Sky',
    division: 'division1FCS',
  },
  {
    school: 'Western Carolina University',
    nickname: 'Catamounts',
    city: 'Cullowhee',
    state: 'North Carolina',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Western Illinois University',
    nickname: 'Leathernecks',
    city: 'Macomb',
    state: 'Illinois',
    conference: 'Big South-OVC',
    division: 'division1FCS',
  },
  {
    school: 'College of William & Mary',
    nickname: 'Tribe',
    city: 'Williamsburg',
    state: 'Virginia',
    conference: 'CAA',
    division: 'division1FCS',
  },
  {
    school: 'Wofford College',
    nickname: 'Terriers',
    city: 'Spartanburg',
    state: 'South Carolina',
    conference: 'Southern',
    division: 'division1FCS',
  },
  {
    school: 'Yale University',
    nickname: 'Bulldogs',
    city: 'New Haven',
    state: 'Connecticut',
    conference: 'Ivy',
    division: 'division1FCS',
  },
  {
    school: 'Youngstown State University',
    nickname: 'Penguins',
    city: 'Youngstown',
    state: 'Ohio',
    conference: 'Missouri Valley',
    division: 'division1FCS',
  },
  {
    school: 'SEC',
    nickname: 'Vanderbilt',
    city: 'Commodores',
    state: 'Nashville',
    conference: 'TN',
    division: 'division1FCS',
  },
  {
    school: 'ACC',
    nickname: 'Virginia',
    city: 'Cavaliers',
    state: 'Charlottesville',
    conference: 'VA',
    division: 'division1FCS',
  },
  {
    school: 'ACC',
    nickname: 'Virginia Tech',
    city: 'Hokies',
    state: 'Blacksburg',
    conference: 'VA',
    division: 'division1FCS',
  },
  {
    school: 'ACC',
    nickname: 'Wake Forest',
    city: 'Demon Deacons',
    state: 'Winston-Salem',
    conference: 'NC',
    division: 'division1FCS',
  },
  {
    school: 'Big Ten',
    nickname: 'Washington',
    city: 'Huskies',
    state: 'Seattle',
    conference: 'WA',
    division: 'division1FCS',
  },
  {
    school: 'Pac-12',
    nickname: 'Washington State',
    city: 'Cougars',
    state: 'Pullman',
    conference: 'WA',
    division: 'division1FCS',
  },
  {
    school: 'Big 12',
    nickname: 'West Virginia',
    city: 'Mountaineers',
    state: 'Morgantown',
    conference: 'WV',
    division: 'division1FCS',
  },
  {
    school: 'CUSA',
    nickname: 'Western Kentucky',
    city: 'Hilltoppers',
    state: 'Bowling Green',
    conference: 'KY',
    division: 'division1FCS',
  },
  {
    school: 'MAC',
    nickname: 'Western Michigan',
    city: 'Broncos',
    state: 'Kalamazoo',
    conference: 'MI',
    division: 'division1FCS',
  },
  {
    school: 'Big Ten',
    nickname: 'Wisconsin',
    city: 'Badgers',
    state: 'Madison',
    conference: 'WI',
    division: 'division1FCS',
  },
  {
    school: 'Mountain West',
    nickname: 'Wyoming',
    city: 'Cowboys',
    state: 'Laramie',
    conference: 'WY',
    division: 'division1FCS',
  },
  {
    school: 'Air Force',
    nickname: 'Falcons',
    city: 'USAF Academy',
    state: 'CO',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'Akron',
    nickname: 'Zips',
    city: 'Akron',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Alabama',
    nickname: 'Crimson Tide',
    city: 'Tuscaloosa',
    state: 'AL',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Appalachian State',
    nickname: 'Mountaineers',
    city: 'Boone',
    state: 'NC',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Arizona',
    nickname: 'Wildcats',
    city: 'Tucson',
    state: 'AZ',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Arizona State',
    nickname: 'Sun Devils',
    city: 'Tempe',
    state: 'AZ',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Arkansas',
    nickname: 'Razorbacks',
    city: 'Fayetteville',
    state: 'AR',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Arkansas State',
    nickname: 'Red Wolves',
    city: 'Jonesboro',
    state: 'AR',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Army',
    nickname: 'Black Knights',
    city: 'West Point',
    state: 'NY',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Auburn',
    nickname: 'Tigers',
    city: 'Auburn',
    state: 'AL',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Ball State',
    nickname: 'Cardinals',
    city: 'Muncie',
    state: 'IN',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Baylor',
    nickname: 'Bears',
    city: 'Waco',
    state: 'TX',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Boise State',
    nickname: 'Broncos',
    city: 'Boise',
    state: 'ID',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'Boston College',
    nickname: 'Eagles',
    city: 'Chestnut Hill',
    state: 'MA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Bowling Green',
    nickname: 'Falcons',
    city: 'Bowling Green',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Buffalo',
    nickname: 'Bulls',
    city: 'Buffalo',
    state: 'NY',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'BYU',
    nickname: 'Cougars',
    city: 'Provo',
    state: 'UT',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'California',
    nickname: 'Golden Bears',
    city: 'Berkeley',
    state: 'CA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Central Michigan',
    nickname: 'Chippewas',
    city: 'Mount Pleasant',
    state: 'MI',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Charlotte',
    nickname: '49ers',
    city: 'Charlotte',
    state: 'NC',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Cincinnati',
    nickname: 'Bearcats',
    city: 'Cincinnati',
    state: 'OH',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Clemson',
    nickname: 'Tigers',
    city: 'Clemson',
    state: 'SC',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Coastal Carolina',
    nickname: 'Chanticleers',
    city: 'Conway',
    state: 'SC',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Colorado',
    nickname: 'Buffaloes',
    city: 'Boulder',
    state: 'CO',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Colorado State',
    nickname: 'Rams',
    city: 'Fort Collins',
    state: 'CO',
    conference: 'Buffalo',
    division: 'division1FBS',
  },
  {
    school: 'Duke',
    nickname: 'Blue Devils',
    city: 'Durham',
    state: 'NC',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'East Carolina',
    nickname: 'Pirates',
    city: 'Greenville',
    state: 'NC',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Eastern Michigan',
    nickname: 'Eagles',
    city: 'Ypsilanti',
    state: 'MI',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Florida Atlantic',
    nickname: 'Owls',
    city: 'Boca Raton',
    state: 'FL',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'FIU',
    nickname: 'Panthers',
    city: 'Miami',
    state: 'FL',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Florida',
    nickname: 'Gators',
    city: 'Gainesville',
    state: 'FL',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Florida State',
    nickname: 'Seminoles',
    city: 'Tallahassee',
    state: 'FL',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Fresno State',
    nickname: 'Bulldogs',
    city: 'Fresno',
    state: 'CA',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'Georgia',
    nickname: 'Bulldogs',
    city: 'Athens',
    state: 'GA',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Georgia Southern',
    nickname: 'Eagles',
    city: 'Statesboro',
    state: 'GA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Georgia State',
    nickname: 'Panthers',
    city: 'Atlanta',
    state: 'GA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Georgia Tech',
    nickname: 'Yellow Jackets',
    city: 'Atlanta',
    state: 'GA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Hawaii',
    nickname: 'Rainbow Warriors',
    city: 'Honolulu',
    state: 'HI',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'Houston',
    nickname: 'Cougars',
    city: 'Houston',
    state: 'TX',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Illinois',
    nickname: 'Fighting Illini',
    city: 'Urbana-Champaign',
    state: 'IL',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Indiana',
    nickname: 'Hoosiers',
    city: 'Bloomington',
    state: 'IN',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Iowa',
    nickname: 'Hawkeyes',
    city: 'Iowa City',
    state: 'IA',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Iowa State',
    nickname: 'Cyclones',
    city: 'Ames',
    state: 'IA',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Jacksonville State',
    nickname: 'Gamecocks',
    city: 'Jacksonville',
    state: 'AL',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'James Madison',
    nickname: 'Dukes',
    city: 'Harrisonburg',
    state: 'VA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Kansas',
    nickname: 'Jayhawks',
    city: 'Lawrence',
    state: 'KS',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Kansas State',
    nickname: 'Wildcats',
    city: 'Manhattan',
    state: 'KS',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Kennesaw State',
    nickname: 'Owls',
    city: 'Kennesaw',
    state: 'GA',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Kent State',
    nickname: 'Golden Flashes',
    city: 'Kent',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Kentucky',
    nickname: 'Wildcats',
    city: 'Lexington',
    state: 'KY',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Liberty',
    nickname: 'Flames',
    city: 'Lynchburg',
    state: 'VA',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Louisiana',
    nickname: "Ragin' Cajuns",
    city: 'Lafayette',
    state: 'LA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Louisiana\u2013Monroe',
    nickname: 'Warhawks',
    city: 'Monroe',
    state: 'LA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Louisiana Tech',
    nickname: 'Bulldogs',
    city: 'Ruston',
    state: 'LA',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Louisville',
    nickname: 'Cardinals',
    city: 'Louisville',
    state: 'KY',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'LSU',
    nickname: 'Tigers',
    city: 'Baton Rouge',
    state: 'LA',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Marshall',
    nickname: 'Thundering Herd',
    city: 'Huntington',
    state: 'WV',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Maryland',
    nickname: 'Terrapins',
    city: 'College Park',
    state: 'MD',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Memphis',
    nickname: 'Tigers',
    city: 'Memphis',
    state: 'TN',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Miami (FL)',
    nickname: 'Hurricanes',
    city: 'Coral Gables',
    state: 'FL',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Miami (OH)',
    nickname: 'RedHawks',
    city: 'Oxford',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Michigan',
    nickname: 'Wolverines',
    city: 'Ann Arbor',
    state: 'MI',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Michigan State',
    nickname: 'Spartans',
    city: 'East Lansing',
    state: 'MI',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Middle Tennessee',
    nickname: 'Blue Raiders',
    city: 'Murfreesboro',
    state: 'TN',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Minnesota',
    nickname: 'Golden Gophers',
    city: 'Minneapolis',
    state: 'MN',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Mississippi State',
    nickname: 'Bulldogs',
    city: 'Mississippi State',
    state: 'MS',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Missouri',
    nickname: 'Tigers',
    city: 'Columbia',
    state: 'MO',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Navy',
    nickname: 'Midshipmen',
    city: 'Annapolis',
    state: 'MD',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'NC State',
    nickname: 'Wolfpack',
    city: 'Raleigh',
    state: 'NC',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Nebraska',
    nickname: 'Cornhuskers',
    city: 'Lincoln',
    state: 'NE',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Nevada',
    nickname: 'Wolf Pack',
    city: 'Reno',
    state: 'NV',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'New Mexico',
    nickname: 'Lobos',
    city: 'Albuquerque',
    state: 'NM',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'New Mexico State',
    nickname: 'Aggies',
    city: 'Las Cruces',
    state: 'NM',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'North Carolina',
    nickname: 'Tar Heels',
    city: 'Chapel Hill',
    state: 'NC',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'North Texas',
    nickname: 'Mean Green',
    city: 'Denton',
    state: 'TX',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Northern Illinois',
    nickname: 'Huskies',
    city: 'DeKalb',
    state: 'IL',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Northwestern',
    nickname: 'Wildcats',
    city: 'Evanston',
    state: 'IL',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Notre Dame',
    nickname: 'Fighting Irish',
    city: 'South Bend',
    state: 'IN',
    conference: 'Independent',
    division: 'division1FBS',
  },
  {
    school: 'Ohio',
    nickname: 'Bobcats',
    city: 'Athens',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Ohio State',
    nickname: 'Buckeyes',
    city: 'Columbus',
    state: 'OH',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Oklahoma',
    nickname: 'Sooners',
    city: 'Norman',
    state: 'OK',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Oklahoma State',
    nickname: 'Cowboys',
    city: 'Stillwater',
    state: 'OK',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Old Dominion',
    nickname: 'Monarchs',
    city: 'Norfolk',
    state: 'VA',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Ole Miss',
    nickname: 'Rebels',
    city: 'University',
    state: 'MS',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Oregon',
    nickname: 'Ducks',
    city: 'Eugene',
    state: 'OR',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Oregon State',
    nickname: 'Beavers',
    city: 'Corvallis',
    state: 'OR',
    conference: 'Pac-12',
    division: 'division1FBS',
  },
  {
    school: 'Penn State',
    nickname: 'Nittany Lions',
    city: 'University Park',
    state: 'PA',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Pittsburgh',
    nickname: 'Panthers',
    city: 'Pittsburgh',
    state: 'PA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Purdue',
    nickname: 'Boilermakers',
    city: 'West Lafayette',
    state: 'IN',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Rice',
    nickname: 'Owls',
    city: 'Houston',
    state: 'TX',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Rutgers',
    nickname: 'Scarlet Knights',
    city: 'Piscataway',
    state: 'NJ',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Sam Houston',
    nickname: 'Bearkats',
    city: 'Huntsville',
    state: 'TX',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'San Diego State',
    nickname: 'Aztecs',
    city: 'San Diego',
    state: 'CA',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'San Jose State',
    nickname: 'Spartans',
    city: 'San Jose',
    state: 'CA',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'SMU',
    nickname: 'Mustangs',
    city: 'Dallas',
    state: 'TX',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'South Alabama',
    nickname: 'Jaguars',
    city: 'Mobile',
    state: 'AL',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'South Carolina',
    nickname: 'Gamecocks',
    city: 'Columbia',
    state: 'SC',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'South Florida',
    nickname: 'Bulls',
    city: 'Tampa',
    state: 'FL',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Southern Miss',
    nickname: 'Golden Eagles',
    city: 'Hattiesburg',
    state: 'MS',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Stanford',
    nickname: 'Cardinal',
    city: 'Stanford',
    state: 'CA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Syracuse',
    nickname: 'Orange',
    city: 'Syracuse',
    state: 'NY',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'TCU',
    nickname: 'Horned Frogs',
    city: 'Fort Worth',
    state: 'TX',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Temple',
    nickname: 'Owls',
    city: 'Philadelphia',
    state: 'PA',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Tennessee',
    nickname: 'Volunteers',
    city: 'Knoxville',
    state: 'TN',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Texas',
    nickname: 'Longhorns',
    city: 'Austin',
    state: 'TX',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Texas A&M',
    nickname: 'Aggies',
    city: 'College Station',
    state: 'TX',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Texas State',
    nickname: 'Bobcats',
    city: 'San Marcos',
    state: 'TX',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Texas Tech',
    nickname: 'Red Raiders',
    city: 'Lubbock',
    state: 'TX',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Toledo',
    nickname: 'Rockets',
    city: 'Toledo',
    state: 'OH',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Troy',
    nickname: 'Trojans',
    city: 'Troy',
    state: 'AL',
    conference: 'Sun Belt',
    division: 'division1FBS',
  },
  {
    school: 'Tulane',
    nickname: 'Green Wave',
    city: 'New Orleans',
    state: 'LA',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Tulsa',
    nickname: 'Golden Hurricane',
    city: 'Tulsa',
    state: 'OK',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'UAB',
    nickname: 'Blazers',
    city: 'Birmingham',
    state: 'AL',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'UCF',
    nickname: 'Knights',
    city: 'Orlando',
    state: 'FL',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'UCLA',
    nickname: 'Bruins',
    city: 'Los Angeles',
    state: 'CA',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'UConn',
    nickname: 'Huskies',
    city: 'Storrs',
    state: 'CT',
    conference: 'Independent',
    division: 'division1FBS',
  },
  {
    school: 'UMass',
    nickname: 'Minutemen',
    city: 'Amherst',
    state: 'MA',
    conference: 'Independent',
    division: 'division1FBS',
  },
  {
    school: 'UNLV',
    nickname: 'Rebels',
    city: 'Las Vegas',
    state: 'NV',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'USC',
    nickname: 'Trojans',
    city: 'Los Angeles',
    state: 'CA',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Utah',
    nickname: 'Utes',
    city: 'Salt Lake City',
    state: 'UT',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Utah State',
    nickname: 'Aggies',
    city: 'Logan',
    state: 'UT',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
  {
    school: 'UTEP',
    nickname: 'Miners',
    city: 'El Paso',
    state: 'TX',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'UTSA',
    nickname: 'Roadrunners',
    city: 'San Antonio',
    state: 'TX',
    conference: 'American',
    division: 'division1FBS',
  },
  {
    school: 'Vanderbilt',
    nickname: 'Commodores',
    city: 'Nashville',
    state: 'TN',
    conference: 'SEC',
    division: 'division1FBS',
  },
  {
    school: 'Virginia',
    nickname: 'Cavaliers',
    city: 'Charlottesville',
    state: 'VA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Virginia Tech',
    nickname: 'Hokies',
    city: 'Blacksburg',
    state: 'VA',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Wake Forest',
    nickname: 'Demon Deacons',
    city: 'Winston-Salem',
    state: 'NC',
    conference: 'ACC',
    division: 'division1FBS',
  },
  {
    school: 'Washington',
    nickname: 'Huskies',
    city: 'Seattle',
    state: 'WA',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Washington State',
    nickname: 'Cougars',
    city: 'Pullman',
    state: 'WA',
    conference: 'Pac-12',
    division: 'division1FBS',
  },
  {
    school: 'West Virginia',
    nickname: 'Mountaineers',
    city: 'Morgantown',
    state: 'WV',
    conference: 'Big 12',
    division: 'division1FBS',
  },
  {
    school: 'Western Kentucky',
    nickname: 'Hilltoppers',
    city: 'Bowling Green',
    state: 'KY',
    conference: 'CUSA',
    division: 'division1FBS',
  },
  {
    school: 'Western Michigan',
    nickname: 'Broncos',
    city: 'Kalamazoo',
    state: 'MI',
    conference: 'MAC',
    division: 'division1FBS',
  },
  {
    school: 'Wisconsin',
    nickname: 'Badgers',
    city: 'Madison',
    state: 'WI',
    conference: 'Big Ten',
    division: 'division1FBS',
  },
  {
    school: 'Wyoming',
    nickname: 'Cowboys',
    city: 'Laramie',
    state: 'WY',
    conference: 'Mountain West',
    division: 'division1FBS',
  },
];

export const universityOptions = [
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-COLLEGE OF MEDICINE',
    address: '500 UNIVERSITY DRIVE',
    city: 'HERSHEY',
    state: 'PA',
    zip: 17033,
    telephone: '(717) 531-8563',
    population: -999,
    county: 'DAUPHIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'med.psu.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-MAIN CAMPUS',
    address: '201 OLD MAIN',
    city: 'UNIVERSITY PARK',
    state: 'PA',
    zip: 16802,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'CENTRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'SELMA UNIVERSITY',
    address: '1501 LAPSLEY ST, DINKINS HALL',
    city: 'SELMA',
    state: 'AL',
    zip: 36701,
    telephone: '(334) 872-2533 EXT 101',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'selmauniversity.edu/',
  },
  {
    name: 'GUIDANCE COLLEGE',
    address: '1902 BAKER RD',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77094,
    telephone: '(713) 231-7391',
    population: -999,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.guidancecollege.org/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE FAYETTE- EBERLY',
    address: '2201 UNIVERSITY DRIVE',
    city: 'LEMONT FURNACE',
    state: 'PA',
    zip: 15456,
    telephone: '(724) 430-4100',
    population: -999,
    county: 'FAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'fayette.psu.edu/',
  },
  {
    name: 'RADFORD UNIVERSITY-CARILION',
    address: '101 ELM AVENUE SE',
    city: 'ROANOKE',
    state: 'VA',
    zip: 24013,
    telephone: '(888) 985-8483',
    population: -999,
    county: 'ROANOKE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.radford.edu/content/ruc/home.html',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '720 SOUTH RIVER ROAD',
    city: 'ST. GEORGE',
    state: 'UT',
    zip: 84790,
    telephone: '(435) 628-9902 EXT 2125',
    population: -999,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/locations/st-george',
  },
  {
    name: 'FAITH THEOLOGICAL SEMINARY',
    address: '529 WALKER AVENUE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21212,
    telephone: '(410) 323-6211 EXT 113',
    population: -999,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'fts.edu',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE LEHIGH VALLEY',
    address: '2809 SAUCON VALLEY ROAD',
    city: 'CENTER VALLEY',
    state: 'PA',
    zip: 18034,
    telephone: '(610) 285-5000',
    population: -999,
    county: 'LEHIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'lehighvalley.psu.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-ALBUQUERQUE WEST',
    address: '10131 COORS BLVD, SUITE I-01',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87114,
    telephone: '(505) 348-3750',
    population: -999,
    county: 'BERNALILLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/albuquerque-west/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE GREATER ALLEGHENY',
    address: '4000 UNIVERSITY DRIVE',
    city: 'MCKEESPORT',
    state: 'PA',
    zip: 15132,
    telephone: '(412) 675-9000',
    population: -999,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'greaterallegheny.psu.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-COLORADO SPRINGS SOUTH',
    address: '1079 SPACE CENTER DRIVE, SUITE 140',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80915,
    telephone: '(719) 208-3800',
    population: -999,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/colorado-springs-south/',
  },
  {
    name: 'CYRUS THE GREAT INTERNATIONAL ONLINE UNIVERSITY',
    address: '65 LEIGHTON AVE',
    city: 'YONKERS',
    state: 'NY',
    zip: 10705,
    telephone: '(202) 315-3322',
    population: -999,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cgiou.com/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-MESQUITE',
    address: '18600 LBJ FREEWAY',
    city: 'MESQUITE',
    state: 'TX',
    zip: 75150,
    telephone: '(972) 773-8800',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/mesquite/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE MONT ALTO',
    address: '1 CAMPUS DRIVE',
    city: 'MONT ALTO',
    state: 'PA',
    zip: 17237,
    telephone: '(717) 749-6000',
    population: -999,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'montalto.psu.edu/',
  },
  {
    name: 'ZAYTUNA COLLEGE',
    address: '1712 EUCLID AVENUE',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94709,
    telephone: '(510) 900-3154',
    population: -999,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://zaytuna.edu/',
  },
  {
    name: 'MEMPHIS COLLEGE OF ART',
    address: '1930 POPLAR AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 272-5100',
    population: -999,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mca.edu',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE ABINGTON',
    address: '1600 WOODLAND ROAD',
    city: 'ABINGTON',
    state: 'PA',
    zip: 19001,
    telephone: '(215) 881-7300',
    population: -999,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'abington.psu.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-INDIANAPOLIS',
    address: '3600 WOODVIEW TRACE, SUITE 200',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46268,
    telephone: '(317) 810-8100',
    population: -999,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/indianapolis/',
  },
  {
    name: 'FAITH THEOLOGICAL SEMINARY AND CHRISTIAN COLLEGE',
    address: '7607 SHELDON ROAD',
    city: 'TAMPA',
    state: 'FL',
    zip: 33615,
    telephone: '(813) 886-8492',
    population: -999,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ftscc.org',
  },
  {
    name: 'UNIVERSAL TRINITY COLLEGE',
    address: '8345 NW 66 STREET #D3909',
    city: 'MIAMI',
    state: 'FL',
    zip: 33166,
    telephone: '(209) 263-0551',
    population: -999,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utc-edu.com',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE ERIE-BEHREND COLLEGE',
    address: '4701 COLLEGE DRIVE',
    city: 'ERIE',
    state: 'PA',
    zip: 16563,
    telephone: '(814) 898-6000',
    population: -999,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'behrend.psu.edu/',
  },
  {
    name: 'THE UNIVERSITY OF AMERICA',
    address: '41707 WINCHESTER ROAD',
    city: 'TEMECULA',
    state: 'CA',
    zip: 92590,
    telephone: '(951) 239-3084',
    population: -999,
    county: 'RIVERSIDE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ua-edu.us/',
  },
  {
    name: "CHRISTIE'S EDUCATION",
    address: '1230 AVENUE OF THE AMERICAS, 20TH FLOOR',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10020,
    telephone: '(212) 355-1501',
    population: -999,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.christies.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE HARRISBURG',
    address: '777 WEST HARRISBURG PIKE',
    city: 'MIDDLETOWN',
    state: 'PA',
    zip: 17057,
    telephone: '(717) 948-6250',
    population: -999,
    county: 'DAUPHIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'harrisburg.psu.edu',
  },
  {
    name: 'WATKINS COLLEGE OF ART DESIGN & FILM',
    address: '2298 ROSA L PARKS BLVD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37228,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE SCHUYLKILL',
    address: '200 UNIVERSITY DRIVE',
    city: 'SCHUYLKILL HAVEN',
    state: 'PA',
    zip: 17972,
    telephone: '(570) 385-6000',
    population: -999,
    county: 'SCHUYLKILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'schuylkill.psu.edu/',
  },
  {
    name: 'UNIVERSITY OF REDLANDS GRADUATE SCHOOL OF THEOLOGY',
    address: '105 SEMINARY ROAD',
    city: 'SAN ANSELMO',
    state: 'CA',
    zip: 94960,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'MARIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: "ST. JOSEPH'S COLLEGE-LONG ISLAND",
    address: '155 W ROE BLVD',
    city: 'PATCHOGUE',
    state: 'NY',
    zip: 11772,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE DUBOIS',
    address: '1 COLLEGE PLACE',
    city: 'DUBOIS',
    state: 'PA',
    zip: 15801,
    telephone: '(814) 375-4700',
    population: -999,
    county: 'CLEARFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'dubois.psu.edu/',
  },
  {
    name: 'INSTITUTO DE BANCA Y COMERCIO INC',
    address: '56 CARRETERA 20 KM 2.3',
    city: 'GUAYNABO',
    state: 'PR',
    zip: 966,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'GUAYNABO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'ANTIOCH UNIVERSITY-MIDWEST',
    address: '900 DAYTON ST',
    city: 'YELLOW SPRINGS',
    state: 'OH',
    zip: 45387,
    telephone: '(937) 769-1800',
    population: -999,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'midwest.antioch.edu/',
  },
  {
    name: 'MARLBORO COLLEGE GRADUATE & PROFESSIONAL STUDIES',
    address: '2582 SOUTH ROAD',
    city: 'MARLBORO',
    state: 'VT',
    zip: 5344,
    telephone: '(802) 258-9200',
    population: -999,
    county: 'WINDHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marlboro.edu/academics/graduate',
  },
  {
    name: 'SOUTHWEST UNIVERSITY OF VISUAL ARTS-ALBUQUERQUE',
    address: 'NOT AVAILABLE',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87102,
    telephone: '(520) 325-0123',
    population: -999,
    county: 'BERNALILLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.suva.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE GREAT VALLEY',
    address: '30 EAST SWEDESFORD ROAD',
    city: 'MALVERN',
    state: 'PA',
    zip: 19355,
    telephone: '(610) 648-3200',
    population: -999,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'greatvalley.psu.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE SCRANTON',
    address: '120 RIDGE VIEW DRIVE',
    city: 'DUNMORE',
    state: 'PA',
    zip: 18512,
    telephone: '(570) 963-2500',
    population: -999,
    county: 'LACKAWANNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'scranton.psu.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH FLORIDA-ST PETERSBURG',
    address: '140 SEVENTH AVE S.',
    city: 'ST. PETERSBURG',
    state: 'FL',
    zip: 33701,
    telephone: '(727) 873-4873',
    population: -999,
    county: 'PINELLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usfsp.edu',
  },
  {
    name: 'TRIDENT UNIVERSITY INTERNATIONAL',
    address: '5757 PLAZA DRIVE, SUITE 100',
    city: 'CYPRESS',
    state: 'CA',
    zip: 90630,
    telephone: '(800) 375-9878',
    population: -999,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.trident.edu/',
  },
  {
    name: 'ARIZONA STATE UNIVERSITY-POLYTECHNIC',
    address: '7001 E WILLIAMS FIELD ROAD',
    city: 'MESA',
    state: 'AZ',
    zip: 85212,
    telephone: '(855) 278-5080',
    population: -999,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asu.edu/',
  },
  {
    name: 'THE JOHN MARSHALL LAW SCHOOL',
    address: '315 S PLYMOUTH CT',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60604,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'JOHN F. KENNEDY UNIVERSITY',
    address: '100 ELLINWOOD WAY',
    city: 'PLEASANT HILL',
    state: 'CA',
    zip: 94523,
    telephone: '(925) 969-3300',
    population: -999,
    county: 'CONTRA COSTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jfku.edu/',
  },
  {
    name: "SAINT LUKE'S COLLEGE OF HEALTH SCIENCES",
    address: '624 WESTPORT ROAD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64111,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'MARLBORO COLLEGE',
    address: '2582 SOUTH RD',
    city: 'MARLBORO',
    state: 'VT',
    zip: 5344,
    telephone: '(802) 490-0553',
    population: -999,
    county: 'WINDHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marlboro.edu',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-KILLEEN',
    address: '203 W. JASPER STE. 200',
    city: 'KILLEEN',
    state: 'TX',
    zip: 76542,
    telephone: '(254) 251-3710',
    population: -999,
    county: 'BELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/killeen/',
  },
  {
    name: 'INTERNATIONAL BUSINESS COLLEGE-FORT WAYNE',
    address: '5699 COVENTRY LANE',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46804,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE BRANDYWINE',
    address: '25 YEARSLEY MILL ROAD',
    city: 'MEDIA',
    state: 'PA',
    zip: 19063,
    telephone: '(610) 892-1200',
    population: -999,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'brandywine.psu.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-BELLEVUE',
    address: '3604 SUMMIT PLAZA DRIVE',
    city: 'BELLEVUE',
    state: 'NE',
    zip: 68123,
    telephone: '(402) 972-4250',
    population: -999,
    county: 'SARPY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/bellevue/',
  },
  {
    name: 'COLLEGEAMERICA-COLORADO SPRINGS',
    address: '3645 CITADEL DRIVE SOUTH',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80909,
    telephone: '(719) 622-3600 EXT 1200',
    population: -999,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.collegeamerica.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-DICKINSON LAW',
    address: '150 SOUTH COLLEGE STREET',
    city: 'CARLISLE',
    state: 'PA',
    zip: 17013,
    telephone: '(717) 240-5000',
    population: -999,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'law.psu.edu/',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '755 S MAIN ST',
    city: 'LOGAN',
    state: 'UT',
    zip: 84321,
    telephone: '(435) 792-6970 EXT 5001',
    population: -999,
    county: 'CACHE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'ARIZONA STATE UNIVERSITY-DOWNTOWN PHOENIX',
    address: '411 N CENTRAL AVE',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85004,
    telephone: '(855) 278-5080',
    population: -999,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asu.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-PORTLAND',
    address: '2811 NE HOLMAN STREET',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97211,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'HOLY FAMILY COLLEGE',
    address: '2406 S ALVERNO RD',
    city: 'MANITOWOC',
    state: 'WI',
    zip: 54220,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'MANITOWOC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-WORLD CAMPUS',
    address: '128 OUTREACH BUILDING',
    city: 'UNIVERSITY PARK',
    state: 'PA',
    zip: 16802,
    telephone: '(814) 865-5403',
    population: -999,
    county: 'CENTRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'worldcampus.psu.edu/',
  },
  {
    name: 'ARIZONA STATE UNIVERSITY-WEST',
    address: '4701 W THUNDERBIRD ROAD',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85306,
    telephone: '(855) 278-5080',
    population: -999,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asu.edu/',
  },
  {
    name: 'ROBERT MORRIS UNIVERSITY ILLINOIS',
    address: '401 S STATE STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(312) 935-6800',
    population: -999,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://robertmorris.edu/',
  },
  {
    name: "ST JOHN'S SEMINARY",
    address: '5012 SEMINARY RD',
    city: 'CAMARILLO',
    state: 'CA',
    zip: 93012,
    telephone: '(805) 482-2755 EXT 1014',
    population: -999,
    county: 'VENTURA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stjohnsem.edu',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-VIRGINIA',
    address: '4636 COLUMBUS STREET',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23462,
    telephone: '(866) 766-0766',
    population: -999,
    county: 'HENRICO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE BEAVER',
    address: '100 UNIVERSITY DRIVE',
    city: 'MONACA',
    state: 'PA',
    zip: 15061,
    telephone: '(724) 773-3800',
    population: -999,
    county: 'BEAVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'beaver.psu.edu/',
  },
  {
    name: 'GUIDANCE COLLEGE',
    address: '1902 BAKER RD',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77094,
    telephone: '(713) 231-7391',
    population: -999,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.guidancecollege.org/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE YORK',
    address: '1031 EDGECOMB AVENUE',
    city: 'YORK',
    state: 'PA',
    zip: 17403,
    telephone: '(717) 771-4000',
    population: -999,
    county: 'YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'york.psu.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE WILKES-BARRE',
    address: 'OLD ROUTE 115',
    city: 'LEHMAN',
    state: 'PA',
    zip: 18627,
    telephone: '(570) 675-2171',
    population: -999,
    county: 'LUZERNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'wilkesbarre.psu.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH FLORIDA-SARASOTA-MANATEE',
    address: '8350 N TAMIAMI TRAIL',
    city: 'SARASOTA',
    state: 'FL',
    zip: 34243,
    telephone: '(941) 359-4200',
    population: -999,
    county: 'MANATEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'usfsm.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE BERKS',
    address: 'TULPEHOCKEN ROAD',
    city: 'READING',
    state: 'PA',
    zip: 19610,
    telephone: '(610) 396-6000',
    population: -999,
    county: 'BERKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'berks.psu.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE HAZLETON',
    address: '76 UNIVERSITY DRIVE',
    city: 'HAZLETON',
    state: 'PA',
    zip: 18202,
    telephone: '(570) 450-3000',
    population: -999,
    county: 'LUZERNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hazleton.psu.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-RICHARDSON',
    address: '300 NORTH COIT ROAD, SUITE 225',
    city: 'RICHARDSON',
    state: 'TX',
    zip: 75080,
    telephone: '(972) 773-8650',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/richardson/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-GARDEN CITY',
    address: '801 CAMPUS DRIVE',
    city: 'GARDEN CITY',
    state: 'KS',
    zip: 67846,
    telephone: '(620) 805-3550',
    population: -999,
    county: 'FINNEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/garden-city/',
  },
  {
    name: 'SOUTHWESTERN BAPTIST THEOLOGICAL SEMINARY',
    address: '2001 W. SEMINARY DR.',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76115,
    telephone: '(817) 923-1921',
    population: -999,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'swbts.edu/',
  },
  {
    name: 'MACMURRAY COLLEGE',
    address: '447 EAST COLLEGE AVE',
    city: 'JACKSONVILLE',
    state: 'IL',
    zip: 62650,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'MORGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'SAVANNAH LAW SCHOOL',
    address: '7426 HODGSON MEMORIAL DRIVE',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31406,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'CHATHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE ALTOONA',
    address: '3000 IVYSIDE PARK',
    city: 'ALTOONA',
    state: 'PA',
    zip: 16601,
    telephone: '(814) 949-5000',
    population: -999,
    county: 'BLAIR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'altoona.psu.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-MICHIGAN',
    address: '26261 EVERGREEN RD',
    city: 'SOUTHFIELD',
    state: 'MI',
    zip: 48076,
    telephone: '(866) 766-0766',
    population: -999,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE SHENANGO',
    address: '147 SHENANGO AVENUE',
    city: 'SHARON',
    state: 'PA',
    zip: 16146,
    telephone: '(724) 983-2803',
    population: -999,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'shenango.psu.edu',
  },
  {
    name: 'MICHIGAN STATE UNIVERSITY-COLLEGE OF LAW',
    address: '648 N. SHAW LANE, ROOM 368',
    city: 'EAST LANSING',
    state: 'MI',
    zip: 48824,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'INGHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'NEBRASKA CHRISTIAN COLLEGE OF HOPE INTERNATIONAL UNIVERSITY',
    address: '12550 S. 114TH ST.',
    city: 'PAPILLION',
    state: 'NE',
    zip: 68046,
    telephone: '(402) 935-9400',
    population: -999,
    county: 'SARPY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nechristian.edu',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-HAROLD D. BUCKINGHAM GRADUATE SCHOOL',
    address: '5301 MOUNT RUSHMORE RD',
    city: 'RAPID CITY',
    state: 'SD',
    zip: 57701,
    telephone: '(512) 813-2300',
    population: -999,
    county: 'PENNINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/',
  },
  {
    name: 'DANIEL MORGAN GRADUATE SCHOOL OF NATIONAL SECURITY',
    address: '1620 L STREET, NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20036,
    telephone: '(202) 759-4988',
    population: -999,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'dmgs.org/',
  },
  {
    name: 'AMERICAN COLLEGE FOR MEDICAL CAREERS',
    address: '5959 LAKE ELLENOR LAKE',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32809,
    telephone: '(407) 738-4488',
    population: -999,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acmc.edu',
  },
  {
    name: 'INSTITUTE OF LUTHERAN THEOLOGY',
    address: '910 4TH STREET',
    city: 'BROOKINGS',
    state: 'SD',
    zip: 57006,
    telephone: '(605) 692-9337',
    population: -999,
    county: 'BROOKINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ilt.edu/',
  },
  {
    name: 'PENNSYLVANIA STATE UNIVERSITY-PENN STATE NEW KENSINGTON',
    address: '3550 SEVENTH STREET ROAD',
    city: 'NEW KENSINGTON',
    state: 'PA',
    zip: 15068,
    telephone: '(724) 334-5466',
    population: -999,
    county: 'WESTMORELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'newkensington.psu.edu/',
  },
  {
    name: 'MONTANA BIBLE COLLEGE',
    address: '20 CORNERSTONE WAY',
    city: 'BOZEMAN',
    state: 'MT',
    zip: 59718,
    telephone: '(406) 586-3585',
    population: -999,
    county: 'GALLATIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://montanabiblecollege.edu/',
  },
  {
    name: 'REFORMED PRESBYTERIAN THEOLOGICAL SEMINARY',
    address: '7418 PENN AVE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15208,
    telephone: '(412) 731-6000',
    population: -999,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rpts.edu',
  },
  {
    name: 'COLUMBIA COLLEGE OF NURSING',
    address: '4425 N PORT WASHINGTON RD',
    city: 'GLENDALE',
    state: 'WI',
    zip: 53212,
    telephone: '(414) 326-2330',
    population: -999,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccon.edu/',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '1476 SANDHILL ROAD',
    city: 'OREM',
    state: 'UT',
    zip: 84058,
    telephone: '(801) 418-1450 EXT 2001',
    population: -999,
    county: 'UTAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'COLLEGEAMERICA-DENVER',
    address: '1385 S COLORADO BLVD., 5TH FLOOR',
    city: 'DENVER',
    state: 'CO',
    zip: 80222,
    telephone: '(303) 300-8740',
    population: -999,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.collegeamerica.edu/',
  },
  {
    name: 'COLLEGEAMERICA-FORT COLLINS',
    address: '4601 SOUTH MASON ST',
    city: 'FORT COLLINS',
    state: 'CO',
    zip: 80525,
    telephone: '(970) 225-4860',
    population: -999,
    county: 'LARIMER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.collegeamerica.edu/',
  },
  {
    name: 'FAITH THEOLOGICAL SEMINARY AND CHRISTIAN COLLEGE',
    address: '7607 SHELDON ROAD',
    city: 'TAMPA',
    state: 'FL',
    zip: 33615,
    telephone: '(813) 886-8492',
    population: -999,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ftscc.org/',
  },
  {
    name: 'CALIFORNIA INTERNATIONAL BUSINESS UNIVERSITY',
    address: '550 WEST B STREET',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 384-8596',
    population: -999,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cibu.edu',
  },
  {
    name: 'SOUTHWEST UNIVERSITY OF VISUAL ARTS-TUCSON',
    address: '20 E. CONGRESS ST.',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85701,
    telephone: '(520) 325-0123',
    population: -999,
    county: 'PIMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.suva.edu/',
  },
  {
    name: 'MOUNTAIN VIEW COLLEGE',
    address: '4849 WEST ILLINOIS AVE.',
    city: 'DALLAS',
    state: 'TX',
    zip: 75211,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'FORTIS COLLEGE-LANDOVER',
    address: '4351 GARDEN CITY DRIVE',
    city: 'LANDOVER',
    state: 'MD',
    zip: 20785,
    telephone: '(301) 459-3650',
    population: -999,
    county: "PRINCE GEORGE'S",
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'EAST SAN GABRIEL VALLEY REGIONAL OCCUPATIONAL PROGRAM',
    address: '1501 W DEL NORTE ST.',
    city: 'WEST COVINA',
    state: 'CA',
    zip: 91790,
    telephone: '(626) 472-5134',
    population: -999,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.esgvrop.org',
  },
  {
    name: 'EASTFIELD COLLEGE',
    address: '3737 MOTLEY DR',
    city: 'MESQUITE',
    state: 'TX',
    zip: 75150,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'CAREER QUEST LEARNING CENTER-BAY CITY BRANCH',
    address: '3900 STATE STREET ROAD STE 200',
    city: 'BAY CITY',
    state: 'MI',
    zip: 48706,
    telephone: '(989) 322-3900',
    population: -999,
    county: 'BAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.careerquest.edu/',
  },
  {
    name: 'BROOKHAVEN COLLEGE',
    address: '3939 VALLEY VIEW LN',
    city: 'FARMERS BRANCH',
    state: 'TX',
    zip: 75244,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'FORTIS INSTITUTE-ERIE',
    address: '5757 WEST 26TH STREET',
    city: 'ERIE',
    state: 'PA',
    zip: 16506,
    telephone: '(814) 838-7673',
    population: -999,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fortis.edu/',
  },
  {
    name: 'BROWN COLLEGE OF COURT REPORTING',
    address: '1100 SPRING STREET, SUITE 101',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30309,
    telephone: '(404) 876-1227',
    population: -999,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bccr.edu/',
  },
  {
    name: 'PIONEER PACIFIC COLLEGE',
    address: '4145 SW WATSON AVE. #300',
    city: 'BEAVERTON',
    state: 'OR',
    zip: 97005,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'FLORIDA TECHNICAL COLLEGE',
    address: '12900 CHALLENGER PARKWAY',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32826,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'BRADFORD SCHOOL',
    address: '2469 STELZER ROAD',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43219,
    telephone: '(614) 416-6200',
    population: -999,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bradfordschoolcolumbus.edu',
  },
  {
    name: 'CEDAR VALLEY COLLEGE',
    address: '3030 NORTH DALLAS AVE',
    city: 'LANCASTER',
    state: 'TX',
    zip: 75134,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'PIERCE COLLEGE-PUYALLUP',
    address: '9401 FARWEST DR SW',
    city: 'LAKEWOOD',
    state: 'WA',
    zip: 98498,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'PIERCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'NORTH LAKE COLLEGE',
    address: '5001 NORTH MACARTHUR BLVD.',
    city: 'IRVING',
    state: 'TX',
    zip: 75038,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'FORTIS COLLEGE-MONTGOMERY',
    address: '3470 EASTDALE CIR',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36117,
    telephone: '(334) 244-1827',
    population: -999,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'RICHLAND COLLEGE',
    address: '12800 ABRAMS RD.',
    city: 'DALLAS',
    state: 'TX',
    zip: 75243,
    telephone: 'NOT AVAILABLE',
    population: -999,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'NOT AVAILABLE',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-ILLINOIS',
    address: '203 N LASALLE STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60601,
    telephone: '(866) 766-0766',
    population: 2,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-LITTLE ROCK CAMPUS',
    address: '10600 COLONEL GLENN RD, SUITE 100',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72204,
    telephone: '(501) 312-0007',
    population: 6,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/little-rock-arkansas-technical-colleges',
  },
  {
    name: 'FORREST COLLEGE',
    address: '601 E RIVER STREET',
    city: 'ANDERSON',
    state: 'SC',
    zip: 29624,
    telephone: '(864) 225-7653',
    population: 7,
    county: 'ANDERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.forrestcollege.edu/',
  },
  {
    name: 'GLOBAL TECH COLLEGE',
    address: '4346 SECOR ROAD',
    city: 'TOLEDO',
    state: 'OH',
    zip: 43623,
    telephone: '(567) 200-6829',
    population: 8,
    county: 'LUCAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.globaltech.edu/',
  },
  {
    name: 'BIRTHINGWAY COLLEGE OF MIDWIFERY',
    address: '4997 SW NORMANDY PLACE',
    city: 'BEAVERTON',
    state: 'OR',
    zip: 97005,
    telephone: '(503) 760-3131',
    population: 9,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'birthingway.edu/',
  },
  {
    name: 'ELMEZZI GRADUATE SCHOOL OF MOLECULAR MEDICINE',
    address: '350 COMMUNITY DRIVE',
    city: 'MANHASSET',
    state: 'NY',
    zip: 11030,
    telephone: '(516) 562-3405',
    population: 9,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website:
      'www.northwell.edu/education-and-resources/elmezzi-graduate-school-of-molecular-medicine',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-PENNSYLVANIA',
    address: '30 S 17TH ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19103,
    telephone: '(866) 766-0766',
    population: 9,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-NEW JERSEY',
    address: '88 TOWN SQUARE PLACE',
    city: 'JERSEY CITY',
    state: 'NJ',
    zip: 7310,
    telephone: '(866) 766-0766',
    population: 11,
    county: 'HUDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-WASHINGTON',
    address: '7100 FORT DENT WAY',
    city: 'TUKWILA',
    state: 'WA',
    zip: 98188,
    telephone: '(866) 766-0766',
    population: 11,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-NEW MEXICO',
    address: '5700 PASADENA NE',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87113,
    telephone: '(866) 766-0766',
    population: 13,
    county: 'BERNALILLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'ASPIRA CITY COLLEGE',
    address: '4322 N. 5TH STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19140,
    telephone: '(215) 455-2300 EXT 7009',
    population: 13,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aspiracitycollege.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-NORTH CAROLINA',
    address: '3800 ARCO CORPORATE DR',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28273,
    telephone: '(866) 766-0766',
    population: 14,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'TALMUDICAL INSTITUTE OF UPSTATE NEW YORK',
    address: '769 PARK AVE',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14607,
    telephone: '(716) 473-2810',
    population: 17,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tiuny.org/',
  },
  {
    name: 'GLOBAL TECH COLLEGE',
    address: '4346 SECOR ROAD',
    city: 'TOLEDO',
    state: 'OH',
    zip: 43623,
    telephone: '(567) 377-7010',
    population: 17,
    county: 'LUCAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.globaltech.edu',
  },
  {
    name: 'CHI HEALTH SCHOOL OF RADIOLOGIC TECHNOLOGY',
    address: '6901 NORTH 72ND ST',
    city: 'OMAHA',
    state: 'NE',
    zip: 68122,
    telephone: '(402) 572-3654',
    population: 18,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chihealth.com/school-of-radiologic-technology',
  },
  {
    name: 'JNA INSTITUTE OF CULINARY ARTS',
    address: '1212 S BROAD ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19146,
    telephone: '(215) 468-8800',
    population: 19,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.culinaryarts.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-GEORGETOWN',
    address: '1015 W. UNIVERSITY AVENUE, SUITE 700',
    city: 'GEORGETOWN',
    state: 'TX',
    zip: 78628,
    telephone: '(512) 942-6750',
    population: 21,
    county: 'WILLIAMSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/georgetown/',
  },
  {
    name: 'COLLEGEAMERICA-FLAGSTAFF',
    address: '399 MALPAIS',
    city: 'FLAGSTAFF',
    state: 'AZ',
    zip: 86001,
    telephone: '(928) 213-6060 EXT 1400',
    population: 21,
    county: 'COCONINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.collegeamerica.edu/',
  },
  {
    name: "DELL'ARTE INTERNATIONAL SCHOOL OF PHYSICAL THEATRE",
    address: '131 H STREET',
    city: 'BLUE LAKE',
    state: 'CA',
    zip: 95525,
    telephone: '(707) 668-5663',
    population: 22,
    county: 'HUMBOLDT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dellarte.com/school',
  },
  {
    name: 'PATHWAYS COLLEGE',
    address: '320 N. HALSTEAD ST.',
    city: 'PASADENA',
    state: 'CA',
    zip: 91107,
    telephone: '(888) 532-7282',
    population: 22,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pathwayscollege.org/',
  },
  {
    name: 'CHRIST THE KING SEMINARY',
    address: '711 KNOX RD',
    city: 'EAST AURORA',
    state: 'NY',
    zip: 14052,
    telephone: '(716) 652-8900',
    population: 22,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cks.edu/',
  },
  {
    name: 'LOS ANGELES ACADEMY OF FIGURATIVE ART',
    address: '16926 SATICOY STREET',
    city: 'VAN NUYS',
    state: 'CA',
    zip: 91406,
    telephone: '(818) 429-3110',
    population: 24,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'laafa.edu/',
  },
  {
    name: 'MYOTHERAPY INSTITUTE',
    address: '4001 PIONEER WOODS DRIVE',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68506,
    telephone: '(402) 421-7410',
    population: 24,
    county: 'LANCASTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.myotherapy.edu/',
  },
  {
    name: 'THE SCHOOL OF ARCHITECTURE',
    address: '6433 E. DOUBLETREE RANCH RD.',
    city: 'PARADISE VALLEY',
    state: 'AZ',
    zip: 85253,
    telephone: '(480) 750-4470',
    population: 25,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://theschoolofarchitecture.edu/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY-ST LOUIS',
    address: '710 NORTH TUCKER STREET',
    city: 'ST. LOUIS',
    state: 'MO',
    zip: 63101,
    telephone: '(314) 499-5062',
    population: 25,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'stlouis.psm.edu/#',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-GEORGIA',
    address: '859 MOUNT VERNON HIGHWAY',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30328,
    telephone: '(866) 766-0766',
    population: 27,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'PREMIERE INTERNATIONAL COLLEGE',
    address: '2055 CENTRAL AVENUE',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33901,
    telephone: '(239) 454-5000',
    population: 27,
    county: 'LEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'picollege.edu',
  },
  {
    name: 'PROVO COLLEGE-IDAHO FALLS CAMPUS',
    address: '1592 EAST 17TH STREET',
    city: 'IDAHO FALLS',
    state: 'ID',
    zip: 83404,
    telephone: '(208) 779-2613',
    population: 28,
    county: 'BONNEVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eaglegatecollege.edu/locations/idaho-falls/',
  },
  {
    name: 'CONWAY SCHOOL OF LANDSCAPE DESIGN',
    address: '88 VILLAGE HILL ROAD',
    city: 'NORTHAMPTON',
    state: 'MA',
    zip: 1060,
    telephone: '(413) 369-4044',
    population: 28,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csld.edu/',
  },
  {
    name: 'AMERICAN ISLAMIC COLLEGE',
    address: '640 W IRVING PARK RD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60613,
    telephone: '(773) 281-4700',
    population: 29,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aicusa.edu/',
  },
  {
    name: 'W L BONNER COLLEGE',
    address: '4430 ARGENT CT',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29203,
    telephone: '(803) 726-3503',
    population: 29,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wlbc.edu/',
  },
  {
    name: 'BEVERLY HILLS DESIGN INSTITUTE',
    address: '8484 WILSHIRE BLVD SUITE #730',
    city: 'BEVERLY HILLS',
    state: 'CA',
    zip: 90211,
    telephone: '(310) 360-8888',
    population: 29,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bhdi.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-HIGH POINT',
    address: '3975 PREMIER DRIVE',
    city: 'HIGH POINT',
    state: 'NC',
    zip: 27265,
    telephone: '(336) 812-7200',
    population: 29,
    county: 'GUILFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southuniversity.edu/high-point#location=High Point, NC',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY',
    address: '16801 GREENSPOINT PARK DRIVE SUITE 150',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77060,
    telephone: '(281) 931-7717',
    population: 29,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/north-houston-college/',
  },
  {
    name: 'MILAN INSTITUTE-BAKERSFIELD WEST',
    address: '3115 N. SILLECT',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93308,
    telephone: '(661) 437-4000',
    population: 29,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.milaninstitute.edu/',
  },
  {
    name: 'PREMIERE INTERNATIONAL COLLEGE',
    address: '2055 CENTRAL AVENUE',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33901,
    telephone: '(239) 454-5000',
    population: 29,
    county: 'LEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'picollege.edu/',
  },
  {
    name: 'NEW ENGLAND CULINARY INSTITUTE',
    address: '62 RIDGE STREET, 2ND FLOOR',
    city: 'MONTPELIER',
    state: 'VT',
    zip: 5602,
    telephone: '(802) 327-0287',
    population: 30,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neci.edu/',
  },
  {
    name: 'BETHEL SEMINARY-SAN DIEGO',
    address: '6116 AROSA ST',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92115,
    telephone: '(619) 325-5200',
    population: 31,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bethel.edu/',
  },
  {
    name: 'MOUNTAIN STATE COLLEGE',
    address: '1508 SPRING ST',
    city: 'PARKERSBURG',
    state: 'WV',
    zip: 26101,
    telephone: '(304) 485-5487',
    population: 31,
    county: 'WOOD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.msc.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-KINGS BAY',
    address: '918 USS JAMES MADISON ROAD BLDG 1030',
    city: 'KINGS BAY',
    state: 'GA',
    zip: 31547,
    telephone: '(605) 718-6550',
    population: 32,
    county: 'CAMDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/kings-bay/',
  },
  {
    name: 'INSTITUTE OF TAOIST EDUCATION AND ACUPUNCTURE',
    address: '317 W SOUTH BOULDER RD, SUITE 5',
    city: 'LOUISVILLE',
    state: 'CO',
    zip: 80027,
    telephone: '(720) 890-8922',
    population: 32,
    county: 'BOULDER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.itea.edu/',
  },
  {
    name: 'YESHIVA BAIS AHARON',
    address: '905 PARK AVENUE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 364-7604',
    population: 33,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yeshivabaisaharon.com/',
  },
  {
    name: 'TRIANGLE TECH-CHAMBERSBURG',
    address: '1669 OPPORTUNITY AVENUE',
    city: 'CHAMBERSBURG',
    state: 'PA',
    zip: 17201,
    telephone: '(412) 359-1000 EXT 7901',
    population: 33,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.triangle-tech.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-UTAH',
    address: '5373 S. GREEN STREET',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84123,
    telephone: '(866) 766-0766',
    population: 34,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'AUSTIN GRADUATE SCHOOL OF THEOLOGY',
    address: '7640 GUADALUPE ST',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78752,
    telephone: '(512) 476-2772',
    population: 34,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.austingrad.edu/',
  },
  {
    name: 'CALIFORNIA CHRISTIAN COLLEGE',
    address: '5364 E. BELMONT AVENUE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93727,
    telephone: '(559) 251-4215',
    population: 34,
    county: 'FRESNO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calchristiancollege.edu/',
  },
  {
    name: 'CENTRAL YESHIVA BETH JOSEPH',
    address: '1502 AVENUE N',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 951-6858',
    population: 35,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://centralyeshivabethjoseph.com/',
  },
  {
    name: 'ALEXANDRIA SCHOOL OF SCIENTIFIC THERAPEUTICS',
    address: '809 S HARRISON ST',
    city: 'ALEXANDRIA',
    state: 'IN',
    zip: 46001,
    telephone: '(765) 724-9152',
    population: 35,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.assti.com/',
  },
  {
    name: 'CALIFORNIA ARTS UNIVERSITY',
    address: '4100 W. COMMONWEALTH AVE. SUITE 101',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92833,
    telephone: '(714) 222-1110',
    population: 36,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cauniv.edu/',
  },
  {
    name: 'TAYLOR ANDREWS ACADEMY OF HAIR DESIGN-HAIR LAB DETROIT BARBER SCHOOL',
    address: '15070 DIX TOLEDO ROAD',
    city: 'SOUTHGATE',
    state: 'MI',
    zip: 48195,
    telephone: '(734) 258-8183',
    population: 36,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hairlabdetroitbarberschool.com/',
  },
  {
    name: 'THE CREATIVE CENTER',
    address: '10850 EMMET STREET',
    city: 'OMAHA',
    state: 'NE',
    zip: 68164,
    telephone: '(402) 898-1000',
    population: 37,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.creativecenter.edu/',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '901 PIER VIEW DRIVE SUITE 105',
    city: 'IDAHO FALLS',
    state: 'ID',
    zip: 83402,
    telephone: '(208) 522-0887',
    population: 39,
    county: 'BONNEVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'BALDY VIEW REGIONAL OCCUPATIONAL PROGRAM',
    address: '1501 BON VIEW AVENUE',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91761,
    telephone: '(909) 947-3400',
    population: 39,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.baldyviewrop.com/',
  },
  {
    name: 'EAGLE GATE COLLEGE-BOISE CAMPUS',
    address: '9300 WEST OVERLAND ROAD',
    city: 'BOISE',
    state: 'ID',
    zip: 83709,
    telephone: '(208) 417-8723',
    population: 40,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eaglegatecollege.edu/locations/boise',
  },
  {
    name: 'YESHIVA GEDOLAH ZICHRON LEYMA',
    address: '2035 VAUXHALL ROAD',
    city: 'UNION',
    state: 'NJ',
    zip: 7083,
    telephone: '(908) 587-0502',
    population: 40,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yzlalumni.org/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-FLORIDA',
    address: '2400 SW 145TH AVENUE',
    city: 'MIRAMAR',
    state: 'FL',
    zip: 33027,
    telephone: '(866) 766-0766',
    population: 40,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'THEOLOGICAL SEMINARY OF THE REFORMED EPISCOPAL CHURCH',
    address: '826 SECOND AVENUE',
    city: 'BLUE BELL',
    state: 'PA',
    zip: 19422,
    telephone: '(610) 292-9852',
    population: 40,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.reseminary.edu/',
  },
  {
    name: 'YESHIVA OF OCEAN',
    address: '7120 HIGHWAY 52',
    city: 'GREENFIELD PARK',
    state: 'NY',
    zip: 12435,
    telephone: '(845) 647-2607',
    population: 40,
    county: 'ULSTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaofocean.com/',
  },
  {
    name: 'DEVRY UNIVERSITY-INDIANA',
    address: '8488 GEORGIA STREET',
    city: 'MERRILLVILLE',
    state: 'IN',
    zip: 46410,
    telephone: '(219) 736-7440',
    population: 40,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'ELMIRA BUSINESS INSTITUTE',
    address: '4100 VESTAL ROAD',
    city: 'VESTAL',
    state: 'NY',
    zip: 13850,
    telephone: '(607) 729-8915',
    population: 40,
    county: 'BROOME',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ebi.edu/',
  },
  {
    name: 'NORTHWEST SCHOOL OF WOODEN BOAT BUILDING',
    address: '42 N WATER ST',
    city: 'PORT HADLOCK',
    state: 'WA',
    zip: 98339,
    telephone: '(360) 385-4948',
    population: 40,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwswb.edu/',
  },
  {
    name: 'KEY COLLEGE',
    address: '1040 BAYVIEW DRIVE',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33304,
    telephone: '(754) 312-2898',
    population: 41,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.keycollege.edu/',
  },
  {
    name: 'YESHIVA COLLEGE OF THE NATIONS CAPITAL',
    address: '1216 ARCOLA AVE',
    city: 'SILVER SPRING',
    state: 'MD',
    zip: 20902,
    telephone: '(301) 649-7077 EXT 1532',
    population: 41,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ycnc.org/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-KINGS BAY',
    address: '918 USS JAMES MADISON ROAD BLDG 1030',
    city: 'KINGS BAY',
    state: 'GA',
    zip: 31547,
    telephone: '(605) 718-6550',
    population: 41,
    county: 'CAMDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/kings-bay/',
  },
  {
    name: 'PACIFIC STATES UNIVERSITY',
    address: '3424 WILSHIRE BLVD. 12TH FLOOR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(323) 731-2383',
    population: 42,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.psuca.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-TENNESSEE',
    address: '3343 PERIMETER HILL DR., STE. 200',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37211,
    telephone: '(615) 445-3456',
    population: 42,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY-NEWPORT',
    address: '76 CAROTHERS ROAD',
    city: 'NEWPORT',
    state: 'KY',
    zip: 41071,
    telephone: '(859) 282-8989',
    population: 42,
    county: 'CAMPBELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/',
  },
  {
    name: 'RABBINICAL SEMINARY MKOR CHAIM',
    address: '160 LOCUST STREET',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 901-2428',
    population: 44,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mkorchaim.org/',
  },
  {
    name: 'YESHIVA ZICHRON ARYEH',
    address: '1213 BAY 25TH STREET',
    city: 'FAR ROCKAWAY',
    state: 'NY',
    zip: 11691,
    telephone: '(516) 295-5700',
    population: 44,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivazichronaryeh.com/',
  },
  {
    name: 'DIGITAL MEDIA INSTITUTE AT INTERTECH',
    address: '2031 KINGS HIGHWAY',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71103,
    telephone: '(318) 213-0788',
    population: 44,
    county: 'CADDO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dmi.edu/',
  },
  {
    name: 'THEATRE OF ARTS',
    address: '6767 SUNSET BLVD SUITE 210',
    city: 'HOLLYWOOD',
    state: 'CA',
    zip: 90028,
    telephone: '(323) 463-2500 EXT 4',
    population: 46,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.toa.edu/',
  },
  {
    name: 'DRAGON RISES COLLEGE OF ORIENTAL MEDICINE',
    address: '1000 NE 16TH AVE., BUILDING F',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32601,
    telephone: '(352) 371-2833',
    population: 47,
    county: 'ALACHUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dragonrises.edu/',
  },
  {
    name: 'YESHIVA OF OCEAN',
    address: '7120 HIGHWAY 52',
    city: 'GREENFIELD PARK',
    state: 'NY',
    zip: 12435,
    telephone: '(845) 647-2607',
    population: 47,
    county: 'ULSTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaofocean.com',
  },
  {
    name: 'BAIS BINYOMIN ACADEMY',
    address: '51 CARLTON ROAD',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 207-0330',
    population: 47,
    county: 'ROCKLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://baisbinyominacademy.com/',
  },
  {
    name: 'AVIATION INSTITUTE OF MAINTENANCE-CHARLOTTE',
    address: '7421 E. INDEPENDENCE BOULEVARD',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28227,
    telephone: '(980) 785-0700',
    population: 47,
    county: 'MECKLENBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aviationmaintenance.edu/campuses/charlotte-nc/index.html',
  },
  {
    name: 'MESSENGER COLLEGE',
    address: '2701 BROWN TRAIL, SUITE 408',
    city: 'BEDFORD',
    state: 'TX',
    zip: 76021,
    telephone: '(817) 554-5950 EXT 100',
    population: 48,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.messengercollege.edu/',
  },
  {
    name: 'VIRGINIA BEACH THEOLOGICAL SEMINARY',
    address: '2221 CENTERVILLE TURNPIKE',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23464,
    telephone: '(757) 479-3706',
    population: 48,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vbts.edu/',
  },
  {
    name: 'YESHIVA OHR NAFTOLI',
    address: '701 BLOOMING GROVE TURNPIKE',
    city: 'NEW WINDSOR',
    state: 'NY',
    zip: 12553,
    telephone: '(845) 784-4020',
    population: 48,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yeshivaohrnaftoli.com/',
  },
  {
    name: 'YOUNG AMERICANS COLLEGE OF THE PERFORMING ARTS',
    address: '1132 OLYMPIC DRIVE',
    city: 'CORONA',
    state: 'CA',
    zip: 92881,
    telephone: '(951) 493-6753',
    population: 48,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.yacollege.edu/',
  },
  {
    name: 'SOUTHWEST COLLEGIATE INSTITUTE FOR THE DEAF',
    address: '3200 AVE C',
    city: 'BIG SPRING',
    state: 'TX',
    zip: 79720,
    telephone: '(432) 264-3700',
    population: 48,
    county: 'HOWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://howardcollege.edu/swcid/',
  },
  {
    name: 'CALIFORNIA INTERNATIONAL BUSINESS UNIVERSITY',
    address: '550 WEST B STREET',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 384-8596',
    population: 49,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cibu.edu',
  },
  {
    name: 'MAINE MEDIA COLLEGE',
    address: '70 CAMDEN STREET',
    city: 'ROCKPORT',
    state: 'ME',
    zip: 4856,
    telephone: '(207) 236-8581',
    population: 49,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mainemedia.edu/college/',
  },
  {
    name: 'YESHIVA OHR YISRAEL',
    address: '2899 NOSTRAND AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11229,
    telephone: '(718) 382-8702',
    population: 49,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ohryisroel.org/',
  },
  {
    name: 'CHIEF DULL KNIFE COLLEGE',
    address: '1 COLLEGE DRIVE',
    city: 'LAME DEER',
    state: 'MT',
    zip: 59043,
    telephone: '(406) 477-6215 EXT 100',
    population: 49,
    county: 'ROSEBUD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cdkc.edu/',
  },
  {
    name: 'GLASGOW CALEDONIAN NEW YORK COLLEGE',
    address: '64 WOOSTER STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10012,
    telephone: '(646) 768-5300',
    population: 49,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcnyc.com/',
  },
  {
    name: 'UNIVERSAL COLLEGE OF HEALING ARTS',
    address: '8702 NORTH 30TH STREET',
    city: 'OMAHA',
    state: 'NE',
    zip: 68112,
    telephone: '(402) 556-4456',
    population: 49,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ucha.edu/',
  },
  {
    name: 'MID-SOUTH CHRISTIAN COLLEGE',
    address: '3097 KNIGHT ROAD',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38118,
    telephone: '(901) 375-4400',
    population: 50,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.midsouthchristian.edu/',
  },
  {
    name: 'TORAH TEMIMAH TALMUDICAL SEMINARY',
    address: '3323 RICHMOND AVE',
    city: 'STATEN ISLAND',
    state: 'NY',
    zip: 10312,
    telephone: '(718) 853-8500',
    population: 50,
    county: 'RICHMOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://torahtemimahtalmudicalseminary.com/',
  },
  {
    name: 'BRYAN UNIVERSITY',
    address: '3704 W. WALNUT ST.',
    city: 'ROGERS',
    state: 'AR',
    zip: 72756,
    telephone: '(479) 899-6644',
    population: 51,
    county: 'BENTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bryanu.edu/',
  },
  {
    name: 'LOS ANGELES PACIFIC COLLEGE',
    address: '3325 WILSHIRE BOULEVARD SUITE 550',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(213) 384-2318',
    population: 51,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lapacific.edu/',
  },
  {
    name: 'WRIGHT GRADUATE UNIVERSITY FOR THE REALIZATION OF HUMAN POTENTIAL',
    address: 'N7698 COUNTY HIGHWAY H',
    city: 'ELKHORN',
    state: 'WI',
    zip: 53121,
    telephone: '(262) 742-4444',
    population: 52,
    county: 'WALWORTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wrightgrad.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE BETH SHRAGA',
    address: '28 SADDLE RIVER RD',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 356-1980',
    population: 52,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rabbinicalcollegebethshraga.com/',
  },
  {
    name: 'ANTIOCH COLLEGE AG',
    address: '1705 TODDS LN',
    city: 'HAMPTON',
    state: 'VA',
    zip: 23666,
    telephone: '(757) 826-1883 EXT 236',
    population: 52,
    county: 'HAMPTON CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'antiochcollegeag.edu/',
  },
  {
    name: 'TRI-STATE BIBLE COLLEGE',
    address: '506 MARGARET ST',
    city: 'SOUTH POINT',
    state: 'OH',
    zip: 45680,
    telephone: '(740) 377-2520 EXT 10',
    population: 52,
    county: 'LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tsbc.edu/',
  },
  {
    name: 'WELLSPRING SCHOOL OF ALLIED HEALTH-WICHITA',
    address: '650 N CARRIAGE PARKWAY, STE 55',
    city: 'WICHITA',
    state: 'KS',
    zip: 67208,
    telephone: '(913) 406-8072',
    population: 52,
    county: 'SEDGWICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wellspring.edu',
  },
  {
    name: 'YESHIVAH GEDOLAH RABBINICAL COLLEGE',
    address: '1140 ALTON RD',
    city: 'MIAMI BEACH',
    state: 'FL',
    zip: 33139,
    telephone: '(305) 653-8770 EXT 2001',
    population: 53,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lecfl.com/',
  },
  {
    name: 'MESIVTA OF EASTERN PARKWAY-YESHIVA ZICHRON MEILECH',
    address: '510 DAHILL RD',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11218,
    telephone: '(718) 438-1002',
    population: 53,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://mesivtaofeasternparkway.com/',
  },
  {
    name: 'INSTITUTE OF BUDDHIST STUDIES',
    address: '2140 DURANT AVENUE',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 809-1444',
    population: 53,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shin-ibs.edu/',
  },
  {
    name: "MERYMA'AT BARBER COLLEGE",
    address: '12825-27 LORAIN AVE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44111,
    telephone: '(216) 202-1144',
    population: 53,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.merymaatbarbercollege.com/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY',
    address: '213 W SOUTHMORE ST SUITE 101',
    city: 'PASADENA',
    state: 'TX',
    zip: 77502,
    telephone: '(713) 920-1120',
    population: 54,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/pasadena-colleges-in-pasadena-tx/',
  },
  {
    name: 'AMERICAN INSTITUTE OF HEALTHCARE & TECHNOLOGY',
    address: '480 LORDSHIP BOULEVARD',
    city: 'STRATFORD',
    state: 'CT',
    zip: 6615,
    telephone: '(203) 870-8400',
    population: 54,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aiht.edu',
  },
  {
    name: 'PUERTO RICO SCHOOL OF NURSE ANESTHETISTS',
    address: '656 PONCE DE LEON AVE FLOOR 1',
    city: 'HATO REY',
    state: 'PR',
    zip: 918,
    telephone: '(787) 998-8997',
    population: 55,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eeapr.org',
  },
  {
    name: 'CARRINGTON COLLEGE-ADMINISTRATIVE OFFICE',
    address: '8909 FOLSOM BLVD.',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95826,
    telephone: '(916) 361-6666',
    population: 55,
    county: 'SACRAMENTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://carrington.edu/',
  },
  {
    name: 'SUMMIT CHRISTIAN COLLEGE',
    address: '2025 21ST STREET',
    city: 'GERING',
    state: 'NE',
    zip: 69341,
    telephone: '(308) 632-6933',
    population: 55,
    county: 'SCOTTS BLUFF',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.summitcc.edu/',
  },
  {
    name: 'REISS-DAVIS GRADUATE SCHOOL',
    address: '3200 MOTOR AVE.',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90034,
    telephone: '(310) 562-6478',
    population: 56,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.reissdavis.org/',
  },
  {
    name: 'INDIAN BIBLE COLLEGE',
    address: '2237 EAST CEDAR AVENUE',
    city: 'FLAGSTAFF',
    state: 'AZ',
    zip: 86004,
    telephone: '(928) 774-3890',
    population: 56,
    county: 'COCONINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.indianbible.org/',
  },
  {
    name: 'BATON ROUGE SCHOOL OF COMPUTERS',
    address: '9352 INTERLINE AVE',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70809,
    telephone: '(225) 923-2524',
    population: 56,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.brsc.edu/',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT XAVIER UNIVERSITY OF LOUISIANA',
    address: '1 DREXEL DRIVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70125,
    telephone: '(800) 721-8072',
    population: 57,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/new-orleans/',
  },
  {
    name: 'CONCEPTION SEMINARY COLLEGE',
    address: '37174 STATE HWY V V',
    city: 'CONCEPTION',
    state: 'MO',
    zip: 64433,
    telephone: '(660) 944-3105',
    population: 57,
    county: 'NODAWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.conception.edu/',
  },
  {
    name: 'MAINE MEDIA COLLEGE',
    address: '70 CAMDEN STREET',
    city: 'ROCKPORT',
    state: 'ME',
    zip: 4856,
    telephone: '(207) 236-8581',
    population: 57,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mainemedia.edu/college/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-DILLON',
    address: '434 E. POINDEXTER STREET',
    city: 'DILLON',
    state: 'MT',
    zip: 59725,
    telephone: '(406) 988-0888',
    population: 57,
    county: 'BEAVERHEAD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pmi.edu/',
  },
  {
    name: 'BETH MEDRASH OF ASBURY PARK',
    address: '1500 VERMONT AVENUE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 370-1560',
    population: 58,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://baismedrashzichronmeir.com/',
  },
  {
    name: 'HAVEN UNIVERSITY',
    address: '12761 EUCLID ST.',
    city: 'GARDEN GROVE',
    state: 'CA',
    zip: 92840,
    telephone: '(714) 592-7878',
    population: 58,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.haven.edu/',
  },
  {
    name: 'YESHIVA OF FAR ROCKAWAY DERECH AYSON RABBINICAL SEMINARY',
    address: '802 HICKSVILLE RD',
    city: 'FAR ROCKAWAY',
    state: 'NY',
    zip: 11691,
    telephone: '(718) 327-7600',
    population: 58,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yofr.org/',
  },
  {
    name: 'APEX COLLEGE OF VETERINARY TECHNOLOGY',
    address: '330 SOUTH EL PASO STREET',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80903,
    telephone: '(719) 375-8228',
    population: 58,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.apexcvt.edu/',
  },
  {
    name: 'COLORADO SCHOOL OF HEALING ARTS',
    address: '7655 W MISSISSIPPI STE 100',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80226,
    telephone: '(303) 986-2320',
    population: 58,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.csha.net/',
  },
  {
    name: 'ALASKA BIBLE COLLEGE',
    address: '248 E ELMWOOD AVE',
    city: 'PALMER',
    state: 'AK',
    zip: 99645,
    telephone: '(907) 745-3201',
    population: 59,
    county: 'MATANUSKA-SUSITNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.akbible.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-NEVADA',
    address: '2490 PASEO VERDE PKWY., STE. 150',
    city: 'HENDERSON',
    state: 'NV',
    zip: 89074,
    telephone: '(702) 933-9700',
    population: 59,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'UNIVERSITY OF PITTSBURGH-TITUSVILLE',
    address: '504 EAST MAIN STREET',
    city: 'TITUSVILLE',
    state: 'PA',
    zip: 16354,
    telephone: '(888) 878-0462',
    population: 60,
    county: 'CRAWFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.titusville.pitt.edu/home',
  },
  {
    name: 'GATHER 4 HIM CHRISTIAN COLLEGE',
    address: '3021 WEST CLEARWATER AVENUE',
    city: 'KENNEWICK',
    state: 'WA',
    zip: 99336,
    telephone: '(509) 420-4545',
    population: 60,
    county: 'BENTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://college.gather4him.net/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY-GAINESVILLE',
    address: '2323-C BROWNS BRIDGE RD',
    city: 'GAINESVILLE',
    state: 'GA',
    zip: 30504,
    telephone: '(678) 450-0550',
    population: 60,
    county: 'HALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/',
  },
  {
    name: 'BAIS MEDRASH MAYAN HATORAH',
    address: '101 MILTON STREET',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 367-9900',
    population: 61,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://baismedrashmayanhatorah.com/',
  },
  {
    name: 'HERITAGE BIBLE COLLEGE',
    address: '494 ANTIOCH CHURCH ROAD',
    city: 'DUNN',
    state: 'NC',
    zip: 28334,
    telephone: '(910) 892-3178',
    population: 61,
    county: 'HARNETT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.heritagebiblecollege.edu/',
  },
  {
    name: 'SEATTLE INSTITUTE OF EAST ASIAN MEDICINE',
    address: '226 SOUTH ORCAS STREET',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98108,
    telephone: '(206) 517-4541',
    population: 62,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sieam.edu/',
  },
  {
    name: 'SOUTHWEST ACUPUNCTURE COLLEGE-SANTA FE',
    address: '2100 CALLE DE LA VUELTA, SUITE D103',
    city: 'SANTA FE',
    state: 'NM',
    zip: 87505,
    telephone: '(505) 438-8884',
    population: 62,
    county: 'SANTA FE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acupuncturecollege.edu/',
  },
  {
    name: 'ARIZONA SCHOOL OF ACUPUNCTURE AND ORIENTAL MEDICINE',
    address: '2856 E FORT LOWELL RD',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85716,
    telephone: '(520) 795-0787 EXT 101',
    population: 62,
    county: 'PIMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asaom.edu/',
  },
  {
    name: 'SCHILLER INTERNATIONAL UNIVERSITY',
    address: '400 N TAMPA ST. SUITE 1700',
    city: 'TAMPA',
    state: 'FL',
    zip: 33602,
    telephone: '(727) 736-5082',
    population: 62,
    county: 'PINELLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.schiller.edu/',
  },
  {
    name: 'TEXAS COUNTY TECHNICAL COLLEGE',
    address: '6915 S HWY 63',
    city: 'HOUSTON',
    state: 'MO',
    zip: 65483,
    telephone: '(417) 967-5466',
    population: 62,
    county: 'TEXAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.texascountytech.edu/',
  },
  {
    name: 'CHRIST MISSION COLLEGE',
    address: '10822 FM 1560 NORTH',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78254,
    telephone: '(210) 688-3101 EXT 103',
    population: 63,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cmctx.org/',
  },
  {
    name: 'SHASTA BIBLE COLLEGE AND GRADUATE SCHOOL',
    address: '2951 GOODWATER AVE.',
    city: 'REDDING',
    state: 'CA',
    zip: 96002,
    telephone: '(530) 221-4275',
    population: 64,
    county: 'SHASTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shasta.edu/',
  },
  {
    name: 'SABER COLLEGE',
    address: '3990 W FLAGLER ST., STE 103',
    city: 'MIAMI',
    state: 'FL',
    zip: 33134,
    telephone: '(305) 443-9170 EXT 279',
    population: 64,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sabercollege.edu/',
  },
  {
    name: 'BERKELEY SCHOOL OF THEOLOGY',
    address: '2606 DWIGHT WAY',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 841-1905 EXT 237',
    population: 65,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.absw.edu/',
  },
  {
    name: 'AMERICAN ACADEMY OF ACUPUNCTURE AND ORIENTAL MEDICINE',
    address: '1925 W COUNTY RD B-2',
    city: 'ROSEVILLE',
    state: 'MN',
    zip: 55113,
    telephone: '(651) 631-0204 EXT 1',
    population: 65,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aaaom.edu/',
  },
  {
    name: 'YESHIVATH BETH MOSHE',
    address: '930 HICKORY ST',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18505,
    telephone: '(570) 346-1747',
    population: 66,
    county: 'LACKAWANNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivabethmoshe.com/',
  },
  {
    name: 'IBS SCHOOL OF COSMETOLOGY AND MASSAGE',
    address: '110 EAST KAAHUMANU AVENUE',
    city: 'KAHULUI',
    state: 'HI',
    zip: 96732,
    telephone: '(808) 214-5293',
    population: 66,
    county: 'MAUI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ibs-hi.com/',
  },
  {
    name: 'CALIFORNIA INDIAN NATIONS COLLEGE',
    address: '75080 FRANK SINATRA DR, STE 222',
    city: 'PALM DESERT',
    state: 'CA',
    zip: 92211,
    telephone: '(760) 834-0593',
    population: 66,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://cincollege.org/',
  },
  {
    name: 'ELYON COLLEGE',
    address: '1400 WEST 6TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11204,
    telephone: '(718) 259-5600',
    population: 67,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'elyon.edu/',
  },
  {
    name: 'PACIFIC BIBLE COLLEGE',
    address: '28 S FIR STREET STE 212',
    city: 'MEDFORD',
    state: 'OR',
    zip: 97501,
    telephone: '(541) 776-9942',
    population: 67,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pacificbible.edu/',
  },
  {
    name: 'THE LANDING SCHOOL',
    address: '286 RIVER RD',
    city: 'ARUNDEL',
    state: 'ME',
    zip: 4046,
    telephone: '(207) 985-7976',
    population: 67,
    county: 'YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.landingschool.edu/',
  },
  {
    name: 'FRANCISCAN SCHOOL OF THEOLOGY',
    address: '5998 ALCALA PARK',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92110,
    telephone: '(619) 574-5800',
    population: 68,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fst.edu/',
  },
  {
    name: 'VALLEY COLLEGE-CLEVELAND',
    address: '8700 BROOKPARK ROAD',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44129,
    telephone: '(216) 453-8201',
    population: 68,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.valley.edu',
  },
  {
    name: "YESHIVAS BE'ER YITZCHOK",
    address: '1391 NORTH AVE',
    city: 'ELIZABETH',
    state: 'NJ',
    zip: 7208,
    telephone: '(908) 354-6057',
    population: 69,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivasbeeryitzchok.org/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY-ST LOUIS',
    address: '710 NORTH TUCKER STREET',
    city: 'ST. LOUIS',
    state: 'MO',
    zip: 63101,
    telephone: '(314) 499-5062',
    population: 69,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'stlouis.psm.edu/#',
  },
  {
    name: 'PCI ACADEMY-IOWA CITY',
    address: '1550 SOUTH 1ST AVENUE',
    city: 'IOWA CITY',
    state: 'IA',
    zip: 52240,
    telephone: '(515) 337-2907',
    population: 69,
    county: 'JOHNSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://pci-academy.com/',
  },
  {
    name: 'MIDWEST COLLEGE OF ORIENTAL MEDICINE-EVANSTON',
    address: '1601 N SHERMAN AVE',
    city: 'EVANSTON',
    state: 'IL',
    zip: 60201,
    telephone: '(800) 593-2320',
    population: 70,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acupuncture.edu/',
  },
  {
    name: 'COLGATE ROCHESTER CROZER DIVINITY SCHOOL',
    address: '320 NORTH GOODMAN ST',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14607,
    telephone: '(585) 271-1320',
    population: 70,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.crcds.edu/',
  },
  {
    name: 'YESHIVA GEDOLAH OF GREATER DETROIT',
    address: '24600 GREENFIELD RD',
    city: 'OAK PARK',
    state: 'MI',
    zip: 48237,
    telephone: '(248) 968-3360',
    population: 70,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yeshivagedolahgreaterdetroit.com/',
  },
  {
    name: 'WAVE LEADERSHIP COLLEGE',
    address: '1000 NORTH GREAT NECK ROAD',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23454,
    telephone: '(757) 401-6426',
    population: 70,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'wavecollege.edu/',
  },
  {
    name: 'SOUTHERN TEXAS CAREERS ACADEMY',
    address: '601 EAST NOLANA SUITE C',
    city: 'MCALLEN',
    state: 'TX',
    zip: 78504,
    telephone: '(956) 687-7772',
    population: 70,
    county: 'HIDALGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'stcacademy.edu/',
  },
  {
    name: 'TRIANGLE TECH INC-SUNBURY',
    address: '191 PERFORMANCE ROAD',
    city: 'SUNBURY',
    state: 'PA',
    zip: 17801,
    telephone: '(570) 988-0700',
    population: 70,
    county: 'NORTHUMBERLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triangle-tech.edu/',
  },
  {
    name: 'CHRIST MISSION COLLEGE',
    address: '10822 FM 1560 NORTH',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78254,
    telephone: '(210) 688-3101',
    population: 71,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cmctx.org',
  },
  {
    name: 'YESHIVAT HECHAL SHEMUEL',
    address: '1532 EAST 10TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 336-2702',
    population: 71,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hechalshemuel.com',
  },
  {
    name: 'MIAMI AD SCHOOL',
    address: '571 NW 28TH ST',
    city: 'MIAMI',
    state: 'FL',
    zip: 33127,
    telephone: '(305) 538-3193 EXT 1003',
    population: 71,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.miamiadschool.com/',
  },
  {
    name: 'COLLEGE OF BUSINESS AND TECHNOLOGY-CUTLER BAY',
    address: '19151 SOUTH DIXIE HWY # 205',
    city: 'CUTLER BAY',
    state: 'FL',
    zip: 33157,
    telephone: '(786) 693-4488',
    population: 71,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cbt.edu/',
  },
  {
    name: 'HORIZON UNIVERSITY',
    address: '7700 INDIAN LAKE ROAD',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46236,
    telephone: '(800) 553-4674',
    population: 72,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.horizonuniversity.edu/',
  },
  {
    name: 'THE NORTH COAST COLLEGE',
    address: '11724 DETROIT AVENUE',
    city: 'LAKEWOOD',
    state: 'OH',
    zip: 44107,
    telephone: '(216) 221-8584',
    population: 72,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.thencc.edu/',
  },
  {
    name: 'YTI CAREER INSTITUTE-ALTOONA',
    address: '3200 PLEASANT BOULEVARD, SUITE A',
    city: 'ALTOONA',
    state: 'PA',
    zip: 16601,
    telephone: '(814) 201-2208',
    population: 72,
    county: 'BLAIR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.yti.edu/',
  },
  {
    name: 'MESIVTHA TIFERETH JERUSALEM OF AMERICA',
    address: '145 E BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10002,
    telephone: '(212) 964-2830',
    population: 73,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'mtj.edu/',
  },
  {
    name: 'BAIS HAMEDRASH AND MESIVTA OF BALTIMORE',
    address: '6823 OLD PIMLICO ROAD',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21209,
    telephone: '(410) 486-0006',
    population: 73,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bhmb.edu/',
  },
  {
    name: 'ACADEMY OF NATURAL THERAPY INC',
    address: '625 8TH AVE',
    city: 'GREELEY',
    state: 'CO',
    zip: 80631,
    telephone: '(970) 352-1181',
    population: 73,
    county: 'WELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.natural-therapy.com/',
  },
  {
    name: 'ASSUMPTION COLLEGE FOR SISTERS',
    address: '200 A MORRIS AVENUE',
    city: 'DENVILLE',
    state: 'NJ',
    zip: 7834,
    telephone: '(973) 957-0188 EXT 101',
    population: 73,
    county: 'MORRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.acs350.org/',
  },
  {
    name: 'NEW HOPE CHRISTIAN COLLEGE-EUGENE',
    address: '2155 BAILEY HILL RD',
    city: 'EUGENE',
    state: 'OR',
    zip: 97405,
    telephone: '(541) 485-1780',
    population: 74,
    county: 'LANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newhope.edu/',
  },
  {
    name: 'INSTITUTE OF CLINICAL ACUPUNCTURE & ORIENTAL MED',
    address: '100 N. BERETANIA STREET, SUITE 203B',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96817,
    telephone: '(808) 521-2288',
    population: 74,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.orientalmedicine.edu/',
  },
  {
    name: 'NORTH CENTRAL INSTITUTE',
    address: '168 JACK MILLER BLVD',
    city: 'CLARKSVILLE',
    state: 'TN',
    zip: 37042,
    telephone: '(931) 431-9700',
    population: 74,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nci.edu/',
  },
  {
    name: 'YESHIVA GEDOLAH OF WOODLAKE VILLAGE',
    address: '199 JOE PARKER ROAD',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 730-2808',
    population: 75,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaohrzechariah.com',
  },
  {
    name: 'TALMUDIC COLLEGE OF FLORIDA',
    address: '4000 ALTON RD',
    city: 'MIAMI BEACH',
    state: 'FL',
    zip: 33140,
    telephone: '(305) 534-7050',
    population: 75,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.talmudicu.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-MISSOURI',
    address: '1310 E 104TH ST, STE 120',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64131,
    telephone: '(816) 943-7300',
    population: 76,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'BAIS MEDRASH OF DEXTER PARK',
    address: '445 SOUTH PASCACK ROAD',
    city: 'CHESTNUT RIDGE',
    state: 'NY',
    zip: 10977,
    telephone: '(845) 735-2807',
    population: 76,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://bmdpark.com/',
  },
  {
    name: 'SHILOH UNIVERSITY',
    address: '416 D AVENUE',
    city: 'KALONA',
    state: 'IA',
    zip: 52247,
    telephone: '(319) 656-2447',
    population: 76,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shilohuniversity.edu/',
  },
  {
    name: 'NORTHWESTERN POLYTECHNIC UNIVERSITY',
    address: '47671 WESTINGHOUSE DRIVE',
    city: 'FREMONT',
    state: 'CA',
    zip: 94539,
    telephone: '(510) 592-9688',
    population: 76,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.npu.edu/',
  },
  {
    name: 'ROSS COLLEGE-QUAD CITIES',
    address: '1801 E. KIMBERLY ROAD, SUITE B',
    city: 'DAVENPORT',
    state: 'IA',
    zip: 52807,
    telephone: '(563) 344-1500',
    population: 76,
    county: 'SCOTT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rosseducation.edu/',
  },
  {
    name: 'BERGIN UNIVERSITY OF CANINE STUDIES',
    address: '10201 OLD REDWOOD HWY',
    city: 'PENNGROVE',
    state: 'CA',
    zip: 94951,
    telephone: '(707) 545-3647',
    population: 77,
    county: 'SONOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.berginu.edu/',
  },
  {
    name: 'TALMUDICAL ACADEMY-NEW JERSEY',
    address: '868 ROUTE 524',
    city: 'ADELPHIA',
    state: 'NJ',
    zip: 7710,
    telephone: '(732) 431-1600',
    population: 77,
    county: 'MONMOUTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://talmudicalacademynj.com/',
  },
  {
    name: 'DEVRY UNIVERSITY-NORTH CAROLINA',
    address: '2015 AYRSLEY TOWN BLVD., STE. 109',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28273,
    telephone: '(704) 697-1020',
    population: 78,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'BYZANTINE CATHOLIC SEMINARY OF SAINTS CYRIL AND METHODIUS',
    address: '3605 PERRYSVILLE AVENUE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15214,
    telephone: '(412) 321-8383',
    population: 79,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bcs.edu/',
  },
  {
    name: 'WINEBRENNER THEOLOGICAL SEMINARY',
    address: '950 NORTH MAIN STREET - 2ND FLOOR',
    city: 'FINDLAY',
    state: 'OH',
    zip: 45840,
    telephone: '(419) 434-4200',
    population: 79,
    county: 'HANCOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'winebrenner.edu/',
  },
  {
    name: 'CITY COLLEGE-MIAMI',
    address: '9300 S DADELAND BLVD., SUITE 200',
    city: 'MIAMI',
    state: 'FL',
    zip: 33156,
    telephone: '(305) 666-9242',
    population: 79,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.citycollege.edu/',
  },
  {
    name: 'YESHIVAT HECHAL SHEMUEL',
    address: '1532 EAST 10TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 336-2702',
    population: 80,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hechalshemuel.com/',
  },
  {
    name: 'CAROLINA CHRISTIAN COLLEGE',
    address: '4209 INDIANA AVENUE',
    city: 'WINSTON SALEM',
    state: 'NC',
    zip: 27105,
    telephone: '(336) 744-0900',
    population: 80,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.carolina.edu/',
  },
  {
    name: 'SOUTHWEST ACUPUNCTURE COLLEGE-BOULDER',
    address: '6630 GUNPARK DR SUITE 200',
    city: 'BOULDER',
    state: 'CO',
    zip: 80301,
    telephone: '(303) 581-9955',
    population: 80,
    county: 'BOULDER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acupuncturecollege.edu/',
  },
  {
    name: 'UNIVERSITY OF FORT LAUDERDALE',
    address: '4131 NW 16TH ST',
    city: 'LAUDERHILL',
    state: 'FL',
    zip: 33313,
    telephone: '(954) 486-7728',
    population: 80,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uftl.edu/',
  },
  {
    name: 'YESHIVA GEDOLA TIFERES YAAKOV YITZCHOK',
    address: '65 CROSS STREET',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 901-6703',
    population: 80,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivatyy.com',
  },
  {
    name: 'MIDWEST COLLEGE OF ORIENTAL MEDICINE-RACINE',
    address: '6232 BANKERS ROAD',
    city: 'RACINE',
    state: 'WI',
    zip: 53403,
    telephone: '(262) 554-2010',
    population: 80,
    county: 'RACINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acupuncture.edu/',
  },
  {
    name: 'ISLAND DRAFTING AND TECHNICAL INSTITUTE',
    address: '128 BROADWAY RTE 110',
    city: 'AMITYVILLE',
    state: 'NY',
    zip: 11701,
    telephone: '(631) 691-8733',
    population: 80,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.idti.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-DAYMAR COLLEGE BOWLING GREEN',
    address: '2421 FITZGERALD INDUSTRIAL DR.',
    city: 'BOWLING GREEN',
    state: 'KY',
    zip: 42101,
    telephone: '(717) 380-1385',
    population: 80,
    county: 'WARREN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daymarcollege.edu/',
  },
  {
    name: 'NORTHSHORE UNIVERSITY HEALTHSYSTEM SCHOOL OF NURSE ANESTHESIA',
    address: '2650 RIDGE AVE, RM G603C',
    city: 'EVANSTON',
    state: 'IL',
    zip: 60201,
    telephone: '(847) 570-1959',
    population: 81,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northshore.org/academics/other-programs/school-of-nurse-anesthesia/',
  },
  {
    name: 'TOYOTA TECHNOLOGICAL INSTITUTE AT CHICAGO',
    address: '6045 S. KENWOOD AVENUE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60637,
    telephone: '(773) 834-2500',
    population: 81,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ttic.edu/',
  },
  {
    name: 'ACADEMY FOR JEWISH RELIGION-CALIFORNIA',
    address: '574 HILGARD AVENUE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90024,
    telephone: '(213) 884-4133',
    population: 81,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ajrca.edu/',
  },
  {
    name: 'COLORADO ACADEMY OF VETERINARY TECHNOLOGY',
    address: '2766 JANITELL ROAD',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80906,
    telephone: '(719) 219-9636',
    population: 81,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cavt.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE TELSHE',
    address: '28400 EUCLID AVE',
    city: 'WICKLIFFE',
    state: 'OH',
    zip: 44092,
    telephone: '(440) 943-5300 EXT 22',
    population: 82,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'independentrabbinicalcolleges.org/index.html',
  },
  {
    name: "MECHON L'HOYROA",
    address: '168 MAPLE AVENUE',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 425-9565',
    population: 82,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mechonlhoyroa.com/',
  },
  {
    name: "YESHIVA D'MONSEY RABBINICAL COLLEGE",
    address: '2 ROMAN BLVD',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 352-5852',
    population: 83,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivadmonsey.com/',
  },
  {
    name: 'INTERNATIONAL COLLEGE OF BROADCASTING',
    address: '6 S SMITHVILLE RD',
    city: 'DAYTON',
    state: 'OH',
    zip: 45431,
    telephone: '(937) 258-8251',
    population: 83,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.icb.edu/',
  },
  {
    name: 'LATIN AMERICAN BIBLE INSTITUTE',
    address: '14209 EAST LOMITAS AVENUE',
    city: 'LA PUENTE',
    state: 'CA',
    zip: 91746,
    telephone: '(626) 968-1328',
    population: 84,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'labi.edu/',
  },
  {
    name: 'OAK VALLEY COLLEGE',
    address: '2759 AYALA DRIVE',
    city: 'RIALTO',
    state: 'CA',
    zip: 92377,
    telephone: '(909) 554-3814',
    population: 84,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://oakvalleycollege.org/',
  },
  {
    name: 'YESHIVA GEDOLA TIFERES YAAKOV YITZCHOK',
    address: '65 CROSS STREET',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 901-6703',
    population: 85,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivatyy.com/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY',
    address: '2950 S. GESSNER',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77063,
    telephone: '(713) 771-5336',
    population: 85,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/',
  },
  {
    name: 'YESHIVA CHEMDAS HATORAH',
    address: '950 MASSACHUSETTS AVENUE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 364-3949',
    population: 86,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.yeshivachemdashatorah.com/',
  },
  {
    name: 'YESHIVA GEDOLAH TIFERES BORUCH',
    address: '21 ROCKVIEW AVENUE',
    city: 'NORTH PLAINFIELD',
    state: 'NJ',
    zip: 7060,
    telephone: '(908) 753-2600',
    population: 86,
    county: 'SOMERSET',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivagedolahtiferesboruch.com/',
  },
  {
    name: 'RABBI JACOB JOSEPH SCHOOL',
    address: 'ONE PLAINFIELD AVE',
    city: 'EDISON',
    state: 'NJ',
    zip: 8817,
    telephone: '(732) 985-6533',
    population: 87,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rabbijacobjoseph.com/',
  },
  {
    name: 'GLASGOW CALEDONIAN NEW YORK COLLEGE',
    address: '64 WOOSTER STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10012,
    telephone: '(646) 768-5300',
    population: 87,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcnyc.com/',
  },
  {
    name: 'JUNG TAO SCHOOL OF CLASSICAL CHINESE MEDICINE',
    address: '207 DALE ADAMS ROAD',
    city: 'SUGAR GROVE',
    state: 'NC',
    zip: 28679,
    telephone: '(828) 297-4181',
    population: 87,
    county: 'WATAUGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jungtao.edu/',
  },
  {
    name: 'UNITED INTERNATIONAL COLLEGE',
    address: '3130 COMMERCE PARKWAY',
    city: 'MIRAMAR',
    state: 'FL',
    zip: 33025,
    telephone: '(954) 607-4344',
    population: 87,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unilatina.edu/',
  },
  {
    name: 'PUERTO RICO SCHOOL OF NURSE ANESTHETISTS',
    address: '656 PONCE DE LEON AVE FLOOR 1',
    city: 'HATO REY',
    state: 'PR',
    zip: 918,
    telephone: '(787) 998-8997',
    population: 87,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eeapr.org/',
  },
  {
    name: 'BUCKS COUNTY SCHOOL OF BEAUTY CULTURE INC',
    address: '1761 BUSTLETON PIKE',
    city: 'FEASTERVILLE',
    state: 'PA',
    zip: 19053,
    telephone: '(215) 322-0666',
    population: 87,
    county: 'BUCKS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bcsbc.edu/',
  },
  {
    name: 'SAINT VINCENT SEMINARY',
    address: '300 FRASER PURCHASE RD',
    city: 'LATROBE',
    state: 'PA',
    zip: 15650,
    telephone: '(724) 805-2395',
    population: 88,
    county: 'WESTMORELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.saintvincentseminary.edu/',
  },
  {
    name: 'CALIFORNIA JAZZ CONSERVATORY',
    address: '2087 ADDISON STREET',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 845-5373',
    population: 88,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cjc.edu/',
  },
  {
    name: 'YESHIVA GEDOLAH SHAAREI SHMUEL',
    address: '511 OCEAN AVENUE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 363-2164',
    population: 88,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivagedolahshaareishmuel.com/',
  },
  {
    name: 'SOUTHEASTERN BAPTIST COLLEGE',
    address: '4229 HWY 15 N',
    city: 'LAUREL',
    state: 'MS',
    zip: 39440,
    telephone: '(601) 426-6346',
    population: 89,
    county: 'JONES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.southeasternbaptist.edu/',
  },
  {
    name: 'WONGU UNIVERSITY OF ORIENTAL MEDICINE',
    address: '8620 SOUTH EASTERN AVENUE',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89123,
    telephone: '(702) 463-2122',
    population: 89,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wongu.edu/',
  },
  {
    name: 'THE GENERAL THEOLOGICAL SEMINARY',
    address: '440 WEST 21ST STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10011,
    telephone: '(212) 243-5150',
    population: 90,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gts.edu/',
  },
  {
    name: 'MAGDALEN COLLEGE',
    address: '511 KEARSARGE MOUNTAIN ROAD',
    city: 'WARNER',
    state: 'NH',
    zip: 3278,
    telephone: '(603) 456-2656',
    population: 90,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.magdalen.edu/',
  },
  {
    name: 'CORTIVA INSTITUTE-POMPANO',
    address: '2001 W SAMPLE RD STE 100',
    city: 'POMPANO BEACH',
    state: 'FL',
    zip: 33064,
    telephone: '(954) 922-5505',
    population: 90,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cortiva.edu/',
  },
  {
    name: 'WEST VIRGINIA JUNIOR COLLEGE-UNITED CAREER INSTITUTE',
    address: 'MOUNT BRADDOCK ROAD',
    city: 'MOUNT BRADDOCK',
    state: 'PA',
    zip: 15465,
    telephone: '(724) 437-4600',
    population: 90,
    county: 'FAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.piht.edu/',
  },
  {
    name: 'YESHIVA OF THE TELSHE ALUMNI',
    address: '4904 INDEPENDENCE AVE',
    city: 'RIVERDALE',
    state: 'NY',
    zip: 10471,
    telephone: '(718) 601-3523',
    population: 91,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivatelshealumni.com/',
  },
  {
    name: 'YESHIVA GEDOLAH OF WOODLAKE VILLAGE',
    address: '199 JOE PARKER ROAD',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 730-2808',
    population: 91,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaohrzechariah.com/',
  },
  {
    name: 'BEXLEY HALL SEABURY WESTERN THEOLOGICAL SEMINARY FEDERATION, INC.',
    address: '1407 EAST 60TH STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60637,
    telephone: '(773) 380-6780',
    population: 91,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bexleyseabury.edu/',
  },
  {
    name: 'RECONSTRUCTIONIST RABBINICAL COLLEGE',
    address: '1299 CHURCH RD',
    city: 'WYNCOTE',
    state: 'PA',
    zip: 19095,
    telephone: '(215) 576-0800',
    population: 91,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rrc.edu/',
  },
  {
    name: 'YELLOWSTONE CHRISTIAN COLLEGE',
    address: '1515 S. SHILOH ROAD',
    city: 'BILLINGS',
    state: 'MT',
    zip: 59106,
    telephone: '(406) 656-9950',
    population: 92,
    county: 'YELLOWSTONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yellowstonechristian.edu/',
  },
  {
    name: 'WELLSPRING SCHOOL OF ALLIED HEALTH-WICHITA',
    address: '650 N CARRIAGE PARKWAY, STE 55',
    city: 'WICHITA',
    state: 'KS',
    zip: 67208,
    telephone: '(913) 406-8072',
    population: 92,
    county: 'SEDGWICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wellspring.edu/',
  },
  {
    name: 'SAN DIEGO GLOBAL KNOWLEDGE UNIVERSITY',
    address: '1095 K STREET, SUITE B',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 934-0797',
    population: 93,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sdgku.edu',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-MADERA',
    address: '2185-J WEST CLEVELAND AVENUE',
    city: 'MADERA',
    state: 'CA',
    zip: 93637,
    telephone: '(559) 734-9000',
    population: 94,
    county: 'MADERA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sjvc.edu/',
  },
  {
    name: 'OMEGA GRADUATE SCHOOL',
    address: '500 OXFORD DRIVE',
    city: 'DAYTON',
    state: 'TN',
    zip: 37321,
    telephone: '(423) 775-6596',
    population: 95,
    county: 'RHEA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ogs.edu/',
  },
  {
    name: 'SAN FRANCISCO ART INSTITUTE',
    address: '800 CHESTNUT ST',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94133,
    telephone: '(415) 771-7020',
    population: 95,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfai.edu/',
  },
  {
    name: 'PONTIFICAL JOHN PAUL II INSTITUTE FOR STUDIES ON MARRIAGE AND FAMILY',
    address: '620 MICHIGAN AVE NE - MCGIVNEY HALL',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20064,
    telephone: '(202) 526-3799',
    population: 95,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.johnpaulii.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-DELANO',
    address: '1920 CECIL AVENUE',
    city: 'DELANO',
    state: 'CA',
    zip: 93215,
    telephone: '(559) 734-9000',
    population: 95,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sjvc.edu/',
  },
  {
    name: 'MORRISON INSTITUTE OF TECHNOLOGY',
    address: '701 PORTLAND AVE',
    city: 'MORRISON',
    state: 'IL',
    zip: 61270,
    telephone: '(815) 772-7218 EXT 201',
    population: 95,
    county: 'WHITESIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.morrisontech.edu/',
  },
  {
    name: 'LEARNET ACADEMY INC',
    address: '3251 WEST 6TH STREET, 2ND FLOOR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90020,
    telephone: '(213) 387-4242',
    population: 96,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.learnet.edu/',
  },
  {
    name: 'IRELL & MANELLA GRADUATE SCHOOL OF BIOLOGICAL SCIENCES AT CITY OF HOPE',
    address: '1500 EAST DUARTE ROAD',
    city: 'DUARTE',
    state: 'CA',
    zip: 91010,
    telephone: '(626) 256-4673',
    population: 96,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cityofhope.org/grad-school',
  },
  {
    name: 'KESER TORAH-MAYAN HATALMUD',
    address: '218 JOE PARKER ROAD',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 367-4259',
    population: 96,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mayanhatalmud.org/',
  },
  {
    name: 'BOSTON BAPTIST COLLEGE',
    address: '950 METROPOLITAN AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2136,
    telephone: '(617) 364-3510 EXT 0',
    population: 96,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'boston.edu/',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-PHOENIX',
    address: '16404 NORTH BLACK CANYON HIGHWAY',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85053,
    telephone: '(855) 706-8382',
    population: 97,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'POPE ST JOHN XXIII NATIONAL SEMINARY',
    address: '558 SOUTH AVE',
    city: 'WESTON',
    state: 'MA',
    zip: 2493,
    telephone: '(781) 899-5500',
    population: 97,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.psjs.edu/',
  },
  {
    name: 'BAIS MEDRASH ELYON',
    address: '73 MAIN STREET',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 356-7065',
    population: 97,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'baismedroshelyon.com/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-SANTA MARIA',
    address: '303 PLAZA DRIVE',
    city: 'SANTA MARIA',
    state: 'CA',
    zip: 93454,
    telephone: '(559) 734-9000',
    population: 97,
    county: 'SANTA BARBARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sjvc.edu/',
  },
  {
    name: 'CINCINNATI COLLEGE OF MORTUARY SCIENCE',
    address: '645 W NORTH BEND RD',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45224,
    telephone: '(513) 761-2020',
    population: 98,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccms.edu/',
  },
  {
    name: 'WELLSPRING SCHOOL OF ALLIED HEALTH-SPRINGFIELD',
    address: '229 EAST COMMERCIAL STREET',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65803,
    telephone: '(417) 863-7682',
    population: 98,
    county: 'GREENE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wellspring.edu/',
  },
  {
    name: 'COMPASS COLLEGE OF CINEMATIC ARTS',
    address: '41 SHELDON BLVD SE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49503,
    telephone: '(616) 988-1000',
    population: 99,
    county: 'KENT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'compass.edu/',
  },
  {
    name: 'ROSEDALE BIBLE COLLEGE',
    address: '2270 ROSEDALE RD',
    city: 'IRWIN',
    state: 'OH',
    zip: 43029,
    telephone: '(740) 857-1311',
    population: 99,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rosedale.edu/',
  },
  {
    name: 'UNION BIBLE COLLEGE',
    address: '434 S. UNION STREET',
    city: 'WESTFIELD',
    state: 'IN',
    zip: 46074,
    telephone: '(317) 896-9324',
    population: 100,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ubca.org/',
  },
  {
    name: 'DOMINICAN SCHOOL OF PHILOSOPHY & THEOLOGY',
    address: '2301 VINE STREET',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94708,
    telephone: '(510) 849-2030',
    population: 100,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.dspt.edu/',
  },
  {
    name: "ST BERNARD'S SCHOOL OF THEOLOGY AND MINISTRY",
    address: '120 FRENCH ROAD',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14618,
    telephone: '(585) 271-3657',
    population: 101,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stbernards.edu/',
  },
  {
    name: 'ECUMENICAL THEOLOGICAL SEMINARY',
    address: '2930 WOODWARD AVE',
    city: 'DETROIT',
    state: 'MI',
    zip: 48201,
    telephone: '(313) 831-5200',
    population: 102,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.etseminary.edu/',
  },
  {
    name: 'CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT DALLAS',
    address: '2101 WATERVIEW PARKWAY',
    city: 'RICHARDSON',
    state: 'TX',
    zip: 75080,
    telephone: '(469) 941-8380',
    population: 102,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/dallas/',
  },
  {
    name: 'AMERICAN BAPTIST COLLEGE',
    address: '1800 BAPTIST WORLD CTR DR',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37207,
    telephone: '(615) 256-1463',
    population: 102,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.abcnash.edu/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY-MORROW',
    address: '1580 SOUTHLAKE PARKWAY SUITE C',
    city: 'MORROW',
    state: 'GA',
    zip: 30260,
    telephone: '(770) 960-1298',
    population: 102,
    county: 'CLAYTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ict.edu/',
  },
  {
    name: 'EAST WEST COLLEGE OF NATURAL MEDICINE',
    address: '3808 N. TAMIAMI TR',
    city: 'SARASOTA',
    state: 'FL',
    zip: 34234,
    telephone: '(941) 355-9080 EXT 101',
    population: 103,
    county: 'SARASOTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ewcollege.edu/',
  },
  {
    name: 'ACADEMY FOR FIVE ELEMENT ACUPUNCTURE',
    address: '305 SE 2ND AVE',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32601,
    telephone: '(352) 335-2332',
    population: 104,
    county: 'ALACHUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acupuncturist.edu/',
  },
  {
    name: 'LAUREL TECHNICAL INSTITUTE',
    address: '11618 COTTON ROAD',
    city: 'MEADVILLE',
    state: 'PA',
    zip: 16335,
    telephone: '(814) 724-0700',
    population: 104,
    county: 'CRAWFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.laurel.edu/',
  },
  {
    name: 'WISCONSIN SCHOOL OF PROFESSIONAL PSYCHOLOGY',
    address: '9120 W HAMPTON AVE',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53225,
    telephone: '(414) 464-9777',
    population: 104,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wspp.edu/',
  },
  {
    name: 'THOMAS MORE COLLEGE OF LIBERAL ARTS',
    address: '6 MANCHESTER ST',
    city: 'MERRIMACK',
    state: 'NH',
    zip: 3054,
    telephone: '(603) 880-8308 EXT 18',
    population: 105,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.thomasmorecollege.edu/',
  },
  {
    name: 'ATA COLLEGE',
    address: '1810 GILLESPIE WAY, SUITE 104',
    city: 'EL CAJON',
    state: 'CA',
    zip: 92020,
    telephone: '(619) 596-2766',
    population: 105,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.advancedtraining.edu/',
  },
  {
    name: 'SANTA BARBARA BUSINESS COLLEGE-SANTA MARIA',
    address: '303 E PLAZA DR STE 1',
    city: 'SANTA MARIA',
    state: 'CA',
    zip: 93454,
    telephone: '(559) 734-9000',
    population: 105,
    county: 'SANTA BARBARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sbbcollege.edu/',
  },
  {
    name: 'SAN DIEGO GLOBAL KNOWLEDGE UNIVERSITY',
    address: '1095 K STREET, SUITE B',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 934-0797',
    population: 106,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sdgku.edu/',
  },
  {
    name: 'BETHANY THEOLOGICAL SEMINARY',
    address: '615 NATIONAL RD W',
    city: 'RICHMOND',
    state: 'IN',
    zip: 47374,
    telephone: '(765) 983-1800 EXT 1808',
    population: 106,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bethanyseminary.edu/',
  },
  {
    name: 'DAVIS COLLEGE',
    address: '1 CHRISFIELD AVENUE',
    city: 'JOHNSON CITY',
    state: 'NY',
    zip: 13790,
    telephone: '(607) 729-1581',
    population: 107,
    county: 'BROOME',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.davisny.edu/',
  },
  {
    name: 'YESHIVAS EMEK HATORAH',
    address: '395 KENT ROAD',
    city: 'HOWELL',
    state: 'NJ',
    zip: 7731,
    telephone: '(732) 367-1289',
    population: 107,
    county: 'MONMOUTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivasemekhatorah.com/',
  },
  {
    name: 'WILLIAMSON CHRISTIAN COLLEGE',
    address: '274 MALLORY STATION RD.',
    city: 'FRANKLIN',
    state: 'TN',
    zip: 37067,
    telephone: '(615) 771-7821',
    population: 108,
    county: 'WILLIAMSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.williamsoncc.edu/',
  },
  {
    name: 'ALLEGHENY WESLEYAN COLLEGE',
    address: '2161 WOODSDALE RD',
    city: 'SALEM',
    state: 'OH',
    zip: 44460,
    telephone: '(330) 337-6403 EXT 170',
    population: 108,
    county: 'COLUMBIANA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'awc.edu/',
  },
  {
    name: 'OHR HAMEIR THEOLOGICAL SEMINARY',
    address: '141 FURNACE WOODS RD',
    city: 'PEEKSKILL',
    state: 'NY',
    zip: 10566,
    telephone: '(914) 736-1500',
    population: 109,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ohrhameir.com/',
  },
  {
    name: 'YESHIVA SHAAR EPHRAIM',
    address: '178 MAPLE AVENUE',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 426-3116',
    population: 109,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'shaarephraim.org/',
  },
  {
    name: 'ESCUELA DE TROQUELERIA Y HERRAMENTAJE',
    address: '150 RD 174 URB INDUSTRIAL MINILLAS',
    city: 'BAYAMON',
    state: 'PR',
    zip: 959,
    telephone: '(787) 786-1834',
    population: 110,
    county: 'BAYAMÓN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'escuelatroqueleria.jimdo.com/',
  },
  {
    name: 'THE SANTA BARBARA AND VENTURA COLLEGES OF LAW AT SANTA BARBARA',
    address: '20 E VICTORIA ST',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93101,
    telephone: '(805) 979-9860',
    population: 111,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.collegesoflaw.edu/',
  },
  {
    name: 'ST. JOHN VIANNEY COLLEGE SEMINARY',
    address: '2900 SW 87TH AVE',
    city: 'MIAMI',
    state: 'FL',
    zip: 33165,
    telephone: '(305) 223-4561 EXT 110',
    population: 112,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjvcs.edu/',
  },
  {
    name: 'INTERNATIONAL BAPTIST COLLEGE AND SEMINARY',
    address: '2211 W GERMANN ROAD',
    city: 'CHANDLER',
    state: 'AZ',
    zip: 85286,
    telephone: '(480) 245-7903',
    population: 113,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ibcs.edu/ibc/',
  },
  {
    name: 'PROFESSIONAL GOLFERS CAREER COLLEGE',
    address: '26109 YNEZ ROAD',
    city: 'TEMECULA',
    state: 'CA',
    zip: 92591,
    telephone: '(800) 877-4380',
    population: 113,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.golfcollege.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-HANFORD CLASSROOM',
    address: '215 WEST 7TH STREET',
    city: 'HANFORD',
    state: 'CA',
    zip: 93230,
    telephone: '(559) 734-9000',
    population: 113,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'BETH HAMEDRASH SHAAREI YOSHER INSTITUTE',
    address: '4102 16TH AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11204,
    telephone: '(718) 854-2290',
    population: 114,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'bhsy.edu/',
  },
  {
    name: 'ROSS COLLEGE-HOPKINSVILLE',
    address: '4001 FORT CAMPBELL BOULEVARD',
    city: 'HOPKINSVILLE',
    state: 'KY',
    zip: 42240,
    telephone: '(270) 886-1302',
    population: 114,
    county: 'CHRISTIAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rosseducation.edu/',
  },
  {
    name: 'STACEY JAMES INSTITUTE',
    address: '16534 KEYSTONE BOULEVARD, UNIT C',
    city: 'PARKER',
    state: 'CO',
    zip: 80134,
    telephone: '(303) 810-1033',
    population: 114,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.staceyjamesinstitute.com/',
  },
  {
    name: 'KD CONSERVATORY COLLEGE OF FILM AND DRAMATIC ARTS',
    address: '2600 STEMMONS FWY STE 117',
    city: 'DALLAS',
    state: 'TX',
    zip: 75207,
    telephone: '(214) 638-0484',
    population: 115,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kdstudio.com/',
  },
  {
    name: 'ADVANCED COLLEGE',
    address: '13180 PARAMOUNT BLVD.',
    city: 'SOUTH GATE',
    state: 'CA',
    zip: 90280,
    telephone: '(562) 408-6969',
    population: 115,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.advancedcollege.edu/',
  },
  {
    name: 'COLORADO SCHOOL OF TRADES',
    address: '1575 HOYT ST',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80215,
    telephone: '(303) 233-4697 EXT 45',
    population: 115,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://schooloftrades.edu/about',
  },
  {
    name: 'YESHIVA SHAAREI TORAH OF ROCKLAND',
    address: '91 W CARLTON RD',
    city: 'SUFFERN',
    state: 'NY',
    zip: 10901,
    telephone: '(845) 352-3431 EXT 0',
    population: 116,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.yst.edu/',
  },
  {
    name: 'CHAMPION CHRISTIAN COLLEGE',
    address: '600 GARLAND AVENUE',
    city: 'HOT SPRINGS',
    state: 'AR',
    zip: 71913,
    telephone: '(501) 623-2272',
    population: 116,
    county: 'GARLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'championchristiancollege.com/',
  },
  {
    name: 'NORTHERN PENNSYLVANIA REGIONAL COLLEGE',
    address: '300 2ND AVENUE, SUITE 500',
    city: 'WARREN',
    state: 'PA',
    zip: 16365,
    telephone: '(814) 230-9010',
    population: 116,
    county: 'WARREN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://regionalcollegepa.org/',
  },
  {
    name: 'STARR KING SCHOOL FOR THE MINISTRY',
    address: '5000 MACARTHUR BLVD',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94613,
    telephone: '(510) 845-6232',
    population: 117,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sksm.edu/',
  },
  {
    name: 'KENTUCKY MOUNTAIN BIBLE COLLEGE',
    address: '855 HWY 541',
    city: 'JACKSON',
    state: 'KY',
    zip: 41339,
    telephone: '(606) 693-5000 EXT 100',
    population: 117,
    county: 'BREATHITT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kmbc.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-HAWAII',
    address: '949 KAOKILA BLVD',
    city: 'KAPOLEI',
    state: 'HI',
    zip: 96707,
    telephone: '(866) 766-0766',
    population: 117,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'FLORIDA COLLEGE OF INTEGRATIVE MEDICINE',
    address: '7100 LAKE ELLENOR DR',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32809,
    telephone: '(407) 888-8689',
    population: 117,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fcim.edu/',
  },
  {
    name: 'CAREER QUEST LEARNING CENTERS-JACKSON',
    address: '209 E WASHINGTON AVE, STE 241',
    city: 'JACKSON',
    state: 'MI',
    zip: 49201,
    telephone: '(517) 990-9595',
    population: 118,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.careerquest.edu/',
  },
  {
    name: 'CAMBRIDGE JUNIOR COLLEGE-YUBA CITY',
    address: '939 LIVE OAK BLVD',
    city: 'YUBA CITY',
    state: 'CA',
    zip: 95991,
    telephone: '(530) 674-9199',
    population: 118,
    county: 'SUTTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cambridge.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-RANCHO MIRAGE',
    address: '34275 MONTEREY AVENUE',
    city: 'RANCHO MIRAGE',
    state: 'CA',
    zip: 92270,
    telephone: '(559) 734-9000',
    population: 118,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sjvc.edu/',
  },
  {
    name: 'DIVINE WORD COLLEGE',
    address: '102 JACOBY DR SW',
    city: 'EPWORTH',
    state: 'IA',
    zip: 52045,
    telephone: '(563) 876-3353',
    population: 119,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dwci.edu/',
  },
  {
    name: 'YESHIVA SHAAR HATORAH',
    address: '117-06 84 AVE',
    city: 'KEW GARDENS',
    state: 'NY',
    zip: 11418,
    telephone: '(718) 846-1940 EXT 110',
    population: 119,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'shaarhatorah.edu/',
  },
  {
    name: 'PONTIFICAL FACULTY OF THE IMMACULATE CONCEPTION AT THE DOMINICAN HOUSE OF STUDIES',
    address: '487 MICHIGAN AVE, NE',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20017,
    telephone: '(202) 495-3820',
    population: 119,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dhs.edu/',
  },
  {
    name: 'FINE MORTUARY COLLEGE',
    address: '150 KERRY PLACE',
    city: 'NORWOOD',
    state: 'MA',
    zip: 2062,
    telephone: '(781) 762-1211 EXT 22',
    population: 119,
    county: 'NORFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fmc.edu/',
  },
  {
    name: 'SOUTHEASTERN FREE WILL BAPTIST BIBLE COLLEGE',
    address: '532 EAGLE ROCK ROAD',
    city: 'WENDELL',
    state: 'NC',
    zip: 27591,
    telephone: '(919) 365-7711 EXT 100',
    population: 120,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfwbc.edu/',
  },
  {
    name: 'MEADVILLE LOMBARD THEOLOGICAL SCHOOL',
    address: '610 S. MICHIGAN AVENUE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(773) 256-3000',
    population: 120,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.meadville.edu/',
  },
  {
    name: 'TELSHE YESHIVA-CHICAGO',
    address: '3535 WEST FOSTER',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60625,
    telephone: '(773) 463-7738',
    population: 121,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://telsheyeshivachicago.com/',
  },
  {
    name: 'SAINT LOUIS CHRISTIAN COLLEGE',
    address: '1360 GRANDVIEW DR',
    city: 'FLORISSANT',
    state: 'MO',
    zip: 63033,
    telephone: '(314) 837-6777',
    population: 121,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stlchristian.edu/',
  },
  {
    name: 'YESHIVA GEDOLAH OF CLIFFWOOD',
    address: '200 CENTER STREET',
    city: 'KEYPORT',
    state: 'NJ',
    zip: 7735,
    telephone: '(732) 765-9126',
    population: 122,
    county: 'MONMOUTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivagedolahcliffwood.com/',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '1444 ENTERTAINMENT AVENUE',
    city: 'BOISE',
    state: 'ID',
    zip: 83709,
    telephone: '(208) 383-4540 EXT 31352',
    population: 122,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'AMERICAN CONSERVATORY THEATER',
    address: '415 GEARY STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94102,
    telephone: '(415) 834-3200 EXT 2400',
    population: 122,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.act-sf.org/',
  },
  {
    name: 'CHURCH DIVINITY SCHOOL OF THE PACIFIC',
    address: '2451 RIDGE ROAD',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94709,
    telephone: '(510) 204-0700',
    population: 122,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cdsp.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF THE BUILDING ARTS',
    address: '649 MEETING STREET',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29403,
    telephone: '(843) 577-5245',
    population: 122,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'acba.edu/',
  },
  {
    name: 'AMERICAN INSTITUTE OF HEALTHCARE & TECHNOLOGY',
    address: '480 LORDSHIP BOULEVARD',
    city: 'STRATFORD',
    state: 'CT',
    zip: 6615,
    telephone: '(203) 870-8400',
    population: 122,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aiht.edu/',
  },
  {
    name: 'CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY - COLLEGE OF NURSING',
    address: '2101 WATERVIEW PKWY',
    city: 'RICHARDSON',
    state: 'TX',
    zip: 75080,
    telephone: '(469) 941-8300',
    population: 122,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.dni.edu/',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT SAN DIEGO',
    address: '401 W. A STREET AT 1 COLUMBIA PLACE',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 541-4500',
    population: 123,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/san-diego/',
  },
  {
    name: 'COLLEGE OF BUSINESS AND TECHNOLOGY-MAIN CAMPUS',
    address: '8230 W FLAGLER ST.',
    city: 'MIAMI',
    state: 'FL',
    zip: 33144,
    telephone: '(305) 273-4499 EXT 200',
    population: 123,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cbt.edu/',
  },
  {
    name: 'ST JOSEPH SCHOOL OF NURSING',
    address: '5 WOODWARD AVE',
    city: 'NASHUA',
    state: 'NH',
    zip: 3060,
    telephone: '(603) 884-4643',
    population: 124,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjson.edu/',
  },
  {
    name: 'MARIANO MORENO CULINARY INSTITUTE',
    address: '2135 CORAL WAY',
    city: 'MIAMI',
    state: 'FL',
    zip: 33145,
    telephone: '(305) 858-0561',
    population: 124,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mmci.edu.com/',
  },
  {
    name: 'ACADEMY COLLEGE',
    address: '1600 W. 82ND STREET, SUITE 100',
    city: 'BLOOMINGTON',
    state: 'MN',
    zip: 55431,
    telephone: '(952) 851-0066',
    population: 125,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.academycollege.edu/',
  },
  {
    name: 'NORTHWEST COLLEGE OF ART & DESIGN',
    address: '1126 PACIFIC AVENUE, SUITE 101',
    city: 'TACOMA',
    state: 'WA',
    zip: 98402,
    telephone: '(253) 272-1126',
    population: 125,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ncad.edu/',
  },
  {
    name: 'VALLEY COLLEGE-BECKLEY',
    address: '120 NEW RIVER TOWN CENTER',
    city: 'BECKLEY',
    state: 'WV',
    zip: 25801,
    telephone: '(304) 252-9547',
    population: 125,
    county: 'RALEIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.valley.edu/',
  },
  {
    name: 'KEWEENAW BAY OJIBWA COMMUNITY COLLEGE',
    address: '111 BEARTOWN ROAD',
    city: 'BARAGA',
    state: 'MI',
    zip: 49908,
    telephone: '(906) 524-8400',
    population: 125,
    county: 'BARAGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kbocc.edu/',
  },
  {
    name: 'SAGINAW CHIPPEWA TRIBAL COLLEGE',
    address: '2274 ENTERPRISE DR',
    city: 'MOUNT PLEASANT',
    state: 'MI',
    zip: 48858,
    telephone: '(989) 317-4760',
    population: 126,
    county: 'ISABELLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sagchip.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-PHILADELPHIA',
    address: '1500 SPRING GARDEN STREET STE. 101',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19130,
    telephone: '(717) 380-1385',
    population: 126,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hussiancollege.edu/',
  },
  {
    name: 'ST LOUIS COLLEGE OF HEALTH CAREERS-ST LOUIS',
    address: '909 SOUTH TAYLOR AVENUE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63110,
    telephone: '(314) 652-0300 EXT 2528',
    population: 126,
    county: 'ST. LOUIS CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.slchc.edu/',
  },
  {
    name: 'MONTEFIORE SCHOOL OF NURSING',
    address: '53 VALENTINE STREET',
    city: 'MOUNT VERNON',
    state: 'NY',
    zip: 10550,
    telephone: '(914) 361-6537',
    population: 126,
    county: 'WESTCHESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.montefiorehs.org/body.cfm?id=34',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-ELLSWORTH AFB EXTENSION',
    address: '1000 ELLSWORTH STREET, SUITE 2400-B',
    city: 'ELLSWORTH AIR FORCE BASE',
    state: 'SD',
    zip: 57706,
    telephone: '(605) 718-6550',
    population: 127,
    county: 'PENNINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/ellsworth-afb/',
  },
  {
    name: 'YESHIVA SHOLOM SHACHNA',
    address: '401 ELMWOOD AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 253-1664',
    population: 127,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivasholomshachna.com/',
  },
  {
    name: 'OHIO BUSINESS COLLEGE-SANDUSKY',
    address: '5202 TIMBER COMMONS DRIVE',
    city: 'SANDUSKY',
    state: 'OH',
    zip: 44870,
    telephone: '(419) 627-8345 EXT 2210',
    population: 127,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ohiobusinesscollege.edu/',
  },
  {
    name: 'COCHRAN SCHOOL OF NURSING',
    address: "967 NORTH BROADWAY-ANDRUS PAVILLION-SAINT JOHN'S RIVERSIDE, HOSP",
    city: 'YONKERS',
    state: 'NY',
    zip: 10701,
    telephone: '(914) 964-4296',
    population: 128,
    county: 'WESTCHESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cochranschoolofnursing.us/',
  },
  {
    name: 'FAIRFAX UNIVERSITY OF AMERICA',
    address: '4401 VILLAGE DRIVE',
    city: 'FAIRFAX',
    state: 'VA',
    zip: 22030,
    telephone: '(703) 591-7042',
    population: 129,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fxua.edu/',
  },
  {
    name: 'STEVENS-THE INSTITUTE OF BUSINESS & ARTS',
    address: '1521 WASHINGTON AVENUE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63103,
    telephone: '(314) 421-0949 EXT 1101',
    population: 129,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.siba.edu/',
  },
  {
    name: 'LOUISIANA CULINARY INSTITUTE',
    address: '10550 AIRLINE HWY',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70816,
    telephone: '(225) 769-8820',
    population: 130,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lci.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF THE BUILDING ARTS',
    address: '649 MEETING STREET',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29403,
    telephone: '(843) 577-5245',
    population: 131,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'acba.edu',
  },
  {
    name: 'TAYLOR BUSINESS INSTITUTE',
    address: '180 NORTH WABASH AVENUE, FIFTH FLOOR',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60601,
    telephone: '(312) 658-5100',
    population: 131,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tbiil.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-DAYMAR COLLEGE COLUMBUS',
    address: '2745 WINCHESTER PIKE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43232,
    telephone: '(717) 380-1385',
    population: 131,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daymarcollege.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-COLORADO',
    address: '1870 W. 122ND AVE.',
    city: 'WESTMINSTER',
    state: 'CO',
    zip: 80234,
    telephone: '(303) 280-7400',
    population: 132,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'SAINT VLADIMIRS ORTHODOX THEOLOGICAL SEMINARY',
    address: '575 SCARSDALE RD',
    city: 'YONKERS',
    state: 'NY',
    zip: 10707,
    telephone: '(914) 961-8313',
    population: 132,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.svots.edu/',
  },
  {
    name: 'VALLEY FORGE MILITARY COLLEGE',
    address: '1001 EAGLE RD',
    city: 'WAYNE',
    state: 'PA',
    zip: 19087,
    telephone: '(610) 989-1450',
    population: 132,
    county: 'DELAWARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vfmac.edu/',
  },
  {
    name: 'XAVIER COLLEGE SCHOOL OF NURSING',
    address: '1340 NORTH EL DORADO STREET',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95202,
    telephone: '(209) 941-0968',
    population: 133,
    county: 'SAN JOAQUIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.xavier-college.com/',
  },
  {
    name: 'TEXAS HEALTH AND SCIENCE UNIVERSITY',
    address: '4005 MENCHACA RD',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78704,
    telephone: '(512) 444-8082',
    population: 133,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thsu.edu/',
  },
  {
    name: 'FINGER LAKES HEALTH COLLEGE OF NURSING & HEALTH SCIENCES',
    address: '196 NORTH STREET',
    city: 'GENEVA',
    state: 'NY',
    zip: 14456,
    telephone: '(315) 787-4005',
    population: 133,
    county: 'ONTARIO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.flhcon.edu/',
  },
  {
    name: 'CENTURA COLLEGE-VIRGINIA BEACH',
    address: '2697 DEAN DR. STE. 100',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23452,
    telephone: '(757) 340-2121 EXT 310',
    population: 133,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.centuracollege.edu/campuses/virginia-beach/',
  },
  {
    name: 'COLUMBIA INSTITUTE',
    address: '12125 VEIRS MILL RD.',
    city: 'SILVER SPRING',
    state: 'MD',
    zip: 20906,
    telephone: '(301) 929-0565',
    population: 133,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccdc.edu/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY-CENTRO UNIVERSITARIO DE SAN JUAN',
    address: 'CALLE ROSALES, ESQ SAN ANTONIO PARADA 26 1/2',
    city: 'SANTURCE',
    state: 'PR',
    zip: 914,
    telephone: '(787) 840-2575 EXT 4824',
    population: 134,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.psm.edu/',
  },
  {
    name: 'BOISE BIBLE COLLEGE',
    address: '8695 W MARIGOLD ST',
    city: 'BOISE',
    state: 'ID',
    zip: 83714,
    telephone: '(208) 376-7731',
    population: 134,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://boisebible.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE OHR YISROEL',
    address: '8800 SEAVIEW AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11236,
    telephone: '(718) 633-4715',
    population: 134,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rabbinicalcollegeohryisroel.com/',
  },
  {
    name: 'TRIANGLE TECH INC-PITTSBURGH',
    address: '1940 PERRYSVILLE AVENUE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15214,
    telephone: '(412) 359-1000 EXT 7198',
    population: 134,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triangle-tech.edu/',
  },
  {
    name: 'SEATTLE FILM INSTITUTE',
    address: '3210 16TH AVENUE W',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98119,
    telephone: '(206) 568-4387',
    population: 136,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sfi.edu/#fronttable',
  },
  {
    name: 'PLATT COLLEGE-SAN DIEGO',
    address: '6250 EL CAJON BLVD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92115,
    telephone: '(619) 265-0107',
    population: 136,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.platt.edu/',
  },
  {
    name: 'DAVIS COLLEGE',
    address: '433 N. SUMMIT STREET STE. 202',
    city: 'TOLEDO',
    state: 'OH',
    zip: 43604,
    telephone: '(419) 473-2700',
    population: 136,
    county: 'LUCAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daviscollege.edu/',
  },
  {
    name: 'BAPTIST MISSIONARY ASSOCIATION THEOLOGICAL SEMINARY',
    address: '1530 E PINE ST',
    city: 'JACKSONVILLE',
    state: 'TX',
    zip: 75766,
    telephone: '(903) 586-2501',
    population: 137,
    county: 'CHEROKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bmats.edu/',
  },
  {
    name: 'KENRICK GLENNON SEMINARY',
    address: '5200 GLENNON DR',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63119,
    telephone: '(314) 792-6100',
    population: 137,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kenrick.edu/',
  },
  {
    name: 'JOSE MARIA VARGAS UNIVERSITY',
    address: '10131 PINES BOULEVARD',
    city: 'PEMBROKE PINES',
    state: 'FL',
    zip: 33026,
    telephone: '(954) 322-4460 EXT 106',
    population: 137,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jmvu.edu/',
  },
  {
    name: 'COLORADO SCHOOL OF TRADITIONAL CHINESE MEDICINE',
    address: '1441 YORK ST STE 302',
    city: 'DENVER',
    state: 'CO',
    zip: 80206,
    telephone: '(303) 329-6355',
    population: 138,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cstcm.edu/',
  },
  {
    name: "SAINT JOHN'S SEMINARY",
    address: '127 LAKE STREET',
    city: 'BRIGHTON',
    state: 'MA',
    zip: 2135,
    telephone: '(617) 254-2610',
    population: 138,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjs.edu/',
  },
  {
    name: 'SOUTHWESTERN CHRISTIAN COLLEGE',
    address: '200 BOWSER CIRCLE',
    city: 'TERRELL',
    state: 'TX',
    zip: 75160,
    telephone: '(972) 524-3341 EXT 107',
    population: 139,
    county: 'KAUFMAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swcc.edu/',
  },
  {
    name: 'PACIFIC SCHOOL OF RELIGION',
    address: '1798 SCENIC AVE',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94709,
    telephone: '(510) 849-8200',
    population: 139,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.psr.edu/',
  },
  {
    name: 'CARIS COLLEGE',
    address: '2780 JEFFERSON CENTRE WAY, SUITE 103',
    city: 'JEFFERSONVILLE',
    state: 'IN',
    zip: 47130,
    telephone: '(812) 258-9510',
    population: 139,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cariscollege.edu/',
  },
  {
    name: 'PLATT COLLEGE-OKC-MEMORIAL',
    address: '2727 W. MEMORIAL RD',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73134,
    telephone: '(405) 749-2433',
    population: 139,
    county: 'OKLAHOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.plattcolleges.edu/',
  },
  {
    name: 'HOPE COLLEGE OF ARTS AND SCIENCES',
    address: '1200 SOUTH WEST 3RD STREET',
    city: 'POMPANO BEACH',
    state: 'FL',
    zip: 33069,
    telephone: '(954) 532-9614',
    population: 140,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hcas.edu/',
  },
  {
    name: 'OAK HILLS CHRISTIAN COLLEGE',
    address: '1600 OAK HILLS RD SW',
    city: 'BEMIDJI',
    state: 'MN',
    zip: 56601,
    telephone: '(218) 751-8670',
    population: 140,
    county: 'BELTRAMI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oakhills.edu/',
  },
  {
    name: 'LEXINGTON THEOLOGICAL SEMINARY',
    address: '230 LEXINGTON GREEN CIRCLE, SUITE 300',
    city: 'LEXINGTON',
    state: 'KY',
    zip: 40503,
    telephone: '(859) 252-0361',
    population: 141,
    county: 'FAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lextheo.edu/',
  },
  {
    name: 'SAINT MICHAEL COLLEGE OF ALLIED HEALTH',
    address: '1106 BLADENSBURG ROAD NE',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20002,
    telephone: '(703) 746-8708',
    population: 141,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.smcah.edu/',
  },
  {
    name: 'SOUTHSIDE COLLEGE OF HEALTH SCIENCES',
    address: '430 CLAIRMONT COURT - SUITE 200',
    city: 'COLONIAL HEIGHTS',
    state: 'VA',
    zip: 23834,
    telephone: '(804) 765-5800',
    population: 141,
    county: 'COLONIAL HEIGHTS CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.srmconline.com/',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-FORT LAUDERDALE',
    address: '600 CORPORATE DRIVE SUITE 200',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33334,
    telephone: '(855) 706-8382',
    population: 142,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'HERITAGE CHRISTIAN UNIVERSITY',
    address: '3625 HELTON DR',
    city: 'FLORENCE',
    state: 'AL',
    zip: 35630,
    telephone: '(256) 766-6610',
    population: 142,
    county: 'LAUDERDALE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hcu.edu/',
  },
  {
    name: 'RENSSELAER AT HARTFORD',
    address: '275 WINDSOR ST',
    city: 'HARTFORD',
    state: 'CT',
    zip: 6120,
    telephone: '(860) 548-2400',
    population: 142,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ewp.rpi.edu/index.html',
  },
  {
    name: 'MASON ANTHONY SCHOOL OF COSMETOLOGY ARTS & SCIENCES',
    address: '5405 ROBERTS ROAD',
    city: 'HILLIARD',
    state: 'OH',
    zip: 43026,
    telephone: '(614) 710-1025',
    population: 142,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.masonanthony.com/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-NEVADA',
    address: '3755 BREAKTHROUGH WAY',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89135,
    telephone: '(866) 766-0766',
    population: 143,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'MIAMI MEDIA SCHOOL',
    address: '7955 NW 12 STREET SUITE 119',
    city: 'DORAL',
    state: 'FL',
    zip: 33126,
    telephone: '(305) 728-1120',
    population: 143,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://beonair.com/',
  },
  {
    name: 'REMINGTON COLLEGE-BATON ROUGE CAMPUS',
    address: '4520 SOUTH SHERWOOD FORREST BOULEVARD',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70816,
    telephone: '(225) 236-3200',
    population: 143,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/baton-rouge-career-college',
  },
  {
    name: 'YESHIVA KARLIN STOLIN',
    address: '1818 54TH ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11204,
    telephone: '(718) 232-7800',
    population: 144,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivakarlinstolin.org/',
  },
  {
    name: 'WEST VIRGINIA JUNIOR COLLEGE-BRIDGEPORT',
    address: '176 THOMPSON DR.',
    city: 'BRIDGEPORT',
    state: 'WV',
    zip: 26330,
    telephone: '(304) 842-4007',
    population: 144,
    county: 'HARRISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wvjc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-PARKSIDE FLEX',
    address: '900 WOOD RD',
    city: 'KENOSHA',
    state: 'WI',
    zip: 53141,
    telephone: '(877) 895-3276',
    population: 145,
    county: 'KENOSHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://flex.wisconsin.edu/',
  },
  {
    name: 'WEBB INSTITUTE',
    address: '298 CRESCENT BEACH RD',
    city: 'GLEN COVE',
    state: 'NY',
    zip: 11542,
    telephone: '(516) 671-8355',
    population: 145,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.webb.edu/',
  },
  {
    name: 'TALMUDICAL YESHIVA OF PHILADELPHIA',
    address: '6063 DREXEL RD',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19131,
    telephone: '(215) 477-1000',
    population: 146,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.meterware.com/typ/Talmudical_Yeshiva_of_Philadelphia/NetPriceCalculator/',
  },
  {
    name: 'HAMILTON TECHNICAL COLLEGE',
    address: '1011 E 53RD ST',
    city: 'DAVENPORT',
    state: 'IA',
    zip: 52807,
    telephone: '(563) 386-3570',
    population: 146,
    county: 'SCOTT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hamiltontechcollege.edu/',
  },
  {
    name: 'NASHOTAH HOUSE',
    address: '2777 MISSION RD',
    city: 'NASHOTAH',
    state: 'WI',
    zip: 53058,
    telephone: '(262) 646-6500',
    population: 146,
    county: 'WAUKESHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nashotah.edu/',
  },
  {
    name: 'CAREERS UNLIMITED',
    address: '1176 SOUTH 1480 WEST',
    city: 'OREM',
    state: 'UT',
    zip: 84058,
    telephone: '(801) 426-8234',
    population: 146,
    county: 'UTAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucdh.edu/',
  },
  {
    name: 'ELIM BIBLE INSTITUTE AND COLLEGE',
    address: '7245 COLLEGE STREET',
    city: 'LIMA',
    state: 'NY',
    zip: 14485,
    telephone: '(585) 582-1230',
    population: 146,
    county: 'LIVINGSTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.elim.edu/',
  },
  {
    name: 'URSHAN GRADUATE SCHOOL OF THEOLOGY',
    address: '1151 CENTURY TEL DRIVE',
    city: 'WENTZVILLE',
    state: 'MO',
    zip: 63385,
    telephone: '(314) 838-8858',
    population: 147,
    county: 'ST. CHARLES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ugst.edu/',
  },
  {
    name: 'SAINT PAUL SCHOOL OF THEOLOGY',
    address: '13720 ROE AVENUE',
    city: 'LEAWOOD',
    state: 'KS',
    zip: 66224,
    telephone: '(913) 253-5000',
    population: 147,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.spst.edu/',
  },
  {
    name: 'HIGH TECH HIGH GRADUATE SCHOOL OF EDUCATION',
    address: '2861 WOMBLE ROAD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92106,
    telephone: '(619) 398-4902',
    population: 147,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hthgse.edu/',
  },
  {
    name: 'ACADEMY OF CHINESE CULTURE AND HEALTH SCIENCES',
    address: '1600 BROADWAY, STE. 200',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94612,
    telephone: '(510) 763-7787 EXT 0',
    population: 147,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acchs.edu/',
  },
  {
    name: 'DELAWARE COLLEGE OF ART AND DESIGN',
    address: '600 N MARKET ST',
    city: 'WILMINGTON',
    state: 'DE',
    zip: 19801,
    telephone: '(302) 622-8000',
    population: 147,
    county: 'NEW CASTLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dcad.edu/',
  },
  {
    name: "ST. JOHN'S COLLEGE-DEPARTMENT OF NURSING",
    address: '729 E. CARPENTER ST',
    city: 'SPRINGFIELD',
    state: 'IL',
    zip: 62702,
    telephone: '(217) 525-5628',
    population: 148,
    county: 'SANGAMON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sjcs.edu/',
  },
  {
    name: 'PARDEE RAND GRADUATE SCHOOL',
    address: '1776 MAIN ST',
    city: 'SANTA MONICA',
    state: 'CA',
    zip: 90401,
    telephone: '(310) 393-0411 EXT 8405',
    population: 149,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.prgs.edu/',
  },
  {
    name: 'ANABAPTIST MENNONITE BIBLICAL SEMINARY',
    address: '3003 BENHAM AVE',
    city: 'ELKHART',
    state: 'IN',
    zip: 46517,
    telephone: '(574) 295-3726',
    population: 149,
    county: 'ELKHART',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ambs.edu/',
  },
  {
    name: 'RED LAKE NATION COLLEGE',
    address: '15480 MIGIZI DRIVE',
    city: 'RED LAKE',
    state: 'MN',
    zip: 56671,
    telephone: '(218) 679-2860',
    population: 149,
    county: 'BELTRAMI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rlnc.education/',
  },
  {
    name: 'SACRED HEART SEMINARY AND SCHOOL OF THEOLOGY',
    address: '7335 S HWY 100',
    city: 'FRANKLIN',
    state: 'WI',
    zip: 53132,
    telephone: '(414) 425-8300',
    population: 150,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shsst.edu/',
  },
  {
    name: 'MID-AMERICA COLLEGE OF FUNERAL SERVICE',
    address: '3111 HAMBURG PKE',
    city: 'JEFFERSONVILLE',
    state: 'IN',
    zip: 47130,
    telephone: '(812) 288-8878',
    population: 150,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mid-america.edu/',
  },
  {
    name: 'HARTFORD SEMINARY',
    address: '77 SHERMAN STREET',
    city: 'HARTFORD',
    state: 'CT',
    zip: 6105,
    telephone: '(860) 509-9500',
    population: 150,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hartsem.edu/',
  },
  {
    name: 'COLLEGE OF COURT REPORTING INC',
    address: '455 WEST LINCOLNWAY, SUITE A',
    city: 'VALPARAISO',
    state: 'IN',
    zip: 46385,
    telephone: '(219) 531-1459',
    population: 150,
    county: 'PORTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccr.edu/',
  },
  {
    name: 'EDEN THEOLOGICAL SEMINARY',
    address: '475 E LOCKWOOD AVE',
    city: 'WEBSTER GROVES',
    state: 'MO',
    zip: 63119,
    telephone: '(314) 918-2620',
    population: 151,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eden.edu/',
  },
  {
    name: 'TRIANGLE TECH INC-GREENSBURG',
    address: '222 E PITTSBURGH ST STE A',
    city: 'GREENSBURG',
    state: 'PA',
    zip: 15601,
    telephone: '(724) 832-1050',
    population: 151,
    county: 'WESTMORELAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triangle-tech.edu/',
  },
  {
    name: 'TRIANGLE TECH INC-DUBOIS',
    address: '225 TANNERY ROW ROAD',
    city: 'FALLS CREEK',
    state: 'PA',
    zip: 15840,
    telephone: '(814) 371-2090',
    population: 152,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triangle-tech.edu/',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF ARTS & TECHNOLOGY-NATIONAL CITY',
    address: '401 MILE OF CARS WAY SUITE 100',
    city: 'NATIONAL CITY',
    state: 'CA',
    zip: 91950,
    telephone: '(877) 559-3621',
    population: 152,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ciat.edu/',
  },
  {
    name: 'ACUPUNCTURE AND INTEGRATIVE MEDICINE COLLEGE-BERKELEY',
    address: '2550 SHATTUCK AVENUE',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 666-8248 EXT 103',
    population: 153,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.aimc.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-DAYMAR COLLEGE MURFREESBORO',
    address: '415 GOLDEN BEAR COURT',
    city: 'MURFREESBORO',
    state: 'TN',
    zip: 37128,
    telephone: '(717) 380-1385',
    population: 153,
    county: 'RUTHERFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daymarcollege.edu/',
  },
  {
    name: 'YESHIVA DERECH CHAIM',
    address: '1573 39TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11218,
    telephone: '(718) 438-5476',
    population: 154,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ydc.edu/',
  },
  {
    name: 'TRIANGLE TECH INC-BETHLEHEM',
    address: '3184 AIRPORT ROAD',
    city: 'BETHLEHEM',
    state: 'PA',
    zip: 18017,
    telephone: '(610) 266-2910',
    population: 154,
    county: 'LEHIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triangle-tech.edu/',
  },
  {
    name: 'HOUSTON GRADUATE SCHOOL OF THEOLOGY',
    address: '4300C WEST BELLFORT',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77035,
    telephone: '(713) 942-9505',
    population: 156,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hgst.edu/',
  },
  {
    name: 'PONTIFICAL COLLEGE JOSEPHINUM',
    address: '7625 N HIGH STREET',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43235,
    telephone: '(614) 885-5585',
    population: 156,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pcj.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF ACUPUNCTURE AND ORIENTAL MED',
    address: '9100 PARK WEST DRIVE',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77063,
    telephone: '(713) 780-9777',
    population: 157,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acaom.edu/',
  },
  {
    name: 'CEM COLLEGE-MAYAGUEZ',
    address: 'CALLE CRISTY #56',
    city: 'MAYAGUEZ',
    state: 'PR',
    zip: 680,
    telephone: '(787) 986-7440',
    population: 157,
    county: 'MAYAGÜEZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cemcollege.edu/cem/',
  },
  {
    name: 'LANSDALE SCHOOL OF BUSINESS',
    address: '290 WISSAHICKON AVENUE',
    city: 'NORTH WALES',
    state: 'PA',
    zip: 19454,
    telephone: '(215) 699-5700',
    population: 157,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lsb.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-PENNSYLVANIA',
    address: '1015 VIRGINIA DR., STE. 110',
    city: 'FT. WASHINGTON',
    state: 'PA',
    zip: 19034,
    telephone: '(215) 591-5700',
    population: 158,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: "ST. PETER'S HOSPITAL COLLEGE OF NURSING",
    address: '714 NEW SCOTLAND AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12208,
    telephone: '(518) 525-6850',
    population: 158,
    county: 'ALBANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sphp.com/careers/schools-of-nursing/',
  },
  {
    name: 'HUNTSVILLE BIBLE COLLEGE',
    address: '906 OAKWOOD AVE',
    city: 'HUNTSVILLE',
    state: 'AL',
    zip: 35811,
    telephone: '(256) 469-7536',
    population: 158,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hbc1.edu/',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-TAMPA',
    address: '1411 N WEST SHORE BLVD, SUITE 200',
    city: 'TAMPA',
    state: 'FL',
    zip: 33607,
    telephone: '(855) 706-8382',
    population: 159,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'UNIVERSITY OF EAST-WEST MEDICINE',
    address: '595 LAWRENCE EXPRESSWAY',
    city: 'SUNNYVALE',
    state: 'CA',
    zip: 94085,
    telephone: '(408) 733-1878',
    population: 159,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uewm.edu/',
  },
  {
    name: 'SANTA BARBARA BUSINESS COLLEGE-BAKERSFIELD',
    address: '5300 CALIFORNIA AVENUE',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93309,
    telephone: '(559) 734-9000',
    population: 159,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sbbcollege.edu/',
  },
  {
    name: 'BNOS ZION OF BOBOV SEMINARY',
    address: '5000 14TH AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 438-3080',
    population: 159,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bnoszionbobov.com/',
  },
  {
    name: 'DAOIST TRADITIONS COLLEGE OF CHINESE MEDICAL ARTS',
    address: '382 MONTFORD AVE',
    city: 'ASHEVILLE',
    state: 'NC',
    zip: 28801,
    telephone: '(828) 225-3993',
    population: 160,
    county: 'BUNCOMBE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'daoisttraditions.edu/',
  },
  {
    name: 'UNIFICATION THEOLOGICAL SEMINARY',
    address: '4 WEST 43RD STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10036,
    telephone: '(212) 563-6647',
    population: 160,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uts.edu/',
  },
  {
    name: 'BET MEDRASH GADOL ATERET TORAH',
    address: '1750 EAST FOURTH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11223,
    telephone: '(718) 375-7100',
    population: 160,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'betmedrashgadolaterettorah.com/',
  },
  {
    name: 'PROVIDENCE CHRISTIAN COLLEGE',
    address: '464 E WALNUT ST',
    city: 'PASADENA',
    state: 'CA',
    zip: 91101,
    telephone: '(626) 696-4000',
    population: 160,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.providencecc.edu/',
  },
  {
    name: 'YESHIVA OHR ELCHONON CHABAD WEST COAST TALMUDICAL SEMINARY',
    address: '7215 WARING AVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90046,
    telephone: '(323) 937-3763',
    population: 161,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.yoec.edu/',
  },
  {
    name: 'SHEPHERDS THEOLOGICAL SEMINARY',
    address: '6051 TRYON ROAD',
    city: 'CARY',
    state: 'NC',
    zip: 27518,
    telephone: '(919) 573-5350',
    population: 161,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'shepherds.edu/',
  },
  {
    name: 'YESHIVA YESODA HATORAH VETZ CHAIM',
    address: '27 LEE AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11211,
    telephone: '(718) 302-7500',
    population: 161,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivayh.org',
  },
  {
    name: 'ETI TECHNICAL COLLEGE',
    address: '2076 YOUNGSTOWN WARREN RD',
    city: 'NILES',
    state: 'OH',
    zip: 44446,
    telephone: '(330) 652-9919',
    population: 162,
    county: 'TRUMBULL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'eticollege.edu/',
  },
  {
    name: 'LAUREL TECHNICAL INSTITUTE',
    address: '2370 BROADWAY AVENUE',
    city: 'HERMITAGE',
    state: 'PA',
    zip: 16148,
    telephone: '(724) 983-0700',
    population: 162,
    county: 'MERCER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.laurel.edu/',
  },
  {
    name: 'YESHIVA YESODA HATORAH VETZ CHAIM',
    address: '27 LEE AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11211,
    telephone: '(718) 302-7500 EXT 1166',
    population: 163,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivayh.org/',
  },
  {
    name: 'PAIER COLLEGE OF ART INC',
    address: '20 GORHAM AVE',
    city: 'HAMDEN',
    state: 'CT',
    zip: 6514,
    telephone: '(203) 287-3031',
    population: 164,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.paier.edu/',
  },
  {
    name: 'MOUNT ANGEL SEMINARY',
    address: '1 ABBEY DRIVE',
    city: 'SAINT BENEDICT',
    state: 'OR',
    zip: 97373,
    telephone: '(503) 845-3951',
    population: 164,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mountangelabbey.org/seminary',
  },
  {
    name: 'NEW YORK SEMINARY',
    address: '911 MCDONALD AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11218,
    telephone: '(718) 298-2601',
    population: 164,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'thenyseminary.com/',
  },
  {
    name: 'SAINT JOSEPH SEMINARY COLLEGE',
    address: '75376 RIVER ROAD',
    city: 'ST. BENEDICT',
    state: 'LA',
    zip: 70457,
    telephone: '(985) 867-2232',
    population: 165,
    county: 'ST. TAMMANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sjasc.edu/',
  },
  {
    name: 'CARIBBEAN UNIVERSITY-VEGA BAJA',
    address: 'CARR 671 K.M. 5, SECTOR EL CRIOLLO, BO. ALGARROBO',
    city: 'VEGA BAJA',
    state: 'PR',
    zip: 964,
    telephone: '(787) 858-3668',
    population: 165,
    county: 'VEGA BAJA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caribbean.edu/',
  },
  {
    name: 'LANCASTER THEOLOGICAL SEMINARY',
    address: '555 W JAMES ST',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17603,
    telephone: '(717) 393-0654',
    population: 165,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lancasterseminary.edu/',
  },
  {
    name: "YESHIVAS MAHARIT D'SATMAR",
    address: '475 COUNTY ROUTE 105',
    city: 'MONROE',
    state: 'NY',
    zip: 10950,
    telephone: '(845) 782-1380',
    population: 166,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivasmaharit.com/',
  },
  {
    name: 'BOLIVAR TECHNICAL COLLEGE',
    address: '1135 NORTH OAKLAND AVENUE',
    city: 'BOLIVAR',
    state: 'MO',
    zip: 65613,
    telephone: '(417) 777-5062',
    population: 166,
    county: 'POLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bolivarcollege.org/',
  },
  {
    name: 'AQUINAS INSTITUTE OF THEOLOGY',
    address: '23 SOUTH SPRING AVENUE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63108,
    telephone: '(314) 256-8800',
    population: 167,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ai.edu/',
  },
  {
    name: 'BAPTIST UNIVERSITY OF THE AMERICAS',
    address: '7838 BARLITE BLVD.',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78224,
    telephone: '(210) 924-4338 EXT 200',
    population: 167,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bua.edu/',
  },
  {
    name: 'COMMONWEALTH TECHNICAL INSTITUTE',
    address: '727 GOUCHER ST',
    city: 'JOHNSTOWN',
    state: 'PA',
    zip: 15905,
    telephone: '(814) 255-8200',
    population: 167,
    county: 'CAMBRIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dli.pa.gov/',
  },
  {
    name: 'FIDM-FASHION INSTITUTE OF DESIGN & MERCHANDISING-SAN FRANCISCO',
    address: '55 STOCKTON ST',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94108,
    telephone: '(415) 675-5200',
    population: 167,
    county: 'SAN FRANCISCO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fidm.edu/',
  },
  {
    name: 'YESHIVA GEDOLAH KEREN HATORAH',
    address: '1083 BROOK ROAD',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 942-1811',
    population: 168,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivagedolahkerenhatorah.com/',
  },
  {
    name: 'UNITED THEOLOGICAL SEMINARY OF THE TWIN CITIES',
    address: '767 EUSTIS ST. SUITE 140',
    city: 'ST. PAUL',
    state: 'MN',
    zip: 55114,
    telephone: '(651) 633-4311',
    population: 168,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unitedseminary.edu/',
  },
  {
    name: 'CITY VISION UNIVERSITY',
    address: '1100 E 11TH STREET',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64106,
    telephone: '(816) 960-2008',
    population: 168,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cityvision.edu/',
  },
  {
    name: 'BAKKE GRADUATE UNIVERSITY',
    address: '8515 GREENVILLE AVE S206',
    city: 'DALLAS',
    state: 'TX',
    zip: 75243,
    telephone: '(214) 329-4447 EXT 115',
    population: 168,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bgu.edu/',
  },
  {
    name: 'CLEAR CREEK BAPTIST BIBLE COLLEGE',
    address: '300 CLEAR CREEK RD',
    city: 'PINEVILLE',
    state: 'KY',
    zip: 40977,
    telephone: '(606) 337-3196',
    population: 170,
    county: 'BELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ccbbc.edu/',
  },
  {
    name: 'CALIFORNIA COLLEGE SAN DIEGO-COLLEGEAMERICA-PHOENIX',
    address: '9801 N. METRO PARKWAY EAST',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85051,
    telephone: '(602) 589-9860 EXT 1901',
    population: 170,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.collegeamerica.edu/',
  },
  {
    name: 'BAIS MEDRASH TORAS CHESED',
    address: '901 MONMOUTH AVE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 364-1220 EXT 2',
    population: 170,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bmtc.edu/',
  },
  {
    name: 'NEW YORK SEMINARY',
    address: '911 MCDONALD AVENUE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11218,
    telephone: '(718) 298-2601',
    population: 170,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'thenyseminary.com/',
  },
  {
    name: 'INTERIOR DESIGNERS INSTITUTE',
    address: '1061 CAMELBACK STREET',
    city: 'NEWPORT BEACH',
    state: 'CA',
    zip: 92660,
    telephone: '(949) 675-4451',
    population: 171,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.idi.edu/',
  },
  {
    name: 'BELANGER SCHOOL OF NURSING',
    address: '650 MCCLELLAN ST',
    city: 'SCHENECTADY',
    state: 'NY',
    zip: 12304,
    telephone: '(518) 243-4471',
    population: 171,
    county: 'SCHENECTADY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ellisbelangerschoolofnursing.org/',
  },
  {
    name: 'DESIGN INSTITUTE OF SAN DIEGO',
    address: '8555 COMMERCE AVE',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92121,
    telephone: '(858) 566-1200',
    population: 172,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.disd.edu/',
  },
  {
    name: 'YESHIVA GEDOLA TIFERES YERACHMIEL',
    address: '911 SOMERSET AVENUE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 676-1790',
    population: 172,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivagedolatiferesyerachmiel.com/',
  },
  {
    name: 'MACHZIKEI HADATH RABBINICAL COLLEGE',
    address: '5407 16TH AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11204,
    telephone: '(718) 854-8791',
    population: 173,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://mhrc.edu/',
  },
  {
    name: 'FAMILY OF FAITH CHRISTIAN UNIVERSITY',
    address: '30 KINVILLE',
    city: 'SHAWNEE',
    state: 'OK',
    zip: 74802,
    telephone: '(405) 695-5533',
    population: 173,
    county: 'POTTAWATOMIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.familyoffaith.edu/',
  },
  {
    name: 'HUNTINGTON UNIVERSITY OF HEALTH SCIENCES',
    address: '118 LEGACY VIEW WAY',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37918,
    telephone: '(865) 524-8079',
    population: 175,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.huhs.edu/',
  },
  {
    name: 'WESTMINSTER THEOLOGICAL SEMINARY IN CALIFORNIA',
    address: '1725 BEAR VALLEY PARKWAY',
    city: 'ESCONDIDO',
    state: 'CA',
    zip: 92027,
    telephone: '(760) 480-8474',
    population: 175,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wscal.edu/',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '1350 W. 1890 S.',
    city: 'WEST HAVEN',
    state: 'UT',
    zip: 84401,
    telephone: '(801) 622-1567 EXT 1000',
    population: 176,
    county: 'WEBER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'COLLEGE OF BUSINESS AND TECHNOLOGY-HIALEAH',
    address: '935 WEST 49 STREET # 203',
    city: 'HIALEAH',
    state: 'FL',
    zip: 33012,
    telephone: '(305) 273-4499 EXT 300',
    population: 176,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cbt.edu/',
  },
  {
    name: 'MAPLE SPRINGS BAPTIST BIBLE COLLEGE AND SEMINARY',
    address: '4130 BELT RD',
    city: 'CAPITOL HEIGHTS',
    state: 'MD',
    zip: 20743,
    telephone: '(301) 736-3631',
    population: 177,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msbbcs.edu/',
  },
  {
    name: 'SAMARITAN HOSPITAL SCHOOL OF NURSING',
    address: '1300 MASSACHUSETTS AVENUE',
    city: 'TROY',
    state: 'NY',
    zip: 12065,
    telephone: '(518) 268-5130',
    population: 177,
    county: 'RENSSELAER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sphp.com/careers/schools-of-nursing/',
  },
  {
    name: 'YOUNG AMERICANS COLLEGE OF THE PERFORMING ARTS',
    address: '1132 OLYMPIC DRIVE',
    city: 'CORONA',
    state: 'CA',
    zip: 92881,
    telephone: '(951) 493-6753',
    population: 177,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.yacollege.edu',
  },
  {
    name: 'STEVENS-HENAGER COLLEGE',
    address: '383 W VINE ST',
    city: 'MURRAY',
    state: 'UT',
    zip: 84123,
    telephone: '(801) 281-7620',
    population: 178,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenshenager.edu/',
  },
  {
    name: 'SPERTUS COLLEGE',
    address: '610 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(312) 922-9012',
    population: 178,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.spertus.edu/',
  },
  {
    name: 'WESLEY BIBLICAL SEMINARY',
    address: '1880 E COUNTY LINE ROAD',
    city: 'RIDGELAND',
    state: 'MS',
    zip: 39157,
    telephone: '(601) 366-8880',
    population: 178,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wbs.edu/',
  },
  {
    name: 'SHEPHERDS COLLEGE',
    address: '1805 15TH AVENUE',
    city: 'UNION GROVE',
    state: 'WI',
    zip: 53182,
    telephone: '(262) 878-5620 EXT 0',
    population: 178,
    county: 'RACINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shepherdscollege.edu/',
  },
  {
    name: 'PHOENIX INSTITUTE OF HERBAL MEDICINE & ACUPUNCTURE',
    address: '301 E BETHANY HOME RD STE A100',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85012,
    telephone: '(602) 274-1885',
    population: 178,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pihma.edu/',
  },
  {
    name: 'ANTIOCH UNIVERSITY-PHD PROGRAM IN LEADERSHIP AND CHANGE',
    address: '900 DAYTON STREET',
    city: 'YELLOW SPRINGS',
    state: 'OH',
    zip: 45387,
    telephone: '(937) 769-1360',
    population: 179,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.antioch.edu/gslc/',
  },
  {
    name: 'RABBINICAL COLLEGE OF LONG ISLAND',
    address: '205 W BEACH ST',
    city: 'LONG BEACH',
    state: 'NY',
    zip: 11561,
    telephone: '(516) 431-7414',
    population: 180,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rabbinicalcollegelongisland.com/',
  },
  {
    name: 'PELOTON COLLEGE',
    address: '1200 EAST COPELAND ROAD',
    city: 'ARLINGTON',
    state: 'TX',
    zip: 76011,
    telephone: '(214) 777-6433',
    population: 180,
    county: 'TARRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pelotoncollege.edu/',
  },
  {
    name: 'YESHIVAS NOVOMINSK',
    address: '1690 60TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11204,
    telephone: '(718) 438-2727',
    population: 181,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivasnovominsk.com/',
  },
  {
    name: 'AMERICAN ACADEMY OF DRAMATIC ARTS-LOS ANGELES',
    address: '1336 NORTH LA BREA AVENUE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90028,
    telephone: '(323) 464-2777 EXT 109',
    population: 181,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aada.edu/',
  },
  {
    name: 'INSTITUTE OF PRODUCTION AND RECORDING',
    address: '300 NORTH 1ST AVE, SUITE 100',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55401,
    telephone: '(612) 351-0631',
    population: 181,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ipr.edu/',
  },
  {
    name: 'NEW BRUNSWICK THEOLOGICAL SEMINARY',
    address: '35 SEMINARY PLACE',
    city: 'NEW BRUNSWICK',
    state: 'NJ',
    zip: 8901,
    telephone: '(732) 247-5241',
    population: 182,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nbts.edu/',
  },
  {
    name: 'LEECH LAKE TRIBAL COLLEGE',
    address: '6945 LITTLEWOLF ROAD NW',
    city: 'CASS LAKE',
    state: 'MN',
    zip: 56633,
    telephone: '(218) 335-4200',
    population: 182,
    county: 'CASS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lltc.edu/',
  },
  {
    name: 'CALIFORNIA COLLEGE SAN DIEGO',
    address: '277 RANCHEROS DRIVE, SUITE 200',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92069,
    telephone: '(619) 680-4430 EXT 1501',
    population: 183,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cc-sd.edu/',
  },
  {
    name: 'SISSETON WAHPETON COLLEGE',
    address: '12572 BIA RD 700',
    city: 'SISSETON',
    state: 'SD',
    zip: 57262,
    telephone: '(605) 698-3966 EXT 1100',
    population: 184,
    county: 'ROBERTS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.swcollege.edu/',
  },
  {
    name: 'LITTLE PRIEST TRIBAL COLLEGE',
    address: '601 E. COLLEGE DRIVE',
    city: 'WINNEBAGO',
    state: 'NE',
    zip: 68071,
    telephone: '(402) 878-2380 EXT 155',
    population: 185,
    county: 'THURSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.littlepriest.edu/',
  },
  {
    name: 'BRITE DIVINITY SCHOOL',
    address: '2800 S. UNIVERSITY DR.',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76129,
    telephone: '(817) 257-7575',
    population: 185,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brite.edu/',
  },
  {
    name: 'JOHN A GUPTON COLLEGE',
    address: '1616 CHURCH ST',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37203,
    telephone: '(615) 327-3927',
    population: 185,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.guptoncollege.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-ONTARIO',
    address: '4580 ONTARIO MILLS PARKWAY #200',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91764,
    telephone: '(909) 366-4122',
    population: 185,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'KEHILATH YAKOV RABBINICAL SEMINARY',
    address: '340 ILLINGTON ROAD',
    city: 'OSSINING',
    state: 'NY',
    zip: 10562,
    telephone: '(718) 963-1212 EXT 2108',
    population: 186,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'kehilathyakov.com/',
  },
  {
    name: 'MIRRER YESHIVA CENT INSTITUTE',
    address: '1791-5 OCEAN PARKWAY',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11223,
    telephone: '(718) 645-0536',
    population: 186,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mirreryeshiva.com/',
  },
  {
    name: 'HOOD THEOLOGICAL SEMINARY',
    address: '1810 LUTHERAN SYNOD DRIVE',
    city: 'SALISBURY',
    state: 'NC',
    zip: 28144,
    telephone: '(704) 636-7611',
    population: 186,
    county: 'ROWAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hoodseminary.edu/',
  },
  {
    name: 'CLINTON COLLEGE',
    address: '1029 CRAWFORD RD',
    city: 'ROCK HILL',
    state: 'SC',
    zip: 29730,
    telephone: '(803) 327-7402 EXT 8151',
    population: 186,
    county: 'YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clintoncollege.edu/',
  },
  {
    name: 'AMERICA EVANGELICAL UNIVERSITY',
    address: '1818 SOUTH WESTERN AVENUE SUITE 409',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90006,
    telephone: '(323) 643-0301',
    population: 187,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aeu.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO-VILLALBA',
    address: 'ROAD #149, KM. 54.2 BARRIO VILLALBA ARRIBA',
    city: 'VILLALBA',
    state: 'PR',
    zip: 766,
    telephone: '(787) 588-0003 EXT 6001',
    population: 187,
    county: 'VILLALBA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'HAZELDEN BETTY FORD GRADUATE SCHOOL OF ADDICTION STUDIES',
    address: '15251 PLEASANT VALLEY RD',
    city: 'CENTER CITY',
    state: 'MN',
    zip: 55012,
    telephone: '(888) 257-7800 EXT 4175',
    population: 187,
    county: 'CHISAGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hazeldenbettyford.edu/',
  },
  {
    name: 'LINFIELD UNIVERSITY-ONLINE AND CONTINUING EDUCATION',
    address: '900 SE BAKER STREET',
    city: 'MCMINNVILLE',
    state: 'OR',
    zip: 97128,
    telephone: '(503) 883-2447',
    population: 187,
    county: 'YAMHILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.linfield.edu/academics/oce/index.html',
  },
  {
    name: 'CRANBROOK ACADEMY OF ART',
    address: '39221 WOODWARD AVENUE',
    city: 'BLOOMFIELD HILLS',
    state: 'MI',
    zip: 48304,
    telephone: '(248) 645-3300',
    population: 187,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cranbrookart.edu/',
  },
  {
    name: 'PLATT COLLEGE-MOORE',
    address: '201 N. EASTERN',
    city: 'MOORE',
    state: 'OK',
    zip: 73160,
    telephone: '(405) 912-3260',
    population: 188,
    county: 'CLEVELAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.plattcolleges.edu/',
  },
  {
    name: 'POLYTECHNIC UNIVERSITY OF PUERTO RICO-MIAMI',
    address: '8180 N.W. 36 ST., SUITE 401',
    city: 'MIAMI',
    state: 'FL',
    zip: 33166,
    telephone: '(305) 418-8000 EXT 706',
    population: 190,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pupr.edu/',
  },
  {
    name: 'ATLANTIC INSTITUTE OF ORIENTAL MEDICINE',
    address: '100 E BROWARD BLVD, SUITE 100',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33301,
    telephone: '(954) 763-9840 EXT 203',
    population: 190,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atom.edu/',
  },
  {
    name: 'YESHIVA KOLLEL TIFERETH ELIZER',
    address: '1227 47TH STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(929) 222-8090',
    population: 191,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yeshivakolleltiferethelizer.com/',
  },
  {
    name: 'SEMINARIO EVANGELICO DE PUERTO RICO',
    address: '776 PONCE DE LEON AVENUE',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 925,
    telephone: '(787) 763-6700 EXT 251',
    population: 191,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.se-pr.edu/',
  },
  {
    name: 'YO SAN UNIVERSITY OF TRADITIONAL CHINESE MEDICINE',
    address: '13315 W. WASHINGTON BOULEVARD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90066,
    telephone: '(310) 577-3000 EXT 110',
    population: 191,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yosan.edu/',
  },
  {
    name: 'MERIDIAN UNIVERSITY',
    address: '47 SIXTH STREET',
    city: 'PETALUMA',
    state: 'CA',
    zip: 94952,
    telephone: '(707) 765-1836',
    population: 191,
    county: 'SONOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'meridianuniversity.edu/',
  },
  {
    name: 'STERLING COLLEGE',
    address: '16 STERLING DRIVE',
    city: 'CRAFTSBURY COMMON',
    state: 'VT',
    zip: 5827,
    telephone: '(802) 586-7711',
    population: 192,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sterlingcollege.edu/',
  },
  {
    name: 'BOSTON GRADUATE SCHOOL OF PSYCHOANALYSIS INC',
    address: '1581 BEACON STREET',
    city: 'BROOKLINE',
    state: 'MA',
    zip: 2446,
    telephone: '(617) 277-3915',
    population: 193,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bgsp.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-HOUSTON SOUTHEAST CAMPUS',
    address: '20985 INTERSTATE 45 SOUTH',
    city: 'WEBSTER',
    state: 'TX',
    zip: 77598,
    telephone: '(281) 885-4450',
    population: 193,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/houston-career-schools-overview',
  },
  {
    name: 'INSTITUTE OF WORLD POLITICS',
    address: '1521 16TH ST NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20036,
    telephone: '(202) 462-2101',
    population: 194,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iwp.edu/',
  },
  {
    name: 'KANSAS CHRISTIAN COLLEGE',
    address: '7401 METCALF',
    city: 'OVERLAND PARK',
    state: 'KS',
    zip: 66204,
    telephone: '(913) 722-0272',
    population: 194,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kansaschristian.edu/',
  },
  {
    name: 'AOMA GRADUATE SCHOOL OF INTEGRATIVE MEDICINE',
    address: '4701 WESTGATE BLVD',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78745,
    telephone: '(512) 454-1188',
    population: 194,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://aoma.edu/',
  },
  {
    name: 'METHODIST THEOLOGICAL SCHOOL IN OHIO',
    address: '3081 COLUMBUS PIKE',
    city: 'DELAWARE',
    state: 'OH',
    zip: 43015,
    telephone: '(740) 363-1146 EXT 3440',
    population: 194,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtso.edu/',
  },
  {
    name: 'WHITE EARTH TRIBAL AND COMMUNITY COLLEGE',
    address: '2250 COLLEGE ROAD',
    city: 'MAHNOMEN',
    state: 'MN',
    zip: 56557,
    telephone: '(218) 935-0417 EXT 319',
    population: 194,
    county: 'MAHNOMEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wetcc.edu/',
  },
  {
    name: 'GLENDALE CAREER COLLEGE-BRIGHTWOOD TEACHOUT',
    address: '8888 BALBOA AVENUE',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92123,
    telephone: '(460) 465-0460',
    population: 194,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'glendalecareer.com',
  },
  {
    name: 'BEIS MEDRASH HEICHAL DOVID',
    address: '211 BEACH SEVENTEENTH STREET',
    city: 'FAR ROCKAWAY',
    state: 'NY',
    zip: 11691,
    telephone: '(718) 868-2300',
    population: 195,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.heichaldovid.org/',
  },
  {
    name: 'WON INSTITUTE OF GRADUATE STUDIES',
    address: '137 S EASTON RD',
    city: 'GLENSIDE',
    state: 'PA',
    zip: 19038,
    telephone: '(215) 884-8942',
    population: 195,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.woninstitute.edu/',
  },
  {
    name: 'CENTURA COLLEGE-RICHMOND MAIN',
    address: '7914 MIDLOTHIAN TURNPIKE',
    city: 'NORTH CHESTERFIELD',
    state: 'VA',
    zip: 23235,
    telephone: '(804) 330-0111',
    population: 195,
    county: 'CHESTERFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.centuracollege.edu/campuses/richmond/',
  },
  {
    name: 'CARVER CAREER CENTER',
    address: '4799 MIDLAND DR',
    city: 'CHARLESTON',
    state: 'WV',
    zip: 25306,
    telephone: '(304) 348-1965',
    population: 195,
    county: 'KANAWHA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.carvercareercenter.edu/',
  },
  {
    name: 'INSTITUTE FOR CLINICAL SOCIAL WORK',
    address: '1345 W ARGYLE STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60640,
    telephone: '(773) 943-6500',
    population: 196,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.icsw.edu/',
  },
  {
    name: 'CHESTER CAREER COLLEGE',
    address: '751 WEST HUNDRED ROAD',
    city: 'CHESTER',
    state: 'VA',
    zip: 23836,
    telephone: '(804) 425-5797',
    population: 196,
    county: 'CHESTERFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'chestercareercollege.edu/',
  },
  {
    name: 'UNIVERSITY OF THE POTOMAC-VA CAMPUS',
    address: '7799 LEESBURG PIKE',
    city: 'FALLS CHURCH',
    state: 'VA',
    zip: 22043,
    telephone: '(202) 521-1290',
    population: 197,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.potomac.edu/',
  },
  {
    name: 'CITY COLLEGE-GAINESVILLE',
    address: '7001 N.W. 4TH BLVD.',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32607,
    telephone: '(352) 335-4000',
    population: 197,
    county: 'ALACHUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.citycollege.edu/',
  },
  {
    name: 'CORTIVA INSTITUTE-MAITLAND',
    address: '2600 LAKE LUCIEN DRIVE SUITE#240',
    city: 'MAITLAND',
    state: 'FL',
    zip: 32751,
    telephone: '(954) 962-2624',
    population: 197,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cortiva.edu/',
  },
  {
    name: 'CENTURA COLLEGE-CHESAPEAKE',
    address: '932 B VENTURES WAY',
    city: 'CHESAPEAKE',
    state: 'VA',
    zip: 23320,
    telephone: '(757) 549-2121',
    population: 197,
    county: 'CHESAPEAKE CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.centuracollege.edu/campuses/chesapeake/',
  },
  {
    name: "WOMEN'S INSTITUTE OF TORAH SEMINARY AND COLLEGE",
    address: '6602 PARK HEIGHTS AVENUE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21215,
    telephone: '(410) 358-3144',
    population: 198,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wits.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF HEALTHCARE AND TECHNOLOGY',
    address: '6330 PACIFIC BLVD STE 201',
    city: 'HUNTINGTON PARK',
    state: 'CA',
    zip: 90255,
    telephone: '(323) 585-9000',
    population: 198,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ach.edu/',
  },
  {
    name: 'EPISCOPAL THEOLOGICAL SEMINARY OF THE SOUTHWEST',
    address: '501 E. 32ND ST.',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78705,
    telephone: '(512) 472-4133',
    population: 198,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ssw.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO-HUMACAO',
    address: 'ANTONIO LOPEZ STREET #4 AND 6',
    city: 'HUMACAO',
    state: 'PR',
    zip: 791,
    telephone: '(787) 719-2236',
    population: 198,
    county: 'HUMACAO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'PAYNE THEOLOGICAL SEMINARY',
    address: '1230 WILBERFORCE-CLIFTON RD.',
    city: 'WILBERFORCE',
    state: 'OH',
    zip: 45384,
    telephone: '(937) 376-2946',
    population: 199,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.payne.edu/',
  },
  {
    name: 'LAKEVIEW COLLEGE OF NURSING',
    address: '903 N LOGAN AVE',
    city: 'DANVILLE',
    state: 'IL',
    zip: 61832,
    telephone: '(217) 709-0920',
    population: 199,
    county: 'VERMILION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lakeviewcol.edu/',
  },
  {
    name: 'AANIIIH NAKODA COLLEGE',
    address: '269 BLACKFEET AVENUE AGENCY',
    city: 'HARLEM',
    state: 'MT',
    zip: 59526,
    telephone: '(406) 353-2607 EXT 3901',
    population: 199,
    county: 'BLAINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ancollege.edu/',
  },
  {
    name: 'WORSHAM COLLEGE OF MORTUARY SCIENCE',
    address: '495 NORTHGATE PKWY',
    city: 'WHEELING',
    state: 'IL',
    zip: 60090,
    telephone: '(847) 808-8444',
    population: 199,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.worsham.edu/',
  },
  {
    name: 'PLATT COLLEGE',
    address: '3801 S SHERIDAN',
    city: 'TULSA',
    state: 'OK',
    zip: 74145,
    telephone: '(918) 663-9000',
    population: 200,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.plattcolleges.edu/',
  },
  {
    name: 'SAINT VINCENT DE PAUL REGIONAL SEMINARY',
    address: '10701 SOUTH MILITARY TRAIL',
    city: 'BOYNTON BEACH',
    state: 'FL',
    zip: 33436,
    telephone: '(561) 732-4424 EXT 156',
    population: 201,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.svdp.edu/',
  },
  {
    name: "YESHIVA GEDOLAH IMREI YOSEF D'SPINKA",
    address: '1466 56TH ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 851-8721',
    population: 202,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'spinka58st.com/',
  },
  {
    name: 'PRESIDIO GRADUATE SCHOOL',
    address: '1202 RALSTON AVE #300',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94129,
    telephone: '(415) 655-8918',
    population: 202,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.presidio.edu/',
  },
  {
    name: 'REFORMED UNIVERSITY',
    address: '1724 ATKINSON ROAD',
    city: 'LAWRENCEVILLE',
    state: 'GA',
    zip: 30043,
    telephone: '(770) 232-2717',
    population: 202,
    county: 'GWINNETT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'runiv.edu/',
  },
  {
    name: 'PACIFIC RIM CHRISTIAN UNIVERSITY',
    address: '2223 HOONEE PL.',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96819,
    telephone: '(808) 518-4791',
    population: 202,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pacrim.edu/#home',
  },
  {
    name: 'DONGGUK UNIVERSITY LOS ANGELES',
    address: '440 SHATTO PL',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90020,
    telephone: '(213) 487-0110',
    population: 202,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dula.edu/',
  },
  {
    name: 'CEM COLLEGE-BAYAMON',
    address: '25 DEGETAU ST',
    city: 'BAYAMÓN',
    state: 'PR',
    zip: 961,
    telephone: '(787) 780-8900',
    population: 204,
    county: 'BAYAMÓN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cemcollege.edu/',
  },
  {
    name: 'OHIO VALLEY COLLEGE OF TECHNOLOGY',
    address: '15258 STATE ROUTE 170',
    city: 'EAST LIVERPOOL',
    state: 'OH',
    zip: 43920,
    telephone: '(330) 385-1070',
    population: 205,
    county: 'COLUMBIANA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ovct.edu/',
  },
  {
    name: 'ANTIOCH COLLEGE',
    address: '1 MORGAN PL',
    city: 'YELLOW SPRINGS',
    state: 'OH',
    zip: 45387,
    telephone: '(937) 319-6082',
    population: 206,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'antiochcollege.edu/',
  },
  {
    name: 'ALHAMBRA MEDICAL UNIVERSITY',
    address: '2215 W. MISSION ROAD',
    city: 'ALHAMBRA',
    state: 'CA',
    zip: 91803,
    telephone: '(626) 289-7719',
    population: 206,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amu.edu/',
  },
  {
    name: 'CAROLINA COLLEGE OF BIBLICAL STUDIES',
    address: '817 SOUTH MCPHERSON CHURCH ROAD',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28303,
    telephone: '(910) 323-5614',
    population: 207,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ccbs.edu/',
  },
  {
    name: 'CONGREGATION TALMIDEI MESIVTA TIFERES SHMIEL ALEKSANDER',
    address: '1535 63RD STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 435-2105',
    population: 207,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaaleksander.org/',
  },
  {
    name: 'HOBE SOUND BIBLE COLLEGE',
    address: '11298 SE GOMEZ AVE',
    city: 'HOBE SOUND',
    state: 'FL',
    zip: 33455,
    telephone: '(772) 546-5534',
    population: 208,
    county: 'MARTIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hsbc.edu/',
  },
  {
    name: 'VERVE COLLEGE',
    address: '2625 BUTTERFIELD RD, STE 102E',
    city: 'OAK BROOK',
    state: 'IL',
    zip: 60523,
    telephone: '(630) 705-9999',
    population: 208,
    county: 'DUPAGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vervecollege.edu/',
  },
  {
    name: 'BETH MEDRASH MEOR YITZCHOK',
    address: '85 DYKSTRAS WAY EAST',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 426-3488',
    population: 209,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://bethmedrashmeoryitzchok.com/',
  },
  {
    name: 'KUYPER COLLEGE',
    address: '3333 EAST BELTLINE AVE NE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49525,
    telephone: '(616) 222-3000',
    population: 209,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kuyper.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-FORTY FORT',
    address: '166 SLOCUM STREET',
    city: 'FORTY FORT',
    state: 'PA',
    zip: 18704,
    telephone: '(570) 288-8400',
    population: 209,
    county: 'LUZERNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortisinstitute.edu/',
  },
  {
    name: 'CASA LOMA COLLEGE-VAN NUYS',
    address: '6725 KESTER AVE',
    city: 'VAN NUYS',
    state: 'CA',
    zip: 91405,
    telephone: '(818) 785-2726',
    population: 209,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.casalomacollege.edu/',
  },
  {
    name: 'CALIFORNIA MIRAMAR UNIVERSITY',
    address: '3550 CAMINO DEL RIO NORTH, SUITE 208',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92108,
    telephone: '(858) 653-3000 EXT 11',
    population: 210,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calmu.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO-HUMACAO',
    address: 'ANTONIO LOPEZ STREET #4 AND 6',
    city: 'HUMACAO',
    state: 'PR',
    zip: 791,
    telephone: '(787) 719-2236 EXT 5001',
    population: 210,
    county: 'HUMACAO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'JOHN PATRICK UNIVERSITY OF HEALTH AND APPLIED SCIENCES',
    address: '100 EAST WAYNE STREET, SUITE 140',
    city: 'SOUTH BEND',
    state: 'IN',
    zip: 46601,
    telephone: '(574) 232-2408',
    population: 210,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://jpu.edu/',
  },
  {
    name: 'NEW YORK ACADEMY OF ART',
    address: '111 FRANKLIN ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10013,
    telephone: '(212) 966-0300',
    population: 211,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'nyaa.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-FRESNO AVIATION',
    address: '4985 EAST ANDERSON AVENUE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93727,
    telephone: '(559) 734-9000',
    population: 211,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'PRESBYTERIAN THEOLOGICAL SEMINARY IN AMERICA',
    address: '15605 CARMENITA ROAD',
    city: 'SANTA FE SPRINGS',
    state: 'CA',
    zip: 90670,
    telephone: '(562) 926-1023 EXT 300',
    population: 212,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ptsa.edu/',
  },
  {
    name: 'COLLEGE UNBOUND',
    address: '325 PUBLIC STREET',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2905,
    telephone: '(401) 752-2640',
    population: 212,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'collegeunbound.org',
  },
  {
    name: 'MEMPHIS THEOLOGICAL SEMINARY',
    address: '168 EAST PARKWAY SOUTH',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 458-8232',
    population: 212,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.memphisseminary.edu/',
  },
  {
    name: 'AVIATION INSTITUTE OF MAINTENANCE-MANASSAS',
    address: '10640 DAVIDSON PLACE',
    city: 'MANASSAS',
    state: 'VA',
    zip: 20109,
    telephone: '(703) 257-5515',
    population: 212,
    county: 'PRINCE WILLIAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aviationmaintenance.edu/campuses/washington-dc-va/',
  },
  {
    name: 'SOUTHERN CALIFORNIA SEMINARY',
    address: '2075 E. MADISON AVENUE',
    city: 'EL CAJON',
    state: 'CA',
    zip: 92019,
    telephone: '(619) 201-8999',
    population: 213,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.socalsem.edu/',
  },
  {
    name: 'CONGREGATION TALMIDEI MESIVTA TIFERES SHMIEL ALEKSANDER',
    address: '1535 63RD STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 435-2105',
    population: 213,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'YeshivaAleksander.org',
  },
  {
    name: 'ARLINGTON BAPTIST UNIVERSITY',
    address: '3001 W DIVISION',
    city: 'ARLINGTON',
    state: 'TX',
    zip: 76012,
    telephone: '(817) 461-8741',
    population: 213,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://abu.edu/',
  },
  {
    name: 'SAE INSTITUTE OF TECHNOLOGY-CHICAGO',
    address: '820 N. ORLEANS STREET, SUITE 125',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60610,
    telephone: '(312) 300-5685',
    population: 213,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'chicago.sae.edu/',
  },
  {
    name: 'EPIC BIBLE COLLEGE',
    address: '4330 AUBURN BOULEVARD',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95841,
    telephone: '(916) 348-4689',
    population: 213,
    county: 'SACRAMENTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'epic.edu/',
  },
  {
    name: 'EAGLE GATE COLLEGE-LAYTON',
    address: '915 N 400 W',
    city: 'LAYTON',
    state: 'UT',
    zip: 84041,
    telephone: '(801) 546-7500',
    population: 213,
    county: 'DAVIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eaglegatecollege.edu/',
  },
  {
    name: 'PHILLIPS THEOLOGICAL SEMINARY',
    address: '901 N MINGO RD',
    city: 'TULSA',
    state: 'OK',
    zip: 74116,
    telephone: '(918) 610-8303',
    population: 214,
    county: 'TULSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ptstulsa.edu/',
  },
  {
    name: 'COLUMBIA CENTRAL UNIVERSITY-YAUCO',
    address: '3 BETANCES ST',
    city: 'YAUCO',
    state: 'PR',
    zip: 698,
    telephone: '(787) 856-0845',
    population: 215,
    county: 'YAUCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbiacentral.edu/',
  },
  {
    name: 'WALNUT HILL COLLEGE',
    address: '4207 WALNUT ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19104,
    telephone: '(215) 222-4200 EXT 3015',
    population: 215,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.walnuthillcollege.edu/',
  },
  {
    name: 'ACUPUNCTURE AND MASSAGE COLLEGE',
    address: '10506 N KENDALL DRIVE',
    city: 'MIAMI',
    state: 'FL',
    zip: 33176,
    telephone: '(305) 595-9500',
    population: 215,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amcollege.edu/',
  },
  {
    name: 'LUTHERAN SCHOOL OF THEOLOGY AT CHICAGO',
    address: '1100 E 55TH ST',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60615,
    telephone: '(773) 256-0700',
    population: 215,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lstc.edu/',
  },
  {
    name: 'AVIATION INSTITUTE OF MAINTENANCE-CHARLOTTE',
    address: '7421 E. INDEPENDENCE BOULEVARD',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28227,
    telephone: '(980) 785-0700',
    population: 215,
    county: 'MECKLENBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aviationmaintenance.edu/campuses/charlotte-nc/index.html',
  },
  {
    name: 'OHIO BUSINESS COLLEGE-SHEFFIELD',
    address: '5095 WATERFORD DR.',
    city: 'SHEFFIELD VILLAGE',
    state: 'OH',
    zip: 44035,
    telephone: '(440) 934-3101 EXT 2330',
    population: 215,
    county: 'LORAIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ohiobusinesscollege.edu/',
  },
  {
    name: 'GLENDALE CAREER COLLEGE-BRIGHTWOOD TEACHOUT',
    address: '8888 BALBOA AVENUE',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92123,
    telephone: '(858) 715-1123',
    population: 217,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'glendalecareer.com/',
  },
  {
    name: 'HUSSIAN COLLEGE-DAYMAR COLLEGE NASHVILLE',
    address: '560 ROYAL PARKWAY',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37214,
    telephone: '(717) 380-1385',
    population: 217,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daymarcollege.edu/',
  },
  {
    name: 'EVANGELICAL THEOLOGICAL SEMINARY',
    address: '121 S COLLEGE ST',
    city: 'MYERSTOWN',
    state: 'PA',
    zip: 17067,
    telephone: '(717) 866-5775',
    population: 218,
    county: 'LEBANON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.evangelical.edu/',
  },
  {
    name: 'PLATT COLLEGE-MCCANN-LEWISBURG',
    address: '7495 WESTBRANCH HWY',
    city: 'LEWISBURG',
    state: 'PA',
    zip: 17837,
    telephone: '(570) 286-3058',
    population: 218,
    county: 'UNION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mccann.edu/',
  },
  {
    name: 'SIMMONS COLLEGE OF KENTUCKY',
    address: '1018 SOUTH 7TH STREET',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40203,
    telephone: '(502) 776-1443 EXT 5113',
    population: 219,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.simmonscollegeky.edu/',
  },
  {
    name: 'WADE COLLEGE',
    address: '1950 N. STEMMONS FREEWAY, SUITE 4080 DALLAS INFOMART',
    city: 'DALLAS',
    state: 'TX',
    zip: 75207,
    telephone: '(214) 637-3530',
    population: 219,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wadecollege.edu/',
  },
  {
    name: 'PITTSBURGH INSTITUTE OF MORTUARY SCIENCE INC',
    address: '5808 BAUM BLVD',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15206,
    telephone: '(412) 362-8500',
    population: 219,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pims.edu/',
  },
  {
    name: 'LIVING ARTS COLLEGE',
    address: '3000 WAKEFIELD CROSSING DRIVE',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27614,
    telephone: '(919) 488-8500',
    population: 219,
    county: 'WAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'living-arts-college.edu/',
  },
  {
    name: 'ATHENAEUM OF OHIO',
    address: '6616 BEECHMONT AVE',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45230,
    telephone: '(513) 231-2223',
    population: 220,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.athenaeum.edu/',
  },
  {
    name: 'OTTAWA UNIVERSITY-ONLINE',
    address: '1001 SOUTH CEDAR',
    city: 'OTTAWA',
    state: 'KS',
    zip: 66067,
    telephone: '(785) 242-5200',
    population: 221,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/',
  },
  {
    name: 'NEW SAINT ANDREWS COLLEGE',
    address: '405 S. MAIN STREET',
    city: 'MOSCOW',
    state: 'ID',
    zip: 83843,
    telephone: '(208) 882-1566 EXT 101',
    population: 221,
    county: 'LATAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'nsa.edu/',
  },
  {
    name: 'ARIZONA COLLEGE-DALLAS',
    address: '8330 LBJ FREEWAY SUITE 100',
    city: 'DALLAS',
    state: 'TX',
    zip: 75243,
    telephone: '(855) 706-8382',
    population: 221,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'INTERNATIONAL INSTITUTE FOR RESTORATIVE PRACTICES',
    address: '544 MAIN STREET',
    city: 'BETHLEHEM',
    state: 'PA',
    zip: 18018,
    telephone: '(610) 807-9221',
    population: 221,
    county: 'NORTHAMPTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'iirp.edu/',
  },
  {
    name: "SH'OR YOSHUV RABBINICAL COLLEGE",
    address: '1 CEDARLAWN AVENUE',
    city: 'LAWRENCE',
    state: 'NY',
    zip: 11559,
    telephone: '(516) 239-9002 EXT 112',
    population: 222,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.shoryoshuv.org/',
  },
  {
    name: 'LOUISVILLE PRESBYTERIAN THEOLOGICAL SEMINARY',
    address: '1044 ALTA VISTA RD',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40205,
    telephone: '(502) 895-3411',
    population: 222,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lpts.edu/',
  },
  {
    name: 'UNIVERSAL TECHNOLOGY COLLEGE OF PUERTO RICO',
    address: '111 COMERCIO ST',
    city: 'AGUADILLA',
    state: 'PR',
    zip: 603,
    telephone: '(787) 882-2065 EXT 239',
    population: 222,
    county: 'AGUADILLA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.unitecpr.edu/',
  },
  {
    name: 'NORTHEASTERN SEMINARY',
    address: '2265 WESTSIDE DR',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14624,
    telephone: '(585) 594-6800',
    population: 223,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nes.edu/',
  },
  {
    name: 'ARIZONA COLLEGE-DALLAS',
    address: '8330 LBJ FREEWAY SUITE 100',
    city: 'DALLAS',
    state: 'TX',
    zip: 75243,
    telephone: '(855) 706-8382',
    population: 223,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.arizonacollege.edu',
  },
  {
    name: 'MID-ATLANTIC CHRISTIAN UNIVERSITY',
    address: '715 N POINDEXTER ST',
    city: 'ELIZABETH CITY',
    state: 'NC',
    zip: 27909,
    telephone: '(252) 334-2000',
    population: 223,
    county: 'PASQUOTANK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.macuniversity.edu/',
  },
  {
    name: 'SAE EXPRESSION COLLEGE',
    address: '6601 SHELLMOND ST',
    city: 'EMERYVILLE',
    state: 'CA',
    zip: 94608,
    telephone: '(510) 654-2934',
    population: 223,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'usa.sae.edu/campuses/emeryville/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-RANCHO CORDOVA',
    address: '11050 OLSON DRIVE',
    city: 'RANCHO CORDOVA',
    state: 'CA',
    zip: 95670,
    telephone: '(559) 734-9000',
    population: 223,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'MERIDIAN COLLEGE',
    address: '7020 PROFESSIONAL PKWY E',
    city: 'SARASOTA',
    state: 'FL',
    zip: 34240,
    telephone: '(941) 377-4880',
    population: 223,
    county: 'SARASOTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.meridian.edu/',
  },
  {
    name: 'CARIBBEAN UNIVERSITY-CAROLINA',
    address: 'CALLE IGNACIO ARZUAGA #208',
    city: 'CAROLINA',
    state: 'PR',
    zip: 985,
    telephone: '(787) 769-0007',
    population: 224,
    county: 'CAROLINA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caribbean.edu/',
  },
  {
    name: 'GREAT LAKES CHRISTIAN COLLEGE',
    address: '6211 W WILLOW HWY',
    city: 'LANSING',
    state: 'MI',
    zip: 48917,
    telephone: '(517) 321-0242',
    population: 224,
    county: 'EATON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.glcc.edu/',
  },
  {
    name: 'RAINY RIVER COMMUNITY COLLEGE',
    address: '1501 HIGHWAY 71',
    city: 'INTERNATIONAL FALLS',
    state: 'MN',
    zip: 56649,
    telephone: '(218) 285-7722',
    population: 225,
    county: 'KOOCHICHING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rainyriver.edu/',
  },
  {
    name: 'CHARLOTTE CHRISTIAN COLLEGE AND THEOLOGICAL SEMINARY',
    address: '7520 EAST INDEPENDENCE BLVD, SUITE 100',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28227,
    telephone: '(704) 334-6882 EXT 100',
    population: 226,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.charlottechristian.edu/',
  },
  {
    name: 'MANHATTAN CHRISTIAN COLLEGE',
    address: '1415 ANDERSON AVE',
    city: 'MANHATTAN',
    state: 'KS',
    zip: 66502,
    telephone: '(785) 539-3571',
    population: 226,
    county: 'RILEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mccks.edu/',
  },
  {
    name: 'AMERICAN ACADEMY OF DRAMATIC ARTS-NEW YORK',
    address: '120 MADISON AVE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10016,
    telephone: '(212) 686-9244',
    population: 226,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aada.edu/',
  },
  {
    name: 'JOHNSON UNIVERSITY FLORIDA',
    address: '1011 BILL BECK BLVD',
    city: 'KISSIMMEE',
    state: 'FL',
    zip: 34744,
    telephone: '(407) 847-8966',
    population: 227,
    county: 'OSCEOLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'johnsonu.edu/',
  },
  {
    name: 'FLORIDA COASTAL SCHOOL OF LAW',
    address: '8787 BAYPINE ROAD',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32256,
    telephone: '(904) 680-7700',
    population: 227,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fcsl.edu/',
  },
  {
    name: 'INTERCOAST COLLEGES-FAIRFIELD',
    address: '5253 BUSINESS CTR. DR. STE B',
    city: 'FAIRFIELD',
    state: 'CA',
    zip: 94534,
    telephone: '(707) 421-9700',
    population: 227,
    county: 'SOLANO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.intercoast.edu/',
  },
  {
    name: 'VET TECH INSTITUTE OF HOUSTON',
    address: '4669 SOUTHWEST FWY STE 100',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77027,
    telephone: '(713) 629-1500',
    population: 227,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'vti.edu/',
  },
  {
    name: 'CENTURA COLLEGE-NEWPORT NEWS',
    address: '616 DENBIGH BLVD.',
    city: 'NEWPORT NEWS',
    state: 'VA',
    zip: 23608,
    telephone: '(757) 874-2121',
    population: 227,
    county: 'NEWPORT NEWS CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.centuracollege.edu/campuses/newport-news/',
  },
  {
    name: 'FREMONT COLLEGE',
    address: '18000 STUDEBAKER ROAD SUITE 900A',
    city: 'CERRITOS',
    state: 'CA',
    zip: 90703,
    telephone: '(562) 809-5100',
    population: 227,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fremont.edu/',
  },
  {
    name: 'NAZARENE THEOLOGICAL SEMINARY',
    address: '1700 E MEYER BLVD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64131,
    telephone: '(816) 268-5400',
    population: 228,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nts.edu/',
  },
  {
    name: 'CATHOLIC DISTANCE UNIVERSITY',
    address: '300 S. GEORGE STREET',
    city: 'CHARLES TOWN',
    state: 'WV',
    zip: 25414,
    telephone: '(888) 254-4238 EXT 0',
    population: 228,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cdu.edu/',
  },
  {
    name: 'YESHIVA OF NITRA RABBINICAL COLLEGE',
    address: 'CROTON LAKE ROAD',
    city: 'MOUNT KISCO',
    state: 'NY',
    zip: 10549,
    telephone: '(718) 384-5460 EXT 204',
    population: 228,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivaofnitra.org/',
  },
  {
    name: 'HEBREW COLLEGE',
    address: '160 HERRICK ROAD',
    city: 'NEWTON CENTRE',
    state: 'MA',
    zip: 2459,
    telephone: '(617) 559-8600',
    population: 229,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hebrewcollege.edu/',
  },
  {
    name: 'APPALACHIAN SCHOOL OF LAW',
    address: '1169 EDGEWATER DRIVE',
    city: 'GRUNDY',
    state: 'VA',
    zip: 24614,
    telephone: '(276) 935-4349 EXT 1231',
    population: 230,
    county: 'BUCHANAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asl.edu/',
  },
  {
    name: 'TRINITY COLLEGE OF NURSING & HEALTH SCIENCES',
    address: '2122 25TH AVENUE',
    city: 'ROCK ISLAND',
    state: 'IL',
    zip: 61201,
    telephone: '(309) 779-7700',
    population: 231,
    county: 'ROCK ISLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.trinitycollegeqc.edu/default.aspx',
  },
  {
    name: 'APPALACHIAN COLLEGE OF PHARMACY',
    address: '1060 DRAGON ROAD',
    city: 'OAKWOOD',
    state: 'VA',
    zip: 24631,
    telephone: '(276) 498-4190 EXT 5230',
    population: 231,
    county: 'BUCHANAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acp.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE OF OHR SHIMON YISROEL',
    address: '215-217 HEWES ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11211,
    telephone: '(718) 855-4092 EXT 0',
    population: 232,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ohr-sy.com/',
  },
  {
    name: 'UNIVERSIDAD PENTECOSTAL MIZPA',
    address: 'BO CAIMITO RD 199 KM 0.3',
    city: 'RIO PIEDRAS',
    state: 'PR',
    zip: 928,
    telephone: '(787) 720-4476 EXT 300',
    population: 232,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'mizpa.edu/',
  },
  {
    name: 'THE MODERN COLLEGE OF DESIGN',
    address: '1725 E DAVID RD',
    city: 'KETTERING',
    state: 'OH',
    zip: 45440,
    telephone: '(937) 294-0592',
    population: 233,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://themodern.edu/',
  },
  {
    name: 'SOUTHWESTERN COLLEGE',
    address: '3960 SAN FELIPE ROAD',
    city: 'SANTA FE',
    state: 'NM',
    zip: 87507,
    telephone: '(505) 467-6806',
    population: 233,
    county: 'SANTA FE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.swc.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-CITRUS HEIGHTS',
    address: '7310 A GREENBACK LANE A',
    city: 'CITRUS HEIGHTS',
    state: 'CA',
    zip: 95621,
    telephone: '(916) 209-5079',
    population: 235,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-LANCASTER',
    address: '42135 10TH STREET WEST',
    city: 'LANCASTER',
    state: 'CA',
    zip: 93534,
    telephone: '(559) 734-9000',
    population: 235,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'CHRISTIAN THEOLOGICAL SEMINARY',
    address: '1000 W 42ND ST',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46208,
    telephone: '(317) 924-1331',
    population: 236,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cts.edu/',
  },
  {
    name: 'MILLENNIA ATLANTIC UNIVERSITY',
    address: '3801 NW 97TH AVENUE, SUITE 100',
    city: 'DORAL',
    state: 'FL',
    zip: 33178,
    telephone: '(786) 331-1000',
    population: 237,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.maufl.edu/',
  },
  {
    name: 'BLESSING RIEMAN COLLEGE OF NURSING AND HEALTH SCIENCES',
    address: '3609 NORTH MARX DRIVE',
    city: 'QUINCY',
    state: 'IL',
    zip: 62305,
    telephone: '(217) 228-5520 EXT 6905',
    population: 238,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brcn.edu/',
  },
  {
    name: 'HELLENIC COLLEGE-HOLY CROSS GREEK ORTHODOX SCHOOL OF THEOLOGY',
    address: '50 GODDARD AVE',
    city: 'BROOKLINE',
    state: 'MA',
    zip: 2445,
    telephone: '(617) 731-3500 EXT 1222',
    population: 238,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hchc.edu/',
  },
  {
    name: 'COLLEGE UNBOUND',
    address: '325 PUBLIC STREET',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2905,
    telephone: '(401) 752-2640',
    population: 239,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'collegeunbound.org/',
  },
  {
    name: 'AMERICAN ACADEMY OF ART',
    address: '332 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60604,
    telephone: '(312) 461-0600',
    population: 239,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.aaart.edu/',
  },
  {
    name: 'CHATFIELD COLLEGE',
    address: '20918 STATE ROUTE 251',
    city: 'SAINT MARTIN',
    state: 'OH',
    zip: 45118,
    telephone: '(513) 875-3344 EXT 152',
    population: 239,
    county: 'BROWN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chatfield.edu/',
  },
  {
    name: 'OHEL MARGULIA SEMINARY',
    address: '22 ASHEL LANE',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 731-3730',
    population: 239,
    county: 'ROCKLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ohelmarguliaseminary.com/',
  },
  {
    name: 'CONCORDE CAREER INSTITUTE-ORLANDO',
    address: '3444 MCCRORY PLACE',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32803,
    telephone: '(407) 812-3060',
    population: 239,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/orlando-florida',
  },
  {
    name: 'MAINE COLLEGE OF HEALTH PROFESSIONS',
    address: '70 MIDDLE STREET',
    city: 'LEWISTON',
    state: 'ME',
    zip: 4240,
    telephone: '(207) 795-2840',
    population: 240,
    county: 'ANDROSCOGGIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mchp.edu/',
  },
  {
    name: 'AMERICAN NATIONAL UNIVERSITY-PIKEVILLE',
    address: '50 NATIONAL COLLEGE BOULEVARD',
    city: 'PIKEVILLE',
    state: 'KY',
    zip: 41501,
    telephone: '(859) 253-0621',
    population: 241,
    county: 'PIKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.an.edu/locations/',
  },
  {
    name: 'DEVRY UNIVERSITY-VIRGINIA',
    address: '1400 CRYSTAL DR, STE 120',
    city: 'ARLINGTON',
    state: 'VA',
    zip: 22202,
    telephone: '(703) 414-4000',
    population: 242,
    county: 'ARLINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'CEM COLLEGE-HUMACAO',
    address: '8 DR VIDAL ST',
    city: 'HUMACAO',
    state: 'PR',
    zip: 791,
    telephone: '(787) 850-8333',
    population: 242,
    county: 'HUMACAO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cemcollege.edu/cem/',
  },
  {
    name: 'CANKDESKA CIKANA COMMUNITY COLLEGE',
    address: '214 1ST AVE',
    city: 'FORT TOTTEN',
    state: 'ND',
    zip: 58335,
    telephone: '(701) 766-4415',
    population: 245,
    county: 'BENSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.littlehoop.edu/',
  },
  {
    name: 'TRI-COMMUNITY ADULT EDUCATION',
    address: '231 STEPHANIE DRIVE',
    city: 'COVINA',
    state: 'CA',
    zip: 91722,
    telephone: '(626) 974-4200',
    population: 245,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tri-communityadulted.org/',
  },
  {
    name: 'SAN JOAQUIN COLLEGE OF LAW',
    address: '901 FIFTH ST',
    city: 'CLOVIS',
    state: 'CA',
    zip: 93612,
    telephone: '(559) 323-2100',
    population: 246,
    county: 'FRESNO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjcl.edu/',
  },
  {
    name: 'SOUTHEAST MISSOURI HOSPITAL COLLEGE OF NURSING AND HEALTH SCIENCES',
    address: '2001 WILLIAM STREET',
    city: 'CAPE GIRARDEAU',
    state: 'MO',
    zip: 63703,
    telephone: '(573) 334-6825',
    population: 246,
    county: 'CAPE GIRARDEAU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sehcollege.edu/',
  },
  {
    name: 'BETHLEHEM COLLEGE & SEMINARY',
    address: '720 13TH AVENUE SOUTH',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55415,
    telephone: '(612) 455-3420',
    population: 247,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'bcsmn.edu/',
  },
  {
    name: 'YESHIVA TORAS CHAIM',
    address: '999 RIDGE AVE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 942-3090',
    population: 247,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ytclakewood.com/',
  },
  {
    name: 'WEST VIRGINIA JUNIOR COLLEGE-CHARLESTON',
    address: '5514 BIG TYLER ROAD SUITE 200',
    city: 'CROSS LANES',
    state: 'WV',
    zip: 25313,
    telephone: '(304) 345-2820',
    population: 247,
    county: 'KANAWHA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wvjc.edu/',
  },
  {
    name: 'LOS ANGELES COUNTY COLLEGE OF NURSING AND ALLIED HEALTH',
    address: '1237 N. MISSION RD.',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90033,
    telephone: '(323) 409-5911',
    population: 247,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'dhs.lacounty.gov/wps/portal/dhs/conah/',
  },
  {
    name: 'SEMINARY BNOS CHAIM',
    address: '388 CHESTNUT STREET',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 730-7589',
    population: 248,
    county: 'OCEAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.seminarybnoschaim.com/',
  },
  {
    name: 'NUETA HIDATSA SAHNISH COLLEGE',
    address: '301 COLLEGE DRIVE',
    city: 'NEW TOWN',
    state: 'ND',
    zip: 58763,
    telephone: '(701) 627-4738',
    population: 248,
    county: 'MOUNTRAIL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nhsc.edu/',
  },
  {
    name: 'TRINITY INTERNATIONAL UNIVERSITY-FLORIDA',
    address: '9010 SW 137TH AVE, SUITE #101',
    city: 'MIAMI',
    state: 'FL',
    zip: 33186,
    telephone: '(954) 382-6400',
    population: 249,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'florida.tiu.edu/',
  },
  {
    name: 'CITY COLLEGE-HOLLYWOOD',
    address: '6565 TAFT STREET',
    city: 'HOLLYWOOD',
    state: 'FL',
    zip: 33024,
    telephone: '(954) 977-1777',
    population: 249,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.citycollege.edu/',
  },
  {
    name: 'TRINITY EPISCOPAL SCHOOL FOR MINISTRY',
    address: '311 ELEVENTH ST',
    city: 'AMBRIDGE',
    state: 'PA',
    zip: 15003,
    telephone: '(724) 266-3838',
    population: 250,
    county: 'BEAVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tsm.edu/',
  },
  {
    name: 'PACIFIC COLLEGE OF HEALTH SCIENCE-CHICAGO',
    address: '65 EAST WACKER PLACE, 21ST FL',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60601,
    telephone: '(773) 477-4822 EXT 301',
    population: 252,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pacificcollege.edu/',
  },
  {
    name: 'AUSTIN PRESBYTERIAN THEOLOGICAL SEMINARY',
    address: '100 E 27TH ST',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78705,
    telephone: '(512) 404-4800',
    population: 252,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.austinseminary.edu/',
  },
  {
    name: 'WESTERN MARICOPA EDUCATION CENTER',
    address: '6997 N GLEN HARBOR BLVD',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85307,
    telephone: '(623) 738-0022',
    population: 252,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://west-mec.edu/findyourhappy/',
  },
  {
    name: 'SIT GRADUATE INSTITUTE',
    address: '1 KIPLING RD',
    city: 'BRATTLEBORO',
    state: 'VT',
    zip: 5302,
    telephone: '(802) 257-7751',
    population: 254,
    county: 'WINDHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sit.edu/',
  },
  {
    name: 'MICHIGAN SCHOOL OF PSYCHOLOGY',
    address: '26811 ORCHARD LAKE RD.',
    city: 'FARMINGTON HILLS',
    state: 'MI',
    zip: 48334,
    telephone: '(248) 476-1122 EXT 100',
    population: 255,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msp.edu/',
  },
  {
    name: "CROWLEY'S RIDGE COLLEGE",
    address: '100 COLLEGE DR',
    city: 'PARAGOULD',
    state: 'AR',
    zip: 72450,
    telephone: '(870) 236-6901',
    population: 255,
    county: 'GREENE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.crc.edu/',
  },
  {
    name: 'HUNTINGTON JUNIOR COLLEGE',
    address: '900 FIFTH AVE',
    city: 'HUNTINGTON',
    state: 'WV',
    zip: 25701,
    telephone: '(304) 697-7550',
    population: 255,
    county: 'CABELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.huntingtonjuniorcollege.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-MACON',
    address: '175 TOM HILL SR BLVD',
    city: 'MACON',
    state: 'GA',
    zip: 31210,
    telephone: '(478) 803-4800',
    population: 255,
    county: 'BIBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.miller-motte.edu/',
  },
  {
    name: 'PITTSBURGH CAREER INSTITUTE',
    address: '421 SEVENTH AVENUE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15219,
    telephone: '(412) 281-2600',
    population: 256,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.pci.edu/',
  },
  {
    name: 'VERITAS BAPTIST COLLEGE',
    address: '181 US 50 E., SUITE 204',
    city: 'GREENDALE',
    state: 'IN',
    zip: 47025,
    telephone: '(812) 221-1714',
    population: 257,
    county: 'DEARBORN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vbc.edu/',
  },
  {
    name: 'BLUE CLIFF COLLEGE-HOUMA',
    address: '803 BARROW ST',
    city: 'HOUMA',
    state: 'LA',
    zip: 70360,
    telephone: '(985) 601-4000',
    population: 257,
    county: 'TERREBONNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bluecliffcollege.edu/',
  },
  {
    name: 'THE ART INSTITUTE OF VIRGINIA BEACH',
    address: 'TWO COLUMBUS CENTER, 4500 MAIN ST STE 100',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23462,
    telephone: '(757) 493-6700',
    population: 258,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/virginia-beach/',
  },
  {
    name: 'VALLEY COLLEGE-CLEVELAND',
    address: '8700 BROOKPARK ROAD',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44129,
    telephone: '(216) 453-8201',
    population: 258,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.valley.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-NEW JERSEY',
    address: '517 ROUTE 1 S, STE 1000',
    city: 'ISELIN',
    state: 'NJ',
    zip: 8830,
    telephone: '(732) 729-3960',
    population: 259,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-NORTH CAROLINA',
    address: '2015 AYRSLEY TOWN BOULEVARD, SUITE 204',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28273,
    telephone: '(980) 939-6241',
    population: 259,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'NEW YORK COLLEGE OF TRADITIONAL CHINESE MEDICINE',
    address: '200 OLD COUNTRY ROAD, SUITE 500',
    city: 'MINEOLA',
    state: 'NY',
    zip: 11501,
    telephone: '(516) 739-1545',
    population: 261,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyctcm.edu/',
  },
  {
    name: 'EASTERN VIRGINIA CAREER COLLEGE',
    address: '10304 SPOTSYLVANIA AVE, SUITE 400',
    city: 'FREDERICKSBURG',
    state: 'VA',
    zip: 22408,
    telephone: '(540) 373-4465 EXT 221',
    population: 261,
    county: 'SPOTSYLVANIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.evcc.edu/',
  },
  {
    name: 'ECCLESIA COLLEGE',
    address: '9653 NATIONS DR',
    city: 'SPRINGDALE',
    state: 'AR',
    zip: 72762,
    telephone: '(479) 248-7236',
    population: 262,
    county: 'BENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ecollege.edu/',
  },
  {
    name: "ST LUKE'S COLLEGE",
    address: '2720 STONE PARK BLVD',
    city: 'SIOUX CITY',
    state: 'IA',
    zip: 51104,
    telephone: '(712) 279-3149',
    population: 262,
    county: 'WOODBURY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stlukescollege.edu/',
  },
  {
    name: 'DOUGLAS EDUCATION CENTER',
    address: '130 7TH ST',
    city: 'MONESSEN',
    state: 'PA',
    zip: 15062,
    telephone: '(724) 684-3684',
    population: 262,
    county: 'WESTMORELAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dec.edu/',
  },
  {
    name: 'ILIFF SCHOOL OF THEOLOGY',
    address: '2323 E. ILIFF AVE.',
    city: 'DENVER',
    state: 'CO',
    zip: 80210,
    telephone: '(303) 744-1287',
    population: 263,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iliff.edu/',
  },
  {
    name: 'POLYTECHNIC UNIVERSITY OF PUERTO RICO-ORLANDO',
    address: '550 N ECONLOCKHATCHEE TR',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32825,
    telephone: '(407) 677-7000 EXT 801',
    population: 263,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pupr.edu/orlando',
  },
  {
    name: 'CENTRAL CHRISTIAN COLLEGE OF THE BIBLE',
    address: '911 E URBANDALE DR',
    city: 'MOBERLY',
    state: 'MO',
    zip: 65270,
    telephone: '(660) 263-3900 EXT 110',
    population: 263,
    county: 'RANDOLPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cccb.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-CALIFORNIA',
    address: '10971 SUN CENTER',
    city: 'RANCHO CORDOVA',
    state: 'CA',
    zip: 95670,
    telephone: '(916) 330-3410',
    population: 263,
    county: 'SACRAMENTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'AVIATION INSTITUTE OF MAINTENANCE-NORFOLK',
    address: '2329 E. LITTLE CREEK ROAD',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23518,
    telephone: '(757) 363-2121',
    population: 263,
    county: 'NORFOLK CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aviationmaintenance.edu/campuses/norfolk-va/',
  },
  {
    name: 'TAYLOR COLLEGE',
    address: '5190 SE 125TH STREET',
    city: 'BELLEVIEW',
    state: 'FL',
    zip: 34420,
    telephone: '(352) 245-4119',
    population: 263,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.taylorcollege.edu/',
  },
  {
    name: 'SAINT CHARLES BORROMEO SEMINARY-OVERBROOK',
    address: '100 EAST WYNNEWOOD ROAD',
    city: 'WYNNEWOOD',
    state: 'PA',
    zip: 19096,
    telephone: '(610) 667-3394',
    population: 264,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scs.edu/',
  },
  {
    name: 'HEBREW THEOLOGICAL COLLEGE',
    address: '7135 N CARPENTER RD',
    city: 'SKOKIE',
    state: 'IL',
    zip: 60077,
    telephone: '(847) 982-2500',
    population: 264,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.htc.edu/',
  },
  {
    name: 'WARTBURG THEOLOGICAL SEMINARY',
    address: '333 WARTBURG PL',
    city: 'DUBUQUE',
    state: 'IA',
    zip: 52003,
    telephone: '(563) 589-0200',
    population: 265,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wartburgseminary.edu/',
  },
  {
    name: 'MIDDLE TENNESSEE SCHOOL OF ANESTHESIA INC',
    address: '315 HOSPITAL DRIVE',
    city: 'MADISON',
    state: 'TN',
    zip: 37115,
    telephone: '(615) 732-7670',
    population: 266,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtsa.edu/',
  },
  {
    name: 'MARTIN UNIVERSITY',
    address: '2186 NORTH SHERMAN DRIVE',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46218,
    telephone: '(317) 543-3235',
    population: 266,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.martin.edu/',
  },
  {
    name: 'GWINNETT COLLEGE-LILBURN',
    address: '4230 HWY 29 STE 11',
    city: 'LILBURN',
    state: 'GA',
    zip: 30047,
    telephone: '(770) 381-7200',
    population: 266,
    county: 'GWINNETT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gwinnettcollege.edu/',
  },
  {
    name: 'ICPR JUNIOR COLLEGE-ARECIBO',
    address: '20 SAN PATRICIO',
    city: 'ARECIBO',
    state: 'PR',
    zip: 614,
    telephone: '(787) 878-6000',
    population: 266,
    county: 'ARECIBO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.icprjc.edu/',
  },
  {
    name: 'AMERICAN JEWISH UNIVERSITY',
    address: '15600 MULHOLLAND DR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90077,
    telephone: '(310) 476-9777',
    population: 267,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aju.edu/',
  },
  {
    name: 'EASTERN INTERNATIONAL COLLEGE-BELLEVILLE',
    address: '251 WASHINGTON AVE',
    city: 'BELLEVILLE',
    state: 'NJ',
    zip: 7109,
    telephone: '(973) 751-9051 EXT 202',
    population: 267,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eicollege.edu/',
  },
  {
    name: 'ATA COLLEGE-CINCINNATI',
    address: '225 PICTORIA DRIVE, SUITE 200',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45246,
    telephone: '(513) 671-1920',
    population: 267,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ata.edu/',
  },
  {
    name: 'AMBRIA COLLEGE OF NURSING',
    address: '5210 TRILLIUM BLVD',
    city: 'HOFFMAN ESTATES',
    state: 'IL',
    zip: 60192,
    telephone: '(847) 397-0300 EXT 2271',
    population: 267,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ambria.edu/',
  },
  {
    name: 'UNIVERSITY OF THE POTOMAC-WASHINGTON DC CAMPUS',
    address: '1401 H STREET NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20005,
    telephone: '(202) 274-2300',
    population: 268,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.potomac.edu/',
  },
  {
    name: 'THE ART INSTITUTE OF AUSTIN',
    address: '1204 CHESTNUT ST.',
    city: 'BASTROP',
    state: 'TX',
    zip: 78602,
    telephone: '(512) 691-1707',
    population: 269,
    county: 'BASTROP',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/austin/',
  },
  {
    name: 'CENTURA COLLEGE-NORFOLK',
    address: '7020 NORTH MILITARY HIGHWAY',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23518,
    telephone: '(757) 853-2121',
    population: 269,
    county: 'NORFOLK CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.centuracollege.edu/campuses/norfolk/',
  },
  {
    name: 'DERECH HACHAIM SEMINARY',
    address: '5A ISRAEL ZUPNICK DRIVE',
    city: 'MONROE',
    state: 'NY',
    zip: 10950,
    telephone: '(845) 783-5820',
    population: 270,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'derechhachaimseminary.com',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE-JACKSONVILLE',
    address: '105 NEW FRONTIER WAY',
    city: 'JACKSONVILLE',
    state: 'NC',
    zip: 28546,
    telephone: '(910) 478-4300',
    population: 271,
    county: 'ONSLOW',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'OTTAWA UNIVERSITY-MILWAUKEE',
    address: '245 SOUTH EXECUTIVE DRIVE, SUITE 110',
    city: 'BROOKFIELD',
    state: 'WI',
    zip: 53005,
    telephone: '(262) 879-0200',
    population: 272,
    county: 'WAUKESHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/',
  },
  {
    name: 'ATA CAREER EDUCATION',
    address: '7351 SPRING HILL DRIVE, SUITE 11',
    city: 'SPRING HILL',
    state: 'FL',
    zip: 34606,
    telephone: '(352) 684-3007',
    population: 272,
    county: 'HERNANDO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.atafl.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-TEXAS',
    address: '11451 KATY FREEWAY',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77079,
    telephone: '(866) 766-0766',
    population: 273,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'MDT COLLEGE OF HEALTH SCIENCES',
    address: '325 ALPHA PARK DR',
    city: 'HIGHLAND HEIGHTS',
    state: 'OH',
    zip: 44143,
    telephone: '(440) 449-1700',
    population: 273,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.atsinstitute.edu/',
  },
  {
    name: 'LITTLE BIG HORN COLLEGE',
    address: '8645 SOUTH WEAVER DRIVE',
    city: 'CROW AGENCY',
    state: 'MT',
    zip: 59022,
    telephone: '(406) 638-3104',
    population: 274,
    county: 'BIG HORN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lbhc.edu/',
  },
  {
    name: 'GRACE MISSION UNIVERSITY',
    address: '1645 WEST VALENCIA DRIVE',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92833,
    telephone: '(714) 525-0088',
    population: 274,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gm.edu/',
  },
  {
    name: 'YESHIVATH ZICHRON MOSHE',
    address: 'LAUREL PARK ROAD',
    city: 'SOUTH FALLSBURG',
    state: 'NY',
    zip: 12779,
    telephone: '(845) 434-5240',
    population: 275,
    county: 'SULLIVAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivathzichronmoshe.com/',
  },
  {
    name: 'GRADUATE THEOLOGICAL UNION',
    address: '2400 RIDGE RD',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94709,
    telephone: '(510) 649-2400',
    population: 275,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gtu.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-INDIANA',
    address: '9100 KEYSTONE CROSSING, SUITE 300',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46240,
    telephone: '(317) 816-7335',
    population: 275,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'COMMONWEALTH INSTITUTE OF FUNERAL SERVICE',
    address: '415 BARREN SPRINGS DR',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77090,
    telephone: '(281) 873-0262',
    population: 275,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.commonwealth.edu/',
  },
  {
    name: 'CENTER FOR ADVANCED LEGAL STUDIES',
    address: '800 W SAM HOUSTON PARKWAY S, SUITE 100',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77042,
    telephone: '(713) 529-2778',
    population: 275,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.paralegal.edu/',
  },
  {
    name: 'CITY COLLEGE-ALTAMONTE SPRINGS',
    address: '177 MONTGOMERY ROAD',
    city: 'ALTAMONTE SPRINGS',
    state: 'FL',
    zip: 32714,
    telephone: '(407) 831-9816',
    population: 275,
    county: 'SEMINOLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.citycollege.edu/',
  },
  {
    name: 'OBLATE SCHOOL OF THEOLOGY',
    address: '285 OBLATE DR',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78216,
    telephone: '(210) 341-1366',
    population: 276,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ost.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-COOKEVILLE',
    address: '1025 HIGHWAY 111',
    city: 'COOKEVILLE',
    state: 'TN',
    zip: 38501,
    telephone: '(931) 526-3660',
    population: 278,
    county: 'PUTNAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF ADVANCED MANAGEMENT',
    address: '1000 S. FREMONT AVE. MAILBOX #45, BLDG A10, 4TH FLOOR, SUITE 10402',
    city: 'ALHAMBRA',
    state: 'CA',
    zip: 91803,
    telephone: '(626) 350-1500',
    population: 279,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ciam.edu/',
  },
  {
    name: 'UNION PRESBYTERIAN SEMINARY',
    address: '3401 BROOK RD',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23227,
    telephone: '(804) 355-0671',
    population: 280,
    county: 'RICHMOND CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upsem.edu/',
  },
  {
    name: 'GUPTON JONES COLLEGE OF FUNERAL SERVICE',
    address: '5141 SNAPFINGER WOODS DR',
    city: 'DECATUR',
    state: 'GA',
    zip: 30035,
    telephone: '(770) 593-2257',
    population: 280,
    county: 'DEKALB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gupton-jones.edu/',
  },
  {
    name: 'VISIBLE MUSIC COLLEGE',
    address: '200 MADISON AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38103,
    telephone: '(901) 381-3939',
    population: 281,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.visible.edu/',
  },
  {
    name: 'AMERICAN INTERCONTINENTAL UNIVERSITY-HOUSTON',
    address: '9999 RICHMOND AVENUE',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77042,
    telephone: '(832) 201-3600',
    population: 281,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aiuniv.edu/online-campus/campus-locations/houston',
  },
  {
    name: 'BARCLAY COLLEGE',
    address: '607 N KINGMAN',
    city: 'HAVILAND',
    state: 'KS',
    zip: 67059,
    telephone: '(620) 862-5252',
    population: 282,
    county: 'KIOWA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.barclaycollege.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-SAN LEANDRO CAMPUS',
    address: '15555 EAST 14TH STREET',
    city: 'SAN LEANDRO',
    state: 'CA',
    zip: 94578,
    telephone: '(510) 964-3085 EXT 888',
    population: 282,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'ALDER GRADUATE SCHOOL OF EDUCATION',
    address: '2946 BROADWAY',
    city: 'REDWOOD CITY',
    state: 'CA',
    zip: 94062,
    telephone: '(650) 362-3997',
    population: 283,
    county: 'SAN MATEO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://aldergse.edu/',
  },
  {
    name: 'OHEL MARGULIA SEMINARY',
    address: '22 ASHEL LANE',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 731-3730',
    population: 283,
    county: 'ROCKLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ohelmarguliaseminary.com/',
  },
  {
    name: 'COLUMBIA THEOLOGICAL SEMINARY',
    address: '701 S. COLUMBIA DR',
    city: 'DECATUR',
    state: 'GA',
    zip: 30030,
    telephone: '(404) 378-8821',
    population: 284,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ctsnet.edu/',
  },
  {
    name: 'TRINITY COLLEGE OF FLORIDA',
    address: '2430 WELBILT BOULEVARD',
    city: 'TRINITY',
    state: 'FL',
    zip: 34655,
    telephone: '(727) 376-6911',
    population: 284,
    county: 'PASCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'trinitycollege.edu/',
  },
  {
    name: 'DERECH HACHAIM SEMINARY',
    address: '5A ISRAEL ZUPNICK DRIVE',
    city: 'MONROE',
    state: 'NY',
    zip: 10950,
    telephone: '(845) 783-5820',
    population: 284,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'derechhachaimseminary.com/',
  },
  {
    name: 'EMMAUS BIBLE COLLEGE',
    address: '2570 ASBURY RD',
    city: 'DUBUQUE',
    state: 'IA',
    zip: 52001,
    telephone: '(563) 588-8000',
    population: 285,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.emmaus.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-ARIZONA',
    address: '2149 W. DUNLAP AVE.',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85021,
    telephone: '(602) 749-4500',
    population: 285,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-SCHOOL OF OPTOMETRY',
    address: '500 JOHN WILL HARRIS AVENUE',
    city: 'BAYAMON',
    state: 'PR',
    zip: 957,
    telephone: '(787) 765-1915 EXT 1020',
    population: 285,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.optonet.inter.edu/',
  },
  {
    name: 'PACIFIC ISLANDS UNIVERSITY',
    address: "172 KINNEY'S ROAD",
    city: 'MANGILAO',
    state: 'GU',
    zip: 96913,
    telephone: '(671) 734-1812',
    population: 285,
    county: 'GUAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.piu.edu/',
  },
  {
    name: 'CHATTANOOGA COLLEGE MEDICAL DENTAL AND TECHNICAL CAREERS',
    address: '248 NORTHGATE MALL DRIVE',
    city: 'CHATTANOOGA',
    state: 'TN',
    zip: 37415,
    telephone: '(423) 305-7781',
    population: 285,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chattanoogacollege.edu/',
  },
  {
    name: 'UNIVERSITY OF THE DISTRICT OF COLUMBIA-DAVID A CLARKE SCHOOL OF LAW',
    address: '4340 CONNECTICUT AVE NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20008,
    telephone: '(202) 274-7400',
    population: 286,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.law.udc.edu/',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-TUCSON',
    address: '300 SOUTH CRAYCROFT ROAD, SUITE 300',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85711,
    telephone: '(855) 706-8382',
    population: 287,
    county: 'PIMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'POMEROY COLLEGE OF NURSING AT CROUSE HOSPITAL',
    address: '765 IRVING AVE',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13210,
    telephone: '(315) 470-7256',
    population: 287,
    county: 'ONONDAGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.crouse.org/nursing',
  },
  {
    name: 'CALIFORNIA CAREER INSTITUTE',
    address: '1240 S STATE COLLEGE BLVD STE. 135',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92806,
    telephone: '(714) 539-5959',
    population: 287,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.calinstitute.edu/',
  },
  {
    name: 'APPALACHIAN BIBLE COLLEGE',
    address: '161 COLLEGE DRIVE',
    city: 'MOUNT HOPE',
    state: 'WV',
    zip: 25880,
    telephone: '(304) 877-6428',
    population: 288,
    county: 'RALEIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://abc.edu/',
  },
  {
    name: 'COLLEGE OF MENOMINEE NATION',
    address: 'N172 STATE HIGHWAY 47&55',
    city: 'KESHENA',
    state: 'WI',
    zip: 54135,
    telephone: '(715) 799-5600 EXT 3084',
    population: 288,
    county: 'MENOMINEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.menominee.edu/',
  },
  {
    name: 'SOUTH COAST COLLEGE',
    address: '2011 W. CHAPMAN AVENUE',
    city: 'ORANGE',
    state: 'CA',
    zip: 92868,
    telephone: '(714) 867-5009',
    population: 288,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southcoastcollege.edu/',
  },
  {
    name: 'WHITWORTH UNIVERSITY-ADULT DEGREE PROGRAMS',
    address: '300 W HAWTHORNE RD',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99251,
    telephone: '(509) 777-1000',
    population: 289,
    county: 'SPOKANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.whitworth.edu/cms/',
  },
  {
    name: 'THE SANTA BARBARA AND VENTURA COLLEGES OF LAW AT VENTURA',
    address: '4475 MARKET ST',
    city: 'VENTURA',
    state: 'CA',
    zip: 93003,
    telephone: '(805) 765-9300',
    population: 290,
    county: 'VENTURA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.collegesoflaw.edu/',
  },
  {
    name: 'CATHOLIC THEOLOGICAL UNION AT CHICAGO',
    address: '5416 S CORNELL AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60615,
    telephone: '(773) 324-8000 EXT 400',
    population: 290,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ctu.edu/',
  },
  {
    name: 'MISSIO THEOLOGICAL SEMINARY',
    address: '421 N. 7TH STREET, SUITE 700',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19123,
    telephone: '(215) 368-5000',
    population: 290,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.missio.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO-MANATI',
    address: 'MCKINLEY STREET #52',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 621-3652 EXT 4001',
    population: 290,
    county: 'MANATÍ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE-FAYETTEVILLE',
    address: '3725 RAMSEY ST.',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28311,
    telephone: '(910) 354-1900',
    population: 290,
    county: 'CUMBERLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'PITTSBURGH THEOLOGICAL SEMINARY',
    address: '616 N HIGHLAND AVE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15206,
    telephone: '(412) 362-5610',
    population: 292,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pts.edu/',
  },
  {
    name: 'DAYTONA COLLEGE',
    address: '425 SOUTH NOVA ROAD',
    city: 'ORMOND BEACH',
    state: 'FL',
    zip: 32174,
    telephone: '(386) 267-0565',
    population: 292,
    county: 'VOLUSIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'daytonacollege.edu/',
  },
  {
    name: 'PLATT COLLEGE-AURORA',
    address: '3100 S PARKER RD',
    city: 'AURORA',
    state: 'CO',
    zip: 80014,
    telephone: '(303) 369-5151',
    population: 293,
    county: 'ARAPAHOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattcolorado.edu/',
  },
  {
    name: 'BAPTIST BIBLE COLLEGE',
    address: '628 E KEARNEY',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65803,
    telephone: '(417) 268-6000',
    population: 293,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gobbc.edu/',
  },
  {
    name: 'PLATT COLLEGE-MCCANN-MONROE',
    address: '2319 LOUISVILLE AVE',
    city: 'MONROE',
    state: 'LA',
    zip: 71201,
    telephone: '(318) 323-2889',
    population: 293,
    county: 'OUACHITA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mccann.edu/',
  },
  {
    name: 'PENN COMMERCIAL BUSINESS/TECHNICAL SCHOOL',
    address: '242 OAK SPRING ROAD',
    city: 'WASHINGTON',
    state: 'PA',
    zip: 15301,
    telephone: '(724) 222-5330',
    population: 293,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.penncommercial.edu/',
  },
  {
    name: 'UNIVERSITY OF WEST LOS ANGELES',
    address: '9800 S. LA CIENEGA BLVD.',
    city: 'INGLEWOOD',
    state: 'CA',
    zip: 90301,
    telephone: '(562) 342-5200',
    population: 294,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwla.edu/',
  },
  {
    name: 'MCCORMICK THEOLOGICAL SEMINARY',
    address: '5460 S. UNIVERSITY',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60615,
    telephone: '(773) 947-6300',
    population: 297,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mccormick.edu/',
  },
  {
    name: 'NEBRASKA INDIAN COMMUNITY COLLEGE',
    address: '1111 HWY 75',
    city: 'MACY',
    state: 'NE',
    zip: 68039,
    telephone: '(402) 494-2311',
    population: 297,
    county: 'THURSTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.thenicc.edu/',
  },
  {
    name: 'PAINE COLLEGE',
    address: '1235 15TH ST',
    city: 'AUGUSTA',
    state: 'GA',
    zip: 30901,
    telephone: '(706) 821-8200',
    population: 298,
    county: 'RICHMOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.paine.edu/',
  },
  {
    name: 'GRACE COLLEGE OF DIVINITY',
    address: '5117 CLIFFDALE ROAD',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28314,
    telephone: '(910) 221-2224',
    population: 298,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcd.edu/',
  },
  {
    name: 'CALVIN THEOLOGICAL SEMINARY',
    address: '3233 BURTON ST SE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49546,
    telephone: '(616) 957-6036',
    population: 298,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calvinseminary.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE OF AMERICA',
    address: '226 SUSSEX AVE',
    city: 'MORRISTOWN',
    state: 'NJ',
    zip: 7960,
    telephone: '(973) 267-9404',
    population: 299,
    county: 'MORRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rca.edu/',
  },
  {
    name: 'BROADVIEW UNIVERSITY-WEST JORDAN',
    address: '1902 W 7800 S',
    city: 'WEST JORDAN',
    state: 'UT',
    zip: 84088,
    telephone: '(385) 501-4803',
    population: 300,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.broadviewuniversity.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-LOUISIANA',
    address: '400 LABARRE ROAD',
    city: 'JEFFERSON',
    state: 'LA',
    zip: 70121,
    telephone: '(504) 565-7995',
    population: 300,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'GWINNETT COLLEGE-MARIETTA CAMPUS',
    address: '1130 NORTHCHASE PKWY, STE 100',
    city: 'MARIETTA',
    state: 'GA',
    zip: 30067,
    telephone: '(770) 859-9779',
    population: 300,
    county: 'COBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gwinnettcollege.edu/',
  },
  {
    name: 'THOMAS JEFFERSON SCHOOL OF LAW',
    address: '701 B STREET - SUITE 110',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 961-4325',
    population: 301,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tjsl.edu/',
  },
  {
    name: 'NEW YORK THEOLOGICAL SEMINARY',
    address: '475 RIVERSIDE DR STE 500',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10115,
    telephone: '(212) 870-1211',
    population: 301,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'nyts.edu/',
  },
  {
    name: 'PINE MANOR COLLEGE',
    address: '400 HEATH ST',
    city: 'CHESTNUT HILL',
    state: 'MA',
    zip: 2467,
    telephone: '(617) 731-7000',
    population: 301,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pmc.edu/',
  },
  {
    name: 'UNIVERSITY OF SAINT MARY OF THE LAKE',
    address: '1000 E MAPLE AVE',
    city: 'MUNDELEIN',
    state: 'IL',
    zip: 60060,
    telephone: '(847) 566-6401',
    population: 302,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usml.edu/',
  },
  {
    name: 'MIDWIVES COLLEGE OF UTAH',
    address: '1174 EAST GRAYSTONE WAY, SUITE #2',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84106,
    telephone: '(801) 649-5230',
    population: 302,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.midwifery.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-MOBILE CAMPUS',
    address: '828 DOWNTOWNER LOOP W',
    city: 'MOBILE',
    state: 'AL',
    zip: 36609,
    telephone: '(251) 343-8200',
    population: 302,
    county: 'MOBILE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/mobile-alabama-colleges-campus',
  },
  {
    name: 'IGLOBAL UNIVERSITY',
    address: '8133 LEESBURG PIKE #230',
    city: 'VIENNA',
    state: 'VA',
    zip: 22182,
    telephone: '(703) 941-2020',
    population: 303,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.igu.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO-MANATI',
    address: 'MCKINLEY STREET #52',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 621-3652',
    population: 304,
    county: 'MANATÍ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'JAMESTOWN BUSINESS COLLEGE',
    address: '7 FAIRMOUNT AVE',
    city: 'JAMESTOWN',
    state: 'NY',
    zip: 14701,
    telephone: '(716) 664-5100',
    population: 304,
    county: 'CHAUTAUQUA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jbc.edu/',
  },
  {
    name: 'DALLAS CHRISTIAN COLLEGE',
    address: '2700 CHRISTIAN PKWY.',
    city: 'DALLAS',
    state: 'TX',
    zip: 75234,
    telephone: '(972) 241-3371',
    population: 305,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dallas.edu/',
  },
  {
    name: 'CRISWELL COLLEGE',
    address: '4010 GASTON AVENUE',
    city: 'DALLAS',
    state: 'TX',
    zip: 75246,
    telephone: '(214) 821-5433',
    population: 307,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.criswell.edu/',
  },
  {
    name: 'VIRGINIA UNIVERSITY OF LYNCHBURG',
    address: '2058 GARFIELD AVE',
    city: 'LYNCHBURG',
    state: 'VA',
    zip: 24501,
    telephone: '(434) 528-5276 EXT 1145',
    population: 308,
    county: 'LYNCHBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vul.edu/',
  },
  {
    name: 'FELBRY COLLEGE SCHOOL OF NURSING',
    address: '6055 CLEVELAND AVENUE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43231,
    telephone: '(614) 781-1085 EXT 102',
    population: 311,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'felbrycollege.edu/',
  },
  {
    name: 'INSTITUTO TECNOLOGICO DE PUERTO RICO-RECINTO DE PONCE',
    address: '4820 CANDIDO HOYOS URB. PERLA DEL SUR',
    city: 'PONCE',
    state: 'PR',
    zip: 717,
    telephone: '(787) 843-1305',
    population: 311,
    county: 'PONCE',
    naics_desc: 'JUNIOR COLLEGES',
    website:
      'https://de.pr.gov/wp-content/uploads/2020/05/itpr-catalogo-general-2020-2022-actual-1.pdf',
  },
  {
    name: 'NORTHERN BAPTIST THEOLOGICAL SEMINARY',
    address: '410 WARRENVILLE ROAD, SUITE 300',
    city: 'LISLE',
    state: 'IL',
    zip: 60532,
    telephone: '(630) 620-2100',
    population: 312,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.seminary.edu/',
  },
  {
    name: 'OKLAHOMA TECHNICAL COLLEGE',
    address: '4444 SOUTH SHERIDAN',
    city: 'TULSA',
    state: 'OK',
    zip: 74145,
    telephone: '(918) 610-0027',
    population: 312,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oklahomatechnicalcollege.com/',
  },
  {
    name: 'ANTIOCH UNIVERSITY ONLINE',
    address: '900 DAYTON STREET',
    city: 'YELLOW SPRINGS',
    state: 'OH',
    zip: 45387,
    telephone: '(937) 769-1352',
    population: 313,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'online.antioch.edu/',
  },
  {
    name: 'CURTIS INSTITUTE OF MUSIC',
    address: '1726 LOCUST ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19103,
    telephone: '(215) 435-1698',
    population: 313,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.curtis.edu/',
  },
  {
    name: 'MILAN INSTITUTE-MERCED',
    address: '780 LOUGHBOROUGH DRIVE',
    city: 'MERCED',
    state: 'CA',
    zip: 95340,
    telephone: '(209) 230-9420',
    population: 313,
    county: 'MERCED',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.milaninstitute.edu/',
  },
  {
    name: 'LAUREL BUSINESS INSTITUTE',
    address: '11 EAST PENN ST',
    city: 'UNIONTOWN',
    state: 'PA',
    zip: 15401,
    telephone: '(724) 439-4900',
    population: 313,
    county: 'FAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'laurel.edu/',
  },
  {
    name: 'TRINITY BIBLE COLLEGE AND GRADUATE SCHOOL',
    address: '50 6TH AVE S',
    city: 'ELLENDALE',
    state: 'ND',
    zip: 58436,
    telephone: '(888) 822-2329',
    population: 314,
    county: 'DICKEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'trinitybiblecollege.edu/',
  },
  {
    name: 'PENNSYLVANIA ACADEMY OF THE FINE ARTS',
    address: '128 N. BROAD STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19102,
    telephone: '(215) 972-7600',
    population: 314,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pafa.org/',
  },
  {
    name: 'EAGLE GATE COLLEGE-MURRAY',
    address: '5588 SOUTH GREEN STREET',
    city: 'MURRAY',
    state: 'UT',
    zip: 84123,
    telephone: '(801) 333-8100',
    population: 314,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'eaglegatecollege.edu/',
  },
  {
    name: 'HELMS COLLEGE',
    address: '5171 EISENHOWER PARKWAY',
    city: 'MACON',
    state: 'GA',
    zip: 31206,
    telephone: '(478) 319-3373',
    population: 315,
    county: 'BIBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.helms.edu/',
  },
  {
    name: 'PHILLIPS SCHOOL OF NURSING AT MOUNT SINAI BETH ISRAEL',
    address: '766 AVENUE OF THE AMERICAS 4TH FLOOR',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10001,
    telephone: '(212) 614-6114',
    population: 316,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pson.edu/',
  },
  {
    name: "EMPEROR'S COLLEGE OF TRADITIONAL ORIENTAL MEDICINE",
    address: '1807 WILSHIRE BLVD, STE #200',
    city: 'SANTA MONICA',
    state: 'CA',
    zip: 90403,
    telephone: '(310) 453-8300',
    population: 317,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emperors.edu/',
  },
  {
    name: 'EMPIRE COLLEGE',
    address: '3035 CLEVELAND AVE',
    city: 'SANTA ROSA',
    state: 'CA',
    zip: 95403,
    telephone: '(707) 546-4000',
    population: 317,
    county: 'SONOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.empcol.edu/',
  },
  {
    name: 'COLLEGE OF THE MUSCOGEE NATION',
    address: '2170 RAVEN CIRCLE',
    city: 'OKMULGEE',
    state: 'OK',
    zip: 74447,
    telephone: '(918) 549-2800',
    population: 318,
    county: 'OKMULGEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cmn.edu/',
  },
  {
    name: 'PHOENIX SEMINARY',
    address: '7901 E. SHEA BLVD.',
    city: 'SCOTTSDALE',
    state: 'AZ',
    zip: 85260,
    telephone: '(602) 429-4945 EXT 4945',
    population: 318,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ps.edu/',
  },
  {
    name: 'UNIVERSITY OF SAINT KATHERINE',
    address: '1637 CAPALINA ROAD',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92069,
    telephone: '(760) 471-1316',
    population: 318,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usk.edu/',
  },
  {
    name: 'FORTIS COLLEGE-MONTGOMERY',
    address: '3736 ATLANTA HWY',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36109,
    telephone: '(334) 272-3857',
    population: 318,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'STAUTZENBERGER COLLEGE-BRECKSVILLE',
    address: '8001 KATHERINE BOULEVARD',
    city: 'BRECKSVILLE',
    state: 'OH',
    zip: 44141,
    telephone: '(440) 838-1999',
    population: 320,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sctoday.edu/',
  },
  {
    name: 'VET TECH INSTITUTE',
    address: '125 SEVENTH ST',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15222,
    telephone: '(412) 391-7021',
    population: 321,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'vti.edu/',
  },
  {
    name: 'SHORTER COLLEGE',
    address: '604 LOCUST ST',
    city: 'N LITTLE ROCK',
    state: 'AR',
    zip: 72114,
    telephone: '(501) 374-6305 EXT 107',
    population: 322,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.shortercollege.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-SCRANTON',
    address: '517 ASH STREET',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18509,
    telephone: '(570) 558-1818',
    population: 323,
    county: 'LACKAWANNA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'MACCORMAC COLLEGE',
    address: '29 E. MADISON',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60602,
    telephone: '(312) 922-1884 EXT 203',
    population: 323,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.maccormac.edu/',
  },
  {
    name: 'PLATT COLLEGE-MCCANN-ALLENTOWN',
    address: '2200 N IRVING ST',
    city: 'ALLENTOWN',
    state: 'PA',
    zip: 18109,
    telephone: '(484) 223-4600',
    population: 324,
    county: 'LEHIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mccann.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-WEST VIRGINIA',
    address: '135 CORPORATE CENTER DRIVE SUITE 531',
    city: 'SCOTT DEPOT',
    state: 'WV',
    zip: 25560,
    telephone: '(877) 445-7180',
    population: 325,
    county: 'PUTNAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/west-virginia/teays-valley',
  },
  {
    name: 'ABRAHAM LINCOLN UNIVERSITY',
    address: '100 WEST BROADWAY, SUITE 600',
    city: 'GLENDALE',
    state: 'CA',
    zip: 91210,
    telephone: '(213) 252-5100',
    population: 325,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.alu.edu/',
  },
  {
    name: 'ART ACADEMY OF CINCINNATI',
    address: '1212 JACKSON STREET',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45202,
    telephone: '(513) 562-6262',
    population: 325,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artacademy.edu/',
  },
  {
    name: 'ROSS COLLEGE-CANTON',
    address: '4300 MUNSON STREET, NORTH WEST',
    city: 'CANTON',
    state: 'OH',
    zip: 44718,
    telephone: '(330) 494-1214',
    population: 325,
    county: 'STARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rosseducation.edu/',
  },
  {
    name: 'MIDWEST INSTITUTE',
    address: '2 SOCCER PARK DRIVE',
    city: 'FENTON',
    state: 'MO',
    zip: 63026,
    telephone: '(314) 344-4440',
    population: 325,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'midwestinstitute.com/',
  },
  {
    name: 'ORLEANS TECHNICAL COLLEGE',
    address: '2770 RED LION ROAD',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19114,
    telephone: '(215) 728-4700',
    population: 328,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.orleanstech.edu/',
  },
  {
    name: 'VALOR CHRISTIAN COLLEGE',
    address: '4595 GENDER ROAD',
    city: 'CANAL WINCHESTER',
    state: 'OH',
    zip: 43110,
    telephone: '(614) 837-4088',
    population: 328,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.valorcollege.edu/',
  },
  {
    name: 'UNIVERSITY OF MANAGEMENT AND TECHNOLOGY',
    address: '1901 FORT MYER DRIVE, SUITE 700',
    city: 'ARLINGTON',
    state: 'VA',
    zip: 22209,
    telephone: '(703) 516-0035',
    population: 329,
    county: 'ARLINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umtweb.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-LOS ANGELES',
    address: '1201 W. 5TH STREET',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90017,
    telephone: '(717) 380-1385',
    population: 329,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'relativityschool.org/',
  },
  {
    name: 'CAREER QUEST LEARNING CENTERS-LANSING',
    address: '3215 S. PENNSYLVANIA AVENUE',
    city: 'LANSING',
    state: 'MI',
    zip: 48910,
    telephone: '(517) 318-3330',
    population: 329,
    county: 'INGHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.careerquest.edu/',
  },
  {
    name: 'BLUE CLIFF COLLEGE-LAFAYETTE',
    address: '120 JAMES COMEAUX RD.',
    city: 'LAFAYETTE',
    state: 'LA',
    zip: 70508,
    telephone: '(337) 269-0620',
    population: 329,
    county: 'LAFAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bluecliffcollege.edu/',
  },
  {
    name: 'BENNETT COLLEGE',
    address: '900 E WASHINGTON ST',
    city: 'GREENSBORO',
    state: 'NC',
    zip: 27401,
    telephone: '(336) 517-2100',
    population: 330,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bennett.edu/',
  },
  {
    name: 'UNION THEOLOGICAL SEMINARY IN THE CITY OF NEW YORK',
    address: '3041 BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 662-7100',
    population: 330,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'utsnyc.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE-RALEIGH',
    address: '3901 CAPITAL BLVD STE 151',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27604,
    telephone: '(919) 723-2820',
    population: 330,
    county: 'WAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'DELTA COLLEGE OF ARTS & TECHNOLOGY',
    address: '7380 EXCHANGE PLACE',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70806,
    telephone: '(225) 928-7770',
    population: 330,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.deltacollege.com/',
  },
  {
    name: 'ADLER GRADUATE SCHOOL',
    address: '10225 YELLOW CIRCLE DR.',
    city: 'MINNETONKA',
    state: 'MN',
    zip: 55343,
    telephone: '(612) 861-7554',
    population: 331,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alfredadler.edu/',
  },
  {
    name: 'INTERNATIONAL BUSINESS COLLEGE-INDIANAPOLIS',
    address: '7205 SHADELAND STATION',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46256,
    telephone: '(317) 813-2300',
    population: 331,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ibcindianapolis.edu/',
  },
  {
    name: 'BRYAN UNIVERSITY',
    address: '4255 NATURE CENTER WAY',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65804,
    telephone: '(417) 862-5700',
    population: 332,
    county: 'GREENE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bryanu.edu/',
  },
  {
    name: 'MINNESOTA STATE COLLEGES AND UNIVERSITIES SYSTEM OFFICE',
    address: '30 EAST 7TH ST',
    city: 'ST PAUL',
    state: 'MN',
    zip: 55101,
    telephone: '(800) 456-8519',
    population: 333,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.minnstate.edu/',
  },
  {
    name: 'ERIE INSTITUTE OF TECHNOLOGY INC',
    address: '940 MILLCREEK MALL',
    city: 'ERIE',
    state: 'PA',
    zip: 16565,
    telephone: '(814) 868-9900',
    population: 333,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.erieit.edu/',
  },
  {
    name: 'SAN IGNACIO UNIVERSITY',
    address: '3905 NW 107TH AVE SUITE 301',
    city: 'DORAL',
    state: 'FL',
    zip: 33178,
    telephone: '(305) 629-2929 EXT 4015',
    population: 334,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sanignaciouniversity.edu/',
  },
  {
    name: 'UNIVERSITY OF THE WEST',
    address: '1409 WALNUT GROVE AVE',
    city: 'ROSEMEAD',
    state: 'CA',
    zip: 91770,
    telephone: '(626) 571-8811 EXT 100',
    population: 335,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwest.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-LAFAYETTE CAMPUS',
    address: '303 RUE LOUIS XIV',
    city: 'LAFAYETTE',
    state: 'LA',
    zip: 70508,
    telephone: '(337) 981-4010',
    population: 336,
    county: 'LAFAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/louisiana-career-school-overview',
  },
  {
    name: 'SPARTAN COLLEGE OF AERONAUTICS AND TECHNOLOGY',
    address: '10851 W 120TH AVE',
    city: 'BROOMFIELD',
    state: 'CO',
    zip: 80021,
    telephone: '(303) 466-1714',
    population: 338,
    county: 'BROOMFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.spartan.edu/',
  },
  {
    name: 'CHICAGO THEOLOGICAL SEMINARY',
    address: '1407 E. 60TH STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60637,
    telephone: '(773) 896-2400',
    population: 339,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ctschicago.edu/',
  },
  {
    name: 'ANGELES COLLEGE',
    address: '3440 WILSHIRE BLVD STE 310',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(213) 487-2211',
    population: 340,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.angelescollege.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-COOKEVILLE',
    address: '1025 HIGHWAY 111',
    city: 'COOKEVILLE',
    state: 'TN',
    zip: 38501,
    telephone: '(931) 526-3660',
    population: 340,
    county: 'PUTNAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'NEBRASKA COLLEGE OF TECHNICAL AGRICULTURE',
    address: '404 EAST 7TH',
    city: 'CURTIS',
    state: 'NE',
    zip: 69025,
    telephone: '(308) 367-5259',
    population: 341,
    county: 'FRONTIER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://ncta.unl.edu/',
  },
  {
    name: 'MAYFIELD COLLEGE',
    address: '35-325 DATE PALM DR STE 101',
    city: 'CATHEDRAL CITY',
    state: 'CA',
    zip: 92234,
    telephone: '(760) 328-5554',
    population: 341,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mayfieldcollege.edu/',
  },
  {
    name: 'CALIFORNIA HEALTH SCIENCES UNIVERSITY',
    address: '120 NORTH CLOVIS AVENUE',
    city: 'CLOVIS',
    state: 'CA',
    zip: 93612,
    telephone: '(559) 325-3600',
    population: 342,
    county: 'FRESNO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://chsu.edu/',
  },
  {
    name: 'TEXAS CHIROPRACTIC COLLEGE FOUNDATION INC',
    address: '5912 SPENCER HWY',
    city: 'PASADENA',
    state: 'TX',
    zip: 77505,
    telephone: '(281) 487-1170',
    population: 343,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.txchiro.edu/',
  },
  {
    name: 'PENNSYLVANIA COLLEGE OF ART AND DESIGN',
    address: '204 N PRINCE ST',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17608,
    telephone: '(800) 689-0379',
    population: 344,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'pcad.edu/',
  },
  {
    name: 'CLAREMONT SCHOOL OF THEOLOGY',
    address: '1325 N COLLEGE AVE',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 447-2500',
    population: 344,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cst.edu/',
  },
  {
    name: 'JUDSON COLLEGE',
    address: '302 BIBB ST',
    city: 'MARION',
    state: 'AL',
    zip: 36756,
    telephone: '(334) 683-5100',
    population: 345,
    county: 'PERRY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.judson.edu/',
  },
  {
    name: 'BLUE CLIFF COLLEGE-GULFPORT',
    address: '12251 BERNARD PKWY',
    city: 'GULFPORT',
    state: 'MS',
    zip: 39503,
    telephone: '(228) 896-9727 EXT 0000',
    population: 345,
    county: 'HARRISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bluecliffcollege.edu/',
  },
  {
    name: 'HUMACAO COMMUNITY COLLEGE',
    address: 'GEORGETTI ST. #69',
    city: 'HUMACAO',
    state: 'PR',
    zip: 791,
    telephone: '(787) 852-1430',
    population: 346,
    county: 'HUMACAO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hccpr.edu/',
  },
  {
    name: 'REID STATE TECHNICAL COLLEGE',
    address: '100 AND HWY 83',
    city: 'EVERGREEN',
    state: 'AL',
    zip: 36401,
    telephone: '(251) 578-1313',
    population: 346,
    county: 'CONECUH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rstc.edu/',
  },
  {
    name: 'ILISAGVIK COLLEGE',
    address: '100 STEVENSON STREET',
    city: 'BARROW',
    state: 'AK',
    zip: 99723,
    telephone: '(907) 852-3333',
    population: 347,
    county: 'NORTH SLOPE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ilisagvik.edu/',
  },
  {
    name: 'SITTING BULL COLLEGE',
    address: '9299 HWY 24',
    city: 'FORT YATES',
    state: 'ND',
    zip: 58538,
    telephone: '(701) 854-8000',
    population: 348,
    county: 'SIOUX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sittingbull.edu/',
  },
  {
    name: 'SAE INSTITUTE OF TECHNOLOGY-ATLANTA',
    address: '215 PEACHTREE STREET',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30303,
    telephone: '(954) 415-0901',
    population: 348,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.usa.sae.edu/',
  },
  {
    name: 'ANTIOCH UNIVERSITY-SANTA BARBARA',
    address: '602 ANACAPA STREET',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93101,
    telephone: '(805) 962-8179',
    population: 349,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.antiochsb.edu/',
  },
  {
    name: 'SAINT MEINRAD SCHOOL OF THEOLOGY',
    address: '200 HILL DRIVE',
    city: 'ST. MEINRAD',
    state: 'IN',
    zip: 47577,
    telephone: '(812) 357-6611',
    population: 349,
    county: 'SPENCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.saintmeinrad.edu/',
  },
  {
    name: 'AMERICAN INSTITUTE-TOMS RIVER',
    address: '2363 LAKEWOOD RD',
    city: 'TOMS RIVER',
    state: 'NJ',
    zip: 8755,
    telephone: '(732) 719-2730',
    population: 349,
    county: 'OCEAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.americaninstitute.com/',
  },
  {
    name: 'CARRINGTON COLLEGE-PORTLAND',
    address: '2004 LLOYD CENTER, 3RD FL.',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97232,
    telephone: '(503) 761-6100',
    population: 350,
    county: 'MULTNOMAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'CALIFORNIA COLLEGE SAN DIEGO',
    address: '6602 CONVOY COURT STE 100',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92111,
    telephone: '(619) 680-4430 EXT 1501',
    population: 351,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cc-sd.edu/',
  },
  {
    name: 'SAINT ANTHONY COLLEGE OF NURSING',
    address: '3301 N. MULFORD ROAD',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61114,
    telephone: '(815) 282-7900',
    population: 351,
    county: 'WINNEBAGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sacn.edu/',
  },
  {
    name: 'LAC COURTE OREILLES OJIBWE COLLEGE',
    address: '13466 W TREPANIA RD',
    city: 'HAYWARD',
    state: 'WI',
    zip: 54843,
    telephone: '(715) 634-4790 EXT 100',
    population: 351,
    county: 'SAWYER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lco.edu/',
  },
  {
    name: 'LINFIELD UNIVERSITY-SCHOOL OF NURSING',
    address: '2255 NW NORTHRUP ST',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97210,
    telephone: '(503) 413-8481',
    population: 352,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.linfield.edu/',
  },
  {
    name: 'NOSSI COLLEGE OF ART',
    address: '590 CREATIVE WAY',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37115,
    telephone: '(615) 514-2787',
    population: 352,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nossi.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-CHARLESTON',
    address: '8085 RIVERS AVE., STE E',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29418,
    telephone: '(843) 574-0101',
    population: 352,
    county: 'CHARLESTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://miller-motte.edu/',
  },
  {
    name: 'INSTITUTO TECNOLOGICO DE PUERTO RICO-RECINTO DE SAN JUAN',
    address: 'CALLE ALEGRIA FINAL URB LAS VIRTUDES',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 924,
    telephone: '(787) 764-2483 EXT 2011',
    population: 352,
    county: 'SAN JUAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://instituto-tecnologico-de-puerto-rico-1.jimdosite.com/',
  },
  {
    name: 'INTERNATIONAL TECHNOLOGICAL UNIVERSITY',
    address: '3120 SCOTT BLVD',
    city: 'SANTA CLARA',
    state: 'CA',
    zip: 95054,
    telephone: '(888) 488-4968',
    population: 353,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.itu.edu/',
  },
  {
    name: 'EASTERN INTERNATIONAL COLLEGE-JERSEY CITY',
    address: '684 NEWARK AVE',
    city: 'JERSEY CITY',
    state: 'NJ',
    zip: 7306,
    telephone: '(201) 216-9901',
    population: 353,
    county: 'HUDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eicollege.edu/',
  },
  {
    name: 'WILLIAMSON COLLEGE OF THE TRADES',
    address: '106 SOUTH NEW MIDDLETOWN ROAD',
    city: 'MEDIA',
    state: 'PA',
    zip: 19063,
    telephone: '(610) 566-1776',
    population: 354,
    county: 'DELAWARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.williamson.edu/',
  },
  {
    name: 'PACIFIC COLLEGE',
    address: '3160 RED HILL AVE',
    city: 'COSTA MESA',
    state: 'CA',
    zip: 92626,
    telephone: '(714) 662-4402',
    population: 356,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pacific-college.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-STOCKTON',
    address: '1313 WEST ROBINHOOD DRIVE B',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95207,
    telephone: '(209) 676-3341',
    population: 357,
    county: 'SAN JOAQUIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-PLEASANT HILL CAMPUS',
    address: '380 CIVIC DRIVE, SUITE 300',
    city: 'PLEASANT HILL',
    state: 'CA',
    zip: 94523,
    telephone: '(925) 273-3922 EXT 650',
    population: 357,
    county: 'CONTRA COSTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'URSHAN COLLEGE',
    address: '1151 CENTURY TEL DRIVE',
    city: 'WENTZVILLE',
    state: 'MO',
    zip: 63385,
    telephone: '(314) 838-8858',
    population: 358,
    county: 'ST. CHARLES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'Urshancollege.org',
  },
  {
    name: 'INTERDENOMINATIONAL THEOLOGICAL CENTER',
    address: '700 MARTIN LUTHER KING JR DR SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30314,
    telephone: '(404) 527-7729',
    population: 359,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.itc.edu/',
  },
  {
    name: 'ATA COLLEGE',
    address: '10200 LINN STATION RD STE 125',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40223,
    telephone: '(502) 371-8330',
    population: 360,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ata.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-CONWAY',
    address: '2451 EAST HIGHWAY 501',
    city: 'CONWAY',
    state: 'SC',
    zip: 29526,
    telephone: '(843) 591-1100',
    population: 362,
    county: 'HORRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'FAITH INTERNATIONAL UNIVERSITY',
    address: '3504 N PEARL ST',
    city: 'TACOMA',
    state: 'WA',
    zip: 98407,
    telephone: '(253) 752-2020 EXT 110',
    population: 363,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.faithseminary.edu/',
  },
  {
    name: 'RANDALL UNIVERSITY',
    address: '3701 S. I-35 FRONTAGE ROAD',
    city: 'MOORE',
    state: 'OK',
    zip: 73160,
    telephone: '(405) 912-9000',
    population: 363,
    county: 'CLEVELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ru.edu/',
  },
  {
    name: 'JOHN PAUL THE GREAT CATHOLIC UNIVERSITY',
    address: '155 W. GRAND AVE',
    city: 'ESCONDIDO',
    state: 'CA',
    zip: 92025,
    telephone: '(858) 653-6740',
    population: 364,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://jpcatholic.edu/',
  },
  {
    name: 'LAWRENCE MEMORIAL HOSPITAL SCHOOL OF NURSING',
    address: '170 GOVERNORS AVE',
    city: 'MEDFORD',
    state: 'MA',
    zip: 2155,
    telephone: '(781) 306-6600',
    population: 365,
    county: 'MIDDLESEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lmregis.org/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-MODESTO',
    address: '5380 PIRRONE ROAD',
    city: 'SALIDA',
    state: 'CA',
    zip: 95368,
    telephone: '(559) 734-9000',
    population: 365,
    county: 'STANISLAUS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'MASSACHUSETTS SCHOOL OF LAW',
    address: '500 FEDERAL ST WOODLAND PARK',
    city: 'ANDOVER',
    state: 'MA',
    zip: 1810,
    telephone: '(978) 681-0800',
    population: 366,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mslaw.edu/',
  },
  {
    name: 'ICPR JUNIOR COLLEGE-MAYAGUEZ',
    address: '80 WEST MCKINLEY ST',
    city: 'MAYAGUEZ',
    state: 'PR',
    zip: 681,
    telephone: '(787) 832-6000 EXT 229',
    population: 367,
    county: 'MAYAGÜEZ',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.icprjc.edu/',
  },
  {
    name: 'CEM COLLEGE-SAN JUAN',
    address: '1206 13TH. STREET EXT SAN AGUSTIN',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 926,
    telephone: '(787) 765-4210 EXT 105',
    population: 368,
    county: 'SAN JUAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cemcollege.edu/cem/',
  },
  {
    name: 'AVE MARIA SCHOOL OF LAW',
    address: '1025 COMMONS CIRCLE',
    city: 'NAPLES',
    state: 'FL',
    zip: 34119,
    telephone: '(239) 687-5300',
    population: 374,
    county: 'COLLIER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.avemarialaw.edu/',
  },
  {
    name: "ATLANTA'S JOHN MARSHALL LAW SCHOOL",
    address: '1422 WEST PEACHTREE STREET NW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30309,
    telephone: '(678) 916-2600',
    population: 375,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.johnmarshall.edu/',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF ARTS & TECHNOLOGY',
    address: '2820 CAMINO DEL RIO SOUTH SUITE 100',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92108,
    telephone: '(877) 559-3621',
    population: 375,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ciat.edu/',
  },
  {
    name: 'RIVERSIDE COLLEGE OF HEALTH CAREERS',
    address: '316 MAIN STREET',
    city: 'NEWPORT NEWS',
    state: 'VA',
    zip: 23601,
    telephone: '(757) 240-2200',
    population: 376,
    county: 'NEWPORT NEWS CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://riverside.edu/',
  },
  {
    name: 'BEL-REA INSTITUTE OF ANIMAL TECHNOLOGY',
    address: '1681 S DAYTON ST',
    city: 'DENVER',
    state: 'CO',
    zip: 80247,
    telephone: '(303) 751-8700',
    population: 376,
    county: 'ARAPAHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.belrea.edu/',
  },
  {
    name: 'TALMUDICAL SEMINARY OHOLEI TORAH',
    address: '667 EASTERN PKY',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11213,
    telephone: '(718) 774-5050',
    population: 377,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tsot.edu/',
  },
  {
    name: 'GARRETT-EVANGELICAL THEOLOGICAL SEMINARY',
    address: '2121 SHERIDAN ROAD',
    city: 'EVANSTON',
    state: 'IL',
    zip: 60201,
    telephone: '(847) 866-3900',
    population: 380,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.garrett.edu/',
  },
  {
    name: 'CALIFORNIA AERONAUTICAL UNIVERSITY',
    address: '1450 BOUGHTON DRIVE',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93308,
    telephone: '(661) 615-5915',
    population: 382,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.calaero.edu/',
  },
  {
    name: 'BROOKLINE COLLEGE-TUCSON',
    address: '5441 E. 22ND ST, STE.125',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85711,
    telephone: '(520) 748-9799',
    population: 383,
    county: 'PIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.brooklinecollege.edu/',
  },
  {
    name: 'THE SEATTLE SCHOOL OF THEOLOGY & PSYCHOLOGY',
    address: '2501 ELLIOTT AVENUE',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98121,
    telephone: '(206) 876-6132',
    population: 384,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.theseattleschool.edu/',
  },
  {
    name: 'ANDREW COLLEGE',
    address: '501COLLEGE ST',
    city: 'CUTHBERT',
    state: 'GA',
    zip: 39840,
    telephone: '(229) 732-2171',
    population: 384,
    county: 'RANDOLPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.andrewcollege.edu/',
  },
  {
    name: 'CITY COLLEGE-FORT LAUDERDALE',
    address: '2000 W. COMMERCIAL BOULEVARD',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33309,
    telephone: '(954) 492-5353',
    population: 385,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.citycollege.edu/',
  },
  {
    name: 'ARIZONA COLLEGE-MESA',
    address: '163 N DOBSON RD',
    city: 'MESA',
    state: 'AZ',
    zip: 85201,
    telephone: '(855) 706-8382',
    population: 386,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'UNITED STATES SPORTS ACADEMY',
    address: 'ONE ACADEMY DRIVE',
    city: 'DAPHNE',
    state: 'AL',
    zip: 36526,
    telephone: '(251) 626-3303 EXT 7151',
    population: 386,
    county: 'BALDWIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ussa.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-SPOKANE',
    address: '10102 E. KNOX AVE., STE. 200',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99206,
    telephone: '(509) 462-3722',
    population: 386,
    county: 'SPOKANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'ICPR JUNIOR COLLEGE',
    address: 'CARRETERA #2 K.M. 49.9 PUERTA DEL NORTE MALL 4TO. PISO SUITE 17',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 884-6000',
    population: 387,
    county: 'MANATÍ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.icprjc.edu/',
  },
  {
    name: 'DEWEY UNIVERSITY-CAROLINA',
    address: 'ROAD 3 COMPOUND 11 LOT 7 CAROLINA INDUSTRIAL PARK',
    city: 'CAROLINA',
    state: 'PR',
    zip: 986,
    telephone: '(787) 753-1515',
    population: 388,
    county: 'CAROLINA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'dewey.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-NORTH HOUSTON CAMPUS',
    address: '11310 GREENS CROSSING BLVD, STE 300',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77067,
    telephone: '(281) 885-4450',
    population: 388,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/north-houston-texas-colleges',
  },
  {
    name: 'VANDERCOOK COLLEGE OF MUSIC',
    address: '3140 SOUTH FEDERAL STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60616,
    telephone: '(312) 225-6288',
    population: 389,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vandercook.edu/',
  },
  {
    name: 'AMERICAN UNIVERSITY OF PUERTO RICO',
    address: 'CARR. #2, KM.14.4, BO. HATO TEJAS',
    city: 'BAYAMON',
    state: 'PR',
    zip: 960,
    telephone: '(787) 620-2040 EXT 1040',
    population: 389,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'aupr.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-TUCSON',
    address: '201 NORTH BONITA AVENUE',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85745,
    telephone: '(520) 368-3028',
    population: 389,
    county: 'PIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-SHREVEPORT CAMPUS',
    address: '2106 BERT KOUNS INDUSTRIAL LOOP',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71101,
    telephone: '(318) 671-4000',
    population: 389,
    county: 'CADDO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/shreveport-career-school-overview',
  },
  {
    name: 'OREGON COLLEGE OF ORIENTAL MEDICINE',
    address: '75 NW COUCH',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97209,
    telephone: '(503) 253-3443',
    population: 390,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ocom.edu/',
  },
  {
    name: 'SOUTH BAYLO UNIVERSITY',
    address: '1126 N BROOKHURST ST',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92801,
    telephone: '(714) 533-1495',
    population: 390,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southbaylo.edu/',
  },
  {
    name: 'LONGY SCHOOL OF MUSIC OF BARD COLLEGE',
    address: '27 GARDEN STREET',
    city: 'CAMBRIDGE',
    state: 'MA',
    zip: 2138,
    telephone: '(617) 876-0956',
    population: 391,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'longy.edu/',
  },
  {
    name: 'WORLD MISSION UNIVERSITY',
    address: '500 SHATTO PL STE 600',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90020,
    telephone: '(213) 388-1000',
    population: 393,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wmu.edu/',
  },
  {
    name: 'QUEST COLLEGE',
    address: '5430 FREDERICKSBURG RD STE 310',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78229,
    telephone: '(210) 366-2701',
    population: 393,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.questcollege.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-DELAWARE',
    address: '800 NORTH KING STREET SUITE 101',
    city: 'WILMINGTON',
    state: 'DE',
    zip: 19801,
    telephone: '(877) 455-7180',
    population: 394,
    county: 'NEW CASTLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/delaware/wilmington',
  },
  {
    name: 'SOUTH FLORIDA BIBLE COLLEGE AND THEOLOGICAL SEMINARY',
    address: '2200 SW 10TH STREET',
    city: 'DEERFIELD BEACH',
    state: 'FL',
    zip: 33442,
    telephone: '(954) 637-2268',
    population: 396,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfbc.edu/',
  },
  {
    name: 'CLAREMONT LINCOLN UNIVERSITY',
    address: '150 WEST FIRST STREET',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 667-4400',
    population: 396,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://claremontlincoln.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-CHATTANOOGA',
    address: '6397 LEE HIGHWAY, SUITE 100',
    city: 'CHATTANOOGA',
    state: 'TN',
    zip: 37421,
    telephone: '(423) 510-9675 EXT 200',
    population: 396,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'SOUTHERN STATES UNIVERSITY',
    address: '1094 CUHADY PLACE, #120',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92110,
    telephone: '(619) 298-1829',
    population: 398,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ssu.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-HEATHROW CAMPUS',
    address: '7131 BUSINESS PARK LANE STE. 300',
    city: 'LAKE MARY',
    state: 'FL',
    zip: 32746,
    telephone: '(615) 493-9399',
    population: 399,
    county: 'SEMINOLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.remingtoncollege.edu/',
  },
  {
    name: 'OHIO VALLEY UNIVERSITY',
    address: '1 CAMPUS VIEW DRIVE',
    city: 'VIENNA',
    state: 'WV',
    zip: 26105,
    telephone: '(304) 865-6000',
    population: 400,
    county: 'WOOD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ovu.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-LAS VEGAS',
    address: '5740 S. EASTERN AVE., STE. 140',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89119,
    telephone: '(702) 688-4300',
    population: 400,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-KANSAS CITY',
    address: '3239 BROADWAY',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64111,
    telephone: '(816) 531-5223',
    population: 400,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/kansas-city-missouri',
  },
  {
    name: 'PATRICK HENRY COLLEGE',
    address: '10 PATRICK HENRY CIRCLE',
    city: 'PURCELLVILLE',
    state: 'VA',
    zip: 20132,
    telephone: '(540) 338-1776',
    population: 403,
    county: 'LOUDOUN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phc.edu/',
  },
  {
    name: 'SOUTH HILLS SCHOOL OF BUSINESS & TECHNOLOGY',
    address: '480 WAUPELANI DR',
    city: 'STATE COLLEGE',
    state: 'PA',
    zip: 16801,
    telephone: '(814) 234-7755',
    population: 403,
    county: 'CENTRE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southhills.edu/',
  },
  {
    name: 'BACONE COLLEGE',
    address: '2299 OLD BACONE RD',
    city: 'MUSKOGEE',
    state: 'OK',
    zip: 74403,
    telephone: '(918) 683-4581 EXT 7340',
    population: 404,
    county: 'MUSKOGEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bacone.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-NASHVILLE CAMPUS',
    address: '441 DONELSON PK STE 150',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37214,
    telephone: '(615) 889-5520',
    population: 405,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/nashville-tennessee-career-colleges-overview',
  },
  {
    name: 'WESTERN THEOLOGICAL SEMINARY',
    address: '101 E 13TH ST',
    city: 'HOLLAND',
    state: 'MI',
    zip: 49423,
    telephone: '(616) 392-8555',
    population: 406,
    county: 'OTTAWA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westernsem.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS MD ANDERSON CANCER CENTER',
    address: '1515 HOLCOMBE BLVD.',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77030,
    telephone: '(800) 392-1611',
    population: 406,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mdanderson.org/',
  },
  {
    name: 'STONE CHILD COLLEGE',
    address: '8294 UPPER BOX ELDER ROAD',
    city: 'BOX ELDER',
    state: 'MT',
    zip: 59521,
    telephone: '(406) 395-4875 EXT 3264',
    population: 407,
    county: 'CHOUTEAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stonechild.edu/',
  },
  {
    name: 'DALLAS INSTITUTE OF FUNERAL SERVICE',
    address: '3909 S BUCKNER BLVD',
    city: 'DALLAS',
    state: 'TX',
    zip: 75227,
    telephone: '(214) 388-5466',
    population: 407,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.dallasinstitute.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-TEXAS',
    address: '4800 REGENT BLVD., STE. 200',
    city: 'IRVING',
    state: 'TX',
    zip: 75063,
    telephone: '(972) 929-6777',
    population: 408,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'IDAHO COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '1401 EAST CENTRAL DRIVE',
    city: 'MERIDIAN',
    state: 'ID',
    zip: 83642,
    telephone: '(208) 795-4266',
    population: 408,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.idahocom.org',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-SOUTH SAN ANTONIO',
    address: '1964 SW MILITARY DRIVE',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78221,
    telephone: '(210) 957-3826',
    population: 408,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'chcp.edu/',
  },
  {
    name: 'PLATT COLLEGE-ARIZONA AUTOMOTIVE INSTITUTE ARIZONA',
    address: '6829 N 46TH AVE',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85301,
    telephone: '(623) 934-7273',
    population: 410,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aai.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-EAST VALLEY',
    address: '2160 S POWER RD',
    city: 'MESA',
    state: 'AZ',
    zip: 85209,
    telephone: '(480) 898-9898',
    population: 410,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'AVIATOR COLLEGE OF AERONAUTICAL SCIENCE AND TECHNOLOGY',
    address: '3800 ST LUCIE BLVD',
    city: 'FORT PIERCE',
    state: 'FL',
    zip: 34946,
    telephone: '(772) 466-4822',
    population: 411,
    county: 'ST. LUCIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aviator.edu/',
  },
  {
    name: 'CLARY SAGE COLLEGE',
    address: '3131 SOUTH SHERIDAN',
    city: 'TULSA',
    state: 'OK',
    zip: 74145,
    telephone: '(918) 610-0027',
    population: 412,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clarysagecollege.com/',
  },
  {
    name: 'VIRGINIA UNIVERSITY OF INTEGRATIVE MEDICINE',
    address: '9401 MATHY DRIVE STE 100',
    city: 'FAIRFAX',
    state: 'VA',
    zip: 22031,
    telephone: '(703) 323-5690',
    population: 413,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vuim.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-HESPERIA',
    address: '9331 MARIPOSA ROAD',
    city: 'HESPERIA',
    state: 'CA',
    zip: 92344,
    telephone: '(559) 734-9000',
    population: 414,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'CONCORDIA THEOLOGICAL SEMINARY',
    address: '6600 N CLINTON ST',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46825,
    telephone: '(260) 452-2100',
    population: 417,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ctsfw.edu/',
  },
  {
    name: 'PROFESSIONAL SKILLS INSTITUTE',
    address: '1505 HOLLAND ROAD',
    city: 'MAUMEE',
    state: 'OH',
    zip: 43537,
    telephone: '(419) 720-6670',
    population: 417,
    county: 'LUCAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.proskills.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-AURORA',
    address: '111 N. HAVANA STREET',
    city: 'AURORA',
    state: 'CO',
    zip: 80010,
    telephone: '(303) 861-1151',
    population: 417,
    county: 'ARAPAHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/aurora-colorado',
  },
  {
    name: 'DONNELLY COLLEGE',
    address: '608 N 18TH ST',
    city: 'KANSAS CITY',
    state: 'KS',
    zip: 66102,
    telephone: '(913) 621-6000',
    population: 418,
    county: 'WYANDOTTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.donnelly.edu/',
  },
  {
    name: 'LOS ANGELES COLLEGE OF MUSIC',
    address: '300 S FAIR OAKS AVE',
    city: 'PASADENA',
    state: 'CA',
    zip: 91105,
    telephone: '(626) 568-8850',
    population: 419,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lacm.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-COLUMBUS',
    address: '1800 BOX RD',
    city: 'COLUMBUS',
    state: 'GA',
    zip: 31907,
    telephone: '(706) 225-5000 EXT 5002',
    population: 420,
    county: 'MUSCOGEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'LINCOLN TECHNICAL INSTITUTE-PHILADELPHIA',
    address: '9191 TORRESDALE AVE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19136,
    telephone: '(215) 335-0800 EXT 40500',
    population: 421,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/philadelphia-pa',
  },
  {
    name: "ST. JOSEPH'S COLLEGE OF NURSING",
    address: '206 PROSPECT AVE',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13203,
    telephone: '(315) 448-5040',
    population: 422,
    county: 'ONONDAGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sjhcon.edu/',
  },
  {
    name: 'GODS BIBLE SCHOOL AND COLLEGE',
    address: '1810 YOUNG STREET',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45202,
    telephone: '(513) 721-7944',
    population: 425,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gbs.edu/',
  },
  {
    name: 'WILLIAM R MOORE COLLEGE OF TECHNOLOGY',
    address: '1200 POPLAR AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 726-1977',
    population: 426,
    county: 'SHELBY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mooretech.edu/',
  },
  {
    name: 'WASHINGTON COUNTY COMMUNITY COLLEGE',
    address: 'ONE COLLEGE DRIVE',
    city: 'CALAIS',
    state: 'ME',
    zip: 4619,
    telephone: '(207) 454-1000',
    population: 427,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wccc.me.edu/',
  },
  {
    name: 'FORT PECK COMMUNITY COLLEGE',
    address: '605 INDIAN STREET',
    city: 'POPLAR',
    state: 'MT',
    zip: 59255,
    telephone: '(406) 768-6300',
    population: 428,
    county: 'ROOSEVELT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fpcc.edu/',
  },
  {
    name: 'GOOD SAMARITAN COLLEGE OF NURSING AND HEALTH SCIENCE',
    address: '375 DIXMYTH AVE',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45220,
    telephone: '(513) 862-2631',
    population: 429,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gscollege.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-FORT WORTH CAMPUS',
    address: '300 E. LOOP 820',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76112,
    telephone: '(817) 451-0011',
    population: 430,
    county: 'TARRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/fort-worth-texas-career-schools-overview',
  },
  {
    name: 'GODDARD COLLEGE',
    address: '123 PITKIN ROAD',
    city: 'PLAINFIELD',
    state: 'VT',
    zip: 5667,
    telephone: '(802) 454-8311',
    population: 431,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.goddard.edu/',
  },
  {
    name: 'URSHAN COLLEGE',
    address: '1151 CENTURY TEL DRIVE',
    city: 'WENTZVILLE',
    state: 'MO',
    zip: 63385,
    telephone: '(314) 838-8858',
    population: 431,
    county: 'ST. CHARLES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'urshancollege.org/',
  },
  {
    name: 'RABBINICAL ACADEMY MESIVTA RABBI CHAIM BERLIN',
    address: '1593 CONEY ISLAND AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 377-0777',
    population: 431,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rabbinicalacademyrabbichaimberlin.com/',
  },
  {
    name: 'FORTIS COLLEGE-CUTLER BAY',
    address: '19600 SOUTH DIXIE HIGHWAY',
    city: 'CUTLER BAY',
    state: 'FL',
    zip: 33157,
    telephone: '(786) 345-5300',
    population: 431,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website:
      'https://fortis.edu/campuses/florida/cutler-bay/19600-south-dixie-highway-cutler-bay-fl.aspx',
  },
  {
    name: 'SUNSTATE ACADEMY-JONES TECHNICAL INSTITUTE',
    address: '8813 WESTERN WAY',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32256,
    telephone: '(904) 328-5600',
    population: 431,
    county: 'DUVAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jtech.org/',
  },
  {
    name: 'INSTITUTO TECNOLOGICO DE PUERTO RICO-RECINTO DE GUAYAMA',
    address: 'URB. VIVES, FINAL CALLE PASEO #2',
    city: 'GUAYAMA',
    state: 'PR',
    zip: 784,
    telephone: '(787) 866-8522 EXT 2011',
    population: 432,
    county: 'GUAYAMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.de.gov/itec-2/',
  },
  {
    name: 'NEW YORK COLLEGE OF HEALTH PROFESSIONS',
    address: '6801 JERICHO TPK',
    city: 'SYOSSET',
    state: 'NY',
    zip: 11791,
    telephone: '(516) 364-0808 EXT 100',
    population: 433,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nycollege.edu/',
  },
  {
    name: 'NEW YORK COLLEGE OF PODIATRIC MEDICINE',
    address: '53 EAST 124 STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10035,
    telephone: '(212) 410-8000',
    population: 434,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nycpm.edu/',
  },
  {
    name: 'AMERICAN INSTITUTE OF ALTERNATIVE MEDICINE',
    address: '6685 DOUBLETREE AVE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43229,
    telephone: '(614) 825-6255',
    population: 434,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aiam.edu/',
  },
  {
    name: 'CAREER COLLEGE OF NORTHERN NEVADA',
    address: '1421 PULLMAN DR.',
    city: 'SPARKS',
    state: 'NV',
    zip: 89434,
    telephone: '(775) 856-2266',
    population: 435,
    county: 'WASHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccnn.edu/',
  },
  {
    name: 'RICHMONT GRADUATE UNIVERSITY',
    address: '1815 MCCALLIE AVE',
    city: 'CHATTANOOGA',
    state: 'TN',
    zip: 37404,
    telephone: '(423) 226-4574',
    population: 437,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.richmont.edu/',
  },
  {
    name: 'AMERICAN UNIVERSITY OF PUERTO RICO',
    address: 'CARRETERA ESTATAL #2 KM.48.1',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 621-2835 EXT 3601',
    population: 438,
    county: 'MANATÍ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'aupr.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-SOUTHAVEN',
    address: '7900 AIRWAYS BLVD, STE 103',
    city: 'SOUTHAVEN',
    state: 'MS',
    zip: 38671,
    telephone: '(662) 429-9909',
    population: 438,
    county: 'DESOTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/southaven-mississippi',
  },
  {
    name: 'THE ART INSTITUTE OF SAN ANTONIO',
    address: '10000 IH-10 W STE 200',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78230,
    telephone: '(210) 338-7408',
    population: 440,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/san-antonio',
  },
  {
    name: 'LINCOLN UNIVERSITY',
    address: '401 15TH STREET',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94612,
    telephone: '(510) 628-8010',
    population: 440,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lincolnuca.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-MONTGOMERY',
    address: '5355 VAUGHN RD',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36116,
    telephone: '(334) 395-8800',
    population: 441,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/montgomery#location=Montgomery, AL',
  },
  {
    name: 'AULTMAN COLLEGE OF NURSING AND HEALTH SCIENCES',
    address: '2600 6TH ST SW',
    city: 'CANTON',
    state: 'OH',
    zip: 44710,
    telephone: '(330) 363-6347',
    population: 442,
    county: 'STARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.aultmancollege.edu/',
  },
  {
    name: 'ANCILLA COLLEGE',
    address: '9601 S. UNION ROAD',
    city: 'DONALDSON',
    state: 'IN',
    zip: 46513,
    telephone: '(574) 936-8898',
    population: 447,
    county: 'MARSHALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ancilla.edu/',
  },
  {
    name: 'FORTIS COLLEGE-INDIANAPOLIS',
    address: '9001 N WESLEYAN RD STE 101',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46268,
    telephone: '(317) 808-4800',
    population: 447,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'UNITED LUTHERAN SEMINARY',
    address: '61 SEMINARY RIDGE',
    city: 'GETTYSBURG',
    state: 'PA',
    zip: 17325,
    telephone: '(717) 334-6286 EXT 3007',
    population: 448,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unitedlutheranseminary.edu/',
  },
  {
    name: 'WELCH COLLEGE',
    address: '1045 BISON TRAIL',
    city: 'GALLATIN',
    state: 'TN',
    zip: 37066,
    telephone: '(615) 675-5255',
    population: 448,
    county: 'SUMNER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.welch.edu/',
  },
  {
    name: 'LAS VEGAS COLLEGE',
    address: '170 NORTH STEPHAINE SUITE 145',
    city: 'HENDERSON',
    state: 'NV',
    zip: 89074,
    telephone: '(702) 567-1920',
    population: 448,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://lvcollege.edu/',
  },
  {
    name: 'DIVINE MERCY UNIVERSITY',
    address: '45154 UNDERWOOD LANE',
    city: 'STERLING',
    state: 'VA',
    zip: 20166,
    telephone: '(703) 416-1441',
    population: 450,
    county: 'LOUDOUN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.divinemercy.edu/',
  },
  {
    name: 'TRINITY BAPTIST COLLEGE',
    address: '800 HAMMOND BLVD',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32221,
    telephone: '(904) 596-2400',
    population: 453,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tbc.edu/',
  },
  {
    name: 'FRANKLIN W OLIN COLLEGE OF ENGINEERING',
    address: '1000 OLIN WAY',
    city: 'NEEDHAM',
    state: 'MA',
    zip: 2492,
    telephone: '(781) 292-2300',
    population: 453,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.olin.edu/',
  },
  {
    name: 'FORTIS COLLEGE-BATON ROUGE',
    address: '14111 AIRLINE HWY, SUITE 101',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70817,
    telephone: '(225) 248-1015',
    population: 453,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'ALTIERUS CAREER COLLEGE-TAMPA',
    address: '3319 W HILLSBOROUGH AVE',
    city: 'TAMPA',
    state: 'FL',
    zip: 33614,
    telephone: '(813) 879-6000',
    population: 455,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.altierus.edu/',
  },
  {
    name: 'SENTARA COLLEGE OF HEALTH SCIENCES',
    address: '1441 CROSSWAYS BLVD, SUITE 105',
    city: 'CHESAPEAKE',
    state: 'VA',
    zip: 23320,
    telephone: '(757) 388-2900',
    population: 455,
    county: 'CHESAPEAKE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sentara.edu/',
  },
  {
    name: 'ROSEDALE TECHNICAL COLLEGE',
    address: '215 BEECHAM DRIVE, SUITE 2',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15205,
    telephone: '(412) 521-6200 EXT 112',
    population: 455,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rosedaletech.org/',
  },
  {
    name: 'FIVE BRANCHES UNIVERSITY',
    address: '200 7TH AVENUE',
    city: 'SANTA CRUZ',
    state: 'CA',
    zip: 95062,
    telephone: '(831) 476-9424',
    population: 456,
    county: 'SANTA CRUZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fivebranches.edu/',
  },
  {
    name: 'FORTIS COLLEGE',
    address: '7033 AIRPORT BLVD.',
    city: 'MOBILE',
    state: 'AL',
    zip: 36608,
    telephone: '(251) 344-1203 EXT 3111',
    population: 456,
    county: 'MOBILE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE',
    address: '8620 WESTWOOD CENTER DRIVE',
    city: 'VIENNA',
    state: 'VA',
    zip: 22182,
    telephone: '(703) 206-0508',
    population: 457,
    county: 'FAIRFAX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccdc.edu/',
  },
  {
    name: 'CONCORDE CAREER INSTITUTE-TAMPA',
    address: '4202 W SPRUCE',
    city: 'TAMPA',
    state: 'FL',
    zip: 33607,
    telephone: '(813) 874-0094',
    population: 457,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/tampa-florida',
  },
  {
    name: 'TALMUDICAL SEMINARY OF BOBOV',
    address: '5120 NEW UTRECHT AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 854-8700',
    population: 460,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.independentrabbinicalcolleges.org/',
  },
  {
    name: 'PAMLICO COMMUNITY COLLEGE',
    address: '5049 HWY 306 SOUTH',
    city: 'GRANTSBORO',
    state: 'NC',
    zip: 28529,
    telephone: '(252) 249-1851 EXT 3084',
    population: 460,
    county: 'PAMLICO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pamlicocc.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-CLEVELAND CAMPUS',
    address: '14445 BROADWAY AVE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44125,
    telephone: '(440) 777-2560',
    population: 460,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/cleveland-ohio-career-schools-overview',
  },
  {
    name: 'ALASKA CAREER COLLEGE',
    address: '1415 E TUDOR ROAD',
    city: 'ANCHORAGE',
    state: 'AK',
    zip: 99507,
    telephone: '(907) 563-7575',
    population: 464,
    county: 'ANCHORAGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alaskacareercollege.edu/',
  },
  {
    name: 'BETHANY GLOBAL UNIVERSITY',
    address: '6820 AUTO CLUB ROAD',
    city: 'BLOOMINGTON',
    state: 'MN',
    zip: 55438,
    telephone: '(800) 323-3417',
    population: 465,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bethanygu.edu/',
  },
  {
    name: 'CALIFORNIA UNIVERSITY OF SCIENCE AND MEDICINE',
    address: '1501 VIOLET STREET',
    city: 'COLTON',
    state: 'CA',
    zip: 92324,
    telephone: '(909) 580-9661',
    population: 465,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cusm.org/',
  },
  {
    name: 'CULINARY INSTITUTE INC',
    address: '7070 ALLENSBY',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77022,
    telephone: '(713) 358-5092',
    population: 465,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.culinaryinstitute.edu/',
  },
  {
    name: 'DAWSON COMMUNITY COLLEGE',
    address: '300 COLLEGE DR',
    city: 'GLENDIVE',
    state: 'MT',
    zip: 59330,
    telephone: '(406) 377-3396',
    population: 465,
    county: 'DAWSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dawson.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-MISSOURI',
    address: '11830 WESTLINE INDUSTRIAL DRIVE, SUITE 106',
    city: 'ST. LOUIS',
    state: 'MO',
    zip: 63146,
    telephone: '(314) 991-6200',
    population: 466,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TENNESSEE SYSTEM OFFICE',
    address: '1331 CIRCLE PARK DRIVE',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37996,
    telephone: '(865) 974-1000',
    population: 466,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tennessee.edu/',
  },
  {
    name: 'INTERNATIONAL SPORTS SCIENCES ASSOCIATION',
    address: '1015 MARK AVENUE',
    city: 'CARPINTERIA',
    state: 'CA',
    zip: 93013,
    telephone: '(800) 650-4772',
    population: 466,
    county: 'SANTA BARBARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'college.issaonline.edu/',
  },
  {
    name: 'BRYN ATHYN COLLEGE OF THE NEW CHURCH',
    address: '2945 COLLEGE DRIVE',
    city: 'BRYN ATHYN',
    state: 'PA',
    zip: 19009,
    telephone: '(267) 502-6000',
    population: 470,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brynathyn.edu/',
  },
  {
    name: 'EASTERN WEST VIRGINIA COMMUNITY AND TECHNICAL COLLEGE',
    address: '316 EASTERN DRIVE',
    city: 'MOOREFIELD',
    state: 'WV',
    zip: 26836,
    telephone: '(304) 434-8000',
    population: 471,
    county: 'HARDY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.easternwv.edu/',
  },
  {
    name: 'UNITED THEOLOGICAL SEMINARY',
    address: '4501 DENLINGER RD.',
    city: 'DAYTON',
    state: 'OH',
    zip: 45426,
    telephone: '(937) 529-2201',
    population: 472,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.united.edu/',
  },
  {
    name: 'RESEARCH COLLEGE OF NURSING',
    address: '2525 E. MEYER BOULEVARD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64132,
    telephone: '(816) 995-2800',
    population: 472,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'researchcollege.edu/',
  },
  {
    name: 'STANDARD HEALTHCARE SERVICES-COLLEGE OF NURSING',
    address: '7704 LEESBURG PIKE, SUITE 1000',
    city: 'FALLS CHURCH',
    state: 'VA',
    zip: 22043,
    telephone: '(703) 891-1787',
    population: 472,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.standardcollege.edu/',
  },
  {
    name: 'COLLEGE OF THE ATLANTIC',
    address: '105 EDEN STREET',
    city: 'BAR HARBOR',
    state: 'ME',
    zip: 4609,
    telephone: '(207) 288-5015',
    population: 474,
    county: 'HANCOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coa.edu/',
  },
  {
    name: 'EAST-WEST UNIVERSITY',
    address: '816 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(312) 939-0111',
    population: 475,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eastwest.edu/',
  },
  {
    name: 'RABBINICAL COLLEGE BOBOVER YESHIVA BNEI ZION',
    address: '1577 48TH ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 438-2018',
    population: 477,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'rabbinicalcollegeboboveryeshiva.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-ALBUQUERQUE',
    address: '1001 MENAUL BLVD. N.E.',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87107,
    telephone: '(505) 254-7777',
    population: 477,
    county: 'BERNALILLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'TRINITY LAW SCHOOL',
    address: '2200 N GRAND AVE',
    city: 'SANTA ANA',
    state: 'CA',
    zip: 92705,
    telephone: '(714) 796-7141',
    population: 479,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'tls.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-NEW ORLEANS',
    address: '3900 N. CAUSEWAY BLVD.',
    city: 'METAIRIE',
    state: 'LA',
    zip: 70002,
    telephone: '(504) 733-0074',
    population: 481,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-ARKANSAS',
    address: '10825 FINANCIAL CENTRE PKWY STE 400',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72211,
    telephone: '(877) 445-7180',
    population: 481,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/arkansas/little-rock',
  },
  {
    name: 'NORTHPOINT BIBLE COLLEGE',
    address: '320 SOUTH MAIN STREET',
    city: 'HAVERHILL',
    state: 'MA',
    zip: 1835,
    telephone: '(978) 478-3400',
    population: 482,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northpoint.edu/',
  },
  {
    name: 'BETHESDA UNIVERSITY',
    address: '730 N. EUCLID ST',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92801,
    telephone: '(714) 683-1212',
    population: 484,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.buc.edu/',
  },
  {
    name: 'MONTSERRAT COLLEGE OF ART',
    address: '23 ESSEX STREET',
    city: 'BEVERLY',
    state: 'MA',
    zip: 1915,
    telephone: '(978) 921-4242',
    population: 485,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.montserrat.edu/',
  },
  {
    name: 'CONCORDE CAREER INSTITUTE-MIRAMAR',
    address: '10933 MARKS WAY',
    city: 'MIRAMAR',
    state: 'FL',
    zip: 33025,
    telephone: '(954) 731-8880',
    population: 486,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website:
      'https://www.concorde.edu/campus/miramar-florida?SourceID=GOBRND&opti_ca=184111063&opti_ag=12068405503&opti_ad=229977911707&opti_key=kwd-11641010364&gc',
  },
  {
    name: 'UNIVERSITY OF ARIZONA-SIERRA VISTA',
    address: '1140 NORTH COLOMBO AVENUE',
    city: 'SIERRA VISTA',
    state: 'AZ',
    zip: 85635,
    telephone: '(520) 458-8278',
    population: 487,
    county: 'COCHISE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://azcast.arizona.edu/',
  },
  {
    name: 'COTTEY COLLEGE',
    address: '1000 W AUSTIN',
    city: 'NEVADA',
    state: 'MO',
    zip: 64772,
    telephone: '(417) 667-8181',
    population: 487,
    county: 'VERNON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cottey.edu/',
  },
  {
    name: 'YESHIVA OF MACHZIKAI HADAS',
    address: '1321 43RD ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11219,
    telephone: '(718) 853-2442',
    population: 491,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivaofmachzikaihadas.com/',
  },
  {
    name: 'WARNER PACIFIC UNIVERSITY PROFESSIONAL AND GRADUATE STUDIES',
    address: '2600 SE 98TH AVE STE 200',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97266,
    telephone: '(503) 517-1550',
    population: 493,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.warnerpacific.edu/',
  },
  {
    name: 'FOX COLLEGE',
    address: '6640 S. CICERO',
    city: 'BEDFORD PARK',
    state: 'IL',
    zip: 60638,
    telephone: '(708) 444-4500',
    population: 493,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.foxcollege.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-GREECE',
    address: '854 LONG POND ROAD',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14612,
    telephone: '(585) 720-0660',
    population: 494,
    county: 'MONROE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-MICHIGAN',
    address: '200 KIRTS BOULEVARD, SUITE C',
    city: 'TROY',
    state: 'MI',
    zip: 48084,
    telephone: '(248) 817-4140',
    population: 497,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-ALBANY',
    address: '1259 CENTRAL AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12205,
    telephone: '(518) 437-1802 EXT 215',
    population: 497,
    county: 'ALBANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-OHIO',
    address: '2 EASTON OVAL, STE 210',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43219,
    telephone: '(614) 253-7291',
    population: 498,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-VIRGINIA BEACH',
    address: '301 BENDIX RD, STE 100',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23452,
    telephone: '(757) 493-6900',
    population: 500,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/virginia-beach#location=Virginia Beach, VA',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT ANAHEIM',
    address: '2400 E. KATELLA AVE., SUITE 1200',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92806,
    telephone: '(714) 922-9600',
    population: 501,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/anaheim/',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-DALLAS',
    address: '8585 N. STEMMONS FREEWAY, SUITE 300, NORTH TOWER',
    city: 'DALLAS',
    state: 'TX',
    zip: 75247,
    telephone: '(214) 420-3400',
    population: 503,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.chcp.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-RICHMOND',
    address: '2151 OLD BRICK RD',
    city: 'GLEN ALLEN',
    state: 'VA',
    zip: 23060,
    telephone: '(804) 727-6800',
    population: 504,
    county: 'HENRICO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/richmond#location=Richmond, VA',
  },
  {
    name: 'SACRED HEART MAJOR SEMINARY',
    address: '2701 CHICAGO BLVD',
    city: 'DETROIT',
    state: 'MI',
    zip: 48206,
    telephone: '(313) 883-8500',
    population: 507,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shms.edu/',
  },
  {
    name: 'J F INGRAM STATE TECHNICAL COLLEGE',
    address: '5375 INGRAM RD',
    city: 'DEATSVILLE',
    state: 'AL',
    zip: 36022,
    telephone: '(334) 285-5177 EXT 3249',
    population: 507,
    county: 'ELMORE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.istc.edu/',
  },
  {
    name: 'ESCUELA DE ARTES PLASTICAS Y DISENO DE PUERTO RICO',
    address: 'BARRIO BALLAJA CAMPO DEL MORRO',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 902,
    telephone: '(787) 725-8120',
    population: 508,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eap.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-NEVADA',
    address: '9901 COVINGTON CROSS DRIVE',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89144,
    telephone: '(702) 786-1660',
    population: 508,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'GRATZ COLLEGE',
    address: '7605 OLD YORK RD',
    city: 'MELROSE PARK',
    state: 'PA',
    zip: 19027,
    telephone: '(215) 635-7300',
    population: 508,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gratz.edu/',
  },
  {
    name: 'COMMUNITY CHRISTIAN COLLEGE',
    address: '1174 NEVADA STREET, SUITE 200',
    city: 'REDLANDS',
    state: 'CA',
    zip: 92374,
    telephone: '(909) 253-7707',
    population: 508,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cccollege.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-AUSTIN',
    address: '1220 WEST LOUIS HENNA BOULEVARD',
    city: 'ROUND ROCK',
    state: 'TX',
    zip: 78681,
    telephone: '(877) 659-5706',
    population: 509,
    county: 'WILLIAMSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/austin#location=Austin, TX',
  },
  {
    name: 'PLATT COLLEGE-BERKS TECHNICAL INSTITUTE',
    address: '2205 RIDGEWOOD RD',
    city: 'WYOMISSING',
    state: 'PA',
    zip: 19610,
    telephone: '(610) 372-1722',
    population: 509,
    county: 'BERKS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.berks.edu/',
  },
  {
    name: 'FORTIS COLLEGE-NORFOLK',
    address: '6300 CENTER DR BLDG 22',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23502,
    telephone: '(757) 499-5447 EXT 1344',
    population: 509,
    county: 'NORFOLK CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortisedu.info/cig-vabeach.php',
  },
  {
    name: "THE KING'S COLLEGE",
    address: '56 BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10004,
    telephone: '(212) 659-7200',
    population: 514,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tkc.edu/',
  },
  {
    name: 'AMERICAN UNIVERSITY OF HEALTH SCIENCES',
    address: '1600 EAST HILL ST',
    city: 'SIGNAL HILL',
    state: 'CA',
    zip: 90755,
    telephone: '(562) 988-2278 EXT 2001',
    population: 514,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.auhs.edu/',
  },
  {
    name: 'AMERICAN ACADEMY MCALLISTER INSTITUTE OF FUNERAL SERVICE',
    address: '1501 BROADWAY, 11TH FLOOR, SUITE 1102',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10036,
    telephone: '(212) 757-1190',
    population: 515,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.funeraleducation.org/',
  },
  {
    name: 'ADVANCED TECHNOLOGY INSTITUTE',
    address: '5700 SOUTHERN BLVD STE 100',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23462,
    telephone: '(757) 490-1241',
    population: 515,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.auto.edu/',
  },
  {
    name: 'HESSTON COLLEGE',
    address: '301 SOUTH MAIN',
    city: 'HESSTON',
    state: 'KS',
    zip: 67062,
    telephone: '(620) 327-4221',
    population: 515,
    county: 'HARVEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hesston.edu/',
  },
  {
    name: 'INSTITUTO TECNOLOGICO DE PUERTO RICO-RECINTO DE MANATI',
    address: 'STATE ROAD 2 KM.47.3',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 854-2250 EXT 2010',
    population: 515,
    county: 'MANATÍ',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'itec.pr/ITPR-Joomla/',
  },
  {
    name: 'PENTECOSTAL THEOLOGICAL SEMINARY',
    address: '900 WALKER ST NE',
    city: 'CLEVELAND',
    state: 'TN',
    zip: 37320,
    telephone: '(423) 478-7037',
    population: 518,
    county: 'BRADLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ptseminary.edu/',
  },
  {
    name: 'SIOUX FALLS SEMINARY',
    address: '2100 S SUMMIT AVE',
    city: 'SIOUX FALLS',
    state: 'SD',
    zip: 57105,
    telephone: '(605) 336-6588',
    population: 519,
    county: 'MINNEHAHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfseminary.edu/',
  },
  {
    name: 'UNIVERSIDAD TEOLOGICA DEL CARIBE',
    address: 'ROAD 848 KM. 0.5 CALLEJON MARQUEZ, BO. SAINT JUST',
    city: 'TRUJILLO ALTO',
    state: 'PR',
    zip: 978,
    telephone: '(787) 761-0808 EXT 221',
    population: 520,
    county: 'TRUJILLO ALTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utcpr.edu/',
  },
  {
    name: 'CONSERVATORY OF MUSIC OF PUERTO RICO',
    address: '951 PONCE DE LEON AVENUE',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 907,
    telephone: '(787) 751-0160 EXT 223',
    population: 520,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cmpr.edu/',
  },
  {
    name: "ST. JOHN'S COLLEGE",
    address: '1160 CAMINO CRUZ BLANCA',
    city: 'SANTA FE',
    state: 'NM',
    zip: 87505,
    telephone: '(505) 984-6000',
    population: 521,
    county: 'SANTA FE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjc.edu/',
  },
  {
    name: 'MIDWEST TECHNICAL INSTITUTE-SPRINGFIELD',
    address: '3600 SOUTH GLENSTONE OUTER RD',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65804,
    telephone: '(417) 227-4950 EXT 1625',
    population: 521,
    county: 'GREENE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'midwesttech.edu/',
  },
  {
    name: 'ICPR JUNIOR COLLEGE',
    address: '558 MUNOZ RIVERA AVENUE',
    city: 'HATO REY',
    state: 'PR',
    zip: 919,
    telephone: '(787) 753-6000',
    population: 522,
    county: 'SAN JUAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.icprjc.edu/',
  },
  {
    name: 'MARION MILITARY INSTITUTE',
    address: '1101 WASHINGTON ST',
    city: 'MARION',
    state: 'AL',
    zip: 36756,
    telephone: '(800) 664-1842',
    population: 522,
    county: 'PERRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.marionmilitary.edu/',
  },
  {
    name: 'IBMC COLLEGE',
    address: '3842 SOUTH MASON STREET',
    city: 'FORT COLLINS',
    state: 'CO',
    zip: 80525,
    telephone: '(970) 223-2669',
    population: 522,
    county: 'LARIMER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ibmc.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-PORTLAND',
    address: '1425 NE IRVING STREET, BLDG 300',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97232,
    telephone: '(503) 281-4181',
    population: 524,
    county: 'MULTNOMAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/portland-oregon',
  },
  {
    name: 'MORRIS COLLEGE',
    address: '100 WEST COLLEGE STREET',
    city: 'SUMTER',
    state: 'SC',
    zip: 29150,
    telephone: '(803) 934-3200',
    population: 525,
    county: 'SUMTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.morris.edu/',
  },
  {
    name: 'MERCYHURST UNIVERSITY-NORTH EAST CAMPUS',
    address: '16 W DIVISION ST',
    city: 'NORTH EAST',
    state: 'PA',
    zip: 16428,
    telephone: '(814) 725-6100',
    population: 528,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'northeast.mercyhurst.edu/',
  },
  {
    name: 'UNITED TRIBES TECHNICAL COLLEGE',
    address: '3315 UNIVERSITY DRIVE',
    city: 'BISMARCK',
    state: 'ND',
    zip: 58504,
    telephone: '(701) 255-3285',
    population: 528,
    county: 'BURLEIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.uttc.edu/',
  },
  {
    name: 'COLLEGE OF BIBLICAL STUDIES-HOUSTON',
    address: '7000 REGENCY SQUARE BLVD.',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77036,
    telephone: '(713) 785-5995',
    population: 530,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cbshouston.edu/',
  },
  {
    name: 'SHERMAN COLLEGE OF CHIROPRACTIC',
    address: '2020 SPRINGFIELD RD',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29316,
    telephone: '(864) 578-8770',
    population: 530,
    county: 'SPARTANBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sherman.edu/',
  },
  {
    name: 'OREGON COAST COMMUNITY COLLEGE',
    address: '400 SE COLLEGE WAY',
    city: 'NEWPORT',
    state: 'OR',
    zip: 97366,
    telephone: '(541) 265-2283',
    population: 530,
    county: 'LINCOLN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oregoncoastcc.org/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-COLORADO SPRINGS',
    address: '5725 MARK DABLING BLVD, SUITE 150',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80919,
    telephone: '(719) 482-7462',
    population: 531,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-PORT SAINT LUCIE',
    address: '9022 SOUTH US HIGHWAY 1',
    city: 'PORT SAINT LUCIE',
    state: 'FL',
    zip: 34952,
    telephone: '(772) 221-9799',
    population: 532,
    county: 'ST. LUCIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-NASHVILLE',
    address: '3354 PERIMETER HILL DRIVE, SUITE 105',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37211,
    telephone: '(615) 320-5917',
    population: 532,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'SOUTHWESTERN INDIAN POLYTECHNIC INSTITUTE',
    address: '9169 COORS BLVD NW',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87120,
    telephone: '(505) 346-2347',
    population: 533,
    county: 'BERNALILLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sipi.edu/',
  },
  {
    name: 'VOORHEES COLLEGE',
    address: '491 PORTER DRIVE',
    city: 'DENMARK',
    state: 'SC',
    zip: 29042,
    telephone: '(803) 780-1234',
    population: 534,
    county: 'BAMBERG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.voorhees.edu/',
  },
  {
    name: 'SWEET BRIAR COLLEGE',
    address: '134 CHAPEL DRIVE',
    city: 'SWEET BRIAR',
    state: 'VA',
    zip: 24595,
    telephone: '(434) 381-6100',
    population: 534,
    county: 'AMHERST',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sbc.edu/',
  },
  {
    name: 'JOHNSON & WALES UNIVERSITY-DENVER',
    address: '7150 MONTVIEW BLVD',
    city: 'DENVER',
    state: 'CO',
    zip: 80220,
    telephone: '(303) 256-9300',
    population: 535,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jwu.edu/campuses/denver/index.html',
  },
  {
    name: 'SAN JUAN BAUTISTA SCHOOL OF MEDICINE',
    address: 'CARRETERA 172 URB. TURABO GARDENS',
    city: 'CAGUAS',
    state: 'PR',
    zip: 725,
    telephone: '(787) 743-3038 EXT 254',
    population: 536,
    county: 'CAGUAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sanjuanbautista.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-EL PASO',
    address: '6926 GATEWAY BOULEVARD E.',
    city: 'EL PASO',
    state: 'TX',
    zip: 79915,
    telephone: '(915) 633-1133',
    population: 536,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pmi.edu/',
  },
  {
    name: 'SAN FRANCISCO CONSERVATORY OF MUSIC',
    address: '50 OAK STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94102,
    telephone: '(415) 864-7326',
    population: 537,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://sfcm.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW HAMPSHIRE-FRANKLIN PIERCE SCHOOL OF LAW',
    address: '2 WHITE ST',
    city: 'CONCORD',
    state: 'NH',
    zip: 3301,
    telephone: '(603) 228-1541',
    population: 538,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://law.unh.edu/',
  },
  {
    name: 'SAINT FRANCIS MEDICAL CENTER COLLEGE OF NURSING',
    address: '511 NE GREENLEAF ST',
    city: 'PEORIA',
    state: 'IL',
    zip: 61603,
    telephone: '(309) 655-2201',
    population: 538,
    county: 'PEORIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfmccon.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-MIAMI',
    address: '1321 SW 107 AVENUE, SUITE 201B',
    city: 'MIAMI',
    state: 'FL',
    zip: 33174,
    telephone: '(786) 534-0501',
    population: 538,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-BROOKFIELD',
    address: '15895 W BLUEMOUND RD',
    city: 'BROOKFIELD',
    state: 'WI',
    zip: 53005,
    telephone: '(262) 649-1710',
    population: 539,
    county: 'WAUKESHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-MARIETTA',
    address: '2359 WINDY HILL ROAD',
    city: 'MARIETTA',
    state: 'GA',
    zip: 30067,
    telephone: '(770) 226-0056',
    population: 539,
    county: 'COBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/marietta-ga',
  },
  {
    name: 'WARNER PACIFIC UNIVERSITY',
    address: '2219 SE 68TH AVE',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97215,
    telephone: '(503) 517-1000',
    population: 540,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.warnerpacific.edu/',
  },
  {
    name: 'PENNSYLVANIA INSTITUTE OF TECHNOLOGY',
    address: '800 MANCHESTER AVE',
    city: 'MEDIA',
    state: 'PA',
    zip: 19063,
    telephone: '(800) 422-0025',
    population: 540,
    county: 'DELAWARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pit.edu/',
  },
  {
    name: 'NER ISRAEL RABBINICAL COLLEGE',
    address: '400 MOUNT WILSON LN',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21208,
    telephone: '(410) 484-7200',
    population: 542,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://nirc.edu/',
  },
  {
    name: 'FORTIS COLLEGE-ORANGE PARK',
    address: '700 BLANDING BLVD. SUITE 16',
    city: 'ORANGE PARK',
    state: 'FL',
    zip: 32065,
    telephone: '(904) 269-7086',
    population: 542,
    county: 'CLAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'fortis.edu/',
  },
  {
    name: 'STAUTZENBERGER COLLEGE-ROCKFORD CAREER COLLEGE',
    address: '1130 SOUTH ALPINE ROAD SUITE 100',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61108,
    telephone: '(815) 965-8616',
    population: 542,
    county: 'WINNEBAGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rockfordcareercollege.edu/',
  },
  {
    name: 'HUMPHREYS UNIVERSITY-STOCKTON AND MODESTO CAMPUSES',
    address: '6650 INGLEWOOD AVE',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95207,
    telephone: '(209) 478-0800',
    population: 543,
    county: 'SAN JOAQUIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.humphreys.edu/',
  },
  {
    name: 'BLACKFEET COMMUNITY COLLEGE',
    address: '504 S.E. EAST BOUNDARY',
    city: 'BROWNING',
    state: 'MT',
    zip: 59417,
    telephone: '(406) 338-5441 EXT 2201',
    population: 543,
    county: 'GLACIER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bfcc.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-AKRON',
    address: '1600 SOUTH ARLINGTON STREET, SUITE 100',
    city: 'AKRON',
    state: 'OH',
    zip: 44306,
    telephone: '(330) 724-1600',
    population: 543,
    county: 'SUMMIT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'PLATT COLLEGE-ANAHEIM',
    address: '1551 SOUTH DOUGLASS ROAD',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92806,
    telephone: '(714) 333-9606',
    population: 545,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattcollege.edu/',
  },
  {
    name: 'SUMNER COLLEGE',
    address: '8338 NE ALDERWOOD ROAD STE 100',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97220,
    telephone: '(503) 972-6230',
    population: 545,
    county: 'MULTNOMAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sumnercollege.edu/',
  },
  {
    name: 'WELLS COLLEGE',
    address: '170 MAIN STREET',
    city: 'AURORA',
    state: 'NY',
    zip: 13026,
    telephone: '(315) 364-3264',
    population: 547,
    county: 'CAYUGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wells.edu/',
  },
  {
    name: 'MIAMI INTERNATIONAL UNIVERSITY OF ART & DESIGN-ART INSTITUTE DALLAS',
    address: '8080 PARK LANE, SUITE 100',
    city: 'DALLAS',
    state: 'TX',
    zip: 75231,
    telephone: '(214) 692-8080',
    population: 548,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/dallas/',
  },
  {
    name: 'BON SECOURS MEMORIAL COLLEGE OF NURSING',
    address: '8550 MAGELLAN PARKWAY SUITE 1100',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23227,
    telephone: '(804) 627-5300',
    population: 549,
    county: 'HENRICO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bsmcon.edu/',
  },
  {
    name: 'MESIVTA TORAH VODAATH RABBINICAL SEMINARY',
    address: '425 E 9TH ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11218,
    telephone: '(718) 621-3651',
    population: 549,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'independentrabbinicalcolleges.org/index.html',
  },
  {
    name: 'NORTHWESTERN COLLEGE',
    address: '7725 SOUTH HARLEM AVENUE',
    city: 'BRIDGEVIEW',
    state: 'IL',
    zip: 60455,
    telephone: '(708) 237-5050',
    population: 552,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nc.edu/',
  },
  {
    name: 'THE BAPTIST COLLEGE OF FLORIDA',
    address: '5400 COLLEGE DR',
    city: 'GRACEVILLE',
    state: 'FL',
    zip: 32440,
    telephone: '(850) 263-3261',
    population: 555,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baptistcollege.edu/',
  },
  {
    name: 'AMERICAN MEDICAL ACADEMY',
    address: '12215 SW 112 STREET',
    city: 'MIAMI',
    state: 'FL',
    zip: 33186,
    telephone: '(305) 271-6555',
    population: 555,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ama.edu/',
  },
  {
    name: 'OHIO TECHNICAL COLLEGE',
    address: '1374 E 51ST ST',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44103,
    telephone: '(216) 881-1700',
    population: 558,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ohiotech.edu/',
  },
  {
    name: 'GWINNETT INSTITUTE',
    address: '1900 NORTH ALAFAYA TRAIL',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32826,
    telephone: '(407) 434-8700',
    population: 560,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gwinnettcollege.edu/',
  },
  {
    name: 'PAUL QUINN COLLEGE',
    address: '3837 SIMPSON STUART RD',
    city: 'DALLAS',
    state: 'TX',
    zip: 75241,
    telephone: '(214) 379-5577',
    population: 561,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pqc.edu/',
  },
  {
    name: 'FORTIS COLLEGE-RICHMOND',
    address: '2000 WESTMORELAND STREET, SUITE A',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23230,
    telephone: '(804) 323-1020',
    population: 561,
    county: 'HENRICO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'JACKSONVILLE COLLEGE-MAIN CAMPUS',
    address: '105 B J ALBRITTON DR',
    city: 'JACKSONVILLE',
    state: 'TX',
    zip: 75766,
    telephone: '(903) 586-2518',
    population: 562,
    county: 'CHEROKEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jacksonville-college.edu/',
  },
  {
    name: 'BENJAMIN FRANKLIN INSTITUTE OF TECHNOLOGY',
    address: '41 BERKELEY ST',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 423-4630',
    population: 563,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bfit.edu/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY-EAST',
    address: 'URB VILLA FLORES CALLE ACACIA #1213',
    city: 'PONCE',
    state: 'PR',
    zip: 731,
    telephone: '(787) 840-2575',
    population: 563,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.psm.edu',
  },
  {
    name: 'MILDRED ELLEY SCHOOL-ALBANY CAMPUS',
    address: '855 CENTRAL AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12206,
    telephone: '(518) 786-0855',
    population: 563,
    county: 'ALBANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mildred-elley.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-MISSISSIPPI',
    address: '100 EAST CAPITOL STREET SUITE 100',
    city: 'JACKSON',
    state: 'MS',
    zip: 39201,
    telephone: '(877) 445-7180',
    population: 564,
    county: 'HINDS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/mississippi/jackson',
  },
  {
    name: 'IDAHO COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '1401 EAST CENTRAL DRIVE',
    city: 'MERIDIAN',
    state: 'ID',
    zip: 83642,
    telephone: '(208) 795-4266',
    population: 564,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.idahocom.org/',
  },
  {
    name: 'UNIVERSITY OF CONNECTICUT-AVERY POINT',
    address: '1084 SHENNECOSSETT RD',
    city: 'GROTON',
    state: 'CT',
    zip: 6340,
    telephone: '(860) 405-9000',
    population: 564,
    county: 'NEW LONDON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'averypoint.uconn.edu/',
  },
  {
    name: 'MOORE COLLEGE OF ART AND DESIGN',
    address: '20TH AND THE PARKWAY',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19103,
    telephone: '(215) 568-4515',
    population: 565,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.moore.edu/',
  },
  {
    name: 'MANDL SCHOOL-THE COLLEGE OF ALLIED HEALTH',
    address: '254 W 54TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10019,
    telephone: '(212) 247-3434 EXT 136',
    population: 566,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mandl.edu/',
  },
  {
    name: 'CENTER FOR ADVANCED STUDIES ON PUERTO RICO AND THE CARIBBEAN',
    address: 'CALLE DEL CRISTO #52',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 901,
    telephone: '(787) 723-4481 EXT 21',
    population: 567,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ceaprc.edu/',
  },
  {
    name: 'THE ART INSTITUTE OF HOUSTON',
    address: '4140 SOUTHWEST FREEWAY',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77027,
    telephone: '(713) 623-2040',
    population: 567,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/houston',
  },
  {
    name: 'BLUE CLIFF COLLEGE-ALEXANDRIA',
    address: '1505 METRO DR STE 1',
    city: 'ALEXANDRIA',
    state: 'LA',
    zip: 71301,
    telephone: '(318) 445-2778',
    population: 567,
    county: 'RAPIDES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bluecliffcollege.edu/',
  },
  {
    name: 'BAY MILLS COMMUNITY COLLEGE',
    address: '12214 W LAKESHORE DR',
    city: 'BRIMLEY',
    state: 'MI',
    zip: 49715,
    telephone: '(906) 248-3354 EXT 8423',
    population: 567,
    county: 'CHIPPEWA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bmcc.edu/',
  },
  {
    name: 'CALVARY UNIVERSITY',
    address: '15800 CALVARY ROAD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64147,
    telephone: '(816) 322-0110',
    population: 568,
    county: 'CASS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calvary.edu/',
  },
  {
    name: 'ARIZONA COLLEGE-GLENDALE',
    address: '4425 W OLIVE AVENUE, SUITE 300',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85302,
    telephone: '(855) 706-8382',
    population: 569,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.arizonacollege.edu/',
  },
  {
    name: 'BEAL UNIVERSITY',
    address: '99 FARM ROAD',
    city: 'BANGOR',
    state: 'ME',
    zip: 4401,
    telephone: '(207) 947-4591',
    population: 573,
    county: 'PENOBSCOT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.beal.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-FRESNO',
    address: '295 EAST SIERRA AVENUE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93710,
    telephone: '(559) 734-9000',
    population: 573,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-RENO',
    address: '5580 KIETZKE LN.',
    city: 'RENO',
    state: 'NV',
    zip: 89511,
    telephone: '(775) 335-2900',
    population: 575,
    county: 'WASHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'AVERETT UNIVERSITY-NON-TRADITIONAL PROGRAMS',
    address: '420 W MAIN ST',
    city: 'DANVILLE',
    state: 'VA',
    zip: 24541,
    telephone: '(800) 448-5233',
    population: 576,
    county: 'DANVILLE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://gps.averett.edu/',
  },
  {
    name: 'FINLANDIA UNIVERSITY',
    address: '601 QUINCY ST',
    city: 'HANCOCK',
    state: 'MI',
    zip: 49930,
    telephone: '(906) 482-5300',
    population: 577,
    county: 'HOUGHTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.finlandia.edu/',
  },
  {
    name: 'PINNACLE CAREER INSTITUTE-SOUTH KANSAS CITY',
    address: '10301 HICKMAN MILLS DR.',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64137,
    telephone: '(816) 331-5700',
    population: 577,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pcitraining.edu/',
  },
  {
    name: 'JEWISH THEOLOGICAL SEMINARY OF AMERICA',
    address: '3080 BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 678-8000',
    population: 578,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jtsa.edu/',
  },
  {
    name: 'THOMAS AQUINAS COLLEGE',
    address: '10,000 OJAI ROAD',
    city: 'SANTA PAULA',
    state: 'CA',
    zip: 93060,
    telephone: '(805) 525-4417',
    population: 578,
    county: 'VENTURA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://thomasaquinas.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-SAN ANTONIO',
    address: '4803 NW LOOP 410',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78229,
    telephone: '(210) 428-2000',
    population: 579,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/san-antonio-texas',
  },
  {
    name: 'ARKANSAS BAPTIST COLLEGE',
    address: '1600 DR. MARTIN LUTHER KING JR. DRIVE',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72202,
    telephone: '(501) 420-1200',
    population: 580,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.arkansasbaptist.edu/',
  },
  {
    name: 'WILBERFORCE UNIVERSITY',
    address: '1055 N BICKETT RD',
    city: 'WILBERFORCE',
    state: 'OH',
    zip: 45384,
    telephone: '(937) 376-2911',
    population: 580,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wilberforce.edu/',
  },
  {
    name: "BARD COLLEGE AT SIMON'S ROCK",
    address: '84 ALFORD ROAD',
    city: 'GREAT BARRINGTON',
    state: 'MA',
    zip: 1230,
    telephone: '(413) 644-4400',
    population: 580,
    county: 'BERKSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.simons-rock.edu/',
  },
  {
    name: 'ST LOUIS COLLEGE OF HEALTH CAREERS-FENTON',
    address: '1297 NORTH HIGHWAY DRIVE',
    city: 'FENTON',
    state: 'MO',
    zip: 63026,
    telephone: '(636) 529-0000 EXT 3575',
    population: 581,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.slchc.edu/',
  },
  {
    name: 'TILLAMOOK BAY COMMUNITY COLLEGE',
    address: '4301 THIRD ST.',
    city: 'TILLAMOOK',
    state: 'OR',
    zip: 97141,
    telephone: '(503) 842-8222',
    population: 585,
    county: 'TILLAMOOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'tillamookbaycc.edu/',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-MCALLEN CAMPUS',
    address: '1917 W. NOLANA AVE SUITE 100',
    city: 'MCALLEN',
    state: 'TX',
    zip: 78504,
    telephone: '(956) 800-1500',
    population: 587,
    county: 'HIDALGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chcp.edu/',
  },
  {
    name: 'CAROLINAS COLLEGE OF HEALTH SCIENCES',
    address: '2110 WATER RIDGE PARKWAY',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28217,
    telephone: '(704) 355-5043',
    population: 588,
    county: 'MECKLENBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.carolinascollege.edu/',
  },
  {
    name: 'NEWSCHOOL OF ARCHITECTURE AND DESIGN',
    address: '1249 F ST',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(800) 490-7081',
    population: 589,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newschoolarch.edu/',
  },
  {
    name: 'PENNCO TECH-BRISTOL',
    address: '3815 OTTER ST',
    city: 'BRISTOL',
    state: 'PA',
    zip: 19007,
    telephone: '(215) 785-0111',
    population: 589,
    county: 'BUCKS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.penncotech.edu/pennco-bristol.php',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-MILWAUKEE FLEX',
    address: '2200 E KENWOOD BLVD',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53201,
    telephone: '(877) 895-3276',
    population: 590,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://flex.wisconsin.edu/',
  },
  {
    name: 'DEWEY UNIVERSITY-HATO REY',
    address: 'BARBOSA AVE #427 3RD FLOOR - MALCO BLDG',
    city: 'HATO REY',
    state: 'PR',
    zip: 910,
    telephone: '(787) 753-0039 EXT 0',
    population: 590,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'dewey.edu/',
  },
  {
    name: 'HOLY CROSS COLLEGE',
    address: '54515 STATE ROAD 933 NORTH',
    city: 'NOTRE DAME',
    state: 'IN',
    zip: 46556,
    telephone: '(574) 239-8377',
    population: 591,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hcc-nd.edu/',
  },
  {
    name: 'BROOKLINE COLLEGE-TEMPE',
    address: '1140-1150 S. PRIEST DRIVE',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85281,
    telephone: '(480) 545-8755',
    population: 591,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'brooklinecollege.edu/',
  },
  {
    name: 'LAKE FOREST GRADUATE SCHOOL OF MANAGEMENT',
    address: '1905 W. FIELD COURT',
    city: 'LAKE FOREST',
    state: 'IL',
    zip: 60045,
    telephone: '(847) 234-5005',
    population: 592,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lfgsm.edu/',
  },
  {
    name: 'DENMARK TECHNICAL COLLEGE',
    address: '1126 SOLOMON BLATT BLVD',
    city: 'DENMARK',
    state: 'SC',
    zip: 29042,
    telephone: '(803) 793-5100',
    population: 592,
    county: 'BAMBERG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.denmarktech.edu/',
  },
  {
    name: 'JOHNSON COLLEGE',
    address: '3427 N MAIN AVE',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18508,
    telephone: '(570) 342-6404',
    population: 593,
    county: 'LACKAWANNA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.johnson.edu/',
  },
  {
    name: 'NEUMONT COLLEGE OF COMPUTER SCIENCE',
    address: '143 SOUTH MAIN STREET',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84111,
    telephone: '(801) 302-2800',
    population: 594,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.neumont.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-BOISE',
    address: '1122 N. LIBERTY ST.',
    city: 'BOISE',
    state: 'ID',
    zip: 83704,
    telephone: '(208) 377-8080',
    population: 594,
    county: 'ADA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'CALIFORNIA INTERCONTINENTAL UNIVERSITY',
    address: '17310 RED HILL AVE. SUITE 200',
    city: 'IRVINE',
    state: 'CA',
    zip: 92614,
    telephone: '(949) 359-0045',
    population: 596,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.caluniversity.edu/',
  },
  {
    name: 'COYNE COLLEGE',
    address: '1 NORTH STATE STREET, SUITE 400',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60602,
    telephone: '(773) 577-8100',
    population: 598,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coynecollege.edu/',
  },
  {
    name: 'BEACON COLLEGE',
    address: '105 E MAIN ST',
    city: 'LEESBURG',
    state: 'FL',
    zip: 34748,
    telephone: '(352) 787-7660',
    population: 599,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.beaconcollege.edu/',
  },
  {
    name: 'SINTE GLESKA UNIVERSITY',
    address: 'E. HIGHWAY 18, 101 ANTELOPE LAKE CIRCLE',
    city: 'MISSION',
    state: 'SD',
    zip: 57555,
    telephone: '(605) 856-8100',
    population: 600,
    county: 'TODD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sintegleska.edu/',
  },
  {
    name: 'LOUISBURG COLLEGE',
    address: '501 N. MAIN ST.',
    city: 'LOUISBURG',
    state: 'NC',
    zip: 27549,
    telephone: '(919) 496-2521',
    population: 605,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.louisburg.edu/',
  },
  {
    name: 'WESLEY THEOLOGICAL SEMINARY',
    address: '4500 MASSACHUSETTS AVE., NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20016,
    telephone: '(202) 885-8600',
    population: 606,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wesleyseminary.edu/',
  },
  {
    name: 'HELENE FULD COLLEGE OF NURSING',
    address: '24 EAST 120TH STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10035,
    telephone: '(212) 616-7200',
    population: 607,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.helenefuld.edu/',
  },
  {
    name: 'PLATT COLLEGE-ONTARIO',
    address: '3700 INLAND EMPIRE BOULEVARD, STE 400',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91764,
    telephone: '(909) 941-9410',
    population: 609,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattcollege.edu/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY-EAST',
    address: 'URB VILLA FLORES CALLE ACACIA #1213',
    city: 'PONCE',
    state: 'PR',
    zip: 731,
    telephone: '(787) 840-2575',
    population: 610,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.psm.edu/',
  },
  {
    name: 'PRINCIPIA COLLEGE',
    address: '1 MAYBECK PLACE',
    city: 'ELSAH',
    state: 'IL',
    zip: 62028,
    telephone: '(618) 374-2131',
    population: 610,
    county: 'JERSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.principiacollege.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-WEST PALM BEACH',
    address: '9801 BELVEDERE ROAD',
    city: 'ROYAL PALM BEACH',
    state: 'FL',
    zip: 33411,
    telephone: '(561) 273-6500',
    population: 610,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/west-palm-beach#location=West Palm Beach, FL',
  },
  {
    name: 'VERMONT COLLEGE OF FINE ARTS',
    address: '36 COLLEGE ST',
    city: 'MONTPELIER',
    state: 'VT',
    zip: 5602,
    telephone: '(802) 828-8600',
    population: 610,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vcfa.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE TECHNICAL-AUGUSTA',
    address: '621 NW FRONTAGE ROAD',
    city: 'AUGUSTA',
    state: 'GA',
    zip: 30907,
    telephone: '(706) 396-8000',
    population: 610,
    county: 'RICHMOND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.miller-motte.edu/campuses/augusta-career-training',
  },
  {
    name: 'PLATT COLLEGE-RIVERSIDE',
    address: '6465 SYCAMORE CANYON BLVD STE 100',
    city: 'RIVERSIDE',
    state: 'CA',
    zip: 92507,
    telephone: '(951) 572-4300',
    population: 612,
    county: 'RIVERSIDE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattcollege.edu/',
  },
  {
    name: 'PRINCETON THEOLOGICAL SEMINARY',
    address: '64 MERCER ST',
    city: 'PRINCETON',
    state: 'NJ',
    zip: 8542,
    telephone: '(609) 921-8300',
    population: 613,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ptsem.edu/',
  },
  {
    name: 'SOUTHWESTERN CHRISTIAN UNIVERSITY',
    address: '7210 NW 39TH EXPRESSWAY',
    city: 'BETHANY',
    state: 'OK',
    zip: 73008,
    telephone: '(405) 789-7661',
    population: 614,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swcu.edu/',
  },
  {
    name: 'CLEVELAND INSTITUTE OF MUSIC',
    address: '11021 EAST BLVD',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44106,
    telephone: '(216) 791-5000',
    population: 614,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cim.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-DALLAS',
    address: '12606 GREENVILLE AVE STE 130',
    city: 'DALLAS',
    state: 'TX',
    zip: 75243,
    telephone: '(469) 221-3400',
    population: 615,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/dallas-texas',
  },
  {
    name: 'ATLANTIS UNIVERSITY',
    address: '1442 BISCAYNE BOULEVARD',
    city: 'MIAMI',
    state: 'FL',
    zip: 33132,
    telephone: '(305) 377-8817 EXT 1005',
    population: 617,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atlantisuniversity.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-BIRMINGHAM',
    address: '100 LONDON PKWY STE 150',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35211,
    telephone: '(205) 940-7800 EXT 4911',
    population: 618,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'MAINE COLLEGE OF ART',
    address: '522 CONGRESS ST.',
    city: 'PORTLAND',
    state: 'ME',
    zip: 4101,
    telephone: '(207) 669-5521',
    population: 621,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.meca.edu/',
  },
  {
    name: 'CABARRUS COLLEGE OF HEALTH SCIENCES',
    address: '401 MEDICAL PARK DRIVE',
    city: 'CONCORD',
    state: 'NC',
    zip: 28025,
    telephone: '(704) 403-1555',
    population: 621,
    county: 'CABARRUS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atriumhealth.org/education/cabarrus-college-of-health-sciences',
  },
  {
    name: 'FORTIS COLLEGE-COLUMBIA',
    address: '246 STONERIDGE DR STE 101',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29210,
    telephone: '(803) 678-4800',
    population: 621,
    county: 'RICHLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fortis.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-VIRGINIA',
    address: '1951 KIDWELL DRIVE',
    city: 'VIENNA',
    state: 'VA',
    zip: 22182,
    telephone: '(703) 416-7300',
    population: 622,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'RABBINICAL SEMINARY OF AMERICA',
    address: '76-01 147TH ST',
    city: 'FLUSHING',
    state: 'NY',
    zip: 11367,
    telephone: '(718) 268-4700',
    population: 622,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rabbinical.org/',
  },
  {
    name: 'MTI COLLEGE',
    address: '5221 MADISON AVENUE',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95841,
    telephone: '(916) 339-1500',
    population: 623,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mticollege.edu/',
  },
  {
    name: 'SOUTHERN CALIFORNIA INSTITUTE OF TECHNOLOGY',
    address: '525 N. MULLER STREET',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92801,
    telephone: '(714) 300-0300',
    population: 624,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.scitech.edu/',
  },
  {
    name: 'ROGER WILLIAMS UNIVERSITY SCHOOL OF LAW',
    address: 'TEN METACOM AVE',
    city: 'BRISTOL',
    state: 'RI',
    zip: 2809,
    telephone: '(401) 254-4500',
    population: 624,
    county: 'BRISTOL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'law.rwu.edu/',
  },
  {
    name: 'LUTHER SEMINARY',
    address: '2481 COMO AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55108,
    telephone: '(651) 641-3456',
    population: 624,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.luthersem.edu/',
  },
  {
    name: 'KANSAS CITY UNIVERSITY OF MEDICINE AND BIOSCIENCES-JOPLIN',
    address: "2901 ST. JOHN'S BOULEVARD",
    city: 'JOPLIN',
    state: 'MO',
    zip: 64804,
    telephone: '(417) 208-0630',
    population: 626,
    county: 'JASPER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kcumb.edu/',
  },
  {
    name: 'FORTIS COLLEGE-SALT LAKE CITY',
    address: '3949 S 700 E STE 150',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84107,
    telephone: '(801) 713-0915',
    population: 626,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'SOUTHERN CALIFORNIA INSTITUTE OF ARCHITECTURE',
    address: '960 E. 3RD STREET',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90013,
    telephone: '(213) 613-2200',
    population: 627,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sciarc.edu/',
  },
  {
    name: 'CAREER NETWORKS INSTITUTE',
    address: '1610 E. SAINT ANDREW PLACE SUITE 200',
    city: 'SANTA ANA',
    state: 'CA',
    zip: 92705,
    telephone: '(714) 437-9697',
    population: 631,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cnicollege.edu/',
  },
  {
    name: 'CONCORDE CAREER INSTITUTE-JACKSONVILLE',
    address: '7259 SALISBURY ROAD',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32256,
    telephone: '(904) 725-0525',
    population: 633,
    county: 'DUVAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/jacksonville-florida',
  },
  {
    name: 'INTELLITEC COLLEGE-COLORADO SPRINGS',
    address: '2315 EAST PIKES PEAK AVENUE',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80909,
    telephone: '(719) 632-7626 EXT 1101',
    population: 634,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'intellitec.edu/',
  },
  {
    name: 'SANS TECHNOLOGY INSTITUTE',
    address: '8120 WOODMONT AVE.',
    city: 'BETHESDA',
    state: 'MD',
    zip: 20814,
    telephone: '(301) 241-7665',
    population: 635,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sans.edu',
  },
  {
    name: 'FORTIS COLLEGE-CUYAHOGA FALLS',
    address: '2545 BAILEY ROAD',
    city: 'CUYAHOGA FALLS',
    state: 'OH',
    zip: 44221,
    telephone: '(330) 923-9959 EXT 4666',
    population: 635,
    county: 'SUMMIT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'fortiscollege.edu/',
  },
  {
    name: 'EASTERN NEW MEXICO UNIVERSITY RUIDOSO BRANCH COMMUNITY COLLEGE',
    address: '709 MECHEM DR',
    city: 'RUIDOSO',
    state: 'NM',
    zip: 88345,
    telephone: '(575) 257-2120',
    population: 636,
    county: 'LINCOLN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ruidoso.enmu.edu/',
  },
  {
    name: 'THE WRIGHT INSTITUTE',
    address: '2728 DURANT AVE',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 841-9230 EXT 101',
    population: 638,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wi.edu/',
  },
  {
    name: 'CENTRAL YESHIVA TOMCHEI TMIMIM LUBAVITZ',
    address: '841 OCEAN PKY',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11230,
    telephone: '(718) 774-3430',
    population: 638,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cyttl.edu/',
  },
  {
    name: 'URBAN COLLEGE OF BOSTON',
    address: '2 BOYLSTON STREET, 2ND FLOOR',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 449-7070',
    population: 638,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.urbancollege.edu/',
  },
  {
    name: 'VERMILION COMMUNITY COLLEGE',
    address: '1900 EAST CAMP STREET',
    city: 'ELY',
    state: 'MN',
    zip: 55731,
    telephone: '(218) 235-2100',
    population: 641,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.vcc.edu/',
  },
  {
    name: 'ATENAS COLLEGE',
    address: 'PASEO DEL ATENAS #101',
    city: 'MANATI',
    state: 'PR',
    zip: 674,
    telephone: '(787) 884-3838',
    population: 641,
    county: 'MANATÍ',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.atenascollege.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY AGRICULTURAL TECHNICAL INSTITUTE',
    address: '1328 DOVER RD',
    city: 'WOOSTER',
    state: 'OH',
    zip: 44691,
    telephone: '(330) 287-1331',
    population: 641,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ati.osu.edu/',
  },
  {
    name: 'VISTA COLLEGE-ONLINE',
    address: '300 N. COIT RD, SUITE 300',
    city: 'RICHARDSON',
    state: 'TX',
    zip: 75080,
    telephone: '(972) 733-3431',
    population: 643,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'vistacollege.edu/',
  },
  {
    name: 'COGSWELL UNIVERSITY OF SILICON VALLEY',
    address: '191 BAYPOINTE PARKWAY',
    city: 'SAN JOSE',
    state: 'CA',
    zip: 95134,
    telephone: '(800) 264-7955',
    population: 644,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://cogswell.edu/',
  },
  {
    name: 'STAUTZENBERGER COLLEGE-ROCKFORD CAREER COLLEGE',
    address: '1130 SOUTH ALPINE ROAD SUITE 100',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61108,
    telephone: '(815) 965-8616',
    population: 644,
    county: 'WINNEBAGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rockfordcareercollege.edu/',
  },
  {
    name: 'HUERTAS COLLEGE',
    address: '#41 HECTOR R BUNKER ST',
    city: 'CAGUAS',
    state: 'PR',
    zip: 725,
    telephone: '(787) 746-1400 EXT 1022',
    population: 644,
    county: 'CAGUAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.huertas.edu/',
  },
  {
    name: "BE'ER YAAKOV TALMUDIC SEMINARY",
    address: '12 TRUMAN AVENUE',
    city: 'SPRING VALLEY',
    state: 'NY',
    zip: 10977,
    telephone: '(845) 406-9699',
    population: 645,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'byts.edu/',
  },
  {
    name: 'BLACKBURN COLLEGE',
    address: '700 COLLEGE AVE',
    city: 'CARLINVILLE',
    state: 'IL',
    zip: 62626,
    telephone: '(217) 854-3231',
    population: 645,
    county: 'MACOUPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.blackburn.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-CENTER FOR GRADUATE STUDIES',
    address: '590 NORTH VERMONT AVENUE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90004,
    telephone: '(323) 284-7998',
    population: 646,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'EUREKA COLLEGE',
    address: '300 E. COLLEGE AVENUE',
    city: 'EUREKA',
    state: 'IL',
    zip: 61530,
    telephone: '(309) 467-3721',
    population: 649,
    county: 'WOODFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eureka.edu/',
  },
  {
    name: 'LINCOLN TECHNICAL INSTITUTE-ALLENTOWN',
    address: '5151 TILGHMAN ST',
    city: 'ALLENTOWN',
    state: 'PA',
    zip: 18104,
    telephone: '(610) 398-5300 EXT 40700',
    population: 649,
    county: 'LEHIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/allentown-pa',
  },
  {
    name: 'STAUTZENBERGER COLLEGE-MAUMEE',
    address: '1796 INDIAN WOOD CIRCLE',
    city: 'MAUMEE',
    state: 'OH',
    zip: 43537,
    telephone: '(419) 866-0261',
    population: 649,
    county: 'LUCAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sctoday.edu/',
  },
  {
    name: 'BETHEL COLLEGE-NORTH NEWTON',
    address: '300 E 27TH ST',
    city: 'NORTH NEWTON',
    state: 'KS',
    zip: 67117,
    telephone: '(316) 283-2500',
    population: 650,
    county: 'HARVEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bethelks.edu/',
  },
  {
    name: 'BAPTIST HEALTH SYSTEM SCHOOL OF HEALTH PROFESSIONS',
    address: '8400 DATAPOINT DR',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78229,
    telephone: '(210) 297-9636',
    population: 650,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bshp.edu/',
  },
  {
    name: "ST. JOHN'S COLLEGE",
    address: '60 COLLEGE AVE',
    city: 'ANNAPOLIS',
    state: 'MD',
    zip: 21401,
    telephone: '(410) 263-2371',
    population: 651,
    county: 'ANNE ARUNDEL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjc.edu/',
  },
  {
    name: 'PROVO COLLEGE',
    address: '1450 W 820 N',
    city: 'PROVO',
    state: 'UT',
    zip: 84601,
    telephone: '(801) 818-8901',
    population: 651,
    county: 'UTAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.provocollege.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-SAN JOSE',
    address: '5883 RUE FERRARI #125',
    city: 'SAN JOSE',
    state: 'CA',
    zip: 95138,
    telephone: '(408) 337-3534',
    population: 652,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'FORTIS COLLEGE-CINCINNATI',
    address: '11499 CHESTER ROAD STE 200',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45246,
    telephone: '(513) 771-2795 EXT 2186',
    population: 652,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'FLORIDA COLLEGE',
    address: '119 N GLEN ARVEN AVE',
    city: 'TEMPLE TERRACE',
    state: 'FL',
    zip: 33617,
    telephone: '(813) 988-5131 EXT 102',
    population: 653,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.floridacollege.edu/',
  },
  {
    name: 'WESTERN TECHNICAL COLLEGE',
    address: '9451 DIANA DRIVE',
    city: 'EL PASO',
    state: 'TX',
    zip: 79924,
    telephone: '(915) 566-9621',
    population: 653,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.westerntech.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-SYRACUSE NORTH',
    address: '7805 OSWEGO RD',
    city: 'LIVERPOOL',
    state: 'NY',
    zip: 13090,
    telephone: '(315) 652-6500',
    population: 656,
    county: 'ONONDAGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-SAN MARCOS',
    address: '111 CAMPUS WAY',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92078,
    telephone: '(760) 299-4500',
    population: 657,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'CHARLESTON SCHOOL OF LAW',
    address: '81 MARY STREET',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29403,
    telephone: '(843) 329-1000',
    population: 658,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.charlestonlaw.edu/',
  },
  {
    name: 'SOKA UNIVERSITY OF AMERICA',
    address: '1 UNIVERSITY DRIVE',
    city: 'ALISO VIEJO',
    state: 'CA',
    zip: 92656,
    telephone: '(949) 480-4000',
    population: 659,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.soka.edu/',
  },
  {
    name: 'HEBREW UNION COLLEGE-JEWISH INSTITUTE OF RELIGION',
    address: 'ONE W 4TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10012,
    telephone: '(212) 674-5300',
    population: 659,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.huc.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-BIRMINGHAM',
    address: '280 WEST VALLEY AVE',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35209,
    telephone: '(205) 916-2800',
    population: 661,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'VALLEY COLLEGE-MARTINSBURG',
    address: '287 AIKENS CTR EDWIN MILLER BLVD',
    city: 'MARTINSBURG',
    state: 'WV',
    zip: 25404,
    telephone: '(304) 263-0979',
    population: 661,
    county: 'BERKELEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.valley.edu/',
  },
  {
    name: 'ALASKA PACIFIC UNIVERSITY',
    address: '4101 UNIVERSITY DR',
    city: 'ANCHORAGE',
    state: 'AK',
    zip: 99508,
    telephone: '(907) 561-1266',
    population: 662,
    county: 'ANCHORAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alaskapacific.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-MESA',
    address: '1001 WEST SOUTHERN AVENUE',
    city: 'MESA',
    state: 'AZ',
    zip: 85210,
    telephone: '(480) 734-2378',
    population: 666,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'SUM BIBLE COLLEGE AND THEOLOGICAL SEMINARY',
    address: '1101 INVESTMENT BLVD. #115',
    city: 'EL DORADO HILLS',
    state: 'CA',
    zip: 95762,
    telephone: '(510) 567-6174',
    population: 668,
    county: 'EL DORADO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sum.edu/',
  },
  {
    name: 'BEULAH HEIGHTS UNIVERSITY',
    address: '892 BERNE ST SE',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30316,
    telephone: '(404) 627-2681',
    population: 671,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.beulah.edu/',
  },
  {
    name: 'CORNISH COLLEGE OF THE ARTS',
    address: '1000 LENORA STREET',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98121,
    telephone: '(206) 726-5016',
    population: 676,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cornish.edu/',
  },
  {
    name: 'PITTSBURGH INSTITUTE OF AERONAUTICS',
    address: '5 ALLEGHENY COUNTY AIRPORT',
    city: 'WEST MIFFLIN',
    state: 'PA',
    zip: 15122,
    telephone: '(412) 346-2100',
    population: 678,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pia.edu/',
  },
  {
    name: 'HIGHLANDS COLLEGE OF MONTANA TECH',
    address: '25 BASIN CREEK RD',
    city: 'BUTTE',
    state: 'MT',
    zip: 59701,
    telephone: '(406) 496-3711',
    population: 679,
    county: 'SILVER BOW',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mtech.edu/',
  },
  {
    name: 'TAFT UNIVERSITY SYSTEM',
    address: '3333 SOUTH WADSWORTH BOULEVARD, SUITE D-228',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80227,
    telephone: '(303) 867-1155',
    population: 682,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.taftu.edu/',
  },
  {
    name: 'NATIONAL UNIVERSITY OF NATURAL MEDICINE',
    address: '49 S PORTER ST.',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97201,
    telephone: '(503) 552-1555',
    population: 682,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nunm.edu/',
  },
  {
    name: 'NEW CASTLE SCHOOL OF TRADES',
    address: '4117 PULAKSI ROAD',
    city: 'NEW CASTLE',
    state: 'PA',
    zip: 16101,
    telephone: '(724) 964-8811',
    population: 682,
    county: 'LAWRENCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ncstrades.edu/',
  },
  {
    name: 'ALICE LLOYD COLLEGE',
    address: '100 PURPOSE RD',
    city: 'PIPPA PASSES',
    state: 'KY',
    zip: 41844,
    telephone: '(606) 368-6000',
    population: 683,
    county: 'KNOTT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alc.edu/',
  },
  {
    name: 'SOUTHWEST COLLEGE OF NATUROPATHIC MEDICINE & HEALTH SCIENCES',
    address: '2140 E BROADWAY RD',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85282,
    telephone: '(480) 858-9100 EXT 200',
    population: 685,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scnm.edu/',
  },
  {
    name: 'ROANOKE-CHOWAN COMMUNITY COLLEGE',
    address: '109 COMMUNITY COLLEGE RD',
    city: 'AHOSKIE',
    state: 'NC',
    zip: 27910,
    telephone: '(252) 862-1200',
    population: 686,
    county: 'HERTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.roanokechowan.edu/',
  },
  {
    name: 'NEW ENGLAND COLLEGE OF OPTOMETRY',
    address: '424 BEACON ST',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 266-2030',
    population: 687,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neco.edu/',
  },
  {
    name: 'VILLA MARIA COLLEGE',
    address: '240 PINE RIDGE RD',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14225,
    telephone: '(716) 896-0700',
    population: 687,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.villa.edu/',
  },
  {
    name: 'FAITH BAPTIST BIBLE COLLEGE AND THEOLOGICAL SEMINARY',
    address: '1900 NW 4TH ST',
    city: 'ANKENY',
    state: 'IA',
    zip: 50023,
    telephone: '(515) 964-0601',
    population: 688,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://faith.edu/',
  },
  {
    name: 'BROOKLINE COLLEGE-ALBUQUERQUE',
    address: '4201 CENTRAL AVE NW-STE J',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87105,
    telephone: '(505) 880-2877',
    population: 688,
    county: 'BERNALILLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.brooklinecollege.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-FLORIDA',
    address: '2300 SW 145TH AVE.',
    city: 'MIRAMAR',
    state: 'FL',
    zip: 33027,
    telephone: '(954) 499-9775',
    population: 689,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'WEST VIRGINIA JUNIOR COLLEGE-MORGANTOWN',
    address: '148 WILLEY ST',
    city: 'MORGANTOWN',
    state: 'WV',
    zip: 26505,
    telephone: '(304) 296-8282',
    population: 691,
    county: 'MONONGALIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wvjc.edu/',
  },
  {
    name: 'NEW MEXICO STATE UNIVERSITY-GRANTS',
    address: '1500 THIRD STREET',
    city: 'GRANTS',
    state: 'NM',
    zip: 87020,
    telephone: '(505) 287-6678',
    population: 691,
    county: 'CIBOLA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'grants.nmsu.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-DALLAS CAMPUS',
    address: '1800 EASTGATE DR',
    city: 'GARLAND',
    state: 'TX',
    zip: 75041,
    telephone: '(972) 686-7878',
    population: 694,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/dallas-texas-career-schools-overview',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-GARDEN GROVE',
    address: '12951 EUCLID STREET, SUITE 101',
    city: 'GARDEN GROVE',
    state: 'CA',
    zip: 92840,
    telephone: '(714) 703-1900',
    population: 695,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/garden-grove-california',
  },
  {
    name: 'PILLAR COLLEGE',
    address: '60 PARK PLACE, SUITE 701',
    city: 'NEWARK',
    state: 'NJ',
    zip: 7102,
    telephone: '(973) 803-5000 EXT 2000',
    population: 696,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pillar.edu/',
  },
  {
    name: 'MAYLAND COMMUNITY COLLEGE',
    address: '200 MAYLAND DRIVE',
    city: 'SPRUCE PINE',
    state: 'NC',
    zip: 28777,
    telephone: '(828) 765-7351',
    population: 696,
    county: 'AVERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mayland.edu/',
  },
  {
    name: 'UNIVERSITY OF VALLEY FORGE',
    address: '1401 CHARLESTOWN ROAD',
    city: 'PHOENIXVILLE',
    state: 'PA',
    zip: 19460,
    telephone: '(610) 935-0450',
    population: 698,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.valleyforge.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-NORTH HOLLYWOOD',
    address: '12412 VICTORY BOULEVARD',
    city: 'NORTH HOLLYWOOD',
    state: 'CA',
    zip: 91606,
    telephone: '(818) 766-8151',
    population: 700,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/north-hollywood-california',
  },
  {
    name: 'LINCOLN CHRISTIAN UNIVERSITY',
    address: '100 CAMPUS VIEW DRIVE',
    city: 'LINCOLN',
    state: 'IL',
    zip: 62656,
    telephone: '(217) 732-3168',
    population: 702,
    county: 'LOGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lincolnchristian.edu/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-NORTH DAKOTA',
    address: '4012 19TH AVENUE SW',
    city: 'FARGO',
    state: 'ND',
    zip: 58103,
    telephone: '(701) 277-3889',
    population: 702,
    county: 'CASS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'WYOTECH',
    address: '1889 VENTURE DRIVE',
    city: 'LARAMIE',
    state: 'WY',
    zip: 82070,
    telephone: '(307) 742-3776',
    population: 702,
    county: 'ALBANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wyotech.edu/',
  },
  {
    name: 'PALAU COMMUNITY COLLEGE',
    address: '9TH MADALAII HAMLET',
    city: 'KOROR',
    state: 'PW',
    zip: 96940,
    telephone: '(680) 488-2470',
    population: 702,
    county: 'NOT AVAILABLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'palau.edu/',
  },
  {
    name: 'BELLIN COLLEGE',
    address: '3201 EATON ROAD',
    city: 'GREEN BAY',
    state: 'WI',
    zip: 54311,
    telephone: '(920) 433-6699',
    population: 703,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bellincollege.edu/',
  },
  {
    name: 'SPRINGFIELD COLLEGE-REGIONAL, ONLINE, AND CONTINUING EDUCATION',
    address: 'SPRINGFIELD COLLEGE - REGIONAL, ONLINE, AND CONTINUING EDUCATION',
    city: 'SPRINGFIELD',
    state: 'MA',
    zip: 1109,
    telephone: '(413) 748-3204',
    population: 707,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://springfield.edu/regional-and-online',
  },
  {
    name: 'HERZING UNIVERSITY-MINNEAPOLIS',
    address: '435 FORD ROAD',
    city: 'ST. LOUIS PARK',
    state: 'MN',
    zip: 55426,
    telephone: '(763) 535-3000',
    population: 707,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'HOLY APOSTLES COLLEGE AND SEMINARY',
    address: '33 PROSPECT HILL ROAD',
    city: 'CROMWELL',
    state: 'CT',
    zip: 6416,
    telephone: '(860) 632-3010',
    population: 710,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.holyapostles.edu/',
  },
  {
    name: 'COVENANT THEOLOGICAL SEMINARY',
    address: '12330 CONWAY ROAD',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63141,
    telephone: '(314) 434-4044',
    population: 710,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.covenantseminary.edu/',
  },
  {
    name: 'ALBANY LAW SCHOOL',
    address: '80 NEW SCOTLAND AVENUE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12208,
    telephone: '(518) 445-2311',
    population: 711,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.albanylaw.edu/',
  },
  {
    name: 'SOUTHERN COLLEGE OF OPTOMETRY',
    address: '1245 MADISON AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 722-3200',
    population: 712,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sco.edu/',
  },
  {
    name: 'BORICUA COLLEGE',
    address: '3755 BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10032,
    telephone: '(212) 694-1000',
    population: 713,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'boricuacollege.edu/',
  },
  {
    name: 'SAN DIEGO CHRISTIAN COLLEGE',
    address: '200 RIVERVIEW PARKWAY',
    city: 'SANTEE',
    state: 'CA',
    zip: 92071,
    telephone: '(619) 201-8700',
    population: 716,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'sdcc.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-PEMBROKE PINES',
    address: '7891 PINES BOULEVARD',
    city: 'PEMBROKE PINES',
    state: 'FL',
    zip: 33024,
    telephone: '(954) 399-4801',
    population: 716,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'MILES COMMUNITY COLLEGE',
    address: '2715 DICKINSON STREET',
    city: 'MILES CITY',
    state: 'MT',
    zip: 59301,
    telephone: '(800) 541-9281',
    population: 716,
    county: 'CUSTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.milescc.edu/',
  },
  {
    name: 'COMMUNITY CARE COLLEGE',
    address: '4242 SOUTH SHERIDAN',
    city: 'TULSA',
    state: 'OK',
    zip: 74145,
    telephone: '(919) 610-0027',
    population: 717,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.communitycarecollege.edu/',
  },
  {
    name: 'SANS TECHNOLOGY INSTITUTE',
    address: '11200 ROCKVILLE PIKE, SUITE 200',
    city: 'NORTH BETHESDA',
    state: 'MD',
    zip: 20852,
    telephone: '(301) 654-7267',
    population: 718,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sans.edu/',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-AUSTIN',
    address: '6330 E. HIGHWAY 290 SUITE 180',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78723,
    telephone: '(512) 617-5700',
    population: 719,
    county: 'TRAVIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chcp.edu/',
  },
  {
    name: 'REMINGTON COLLEGE-MEMPHIS CAMPUS',
    address: '2710 NONCONNAH BLVD',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38132,
    telephone: '(901) 291-4239',
    population: 721,
    county: 'SHELBY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.remingtoncollege.edu/memphis-tennessee-career-colleges-overview',
  },
  {
    name: 'FORTIS COLLEGE-LANDOVER',
    address: '4351 GARDEN CITY DRIVE',
    city: 'LANDOVER',
    state: 'MD',
    zip: 20785,
    telephone: '(301) 459-3650',
    population: 723,
    county: "PRINCE GEORGE'S",
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-BOYNTON BEACH',
    address: '1743 NORTH CONGRESS AVENUE',
    city: 'BOYNTON BEACH',
    state: 'FL',
    zip: 33426,
    telephone: '(561) 853-9941',
    population: 723,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'NORTHLAND COLLEGE',
    address: '1411 ELLIS AVENUE',
    city: 'ASHLAND',
    state: 'WI',
    zip: 54806,
    telephone: '(715) 682-1699',
    population: 725,
    county: 'ASHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.northland.edu/',
  },
  {
    name: 'METHODIST COLLEGE',
    address: '7600 N. ACADEMIC DRIVE',
    city: 'PEORIA',
    state: 'IL',
    zip: 61615,
    telephone: '(309) 672-5513',
    population: 725,
    county: 'PEORIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.methodistcol.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-ARIZONA',
    address: '2149 W. DUNLAP AVENUE',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85021,
    telephone: '(602) 331-2720',
    population: 725,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'UNIVERSITY OF MINNESOTA-ROCHESTER',
    address: '111 SOUTH BROADWAY, SUITE 300',
    city: 'ROCHESTER',
    state: 'MN',
    zip: 55904,
    telephone: '(877) 280-4699',
    population: 725,
    county: 'OLMSTED',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://r.umn.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-SAN BERNARDINO',
    address: '201 EAST AIRPORT DRIVE, SUITE A',
    city: 'SAN BERNARDINO',
    state: 'CA',
    zip: 92408,
    telephone: '(909) 884-8891',
    population: 725,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/san-bernardino-california',
  },
  {
    name: 'COLEGIO DE CINEMATOGRAFÍA ARTES Y TELEVISION',
    address: 'DR. VEVE #51 ESQ. DEGETAU',
    city: 'BAYAMON',
    state: 'PR',
    zip: 961,
    telephone: '(787) 779-2500',
    population: 725,
    county: 'BAYAMÓN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ccatpuertorico.com/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-WISCONSIN',
    address: '904 SOUTH TAYLOR STREET, SUITE 100',
    city: 'GREEN BAY',
    state: 'WI',
    zip: 54303,
    telephone: '(920) 593-8400',
    population: 727,
    county: 'BROWN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'SANFORD BURNHAM PREBYS MEDICAL DISCOVERY INSTITUTE',
    address: '10901 NORTH TORREY PINES ROAD',
    city: 'LA JOLLA',
    state: 'CA',
    zip: 92037,
    telephone: '(858) 646-3100 EXT 5138',
    population: 728,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sbpdiscovery.org/education/graduate-school',
  },
  {
    name: 'OTTAWA UNIVERSITY-KANSAS CITY',
    address: '4370 W. 109TH STREET SUITE 200',
    city: 'OVERLAND PARK',
    state: 'KS',
    zip: 66211,
    telephone: '(913) 451-1431',
    population: 731,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/',
  },
  {
    name: 'CONCORDIA SEMINARY',
    address: '801 SEMINARY PLACE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63105,
    telephone: '(314) 505-7000',
    population: 731,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csl.edu/',
  },
  {
    name: 'HUSSIAN COLLEGE-DAYMAR COLLEGE CLARKSVILLE',
    address: '2691 TRENTON ROAD',
    city: 'CLARKSVILLE',
    state: 'TN',
    zip: 37040,
    telephone: '(717) 380-1385',
    population: 731,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daymarcollege.edu/',
  },
  {
    name: 'MARYMOUNT CALIFORNIA UNIVERSITY',
    address: '30800 PALOS VERDES DRIVE EAST',
    city: 'RANCHO PALOS VERDES',
    state: 'CA',
    zip: 90275,
    telephone: '(310) 377-5501',
    population: 731,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.marymountcalifornia.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-KENOSHA',
    address: '5800 7TH AVENUE',
    city: 'KENOSHA',
    state: 'WI',
    zip: 53140,
    telephone: '(866) 724-9144',
    population: 732,
    county: 'KENOSHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'SUNY COLLEGE OF OPTOMETRY',
    address: '33 WEST 42ND STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10036,
    telephone: '(212) 938-4000',
    population: 733,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sunyopt.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-TEMECULA',
    address: '27270 MADISON AVENUE',
    city: 'TEMECULA',
    state: 'CA',
    zip: 92590,
    telephone: '(559) 734-9000',
    population: 733,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'NATIONAL UNIVERSITY OF HEALTH SCIENCES',
    address: '200 E ROOSEVELT RD',
    city: 'LOMBARD',
    state: 'IL',
    zip: 60148,
    telephone: '(630) 629-2000',
    population: 734,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nuhs.edu/',
  },
  {
    name: 'NAZARENE BIBLE COLLEGE',
    address: '1465 KELLY JOHNSON BLVD',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80920,
    telephone: '(719) 884-5000',
    population: 734,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nbc.edu/',
  },
  {
    name: 'WILLIAMSBURG TECHNICAL COLLEGE',
    address: '601 MARTIN LUTHER KING JR AVE',
    city: 'KINGSTREE',
    state: 'SC',
    zip: 29556,
    telephone: '(843) 355-4110',
    population: 734,
    county: 'WILLIAMSBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wiltech.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-JACKSONVILLE',
    address: '6600 YOUNGERMAN CIRCLE',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32244,
    telephone: '(904) 418-5201',
    population: 735,
    county: 'DUVAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'NOTRE DAME DE NAMUR UNIVERSITY',
    address: '1500 RALSTON AVE',
    city: 'BELMONT',
    state: 'CA',
    zip: 94002,
    telephone: '(650) 508-3500',
    population: 736,
    county: 'SAN MATEO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ndnu.edu/',
  },
  {
    name: 'TURTLE MOUNTAIN COMMUNITY COLLEGE',
    address: '10145 BIA #7',
    city: 'BELCOURT',
    state: 'ND',
    zip: 58316,
    telephone: '(701) 477-7862',
    population: 736,
    county: 'ROLETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tm.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-UTUADO',
    address: 'CARR. # 10 KM. 52.2',
    city: 'UTUADO',
    state: 'PR',
    zip: 641,
    telephone: '(787) 894-2828 EXT 2240',
    population: 741,
    county: 'UTUADO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprutuado.edu/',
  },
  {
    name: 'CENTENARY COLLEGE OF LOUISIANA',
    address: '2911 CENTENARY BOULEVARD',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71104,
    telephone: '(318) 869-5011',
    population: 744,
    county: 'CADDO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centenary.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-OHIO',
    address: '1350 ALUM CREEK DRIVE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43209,
    telephone: '(614) 252-8890',
    population: 744,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-ALBUQUERQUE',
    address: '4400 CUTLER AVENUE NE',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87110,
    telephone: '(505) 881-1234',
    population: 744,
    county: 'BERNALILLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'CLEVELAND UNIVERSITY-KANSAS CITY',
    address: '10850 LOWELL AVENUE',
    city: 'OVERLAND PARK',
    state: 'KS',
    zip: 66210,
    telephone: '(913) 234-0600',
    population: 745,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cleveland.edu/',
  },
  {
    name: 'ACADEMY FOR NURSING AND HEALTH OCCUPATIONS',
    address: '5154 OKEECHOBEE BLVD STE 201',
    city: 'WEST PALM BEACH',
    state: 'FL',
    zip: 33417,
    telephone: '(561) 683-1400',
    population: 745,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.anho.edu/',
  },
  {
    name: 'FORTIS COLLEGE-CENTERVILLE',
    address: '555 E ALEX BELL RD',
    city: 'CENTERVILLE',
    state: 'OH',
    zip: 45459,
    telephone: '(937) 433-3410',
    population: 746,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'WILEY COLLEGE',
    address: '711 WILEY AVE',
    city: 'MARSHALL',
    state: 'TX',
    zip: 75670,
    telephone: '(903) 927-3300',
    population: 747,
    county: 'HARRISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'wileyc.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-SEATTLE',
    address: '9709 THIRD AVE NE SUITE 400',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98115,
    telephone: '(206) 322-6100',
    population: 747,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'ILLINOIS COLLEGE OF OPTOMETRY',
    address: '3241 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60616,
    telephone: '(312) 949-7400',
    population: 750,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ico.edu/',
  },
  {
    name: 'ALTIERUS CAREER COLLEGE-NORCROSS',
    address: '1750 BEAVER RUIN RD-STE 500',
    city: 'NORCROSS',
    state: 'GA',
    zip: 30093,
    telephone: '(770) 921-1085',
    population: 750,
    county: 'GWINNETT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.altierus.edu/',
  },
  {
    name: 'CAMBRIDGE COLLEGE OF HEALTHCARE & TECHNOLOGY',
    address: '5150 LINTON BLVD, SUITE 340',
    city: 'DELRAY BEACH',
    state: 'FL',
    zip: 33484,
    telephone: '(561) 381-4990',
    population: 751,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cambridgehealth.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-ORLANDO',
    address: '1865 SR 436',
    city: 'WINTER PARK',
    state: 'FL',
    zip: 32792,
    telephone: '(407) 478-0500',
    population: 755,
    county: 'SEMINOLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-KANSAS',
    address: '620 SW GOVERNOR VIEW',
    city: 'TOPEKA',
    state: 'KS',
    zip: 66606,
    telephone: '(785) 228-7320',
    population: 755,
    county: 'SHAWNEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'LUTHER RICE COLLEGE & SEMINARY',
    address: '3038 EVANS MILL ROAD',
    city: 'LITHONIA',
    state: 'GA',
    zip: 30038,
    telephone: '(770) 484-1204',
    population: 755,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lutherrice.edu/',
  },
  {
    name: 'DEFIANCE COLLEGE',
    address: '701 N CLINTON ST.',
    city: 'DEFIANCE',
    state: 'OH',
    zip: 43512,
    telephone: '(419) 784-4010',
    population: 757,
    county: 'DEFIANCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.defiance.edu/',
  },
  {
    name: 'MITCHELL COLLEGE',
    address: '437 PEQUOT AVENUE',
    city: 'NEW LONDON',
    state: 'CT',
    zip: 6320,
    telephone: '(860) 701-5000',
    population: 758,
    county: 'NEW LONDON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mitchell.edu/',
  },
  {
    name: 'CENTRAL CHRISTIAN COLLEGE OF KANSAS',
    address: '1200 S MAIN',
    city: 'MCPHERSON',
    state: 'KS',
    zip: 67460,
    telephone: '(620) 241-0723 EXT 331',
    population: 758,
    county: 'MCPHERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.centralchristian.edu/',
  },
  {
    name: 'PRESENTATION COLLEGE',
    address: '1500 N MAIN',
    city: 'ABERDEEN',
    state: 'SD',
    zip: 57401,
    telephone: '(605) 225-1634',
    population: 758,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.presentation.edu/',
  },
  {
    name: 'FORTIS COLLEGE-SMYRNA',
    address: '2140 SOUTH COBB DRIVE',
    city: 'SMYRNA',
    state: 'GA',
    zip: 30080,
    telephone: '(770) 980-0002',
    population: 758,
    county: 'COBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'fortis.edu/',
  },
  {
    name: 'CHEYNEY UNIVERSITY OF PENNSYLVANIA',
    address: '1837 UNIVERSITY CIRCLE',
    city: 'CHEYNEY',
    state: 'PA',
    zip: 19319,
    telephone: '(610) 399-2275',
    population: 759,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cheyney.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-RENTON',
    address: '555 SOUTH RENTON VILLAGE PLACE SUITE 110',
    city: 'RENTON',
    state: 'WA',
    zip: 98057,
    telephone: '(425) 228-9600',
    population: 759,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-MARGATE',
    address: '3271 N. STATE ROAD 7',
    city: 'MARGATE',
    state: 'FL',
    zip: 33063,
    telephone: '(954) 935-7921',
    population: 759,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'CARIBBEAN UNIVERSITY-PONCE',
    address: 'AVE. EDNITA NAZARIO #1015',
    city: 'PONCE',
    state: 'PR',
    zip: 716,
    telephone: '(787) 840-2955',
    population: 760,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caribbean.edu/',
  },
  {
    name: 'ITI TECHNICAL COLLEGE',
    address: '13944 AIRLINE HWY',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70817,
    telephone: '(225) 752-4233',
    population: 760,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iticollege.edu/',
  },
  {
    name: 'LIFE PACIFIC UNIVERSITY',
    address: '1100 W. COVINA BLVD.',
    city: 'SAN DIMAS',
    state: 'CA',
    zip: 91773,
    telephone: '(909) 599-5433',
    population: 762,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lifepacific.edu/',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-FORT WORTH',
    address: '4248 NORTH FREEWAY',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76137,
    telephone: '(817) 632-5900',
    population: 762,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.chcp.edu/',
  },
  {
    name: 'NORTHWEST INDIAN COLLEGE',
    address: '2522 KWINA RD',
    city: 'BELLINGHAM',
    state: 'WA',
    zip: 98226,
    telephone: '(360) 676-2772',
    population: 762,
    county: 'WHATCOM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nwic.edu/',
  },
  {
    name: 'BETHANY COLLEGE',
    address: '31 E CAMPUS DR',
    city: 'BETHANY',
    state: 'WV',
    zip: 26032,
    telephone: '(304) 829-7000',
    population: 764,
    county: 'BROOKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bethanywv.edu/',
  },
  {
    name: 'PACIFIC NORTHWEST COLLEGE OF ART',
    address: '511 NW BROADWAY',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97209,
    telephone: '(503) 226-4391',
    population: 764,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'pnca.edu/',
  },
  {
    name: 'LANDMARK COLLEGE',
    address: '19 RIVER RD SOUTH',
    city: 'PUTNEY',
    state: 'VT',
    zip: 5346,
    telephone: '(802) 387-6700',
    population: 773,
    county: 'WINDHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.landmark.edu/',
  },
  {
    name: 'EASTERN SHORE COMMUNITY COLLEGE',
    address: '29300 LANKFORD HWY',
    city: 'MELFA',
    state: 'VA',
    zip: 23410,
    telephone: '(757) 789-1789',
    population: 776,
    county: 'ACCOMACK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.es.vccs.edu/',
  },
  {
    name: 'WILLIAMS BAPTIST UNIVERSITY',
    address: '60 W FULBRIGHT AVENUE',
    city: 'WALNUT RIDGE',
    state: 'AR',
    zip: 72476,
    telephone: '(870) 886-6741',
    population: 781,
    county: 'LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://williamsbaptistuniversity.com/',
  },
  {
    name: 'OZARK CHRISTIAN COLLEGE',
    address: '1111 N MAIN ST',
    city: 'JOPLIN',
    state: 'MO',
    zip: 64801,
    telephone: '(417) 626-1236',
    population: 781,
    county: 'JASPER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.occ.edu/',
  },
  {
    name: 'BURRELL COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '3501 ARROWHEAD DRIVE',
    city: 'LAS CRUCES',
    state: 'NM',
    zip: 88001,
    telephone: '(575) 674-2226',
    population: 781,
    county: 'DOÑA ANA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://bcomnm.org/',
  },
  {
    name: 'ERIKSON INSTITUTE',
    address: '451 N. LASALLE STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60654,
    telephone: '(312) 755-2250',
    population: 782,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.erikson.edu/',
  },
  {
    name: 'FORTIS COLLEGE-LANDOVER',
    address: '4351 GARDEN CITY DRIVE',
    city: 'LANDOVER',
    state: 'MD',
    zip: 20785,
    telephone: '(301) 459-3650',
    population: 782,
    county: "PRINCE GEORGE'S",
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'BECKFIELD COLLEGE-FLORENCE',
    address: '16 SPIRAL DRIVE',
    city: 'FLORENCE',
    state: 'KY',
    zip: 41042,
    telephone: '(859) 371-9393 EXT 85937',
    population: 784,
    county: 'BOONE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.beckfield.edu/',
  },
  {
    name: 'NEW YORK SCHOOL OF INTERIOR DESIGN',
    address: '170 EAST 70TH STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10021,
    telephone: '(212) 472-1500',
    population: 785,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nysid.edu/',
  },
  {
    name: 'CENTRAL BAPTIST COLLEGE',
    address: '1501 COLLEGE AVENUE',
    city: 'CONWAY',
    state: 'AR',
    zip: 72034,
    telephone: '(501) 329-6872',
    population: 785,
    county: 'FAULKNER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cbc.edu/',
  },
  {
    name: 'BARNES-JEWISH COLLEGE GOLDFARB SCHOOL OF NURSING',
    address: '4483 DUNCAN AVENUE, MAILSTOP 90-36-697',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63110,
    telephone: '(314) 454-7055',
    population: 786,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.barnesjewishcollege.edu/',
  },
  {
    name: 'LIFE CHIROPRACTIC COLLEGE WEST',
    address: '25001 INDUSTRIAL BLVD',
    city: 'HAYWARD',
    state: 'CA',
    zip: 94545,
    telephone: '(510) 780-4500',
    population: 786,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lifewest.edu/',
  },
  {
    name: 'PACIFIC COLLEGE OF ORIENTAL MEDICINE-NEW YORK',
    address: '110 WILLIAM ST. 19TH FL',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10038,
    telephone: '(212) 982-3456',
    population: 788,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pacificcollege.edu/',
  },
  {
    name: 'NORTHWEST KANSAS TECHNICAL COLLEGE',
    address: '1209 HARRISON ST',
    city: 'GOODLAND',
    state: 'KS',
    zip: 67735,
    telephone: '(785) 890-3641',
    population: 788,
    county: 'SHERMAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwktc.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-ATLANTA',
    address: '50 HURT PLAZA SE STE. 400',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30303,
    telephone: '(404) 816-4533 EXT 116',
    population: 789,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: "THE KING'S UNIVERSITY",
    address: '2121 E. SOUTHLAKE BOULEVARD',
    city: 'SOUTHLAKE',
    state: 'TX',
    zip: 76092,
    telephone: '(817) 722-1700',
    population: 790,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tku.edu/',
  },
  {
    name: 'YORK COLLEGE',
    address: '1125 E 8TH ST',
    city: 'YORK',
    state: 'NE',
    zip: 68467,
    telephone: '(402) 363-5600',
    population: 790,
    county: 'YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.york.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-TAMPA',
    address: '9950 PRINCESS PALM AVENUE SUITE 100',
    city: 'TAMPA',
    state: 'FL',
    zip: 33619,
    telephone: '(813) 577-3321',
    population: 790,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'HAMPSHIRE COLLEGE',
    address: '893 WEST ST',
    city: 'AMHERST',
    state: 'MA',
    zip: 1002,
    telephone: '(413) 549-4600',
    population: 791,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hampshire.edu/',
  },
  {
    name: 'FORTIS INSTITUTE-PENSACOLA',
    address: '4081 E OLIVE RD STE B',
    city: 'PENSACOLA',
    state: 'FL',
    zip: 32514,
    telephone: '(850) 476-7607',
    population: 791,
    county: 'ESCAMBIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortis.edu/',
  },
  {
    name: 'VERMONT LAW SCHOOL',
    address: '164 CHELSEA STREET',
    city: 'SOUTH ROYALTON',
    state: 'VT',
    zip: 5068,
    telephone: '(802) 831-1000',
    population: 792,
    county: 'WINDSOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vermontlaw.edu/',
  },
  {
    name: 'INTERACTIVE COLLEGE OF TECHNOLOGY-CHAMBLEE',
    address: '5303 NEW PEACHTREE RD',
    city: 'CHAMBLEE',
    state: 'GA',
    zip: 30341,
    telephone: '(770) 216-2960',
    population: 792,
    county: 'DEKALB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ict.edu/',
  },
  {
    name: 'WESTMINSTER COLLEGE',
    address: '501 WESTMINSTER AVE',
    city: 'FULTON',
    state: 'MO',
    zip: 65251,
    telephone: '(573) 642-3361',
    population: 793,
    county: 'CALLAWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wcmo.edu/',
  },
  {
    name: 'ALLEN COLLEGE',
    address: '1990 HEATH ST',
    city: 'WATERLOO',
    state: 'IA',
    zip: 50703,
    telephone: '(319) 226-2000',
    population: 797,
    county: 'BLACK HAWK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.allencollege.edu/',
  },
  {
    name: 'RUST COLLEGE',
    address: '150 RUST AVENUE',
    city: 'HOLLY SPRINGS',
    state: 'MS',
    zip: 38635,
    telephone: '(662) 252-8000 EXT 4009',
    population: 797,
    county: 'MARSHALL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rustcollege.edu/',
  },
  {
    name: 'SALEM COLLEGE',
    address: '601 S CHURCH ST',
    city: 'WINSTON-SALEM',
    state: 'NC',
    zip: 27101,
    telephone: '(336) 721-2600',
    population: 798,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.salem.edu/',
  },
  {
    name: 'SALINA AREA TECHNICAL COLLEGE',
    address: '2562 CENTENNIAL ROAD',
    city: 'SALINA',
    state: 'KS',
    zip: 67401,
    telephone: '(785) 309-3100',
    population: 798,
    county: 'SALINE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.salinatech.edu/',
  },
  {
    name: 'KECK GRADUATE INSTITUTE',
    address: '535 WATSON DR',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 607-7855',
    population: 799,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kgi.edu/',
  },
  {
    name: 'WHITE MOUNTAINS COMMUNITY COLLEGE',
    address: '2020 RIVERSIDE DRIVE',
    city: 'BERLIN',
    state: 'NH',
    zip: 3570,
    telephone: '(603) 752-1113',
    population: 801,
    county: 'COOS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wmcc.edu/',
  },
  {
    name: 'MESALANDS COMMUNITY COLLEGE',
    address: '911 S TENTH STREET',
    city: 'TUCUMCARI',
    state: 'NM',
    zip: 88401,
    telephone: '(575) 461-4413',
    population: 806,
    county: 'QUAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mesalands.edu/',
  },
  {
    name: 'ALABAMA COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '445 HEALTH SCIENCES BOULEVARD',
    city: 'DOTHAN',
    state: 'AL',
    zip: 36303,
    telephone: '(334) 699-2266',
    population: 809,
    county: 'HOUSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.acom.edu/',
  },
  {
    name: 'GEISINGER COMMONWEALTH SCHOOL OF MEDICINE',
    address: '525 PINE ST',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18509,
    telephone: '(570) 504-7000',
    population: 810,
    county: 'LACKAWANNA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.geisinger.edu/education',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT WASHINGTON DC',
    address: '901 15TH ST., NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20005,
    telephone: '(202) 706-5000',
    population: 812,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/washington-dc/',
  },
  {
    name: 'CLEVELAND INSTITUTE OF ART',
    address: '11610 EUCLID AVENUE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44106,
    telephone: '(216) 421-7000',
    population: 813,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cia.edu/',
  },
  {
    name: 'ASHER COLLEGE',
    address: '1215 HOWE AVE SUITE 101',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95825,
    telephone: '(916) 649-9600',
    population: 813,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asher.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS SYSTEM EVERSITY',
    address: '2402 NORTH UNIVERSITY AVENUE',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72207,
    telephone: '(844) 837-7489',
    population: 814,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'eversity.uasys.edu',
  },
  {
    name: 'ARIZONA COLLEGE-TEMPE',
    address: '1620 WEST FOUNTAINHEAD PARKWAY, SUITE 110',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85282,
    telephone: '(855) 706-8382',
    population: 816,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.arizonacollege.edu',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-SAN DIEGO',
    address: '4393 IMPERIAL AVENUE, SUITE 100',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92113,
    telephone: '(619) 688-0800',
    population: 816,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/san-diego-california',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-LAS VEGAS',
    address: '2320 SOUTH RANCHO DRIVE',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89102,
    telephone: '(855) 706-8382',
    population: 817,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'SIERRA NEVADA UNIVERSITY',
    address: '999 TAHOE BLVD.',
    city: 'INCLINE VILLAGE',
    state: 'NV',
    zip: 89451,
    telephone: '(775) 831-1314',
    population: 818,
    county: 'WASHOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sierranevada.edu/',
  },
  {
    name: 'ELLSWORTH COMMUNITY COLLEGE',
    address: '1100 COLLEGE AVE',
    city: 'IOWA FALLS',
    state: 'IA',
    zip: 50126,
    telephone: '(800) 322-9235',
    population: 819,
    county: 'HARDIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://ecc.iavalley.edu/',
  },
  {
    name: 'CLEARY UNIVERSITY',
    address: '3750 CLEARY DRIVE',
    city: 'HOWELL',
    state: 'MI',
    zip: 48843,
    telephone: '(800) 686-1883',
    population: 820,
    county: 'LIVINGSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cleary.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-CHULA VISTA',
    address: '780 BAY BLVD SUITE101',
    city: 'CHULA VISTA',
    state: 'CA',
    zip: 91910,
    telephone: '(619) 425-3200',
    population: 820,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'NEW MEXICO MILITARY INSTITUTE',
    address: '101 W. COLLEGE BLVD.',
    city: 'ROSWELL',
    state: 'NM',
    zip: 88201,
    telephone: '(575) 622-6250',
    population: 822,
    county: 'CHAVES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nmmi.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-BAKERSFIELD',
    address: '201 NEW STINE ROAD',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93309,
    telephone: '(559) 734-9000',
    population: 824,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'PACIFIC NORTHWEST UNIVERSITY OF HEALTH SCIENCES',
    address: '200 UNIVERSITY PARKWAY',
    city: 'YAKIMA',
    state: 'WA',
    zip: 98901,
    telephone: '(509) 452-5100',
    population: 825,
    county: 'YAKIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.pnwu.edu/',
  },
  {
    name: "ST PAUL'S SCHOOL OF NURSING-QUEENS",
    address: '97-77 QUEENS BLVD',
    city: 'REGO PARK',
    state: 'NY',
    zip: 11374,
    telephone: '(718) 357-0500',
    population: 828,
    county: 'QUEENS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.stpaulsschoolofnursing.edu/',
  },
  {
    name: 'LAMAR COMMUNITY COLLEGE',
    address: '2401 S MAIN ST',
    city: 'LAMAR',
    state: 'CO',
    zip: 81052,
    telephone: '(719) 336-2248',
    population: 828,
    county: 'PROWERS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lamarcc.edu/',
  },
  {
    name: 'LINCOLN TRAIL COLLEGE',
    address: '11220 STATE HWY 1',
    city: 'ROBINSON',
    state: 'IL',
    zip: 62454,
    telephone: '(618) 393-2982',
    population: 829,
    county: 'CRAWFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iecc.edu/ltc',
  },
  {
    name: 'LE MOYNE-OWEN COLLEGE',
    address: '807 WALKER AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38126,
    telephone: '(901) 435-1000',
    population: 830,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.loc.edu/',
  },
  {
    name: 'MULTNOMAH UNIVERSITY',
    address: '8435 NE GLISAN ST',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97220,
    telephone: '(503) 255-0332',
    population: 831,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.multnomah.edu/',
  },
  {
    name: 'ARKANSAS COLLEGES OF HEALTH EDUCATION',
    address: '7000 CHAD COLLEY BLVD.',
    city: 'FORT SMITH',
    state: 'AR',
    zip: 72916,
    telephone: '(479) 308-2200',
    population: 832,
    county: 'SEBASTIAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'acheedu.org/',
  },
  {
    name: 'TULSA WELDING SCHOOL-TULSA',
    address: '2545 E. 11TH STREET',
    city: 'TULSA',
    state: 'OK',
    zip: 74104,
    telephone: '(800) 935-3776',
    population: 832,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.tws.edu/',
  },
  {
    name: 'LAKES REGION COMMUNITY COLLEGE',
    address: '379 BELMONT ROAD',
    city: 'LACONIA',
    state: 'NH',
    zip: 3246,
    telephone: '(603) 524-3207',
    population: 832,
    county: 'BELKNAP',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lrcc.edu/',
  },
  {
    name: 'GARRETT COLLEGE',
    address: '687 MOSSER ROAD',
    city: 'MCHENRY',
    state: 'MD',
    zip: 21541,
    telephone: '(301) 387-3000',
    population: 832,
    county: 'GARRETT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.garrettcollege.edu/index.php',
  },
  {
    name: 'JOHNSON & WALES UNIVERSITY-NORTH MIAMI',
    address: '1701 NE 127TH ST',
    city: 'NORTH MIAMI',
    state: 'FL',
    zip: 33181,
    telephone: '(305) 892-7000',
    population: 833,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jwu.edu/campuses/north-miami/index.html',
  },
  {
    name: 'RANDOLPH COLLEGE',
    address: '2500 RIVERMONT AVE',
    city: 'LYNCHBURG',
    state: 'VA',
    zip: 24503,
    telephone: '(434) 947-8000',
    population: 834,
    county: 'LYNCHBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.randolphcollege.edu/',
  },
  {
    name: 'TABOR COLLEGE',
    address: '400 S JEFFERSON',
    city: 'HILLSBORO',
    state: 'KS',
    zip: 67063,
    telephone: '(620) 947-3121',
    population: 835,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'tabor.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-DENVER',
    address: '7475 DAKIN ST. SUITE 100',
    city: 'DENVER',
    state: 'CO',
    zip: 80221,
    telephone: '(303) 426-1800',
    population: 835,
    county: 'ADAMS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'YTI CAREER INSTITUTE-YORK',
    address: '1405 WILLIAMS ROAD',
    city: 'YORK',
    state: 'PA',
    zip: 17402,
    telephone: '(717) 757-1100',
    population: 836,
    county: 'YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.yti.edu/',
  },
  {
    name: 'TEXAS COLLEGE',
    address: '2404 N. GRAND AVENUE',
    city: 'TYLER',
    state: 'TX',
    zip: 75702,
    telephone: '(903) 593-8311 EXT 2297',
    population: 838,
    county: 'SMITH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.texascollege.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS SYSTEM EVERSITY',
    address: '2402 NORTH UNIVERSITY AVENUE',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72207,
    telephone: '(844) 837-7489',
    population: 841,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'eversity.uasys.edu/',
  },
  {
    name: 'UNIVERSITY OF ANTELOPE VALLEY',
    address: '44055 SIERRA HIGHWAY',
    city: 'LANCASTER',
    state: 'CA',
    zip: 93534,
    telephone: '(661) 726-1911 EXT 125',
    population: 841,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uav.edu/',
  },
  {
    name: 'UNIVERSITY OF MAINE AT MACHIAS',
    address: "116 O'BRIEN AVE",
    city: 'MACHIAS',
    state: 'ME',
    zip: 4654,
    telephone: '(207) 255-1200',
    population: 843,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'machias.edu/',
  },
  {
    name: 'AMERICAN FILM INSTITUTE CONSERVATORY',
    address: '2021 N WESTERN AVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90027,
    telephone: '(323) 856-7600',
    population: 844,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.afi.com/',
  },
  {
    name: 'UNIVERSIDAD CENTRAL DEL CARIBE',
    address: 'RAMON RUIZ ARNAU UNIVERSITY HOSPITAL LAUREL AVE',
    city: 'BAYAMON',
    state: 'PR',
    zip: 960,
    telephone: '(787) 798-3001 EXT 2323',
    population: 848,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uccaribe.edu/',
  },
  {
    name: 'PAUL SMITHS COLLEGE OF ARTS AND SCIENCE',
    address: '7777 STATE ROUTE 30',
    city: 'PAUL SMITHS',
    state: 'NY',
    zip: 12970,
    telephone: '(518) 327-6000',
    population: 849,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.paulsmiths.edu/',
  },
  {
    name: 'STERLING COLLEGE',
    address: '125 W. COOPER',
    city: 'STERLING',
    state: 'KS',
    zip: 67579,
    telephone: '(620) 278-2173',
    population: 850,
    county: 'RICE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sterling.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-HIALEAH',
    address: '3750 WEST 18 AVENUE',
    city: 'HIALEAH',
    state: 'FL',
    zip: 33012,
    telephone: '(786) 534-0941',
    population: 850,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'INSTITUTE OF AMERICAN INDIAN AND ALASKA NATIVE CULTURE AND ARTS DEVELOPMENT',
    address: '83 AVAN NU PO ROAD',
    city: 'SANTA FE',
    state: 'NM',
    zip: 87508,
    telephone: '(505) 424-2311',
    population: 851,
    county: 'SANTA FE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://iaia.edu/',
  },
  {
    name: 'AMRIDGE UNIVERSITY',
    address: '1200 TAYLOR RD',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36117,
    telephone: '(334) 387-3877 EXT 7550',
    population: 853,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amridgeuniversity.edu/',
  },
  {
    name: 'UNIVERSITY OF CONNECTICUT-WATERBURY CAMPUS',
    address: '99 EAST MAIN STREET',
    city: 'WATERBURY',
    state: 'CT',
    zip: 6702,
    telephone: '(203) 236-9800',
    population: 853,
    county: 'NEW HAVEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'waterbury.uconn.edu/',
  },
  {
    name: 'ALLEN UNIVERSITY',
    address: '1530 HARDEN STREET',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29204,
    telephone: '(803) 376-5700',
    population: 858,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.allenuniversity.edu/',
  },
  {
    name: 'CALUMET COLLEGE OF SAINT JOSEPH',
    address: '2400 NEW YORK AVE',
    city: 'WHITING',
    state: 'IN',
    zip: 46394,
    telephone: '(219) 473-7770 EXT 224',
    population: 858,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccsj.edu/',
  },
  {
    name: 'CUNY SCHOOL OF LAW',
    address: '2 COURT SQUARE',
    city: 'LONG ISLAND CITY',
    state: 'NY',
    zip: 11101,
    telephone: '(718) 340-4200',
    population: 859,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.law.cuny.edu/',
  },
  {
    name: 'BAY STATE COLLEGE',
    address: '31 ST. JAMES AVENUE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 217-9000',
    population: 860,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.baystate.edu/',
  },
  {
    name: 'RESURRECTION UNIVERSITY',
    address: '1431 N. CLAREMONT',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60622,
    telephone: '(773) 252-6464',
    population: 861,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.resu.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-SCHOOL OF LAW',
    address: 'CALLE FEDERICO COSTA 170 URB IND TRES MONJITAS',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 936,
    telephone: '(787) 751-1912 EXT 2100',
    population: 862,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.derecho.inter.edu/inter/',
  },
  {
    name: 'PLATT COLLEGE-LOS ANGELES',
    address: '1000 SOUTH FREMONT AVENUE, A10',
    city: 'ALHAMBRA',
    state: 'CA',
    zip: 91803,
    telephone: '(626) 300-5444',
    population: 865,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattcollege.edu/',
  },
  {
    name: 'LYON COLLEGE',
    address: '2300 HIGHLAND ROAD',
    city: 'BATESVILLE',
    state: 'AR',
    zip: 72501,
    telephone: '(870) 307-7000',
    population: 866,
    county: 'INDEPENDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lyon.edu/',
  },
  {
    name: "ST PAUL'S SCHOOL OF NURSING-STATEN ISLAND",
    address: '2 TELEPORT DRIVE, CORPORATE COMMONS TWO, SUITE 203',
    city: 'STATEN ISLAND',
    state: 'NY',
    zip: 10311,
    telephone: '(718) 517-7700',
    population: 866,
    county: 'RICHMOND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stpaulsschoolofnursing.edu/',
  },
  {
    name: 'HASKELL INDIAN NATIONS UNIVERSITY',
    address: '155 INDIAN AVE',
    city: 'LAWRENCE',
    state: 'KS',
    zip: 66046,
    telephone: '(785) 749-8404',
    population: 867,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.haskell.edu/',
  },
  {
    name: 'NORTH AMERICAN UNIVERSITY',
    address: '11929 WEST AIRPORT BLVD.',
    city: 'STAFFORD',
    state: 'TX',
    zip: 77477,
    telephone: '(832) 230-5555',
    population: 869,
    county: 'FORT BEND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.na.edu/',
  },
  {
    name: 'IOWA WESLEYAN UNIVERSITY',
    address: '601 N MAIN STREET',
    city: 'MOUNT PLEASANT',
    state: 'IA',
    zip: 52641,
    telephone: '(319) 385-8021',
    population: 871,
    county: 'HENRY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.iw.edu/',
  },
  {
    name: 'FIVE TOWNS COLLEGE',
    address: '305 NORTH SERVICE ROAD',
    city: 'DIX HILLS',
    state: 'NY',
    zip: 11746,
    telephone: '(631) 424-7000',
    population: 872,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ftc.edu/',
  },
  {
    name: 'SOUTHEASTERN COLLEGE-WEST PALM BEACH',
    address: '1756 NORTH CONGRESS AVENUE',
    city: 'WEST PALM BEACH',
    state: 'FL',
    zip: 33409,
    telephone: '(561) 433-2330',
    population: 875,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sec.edu/',
  },
  {
    name: 'KENTUCKY CHRISTIAN UNIVERSITY',
    address: '100 ACADEMIC PKWY',
    city: 'GRAYSON',
    state: 'KY',
    zip: 41143,
    telephone: '(606) 474-3000',
    population: 877,
    county: 'CARTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kcu.edu/',
  },
  {
    name: 'THE ART INSTITUTE OF ATLANTA',
    address: '6600 PEACHTREE DUNWOODY RD., N.E., 100 EMBASSY ROW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30328,
    telephone: '(770) 689-4795',
    population: 877,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/atlanta',
  },
  {
    name: 'LUNA COMMUNITY COLLEGE',
    address: '336 LUNA DRIVE',
    city: 'LAS VEGAS',
    state: 'NM',
    zip: 87701,
    telephone: '(505) 454-2500',
    population: 878,
    county: 'SAN MIGUEL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.luna.edu/',
  },
  {
    name: 'EASTWICK COLLEGE-RAMSEY',
    address: '10 SOUTH FRANKLIN TURNPIKE',
    city: 'RAMSEY',
    state: 'NJ',
    zip: 7446,
    telephone: '(201) 327-8877',
    population: 879,
    county: 'BERGEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eastwickcollege.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW HAMPSHIRE AT MANCHESTER',
    address: '88 COMMERCIAL STREET',
    city: 'MANCHESTER',
    state: 'NH',
    zip: 3101,
    telephone: '(603) 641-4101',
    population: 881,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'manchester.unh.edu/',
  },
  {
    name: 'STEPHENS COLLEGE',
    address: '1200 E BROADWAY',
    city: 'COLUMBIA',
    state: 'MO',
    zip: 65215,
    telephone: '(573) 442-2211',
    population: 882,
    county: 'BOONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stephens.edu/',
  },
  {
    name: 'NORTHERN MAINE COMMUNITY COLLEGE',
    address: '33 EDGEMONT DR',
    city: 'PRESQUE ISLE',
    state: 'ME',
    zip: 4769,
    telephone: '(207) 768-2700',
    population: 882,
    county: 'AROOSTOOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nmcc.edu/',
  },
  {
    name: 'ANTIOCH UNIVERSITY-SEATTLE',
    address: '2326 6TH AVE',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98121,
    telephone: '(206) 441-5352',
    population: 885,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.antiochseattle.edu/',
  },
  {
    name: 'SWEDISH INSTITUTE A COLLEGE OF HEALTH SCIENCES',
    address: '226 WEST 26TH STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10001,
    telephone: '(212) 924-5900 EXT 131',
    population: 886,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swedishinstitute.edu/',
  },
  {
    name: 'BRYAN COLLEGE OF HEALTH SCIENCES',
    address: '1535 S 52ND ST',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68506,
    telephone: '(402) 481-3801',
    population: 889,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bryanhealthcollege.edu/bcohs/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-PHOENIX',
    address: '13610 N. BLACK CANYON HIGHWAY, SUITE 102',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85029,
    telephone: '(602) 265-7462',
    population: 890,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pmi.edu/',
  },
  {
    name: 'MIDDLEBURY INSTITUTE OF INTERNATIONAL STUDIES AT MONTEREY',
    address: '460 PIERCE STREET',
    city: 'MONTEREY',
    state: 'CA',
    zip: 93940,
    telephone: '(831) 647-4100 EXT 51355',
    population: 895,
    county: 'MONTEREY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.middlebury.edu/institute/',
  },
  {
    name: 'CAPITOL TECHNOLOGY UNIVERSITY',
    address: '11301 SPRINGFIELD RD',
    city: 'LAUREL',
    state: 'MD',
    zip: 20708,
    telephone: '(301) 369-2800',
    population: 895,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.captechu.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-COLUMBIA',
    address: '9 SCIENCE COURT',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29203,
    telephone: '(803) 799-9082',
    population: 896,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/columbia#location=Columbia, SC',
  },
  {
    name: 'STILLMAN COLLEGE',
    address: '3601 STILLMAN BOULEVARD',
    city: 'TUSCALOOSA',
    state: 'AL',
    zip: 35401,
    telephone: '(205) 349-4240',
    population: 898,
    county: 'TUSCALOOSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://stillman.edu/',
  },
  {
    name: 'NORTHWEST TECHNICAL COLLEGE',
    address: '905 GRANT AVENUE SE',
    city: 'BEMIDJI',
    state: 'MN',
    zip: 56601,
    telephone: '(218) 333-6600',
    population: 898,
    county: 'BELTRAMI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ntcmn.edu/',
  },
  {
    name: 'PONTIFICAL CATHOLIC UNIVERSITY OF PUERTO RICO-ARECIBO',
    address: 'CARRETERA 662 KM 2.3',
    city: 'ARECIBO',
    state: 'PR',
    zip: 614,
    telephone: '(787) 881-1212 EXT 6000',
    population: 901,
    county: 'ARECIBO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pucpr.edu/arecibo',
  },
  {
    name: 'BUSHNELL UNIVERSITY',
    address: '828 E. 11TH AVE.',
    city: 'EUGENE',
    state: 'OR',
    zip: 97401,
    telephone: '(541) 343-1641',
    population: 901,
    county: 'LANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bushnell.edu/',
  },
  {
    name: 'SOUTHERN CAREERS INSTITUTE-SAN ANTONIO',
    address: '6963 NW LOOP 410',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78238,
    telephone: '(512) 437-7500',
    population: 901,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.scitexas.edu/',
  },
  {
    name: 'HODGES UNIVERSITY',
    address: '4501 COLONIAL BLVD',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33966,
    telephone: '(239) 513-1122',
    population: 902,
    county: 'LEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hodges.edu/',
  },
  {
    name: 'JARVIS CHRISTIAN COLLEGE',
    address: 'PR 7631, HWY 80 E',
    city: 'HAWKINS',
    state: 'TX',
    zip: 75765,
    telephone: '(903) 730-4890',
    population: 903,
    county: 'WOOD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jarvis.edu/',
  },
  {
    name: 'HANNIBAL-LAGRANGE UNIVERSITY',
    address: '2800 PALMYRA RD',
    city: 'HANNIBAL',
    state: 'MO',
    zip: 63401,
    telephone: '(573) 221-3675',
    population: 903,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hlg.edu/',
  },
  {
    name: 'KETTERING COLLEGE',
    address: '3737 SOUTHERN BLVD',
    city: 'KETTERING',
    state: 'OH',
    zip: 45429,
    telephone: '(937) 395-8601',
    population: 904,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'kc.edu/',
  },
  {
    name: 'INDEPENDENCE COMMUNITY COLLEGE',
    address: '1057 WEST COLLEGE AVENUE',
    city: 'INDEPENDENCE',
    state: 'KS',
    zip: 67301,
    telephone: '(620) 331-4100',
    population: 905,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.indycc.edu/',
  },
  {
    name: 'MONTGOMERY COMMUNITY COLLEGE',
    address: '1011 PAGE ST',
    city: 'TROY',
    state: 'NC',
    zip: 27371,
    telephone: '(910) 898-9600',
    population: 908,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.montgomery.edu/',
  },
  {
    name: 'BLUFFTON UNIVERSITY',
    address: '1 UNIVERSITY DRIVE',
    city: 'BLUFFTON',
    state: 'OH',
    zip: 45817,
    telephone: '(419) 358-3000',
    population: 909,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bluffton.edu/',
  },
  {
    name: 'MARTIN METHODIST COLLEGE',
    address: '433 WEST MADISON STREET',
    city: 'PULASKI',
    state: 'TN',
    zip: 38478,
    telephone: '(931) 363-9800',
    population: 922,
    county: 'GILES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.martinmethodist.edu/',
  },
  {
    name: 'UNIVERSITY OF SCIENCE AND ARTS OF OKLAHOMA',
    address: '17TH STREET AND GRAND AVENUE',
    city: 'CHICKASHA',
    state: 'OK',
    zip: 73018,
    telephone: '(405) 512-4891',
    population: 923,
    county: 'GRADY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usao.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE HOLLYWOOD',
    address: '18618 OXNARD ST',
    city: 'TARZANA',
    state: 'CA',
    zip: 91356,
    telephone: '(818) 345-8414',
    population: 924,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.columbiacollege.edu/',
  },
  {
    name: 'NEW YORK CHIROPRACTIC COLLEGE',
    address: '2360 STATE ROUTE 89',
    city: 'SENECA FALLS',
    state: 'NY',
    zip: 13148,
    telephone: '(315) 568-3000',
    population: 925,
    county: 'SENECA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nycc.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-WEST PALM BEACH',
    address: '6058 OKEECHOBEE BLVD.',
    city: 'WEST PALM BEACH',
    state: 'FL',
    zip: 33417,
    telephone: '(561) 282-5441',
    population: 929,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'MANHATTAN AREA TECHNICAL COLLEGE',
    address: '3136 DICKENS AVE',
    city: 'MANHATTAN',
    state: 'KS',
    zip: 66503,
    telephone: '(785) 587-2800',
    population: 929,
    county: 'RILEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://manhattantech.edu/',
  },
  {
    name: 'J. F. DRAKE STATE COMMUNITY AND TECHNICAL COLLEGE',
    address: '3421 MERIDIAN ST N',
    city: 'HUNTSVILLE',
    state: 'AL',
    zip: 35811,
    telephone: '(256) 539-8161',
    population: 932,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.drakestate.edu/',
  },
  {
    name: 'BELMONT COLLEGE',
    address: '68094 HAMMOND ROAD',
    city: 'ST CLAIRSVILLE',
    state: 'OH',
    zip: 43950,
    telephone: '(740) 695-9500',
    population: 933,
    county: 'BELMONT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.belmontcollege.edu/',
  },
  {
    name: 'CLARKS SUMMIT UNIVERSITY',
    address: '538 VENARD RD',
    city: 'CLARKS SUMMIT',
    state: 'PA',
    zip: 18411,
    telephone: '(570) 586-2400',
    population: 934,
    county: 'LACKAWANNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.clarkssummitu.edu/',
  },
  {
    name: 'WARREN WILSON COLLEGE',
    address: '701 WARREN WILSON RD',
    city: 'SWANNANOA',
    state: 'NC',
    zip: 28778,
    telephone: '(828) 771-2000',
    population: 936,
    county: 'BUNCOMBE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.warren-wilson.edu/',
  },
  {
    name: 'CLATSOP COMMUNITY COLLEGE',
    address: '1651 LEXINGTON AVENUE',
    city: 'ASTORIA',
    state: 'OR',
    zip: 97103,
    telephone: '(503) 325-0910',
    population: 936,
    county: 'CLATSOP',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clatsopcc.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-GRAND PRAIRIE',
    address: '305 W. INTERSTATE 20',
    city: 'GRAND PRAIRIE',
    state: 'TX',
    zip: 75052,
    telephone: '(469) 348-2500',
    population: 938,
    county: 'TARRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/grand-prairie-texas',
  },
  {
    name: 'SALISH KOOTENAI COLLEGE',
    address: '58138 US HIGHWAY 93',
    city: 'PABLO',
    state: 'MT',
    zip: 59855,
    telephone: '(406) 275-4931',
    population: 940,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.skc.edu/',
  },
  {
    name: 'RIVER VALLEY COMMUNITY COLLEGE',
    address: '1 COLLEGE PLACE',
    city: 'CLAREMONT',
    state: 'NH',
    zip: 3743,
    telephone: '(603) 542-7744',
    population: 940,
    county: 'SULLIVAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rivervalley.edu/',
  },
  {
    name: 'MARSHALL B KETCHUM UNIVERSITY',
    address: '2575 YORBA LINDA BLVD',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92831,
    telephone: '(714) 449-7451',
    population: 941,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ketchum.edu/',
  },
  {
    name: 'SPARTAN COLLEGE OF AERONAUTICS AND TECHNOLOGY',
    address: '8820 EAST PINE STREET',
    city: 'TULSA',
    state: 'OK',
    zip: 74115,
    telephone: '(800) 331-1204',
    population: 941,
    county: 'TULSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.spartan.edu/',
  },
  {
    name: 'YESHIVATH VIZNITZ',
    address: '15 ELYON ROAD',
    city: 'MONSEY',
    state: 'NY',
    zip: 10952,
    telephone: '(845) 731-3700',
    population: 942,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://yeshivathviznitz.com/',
  },
  {
    name: 'REFRIGERATION SCHOOL INC',
    address: '4210 E WASHINGTON STREET',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85034,
    telephone: '(602) 275-7133',
    population: 944,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rsi.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-LAS VEGAS',
    address: '3333 EAST FLAMINGO ROAD',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89121,
    telephone: '(702) 458-9650',
    population: 945,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS COMMUNITY COLLEGE RICH MOUNTAIN',
    address: '1100 COLLEGE DR',
    city: 'MENA',
    state: 'AR',
    zip: 71953,
    telephone: '(479) 394-7622',
    population: 946,
    county: 'POLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uarichmountain.edu/',
  },
  {
    name: 'SOUTHWESTERN ADVENTIST UNIVERSITY',
    address: '100 W HILLCREST',
    city: 'KEENE',
    state: 'TX',
    zip: 76059,
    telephone: '(817) 645-3921',
    population: 950,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swau.edu/',
  },
  {
    name: 'KANSAS CITY ART INSTITUTE',
    address: '4415 WARWICK BLVD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64111,
    telephone: '(816) 472-4852',
    population: 951,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kcai.edu/',
  },
  {
    name: 'COLUMBIA CENTRAL UNIVERSITY-CAGUAS',
    address: 'CARR 183 KM 1.7',
    city: 'CAGUAS',
    state: 'PR',
    zip: 726,
    telephone: '(787) 743-4041 EXT 240',
    population: 951,
    county: 'CAGUAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbiacentral.edu/',
  },
  {
    name: 'NORTH CENTRAL KANSAS TECHNICAL COLLEGE',
    address: '3033 US HIGHWAY 24',
    city: 'BELOIT',
    state: 'KS',
    zip: 67420,
    telephone: '(785) 738-2276',
    population: 951,
    county: 'MITCHELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ncktc.edu/',
  },
  {
    name: 'BETHANY LUTHERAN COLLEGE',
    address: '700 LUTHER DR',
    city: 'MANKATO',
    state: 'MN',
    zip: 56001,
    telephone: '(507) 344-7000',
    population: 955,
    county: 'BLUE EARTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.blc.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-PARMA',
    address: '12955 SNOW RD',
    city: 'PARMA',
    state: 'OH',
    zip: 44130,
    telephone: '(216) 265-3151',
    population: 957,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'OTTAWA UNIVERSITY-SURPRISE',
    address: '15950 N. CIVIC CENTER PLAZA',
    city: 'SURPRISE',
    state: 'AZ',
    zip: 85374,
    telephone: '(855) 546-1342',
    population: 958,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/ouaz/home/',
  },
  {
    name: 'MILLSAPS COLLEGE',
    address: '1701 N STATE ST',
    city: 'JACKSON',
    state: 'MS',
    zip: 39210,
    telephone: '(601) 974-1000',
    population: 960,
    county: 'HINDS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.millsaps.edu/',
  },
  {
    name: 'BANK STREET COLLEGE OF EDUCATION',
    address: '610 W 112 ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10025,
    telephone: '(212) 875-4400',
    population: 963,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bankstreet.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-COLUMBIA',
    address: '9325 SNOWDEN RIVER PKY',
    city: 'COLUMBIA',
    state: 'MD',
    zip: 21046,
    telephone: '(410) 290-7100 EXT 41500',
    population: 963,
    county: 'HOWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/columbia-md',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-MESA',
    address: '957 S. DOBSON ROAD',
    city: 'MESA',
    state: 'AZ',
    zip: 85202,
    telephone: '(480) 644-0267',
    population: 963,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'EASTERN NAZARENE COLLEGE',
    address: '23 E ELM AVE',
    city: 'QUINCY',
    state: 'MA',
    zip: 2170,
    telephone: '(617) 745-3000',
    population: 964,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.enc.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-SAVANNAH',
    address: '709 MALL BLVD',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31406,
    telephone: '(912) 201-8000',
    population: 964,
    county: 'CHATHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/savannah#location=Savannah, GA',
  },
  {
    name: 'DAVIS & ELKINS COLLEGE',
    address: '100 CAMPUS DR',
    city: 'ELKINS',
    state: 'WV',
    zip: 26241,
    telephone: '(304) 637-1900',
    population: 964,
    county: 'RANDOLPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dewv.edu/',
  },
  {
    name: 'WESLEYAN COLLEGE',
    address: '4760 FORSYTH ROAD',
    city: 'MACON',
    state: 'GA',
    zip: 31210,
    telephone: '(478) 477-1110',
    population: 969,
    county: 'BIBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wesleyancollege.edu/',
  },
  {
    name: 'WEST COAST ULTRASOUND INSTITUTE',
    address: '3580 WILSHIRE BLVD., 4TH FLOOR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(310) 289-5123',
    population: 969,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'wcui.edu/',
  },
  {
    name: 'COLUMBIA GORGE COMMUNITY COLLEGE',
    address: '400 E SCENIC DR',
    city: 'THE DALLES',
    state: 'OR',
    zip: 97058,
    telephone: '(541) 506-6011',
    population: 970,
    county: 'WASCO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cgcc.edu/',
  },
  {
    name: 'INTELLITEC COLLEGE-GRAND JUNCTION',
    address: '772 HORIZON DR.',
    city: 'GRAND JUNCTION',
    state: 'CO',
    zip: 81506,
    telephone: '(970) 245-8101',
    population: 970,
    county: 'MESA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'intellitec.edu/',
  },
  {
    name: 'ALBIZU UNIVERSITY-MIAMI',
    address: '2173 N.W. 99TH AVENUE',
    city: 'MIAMI',
    state: 'FL',
    zip: 33172,
    telephone: '(305) 593-1223',
    population: 973,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.albizu.edu/',
  },
  {
    name: 'UNIVERSITY OF ADVANCING TECHNOLOGY',
    address: '2625 W BASELINE RD',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85283,
    telephone: '(602) 383-8228',
    population: 975,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uat.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW MEXICO-LOS ALAMOS CAMPUS',
    address: '4000 UNIVERSITY DR',
    city: 'LOS ALAMOS',
    state: 'NM',
    zip: 87544,
    telephone: '(505) 662-5919',
    population: 975,
    county: 'LOS ALAMOS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'losalamos.unm.edu/',
  },
  {
    name: 'BREWTON-PARKER COLLEGE',
    address: '201 DAVID-ELIZA FOUNTAIN CIRCLE',
    city: 'MOUNT VERNON',
    state: 'GA',
    zip: 30445,
    telephone: '(912) 583-2241',
    population: 978,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bpc.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-ONTARIO',
    address: '4580 ONTARIO MILLS PARKWAY',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91764,
    telephone: '(559) 734-9000',
    population: 978,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sjvc.edu/',
  },
  {
    name: "TOHONO O'ODHAM COMMUNITY COLLEGE",
    address: 'HIGHWAY 86, MILE POST 125.5',
    city: 'SELLS',
    state: 'AZ',
    zip: 85634,
    telephone: '(520) 383-8401',
    population: 978,
    county: 'PIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tocc.edu/',
  },
  {
    name: 'AMERICAN NATIONAL UNIVERSITY',
    address: '1813 EAST MAIN STREET',
    city: 'SALEM',
    state: 'VA',
    zip: 24153,
    telephone: '(540) 986-1800',
    population: 978,
    county: 'SALEM CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.an.edu/locations/',
  },
  {
    name: 'SOUTHERN ARKANSAS UNIVERSITY TECH',
    address: '6415 SPELLMAN ROAD',
    city: 'CAMDEN',
    state: 'AR',
    zip: 71701,
    telephone: '(870) 574-4500',
    population: 979,
    county: 'CALHOUN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sautech.edu/',
  },
  {
    name: 'WEBBER INTERNATIONAL UNIVERSITY',
    address: '1201 N SCENIC HWY',
    city: 'BABSON PARK',
    state: 'FL',
    zip: 33827,
    telephone: '(863) 638-1431',
    population: 983,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.webber.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-SALKEHATCHIE',
    address: '465 JAMES BRANDT BLVD',
    city: 'ALLENDALE',
    state: 'SC',
    zip: 29810,
    telephone: '(800) 922-5500',
    population: 983,
    county: 'ALLENDALE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'uscsalkehatchie.sc.edu/',
  },
  {
    name: 'UNIVERSAL TECHNICAL INSTITUTE-BLOOMFIELD',
    address: '1515 BROAD STREET',
    city: 'BLOOMFIELD',
    state: 'NJ',
    zip: 7003,
    telephone: '(877) 201-2597',
    population: 986,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uti.edu/',
  },
  {
    name: 'MANOR COLLEGE',
    address: '700 FOX CHASE RD',
    city: 'JENKINTOWN',
    state: 'PA',
    zip: 19046,
    telephone: '(215) 885-2360',
    population: 987,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.manor.edu/',
  },
  {
    name: 'RIPON COLLEGE',
    address: '300 WEST SEWARD STREET',
    city: 'RIPON',
    state: 'WI',
    zip: 54971,
    telephone: '(920) 748-8115',
    population: 990,
    county: 'FOND DU LAC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ripon.edu/',
  },
  {
    name: 'WESTERN SEMINARY',
    address: '5511 SE HAWTHORNE BLVD',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97215,
    telephone: '(503) 517-1800',
    population: 991,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westernseminary.edu/',
  },
  {
    name: 'PHILANDER SMITH COLLEGE',
    address: '900 W. DAISY BATES DRIVE',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72202,
    telephone: '(501) 375-9845',
    population: 991,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.philander.edu/',
  },
  {
    name: 'SOUTHERN UNIVERSITY LAW CENTER',
    address: 'NOT AVAILABLE',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70813,
    telephone: '(225) 771-2552',
    population: 992,
    county: 'EAST BATON ROUGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sulc.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-NEW JERSEY',
    address: '2370 STATE ROUTE 70 WEST SUITE 335',
    city: 'CHERRY HILL',
    state: 'NJ',
    zip: 8002,
    telephone: '(877) 445-7180',
    population: 995,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/new-jersey/cherry-hill',
  },
  {
    name: 'WESTMINSTER THEOLOGICAL SEMINARY',
    address: '2960 W CHURCH RD',
    city: 'GLENSIDE',
    state: 'PA',
    zip: 19038,
    telephone: '(215) 887-5511',
    population: 996,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wts.edu/',
  },
  {
    name: 'MIAMI REGIONAL UNIVERSITY',
    address: '700 S ROYAL POINCIANA BLVD',
    city: 'MIAMI SPRINGS',
    state: 'FL',
    zip: 33166,
    telephone: '(305) 442-9223',
    population: 996,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mru.edu/',
  },
  {
    name: 'DENVER SEMINARY',
    address: '6399 S. SANTA FE DRIVE',
    city: 'LITTLETON',
    state: 'CO',
    zip: 80120,
    telephone: '(303) 761-2482',
    population: 998,
    county: 'ARAPAHOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.denverseminary.edu/',
  },
  {
    name: 'CALIFORNIA WESTERN SCHOOL OF LAW',
    address: '225 CEDAR ST',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 239-0391',
    population: 999,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cwsl.edu/',
  },
  {
    name: 'KANSAS WESLEYAN UNIVERSITY',
    address: '100 E. CLAFLIN AVE.',
    city: 'SALINA',
    state: 'KS',
    zip: 67401,
    telephone: '(785) 827-5541',
    population: 1000,
    county: 'SALINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kwu.edu/',
  },
  {
    name: 'BETHANY COLLEGE',
    address: '335 E SWENSSON ST',
    city: 'LINDSBORG',
    state: 'KS',
    zip: 67456,
    telephone: '(785) 227-3380',
    population: 1002,
    county: 'MCPHERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bethanylb.edu/',
  },
  {
    name: 'THIEL COLLEGE',
    address: '75 COLLEGE AVE',
    city: 'GREENVILLE',
    state: 'PA',
    zip: 16125,
    telephone: '(724) 589-2000',
    population: 1003,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.thiel.edu/',
  },
  {
    name: 'BOSTON ARCHITECTURAL COLLEGE',
    address: '320 NEWBURY STREET',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 262-5000',
    population: 1006,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.the-bac.edu/',
  },
  {
    name: 'HILBERT COLLEGE',
    address: '5200 S PARK AVE',
    city: 'HAMBURG',
    state: 'NY',
    zip: 14075,
    telephone: '(716) 649-7900',
    population: 1007,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hilbert.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-HOUSTON',
    address: '11125 EQUITY DRIVE, SUITE 100',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77041,
    telephone: '(713) 778-0778',
    population: 1009,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'WILLIAM JEWELL COLLEGE',
    address: '500 COLLEGE HILL',
    city: 'LIBERTY',
    state: 'MO',
    zip: 64068,
    telephone: '(816) 415-5979',
    population: 1012,
    county: 'CLAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jewell.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-TAMPA',
    address: '4401 N HIMES AVE, SUITE 175',
    city: 'TAMPA',
    state: 'FL',
    zip: 33614,
    telephone: '(813) 393-3800',
    population: 1013,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/tampa#location=Tampa, FL',
  },
  {
    name: 'ROSEMONT COLLEGE',
    address: '1400 MONTGOMERY AVE',
    city: 'ROSEMONT',
    state: 'PA',
    zip: 19010,
    telephone: '(610) 527-0200',
    population: 1013,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rosemont.edu/',
  },
  {
    name: 'OTTAWA UNIVERSITY-OTTAWA',
    address: '1001 SOUTH CEDAR',
    city: 'OTTAWA',
    state: 'KS',
    zip: 66067,
    telephone: '(785) 242-5200',
    population: 1015,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/',
  },
  {
    name: 'UNION COLLEGE',
    address: '3800 S 48TH STREET',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68506,
    telephone: '(402) 486-2600',
    population: 1015,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ucollege.edu/',
  },
  {
    name: 'UNIVERSITY OF THE OZARKS',
    address: '415 N COLLEGE AVE',
    city: 'CLARKSVILLE',
    state: 'AR',
    zip: 72830,
    telephone: '(479) 979-1000',
    population: 1016,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ozarks.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-MELROSE PARK',
    address: '8317 W NORTH AVENUE',
    city: 'MELROSE PARK',
    state: 'IL',
    zip: 60160,
    telephone: '(708) 344-4700 EXT 41600',
    population: 1016,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/melrose-park-il',
  },
  {
    name: 'SOUTHWEST INSTITUTE OF HEALING ARTS',
    address: '1538 E. SOUTHERN AVE',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85282,
    telephone: '(480) 994-9244',
    population: 1017,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'swiha.edu/',
  },
  {
    name: 'WILLIAM JAMES COLLEGE',
    address: 'ONE WELLS AVENUE',
    city: 'NEWTON',
    state: 'MA',
    zip: 2459,
    telephone: '(617) 327-6777',
    population: 1018,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.williamjames.edu/',
  },
  {
    name: 'UNIVERSITY OF THE SOUTHWEST',
    address: '6610 NORTH LOVINGTON HWY',
    city: 'HOBBS',
    state: 'NM',
    zip: 88240,
    telephone: '(575) 392-6561',
    population: 1020,
    county: 'LEA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usw.edu/',
  },
  {
    name: 'NEW COLLEGE OF FLORIDA',
    address: '5800 BAY SHORE ROAD',
    city: 'SARASOTA',
    state: 'FL',
    zip: 34243,
    telephone: '(941) 487-5000',
    population: 1022,
    county: 'SARASOTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ncf.edu/',
  },
  {
    name: 'TEACHERS COLLEGE OF SAN JOAQUIN',
    address: '2721 TRANSWORLD DR.',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95206,
    telephone: '(209) 468-4926',
    population: 1023,
    county: 'SAN JOAQUIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.teacherscollegesj.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-NEW JERSEY',
    address: '630 U.S. HIGHWAY ONE',
    city: 'NORTH BRUNSWICK',
    state: 'NJ',
    zip: 8902,
    telephone: '(732) 875-1300',
    population: 1023,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'WHEELING UNIVERSITY',
    address: '316 WASHINGTON AVE',
    city: 'WHEELING',
    state: 'WV',
    zip: 26003,
    telephone: '(304) 243-2000',
    population: 1025,
    county: 'OHIO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wju.edu/',
  },
  {
    name: 'MUSICIANS INSTITUTE',
    address: '6752 HOLLYWOOD BLVD.',
    city: 'HOLLYWOOD',
    state: 'CA',
    zip: 90028,
    telephone: '(323) 462-1384',
    population: 1026,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mi.edu/',
  },
  {
    name: 'CAZENOVIA COLLEGE',
    address: '22 SULLIVAN ST',
    city: 'CAZENOVIA',
    state: 'NY',
    zip: 13035,
    telephone: '(800) 654-3210',
    population: 1026,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cazenovia.edu/',
  },
  {
    name: 'MENLO COLLEGE',
    address: '1000 EL CAMINO REAL',
    city: 'ATHERTON',
    state: 'CA',
    zip: 94027,
    telephone: '(800) 556-3656',
    population: 1027,
    county: 'SAN MATEO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.menlo.edu/',
  },
  {
    name: 'THE COLLEGE OF THE FLORIDA KEYS',
    address: '5901 COLLEGE RD',
    city: 'KEY WEST',
    state: 'FL',
    zip: 33040,
    telephone: '(305) 296-9081',
    population: 1028,
    county: 'MONROE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cfk.edu/',
  },
  {
    name: 'GOGEBIC COMMUNITY COLLEGE',
    address: 'E4946 JACKSON RD',
    city: 'IRONWOOD',
    state: 'MI',
    zip: 49938,
    telephone: '(906) 932-4231',
    population: 1029,
    county: 'GOGEBIC',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gogebic.edu/',
  },
  {
    name: 'MARIA COLLEGE OF ALBANY',
    address: '700 NEW SCOTLAND AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12208,
    telephone: '(518) 438-3111',
    population: 1030,
    county: 'ALBANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mariacollege.edu/',
  },
  {
    name: 'ELMIRA COLLEGE',
    address: 'ONE PARK PLACE',
    city: 'ELMIRA',
    state: 'NY',
    zip: 14901,
    telephone: '(607) 735-1800',
    population: 1032,
    county: 'CHEMUNG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.elmira.edu/',
  },
  {
    name: 'BAPTIST HEALTH SCIENCES UNIVERSITY',
    address: '1003 MONROE AVE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 572-2468',
    population: 1032,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baptistu.edu/',
  },
  {
    name: 'MCPHERSON COLLEGE',
    address: '1600 E. EUCLID',
    city: 'MCPHERSON',
    state: 'KS',
    zip: 67460,
    telephone: '(620) 242-0400',
    population: 1034,
    county: 'MCPHERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mcpherson.edu/',
  },
  {
    name: 'SAYBROOK UNIVERSITY',
    address: '55 W EUREKA STREET',
    city: 'PASADENA',
    state: 'CA',
    zip: 91103,
    telephone: '(626) 316-5300',
    population: 1036,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.saybrook.edu/',
  },
  {
    name: 'MESABI RANGE COLLEGE',
    address: '1001 CHESTNUT STREET WEST',
    city: 'VIRGINIA',
    state: 'MN',
    zip: 55792,
    telephone: '(218) 741-3095',
    population: 1038,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mesabirange.edu/',
  },
  {
    name: 'TRINE UNIVERSITY-REGIONAL/NON-TRADITIONAL CAMPUSES',
    address: '9910 DUPONT CIRCLE DRIVE EAST',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46825,
    telephone: '(260) 483-4949',
    population: 1041,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'trine.edu/online/index.aspx',
  },
  {
    name: 'OLNEY CENTRAL COLLEGE',
    address: '305 N WEST STREET',
    city: 'OLNEY',
    state: 'IL',
    zip: 62450,
    telephone: '(618) 393-2982',
    population: 1043,
    county: 'RICHLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iecc.edu/occ',
  },
  {
    name: 'ARIZONA COLLEGE OF NURSING-TEMPE',
    address: '1620 WEST FOUNTAINHEAD PARKWAY, SUITE 110',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85282,
    telephone: '(855) 706-8382',
    population: 1044,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizonacollege.edu/',
  },
  {
    name: 'GLEN OAKS COMMUNITY COLLEGE',
    address: '62249 SHIMMEL RD',
    city: 'CENTREVILLE',
    state: 'MI',
    zip: 49032,
    telephone: '(269) 467-9945 EXT 0',
    population: 1044,
    county: 'ST. JOSEPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.glenoaks.edu/',
  },
  {
    name: 'WILLISTON STATE COLLEGE',
    address: '1410 UNIVERSITY AVENUE',
    city: 'WILLISTON',
    state: 'ND',
    zip: 58801,
    telephone: '(701) 774-4200',
    population: 1045,
    county: 'WILLIAMS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://willistonstate.edu/',
  },
  {
    name: 'SALEM COMMUNITY COLLEGE',
    address: '460 HOLLYWOOD AVENUE',
    city: 'CARNEYS POINT',
    state: 'NJ',
    zip: 8069,
    telephone: '(856) 299-2100',
    population: 1046,
    county: 'SALEM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.salemcc.edu/',
  },
  {
    name: 'MOUNT CARMEL COLLEGE OF NURSING',
    address: '127 SO. DAVIS AVE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43222,
    telephone: '(614) 234-5800',
    population: 1048,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mccn.edu/',
  },
  {
    name: 'LAGRANGE COLLEGE',
    address: '601 BROAD STREET',
    city: 'LAGRANGE',
    state: 'GA',
    zip: 30240,
    telephone: '(706) 880-8000',
    population: 1049,
    county: 'TROUP',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lagrange.edu/',
  },
  {
    name: 'MINNEAPOLIS COLLEGE OF ART AND DESIGN',
    address: '2501 STEVENS AVE',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55404,
    telephone: '(612) 874-3737',
    population: 1050,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'mcad.edu/',
  },
  {
    name: 'WESTERN MICHIGAN UNIVERSITY HOMER STRYKER M.D. SCHOOL OF MEDICINE',
    address: '300 PORTAGE STREET',
    city: 'KALAMAZOO',
    state: 'MI',
    zip: 49007,
    telephone: '(269) 337-4500',
    population: 1051,
    county: 'KALAMAZOO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'med.wmich.edu/',
  },
  {
    name: 'MERCY COLLEGE OF HEALTH SCIENCES',
    address: '928 6TH AVE',
    city: 'DES MOINES',
    state: 'IA',
    zip: 50309,
    telephone: '(515) 643-3180',
    population: 1053,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mchs.edu/',
  },
  {
    name: 'LEES-MCRAE COLLEGE',
    address: '191 MAIN STREET',
    city: 'BANNER ELK',
    state: 'NC',
    zip: 28604,
    telephone: '(828) 898-5241',
    population: 1058,
    county: 'AVERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lmc.edu/',
  },
  {
    name: 'CARRINGTON COLLEGE-PHOENIX NORTH',
    address: '2149 W DUNLAP AVENUE',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85051,
    telephone: '(602) 393-5900',
    population: 1061,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'WILLIAM PEACE UNIVERSITY',
    address: '15 E PEACE ST',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27604,
    telephone: '(919) 508-2000',
    population: 1062,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.peace.edu/',
  },
  {
    name: 'HIBBING COMMUNITY COLLEGE',
    address: '1515 EAST 25TH STREET',
    city: 'HIBBING',
    state: 'MN',
    zip: 55746,
    telephone: '(218) 262-7200',
    population: 1066,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hibbing.edu/',
  },
  {
    name: 'NORTHWEST LOUISIANA TECHNICAL COMMUNITY COLLEGE',
    address: '9500 INDUSTRIAL DRIVE',
    city: 'MINDEN',
    state: 'LA',
    zip: 71055,
    telephone: '(318) 371-3035',
    population: 1066,
    county: 'WEBSTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nltcc.edu/',
  },
  {
    name: 'ANTIOCH UNIVERSITY-NEW ENGLAND',
    address: '40 AVON ST',
    city: 'KEENE',
    state: 'NH',
    zip: 3431,
    telephone: '(603) 357-3122',
    population: 1067,
    county: 'CHESHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.antiochne.edu/',
  },
  {
    name: 'CBD COLLEGE',
    address: '3699 WILSHIRE BLVD., FOURTH FLOOR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(213) 427-2200',
    population: 1067,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cbd.edu/',
  },
  {
    name: 'BLUE CLIFF COLLEGE-METAIRIE',
    address: '3200 CLEARY AVE',
    city: 'METAIRIE',
    state: 'LA',
    zip: 70002,
    telephone: '(504) 456-3141 EXT 2225',
    population: 1068,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bluecliffcollege.edu/',
  },
  {
    name: 'PLAZA COLLEGE',
    address: '118-33 QUEENS BOULEVARD',
    city: 'FOREST HILLS',
    state: 'NY',
    zip: 11375,
    telephone: '(718) 779-1430',
    population: 1069,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plazacollege.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO INC-SAN SEBASTIAN',
    address: 'BETANCES # 49',
    city: 'SAN SEBASTIAN',
    state: 'PR',
    zip: 685,
    telephone: '(787) 896-2137',
    population: 1069,
    county: 'SAN SEBASTIÁN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'AI MIAMI INTERNATIONAL UNIVERSITY OF ART AND DESIGN',
    address: '1501 BISCAYNE BOULEVARD, SUITE 100',
    city: 'MIAMI',
    state: 'FL',
    zip: 33132,
    telephone: '(305) 428-5700',
    population: 1074,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artinstitutes.edu/miami/',
  },
  {
    name: 'LIVINGSTONE COLLEGE',
    address: '701 W MONROE ST',
    city: 'SALISBURY',
    state: 'NC',
    zip: 28144,
    telephone: '(704) 216-6000',
    population: 1074,
    county: 'ROWAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.livingstone.edu/',
  },
  {
    name: 'COLEGIO UNIVERSITARIO DE SAN JUAN',
    address: '180 JOSE OLIVER ST TRES MONJITAS IND. PARK',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 918,
    telephone: '(787) 480-2400',
    population: 1076,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cunisanjuan.edu/',
  },
  {
    name: 'NEW MEXICO STATE UNIVERSITY-ALAMOGORDO',
    address: '2400 NORTH SCENIC DRIVE',
    city: 'ALAMOGORDO',
    state: 'NM',
    zip: 88310,
    telephone: '(575) 439-3600',
    population: 1079,
    county: 'OTERO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'nmsua.edu/',
  },
  {
    name: 'SIMPSON UNIVERSITY',
    address: '2211 COLLEGE VIEW DRIVE',
    city: 'REDDING',
    state: 'CA',
    zip: 96003,
    telephone: '(530) 224-5600',
    population: 1083,
    county: 'SHASTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.simpsonu.edu/',
  },
  {
    name: 'SAINT AUGUSTINE COLLEGE',
    address: '1345 W. ARGYLE ST.',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60640,
    telephone: '(773) 878-8756',
    population: 1083,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.staugustine.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-FLORIDA',
    address: '5200 BELFORT ROAD, SUITE 100',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32256,
    telephone: '(904) 251-8100',
    population: 1084,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'NEW ENGLAND LAW-BOSTON',
    address: '154 STUART ST',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 451-0010',
    population: 1087,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nesl.edu/',
  },
  {
    name: 'EMMANUEL COLLEGE',
    address: '181 SPRINGS ST',
    city: 'FRANKLIN SPRINGS',
    state: 'GA',
    zip: 30639,
    telephone: '(706) 245-7226',
    population: 1087,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ec.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-INDIANAPOLIS',
    address: '7225 WINTON DRIVE - BUILDING 128',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46268,
    telephone: '(317) 632-5553 EXT 40400',
    population: 1087,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/indianapolis-in',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-BUFFALO',
    address: '465 MAIN STREET, SUITE 400',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14203,
    telephone: '(716) 884-9120',
    population: 1089,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'METROPOLITAN COLLEGE OF NEW YORK',
    address: '60 WEST STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10006,
    telephone: '(800) 338-4465',
    population: 1091,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mcny.edu/',
  },
  {
    name: 'THE COLLEGE OF WESTCHESTER',
    address: '325 CENTRAL AVE',
    city: 'WHITE PLAINS',
    state: 'NY',
    zip: 10606,
    telephone: '(914) 948-4442',
    population: 1091,
    county: 'WESTCHESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cw.edu/',
  },
  {
    name: 'BLUE MOUNTAIN COLLEGE',
    address: '201 W MAIN ST',
    city: 'BLUE MOUNTAIN',
    state: 'MS',
    zip: 38610,
    telephone: '(662) 685-4771',
    population: 1095,
    county: 'TIPPAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bmc.edu/',
  },
  {
    name: 'BREVARD COLLEGE',
    address: 'ONE BREVARD COLLEGE DRIVE',
    city: 'BREVARD',
    state: 'NC',
    zip: 28712,
    telephone: '(828) 884-8332',
    population: 1096,
    county: 'TRANSYLVANIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.brevard.edu/',
  },
  {
    name: 'ALDERSON BROADDUS UNIVERSITY',
    address: '101 COLLEGE HILL DRIVE',
    city: 'PHILIPPI',
    state: 'WV',
    zip: 26416,
    telephone: '(304) 457-1700',
    population: 1097,
    county: 'BARBOUR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ab.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-EASTERN CAMPUS',
    address: '45425 NATIONAL RD W',
    city: 'SAINT CLAIRSVILLE',
    state: 'OH',
    zip: 43950,
    telephone: '(740) 695-1720',
    population: 1098,
    county: 'BELMONT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ohio.edu/eastern/',
  },
  {
    name: 'WEST VIRGINIA SCHOOL OF OSTEOPATHIC MEDICINE',
    address: '400 LEE STREET NORTH',
    city: 'LEWISBURG',
    state: 'WV',
    zip: 24901,
    telephone: '(304) 645-6270',
    population: 1100,
    county: 'GREENBRIER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvsom.edu/',
  },
  {
    name: 'KENTUCKY WESLEYAN COLLEGE',
    address: '3000 FREDERICA STREET',
    city: 'OWENSBORO',
    state: 'KY',
    zip: 42301,
    telephone: '(270) 926-3111',
    population: 1104,
    county: 'DAVIESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://kwc.edu/',
  },
  {
    name: 'EAST ARKANSAS COMMUNITY COLLEGE',
    address: '1700 NEWCASTLE RD',
    city: 'FORREST CITY',
    state: 'AR',
    zip: 72335,
    telephone: '(870) 633-4480 EXT 200',
    population: 1104,
    county: 'ST. FRANCIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.eacc.edu/',
  },
  {
    name: 'COX COLLEGE',
    address: '1423 N JEFFERSON',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65802,
    telephone: '(417) 269-3401',
    population: 1105,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://coxcollege.edu/',
  },
  {
    name: 'UNION INSTITUTE & UNIVERSITY',
    address: '440 E MCMILLAN ST',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45206,
    telephone: '(800) 861-6400',
    population: 1106,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.myunion.edu/',
  },
  {
    name: 'PACIFIC COLLEGE OF HEALTH AND SCIENCE',
    address: '7445 MISSION VALLEY RD STE 105',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92108,
    telephone: '(619) 574-6909 EXT 104',
    population: 1106,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pacificcollege.edu/',
  },
  {
    name: 'ERSKINE COLLEGE',
    address: '2 WASHINGTON ST',
    city: 'DUE WEST',
    state: 'SC',
    zip: 29639,
    telephone: '(864) 379-2131',
    population: 1106,
    county: 'ABBEVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.erskine.edu/',
  },
  {
    name: 'EARLHAM COLLEGE',
    address: '801 NATIONAL RD WEST',
    city: 'RICHMOND',
    state: 'IN',
    zip: 47374,
    telephone: '(765) 983-1200',
    population: 1113,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://earlham.edu/',
  },
  {
    name: 'PONTIFICAL CATHOLIC UNIVERSITY OF PUERTO RICO-MAYAGUEZ',
    address: '482 SUR CALLE RAMON EMERITO BETANCES',
    city: 'MAYAGUEZ',
    state: 'PR',
    zip: 680,
    telephone: '(787) 834-5151 EXT 5027',
    population: 1113,
    county: 'MAYAGÜEZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://mayaguez.pucpr.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-LAUDERDALE LAKES',
    address: '3383 NORTH STATE ROAD 7',
    city: 'LAUDERDALE LAKES',
    state: 'FL',
    zip: 33319,
    telephone: '(954) 908-4700',
    population: 1113,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'MONMOUTH COLLEGE',
    address: '700 E BROADWAY',
    city: 'MONMOUTH',
    state: 'IL',
    zip: 61462,
    telephone: '(309) 457-2311',
    population: 1114,
    county: 'WARREN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.monmouthcollege.edu/',
  },
  {
    name: 'CAROLINA UNIVERSITY',
    address: '420 S. BROAD ST.',
    city: 'WINSTON-SALEM',
    state: 'NC',
    zip: 27101,
    telephone: '(336) 725-8344',
    population: 1116,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.carolinau.edu/',
  },
  {
    name: 'HOLLINS UNIVERSITY',
    address: '7916 WILLIAMSON RD NW',
    city: 'ROANOKE',
    state: 'VA',
    zip: 24020,
    telephone: '(540) 362-6000',
    population: 1117,
    county: 'ROANOKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hollins.edu/',
  },
  {
    name: 'LAGUNA COLLEGE OF ART AND DESIGN',
    address: '2222 LAGUNA CANYON RD',
    city: 'LAGUNA BEACH',
    state: 'CA',
    zip: 92651,
    telephone: '(949) 376-6000',
    population: 1117,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lcad.edu/',
  },
  {
    name: 'ANTIOCH UNIVERSITY-LOS ANGELES',
    address: '400 CORPORATE POINTE',
    city: 'CULVER CITY',
    state: 'CA',
    zip: 90230,
    telephone: '(310) 578-1080',
    population: 1118,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.antiochla.edu/',
  },
  {
    name: 'MARANATHA BAPTIST UNIVERSITY',
    address: '745 WEST MAIN STREET',
    city: 'WATERTOWN',
    state: 'WI',
    zip: 53094,
    telephone: '(920) 261-9300',
    population: 1119,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mbu.edu/',
  },
  {
    name: 'FORTIS COLLEGE-COLUMBUS',
    address: '4151 EXECUTIVE PARKWAY STE 120',
    city: 'WESTERVILLE',
    state: 'OH',
    zip: 43081,
    telephone: '(614) 882-2551',
    population: 1119,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortiscollege.edu/',
  },
  {
    name: 'TOUGALOO COLLEGE',
    address: '500 W COUNTY LINE RD',
    city: 'TOUGALOO',
    state: 'MS',
    zip: 39174,
    telephone: '(601) 977-7700',
    population: 1120,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tougaloo.edu/',
  },
  {
    name: 'COLORADO NORTHWESTERN COMMUNITY COLLEGE',
    address: '500 KENNEDY DRIVE',
    city: 'RANGELY',
    state: 'CO',
    zip: 81648,
    telephone: '(970) 675-2261',
    population: 1126,
    county: 'RIO BLANCO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cncc.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY-LIMA CAMPUS',
    address: '4240 CAMPUS DR',
    city: 'LIMA',
    state: 'OH',
    zip: 45804,
    telephone: '(567) 242-7272',
    population: 1127,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'lima.osu.edu/',
  },
  {
    name: 'FISK UNIVERSITY',
    address: '1000 17TH AVE NORTH',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37208,
    telephone: '(615) 329-8500',
    population: 1127,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fisk.edu/',
  },
  {
    name: 'HUNTINGDON COLLEGE',
    address: '1500 EAST FAIRVIEW AVENUE',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36106,
    telephone: '(334) 833-4497',
    population: 1127,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.huntingdon.edu/',
  },
  {
    name: 'AIR FORCE INSTITUTE OF TECHNOLOGY-GRADUATE SCHOOL OF ENGINEERING & MANAGEMENT',
    address: '2950 HOBSON WAY',
    city: 'WRIGHT-PATTERSON AFB',
    state: 'OH',
    zip: 45433,
    telephone: '(937) 255-3636',
    population: 1129,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.afit.edu/',
  },
  {
    name: 'SOUTHWESTERN LAW SCHOOL',
    address: '3050 WILSHIRE BOULEVARD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90010,
    telephone: '(213) 738-6700',
    population: 1130,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swlaw.edu/',
  },
  {
    name: 'THE CHRIST COLLEGE OF NURSING AND HEALTH SCIENCES',
    address: '2139 AUBURN AVENUE',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45219,
    telephone: '(513) 585-2401',
    population: 1134,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.thechristcollege.edu/',
  },
  {
    name: 'CENTRAL PENN COLLEGE',
    address: '600 VALLEY ROAD',
    city: 'SUMMERDALE',
    state: 'PA',
    zip: 17093,
    telephone: '(800) 759-2727',
    population: 1135,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centralpenn.edu/',
  },
  {
    name: 'DAKOTA WESLEYAN UNIVERSITY',
    address: '1200 W UNIVERSITY AVE',
    city: 'MITCHELL',
    state: 'SD',
    zip: 57301,
    telephone: '(605) 995-2600',
    population: 1137,
    county: 'DAVISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dwu.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-GEORGIA',
    address: '1 WEST COURT SQUARE, STE. 600',
    city: 'DECATUR',
    state: 'GA',
    zip: 30030,
    telephone: '(404) 270-2706',
    population: 1138,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'COVENANT COLLEGE',
    address: '14049 SCENIC HIGHWAY',
    city: 'LOOKOUT MOUNTAIN',
    state: 'GA',
    zip: 30750,
    telephone: '(706) 820-1560',
    population: 1139,
    county: 'DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.covenant.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW MEXICO-TAOS CAMPUS',
    address: '1157 COUNTY ROAD 110',
    city: 'RANCHOS DE TAOS',
    state: 'NM',
    zip: 87557,
    telephone: '(575) 737-6200',
    population: 1139,
    county: 'TAOS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'taos.unm.edu/index.html',
  },
  {
    name: 'BENNINGTON COLLEGE',
    address: 'ONE COLLEGE DRIVE',
    city: 'BENNINGTON',
    state: 'VT',
    zip: 5201,
    telephone: '(802) 442-5401',
    population: 1141,
    county: 'BENNINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bennington.edu/',
  },
  {
    name: 'AVERETT UNIVERSITY',
    address: '420 W MAIN ST',
    city: 'DANVILLE',
    state: 'VA',
    zip: 24541,
    telephone: '(434) 791-5600',
    population: 1145,
    county: 'DANVILLE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.averett.edu/',
  },
  {
    name: 'OKLAHOMA WESLEYAN UNIVERSITY',
    address: '2201 SILVER LAKE RD',
    city: 'BARTLESVILLE',
    state: 'OK',
    zip: 74006,
    telephone: '(918) 333-6151',
    population: 1146,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.okwu.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY-MANSFIELD CAMPUS',
    address: '1760 UNIVERSITY DRIVE',
    city: 'MANSFIELD',
    state: 'OH',
    zip: 44906,
    telephone: '(419) 755-4317',
    population: 1147,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'mansfield.osu.edu/',
  },
  {
    name: 'WABASH COLLEGE',
    address: '301 WEST WABASH AVENUE',
    city: 'CRAWFORDSVILLE',
    state: 'IN',
    zip: 47933,
    telephone: '(765) 361-6100',
    population: 1150,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wabash.edu/',
  },
  {
    name: 'HOUGHTON COLLEGE',
    address: '1 WILLARD AVE',
    city: 'HOUGHTON',
    state: 'NY',
    zip: 14744,
    telephone: '(585) 567-9200',
    population: 1151,
    county: 'ALLEGANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.houghton.edu/',
  },
  {
    name: 'CARIBBEAN UNIVERSITY-BAYAMON',
    address: '167 AVE. KM 21.2',
    city: 'BAYAMON',
    state: 'PR',
    zip: 960,
    telephone: '(787) 780-0070 EXT 51001',
    population: 1151,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caribbean.edu/',
  },
  {
    name: 'GALEN COLLEGE OF NURSING-CINCINNATI',
    address: '100 E BUSINESS WAY STE 200',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45241,
    telephone: '(513) 475-3600',
    population: 1155,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.galencollege.edu/cincinnati',
  },
  {
    name: 'MARTIN LUTHER COLLEGE',
    address: '1995 LUTHER CT',
    city: 'NEW ULM',
    state: 'MN',
    zip: 56073,
    telephone: '(507) 354-8221 EXT 211',
    population: 1159,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mlc-wels.edu/',
  },
  {
    name: 'PACIFICA GRADUATE INSTITUTE',
    address: '249 LAMBERT RD',
    city: 'CARPINTERIA',
    state: 'CA',
    zip: 93013,
    telephone: '(805) 969-3626 EXT 101',
    population: 1161,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pacifica.edu/',
  },
  {
    name: 'MARTIN COMMUNITY COLLEGE',
    address: '1161 KEHUKEE PK RD',
    city: 'WILLIAMSTON',
    state: 'NC',
    zip: 27892,
    telephone: '(252) 792-1521',
    population: 1163,
    county: 'MARTIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.martincc.edu/',
  },
  {
    name: 'MARYLAND UNIVERSITY OF INTEGRATIVE HEALTH',
    address: '7750 MONTPELIER ROAD',
    city: 'LAUREL',
    state: 'MD',
    zip: 20723,
    telephone: '(410) 888-9048',
    population: 1164,
    county: 'HOWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.muih.edu/',
  },
  {
    name: 'UNITED EDUCATION INSTITUTE-HUNTINGTON PARK CAMPUS',
    address: '6055 PACIFIC BOULEVARD',
    city: 'HUNTINGTON PARK',
    state: 'CA',
    zip: 90255,
    telephone: '(323) 319-9500',
    population: 1165,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.uei.edu/',
  },
  {
    name: 'MILWAUKEE INSTITUTE OF ART & DESIGN',
    address: '273 E ERIE ST',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53202,
    telephone: '(414) 847-3200',
    population: 1166,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.miad.edu/',
  },
  {
    name: 'SALEM UNIVERSITY',
    address: '223 W MAIN ST',
    city: 'SALEM',
    state: 'WV',
    zip: 26426,
    telephone: '(304) 326-1109',
    population: 1168,
    county: 'HARRISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.salemu.edu/',
  },
  {
    name: 'OTTAWA UNIVERSITY-PHOENIX',
    address: '9414 NORTH 25TH AVENUE',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85021,
    telephone: '(602) 371-1188',
    population: 1169,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ottawa.edu/',
  },
  {
    name: 'GREENSBORO COLLEGE',
    address: '815 W MARKET ST',
    city: 'GREENSBORO',
    state: 'NC',
    zip: 27401,
    telephone: '(336) 272-7102',
    population: 1170,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.greensboro.edu/',
  },
  {
    name: 'CLARKE UNIVERSITY',
    address: '1550 CLARKE DR',
    city: 'DUBUQUE',
    state: 'IA',
    zip: 52001,
    telephone: '(563) 588-6300',
    population: 1175,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.clarke.edu/',
  },
  {
    name: 'PACIFIC UNION COLLEGE',
    address: 'ONE ANGWIN AVE',
    city: 'ANGWIN',
    state: 'CA',
    zip: 94508,
    telephone: '(707) 965-6313',
    population: 1179,
    county: 'NAPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.puc.edu/',
  },
  {
    name: 'AMBERTON UNIVERSITY',
    address: '1700 EASTGATE DR',
    city: 'GARLAND',
    state: 'TX',
    zip: 75041,
    telephone: '(972) 279-6511',
    population: 1183,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amberton.edu/',
  },
  {
    name: 'HALLMARK UNIVERSITY',
    address: '10401 IH 10 W',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78230,
    telephone: '(210) 690-9000',
    population: 1183,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hallmarkuniversity.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-ORLANDO',
    address: '989 NORTH SEMORAN BOULEVARD',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32807,
    telephone: '(407) 956-5501',
    population: 1184,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-UNION',
    address: '309 EAST ACADEMY ST',
    city: 'UNION',
    state: 'SC',
    zip: 29379,
    telephone: '(864) 429-8728',
    population: 1184,
    county: 'UNION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sc.edu/about/system_and_campuses/union/index.php',
  },
  {
    name: 'CLINTON COMMUNITY COLLEGE',
    address: '136 CLINTON POINT DR.',
    city: 'PLATTSBURGH',
    state: 'NY',
    zip: 12901,
    telephone: '(518) 562-4200',
    population: 1185,
    county: 'CLINTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.clinton.edu/',
  },
  {
    name: 'BRESCIA UNIVERSITY',
    address: '717 FREDERICA ST',
    city: 'OWENSBORO',
    state: 'KY',
    zip: 42301,
    telephone: '(270) 685-3131',
    population: 1186,
    county: 'DAVIESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brescia.edu/',
  },
  {
    name: 'BLUEFIELD COLLEGE',
    address: '3000 COLLEGE AVENUE',
    city: 'BLUEFIELD',
    state: 'VA',
    zip: 24605,
    telephone: '(276) 326-3682',
    population: 1186,
    county: 'TAZEWELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bluefield.edu/',
  },
  {
    name: 'ST. ANDREWS UNIVERSITY',
    address: '1700 DOGWOOD MILE',
    city: 'LAURINBURG',
    state: 'NC',
    zip: 28352,
    telephone: '(910) 277-5555',
    population: 1186,
    county: 'SCOTLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sa.edu/',
  },
  {
    name: 'OZARKA COLLEGE',
    address: '218 COLLEGE DR',
    city: 'MELBOURNE',
    state: 'AR',
    zip: 72556,
    telephone: '(870) 368-7371',
    population: 1187,
    county: 'IZARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ozarka.edu/',
  },
  {
    name: 'ARIZONA CHRISTIAN UNIVERSITY',
    address: '1 W. FIRESTORM WAY',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85306,
    telephone: '(602) 489-5300',
    population: 1188,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'arizonachristian.edu/',
  },
  {
    name: 'EMORY UNIVERSITY-OXFORD COLLEGE',
    address: '801 EMORY STREET',
    city: 'OXFORD',
    state: 'GA',
    zip: 30054,
    telephone: '(770) 784-8888',
    population: 1188,
    county: 'NEWTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oxford.emory.edu/',
  },
  {
    name: 'HASTINGS COLLEGE',
    address: '710 N TURNER AVE',
    city: 'HASTINGS',
    state: 'NE',
    zip: 68901,
    telephone: '(402) 463-2402 EXT 7405',
    population: 1191,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hastings.edu/',
  },
  {
    name: 'DRURY UNIVERSITY-COLLEGE OF CONTINUING PROFESSIONAL STUDIES',
    address: '900 NORTH BENTON AVENUE',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65802,
    telephone: '(417) 873-7373',
    population: 1192,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.drury.edu/ccps/',
  },
  {
    name: 'NEW RIVER COMMUNITY AND TECHNICAL COLLEGE',
    address: '280 UNIVERSITY DRIVE',
    city: 'BEAVER',
    state: 'WV',
    zip: 25813,
    telephone: '(304) 929-5450',
    population: 1193,
    county: 'RALEIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.newriver.edu/',
  },
  {
    name: 'HACKENSACK MERIDIAN SCHOOL OF MEDICINE',
    address: '123 METRO BOULEVARD',
    city: 'NUTLEY',
    state: 'NJ',
    zip: 7110,
    telephone: '(973) 275-4852',
    population: 1194,
    county: 'PASSAIC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hmsom.org/',
  },
  {
    name: 'ITASCA COMMUNITY COLLEGE',
    address: '1851 EAST HIGHWAY 169',
    city: 'GRAND RAPIDS',
    state: 'MN',
    zip: 55744,
    telephone: '(218) 322-2300',
    population: 1196,
    county: 'ITASCA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.itascacc.edu/',
  },
  {
    name: 'WEST SHORE COMMUNITY COLLEGE',
    address: '3000 N STILES RD',
    city: 'SCOTTVILLE',
    state: 'MI',
    zip: 49454,
    telephone: '(231) 845-6211',
    population: 1199,
    county: 'MASON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.westshore.edu/',
  },
  {
    name: 'GOSHEN COLLEGE',
    address: '1700 S MAIN ST',
    city: 'GOSHEN',
    state: 'IN',
    zip: 46526,
    telephone: '(574) 535-7000',
    population: 1205,
    county: 'ELKHART',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.goshen.edu/',
  },
  {
    name: 'WARNER UNIVERSITY',
    address: '13895 HWY 27',
    city: 'LAKE WALES',
    state: 'FL',
    zip: 33859,
    telephone: '(863) 638-1426',
    population: 1205,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.warner.edu/academics/undergraduate_programs/admissions/criteria-for-admission/',
  },
  {
    name: 'DAKOTA COLLEGE AT BOTTINEAU',
    address: '105 SIMRALL BLVD',
    city: 'BOTTINEAU',
    state: 'ND',
    zip: 58318,
    telephone: '(701) 228-2277',
    population: 1207,
    county: 'BOTTINEAU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dakotacollege.edu/',
  },
  {
    name: 'HARVEY MUDD COLLEGE',
    address: '301 PLATT BLVD.',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8000',
    population: 1210,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hmc.edu/',
  },
  {
    name: 'UNIVERSITY OF PROVIDENCE',
    address: '1301 20TH ST S',
    city: 'GREAT FALLS',
    state: 'MT',
    zip: 59405,
    telephone: '(406) 761-8210',
    population: 1212,
    county: 'CASCADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprovidence.edu/',
  },
  {
    name: 'LAKE ERIE COLLEGE',
    address: '391 W WASHINGTON ST',
    city: 'PAINESVILLE',
    state: 'OH',
    zip: 44077,
    telephone: '(440) 375-7000',
    population: 1214,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lec.edu/',
  },
  {
    name: 'NAROPA UNIVERSITY',
    address: '2130 ARAPAHOE AVE',
    city: 'BOULDER',
    state: 'CO',
    zip: 80302,
    telephone: '(303) 444-0202',
    population: 1215,
    county: 'BOULDER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.naropa.edu/',
  },
  {
    name: 'COLBY-SAWYER COLLEGE',
    address: '541 MAIN ST',
    city: 'NEW LONDON',
    state: 'NH',
    zip: 3257,
    telephone: '(603) 526-3000',
    population: 1215,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.colby-sawyer.edu/',
  },
  {
    name: 'DABNEY S LANCASTER COMMUNITY COLLEGE',
    address: '1000 DABNEY DRIVE',
    city: 'CLIFTON FORGE',
    state: 'VA',
    zip: 24422,
    telephone: '(540) 863-2800',
    population: 1218,
    county: 'ALLEGHANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dslcc.edu/',
  },
  {
    name: 'UNIVERSIDAD ADVENTISTA DE LAS ANTILLAS',
    address: 'CARR 106 KM 2.2 INT',
    city: 'MAYAGUEZ',
    state: 'PR',
    zip: 680,
    telephone: '(787) 834-9595 EXT 0',
    population: 1220,
    county: 'MAYAGÜEZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uaa.edu/',
  },
  {
    name: 'CULVER-STOCKTON COLLEGE',
    address: 'ONE COLLEGE HILL',
    city: 'CANTON',
    state: 'MO',
    zip: 63435,
    telephone: '(573) 288-6000',
    population: 1221,
    county: 'LEWIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.culver.edu/',
  },
  {
    name: 'HAMPDEN-SYDNEY COLLEGE',
    address: 'COLLEGE ROAD',
    city: 'HAMPDEN-SYDNEY',
    state: 'VA',
    zip: 23943,
    telephone: '(434) 223-6000',
    population: 1225,
    county: 'PRINCE EDWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hsc.edu/',
  },
  {
    name: 'FLORIDA CAREER COLLEGE-HOUSTON',
    address: '70-A FARM TO MARKET ROAD 1960 WEST',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77090,
    telephone: '(281) 943-6261',
    population: 1225,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.floridacareercollege.edu/',
  },
  {
    name: 'TRI-COUNTY COMMUNITY COLLEGE',
    address: '21 CAMPUS CIRCLE',
    city: 'MURPHY',
    state: 'NC',
    zip: 28906,
    telephone: '(828) 837-6810',
    population: 1228,
    county: 'CHEROKEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tricountycc.edu/',
  },
  {
    name: 'MONTANA STATE UNIVERSITY-NORTHERN',
    address: '300 W 11TH ST',
    city: 'HAVRE',
    state: 'MT',
    zip: 59501,
    telephone: '(406) 265-3700',
    population: 1229,
    county: 'HILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msun.edu/',
  },
  {
    name: 'OLIVET COLLEGE',
    address: '320 SOUTH MAIN STREET',
    city: 'OLIVET',
    state: 'MI',
    zip: 49076,
    telephone: '(800) 456-7189',
    population: 1229,
    county: 'EATON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.olivetcollege.edu/',
  },
  {
    name: 'DENVER COLLEGE OF NURSING',
    address: '1401 19TH ST',
    city: 'DENVER',
    state: 'CO',
    zip: 80202,
    telephone: '(303) 292-0015',
    population: 1230,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.denvercollegeofnursing.edu/',
  },
  {
    name: 'FLORIDA MEMORIAL UNIVERSITY',
    address: '15800 NW 42 AVENUE',
    city: 'MIAMI GARDENS',
    state: 'FL',
    zip: 33054,
    telephone: '(305) 626-3600',
    population: 1230,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fmuniv.edu/',
  },
  {
    name: 'PITZER COLLEGE',
    address: '1050 NORTH MILLS AVENUE',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8000',
    population: 1231,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pitzer.edu/',
  },
  {
    name: 'WASHINGTON ADVENTIST UNIVERSITY',
    address: '7600 FLOWER AVE',
    city: 'TAKOMA PARK',
    state: 'MD',
    zip: 20912,
    telephone: '(301) 891-4000',
    population: 1231,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wau.edu/',
  },
  {
    name: 'HUSTON-TILLOTSON UNIVERSITY',
    address: '900 CHICON ST',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78702,
    telephone: '(512) 505-3000',
    population: 1232,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.htu.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT EAST LIVERPOOL',
    address: '400 E 4TH ST',
    city: 'EAST LIVERPOOL',
    state: 'OH',
    zip: 43920,
    telephone: '(330) 385-3805',
    population: 1237,
    county: 'COLUMBIANA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/columbiana',
  },
  {
    name: 'MCDOWELL TECHNICAL COMMUNITY COLLEGE',
    address: '54 COLLEGE DRIVE',
    city: 'MARION',
    state: 'NC',
    zip: 28752,
    telephone: '(828) 652-6021',
    population: 1240,
    county: 'MCDOWELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mcdowelltech.edu/',
  },
  {
    name: 'GREAT FALLS COLLEGE MONTANA STATE UNIVERSITY',
    address: '2100 16TH AVE S',
    city: 'GREAT FALLS',
    state: 'MT',
    zip: 59405,
    telephone: '(406) 268-3700',
    population: 1243,
    county: 'CASCADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gfcmsu.edu/',
  },
  {
    name: 'MAINE MARITIME ACADEMY',
    address: '1 PLEASANT STREET',
    city: 'CASTINE',
    state: 'ME',
    zip: 4420,
    telephone: '(800) 464-6565',
    population: 1245,
    county: 'HANCOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://mainemaritime.edu/',
  },
  {
    name: 'BLADEN COMMUNITY COLLEGE',
    address: '7418 NC HWY 41 WEST',
    city: 'DUBLIN',
    state: 'NC',
    zip: 28332,
    telephone: '(910) 879-5500',
    population: 1245,
    county: 'BLADEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bladencc.edu/',
  },
  {
    name: 'SOUTH TEXAS COLLEGE OF LAW HOUSTON',
    address: '1303 SAN JACINTO STREET',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77002,
    telephone: '(713) 659-8040',
    population: 1250,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stcl.edu/',
  },
  {
    name: 'UINTAH BASIN TECHNICAL COLLEGE',
    address: '1100 E LAGOON ST 124-5',
    city: 'ROOSEVELT',
    state: 'UT',
    zip: 84066,
    telephone: '(435) 722-6900',
    population: 1263,
    county: 'UINTAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ubtech.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY MARITIME ACADEMY',
    address: '200 MARITIME ACADEMY DR',
    city: 'VALLEJO',
    state: 'CA',
    zip: 94590,
    telephone: '(707) 654-1000',
    population: 1264,
    county: 'SOLANO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csum.edu/',
  },
  {
    name: 'SPARTANBURG METHODIST COLLEGE',
    address: '1000 POWELL MILL ROAD',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29301,
    telephone: '(864) 587-4000 EXT 4117',
    population: 1264,
    county: 'SPARTANBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.smcsc.edu/',
  },
  {
    name: 'MONTREAT COLLEGE',
    address: '310 GAITHER CIRCLE',
    city: 'MONTREAT',
    state: 'NC',
    zip: 28757,
    telephone: '(828) 669-8012',
    population: 1265,
    county: 'BUNCOMBE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.montreat.edu/',
  },
  {
    name: 'GRACE CHRISTIAN UNIVERSITY',
    address: '1011 ALDON SW',
    city: 'WYOMING',
    state: 'MI',
    zip: 49509,
    telephone: '(616) 538-2330',
    population: 1267,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gracechristian.edu/',
  },
  {
    name: 'ROCKY MOUNTAIN COLLEGE',
    address: '1511 POLY DRIVE',
    city: 'BILLINGS',
    state: 'MT',
    zip: 59102,
    telephone: '(406) 657-1000',
    population: 1273,
    county: 'YELLOWSTONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rocky.edu/',
  },
  {
    name: 'UNIVERSITY OF HEALTH SCIENCES AND PHARMACY IN ST. LOUIS',
    address: '1 PHARMACY PLACE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63110,
    telephone: '(800) 278-5267',
    population: 1273,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uhsp.edu/',
  },
  {
    name: 'WESLEY COLLEGE',
    address: '120 N STATE ST',
    city: 'DOVER',
    state: 'DE',
    zip: 19901,
    telephone: '(302) 736-2300',
    population: 1273,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wesley.edu/',
  },
  {
    name: 'TRANSYLVANIA UNIVERSITY',
    address: '300 N BROADWAY',
    city: 'LEXINGTON',
    state: 'KY',
    zip: 40508,
    telephone: '(859) 233-8300',
    population: 1275,
    county: 'FAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.transy.edu/',
  },
  {
    name: 'MILDRED ELLEY-NEW YORK CAMPUS',
    address: '25 BROADWAY 16TH FLOOR',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10004,
    telephone: '(212) 380-9004',
    population: 1276,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mildred-elley.edu/',
  },
  {
    name: 'TENNESSEE WESLEYAN UNIVERSITY',
    address: '204 EAST COLLEGE STREET',
    city: 'ATHENS',
    state: 'TN',
    zip: 37303,
    telephone: '(423) 745-7504',
    population: 1278,
    county: 'MCMINN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tnwesleyan.edu/',
  },
  {
    name: 'MITCHELL TECHNICAL COLLEGE',
    address: '1800 E. SPRUCE STREET',
    city: 'MITCHELL',
    state: 'SD',
    zip: 57301,
    telephone: '(605) 995-3025',
    population: 1281,
    county: 'DAVISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mitchelltech.edu/',
  },
  {
    name: 'CHOWAN UNIVERSITY',
    address: 'ONE UNIVERSITY PLACE',
    city: 'MURFREESBORO',
    state: 'NC',
    zip: 27855,
    telephone: '(252) 398-6500',
    population: 1284,
    county: 'HERTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chowan.edu/',
  },
  {
    name: 'COLUMBUS COLLEGE OF ART AND DESIGN',
    address: '60 CLEVELAND AVE.',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43215,
    telephone: '(614) 224-9101',
    population: 1284,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccad.edu/',
  },
  {
    name: 'BASTYR UNIVERSITY',
    address: '14500 JUANITA DRIVE NE',
    city: 'KENMORE',
    state: 'WA',
    zip: 98028,
    telephone: '(425) 602-3000',
    population: 1285,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bastyr.edu/',
  },
  {
    name: 'PRESCOTT COLLEGE',
    address: '220 GROVE AVE',
    city: 'PRESCOTT',
    state: 'AZ',
    zip: 86301,
    telephone: '(877) 350-2100',
    population: 1285,
    county: 'YAVAPAI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.prescott.edu/',
  },
  {
    name: 'CORNELL COLLEGE',
    address: '600 FIRST ST. SW',
    city: 'MOUNT VERNON',
    state: 'IA',
    zip: 52314,
    telephone: '(319) 895-4000',
    population: 1286,
    county: 'LINN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cornellcollege.edu/',
  },
  {
    name: 'FERRUM COLLEGE',
    address: '215 FERRUM MOUNTAIN ROAD',
    city: 'FERRUM',
    state: 'VA',
    zip: 24088,
    telephone: '(540) 365-2121',
    population: 1288,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ferrum.edu/',
  },
  {
    name: 'LANE COLLEGE',
    address: '545 LANE AVE',
    city: 'JACKSON',
    state: 'TN',
    zip: 38301,
    telephone: '(731) 426-7500',
    population: 1290,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lanecollege.edu/',
  },
  {
    name: 'PRATT COMMUNITY COLLEGE',
    address: '348 NE SR 61',
    city: 'PRATT',
    state: 'KS',
    zip: 67124,
    telephone: '(620) 672-5641',
    population: 1292,
    county: 'PRATT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.prattcc.edu/',
  },
  {
    name: 'FRANKLIN COLLEGE',
    address: '101 BRANIGIN BLVD',
    city: 'FRANKLIN',
    state: 'IN',
    zip: 46131,
    telephone: '(317) 738-8000',
    population: 1294,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.franklincollege.edu/',
  },
  {
    name: 'THE NEW ENGLAND CONSERVATORY OF MUSIC',
    address: '290 HUNTINGTON AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 585-1100',
    population: 1296,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://necmusic.edu/',
  },
  {
    name: 'SOUTHEAST ARKANSAS COLLEGE',
    address: '1900 S HAZEL STREET',
    city: 'PINE BLUFF',
    state: 'AR',
    zip: 71603,
    telephone: '(870) 543-5900',
    population: 1296,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.seark.edu/',
  },
  {
    name: 'WESTERN MICHIGAN UNIVERSITY-THOMAS M. COOLEY LAW SCHOOL',
    address: '300 S CAPITOL AVE',
    city: 'LANSING',
    state: 'MI',
    zip: 48933,
    telephone: '(517) 371-5140',
    population: 1297,
    county: 'INGHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cooley.edu/',
  },
  {
    name: 'NORTH CENTRAL UNIVERSITY',
    address: '910 ELLIOT AVE',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55404,
    telephone: '(612) 343-4400',
    population: 1297,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northcentral.edu/',
  },
  {
    name: 'SOUTHERN TECHNICAL COLLEGE',
    address: '1685 MEDICAL LANE',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33907,
    telephone: '(239) 939-4766',
    population: 1297,
    county: 'LEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southerntech.edu/',
  },
  {
    name: 'LINCOLN COLLEGE',
    address: '300 KEOKUK ST',
    city: 'LINCOLN',
    state: 'IL',
    zip: 62656,
    telephone: '(217) 732-3155',
    population: 1297,
    county: 'LOGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'lincolncollege.edu/',
  },
  {
    name: 'LONG ISLAND BUSINESS INSTITUTE',
    address: '136-18 39TH AVENUE, FIFTH FLOOR',
    city: 'FLUSHING',
    state: 'NY',
    zip: 11354,
    telephone: '(718) 939-5100',
    population: 1297,
    county: 'QUEENS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.libi.edu/',
  },
  {
    name: 'PEIRCE COLLEGE',
    address: '1420 PINE STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19102,
    telephone: '(888) 467-3472',
    population: 1298,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.peirce.edu/',
  },
  {
    name: 'HALIFAX COMMUNITY COLLEGE',
    address: '100 COLLEGE DRIVE',
    city: 'WELDON',
    state: 'NC',
    zip: 27890,
    telephone: '(252) 536-2551',
    population: 1298,
    county: 'HALIFAX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.halifaxcc.edu/',
  },
  {
    name: 'JOHNSON UNIVERSITY',
    address: '7900 JOHNSON DR',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37998,
    telephone: '(865) 573-4517',
    population: 1301,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'johnsonu.edu/',
  },
  {
    name: 'HANOVER COLLEGE',
    address: '517 BALL DRIVE',
    city: 'HANOVER',
    state: 'IN',
    zip: 47243,
    telephone: '(812) 866-7000',
    population: 1304,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hanover.edu/',
  },
  {
    name: 'BELOIT COLLEGE',
    address: '700 COLLEGE ST',
    city: 'BELOIT',
    state: 'WI',
    zip: 53511,
    telephone: '(608) 363-2000',
    population: 1307,
    county: 'ROCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.beloit.edu/',
  },
  {
    name: 'BRIAR CLIFF UNIVERSITY',
    address: '3303 REBECCA STREET',
    city: 'SIOUX CITY',
    state: 'IA',
    zip: 51104,
    telephone: '(712) 279-5321',
    population: 1308,
    county: 'WOODBURY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.briarcliff.edu/',
  },
  {
    name: 'PHILLIPS COMMUNITY COLLEGE OF THE UNIVERSITY OF ARKANSAS',
    address: '1000 CAMPUS DRIVE',
    city: 'HELENA',
    state: 'AR',
    zip: 72342,
    telephone: '(870) 338-6474',
    population: 1309,
    county: 'PHILLIPS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pccua.edu/',
  },
  {
    name: 'COLLEGE OF SAINT MARY',
    address: '7000 MERCY RD.',
    city: 'OMAHA',
    state: 'NE',
    zip: 68106,
    telephone: '(402) 399-2400',
    population: 1313,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csm.edu/',
  },
  {
    name: 'FIELDING GRADUATE UNIVERSITY',
    address: '2020 DE LA VINA ST',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93105,
    telephone: '(805) 687-1099',
    population: 1315,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fielding.edu/',
  },
  {
    name: 'HOWARD PAYNE UNIVERSITY',
    address: '1000 FISK ST.',
    city: 'BROWNWOOD',
    state: 'TX',
    zip: 76801,
    telephone: '(325) 646-2502',
    population: 1315,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hputx.edu/',
  },
  {
    name: 'DEVRY COLLEGE OF NEW YORK',
    address: '180 MADISON AVE., STE. 1200',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10016,
    telephone: '(212) 312-4300',
    population: 1318,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY-MARION CAMPUS',
    address: '1461 MOUNT VERNON AVE',
    city: 'MARION',
    state: 'OH',
    zip: 43302,
    telephone: '(740) 389-6786',
    population: 1322,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'osumarion.osu.edu/',
  },
  {
    name: 'COKER UNIVERSITY',
    address: '300 E COLLEGE AVE',
    city: 'HARTSVILLE',
    state: 'SC',
    zip: 29550,
    telephone: '(843) 383-8000',
    population: 1322,
    county: 'DARLINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://coker.edu/',
  },
  {
    name: 'COOPER UNION FOR THE ADVANCEMENT OF SCIENCE AND ART',
    address: '7 EAST 7TH STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10003,
    telephone: '(212) 353-4100',
    population: 1323,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cooper.edu/',
  },
  {
    name: 'NORTH FLORIDA COLLEGE',
    address: '325 NW TURNER DAVIS DR',
    city: 'MADISON',
    state: 'FL',
    zip: 32340,
    telephone: '(850) 973-2288',
    population: 1323,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nfc.edu/',
  },
  {
    name: 'QUINEBAUG VALLEY COMMUNITY COLLEGE',
    address: '742 UPPER MAPLE ST',
    city: 'DANIELSON',
    state: 'CT',
    zip: 6239,
    telephone: '(860) 932-4000',
    population: 1325,
    county: 'WINDHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://qvcc.edu/',
  },
  {
    name: 'NEW MEXICO STATE UNIVERSITY-CARLSBAD',
    address: '1500 UNIVERSITY DRIVE',
    city: 'CARLSBAD',
    state: 'NM',
    zip: 88220,
    telephone: '(575) 234-9200',
    population: 1325,
    county: 'EDDY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'carlsbad.nmsu.edu/',
  },
  {
    name: 'NEW YORK LAW SCHOOL',
    address: '185 WEST BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10013,
    telephone: '(212) 431-2100',
    population: 1329,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyls.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-GEORGIA',
    address: '5775 PEACHTREE-DUNWOODY ROAD, NE, SUITE A100',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30342,
    telephone: '(404) 250-8500',
    population: 1330,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'FLINT HILLS TECHNICAL COLLEGE',
    address: '3301 W 18TH ST',
    city: 'EMPORIA',
    state: 'KS',
    zip: 66801,
    telephone: '(620) 343-4600 EXT 1300',
    population: 1331,
    county: 'LYON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fhtc.edu/',
  },
  {
    name: 'UNITED EDUCATION INSTITUTE - UEI COLLEGE - PHOENIX',
    address: '9215 N. BLACK CANYON HIGHWAY',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85021,
    telephone: '(623) 888-5261',
    population: 1333,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.uei.edu/',
  },
  {
    name: 'AVE MARIA UNIVERSITY',
    address: '5050 AVE MARIA BLVD',
    city: 'AVE MARIA',
    state: 'FL',
    zip: 34142,
    telephone: '(239) 280-2500',
    population: 1334,
    county: 'COLLIER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.avemaria.edu/',
  },
  {
    name: 'UNITED STATES MERCHANT MARINE ACADEMY',
    address: '300 STEAMBOAT ROAD',
    city: 'KINGS POINT',
    state: 'NY',
    zip: 11024,
    telephone: '(516) 726-5800',
    population: 1336,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usmma.edu/',
  },
  {
    name: 'CLARKSON COLLEGE',
    address: '101 S 42ND ST',
    city: 'OMAHA',
    state: 'NE',
    zip: 68131,
    telephone: '(402) 552-3100',
    population: 1338,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.clarksoncollege.edu/',
  },
  {
    name: 'NORTHWEST UNIVERSITY-COLLEGE OF ADULT AND PROFESSIONAL STUDIES',
    address: '5520 108TH AVE NE',
    city: 'KIRKLAND',
    state: 'WA',
    zip: 98033,
    telephone: '(425) 822-8266',
    population: 1339,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northwestu.edu/',
  },
  {
    name: 'UNIVERSIDAD CENTRAL DE BAYAMON',
    address: 'AVENIDA ZAYA VERDE LA MILAGROSA BARRIO HATO TEJAS',
    city: 'BAYAMÓN',
    state: 'PR',
    zip: 960,
    telephone: '(787) 786-3030 EXT 2100',
    population: 1341,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucb.edu.pr/',
  },
  {
    name: 'HIRAM COLLEGE',
    address: 'NOT AVAILABLE',
    city: 'HIRAM',
    state: 'OH',
    zip: 44234,
    telephone: '(330) 569-3211',
    population: 1343,
    county: 'PORTAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hiram.edu/',
  },
  {
    name: 'PALO ALTO UNIVERSITY',
    address: '1791 ARASTRADERO RD',
    city: 'PALO ALTO',
    state: 'CA',
    zip: 94304,
    telephone: '(800) 818-6136',
    population: 1343,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.paloaltou.edu/',
  },
  {
    name: 'SHAWNEE COMMUNITY COLLEGE',
    address: '8364 SHAWNEE COLLEGE RD',
    city: 'ULLIN',
    state: 'IL',
    zip: 62992,
    telephone: '(618) 634-3200',
    population: 1343,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.shawneecc.edu/',
  },
  {
    name: 'SCRIPPS COLLEGE',
    address: '1030 NORTH COLUMBIA AVENUE',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8000',
    population: 1344,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scrippscollege.edu/',
  },
  {
    name: 'TALLADEGA COLLEGE',
    address: '627 WEST BATTLE STREET',
    city: 'TALLADEGA',
    state: 'AL',
    zip: 35160,
    telephone: '(256) 761-6100',
    population: 1349,
    county: 'TALLADEGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.talladega.edu/',
  },
  {
    name: 'GREENVILLE UNIVERSITY',
    address: '315 E. COLLEGE AVE.',
    city: 'GREENVILLE',
    state: 'IL',
    zip: 62246,
    telephone: '(618) 664-2800',
    population: 1354,
    county: 'BOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.greenville.edu/',
  },
  {
    name: 'GOLDEY-BEACOM COLLEGE',
    address: '4701 LIMESTONE RD',
    city: 'WILMINGTON',
    state: 'DE',
    zip: 19808,
    telephone: '(302) 998-8814',
    population: 1360,
    county: 'NEW CASTLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gbc.edu/',
  },
  {
    name: 'MARS HILL UNIVERSITY',
    address: '100 ATHLETIC ST',
    city: 'MARS HILL',
    state: 'NC',
    zip: 28754,
    telephone: '(828) 689-4968',
    population: 1361,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mhu.edu/',
  },
  {
    name: 'MCMURRY UNIVERSITY',
    address: 'S 14TH AND SAYLES BLVD',
    city: 'ABILENE',
    state: 'TX',
    zip: 79697,
    telephone: '(325) 793-3800',
    population: 1364,
    county: 'TAYLOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ww2.mcm.edu/',
  },
  {
    name: 'MOUNT MARTY UNIVERSITY',
    address: '1105 W. 8TH STREET',
    city: 'YANKTON',
    state: 'SD',
    zip: 57078,
    telephone: '(605) 668-1545',
    population: 1364,
    county: 'YANKTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mountmarty.edu/',
  },
  {
    name: 'WEST VIRGINIA WESLEYAN COLLEGE',
    address: '59 COLLEGE AVE',
    city: 'BUCKHANNON',
    state: 'WV',
    zip: 26201,
    telephone: '(304) 473-8000',
    population: 1364,
    county: 'UPSHUR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvwc.edu/',
  },
  {
    name: 'NEBRASKA METHODIST COLLEGE OF NURSING & ALLIED HEALTH',
    address: '720 NORTH 87TH STREET',
    city: 'OMAHA',
    state: 'NE',
    zip: 68114,
    telephone: '(402) 354-7000',
    population: 1364,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.methodistcollege.edu/',
  },
  {
    name: 'AMERICAN SAMOA COMMUNITY COLLEGE',
    address: 'P.O. BOX 2609',
    city: 'PAGO PAGO',
    state: 'AS',
    zip: 96799,
    telephone: '(684) 699-9155 EXT 370',
    population: 1364,
    county: 'WESTERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.amsamoa.edu/',
  },
  {
    name: 'UNIVERSITY OF HOLY CROSS',
    address: '4123 WOODLAND DRIVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70131,
    telephone: '(504) 394-7744',
    population: 1365,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uhcno.edu/',
  },
  {
    name: 'HOLY NAMES UNIVERSITY',
    address: '3500 MOUNTAIN BLVD',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94619,
    telephone: '(510) 436-1000',
    population: 1368,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hnu.edu/',
  },
  {
    name: 'AMERICAN CAREER COLLEGE-ANAHEIM',
    address: '1200 N. MAGNOLIA AVE.',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92801,
    telephone: '(949) 783-4800',
    population: 1368,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://americancareercollege.edu/',
  },
  {
    name: 'DIGIPEN INSTITUTE OF TECHNOLOGY',
    address: '9931 WILLOWS RD NE',
    city: 'REDMOND',
    state: 'WA',
    zip: 98052,
    telephone: '(425) 558-0299',
    population: 1370,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.digipen.edu/',
  },
  {
    name: 'URSULINE COLLEGE',
    address: '2550 LANDER RD',
    city: 'PEPPER PIKE',
    state: 'OH',
    zip: 44124,
    telephone: '(440) 449-4200',
    population: 1372,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ursuline.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS COMMUNITY COLLEGE-BATESVILLE',
    address: '2005 WHITE DRIVE',
    city: 'BATESVILLE',
    state: 'AR',
    zip: 72503,
    telephone: '(870) 612-2000',
    population: 1373,
    county: 'INDEPENDENCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uaccb.edu/',
  },
  {
    name: 'FRONTIER COMMUNITY COLLEGE',
    address: '2 FRONTIER DRIVE',
    city: 'FAIRFIELD',
    state: 'IL',
    zip: 62837,
    telephone: '(618) 393-2982',
    population: 1373,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iecc.edu/fcc',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-HASTINGS COLLEGE OF LAW',
    address: '200 MCALLISTER STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94102,
    telephone: '(415) 565-4600',
    population: 1374,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uchastings.edu/',
  },
  {
    name: 'OREGON STATE UNIVERSITY-CASCADES CAMPUS',
    address: '1500 SW CHANDLER AVENUE',
    city: 'BEND',
    state: 'OR',
    zip: 97702,
    telephone: '(541) 322-3100',
    population: 1374,
    county: 'DESCHUTES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://osucascades.edu/',
  },
  {
    name: 'CARROLL COLLEGE',
    address: '1601 N BENTON AVE',
    city: 'HELENA',
    state: 'MT',
    zip: 59625,
    telephone: '(406) 447-4300',
    population: 1375,
    county: 'LEWIS AND CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.carroll.edu/',
  },
  {
    name: 'POTOMAC STATE COLLEGE OF WEST VIRGINIA UNIVERSITY',
    address: '101 FORT AVE',
    city: 'KEYSER',
    state: 'WV',
    zip: 26726,
    telephone: '(304) 788-6820',
    population: 1375,
    county: 'MINERAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.potomacstatecollege.edu/',
  },
  {
    name: 'SOUTHERN VIRGINIA UNIVERSITY',
    address: '1 UNIVERSITY HILL DRIVE',
    city: 'BUENA VISTA',
    state: 'VA',
    zip: 24416,
    telephone: '(540) 261-8400',
    population: 1382,
    county: 'BUENA VISTA CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.svu.edu/',
  },
  {
    name: 'NORTHWESTERN CONNECTICUT COMMUNITY COLLEGE',
    address: 'PARK PL E',
    city: 'WINSTED',
    state: 'CT',
    zip: 6098,
    telephone: '(860) 738-6300',
    population: 1382,
    county: 'LITCHFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwcc.commnet.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-MIAMI',
    address: '9250 NW 36TH STREET',
    city: 'DORAL',
    state: 'FL',
    zip: 33178,
    telephone: '(786) 501-7070',
    population: 1383,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'MAYVILLE STATE UNIVERSITY',
    address: '330 THIRD STREET NE',
    city: 'MAYVILLE',
    state: 'ND',
    zip: 58257,
    telephone: '(701) 788-2301',
    population: 1384,
    county: 'TRAILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mayvillestate.edu/',
  },
  {
    name: 'FONTBONNE UNIVERSITY',
    address: '6800 WYDOWN BLVD',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63105,
    telephone: '(314) 862-3456',
    population: 1386,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fontbonne.edu/',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT CHICAGO',
    address: '325 N WELLS STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60654,
    telephone: '(312) 329-6600',
    population: 1386,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/chicago/',
  },
  {
    name: 'ROCKY MOUNTAIN UNIVERSITY OF HEALTH PROFESSIONS',
    address: '122 EAST 1700 SOUTH',
    city: 'PROVO',
    state: 'UT',
    zip: 84606,
    telephone: '(801) 375-5125',
    population: 1388,
    county: 'UTAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rm.edu/',
  },
  {
    name: 'PAUL D CAMP COMMUNITY COLLEGE',
    address: '100 N COLLEGE DR',
    city: 'FRANKLIN',
    state: 'VA',
    zip: 23851,
    telephone: '(757) 569-6700',
    population: 1389,
    county: 'FRANKLIN CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pdc.edu/',
  },
  {
    name: 'TRINITY CHRISTIAN COLLEGE',
    address: '6601 W COLLEGE DR',
    city: 'PALOS HEIGHTS',
    state: 'IL',
    zip: 60463,
    telephone: '(708) 597-3000',
    population: 1390,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.trnty.edu/',
  },
  {
    name: 'MANHATTAN SCHOOL OF MUSIC',
    address: '130 CLAREMONT AVENUE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 749-2802',
    population: 1391,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msmnyc.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS HOPE-TEXARKANA',
    address: '2500 S MAIN',
    city: 'HOPE',
    state: 'AR',
    zip: 71801,
    telephone: '(870) 777-5722',
    population: 1392,
    county: 'HEMPSTEAD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uaht.edu/',
  },
  {
    name: 'NORTHWESTERN HEALTH SCIENCES UNIVERSITY',
    address: '2501 W 84TH ST',
    city: 'BLOOMINGTON',
    state: 'MN',
    zip: 55431,
    telephone: '(952) 888-4777',
    population: 1393,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nwhealth.edu/',
  },
  {
    name: 'LOUISIANA COLLEGE',
    address: '1140 COLLEGE DR',
    city: 'PINEVILLE',
    state: 'LA',
    zip: 71359,
    telephone: '(318) 487-7011',
    population: 1396,
    county: 'RAPIDES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lacollege.edu/',
  },
  {
    name: 'LABOURE COLLEGE',
    address: '303 ADAMS STREET',
    city: 'MILTON',
    state: 'MA',
    zip: 2186,
    telephone: '(617) 296-8300',
    population: 1397,
    county: 'NORFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.laboure.edu/about-labour-',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY THREE RIVERS',
    address: 'ONE COLLEGE CIRCLE',
    city: 'MALVERN',
    state: 'AR',
    zip: 72104,
    telephone: '(501) 337-5000 EXT 1100',
    population: 1397,
    county: 'HOT SPRING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asutr.edu/',
  },
  {
    name: 'LYCOMING COLLEGE',
    address: 'ONE COLLEGE PLACE',
    city: 'WILLIAMSPORT',
    state: 'PA',
    zip: 17701,
    telephone: '(570) 321-4000',
    population: 1400,
    county: 'LYCOMING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lycoming.edu/',
  },
  {
    name: 'WISCONSIN LUTHERAN COLLEGE',
    address: '8800 W BLUEMOUND RD',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53226,
    telephone: '(414) 443-8800',
    population: 1401,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wlc.edu/',
  },
  {
    name: 'UNIVERSITY OF JAMESTOWN',
    address: '608 6TH ST NE',
    city: 'JAMESTOWN',
    state: 'ND',
    zip: 58405,
    telephone: '(701) 252-3467',
    population: 1402,
    county: 'STUTSMAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uj.edu/',
  },
  {
    name: 'MARYVILLE COLLEGE',
    address: '502 E LAMAR ALEXANDER PKWY',
    city: 'MARYVILLE',
    state: 'TN',
    zip: 37804,
    telephone: '(865) 981-8000',
    population: 1402,
    county: 'BLOUNT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.maryvillecollege.edu/',
  },
  {
    name: 'HERITAGE UNIVERSITY',
    address: '3240 FORT RD',
    city: 'TOPPENISH',
    state: 'WA',
    zip: 98948,
    telephone: '(888) 272-6190',
    population: 1403,
    county: 'YAKIMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.heritage.edu/',
  },
  {
    name: 'SOUTHEASTERN ILLINOIS COLLEGE',
    address: '3575 COLLEGE ROAD',
    city: 'HARRISBURG',
    state: 'IL',
    zip: 62946,
    telephone: '(618) 252-5400',
    population: 1404,
    county: 'SALINE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sic.edu/',
  },
  {
    name: "SAINT AUGUSTINE'S UNIVERSITY",
    address: '1315 OAKWOOD AVENUE',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27610,
    telephone: '(919) 516-4000',
    population: 1405,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.st-aug.edu/',
  },
  {
    name: 'SPOON RIVER COLLEGE',
    address: '23235 NORTH COUNTY 22',
    city: 'CANTON',
    state: 'IL',
    zip: 61520,
    telephone: '(309) 647-4645',
    population: 1406,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.src.edu/',
  },
  {
    name: 'CENTRAL METHODIST UNIVERSITY-COLLEGE OF LIBERAL ARTS AND SCIENCES',
    address: '411 CENTRAL METHODIST SQUARE',
    city: 'FAYETTE',
    state: 'MO',
    zip: 65248,
    telephone: '(660) 248-3391',
    population: 1407,
    county: 'HOWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centralmethodist.edu/',
  },
  {
    name: 'SAINT MARY-OF-THE-WOODS COLLEGE',
    address: '1 ST MARY OF WOODS COLL',
    city: 'SAINT MARY OF THE WOODS',
    state: 'IN',
    zip: 47876,
    telephone: '(812) 535-5151',
    population: 1407,
    county: 'VIGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smwc.edu/',
  },
  {
    name: 'PFEIFFER UNIVERSITY',
    address: '48380 US HWY 52N',
    city: 'MISENHEIMER',
    state: 'NC',
    zip: 28109,
    telephone: '(704) 463-1360',
    population: 1411,
    county: 'STANLY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pfeiffer.edu/',
  },
  {
    name: 'CORBAN UNIVERSITY',
    address: '5000 DEER PARK DR SE',
    city: 'SALEM',
    state: 'OR',
    zip: 97317,
    telephone: '(503) 581-8600',
    population: 1411,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.corban.edu/',
  },
  {
    name: 'BROOKLYN LAW SCHOOL',
    address: '250 JORALEMON ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11201,
    telephone: '(718) 625-2200',
    population: 1411,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brooklaw.edu/',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY MID-SOUTH',
    address: '2000 W. BROADWAY',
    city: 'WEST MEMPHIS',
    state: 'AR',
    zip: 72301,
    telephone: '(870) 733-6722',
    population: 1411,
    county: 'CRITTENDEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asumidsouth.edu/',
  },
  {
    name: 'THE COLLEGE OF IDAHO',
    address: '2112 CLEVELAND BLVD',
    city: 'CALDWELL',
    state: 'ID',
    zip: 83605,
    telephone: '(208) 459-5011',
    population: 1414,
    county: 'CANYON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.collegeofidaho.edu/',
  },
  {
    name: 'MILLS COLLEGE',
    address: '5000 MACARTHUR BLVD',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94613,
    telephone: '(510) 430-2255',
    population: 1415,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mills.edu/',
  },
  {
    name: 'UNION COLLEGE',
    address: '310 COLLEGE ST',
    city: 'BARBOURVILLE',
    state: 'KY',
    zip: 40906,
    telephone: '(606) 546-4151',
    population: 1416,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unionky.edu/',
  },
  {
    name: 'NORTHEAST OHIO MEDICAL UNIVERSITY',
    address: '4209 STATE ROUTE 44',
    city: 'ROOTSTOWN',
    state: 'OH',
    zip: 44272,
    telephone: '(800) 686-2511',
    population: 1418,
    county: 'PORTAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neomed.edu/',
  },
  {
    name: 'WILMINGTON COLLEGE',
    address: '1870 QUAKER WAY',
    city: 'WILMINGTON',
    state: 'OH',
    zip: 45177,
    telephone: '(800) 341-9318',
    population: 1420,
    county: 'CLINTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wilmington.edu/',
  },
  {
    name: 'NORTHERN MARIANAS COLLEGE',
    address: 'AS TERLAJE CAMPUS',
    city: 'SAIPAN',
    state: 'MP',
    zip: 96950,
    telephone: '(670) 237-6700',
    population: 1425,
    county: 'SAIPAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marianas.edu/',
  },
  {
    name: 'THADDEUS STEVENS COLLEGE OF TECHNOLOGY',
    address: '750 E KING ST',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17602,
    telephone: '(717) 299-7731',
    population: 1426,
    county: 'LANCASTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stevenscollege.edu/',
  },
  {
    name: 'WOODBURY UNIVERSITY',
    address: '7500 GLENOAKS BLVD',
    city: 'BURBANK',
    state: 'CA',
    zip: 91504,
    telephone: '(818) 767-0888',
    population: 1431,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://woodbury.edu/',
  },
  {
    name: 'BLUEFIELD STATE COLLEGE',
    address: '219 ROCK STREET',
    city: 'BLUEFIELD',
    state: 'WV',
    zip: 24701,
    telephone: '(304) 327-4000',
    population: 1438,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://bluefieldstate.edu/',
  },
  {
    name: 'ILLINOIS COLLEGE',
    address: '1101 WEST COLLEGE AVE',
    city: 'JACKSONVILLE',
    state: 'IL',
    zip: 62650,
    telephone: '(217) 245-3000',
    population: 1438,
    county: 'MORGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ic.edu/',
  },
  {
    name: 'SOUTH ARKANSAS COMMUNITY COLLEGE',
    address: '300 S WEST AVE',
    city: 'EL DORADO',
    state: 'AR',
    zip: 71731,
    telephone: '(870) 862-8131',
    population: 1439,
    county: 'UNION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southark.edu/',
  },
  {
    name: 'WEST VIRGINIA NORTHERN COMMUNITY COLLEGE',
    address: '1704 MARKET ST.',
    city: 'WHEELING',
    state: 'WV',
    zip: 26003,
    telephone: '(304) 233-5900',
    population: 1440,
    county: 'OHIO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wvncc.edu/',
  },
  {
    name: 'BARTON COLLEGE',
    address: '200 E. ACC DRIVE',
    city: 'WILSON',
    state: 'NC',
    zip: 27893,
    telephone: '(252) 399-6300',
    population: 1445,
    county: 'WILSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.barton.edu/',
  },
  {
    name: 'KIRTLAND COMMUNITY COLLEGE',
    address: '4800 W 4 MILE ROAD',
    city: 'GRAYLING',
    state: 'MI',
    zip: 49738,
    telephone: '(989) 275-5000',
    population: 1446,
    county: 'CRAWFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kirtland.edu/',
  },
  {
    name: 'HENDERSON COMMUNITY COLLEGE',
    address: '2660 S GREEN ST',
    city: 'HENDERSON',
    state: 'KY',
    zip: 42420,
    telephone: '(270) 827-1867',
    population: 1447,
    county: 'HENDERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://henderson.kctcs.edu/',
  },
  {
    name: 'ALBANY COLLEGE OF PHARMACY AND HEALTH SCIENCES',
    address: '106 NEW SCOTLAND AVENUE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12208,
    telephone: '(518) 694-7200',
    population: 1450,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acphs.edu/',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY-MOUNTAIN HOME',
    address: '1600 SOUTH COLLEGE STREET',
    city: 'MOUNTAIN HOME',
    state: 'AR',
    zip: 72653,
    telephone: '(870) 508-6100',
    population: 1451,
    county: 'BAXTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asumh.edu/',
  },
  {
    name: 'OGLALA LAKOTA COLLEGE',
    address: '490 PIYA WICONI ROAD',
    city: 'KYLE',
    state: 'SD',
    zip: 57752,
    telephone: '(605) 455-6000',
    population: 1455,
    county: 'OGLALA LAKOTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.olc.edu/',
  },
  {
    name: 'HELENA COLLEGE UNIVERSITY OF MONTANA',
    address: '1115 N ROBERTS STREET',
    city: 'HELENA',
    state: 'MT',
    zip: 59601,
    telephone: '(406) 447-6900',
    population: 1456,
    county: 'LEWIS AND CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.helenacollege.edu/',
  },
  {
    name: 'BIRMINGHAM-SOUTHERN COLLEGE',
    address: '900 ARKADELPHIA ROAD',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35254,
    telephone: '(205) 226-4600',
    population: 1457,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bsc.edu/',
  },
  {
    name: 'COLBY COMMUNITY COLLEGE',
    address: '1255 S RANGE',
    city: 'COLBY',
    state: 'KS',
    zip: 67701,
    telephone: '(785) 462-3984',
    population: 1457,
    county: 'THOMAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.colbycc.edu/',
  },
  {
    name: 'NICOLET AREA TECHNICAL COLLEGE',
    address: '5364 COLLEGE DRIVE',
    city: 'RHINELANDER',
    state: 'WI',
    zip: 54501,
    telephone: '(715) 365-4410',
    population: 1458,
    county: 'ONEIDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nicoletcollege.edu/',
  },
  {
    name: 'COLLEGE OF THE MARSHALL ISLANDS',
    address: 'OCEANSIDE ULIGA - PO BOX 1258',
    city: 'MAJURO',
    state: 'MH',
    zip: 96960,
    telephone: '(692) 625-3394 EXT 236',
    population: 1460,
    county: 'NOT AVAILABLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cmi.edu/',
  },
  {
    name: 'CONCORDIA COLLEGE',
    address: '171 WHITE PLAINS RD',
    city: 'BRONXVILLE',
    state: 'NY',
    zip: 10708,
    telephone: '(914) 337-9300',
    population: 1462,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.concordia-ny.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-ANN ARBOR',
    address: '4090 GEDDES RD',
    city: 'ANN ARBOR',
    state: 'MI',
    zip: 48105,
    telephone: '(734) 995-7300',
    population: 1466,
    county: 'WASHTENAW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cuaa.edu/',
  },
  {
    name: 'CAIRN UNIVERSITY-LANGHORNE',
    address: '200 MANOR AVE',
    city: 'LANGHORNE',
    state: 'PA',
    zip: 19047,
    telephone: '(215) 752-5800',
    population: 1467,
    county: 'BUCKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cairn.edu/',
  },
  {
    name: 'AGNES SCOTT COLLEGE',
    address: '141 E. COLLEGE AVE.',
    city: 'DECATUR',
    state: 'GA',
    zip: 30030,
    telephone: '(404) 471-6000',
    population: 1468,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.agnesscott.edu/',
  },
  {
    name: 'MOUNTWEST COMMUNITY AND TECHNICAL COLLEGE',
    address: 'ONE MOUNTWEST WAY',
    city: 'HUNTINGTON',
    state: 'WV',
    zip: 25701,
    telephone: '(866) 710-3140',
    population: 1468,
    county: 'CABELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mctc.edu/',
  },
  {
    name: 'ROCHESTER UNIVERSITY',
    address: '800 WEST AVON ROAD',
    city: 'ROCHESTER HILLS',
    state: 'MI',
    zip: 48307,
    telephone: '(248) 218-2011',
    population: 1471,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'rochesteru.edu/',
  },
  {
    name: 'SPRING HILL COLLEGE',
    address: '4000 DAUPHIN ST',
    city: 'MOBILE',
    state: 'AL',
    zip: 36608,
    telephone: '(251) 380-4000',
    population: 1474,
    county: 'MOBILE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shc.edu/',
  },
  {
    name: 'WESTERN DAKOTA TECHNICAL COLLEGE',
    address: '800 MICKELSON DR',
    city: 'RAPID CITY',
    state: 'SD',
    zip: 57703,
    telephone: '(605) 718-2400',
    population: 1474,
    county: 'PENNINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wdt.edu/',
  },
  {
    name: 'CLARENDON COLLEGE',
    address: '1122 COLLEGE DRIVE',
    city: 'CLARENDON',
    state: 'TX',
    zip: 79226,
    telephone: '(806) 874-3571 EXT 107',
    population: 1477,
    county: 'DONLEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clarendoncollege.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-BARRANQUITAS',
    address: 'BO HELECHAL HIGHWAY 156 INTERSECTION 719',
    city: 'BARRANQUITAS',
    state: 'PR',
    zip: 794,
    telephone: '(787) 857-3600 EXT 2011',
    population: 1480,
    county: 'BARRANQUITAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.br.inter.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE',
    address: '1301 COLUMBIA COLLEGE DR',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29203,
    telephone: '(803) 786-3012',
    population: 1480,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbiasc.edu/',
  },
  {
    name: 'NORTHERN NEW MEXICO COLLEGE',
    address: '921 PASEO DE ONATE',
    city: 'ESPANOLA',
    state: 'NM',
    zip: 87532,
    telephone: '(505) 747-2100',
    population: 1481,
    county: 'RIO ARRIBA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'nnmc.edu/',
  },
  {
    name: 'SOUTHERN CALIFORNIA UNIVERSITY OF HEALTH SCIENCES',
    address: '16200 EAST AMBER VALLEY DRIVE',
    city: 'WHITTIER',
    state: 'CA',
    zip: 90604,
    telephone: '(562) 947-8755',
    population: 1481,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scuhs.edu/',
  },
  {
    name: 'PONCE HEALTH SCIENCES UNIVERSITY',
    address: '388 CALLE LUIS F. SALA',
    city: 'PONCE',
    state: 'PR',
    zip: 716,
    telephone: '(575) 575-2575 EXT 02575',
    population: 1487,
    county: 'PONCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.psm.edu/',
  },
  {
    name: 'WESTERN TECHNICAL COLLEGE',
    address: '9624 PLAZA CIRCLE',
    city: 'EL PASO',
    state: 'TX',
    zip: 79927,
    telephone: '(915) 532-3737',
    population: 1489,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.westerntech.edu/',
  },
  {
    name: 'CHARLES R DREW UNIVERSITY OF MEDICINE AND SCIENCE',
    address: '1731 E 120TH ST',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90059,
    telephone: '(323) 563-4800',
    population: 1490,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cdrewu.edu/',
  },
  {
    name: 'HENDRIX COLLEGE',
    address: '1600 WASHINGTON AVE',
    city: 'CONWAY',
    state: 'AR',
    zip: 72032,
    telephone: '(501) 329-6811',
    population: 1492,
    county: 'FAULKNER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hendrix.edu/',
  },
  {
    name: 'NEWBERRY COLLEGE',
    address: '2100 COLLEGE ST',
    city: 'NEWBERRY',
    state: 'SC',
    zip: 29108,
    telephone: '(803) 276-5010',
    population: 1492,
    county: 'NEWBERRY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newberry.edu/',
  },
  {
    name: 'NORTHEASTERN JUNIOR COLLEGE',
    address: '100 COLLEGE AVENUE',
    city: 'STERLING',
    state: 'CO',
    zip: 80751,
    telephone: '(970) 521-6600',
    population: 1493,
    county: 'LOGAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.njc.edu/',
  },
  {
    name: 'WASHINGTON COLLEGE',
    address: '300 WASHINGTON AVE',
    city: 'CHESTERTOWN',
    state: 'MD',
    zip: 21620,
    telephone: '(410) 778-2800',
    population: 1497,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.washcoll.edu/',
  },
  {
    name: 'QUINCY UNIVERSITY',
    address: '1800 COLLEGE AVE',
    city: 'QUINCY',
    state: 'IL',
    zip: 62301,
    telephone: '(217) 222-8020',
    population: 1498,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.quincy.edu/',
  },
  {
    name: 'COLLEGE OF THE SISKIYOUS',
    address: '800 COLLEGE AVE',
    city: 'WEED',
    state: 'CA',
    zip: 96094,
    telephone: '(530) 938-5555',
    population: 1499,
    county: 'SISKIYOU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.siskiyous.edu/',
  },
  {
    name: 'DILLARD UNIVERSITY',
    address: '2601 GENTILLY BLVD',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70122,
    telephone: '(504) 816-4768',
    population: 1501,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dillard.edu/',
  },
  {
    name: 'SCHREINER UNIVERSITY',
    address: '2100 MEMORIAL BLVD',
    city: 'KERRVILLE',
    state: 'TX',
    zip: 78028,
    telephone: '(800) 343-4919',
    population: 1502,
    county: 'KERR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.schreiner.edu/',
  },
  {
    name: 'THOMAS UNIVERSITY',
    address: '1501 MILLPOND RD',
    city: 'THOMASVILLE',
    state: 'GA',
    zip: 31792,
    telephone: '(800) 538-9784 EXT 1000',
    population: 1502,
    county: 'THOMAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.thomasu.edu/',
  },
  {
    name: 'HIGHLAND COMMUNITY COLLEGE',
    address: '2998 W PEARL CITY RD',
    city: 'FREEPORT',
    state: 'IL',
    zip: 61032,
    telephone: '(815) 235-6121',
    population: 1503,
    county: 'STEPHENSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.highland.edu/',
  },
  {
    name: 'UNIVERSITY OF SAINT MARY',
    address: '4100 S 4TH ST',
    city: 'LEAVENWORTH',
    state: 'KS',
    zip: 66048,
    telephone: '(913) 682-5151',
    population: 1504,
    county: 'LEAVENWORTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stmary.edu/',
  },
  {
    name: 'HEIDELBERG UNIVERSITY',
    address: '310 E MARKET ST',
    city: 'TIFFIN',
    state: 'OH',
    zip: 44883,
    telephone: '(419) 448-2000',
    population: 1507,
    county: 'SENECA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.heidelberg.edu/',
  },
  {
    name: 'LOURDES UNIVERSITY',
    address: '6832 CONVENT BLVD',
    city: 'SYLVANIA',
    state: 'OH',
    zip: 43560,
    telephone: '(419) 885-3211',
    population: 1508,
    county: 'LUCAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lourdes.edu/',
  },
  {
    name: 'UNIVERSITY OF PITTSBURGH-BRADFORD',
    address: '300 CAMPUS DRIVE',
    city: 'BRADFORD',
    state: 'PA',
    zip: 16701,
    telephone: '(814) 362-7500',
    population: 1511,
    county: 'MCKEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upb.pitt.edu/',
  },
  {
    name: 'DEAN COLLEGE',
    address: '99 MAIN STREET',
    city: 'FRANKLIN',
    state: 'MA',
    zip: 2038,
    telephone: '(508) 541-1900',
    population: 1511,
    county: 'NORFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dean.edu/',
  },
  {
    name: 'OKLAHOMA PANHANDLE STATE UNIVERSITY',
    address: '323 EAGLE AVE',
    city: 'GOODWELL',
    state: 'OK',
    zip: 73939,
    telephone: '(580) 349-2611',
    population: 1512,
    county: 'TEXAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.opsu.edu/',
  },
  {
    name: 'CONCORDE CAREER COLLEGE-MEMPHIS',
    address: '5100 POPLAR AVENUE, SUITE 132',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38137,
    telephone: '(901) 761-9494',
    population: 1513,
    county: 'SHELBY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.concorde.edu/campus/memphis-tennessee',
  },
  {
    name: 'ASNUNTUCK COMMUNITY COLLEGE',
    address: '170 ELM ST',
    city: 'ENFIELD',
    state: 'CT',
    zip: 6082,
    telephone: '(860) 253-3000',
    population: 1514,
    county: 'HARTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asnuntuck.edu/',
  },
  {
    name: 'UNIVERSITY OF TEXAS HEALTH SCIENCE CENTER AT TYLER',
    address: '11937 US HIGHWAY 271',
    city: 'TYLER',
    state: 'TX',
    zip: 75708,
    telephone: '(903) 877-7777',
    population: 1515,
    county: 'SMITH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uthct.edu/',
  },
  {
    name: 'UNIVERSITY OF WESTERN STATES',
    address: '8000 NE TILLAMOOK STREET',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97213,
    telephone: '(503) 256-3180',
    population: 1516,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uws.edu/',
  },
  {
    name: 'DUNWOODY COLLEGE OF TECHNOLOGY',
    address: '818 DUNWOODY BLVD',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55403,
    telephone: '(612) 374-5800',
    population: 1524,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dunwoody.edu/',
  },
  {
    name: 'MOUNT MARY UNIVERSITY',
    address: '2900 N. MENOMONEE RIVER PKY',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53222,
    telephone: '(414) 930-3000',
    population: 1525,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtmary.edu/',
  },
  {
    name: 'MORGAN COMMUNITY COLLEGE',
    address: '920 BARLOW ROAD',
    city: 'FORT MORGAN',
    state: 'CO',
    zip: 80701,
    telephone: '(970) 542-3100',
    population: 1528,
    county: 'MORGAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.morgancc.edu/',
  },
  {
    name: 'OTERO JUNIOR COLLEGE',
    address: '1802 COLORADO AVE',
    city: 'LA JUNTA',
    state: 'CO',
    zip: 81050,
    telephone: '(719) 384-6823',
    population: 1529,
    county: 'OTERO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ojc.edu/',
  },
  {
    name: 'AMERICAN CAREER COLLEGE-ONTARIO',
    address: '3130 EAST SEDONA COURT',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91764,
    telephone: '(949) 783-4800',
    population: 1535,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://americancareercollege.edu/',
  },
  {
    name: 'JUDSON UNIVERSITY',
    address: '1151 N STATE ST',
    city: 'ELGIN',
    state: 'IL',
    zip: 60123,
    telephone: '(847) 628-2500',
    population: 1536,
    county: 'KANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.judsonu.edu/',
  },
  {
    name: 'WESTMINSTER COLLEGE',
    address: '319 SOUTH MARKET STREET',
    city: 'NEW WILMINGTON',
    state: 'PA',
    zip: 16172,
    telephone: '(724) 946-8761',
    population: 1536,
    county: 'LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westminster.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-SUMTER',
    address: '200 MILLER RD',
    city: 'SUMTER',
    state: 'SC',
    zip: 29150,
    telephone: '(803) 775-8727',
    population: 1536,
    county: 'SUMTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sc.edu/about/system_and_campuses/sumter/index.php',
  },
  {
    name: 'BLACK RIVER TECHNICAL COLLEGE',
    address: '1410 HWY 304 EAST',
    city: 'POCAHONTAS',
    state: 'AR',
    zip: 72455,
    telephone: '(870) 248-4000',
    population: 1538,
    county: 'RANDOLPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.blackrivertech.edu/',
  },
  {
    name: 'COFFEYVILLE COMMUNITY COLLEGE',
    address: '400 W 11TH ST',
    city: 'COFFEYVILLE',
    state: 'KS',
    zip: 67337,
    telephone: '(620) 251-7700',
    population: 1539,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coffeyville.edu/',
  },
  {
    name: 'MGH INSTITUTE OF HEALTH PROFESSIONS',
    address: '36 1ST AVENUE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2129,
    telephone: '(617) 726-2947',
    population: 1542,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mghihp.edu/',
  },
  {
    name: 'ROXBURY COMMUNITY COLLEGE',
    address: '1234 COLUMBUS AVE',
    city: 'ROXBURY CROSSING',
    state: 'MA',
    zip: 2120,
    telephone: '(617) 427-0060',
    population: 1543,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rcc.mass.edu/',
  },
  {
    name: 'EDP UNIVERSITY OF PUERTO RICO INC-SAN JUAN',
    address: '560 PONCE DE LEON AVE. CR. ARROYO ST.',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 919,
    telephone: '(787) 765-3560 EXT 1240',
    population: 1544,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edpuniversity.edu/',
  },
  {
    name: 'GEORGE C WALLACE STATE COMMUNITY COLLEGE-SELMA',
    address: '3000 EARL GOODWIN PARKWAY',
    city: 'SELMA',
    state: 'AL',
    zip: 36703,
    telephone: '(334) 876-9227',
    population: 1544,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wccs.edu/',
  },
  {
    name: 'BRYAN UNIVERSITY',
    address: '350 W WASHINGTON ST',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85281,
    telephone: '(602) 384-2555',
    population: 1545,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'bryanuniversity.edu/',
  },
  {
    name: 'HARCUM COLLEGE',
    address: '750 MONTGOMERY AVE',
    city: 'BRYN MAWR',
    state: 'PA',
    zip: 19010,
    telephone: '(610) 525-4100',
    population: 1546,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.harcum.edu/s/1044/edu/start.aspx',
  },
  {
    name: 'FRANCISCAN MISSIONARIES OF OUR LADY UNIVERSITY',
    address: '5414 BRITTANY DR',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70808,
    telephone: '(225) 768-1700',
    population: 1548,
    county: 'EAST BATON ROUGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.franu.edu/',
  },
  {
    name: 'CENTRAL COLLEGE',
    address: '812 UNIVERSITY',
    city: 'PELLA',
    state: 'IA',
    zip: 50219,
    telephone: '(877) 462-3687',
    population: 1549,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.central.edu/',
  },
  {
    name: 'WASHINGTON & JEFFERSON COLLEGE',
    address: '60 S LINCOLN ST',
    city: 'WASHINGTON',
    state: 'PA',
    zip: 15301,
    telephone: '(724) 503-1001',
    population: 1553,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.washjeff.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW MEXICO-VALENCIA COUNTY CAMPUS',
    address: '280 LA ENTRADA',
    city: 'LOS LUNAS',
    state: 'NM',
    zip: 87031,
    telephone: '(505) 925-8500',
    population: 1556,
    county: 'VALENCIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'valencia.unm.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-TEXAS',
    address: '11025 EQUITY DRIVE',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77041,
    telephone: '(713) 277-9800',
    population: 1558,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'BLUE MOUNTAIN COMMUNITY COLLEGE',
    address: '2411 NW CARDEN AVE',
    city: 'PENDLETON',
    state: 'OR',
    zip: 97801,
    telephone: '(541) 276-1260',
    population: 1558,
    county: 'UMATILLA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bluecc.edu/',
  },
  {
    name: 'PACIFIC OAKS COLLEGE',
    address: '45 W EUREKA STREET',
    city: 'PASADENA',
    state: 'CA',
    zip: 91103,
    telephone: '(877) 314-2380',
    population: 1561,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pacificoaks.edu/',
  },
  {
    name: 'INSTITUTE OF TECHNOLOGY',
    address: '564 W HERNDON',
    city: 'CLOVIS',
    state: 'CA',
    zip: 93612,
    telephone: '(559) 297-4500',
    population: 1561,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iot.edu/',
  },
  {
    name: 'UNITED STATES COAST GUARD ACADEMY',
    address: '15 MOHEGAN AVENUE',
    city: 'NEW LONDON',
    state: 'CT',
    zip: 6320,
    telephone: '(860) 444-8444',
    population: 1562,
    county: 'NEW LONDON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uscga.edu/',
  },
  {
    name: 'WESTERN OKLAHOMA STATE COLLEGE',
    address: '2801 N MAIN ST',
    city: 'ALTUS',
    state: 'OK',
    zip: 73521,
    telephone: '(580) 477-2000',
    population: 1562,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wosc.edu/',
  },
  {
    name: 'ROCKFORD UNIVERSITY',
    address: '5050 E STATE ST',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61108,
    telephone: '(815) 226-4186',
    population: 1563,
    county: 'WINNEBAGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rockford.edu/',
  },
  {
    name: 'THE UNIVERSITY OF MONTANA-WESTERN',
    address: '710 S ATLANTIC',
    city: 'DILLON',
    state: 'MT',
    zip: 59725,
    telephone: '(406) 683-7011',
    population: 1563,
    county: 'BEAVERHEAD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'w.umwestern.edu/',
  },
  {
    name: 'COSSATOT COMMUNITY COLLEGE OF THE UNIVERSITY OF ARKANSAS',
    address: '183 COLLEGE DRIVE',
    city: 'DE QUEEN',
    state: 'AR',
    zip: 71832,
    telephone: '(870) 584-4471',
    population: 1563,
    county: 'SEVIER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cccua.edu/',
  },
  {
    name: 'EASTERN OKLAHOMA STATE COLLEGE',
    address: '1301 W MAIN ST',
    city: 'WILBURTON',
    state: 'OK',
    zip: 74578,
    telephone: '(918) 465-2361',
    population: 1569,
    county: 'LATIMER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eosc.edu/',
  },
  {
    name: 'AMERICAN INTERCONTINENTAL UNIVERSITY-ATLANTA',
    address: '6600 PEACHTREE DUNWOODY ROAD, 500 EMBASSY ROW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30328,
    telephone: '(404) 965-6500 EXT 8118',
    population: 1570,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aiuniv.edu/online-campus/campus-locations/atlanta',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-GRAND PRAIRIE',
    address: '2915 ALOUETTE DRIVE',
    city: 'GRAND PRAIRIE',
    state: 'TX',
    zip: 75052,
    telephone: '(972) 660-5701 EXT 41100',
    population: 1571,
    county: 'TARRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/grand-prairie-tx',
  },
  {
    name: 'MASSACHUSETTS COLLEGE OF LIBERAL ARTS',
    address: '375 CHURCH STREET',
    city: 'NORTH ADAMS',
    state: 'MA',
    zip: 1247,
    telephone: '(413) 662-5000',
    population: 1575,
    county: 'BERKSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mcla.edu/',
  },
  {
    name: 'SAUK VALLEY COMMUNITY COLLEGE',
    address: '173 ILLINOIS RT 2',
    city: 'DIXON',
    state: 'IL',
    zip: 61021,
    telephone: '(815) 288-5511',
    population: 1578,
    county: 'LEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.svcc.edu/',
  },
  {
    name: 'SAINT ELIZABETH UNIVERSITY',
    address: '2 CONVENT ROAD',
    city: 'MORRISTOWN',
    state: 'NJ',
    zip: 7960,
    telephone: '(973) 290-4000',
    population: 1580,
    county: 'MORRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.steu.edu/',
  },
  {
    name: 'HOPE INTERNATIONAL UNIVERSITY',
    address: '2500 E NUTWOOD AVE',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92831,
    telephone: '(714) 879-3901',
    population: 1580,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hiu.edu/',
  },
  {
    name: 'ARKANSAS NORTHEASTERN COLLEGE',
    address: '2501 S DIVISION',
    city: 'BLYTHEVILLE',
    state: 'AR',
    zip: 72316,
    telephone: '(870) 762-1020 EXT 1114',
    population: 1580,
    county: 'MISSISSIPPI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.anc.edu/',
  },
  {
    name: 'HARTWICK COLLEGE',
    address: 'ONE HARTWICK DRIVE',
    city: 'ONEONTA',
    state: 'NY',
    zip: 13820,
    telephone: '(607) 431-4000',
    population: 1581,
    county: 'OTSEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hartwick.edu/',
  },
  {
    name: 'SOFIA UNIVERSITY',
    address: '1069 EAST MEADOW CR',
    city: 'PALO ALTO',
    state: 'CA',
    zip: 94303,
    telephone: '(650) 493-4430',
    population: 1582,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sofia.edu/',
  },
  {
    name: 'CHATTAHOOCHEE VALLEY COMMUNITY COLLEGE',
    address: '2602 COLLEGE DRIVE',
    city: 'PHENIX CITY',
    state: 'AL',
    zip: 36869,
    telephone: '(334) 291-4900',
    population: 1583,
    county: 'RUSSELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cv.edu/',
  },
  {
    name: 'NORTHWEST UNIVERSITY',
    address: '5520 108TH AVE NE',
    city: 'KIRKLAND',
    state: 'WA',
    zip: 98083,
    telephone: '(425) 822-8266',
    population: 1585,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northwestu.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA SCHOOL OF THE ARTS',
    address: '1533 SOUTH MAIN ST.',
    city: 'WINSTON SALEM',
    state: 'NC',
    zip: 27127,
    telephone: '(336) 770-3399',
    population: 1586,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uncsa.edu/',
  },
  {
    name: 'NIGHTINGALE COLLEGE',
    address: '175 S MAIN ST SUITE 400',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84111,
    telephone: '(801) 689-2160',
    population: 1593,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nightingale.edu/',
  },
  {
    name: 'UNIVERSITY OF PITTSBURGH-GREENSBURG',
    address: '150 FINOLI DRIVE',
    city: 'GREENSBURG',
    state: 'PA',
    zip: 15601,
    telephone: '(724) 837-7040',
    population: 1595,
    county: 'WESTMORELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.greensburg.pitt.edu/',
  },
  {
    name: 'KNOX COLLEGE',
    address: '2 E SOUTH ST',
    city: 'GALESBURG',
    state: 'IL',
    zip: 61401,
    telephone: '(309) 341-7000',
    population: 1597,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.knox.edu/',
  },
  {
    name: 'CONVERSE COLLEGE',
    address: '580 E MAIN ST',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29302,
    telephone: '(864) 596-9000',
    population: 1602,
    county: 'SPARTANBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.converse.edu/',
  },
  {
    name: 'SIMPSON COLLEGE',
    address: '701 NORTH C ST',
    city: 'INDIANOLA',
    state: 'IA',
    zip: 50125,
    telephone: '(515) 961-6251',
    population: 1605,
    county: 'WARREN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'simpson.edu/',
  },
  {
    name: 'WILLIAM PENN UNIVERSITY',
    address: '201 TRUEBLOOD AVE',
    city: 'OSKALOOSA',
    state: 'IA',
    zip: 52577,
    telephone: '(641) 673-1001',
    population: 1605,
    county: 'MAHASKA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wmpenn.edu/',
  },
  {
    name: 'MIDWAY UNIVERSITY',
    address: '512 E. STEPHENS ST',
    city: 'MIDWAY',
    state: 'KY',
    zip: 40347,
    telephone: '(859) 846-4421',
    population: 1606,
    county: 'WOODFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.midway.edu/',
  },
  {
    name: 'EMORY & HENRY COLLEGE',
    address: '30461 GARNAND DRIVE',
    city: 'EMORY',
    state: 'VA',
    zip: 24327,
    telephone: '(276) 944-4121',
    population: 1607,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ehc.edu/',
  },
  {
    name: 'SHAW UNIVERSITY',
    address: '118 EAST SOUTH STREET',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27601,
    telephone: '(919) 546-8200',
    population: 1609,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shawu.edu/',
  },
  {
    name: 'JAMES SPRUNT COMMUNITY COLLEGE',
    address: '133 JAMES SPRUNT DRIVE',
    city: 'KENANSVILLE',
    state: 'NC',
    zip: 28349,
    telephone: '(910) 296-2400',
    population: 1610,
    county: 'DUPLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jamessprunt.edu/',
  },
  {
    name: 'SOUTHERN WESLEYAN UNIVERSITY',
    address: '907 WESLEYAN DRIVE',
    city: 'CENTRAL',
    state: 'SC',
    zip: 29630,
    telephone: '(864) 644-5000',
    population: 1614,
    county: 'PICKENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swu.edu/',
  },
  {
    name: 'PIEDMONT COMMUNITY COLLEGE',
    address: '1715 COLLEGE DR',
    city: 'ROXBORO',
    state: 'NC',
    zip: 27573,
    telephone: '(336) 599-1181',
    population: 1614,
    county: 'PERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.piedmontcc.edu/',
  },
  {
    name: 'MONTCALM COMMUNITY COLLEGE',
    address: '2800 COLLEGE DR.',
    city: 'SIDNEY',
    state: 'MI',
    zip: 48885,
    telephone: '(989) 328-2111',
    population: 1617,
    county: 'MONTCALM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.montcalm.edu/',
  },
  {
    name: 'ALPENA COMMUNITY COLLEGE',
    address: '665 JOHNSON ST',
    city: 'ALPENA',
    state: 'MI',
    zip: 49707,
    telephone: '(989) 356-9021',
    population: 1618,
    county: 'ALPENA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alpenacc.edu/',
  },
  {
    name: 'COLUMBIA-GREENE COMMUNITY COLLEGE',
    address: '4400 ROUTE 23',
    city: 'HUDSON',
    state: 'NY',
    zip: 12534,
    telephone: '(518) 828-4181',
    population: 1618,
    county: 'COLUMBIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sunycgcc.edu/',
  },
  {
    name: 'JOHNSON & WALES UNIVERSITY-CHARLOTTE',
    address: 'ACADEMIC CENTER, 801 WEST TRADE STREET',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28202,
    telephone: '(866) 598-2427',
    population: 1621,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jwu.edu/campuses/charlotte/index.html',
  },
  {
    name: 'WESTMONT COLLEGE',
    address: '955 LA PAZ RD',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93108,
    telephone: '(805) 565-6000',
    population: 1623,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westmont.edu/',
  },
  {
    name: 'SALUS UNIVERSITY',
    address: '8360 OLD YORK RD',
    city: 'ELKINS PARK',
    state: 'PA',
    zip: 19027,
    telephone: '(215) 780-1400',
    population: 1624,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.salus.edu/',
  },
  {
    name: 'AUSTIN COLLEGE',
    address: '900 N GRAND AVE',
    city: 'SHERMAN',
    state: 'TX',
    zip: 75090,
    telephone: '(903) 813-2000',
    population: 1625,
    county: 'GRAYSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.austincollege.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-DENVER',
    address: '11194 E 45TH AVE',
    city: 'DENVER',
    state: 'CO',
    zip: 80239,
    telephone: '(303) 722-5724 EXT 43000',
    population: 1627,
    county: 'DENVER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/denver-co',
  },
  {
    name: 'TROCAIRE COLLEGE',
    address: '360 CHOATE AVE',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14220,
    telephone: '(716) 826-1200',
    population: 1629,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://trocaire.edu/',
  },
  {
    name: 'OAKLAND CITY UNIVERSITY',
    address: '138 N LUCRETIA ST',
    city: 'OAKLAND CITY',
    state: 'IN',
    zip: 47660,
    telephone: '(800) 737-5125',
    population: 1630,
    county: 'GIBSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oak.edu/',
  },
  {
    name: 'NORTHEASTERN TECHNICAL COLLEGE',
    address: '1201 CHESTERFIELD HWY.',
    city: 'CHERAW',
    state: 'SC',
    zip: 29520,
    telephone: '(843) 921-6900',
    population: 1630,
    county: 'CHESTERFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.netc.edu/',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF THE ARTS',
    address: '24700 W MCBEAN PKY',
    city: 'VALENCIA',
    state: 'CA',
    zip: 91355,
    telephone: '(661) 255-1050',
    population: 1634,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.calarts.edu/',
  },
  {
    name: 'EASTERN WYOMING COLLEGE',
    address: '3200 WEST C ST',
    city: 'TORRINGTON',
    state: 'WY',
    zip: 82240,
    telephone: '(307) 532-8200',
    population: 1641,
    county: 'GOSHEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ewc.wy.edu/',
  },
  {
    name: 'PRESBYTERIAN COLLEGE',
    address: '503 SOUTH BROAD STREET',
    city: 'CLINTON',
    state: 'SC',
    zip: 29325,
    telephone: '(864) 833-2820',
    population: 1644,
    county: 'LAURENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.presby.edu/',
  },
  {
    name: 'MILLIGAN UNIVERSITY',
    address: '1 BLOWERS BLVD.',
    city: 'MILLIGAN',
    state: 'TN',
    zip: 37682,
    telephone: '(423) 461-8700',
    population: 1646,
    county: 'CARTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.milligan.edu/',
  },
  {
    name: 'KAUAI COMMUNITY COLLEGE',
    address: '3-1901 KAUMUALII HIGHWAY',
    city: 'LIHUE',
    state: 'HI',
    zip: 96766,
    telephone: '(808) 245-8311',
    population: 1649,
    county: 'KAUAI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.kauai.hawaii.edu/',
  },
  {
    name: 'UNIVERSITY OF MAINE AT PRESQUE ISLE',
    address: '181 MAIN ST',
    city: 'PRESQUE ISLE',
    state: 'ME',
    zip: 4769,
    telephone: '(207) 768-9400',
    population: 1650,
    county: 'AROOSTOOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umpi.edu/',
  },
  {
    name: 'GORDON-CONWELL THEOLOGICAL SEMINARY',
    address: '130 ESSEX ST',
    city: 'SOUTH HAMILTON',
    state: 'MA',
    zip: 1982,
    telephone: '(978) 468-7111',
    population: 1651,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gordonconwell.edu/',
  },
  {
    name: 'AMERITECH COLLEGE-DRAPER',
    address: '12257 SOUTH BUSINESS PARK DRIVE-STE 100',
    city: 'DRAPER',
    state: 'UT',
    zip: 84020,
    telephone: '(801) 816-1444',
    population: 1651,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ameritech.edu/',
  },
  {
    name: 'SOUTHERN WEST VIRGINIA COMMUNITY AND TECHNICAL COLLEGE',
    address: 'DEMPSEY BRANCH ROAD',
    city: 'MOUNT GAY',
    state: 'WV',
    zip: 25637,
    telephone: '(304) 896-7098',
    population: 1652,
    county: 'LOGAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.southernwv.edu/',
  },
  {
    name: 'SEMINOLE STATE COLLEGE',
    address: '2701 BOREN BLVD',
    city: 'SEMINOLE',
    state: 'OK',
    zip: 74868,
    telephone: '(405) 382-9950',
    population: 1652,
    county: 'SEMINOLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sscok.edu/',
  },
  {
    name: 'LA ROCHE UNIVERSITY',
    address: '9000 BABCOCK BLVD',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15237,
    telephone: '(412) 367-9300',
    population: 1660,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.laroche.edu/',
  },
  {
    name: 'VIRGINIA WESLEYAN UNIVERSITY',
    address: '5817 WESLEYAN DRIVE',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23455,
    telephone: '(757) 455-3200',
    population: 1660,
    county: 'NORFOLK CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.vwu.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-DALLAS',
    address: '8435 NORTH STEMMONS FREEWAY',
    city: 'DALLAS',
    state: 'TX',
    zip: 75247,
    telephone: '(214) 453-4533',
    population: 1661,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'THE JUILLIARD SCHOOL',
    address: '60 LINCOLN CENTER PLAZA',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10023,
    telephone: '(212) 799-5000',
    population: 1663,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.juilliard.edu/',
  },
  {
    name: 'MARIETTA COLLEGE',
    address: 'IRVINE BLDG',
    city: 'MARIETTA',
    state: 'OH',
    zip: 45750,
    telephone: '(800) 331-7896',
    population: 1663,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marietta.edu/',
  },
  {
    name: 'COLLEGE OF OUR LADY OF THE ELMS',
    address: '291 SPRINGFIELD ST',
    city: 'CHICOPEE',
    state: 'MA',
    zip: 1013,
    telephone: '(413) 594-2761',
    population: 1666,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.elms.edu/',
  },
  {
    name: 'JOHNSON C SMITH UNIVERSITY',
    address: '100 BEATTIES FORD ROAD',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28216,
    telephone: '(704) 378-1000',
    population: 1668,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jcsu.edu/',
  },
  {
    name: 'SHORTER UNIVERSITY',
    address: '315 SHORTER AVE',
    city: 'ROME',
    state: 'GA',
    zip: 30165,
    telephone: '(706) 291-2121',
    population: 1670,
    county: 'FLOYD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.shorter.edu/',
  },
  {
    name: 'NASHUA COMMUNITY COLLEGE',
    address: '505 AMHERST ST',
    city: 'NASHUA',
    state: 'NH',
    zip: 3063,
    telephone: '(603) 578-8900',
    population: 1670,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'nashuacc.edu/',
  },
  {
    name: 'OHIO DOMINICAN UNIVERSITY',
    address: '1216 SUNBURY ROAD',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43219,
    telephone: '(614) 253-2741',
    population: 1671,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ohiodominican.edu/',
  },
  {
    name: 'TRINIDAD STATE JUNIOR COLLEGE',
    address: '600 PROSPECT STREET',
    city: 'TRINIDAD',
    state: 'CO',
    zip: 81082,
    telephone: '(719) 846-5011',
    population: 1673,
    county: 'LAS ANIMAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.trinidadstate.edu/',
  },
  {
    name: 'YOUNG HARRIS COLLEGE',
    address: '1 COLLEGE STREET',
    city: 'YOUNG HARRIS',
    state: 'GA',
    zip: 30582,
    telephone: '(706) 379-3111',
    population: 1673,
    county: 'TOWNS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.yhc.edu/',
  },
  {
    name: 'WESTERN TEXAS COLLEGE',
    address: '6200 COLLEGE AVE',
    city: 'SNYDER',
    state: 'TX',
    zip: 79549,
    telephone: '(325) 573-8511',
    population: 1675,
    county: 'SCURRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wtc.edu/',
  },
  {
    name: 'NORTHWEST COLLEGE',
    address: '231 W 6TH ST',
    city: 'POWELL',
    state: 'WY',
    zip: 82435,
    telephone: '(307) 754-6000',
    population: 1676,
    county: 'PARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwc.edu/',
  },
  {
    name: 'BROOKLINE COLLEGE-PHOENIX',
    address: '2445 W. DUNLAP AVE., STE. 100',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85021,
    telephone: '(602) 242-6265',
    population: 1677,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brooklinecollege.edu/',
  },
  {
    name: 'CATAWBA COLLEGE',
    address: '2300 W INNES ST',
    city: 'SALISBURY',
    state: 'NC',
    zip: 28144,
    telephone: '(800) 228-2922',
    population: 1678,
    county: 'ROWAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.catawba.edu/',
  },
  {
    name: 'LABETTE COMMUNITY COLLEGE',
    address: '200 S 14TH',
    city: 'PARSONS',
    state: 'KS',
    zip: 67357,
    telephone: '(620) 421-6700',
    population: 1678,
    county: 'LABETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.labette.edu/',
  },
  {
    name: 'DINE COLLEGE',
    address: 'ROUTE 12, ONE CIRCLE DRIVE',
    city: 'TSAILE',
    state: 'AZ',
    zip: 86556,
    telephone: '(928) 724-6600',
    population: 1679,
    county: 'APACHE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.dinecollege.edu/',
  },
  {
    name: 'FLORIDA POLYTECHNIC UNIVERSITY',
    address: '4700 RESEARCH WAY',
    city: 'LAKELAND',
    state: 'FL',
    zip: 33805,
    telephone: '(863) 583-9050',
    population: 1679,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'floridapoly.edu/',
  },
  {
    name: 'OGLETHORPE UNIVERSITY',
    address: '4484 PEACHTREE ROAD, NE',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30319,
    telephone: '(404) 261-1441',
    population: 1683,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'oglethorpe.edu/',
  },
  {
    name: 'UNIVERSITY OF CONNECTICUT-HARTFORD CAMPUS',
    address: '10 PROSPECT STREET',
    city: 'HARTFORD',
    state: 'CT',
    zip: 6103,
    telephone: '(959) 200-3500',
    population: 1683,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'hartford.uconn.edu/',
  },
  {
    name: 'NAVAJO TECHNICAL UNIVERSITY',
    address: 'LOWER POINT ROAD, STATE ROAD 371',
    city: 'CROWNPOINT',
    state: 'NM',
    zip: 87313,
    telephone: '(505) 786-4100 EXT 4111',
    population: 1686,
    county: 'MCKINLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.navajotech.edu/',
  },
  {
    name: 'SOUTHEASTERN COMMUNITY COLLEGE',
    address: '4564 CHADBOURN HWY',
    city: 'WHITEVILLE',
    state: 'NC',
    zip: 28472,
    telephone: '(910) 642-7141 EXT 224',
    population: 1693,
    county: 'COLUMBUS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sccnc.edu/',
  },
  {
    name: 'HUNTINGTON UNIVERSITY',
    address: '2303 COLLEGE AVE',
    city: 'HUNTINGTON',
    state: 'IN',
    zip: 46750,
    telephone: '(260) 356-6000',
    population: 1695,
    county: 'HUNTINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.huntington.edu/',
  },
  {
    name: 'DICKINSON STATE UNIVERSITY',
    address: '291 CAMPUS DRIVE',
    city: 'DICKINSON',
    state: 'ND',
    zip: 58601,
    telephone: '(701) 483-2507',
    population: 1699,
    county: 'STARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dickinsonstate.edu/',
  },
  {
    name: 'CROWN COLLEGE',
    address: '8700 COLLEGE VIEW DRIVE',
    city: 'SAINT BONIFACIUS',
    state: 'MN',
    zip: 55375,
    telephone: '(952) 446-4100',
    population: 1699,
    county: 'CARVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.crown.edu/',
  },
  {
    name: 'REINHARDT UNIVERSITY',
    address: '7300 REINHARDT CIRCLE',
    city: 'WALESKA',
    state: 'GA',
    zip: 30183,
    telephone: '(770) 720-5600',
    population: 1704,
    county: 'CHEROKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.reinhardt.edu/',
  },
  {
    name: 'YORK COUNTY COMMUNITY COLLEGE',
    address: '112 COLLEGE DRIVE',
    city: 'WELLS',
    state: 'ME',
    zip: 4090,
    telephone: '(207) 646-9282',
    population: 1704,
    county: 'YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.yccc.edu/',
  },
  {
    name: 'GENEVA COLLEGE',
    address: '3200 COLLEGE AVE',
    city: 'BEAVER FALLS',
    state: 'PA',
    zip: 15010,
    telephone: '(724) 846-5100',
    population: 1705,
    county: 'BEAVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.geneva.edu/',
  },
  {
    name: 'KEYSTONE COLLEGE',
    address: 'ONE COLLEGE GREEN',
    city: 'LA PLUME',
    state: 'PA',
    zip: 18440,
    telephone: '(570) 945-8000',
    population: 1710,
    county: 'WYOMING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.keystone.edu/',
  },
  {
    name: 'FISHER COLLEGE',
    address: '118 BEACON STREET',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 236-8800',
    population: 1710,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fisher.edu/',
  },
  {
    name: 'H COUNCILL TRENHOLM STATE COMMUNITY COLLEGE',
    address: '1225 AIR BASE BLVD',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36108,
    telephone: '(334) 420-4200',
    population: 1714,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.trenholmstate.edu/',
  },
  {
    name: 'BETHEL UNIVERSITY',
    address: '1001 BETHEL CIRCLE',
    city: 'MISHAWAKA',
    state: 'IN',
    zip: 46545,
    telephone: '(574) 807-7000',
    population: 1716,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.betheluniversity.edu/',
  },
  {
    name: 'ATLANTIC UNIVERSITY COLLEGE',
    address: 'COLTON ST. # 9',
    city: 'GUAYNABO',
    state: 'PR',
    zip: 970,
    telephone: '(787) 720-1022 EXT 1000',
    population: 1717,
    county: 'GUAYNABO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atlanticu.edu/',
  },
  {
    name: 'TOURO UNIVERSITY CALIFORNIA',
    address: '1310 CLUB DRIVE',
    city: 'VALLEJO',
    state: 'CA',
    zip: 94592,
    telephone: '(707) 638-5276',
    population: 1719,
    county: 'SOLANO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tu.edu/',
  },
  {
    name: 'MITCHELL HAMLINE SCHOOL OF LAW',
    address: '875 SUMMIT AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55105,
    telephone: '(651) 227-9171',
    population: 1720,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mitchellhamline.edu/',
  },
  {
    name: 'ROCKEFELLER UNIVERSITY',
    address: '1230 YORK AVENUE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10065,
    telephone: '(212) 327-8000',
    population: 1721,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rockefeller.edu/',
  },
  {
    name: 'MILES COLLEGE',
    address: '5500 MYRON MASSEY BLVD',
    city: 'FAIRFIELD',
    state: 'AL',
    zip: 35064,
    telephone: '(205) 929-1000 EXT 1645',
    population: 1726,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.miles.edu/',
  },
  {
    name: 'UNIVERSITY OF MINNESOTA-MORRIS',
    address: '309 BEHMLER HALL',
    city: 'MORRIS',
    state: 'MN',
    zip: 56267,
    telephone: '(320) 589-6035',
    population: 1729,
    county: 'STEVENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://morris.umn.edu/',
  },
  {
    name: 'ALBERTUS MAGNUS COLLEGE',
    address: '700 PROSPECT ST',
    city: 'NEW HAVEN',
    state: 'CT',
    zip: 6511,
    telephone: '(203) 773-8550',
    population: 1730,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.albertus.edu/',
  },
  {
    name: 'DODGE CITY COMMUNITY COLLEGE',
    address: '2501 N 14TH AVE',
    city: 'DODGE CITY',
    state: 'KS',
    zip: 67801,
    telephone: '(620) 225-1321',
    population: 1730,
    county: 'FORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://dc3.edu/',
  },
  {
    name: 'OAKWOOD UNIVERSITY',
    address: '7000 ADVENTIST BLVD NW',
    city: 'HUNTSVILLE',
    state: 'AL',
    zip: 35896,
    telephone: '(256) 726-7000',
    population: 1733,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www2.oakwood.edu/',
  },
  {
    name: 'OTIS COLLEGE OF ART AND DESIGN',
    address: '9045 LINCOLN BLVD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90045,
    telephone: '(800) 527-6847',
    population: 1738,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.otis.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-ALABAMA',
    address: '2 20TH STREET NORTH, #150',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35203,
    telephone: '(877) 455-7180',
    population: 1738,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/alabama/birmingham',
  },
  {
    name: 'LORAS COLLEGE',
    address: '1450 ALTA VISTA',
    city: 'DUBUQUE',
    state: 'IA',
    zip: 52004,
    telephone: '(563) 588-7100',
    population: 1741,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.loras.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-WAUWATOSA',
    address: '10950 W POTTER ROAD',
    city: 'WAUWATOSA',
    state: 'WI',
    zip: 53226,
    telephone: '(414) 302-7000',
    population: 1741,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'KANSAS CITY UNIVERSITY OF MEDICINE AND BIOSCIENCES',
    address: '1750 INDEPENDENCE AVE',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64106,
    telephone: '(816) 654-7000',
    population: 1742,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kcumb.edu/',
  },
  {
    name: 'SOUTHWESTERN COMMUNITY COLLEGE',
    address: '1501 WEST TOWNLINE STREET',
    city: 'CRESTON',
    state: 'IA',
    zip: 50801,
    telephone: '(641) 782-7081',
    population: 1743,
    county: 'UNION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.swcciowa.edu/',
  },
  {
    name: 'SOUTHWESTERN COLLEGE',
    address: '100 COLLEGE STREET',
    city: 'WINFIELD',
    state: 'KS',
    zip: 67156,
    telephone: '(620) 229-6000',
    population: 1744,
    county: 'COWLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sckans.edu/',
  },
  {
    name: 'COPPER MOUNTAIN COMMUNITY COLLEGE',
    address: '6162 ROTARY WAY',
    city: 'JOSHUA TREE',
    state: 'CA',
    zip: 92252,
    telephone: '(760) 366-3791',
    population: 1745,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cmccd.edu/',
  },
  {
    name: 'EDGECOMBE COMMUNITY COLLEGE',
    address: '2009 W WILSON ST',
    city: 'TARBORO',
    state: 'NC',
    zip: 27886,
    telephone: '(252) 823-5166',
    population: 1746,
    county: 'EDGECOMBE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.edgecombe.edu/',
  },
  {
    name: 'WRIGHT STATE UNIVERSITY-LAKE CAMPUS',
    address: '7600 LAKE CAMPUS DRIVE',
    city: 'CELINA',
    state: 'OH',
    zip: 45822,
    telephone: '(419) 586-0300',
    population: 1749,
    county: 'MERCER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://lake.wright.edu/',
  },
  {
    name: 'NEW MEXICO JUNIOR COLLEGE',
    address: '5317 LOVINGTON HWY',
    city: 'HOBBS',
    state: 'NM',
    zip: 88240,
    telephone: '(575) 392-4510',
    population: 1751,
    county: 'LEA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nmjc.edu/',
  },
  {
    name: 'GUILFORD COLLEGE',
    address: '5800 W FRIENDLY AVENUE',
    city: 'GREENSBORO',
    state: 'NC',
    zip: 27410,
    telephone: '(336) 316-2000',
    population: 1754,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.guilford.edu/',
  },
  {
    name: 'EDIC COLLEGE',
    address: 'ANGORA INDUSTRIAL PARK BUILDING G ANGORA AVENUE',
    city: 'CAGUAS',
    state: 'PR',
    zip: 725,
    telephone: '(787) 704-1020 EXT 100',
    population: 1754,
    county: 'CAGUAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ediccollege.edu/',
  },
  {
    name: 'CENTRE COLLEGE',
    address: '625 W WALNUT ST',
    city: 'DANVILLE',
    state: 'KY',
    zip: 40422,
    telephone: '(859) 238-5200',
    population: 1759,
    county: 'BOYLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.centre.edu/',
  },
  {
    name: 'KLAMATH COMMUNITY COLLEGE',
    address: '7390 SOUTH SIXTH STREET',
    city: 'KLAMATH FALLS',
    state: 'OR',
    zip: 97603,
    telephone: '(541) 882-3521',
    population: 1760,
    county: 'KLAMATH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.klamathcc.edu/',
  },
  {
    name: 'AVILA UNIVERSITY',
    address: '11901 WORNALL RD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64145,
    telephone: '(816) 942-8400',
    population: 1761,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.avila.edu/',
  },
  {
    name: 'TREASURE VALLEY COMMUNITY COLLEGE',
    address: '650 COLLEGE BLVD',
    city: 'ONTARIO',
    state: 'OR',
    zip: 97914,
    telephone: '(541) 881-8822',
    population: 1761,
    county: 'MALHEUR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.tvcc.cc/',
  },
  {
    name: 'MANCHESTER UNIVERSITY',
    address: '604 E. COLLEGE AVE',
    city: 'NORTH MANCHESTER',
    state: 'IN',
    zip: 46962,
    telephone: '(260) 982-5000',
    population: 1762,
    county: 'WABASH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.manchester.edu/',
  },
  {
    name: 'FOND DU LAC TRIBAL AND COMMUNITY COLLEGE',
    address: '2101 14TH ST',
    city: 'CLOQUET',
    state: 'MN',
    zip: 55720,
    telephone: '(218) 879-0800',
    population: 1762,
    county: 'CARLTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fdltcc.edu/',
  },
  {
    name: 'COE COLLEGE',
    address: '1220 FIRST AVE NE',
    city: 'CEDAR RAPIDS',
    state: 'IA',
    zip: 52402,
    telephone: '(319) 399-8000',
    population: 1766,
    county: 'LINN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coe.edu/',
  },
  {
    name: 'GRAYS HARBOR COLLEGE',
    address: '1620 EDWARD P SMITH DRIVE',
    city: 'ABERDEEN',
    state: 'WA',
    zip: 98520,
    telephone: '(360) 532-9020',
    population: 1767,
    county: 'GRAYS HARBOR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ghc.edu/',
  },
  {
    name: 'JUNIATA COLLEGE',
    address: '1700 MOORE ST',
    city: 'HUNTINGDON',
    state: 'PA',
    zip: 16652,
    telephone: '(814) 641-3000',
    population: 1768,
    county: 'HUNTINGDON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.juniata.edu/',
  },
  {
    name: 'NORTH CENTRAL MISSOURI COLLEGE',
    address: '1301 MAIN ST',
    city: 'TRENTON',
    state: 'MO',
    zip: 64683,
    telephone: '(660) 359-3948 EXT 1418',
    population: 1770,
    county: 'GRUNDY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ncmissouri.edu/',
  },
  {
    name: 'CLAREMONT MCKENNA COLLEGE',
    address: '500 E 9TH ST',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8000',
    population: 1771,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cmc.edu/',
  },
  {
    name: 'BELMONT ABBEY COLLEGE',
    address: '100 BELMONT-MT HOLLY ROAD',
    city: 'BELMONT',
    state: 'NC',
    zip: 28012,
    telephone: '(704) 461-6700',
    population: 1771,
    county: 'GASTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.belmontabbeycollege.edu/',
  },
  {
    name: 'CENTRAL ALABAMA COMMUNITY COLLEGE',
    address: '1675 CHEROKEE RD',
    city: 'ALEXANDER CITY',
    state: 'AL',
    zip: 35010,
    telephone: '(256) 234-6346',
    population: 1771,
    county: 'TALLAPOOSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cacc.edu/',
  },
  {
    name: 'MALONE UNIVERSITY',
    address: '2600 CLEVELAND AVENUE NW',
    city: 'CANTON',
    state: 'OH',
    zip: 44709,
    telephone: '(330) 471-8100',
    population: 1772,
    county: 'STARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.malone.edu/',
  },
  {
    name: 'CARTERET COMMUNITY COLLEGE',
    address: '3505 ARENDELL ST',
    city: 'MOREHEAD CITY',
    state: 'NC',
    zip: 28557,
    telephone: '(252) 222-6000',
    population: 1772,
    county: 'CARTERET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.carteret.edu/',
  },
  {
    name: 'WILSON COLLEGE',
    address: '1015 PHILADELPHIA AVE',
    city: 'CHAMBERSBURG',
    state: 'PA',
    zip: 17201,
    telephone: '(717) 264-4141',
    population: 1776,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wilson.edu/',
  },
  {
    name: 'ROCKY VISTA UNIVERSITY',
    address: '8401 S CHAMBERS ROAD',
    city: 'PARKER',
    state: 'CO',
    zip: 80134,
    telephone: '(303) 373-2008',
    population: 1778,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rvu.edu/',
  },
  {
    name: 'CEDAR CREST COLLEGE',
    address: '100 COLLEGE DRIVE',
    city: 'ALLENTOWN',
    state: 'PA',
    zip: 18104,
    telephone: '(610) 606-4666',
    population: 1780,
    county: 'LEHIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cedarcrest.edu/',
  },
  {
    name: 'ALMA COLLEGE',
    address: '614 W SUPERIOR',
    city: 'ALMA',
    state: 'MI',
    zip: 48801,
    telephone: '(989) 463-7111',
    population: 1781,
    county: 'GRATIOT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'alma.edu/',
  },
  {
    name: 'NORTH COUNTRY COMMUNITY COLLEGE',
    address: '23 SANTANONI AVENUE',
    city: 'SARANAC LAKE',
    state: 'NY',
    zip: 12983,
    telephone: '(518) 891-2915',
    population: 1781,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nccc.edu/',
  },
  {
    name: 'LINCOLN COLLEGE OF TECHNOLOGY-NASHVILLE',
    address: '1524 GALLATIN RD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37206,
    telephone: '(615) 226-3990',
    population: 1781,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lincolntech.edu/campus/nashville-tn',
  },
  {
    name: 'SOUTHWEST UNIVERSITY AT EL PASO',
    address: '1414 GERONIMO',
    city: 'EL PASO',
    state: 'TX',
    zip: 79925,
    telephone: '(915) 778-4001',
    population: 1781,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'southwestuniversity.edu/',
  },
  {
    name: 'ANDERSON UNIVERSITY',
    address: '1100 E 5TH ST',
    city: 'ANDERSON',
    state: 'IN',
    zip: 46012,
    telephone: '(765) 649-9071',
    population: 1782,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://anderson.edu/',
  },
  {
    name: 'UNITY COLLEGE',
    address: '90 QUAKER HILL ROAD',
    city: 'UNITY',
    state: 'ME',
    zip: 4988,
    telephone: '(207) 509-7100',
    population: 1784,
    county: 'WALDO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://unity.edu/',
  },
  {
    name: 'NATIONAL AMERICAN UNIVERSITY-RAPID CITY',
    address: '5301 MOUNT RUSHMORE ROAD',
    city: 'RAPID CITY',
    state: 'SD',
    zip: 57701,
    telephone: '(605) 394-4800',
    population: 1788,
    county: 'PENNINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.national.edu/locations/campuses/rapid-city/',
  },
  {
    name: 'UNIVERSITY OF MAINE AT FORT KENT',
    address: '23 UNIVERSITY DRIVE',
    city: 'FORT KENT',
    state: 'ME',
    zip: 4743,
    telephone: '(207) 834-7500 EXT 20783',
    population: 1790,
    county: 'AROOSTOOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umfk.maine.edu/',
  },
  {
    name: 'BRYAN COLLEGE-DAYTON',
    address: '721 BRYAN DRIVE',
    city: 'DAYTON',
    state: 'TN',
    zip: 37321,
    telephone: '(423) 775-2041',
    population: 1793,
    county: 'RHEA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bryan.edu/',
  },
  {
    name: 'EASTERN MENNONITE UNIVERSITY',
    address: '1200 PARK RD',
    city: 'HARRISONBURG',
    state: 'VA',
    zip: 22802,
    telephone: '(540) 432-4000',
    population: 1794,
    county: 'HARRISONBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://emu.edu/',
  },
  {
    name: 'SAMPSON COMMUNITY COLLEGE',
    address: 'HIGHWAY 24 WEST',
    city: 'CLINTON',
    state: 'NC',
    zip: 28328,
    telephone: '(910) 592-8081 EXT 2017',
    population: 1797,
    county: 'SAMPSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sampsoncc.edu/',
  },
  {
    name: 'MOREHOUSE SCHOOL OF MEDICINE',
    address: '720 WESTVIEW DRIVE, S.W.',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30310,
    telephone: '(404) 752-1500',
    population: 1798,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msm.edu/',
  },
  {
    name: 'BEAUFORT COUNTY COMMUNITY COLLEGE',
    address: '5337 US HIGHWAY 264 EAST',
    city: 'WASHINGTON',
    state: 'NC',
    zip: 27889,
    telephone: '(252) 946-6194',
    population: 1798,
    county: 'BEAUFORT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.beaufortccc.edu/',
  },
  {
    name: 'UNIVERSITY OF AKRON WAYNE COLLEGE',
    address: '1901 SMUCKER RD',
    city: 'ORRVILLE',
    state: 'OH',
    zip: 44667,
    telephone: '(800) 221-8308',
    population: 1799,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://wayne.uakron.edu/',
  },
  {
    name: 'VAUGHN COLLEGE OF AERONAUTICS AND TECHNOLOGY',
    address: '86-01 23RD AVENUE',
    city: 'FLUSHING',
    state: 'NY',
    zip: 11369,
    telephone: '(718) 429-6600',
    population: 1801,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vaughn.edu/',
  },
  {
    name: 'HARRIS-STOWE STATE UNIVERSITY',
    address: '3026 LACLEDE AVE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63103,
    telephone: '(314) 340-3366',
    population: 1803,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hssu.edu/',
  },
  {
    name: 'ANNA MARIA COLLEGE',
    address: '50 SUNSET LANE',
    city: 'PAXTON',
    state: 'MA',
    zip: 1612,
    telephone: '(508) 849-3300',
    population: 1806,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.annamaria.edu/',
  },
  {
    name: 'MEHARRY MEDICAL COLLEGE',
    address: '1005 DB TODD BLVD.',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37208,
    telephone: '(615) 327-6111',
    population: 1808,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mmc.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-FAJARDO',
    address: 'CALLE UNION-BATEY CENTRAL HIGHWAY 195',
    city: 'FAJARDO',
    state: 'PR',
    zip: 738,
    telephone: '(787) 863-2390',
    population: 1809,
    county: 'FAJARDO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fajardo.inter.edu/',
  },
  {
    name: 'PIERPONT COMMUNITY AND TECHNICAL COLLEGE',
    address: '1201 LOCUST AVE',
    city: 'FAIRMONT',
    state: 'WV',
    zip: 26554,
    telephone: '(304) 367-4907',
    population: 1811,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.pierpont.edu/',
  },
  {
    name: 'MIAMI UNIVERSITY-MIDDLETOWN',
    address: '4200 E UNIVERSITY BLVD',
    city: 'MIDDLETOWN',
    state: 'OH',
    zip: 45042,
    telephone: '(513) 727-3200',
    population: 1815,
    county: 'BUTLER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'miamioh.edu/regionals/',
  },
  {
    name: 'CARRINGTON COLLEGE-SACRAMENTO',
    address: '8909 FOLSOM BLVD.',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95826,
    telephone: '(916) 361-1660',
    population: 1817,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://carrington.edu/',
  },
  {
    name: 'GREAT BAY COMMUNITY COLLEGE',
    address: '320 CORPORATE DRIVE',
    city: 'PORTSMOUTH',
    state: 'NH',
    zip: 3801,
    telephone: '(603) 427-7600',
    population: 1817,
    county: 'ROCKINGHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.greatbay.edu/',
  },
  {
    name: 'HAYWOOD COMMUNITY COLLEGE',
    address: '185 FREEDLANDER DRIVE',
    city: 'CLYDE',
    state: 'NC',
    zip: 28721,
    telephone: '(828) 627-2821',
    population: 1818,
    county: 'HAYWOOD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.haywood.edu/',
  },
  {
    name: 'BERKSHIRE COMMUNITY COLLEGE',
    address: '1350 WEST STREET',
    city: 'PITTSFIELD',
    state: 'MA',
    zip: 1201,
    telephone: '(413) 499-4660',
    population: 1820,
    county: 'BERKSHIRE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.berkshirecc.edu/',
  },
  {
    name: 'NICHOLS COLLEGE',
    address: 'CENTER RD',
    city: 'DUDLEY',
    state: 'MA',
    zip: 1571,
    telephone: '(800) 470-3379',
    population: 1822,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nichols.edu/',
  },
  {
    name: 'MARTINSBURG COLLEGE',
    address: '341 AIKENS CENTER',
    city: 'MARTINSBURG',
    state: 'WV',
    zip: 25404,
    telephone: '(917) 613-8499',
    population: 1822,
    county: 'BERKELEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.martinsburgcollege.edu/',
  },
  {
    name: 'TEXAS LUTHERAN UNIVERSITY',
    address: '1000 W. COURT ST',
    city: 'SEGUIN',
    state: 'TX',
    zip: 78155,
    telephone: '(830) 372-8000',
    population: 1832,
    county: 'GUADALUPE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tlu.edu/',
  },
  {
    name: 'PINE TECHNICAL & COMMUNITY COLLEGE',
    address: '900 4TH ST SE',
    city: 'PINE CITY',
    state: 'MN',
    zip: 55063,
    telephone: '(320) 629-5100',
    population: 1833,
    county: 'PINE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pine.edu/',
  },
  {
    name: 'FORT SCOTT COMMUNITY COLLEGE',
    address: '2108 S HORTON',
    city: 'FORT SCOTT',
    state: 'KS',
    zip: 66701,
    telephone: '(620) 223-2700',
    population: 1834,
    county: 'BOURBON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fortscott.edu/',
  },
  {
    name: 'CLOUD COUNTY COMMUNITY COLLEGE',
    address: '2221 CAMPUS DR',
    city: 'CONCORDIA',
    state: 'KS',
    zip: 66901,
    telephone: '(785) 243-1435',
    population: 1835,
    county: 'CLOUD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cloud.edu/',
  },
  {
    name: 'ANOKA TECHNICAL COLLEGE',
    address: '1355 HIGHWAY 10 WEST',
    city: 'ANOKA',
    state: 'MN',
    zip: 55303,
    telephone: '(763) 433-1100',
    population: 1837,
    county: 'ANOKA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.anokatech.edu/',
  },
  {
    name: 'CHESTNUT HILL COLLEGE',
    address: '9601 GERMANTOWN AVE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19118,
    telephone: '(215) 248-7000',
    population: 1839,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.chc.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-VIRGINIA BEACH',
    address: '301 CENTRE POINTE DR',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23462,
    telephone: '(757) 499-7900',
    population: 1841,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'GRACELAND UNIVERSITY-LAMONI',
    address: '1 UNIVERSITY PLACE',
    city: 'LAMONI',
    state: 'IA',
    zip: 50140,
    telephone: '(641) 784-5000',
    population: 1841,
    county: 'DECATUR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.graceland.edu/',
  },
  {
    name: 'SEWARD COUNTY COMMUNITY COLLEGE',
    address: '1801 N. KANSAS AVE.',
    city: 'LIBERAL',
    state: 'KS',
    zip: 67901,
    telephone: '(620) 624-1951',
    population: 1841,
    county: 'SEWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sccc.edu/',
  },
  {
    name: 'LURLEEN B WALLACE COMMUNITY COLLEGE',
    address: '1000 DANNELLY BLVD.',
    city: 'ANDALUSIA',
    state: 'AL',
    zip: 36420,
    telephone: '(334) 222-6591',
    population: 1842,
    county: 'COVINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lbwcc.edu/',
  },
  {
    name: 'PITTSBURGH TECHNICAL COLLEGE',
    address: '1111 MCKEE ROAD',
    city: 'OAKDALE',
    state: 'PA',
    zip: 15071,
    telephone: '(412) 809-5100',
    population: 1844,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ptcollege.edu/',
  },
  {
    name: 'KEUKA COLLEGE',
    address: '141 CENTRAL AVENUE',
    city: 'KEUKA PARK',
    state: 'NY',
    zip: 14478,
    telephone: '(315) 279-5000',
    population: 1851,
    county: 'YATES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.keuka.edu/',
  },
  {
    name: 'OKLAHOMA STATE UNIVERSITY CENTER FOR HEALTH SCIENCES',
    address: '1111 W 17TH ST',
    city: 'TULSA',
    state: 'OK',
    zip: 74107,
    telephone: '(918) 582-1972',
    population: 1854,
    county: 'TULSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://medicine.okstate.edu/',
  },
  {
    name: 'COAHOMA COMMUNITY COLLEGE',
    address: '3240 FRIARS POINT RD',
    city: 'CLARKSDALE',
    state: 'MS',
    zip: 38614,
    telephone: '(662) 627-2571',
    population: 1855,
    county: 'COAHOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coahomacc.edu/',
  },
  {
    name: 'NORTH CENTRAL MICHIGAN COLLEGE',
    address: '1515 HOWARD ST',
    city: 'PETOSKEY',
    state: 'MI',
    zip: 49770,
    telephone: '(231) 348-6600',
    population: 1856,
    county: 'EMMET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ncmich.edu/',
  },
  {
    name: 'ATLANTA METROPOLITAN STATE COLLEGE',
    address: '1630 METROPOLITAN PARKWAY, SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30310,
    telephone: '(404) 756-4000',
    population: 1860,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.atlm.edu/',
  },
  {
    name: 'GLENVILLE STATE COLLEGE',
    address: '200 HIGH STREET',
    city: 'GLENVILLE',
    state: 'WV',
    zip: 26351,
    telephone: '(304) 462-7361',
    population: 1861,
    county: 'GILMER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.glenville.edu/',
  },
  {
    name: 'AMERICAN CAREER COLLEGE-LOS ANGELES',
    address: '4021 ROSEWOOD AVENUE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90004,
    telephone: '(949) 783-4800',
    population: 1862,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://americancareercollege.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT SALEM',
    address: '2491 STATE ROUTE 45 SOUTH',
    city: 'SALEM',
    state: 'OH',
    zip: 44460,
    telephone: '(330) 332-0361',
    population: 1863,
    county: 'COLUMBIANA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kent.edu/columbiana',
  },
  {
    name: 'MERCY COLLEGE OF OHIO',
    address: '2221 MADISON AVENUE',
    city: 'TOLEDO',
    state: 'OH',
    zip: 43604,
    telephone: '(419) 251-1313',
    population: 1865,
    county: 'LUCAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mercycollege.edu/',
  },
  {
    name: 'NORTHWESTERN COLLEGE',
    address: '101 SEVENTH ST SW',
    city: 'ORANGE CITY',
    state: 'IA',
    zip: 51041,
    telephone: '(712) 707-7000',
    population: 1866,
    county: 'SIOUX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nwciowa.edu/',
  },
  {
    name: 'GREENFIELD COMMUNITY COLLEGE',
    address: 'ONE COLLEGE DR',
    city: 'GREENFIELD',
    state: 'MA',
    zip: 1301,
    telephone: '(413) 775-1000',
    population: 1867,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gcc.mass.edu/',
  },
  {
    name: 'KALAMAZOO COLLEGE',
    address: '1200 ACADEMY ST',
    city: 'KALAMAZOO',
    state: 'MI',
    zip: 49006,
    telephone: '(269) 337-7000',
    population: 1869,
    county: 'KALAMAZOO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kzoo.edu/',
  },
  {
    name: 'WITTENBERG UNIVERSITY',
    address: 'WARD ST AT N WITTENBERG AVE',
    city: 'SPRINGFIELD',
    state: 'OH',
    zip: 45504,
    telephone: '(937) 327-6231',
    population: 1869,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wittenberg.edu/',
  },
  {
    name: 'FLORIDA INSTITUTE OF TECHNOLOGY-ONLINE',
    address: '150 WEST UNIVERSITY BLVD',
    city: 'MELBOURNE',
    state: 'FL',
    zip: 32901,
    telephone: '(321) 674-8000',
    population: 1870,
    county: 'BREVARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fit.edu/',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF INTEGRAL STUDIES',
    address: '1453 MISSION STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94103,
    telephone: '(415) 575-6100',
    population: 1871,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ciis.edu/',
  },
  {
    name: 'WHITMAN COLLEGE',
    address: '345 BOYER AVE',
    city: 'WALLA WALLA',
    state: 'WA',
    zip: 99362,
    telephone: '(509) 527-5111',
    population: 1873,
    county: 'WALLA WALLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.whitman.edu/',
  },
  {
    name: 'VIRGINIA UNION UNIVERSITY',
    address: '1500 N LOMBARDY ST',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23220,
    telephone: '(804) 257-5600',
    population: 1875,
    county: 'RICHMOND CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vuu.edu/',
  },
  {
    name: 'GEORGETOWN COLLEGE',
    address: '400 EAST COLLEGE STREET',
    city: 'GEORGETOWN',
    state: 'KY',
    zip: 40324,
    telephone: '(502) 863-8000',
    population: 1875,
    county: 'SCOTT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.georgetowncollege.edu/',
  },
  {
    name: 'SOUTHERN TECHNICAL COLLEGE',
    address: '1485 FLORIDA MALL AVENUE',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32809,
    telephone: '(407) 671-9922',
    population: 1875,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southerntech.edu/',
  },
  {
    name: 'SULLIVAN COUNTY COMMUNITY COLLEGE',
    address: '112 COLLEGE ROAD',
    city: 'LOCH SHELDRAKE',
    state: 'NY',
    zip: 12759,
    telephone: '(845) 434-5750',
    population: 1877,
    county: 'SULLIVAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunysullivan.edu/',
  },
  {
    name: 'UNIVERSITY OF RIO GRANDE',
    address: '218 N COLLEGE AVE',
    city: 'RIO GRANDE',
    state: 'OH',
    zip: 45674,
    telephone: '(740) 245-7206',
    population: 1881,
    county: 'GALLIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rio.edu/',
  },
  {
    name: 'COLLEGE OF THE OZARKS',
    address: '100 OPPORTUNITY AVENUE',
    city: 'POINT LOOKOUT',
    state: 'MO',
    zip: 65726,
    telephone: '(417) 334-6411',
    population: 1882,
    county: 'TANEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cofo.edu/',
  },
  {
    name: 'NORTHWEST CAREER COLLEGE',
    address: '7398 SMOKE RANCH ROAD, STE 100',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89128,
    telephone: '(702) 254-7577',
    population: 1884,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northwestcareercollege.edu/',
  },
  {
    name: 'LAKE REGION STATE COLLEGE',
    address: '1801 COLLEGE DR N',
    city: 'DEVILS LAKE',
    state: 'ND',
    zip: 58301,
    telephone: '(701) 662-1600',
    population: 1886,
    county: 'RAMSEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lrsc.edu/',
  },
  {
    name: 'BRIDGEVALLEY COMMUNITY & TECHNICAL COLLEGE',
    address: '2001 UNION CARBIDE DR',
    city: 'SOUTH CHARLESTON',
    state: 'WV',
    zip: 25136,
    telephone: '(304) 734-6600',
    population: 1889,
    county: 'KANAWHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bridgevalley.edu/',
  },
  {
    name: 'OHIO WESLEYAN UNIVERSITY',
    address: '61 S SANDUSKY STREET',
    city: 'DELAWARE',
    state: 'OH',
    zip: 43015,
    telephone: '(740) 368-2000',
    population: 1892,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.owu.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-GUAYAMA',
    address: 'BO MACHETE HIGHWAY 744 KM 1.2',
    city: 'GUAYAMA',
    state: 'PR',
    zip: 784,
    telephone: '(787) 864-2222',
    population: 1895,
    county: 'GUAYAMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.guayama.inter.edu/',
  },
  {
    name: 'FRANK PHILLIPS COLLEGE',
    address: '1301 W. ROOSEVELT ST.',
    city: 'BORGER',
    state: 'TX',
    zip: 79008,
    telephone: '(806) 457-4200',
    population: 1896,
    county: 'HUTCHINSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fpctx.edu/',
  },
  {
    name: 'VERMONT TECHNICAL COLLEGE',
    address: '124 ADMIN DRIVE',
    city: 'RANDOLPH',
    state: 'VT',
    zip: 5061,
    telephone: '(802) 728-1000',
    population: 1901,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vtc.edu/',
  },
  {
    name: 'DES MOINES UNIVERSITY-OSTEOPATHIC MEDICAL CENTER',
    address: '3200 GRAND AVE',
    city: 'DES MOINES',
    state: 'IA',
    zip: 50312,
    telephone: '(515) 271-1400',
    population: 1901,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dmu.edu/',
  },
  {
    name: 'SPALDING UNIVERSITY',
    address: '901 S FOURTH STREET',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40203,
    telephone: '(502) 585-9911',
    population: 1902,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.spalding.edu/',
  },
  {
    name: 'WEST VIRGINIA UNIVERSITY INSTITUTE OF TECHNOLOGY',
    address: '512 SOUTH KANAWHA STREET',
    city: 'BECKLEY',
    state: 'WV',
    zip: 25801,
    telephone: '(304) 442-1000',
    population: 1906,
    county: 'RALEIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvutech.edu/',
  },
  {
    name: 'NORTHWEST IOWA COMMUNITY COLLEGE',
    address: '603 W PARK ST',
    city: 'SHELDON',
    state: 'IA',
    zip: 51201,
    telephone: '(712) 324-5061',
    population: 1906,
    county: 'SIOUX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwicc.edu/',
  },
  {
    name: 'BLOOMFIELD COLLEGE',
    address: '467 FRANKLIN ST',
    city: 'BLOOMFIELD',
    state: 'NJ',
    zip: 7003,
    telephone: '(973) 748-9000',
    population: 1907,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bloomfield.edu/',
  },
  {
    name: 'SOUTHWESTERN OREGON COMMUNITY COLLEGE',
    address: '1988 NEWMARK AVE',
    city: 'COOS BAY',
    state: 'OR',
    zip: 97420,
    telephone: '(541) 888-2525',
    population: 1910,
    county: 'COOS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.socc.edu/',
  },
  {
    name: 'THOMAS COLLEGE',
    address: '180 W RIVER RD',
    city: 'WATERVILLE',
    state: 'ME',
    zip: 4901,
    telephone: '(207) 859-1111',
    population: 1912,
    county: 'KENNEBEC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.thomas.edu/',
  },
  {
    name: 'LINFIELD UNIVERSITY-MCMINNVILLE CAMPUS',
    address: '900 SE BAKER',
    city: 'MCMINNVILLE',
    state: 'OR',
    zip: 97128,
    telephone: '(503) 883-2200',
    population: 1913,
    county: 'YAMHILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.linfield.edu/',
  },
  {
    name: 'AQUINAS COLLEGE',
    address: '1700 FULTON ST. E',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49506,
    telephone: '(616) 632-8900',
    population: 1913,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aquinas.edu/',
  },
  {
    name: 'WHITTIER COLLEGE',
    address: '13406 E PHILADELPHIA STREET',
    city: 'WHITTIER',
    state: 'CA',
    zip: 90601,
    telephone: '(562) 907-4205',
    population: 1914,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.whittier.edu/',
  },
  {
    name: 'NORTH ARKANSAS COLLEGE',
    address: '1515 PIONEER DR',
    city: 'HARRISON',
    state: 'AR',
    zip: 72601,
    telephone: '(870) 743-3000',
    population: 1914,
    county: 'BOONE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northark.edu/',
  },
  {
    name: 'TRINITY INTERNATIONAL UNIVERSITY-ILLINOIS',
    address: '2065 HALF DAY RD',
    city: 'DEERFIELD',
    state: 'IL',
    zip: 60015,
    telephone: '(847) 945-8800',
    population: 1918,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tiu.edu/',
  },
  {
    name: 'MARIAN UNIVERSITY',
    address: '45 S NATIONAL AVE',
    city: 'FOND DU LAC',
    state: 'WI',
    zip: 54935,
    telephone: '(920) 923-7600',
    population: 1919,
    county: 'FOND DU LAC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.marianuniversity.edu/',
  },
  {
    name: 'URSINUS COLLEGE',
    address: '601 E. MAIN ST',
    city: 'COLLEGEVILLE',
    state: 'PA',
    zip: 19426,
    telephone: '(610) 409-3000',
    population: 1928,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ursinus.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF BEAVER COUNTY',
    address: '1 CAMPUS DRIVE',
    city: 'MONACA',
    state: 'PA',
    zip: 15061,
    telephone: '(724) 480-2222',
    population: 1929,
    county: 'BEAVER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ccbc.edu/',
  },
  {
    name: 'VALLEY CITY STATE UNIVERSITY',
    address: '101 COLLEGE ST SW',
    city: 'VALLEY CITY',
    state: 'ND',
    zip: 58072,
    telephone: '(701) 845-7990',
    population: 1930,
    county: 'BARNES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vcsu.edu/',
  },
  {
    name: 'TUSCULUM UNIVERSITY',
    address: '60 SHILOH ROAD',
    city: 'GREENEVILLE',
    state: 'TN',
    zip: 37743,
    telephone: '(423) 636-7300',
    population: 1940,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tusculum.edu/',
  },
  {
    name: 'NOTRE DAME COLLEGE',
    address: '4545 COLLEGE RD',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44121,
    telephone: '(216) 381-1680',
    population: 1942,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.notredamecollege.edu/',
  },
  {
    name: 'SOUTHWESTERN UNIVERSITY',
    address: '1001 E. UNIVERSITY AVENUE',
    city: 'GEORGETOWN',
    state: 'TX',
    zip: 78626,
    telephone: '(512) 863-6511',
    population: 1942,
    county: 'WILLIAMSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southwestern.edu/',
  },
  {
    name: 'TOCCOA FALLS COLLEGE',
    address: '107 KINCAID DRIVE',
    city: 'TOCCOA FALLS',
    state: 'GA',
    zip: 30598,
    telephone: '(706) 886-6831',
    population: 1943,
    county: 'STEPHENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://tfc.edu/',
  },
  {
    name: 'ADLER UNIVERSITY',
    address: '17 NORTH DEARBORN STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60602,
    telephone: '(312) 662-4000',
    population: 1944,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.adler.edu/',
  },
  {
    name: 'MISSOURI VALLEY COLLEGE',
    address: '500 E COLLEGE ST',
    city: 'MARSHALL',
    state: 'MO',
    zip: 65340,
    telephone: '(660) 831-4000',
    population: 1946,
    county: 'SALINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.moval.edu/',
  },
  {
    name: 'UNIVERSAL TECHNICAL INSTITUTE OF ARIZONA INC',
    address: '10695 WEST PIERCE STREET',
    city: 'AVONDALE',
    state: 'AZ',
    zip: 85323,
    telephone: '(800) 510-5845',
    population: 1946,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uti.edu/',
  },
  {
    name: 'EASTERN NEW MEXICO UNIVERSITY-ROSWELL CAMPUS',
    address: '52 UNIVERSITY BLVD',
    city: 'ROSWELL',
    state: 'NM',
    zip: 88202,
    telephone: '(575) 624-7000',
    population: 1948,
    county: 'CHAVES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.roswell.enmu.edu/',
  },
  {
    name: 'CENTENARY UNIVERSITY',
    address: '400 JEFFERSON ST',
    city: 'HACKETTSTOWN',
    state: 'NJ',
    zip: 7840,
    telephone: '(908) 852-1400',
    population: 1951,
    county: 'WARREN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centenaryuniversity.edu/',
  },
  {
    name: 'WESTERN NEBRASKA COMMUNITY COLLEGE',
    address: '1601 EAST 27TH STREET',
    city: 'SCOTTSBLUFF',
    state: 'NE',
    zip: 69361,
    telephone: '(308) 635-3606',
    population: 1954,
    county: 'SCOTTS BLUFF',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wncc.edu/',
  },
  {
    name: 'REED COLLEGE',
    address: '3203 SE WOODSTOCK BLVD',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97202,
    telephone: '(503) 771-1112',
    population: 1956,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.reed.edu/',
  },
  {
    name: 'BRIDGEWATER COLLEGE',
    address: '402 E COLLEGE ST',
    city: 'BRIDGEWATER',
    state: 'VA',
    zip: 22812,
    telephone: '(540) 828-8000',
    population: 1957,
    county: 'ROCKINGHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bridgewater.edu/',
  },
  {
    name: 'HAVERFORD COLLEGE',
    address: '370 LANCASTER AVE',
    city: 'HAVERFORD',
    state: 'PA',
    zip: 19041,
    telephone: '(610) 896-1000',
    population: 1959,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.haverford.edu/',
  },
  {
    name: 'LAWRENCE UNIVERSITY',
    address: 'COLLEGE AVE',
    city: 'APPLETON',
    state: 'WI',
    zip: 54911,
    telephone: '(920) 832-7000',
    population: 1960,
    county: 'OUTAGAMIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lawrence.edu/',
  },
  {
    name: 'CHARTER OAK STATE COLLEGE',
    address: '55 PAUL MANAFORT DRIVE',
    city: 'NEW BRITAIN',
    state: 'CT',
    zip: 6053,
    telephone: '(860) 515-3800',
    population: 1962,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.charteroak.edu/',
  },
  {
    name: 'WARTBURG COLLEGE',
    address: '100 WARTBURG BLVD.',
    city: 'WAVERLY',
    state: 'IA',
    zip: 50677,
    telephone: '(319) 352-8200',
    population: 1966,
    county: 'BREMER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wartburg.edu/',
  },
  {
    name: 'NORTHEASTERN OKLAHOMA A&M COLLEGE',
    address: '200 I ST NE',
    city: 'MIAMI',
    state: 'OK',
    zip: 74354,
    telephone: '(918) 542-8441',
    population: 1970,
    county: 'OTTAWA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.neo.edu/',
  },
  {
    name: 'DORDT UNIVERSITY',
    address: '700 7TH ST SE',
    city: 'SIOUX CENTER',
    state: 'IA',
    zip: 51250,
    telephone: '(712) 722-6000',
    population: 1979,
    county: 'SIOUX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dordt.edu/',
  },
  {
    name: 'LAKE FOREST COLLEGE',
    address: '555 N SHERIDAN ROAD',
    city: 'LAKE FOREST',
    state: 'IL',
    zip: 60045,
    telephone: '(847) 234-3100',
    population: 1979,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lakeforest.edu/',
  },
  {
    name: 'WAYNESBURG UNIVERSITY',
    address: '51 W COLLEGE ST',
    city: 'WAYNESBURG',
    state: 'PA',
    zip: 15370,
    telephone: '(724) 627-8191',
    population: 1983,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.waynesburg.edu/',
  },
  {
    name: 'WALSH COLLEGE',
    address: '3838 LIVERNOIS',
    city: 'TROY',
    state: 'MI',
    zip: 48083,
    telephone: '(248) 823-1600',
    population: 1985,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.walshcollege.edu/',
  },
  {
    name: 'TOURO UNIVERSITY NEVADA',
    address: '874 AMERICAN PACIFIC DRIVE',
    city: 'HENDERSON',
    state: 'NV',
    zip: 89014,
    telephone: '(702) 777-8687',
    population: 1986,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tun.touro.edu/',
  },
  {
    name: 'MASSACHUSETTS MARITIME ACADEMY',
    address: '101 ACADEMY DR',
    city: 'BUZZARDS BAY',
    state: 'MA',
    zip: 2532,
    telephone: '(508) 830-5000',
    population: 1988,
    county: 'BARNSTABLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.maritime.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-LANCASTER',
    address: '476 HUBBARD DRIVE',
    city: 'LANCASTER',
    state: 'SC',
    zip: 29720,
    telephone: '(803) 313-7000',
    population: 1988,
    county: 'LANCASTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sc.edu/about/system_and_campuses/lancaster/index.php',
  },
  {
    name: "ST. MARY'S COLLEGE OF MARYLAND",
    address: '47645 COLLEGE DRIVE',
    city: "ST. MARY'S CITY",
    state: 'MD',
    zip: 20686,
    telephone: '(240) 895-2000',
    population: 1990,
    county: "ST. MARY'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smcm.edu/',
  },
  {
    name: 'ASBURY THEOLOGICAL SEMINARY',
    address: '204 N LEXINGTON AVE',
    city: 'WILMORE',
    state: 'KY',
    zip: 40390,
    telephone: '(859) 858-3581',
    population: 1991,
    county: 'JESSAMINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asburyseminary.edu/',
  },
  {
    name: 'ROBERTS WESLEYAN COLLEGE',
    address: '2301 WESTSIDE DR',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14624,
    telephone: '(585) 594-6000',
    population: 1995,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.roberts.edu/',
  },
  {
    name: 'STATE TECHNICAL COLLEGE OF MISSOURI',
    address: 'ONE TECHNOLOGY DRIVE',
    city: 'LINN',
    state: 'MO',
    zip: 65051,
    telephone: '(573) 897-5000',
    population: 1997,
    county: 'OSAGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.statetechmo.edu/',
  },
  {
    name: 'ALBION COLLEGE',
    address: '611 E PORTER ST',
    city: 'ALBION',
    state: 'MI',
    zip: 49224,
    telephone: '(517) 629-1000',
    population: 2005,
    county: 'CALHOUN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.albion.edu/',
  },
  {
    name: 'GUAM COMMUNITY COLLEGE',
    address: '1 SESAME STREET',
    city: 'MANGILAO',
    state: 'GU',
    zip: 96913,
    telephone: '(671) 735-5700',
    population: 2005,
    county: 'GUAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.guamcc.edu/',
  },
  {
    name: 'SUNY MARITIME COLLEGE',
    address: '6 PENNYFIELD AVENUE',
    city: 'THROGGS NECK',
    state: 'NY',
    zip: 10465,
    telephone: '(718) 409-7200',
    population: 2009,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sunymaritime.edu/',
  },
  {
    name: 'PARKER UNIVERSITY',
    address: '2540 WALNUT HILL LANE',
    city: 'DALLAS',
    state: 'TX',
    zip: 75229,
    telephone: '(972) 438-6932',
    population: 2012,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.parker.edu/',
  },
  {
    name: 'LASSEN COMMUNITY COLLEGE',
    address: '478-200 HWY 139',
    city: 'SUSANVILLE',
    state: 'CA',
    zip: 96130,
    telephone: '(530) 257-6181',
    population: 2012,
    county: 'LASSEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lassencollege.edu/',
  },
  {
    name: "SAINT MARTIN'S UNIVERSITY",
    address: '5000 ABBEY WAY SE',
    city: 'LACEY',
    state: 'WA',
    zip: 98503,
    telephone: '(360) 491-4700',
    population: 2014,
    county: 'THURSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stmartin.edu/',
  },
  {
    name: 'NEOSHO COUNTY COMMUNITY COLLEGE',
    address: '800 W 14TH ST',
    city: 'CHANUTE',
    state: 'KS',
    zip: 66720,
    telephone: '(620) 431-2820',
    population: 2014,
    county: 'NEOSHO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.neosho.edu/',
  },
  {
    name: 'ALBRIGHT COLLEGE',
    address: '1621 N. 13TH ST.',
    city: 'READING',
    state: 'PA',
    zip: 19612,
    telephone: '(610) 921-2381',
    population: 2016,
    county: 'BERKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.albright.edu/home/',
  },
  {
    name: 'MARSHALLTOWN COMMUNITY COLLEGE',
    address: '3700 S CENTER ST',
    city: 'MARSHALLTOWN',
    state: 'IA',
    zip: 50158,
    telephone: '(641) 752-7106',
    population: 2016,
    county: 'MARSHALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://mcc.iavalley.edu/',
  },
  {
    name: 'ENTERPRISE STATE COMMUNITY COLLEGE',
    address: '600 PLAZA DRIVE',
    city: 'ENTERPRISE',
    state: 'AL',
    zip: 36330,
    telephone: '(334) 347-2623',
    population: 2017,
    county: 'COFFEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.escc.edu/',
  },
  {
    name: 'CARDINAL STRITCH UNIVERSITY',
    address: '6801 N YATES RD',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53217,
    telephone: '(414) 410-4000',
    population: 2026,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stritch.edu/',
  },
  {
    name: 'PENINSULA COLLEGE',
    address: '1502 E LAURIDSEN BLVD',
    city: 'PORT ANGELES',
    state: 'WA',
    zip: 98362,
    telephone: '(360) 452-9277',
    population: 2026,
    county: 'CLALLAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pencol.edu/',
  },
  {
    name: 'STANBRIDGE UNIVERSITY',
    address: '2041 BUSINESS CTR DR STE 107',
    city: 'IRVINE',
    state: 'CA',
    zip: 92612,
    telephone: '(949) 794-9090 EXT 5104',
    population: 2027,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stanbridge.edu/',
  },
  {
    name: 'EAST TEXAS BAPTIST UNIVERSITY',
    address: 'ONE TIGER DRIVE',
    city: 'MARSHALL',
    state: 'TX',
    zip: 75670,
    telephone: '(903) 935-7963',
    population: 2031,
    county: 'HARRISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.etbu.edu/',
  },
  {
    name: 'RANDOLPH-MACON COLLEGE',
    address: '204 HENRY ST',
    city: 'ASHLAND',
    state: 'VA',
    zip: 23005,
    telephone: '(804) 752-7200',
    population: 2032,
    county: 'HANOVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rmc.edu/',
  },
  {
    name: 'DRURY UNIVERSITY',
    address: '900 N. BENTON AVE',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65802,
    telephone: '(417) 873-7879',
    population: 2032,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.drury.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS COMMUNITY COLLEGE-MORRILTON',
    address: '1537 UNIVERSITY BLVD.',
    city: 'MORRILTON',
    state: 'AR',
    zip: 72110,
    telephone: '(501) 977-2000',
    population: 2032,
    county: 'CONWAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.uaccm.edu/',
  },
  {
    name: 'SOUTHEASTERN TECHNICAL COLLEGE',
    address: '3001 E FIRST ST',
    city: 'VIDALIA',
    state: 'GA',
    zip: 30474,
    telephone: '(912) 538-3100',
    population: 2032,
    county: 'TOOMBS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southeasterntech.edu/',
  },
  {
    name: 'LIM COLLEGE',
    address: '12 E 53RD ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10022,
    telephone: '(212) 752-1530',
    population: 2033,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.limcollege.edu/',
  },
  {
    name: 'SOUTHWESTERN MICHIGAN COLLEGE',
    address: '58900 CHERRY GROVE RD',
    city: 'DOWAGIAC',
    state: 'MI',
    zip: 49047,
    telephone: '(269) 782-1000',
    population: 2034,
    county: 'CASS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.swmich.edu/',
  },
  {
    name: 'SARAH LAWRENCE COLLEGE',
    address: 'ONE MEADWAY',
    city: 'BRONXVILLE',
    state: 'NY',
    zip: 10708,
    telephone: '(914) 337-0700',
    population: 2037,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sarahlawrence.edu/',
  },
  {
    name: 'FEATHER RIVER COMMUNITY COLLEGE DISTRICT',
    address: '570 GOLDEN EAGLE AVE',
    city: 'QUINCY',
    state: 'CA',
    zip: 95971,
    telephone: '(530) 283-0202',
    population: 2038,
    county: 'PLUMAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.frc.edu/',
  },
  {
    name: 'SOUTH GEORGIA TECHNICAL COLLEGE',
    address: '900 SOUTH GA TECH PARKWAY',
    city: 'AMERICUS',
    state: 'GA',
    zip: 31709,
    telephone: '(229) 931-2394',
    population: 2038,
    county: 'SUMTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southgatech.edu/',
  },
  {
    name: 'KING UNIVERSITY',
    address: '1350 KING COLLEGE RD',
    city: 'BRISTOL',
    state: 'TN',
    zip: 37620,
    telephone: '(423) 968-1187',
    population: 2043,
    county: 'SULLIVAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.king.edu/',
  },
  {
    name: 'ROSEMAN UNIVERSITY OF HEALTH SCIENCES',
    address: '11 SUNSET WAY',
    city: 'HENDERSON',
    state: 'NV',
    zip: 89014,
    telephone: '(702) 990-4433',
    population: 2044,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.roseman.edu/',
  },
  {
    name: 'FRIENDS UNIVERSITY',
    address: '2100 W. UNIVERSITY AVE.',
    city: 'WICHITA',
    state: 'KS',
    zip: 67213,
    telephone: '(316) 295-5000',
    population: 2046,
    county: 'SEDGWICK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.friends.edu/',
  },
  {
    name: 'COLLEGE FOR CREATIVE STUDIES',
    address: '201 E KIRBY',
    city: 'DETROIT',
    state: 'MI',
    zip: 48202,
    telephone: '(313) 664-7400',
    population: 2046,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.collegeforcreativestudies.edu/',
  },
  {
    name: 'ROCKY MOUNTAIN COLLEGE OF ART AND DESIGN',
    address: '1600 PIERCE ST',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80214,
    telephone: '(303) 753-6046',
    population: 2046,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rmcad.edu/',
  },
  {
    name: 'CENTRAL WYOMING COLLEGE',
    address: '2660 PECK AVENUE',
    city: 'RIVERTON',
    state: 'WY',
    zip: 82501,
    telephone: '(800) 735-8418',
    population: 2052,
    county: 'FREMONT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cwc.edu/',
  },
  {
    name: 'UNIVERSITY OF SIOUX FALLS',
    address: '1101 W 22ND ST',
    city: 'SIOUX FALLS',
    state: 'SD',
    zip: 57105,
    telephone: '(605) 331-5000',
    population: 2053,
    county: 'MINNEHAHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usiouxfalls.edu/',
  },
  {
    name: "SAINT MARY'S COLLEGE",
    address: '133 LE MANS HALL',
    city: 'NOTRE DAME',
    state: 'IN',
    zip: 46556,
    telephone: '(574) 284-4000',
    population: 2054,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.saintmarys.edu/',
  },
  {
    name: 'BENEDICT COLLEGE',
    address: '1600 HARDEN STREET',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29204,
    telephone: '(803) 256-4220',
    population: 2055,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.benedict.edu/',
  },
  {
    name: 'RINGLING COLLEGE OF ART AND DESIGN',
    address: '2700 NORTH TAMIAMI TRAIL',
    city: 'SARASOTA',
    state: 'FL',
    zip: 34234,
    telephone: '(800) 255-7695',
    population: 2055,
    county: 'SARASOTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ringling.edu/',
  },
  {
    name: 'MINNESOTA STATE COLLEGE SOUTHEAST',
    address: '1250 HOMER RD',
    city: 'WINONA',
    state: 'MN',
    zip: 55987,
    telephone: '(507) 453-2700',
    population: 2055,
    county: 'WINONA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southeastmn.edu/',
  },
  {
    name: 'LUBBOCK CHRISTIAN UNIVERSITY',
    address: '5601 19TH STREET',
    city: 'LUBBOCK',
    state: 'TX',
    zip: 79407,
    telephone: '(806) 796-8800',
    population: 2056,
    county: 'LUBBOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lcu.edu/',
  },
  {
    name: 'WASHINGTON STATE COMMUNITY COLLEGE',
    address: '710 COLEGATE DR',
    city: 'MARIETTA',
    state: 'OH',
    zip: 45750,
    telephone: '(740) 374-8716',
    population: 2066,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wscc.edu/',
  },
  {
    name: 'THE UNIVERSITY OF THE ARTS',
    address: '320 SOUTH BROAD ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19102,
    telephone: '(800) 616-2787',
    population: 2074,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uarts.edu/',
  },
  {
    name: 'MOUNT MERCY UNIVERSITY',
    address: '1330 ELMHURST DR NE',
    city: 'CEDAR RAPIDS',
    state: 'IA',
    zip: 52402,
    telephone: '(319) 363-8213',
    population: 2074,
    county: 'LINN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtmercy.edu/',
  },
  {
    name: 'BRUNSWICK COMMUNITY COLLEGE',
    address: '50 COLLEGE RD',
    city: 'BOLIVIA',
    state: 'NC',
    zip: 28422,
    telephone: '(910) 755-7300',
    population: 2077,
    county: 'BRUNSWICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.brunswickcc.edu/',
  },
  {
    name: 'RANKEN TECHNICAL COLLEGE',
    address: '4431 FINNEY AVE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63113,
    telephone: '(314) 371-0236',
    population: 2077,
    county: 'ST. LOUIS CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ranken.edu/',
  },
  {
    name: 'BECKER COLLEGE',
    address: '61 SEVER ST',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1609,
    telephone: '(877) 523-2537',
    population: 2078,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.becker.edu/',
  },
  {
    name: 'CONCORD UNIVERSITY',
    address: '1000 VERMILLION STREET',
    city: 'ATHENS',
    state: 'WV',
    zip: 24712,
    telephone: '(888) 344-6679',
    population: 2080,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.concord.edu/',
  },
  {
    name: 'OUACHITA BAPTIST UNIVERSITY',
    address: '410 OUACHITA ST',
    city: 'ARKADELPHIA',
    state: 'AR',
    zip: 71998,
    telephone: '(870) 245-5000',
    population: 2083,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.obu.edu/',
  },
  {
    name: 'WALLA WALLA UNIVERSITY',
    address: '204 S COLLEGE AVE',
    city: 'COLLEGE PLACE',
    state: 'WA',
    zip: 99324,
    telephone: '(509) 527-2615',
    population: 2087,
    county: 'WALLA WALLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wallawalla.edu/',
  },
  {
    name: 'SAINT VINCENT COLLEGE',
    address: '300 FRASER PURCHASE RD',
    city: 'LATROBE',
    state: 'PA',
    zip: 15650,
    telephone: '(724) 539-9761',
    population: 2088,
    county: 'WESTMORELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stvincent.edu/',
  },
  {
    name: 'HULT INTERNATIONAL BUSINESS SCHOOL',
    address: '1 EDUCATION STREET',
    city: 'CAMBRIDGE',
    state: 'MA',
    zip: 2141,
    telephone: '(617) 619-1743',
    population: 2091,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hult.edu/',
  },
  {
    name: 'OKLAHOMA BAPTIST UNIVERSITY',
    address: '500 W UNIVERSITY',
    city: 'SHAWNEE',
    state: 'OK',
    zip: 74804,
    telephone: '(405) 275-2850',
    population: 2097,
    county: 'POTTAWATOMIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.okbu.edu/',
  },
  {
    name: 'BAY DE NOC COMMUNITY COLLEGE',
    address: '2001 N LINCOLN ROAD',
    city: 'ESCANABA',
    state: 'MI',
    zip: 49829,
    telephone: '(906) 786-5802',
    population: 2100,
    county: 'DELTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.baycollege.edu/',
  },
  {
    name: 'REND LAKE COLLEGE',
    address: '468 N KEN GRAY PKWY',
    city: 'INA',
    state: 'IL',
    zip: 62846,
    telephone: '(618) 437-5321',
    population: 2101,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rlc.edu/',
  },
  {
    name: 'NORTH CAROLINA WESLEYAN COLLEGE',
    address: '3400 N WESLEYAN BLVD',
    city: 'ROCKY MOUNT',
    state: 'NC',
    zip: 27804,
    telephone: '(252) 985-5100',
    population: 2102,
    county: 'NASH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ncwc.edu/',
  },
  {
    name: 'COLLEGE OF SAINT BENEDICT',
    address: '37 S. COLLEGE AVE.',
    city: 'SAINT JOSEPH',
    state: 'MN',
    zip: 56374,
    telephone: '(320) 363-5011',
    population: 2110,
    county: 'STEARNS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://csbsju.edu/',
  },
  {
    name: 'BELLINGHAM TECHNICAL COLLEGE',
    address: '3028 LINDBERGH AVE',
    city: 'BELLINGHAM',
    state: 'WA',
    zip: 98225,
    telephone: '(360) 752-7000',
    population: 2110,
    county: 'WHATCOM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.btc.edu/',
  },
  {
    name: 'CARL SANDBURG COLLEGE',
    address: '2400 TOM L. WILSON BOULEVARD',
    city: 'GALESBURG',
    state: 'IL',
    zip: 61401,
    telephone: '(309) 344-2518',
    population: 2115,
    county: 'KNOX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sandburg.edu/',
  },
  {
    name: 'ST. THOMAS AQUINAS COLLEGE',
    address: '125 RTE 340',
    city: 'SPARKILL',
    state: 'NY',
    zip: 10976,
    telephone: '(845) 398-4000',
    population: 2116,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stac.edu/',
  },
  {
    name: 'SOUTHWEST MISSISSIPPI COMMUNITY COLLEGE',
    address: '1156 COLLEGE DR',
    city: 'SUMMIT',
    state: 'MS',
    zip: 39666,
    telephone: '(601) 276-2000',
    population: 2117,
    county: 'PIKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.smcc.edu/',
  },
  {
    name: 'ILLINOIS WESLEYAN UNIVERSITY',
    address: '1312 N PARK ST',
    city: 'BLOOMINGTON',
    state: 'IL',
    zip: 61702,
    telephone: '(309) 556-1000',
    population: 2118,
    county: 'MCLEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iwu.edu/',
  },
  {
    name: 'FULTON-MONTGOMERY COMMUNITY COLLEGE',
    address: '2805 STATE HWY 67',
    city: 'JOHNSTOWN',
    state: 'NY',
    zip: 12095,
    telephone: '(518) 762-3622',
    population: 2119,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fmcc.edu/',
  },
  {
    name: 'SAN JOAQUIN VALLEY COLLEGE-VISALIA',
    address: '8344 W MINERAL KING AVE',
    city: 'VISALIA',
    state: 'CA',
    zip: 93291,
    telephone: '(559) 734-9000',
    population: 2121,
    county: 'TULARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjvc.edu/',
  },
  {
    name: 'MONTANA TECHNOLOGICAL UNIVERSITY',
    address: '1300 W PARK ST',
    city: 'BUTTE',
    state: 'MT',
    zip: 59701,
    telephone: '(406) 496-4256',
    population: 2122,
    county: 'SILVER BOW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mtech.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-FLORIDA',
    address: '5650 BRECKENRIDGE PARK DRIVE SUITE 300',
    city: 'TAMPA',
    state: 'FL',
    zip: 33610,
    telephone: '(877) 445-7180',
    population: 2122,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/florida/tampa-east',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY HEALTH SCIENCES CENTER-SHREVEPORT',
    address: '1501 KINGS HWY',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71103,
    telephone: '(318) 675-8769',
    population: 2123,
    county: 'CADDO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lsuhs.edu/',
  },
  {
    name: 'LOGAN UNIVERSITY',
    address: '1851 SCHOETTLER RD',
    city: 'CHESTERFIELD',
    state: 'MO',
    zip: 63017,
    telephone: '(636) 227-2100',
    population: 2125,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.logan.edu/',
  },
  {
    name: 'DOMINICAN COLLEGE OF BLAUVELT',
    address: '470 WESTERN HIGHWAY',
    city: 'ORANGEBURG',
    state: 'NY',
    zip: 10962,
    telephone: '(845) 359-7800',
    population: 2126,
    county: 'ROCKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dc.edu/',
  },
  {
    name: 'OCONEE FALL LINE TECHNICAL COLLEGE',
    address: '1189 DEEPSTEP RD',
    city: 'SANDERSVILLE',
    state: 'GA',
    zip: 31082,
    telephone: '(478) 553-2050',
    population: 2126,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oftc.edu/',
  },
  {
    name: 'SAINT JOHNS UNIVERSITY',
    address: '2850 ABBEY PLAZA',
    city: 'COLLEGEVILLE',
    state: 'MN',
    zip: 56321,
    telephone: '(320) 363-2011',
    population: 2134,
    county: 'STEARNS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://csbsju.edu/',
  },
  {
    name: 'PERU STATE COLLEGE',
    address: '600 HOYT STREET',
    city: 'PERU',
    state: 'NE',
    zip: 68421,
    telephone: '(402) 872-3815',
    population: 2134,
    county: 'NEMAHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.peru.edu/',
  },
  {
    name: 'GRANITE STATE COLLEGE',
    address: '25 HALL STREET',
    city: 'CONCORD',
    state: 'NH',
    zip: 3301,
    telephone: '(603) 228-3000',
    population: 2135,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.granite.edu/',
  },
  {
    name: 'REDLANDS COMMUNITY COLLEGE',
    address: '1300 S COUNTRY CLUB RD',
    city: 'EL RENO',
    state: 'OK',
    zip: 73036,
    telephone: '(405) 262-2552',
    population: 2140,
    county: 'CANADIAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.redlandscc.edu/',
  },
  {
    name: 'MANSFIELD UNIVERSITY OF PENNSYLVANIA',
    address: '5 SWAN STREET',
    city: 'MANSFIELD',
    state: 'PA',
    zip: 16933,
    telephone: '(570) 662-4000',
    population: 2142,
    county: 'TIOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mansfield.edu/',
  },
  {
    name: 'ENSIGN COLLEGE',
    address: '95 NORTH 300 WEST',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84101,
    telephone: '(801) 524-8100',
    population: 2142,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ensign.edu/',
  },
  {
    name: "SAINT MICHAEL'S COLLEGE",
    address: 'ONE WINOOSKI PARK',
    city: 'COLCHESTER',
    state: 'VT',
    zip: 5439,
    telephone: '(802) 654-2000',
    population: 2143,
    county: 'CHITTENDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smcvt.edu/',
  },
  {
    name: 'ALLEGHENY COLLEGE',
    address: '520 N MAIN ST',
    city: 'MEADVILLE',
    state: 'PA',
    zip: 16335,
    telephone: '(814) 332-3100',
    population: 2143,
    county: 'CRAWFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://allegheny.edu/',
  },
  {
    name: 'MECH-TECH COLLEGE',
    address: 'NUM 39-40 B ST W INDUSTRIAL PK',
    city: 'CAGUAS',
    state: 'PR',
    zip: 725,
    telephone: '(787) 744-1060 EXT 1000',
    population: 2144,
    county: 'CAGUAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mechtech.edu/',
  },
  {
    name: 'NEW YORK FILM ACADEMY',
    address: '3300 WEST RIVERSIDE DRIVE',
    city: 'BURBANK',
    state: 'CA',
    zip: 91505,
    telephone: '(818) 333-3558',
    population: 2149,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyfa.edu/',
  },
  {
    name: 'NORTHWESTERN OKLAHOMA STATE UNIVERSITY',
    address: '709 OKLAHOMA BLVD',
    city: 'ALVA',
    state: 'OK',
    zip: 73717,
    telephone: '(580) 327-1700',
    population: 2151,
    county: 'WOODS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nwosu.edu/',
  },
  {
    name: 'MIDAMERICA NAZARENE UNIVERSITY',
    address: '2030 E COLLEGE WAY',
    city: 'OLATHE',
    state: 'KS',
    zip: 66062,
    telephone: '(913) 782-3750',
    population: 2156,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mnu.edu/',
  },
  {
    name: 'MIDLAND UNIVERSITY',
    address: '900 N. CLARKSON ST.',
    city: 'FREMONT',
    state: 'NE',
    zip: 68025,
    telephone: '(800) 642-8382',
    population: 2158,
    county: 'DODGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.midlandu.edu/',
  },
  {
    name: 'CARL ALBERT STATE COLLEGE',
    address: '1507 S MCKENNA',
    city: 'POTEAU',
    state: 'OK',
    zip: 74953,
    telephone: '(918) 647-1200',
    population: 2160,
    county: 'LE FLORE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.carlalbert.edu/',
  },
  {
    name: 'WILSON COMMUNITY COLLEGE',
    address: '902 HERRING AVE',
    city: 'WILSON',
    state: 'NC',
    zip: 27893,
    telephone: '(252) 291-1195',
    population: 2162,
    county: 'WILSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wilsoncc.edu/',
  },
  {
    name: 'BIG BEND COMMUNITY COLLEGE',
    address: '7662 CHANUTE ST NE',
    city: 'MOSES LAKE',
    state: 'WA',
    zip: 98837,
    telephone: '(509) 793-2222',
    population: 2162,
    county: 'GRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bigbend.edu/',
  },
  {
    name: 'WESTERN PIEDMONT COMMUNITY COLLEGE',
    address: '1001 BURKEMONT AVE',
    city: 'MORGANTON',
    state: 'NC',
    zip: 28655,
    telephone: '(828) 448-3500',
    population: 2165,
    county: 'BURKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wpcc.edu/',
  },
  {
    name: 'MISSOURI STATE UNIVERSITY-WEST PLAINS',
    address: '128 GARFIELD AVENUE',
    city: 'WEST PLAINS',
    state: 'MO',
    zip: 65775,
    telephone: '(417) 255-7255',
    population: 2167,
    county: 'HOWELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'wp.missouristate.edu/',
  },
  {
    name: 'NATIONAL PARK COLLEGE',
    address: '101 COLLEGE DR',
    city: 'HOT SPRINGS',
    state: 'AR',
    zip: 71913,
    telephone: '(501) 760-4222',
    population: 2171,
    county: 'GARLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.np.edu/',
  },
  {
    name: 'AMERICAN MUSICAL AND DRAMATIC ACADEMY',
    address: '211 WEST 61ST STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10023,
    telephone: '(212) 787-5300 EXT 3331',
    population: 2172,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amda.edu/',
  },
  {
    name: 'GALLAUDET UNIVERSITY',
    address: '800 FLORIDA AVE, NE',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20002,
    telephone: '(202) 651-5000',
    population: 2174,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gallaudet.edu/',
  },
  {
    name: 'ASBURY UNIVERSITY',
    address: '1 MACKLEM DR',
    city: 'WILMORE',
    state: 'KY',
    zip: 40390,
    telephone: '(859) 858-3511',
    population: 2175,
    county: 'JESSAMINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asbury.edu/',
  },
  {
    name: 'TRINITY WASHINGTON UNIVERSITY',
    address: '125 MICHIGAN AVE NE',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20017,
    telephone: '(202) 884-9050',
    population: 2179,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.trinitydc.edu/',
  },
  {
    name: 'WHEATON COLLEGE',
    address: '26 E MAIN ST',
    city: 'NORTON',
    state: 'MA',
    zip: 2766,
    telephone: '(508) 286-8200',
    population: 2179,
    county: 'BRISTOL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wheatoncollege.edu/',
  },
  {
    name: 'PENNSYLVANIA COLLEGE OF HEALTH SCIENCES',
    address: '850 GREENFIELD ROAD',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17601,
    telephone: '(800) 622-5443',
    population: 2183,
    county: 'LANCASTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.pacollege.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-ZANESVILLE CAMPUS',
    address: '1425 NEWARK RD',
    city: 'ZANESVILLE',
    state: 'OH',
    zip: 43701,
    telephone: '(740) 453-0762',
    population: 2185,
    county: 'MUSKINGUM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ohio.edu/zanesville/',
  },
  {
    name: 'STRAYER UNIVERSITY-PENNSYLVANIA',
    address: '3800 HORIZON BLVD STE 100',
    city: 'TREVOSE',
    state: 'PA',
    zip: 19053,
    telephone: '(877) 445-7180',
    population: 2190,
    county: 'BUCKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.strayer.edu/campus-locations/pennsylvania/lower-bucks-county',
  },
  {
    name: 'JOHN WOOD COMMUNITY COLLEGE',
    address: '1301 S 48TH STREET',
    city: 'QUINCY',
    state: 'IL',
    zip: 62305,
    telephone: '(217) 224-6500',
    population: 2194,
    county: 'ADAMS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jwcc.edu/',
  },
  {
    name: 'AIKEN TECHNICAL COLLEGE',
    address: '2276 JEFFERSON DAVIS HIGHWAY',
    city: 'GRANITEVILLE',
    state: 'SC',
    zip: 29829,
    telephone: '(803) 508-7263',
    population: 2202,
    county: 'AIKEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.atc.edu/',
  },
  {
    name: 'GARDEN CITY COMMUNITY COLLEGE',
    address: '801 CAMPUS DR',
    city: 'GARDEN CITY',
    state: 'KS',
    zip: 67846,
    telephone: '(620) 276-7611 EXT 571',
    population: 2204,
    county: 'FINNEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gcccks.edu/',
  },
  {
    name: 'CHIPOLA COLLEGE',
    address: '3094 INDIAN CIRCLE',
    city: 'MARIANNA',
    state: 'FL',
    zip: 32446,
    telephone: '(850) 526-2761',
    population: 2205,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chipola.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT ASHTABULA',
    address: '3300 LAKE ROAD WEST',
    city: 'ASHTABULA',
    state: 'OH',
    zip: 44004,
    telephone: '(440) 964-3322',
    population: 2207,
    county: 'ASHTABULA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/ashtabula',
  },
  {
    name: 'GRACE COLLEGE AND THEOLOGICAL SEMINARY',
    address: '200 SEMINARY DR',
    city: 'WINONA LAKE',
    state: 'IN',
    zip: 46590,
    telephone: '(574) 372-5100',
    population: 2208,
    county: 'KOSCIUSKO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.grace.edu/',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY-NEWPORT',
    address: '7648 VICTORY BLVD',
    city: 'NEWPORT',
    state: 'AR',
    zip: 72112,
    telephone: '(870) 512-7800',
    population: 2210,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asun.edu/',
  },
  {
    name: 'SOUTHERN STATE COMMUNITY COLLEGE',
    address: '100 HOBART DRIVE',
    city: 'HILLSBORO',
    state: 'OH',
    zip: 45133,
    telephone: '(937) 393-3431',
    population: 2212,
    county: 'HIGHLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sscc.edu/',
  },
  {
    name: 'ROBESON COMMUNITY COLLEGE',
    address: '5160 FAYETTEVILLE ROAD',
    city: 'LUMBERTON',
    state: 'NC',
    zip: 28360,
    telephone: '(910) 272-3700',
    population: 2215,
    county: 'ROBESON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.robeson.edu/',
  },
  {
    name: 'ECKERD COLLEGE',
    address: '4200 54TH AVE S',
    city: 'SAINT PETERSBURG',
    state: 'FL',
    zip: 33711,
    telephone: '(727) 867-1166',
    population: 2228,
    county: 'PINELLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eckerd.edu/',
  },
  {
    name: 'LIMESTONE UNIVERSITY',
    address: '1115 COLLEGE DRIVE',
    city: 'GAFFNEY',
    state: 'SC',
    zip: 29340,
    telephone: '(800) 795-7151 EXT 0',
    population: 2229,
    county: 'CHEROKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.limestone.edu/',
  },
  {
    name: 'WOFFORD COLLEGE',
    address: '429 N CHURCH ST',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29303,
    telephone: '(864) 597-4000',
    population: 2237,
    county: 'SPARTANBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wofford.edu/',
  },
  {
    name: 'EASTERN MAINE COMMUNITY COLLEGE',
    address: '354 HOGAN RD',
    city: 'BANGOR',
    state: 'ME',
    zip: 4401,
    telephone: '(207) 974-4600',
    population: 2237,
    county: 'PENOBSCOT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.emcc.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-CALIFORNIA',
    address: '2970 E INLAND EMPIRE BLVD, STE 100',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91764,
    telephone: '(909) 622-8866',
    population: 2239,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'GRAND VIEW UNIVERSITY',
    address: '1200 GRANDVIEW AVE',
    city: 'DES MOINES',
    state: 'IA',
    zip: 50316,
    telephone: '(515) 263-2800',
    population: 2243,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.grandview.edu/',
  },
  {
    name: 'BOWLING GREEN STATE UNIVERSITY-FIRELANDS',
    address: 'ONE UNIVERSITY DRIVE',
    city: 'HURON',
    state: 'OH',
    zip: 44839,
    telephone: '(419) 372-5526',
    population: 2246,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.firelands.bgsu.edu/',
  },
  {
    name: 'CONNORS STATE COLLEGE',
    address: '700 COLLEGE ROAD',
    city: 'WARNER',
    state: 'OK',
    zip: 74469,
    telephone: '(918) 463-2931',
    population: 2249,
    county: 'MUSKOGEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'connorsstate.edu/',
  },
  {
    name: 'PIMA MEDICAL INSTITUTE-TUCSON',
    address: '2121 N CRAYCROFT ROAD, BLDG 1',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85712,
    telephone: '(520) 326-1600',
    population: 2253,
    county: 'PIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pmi.edu/',
  },
  {
    name: 'SNEAD STATE COMMUNITY COLLEGE',
    address: '102 ELDER STREET',
    city: 'BOAZ',
    state: 'AL',
    zip: 35957,
    telephone: '(256) 593-5120',
    population: 2256,
    county: 'MARSHALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.snead.edu/',
  },
  {
    name: 'CHESAPEAKE COLLEGE',
    address: '1000 COLLEGE CIRCLE',
    city: 'WYE MILLS',
    state: 'MD',
    zip: 21679,
    telephone: '(410) 822-5400',
    population: 2257,
    county: "QUEEN ANNE'S",
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.chesapeake.edu/',
  },
  {
    name: 'ADVENTHEALTH UNIVERSITY',
    address: '671 WINYAH DRIVE',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32803,
    telephone: '(407) 303-7742',
    population: 2259,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ahu.edu/',
  },
  {
    name: 'SOUTH GEORGIA STATE COLLEGE',
    address: '100 W COLLEGE PARK DR',
    city: 'DOUGLAS',
    state: 'GA',
    zip: 31533,
    telephone: '(912) 260-4200',
    population: 2259,
    county: 'COFFEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sgsc.edu/',
  },
  {
    name: 'UNIVERSITY OF MAINE AT FARMINGTON',
    address: '224 MAIN ST.',
    city: 'FARMINGTON',
    state: 'ME',
    zip: 4938,
    telephone: '(207) 778-7000',
    population: 2260,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.umf.maine.edu/',
  },
  {
    name: 'ROCKINGHAM COMMUNITY COLLEGE',
    address: '215 WRENN MEMORIAL ROAD',
    city: 'WENTWORTH',
    state: 'NC',
    zip: 27375,
    telephone: '(336) 342-4261',
    population: 2264,
    county: 'ROCKINGHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rockinghamcc.edu/',
  },
  {
    name: "THE UNIVERSITY OF VIRGINIA'S COLLEGE AT WISE",
    address: '1 COLLEGE AVENUE',
    city: 'WISE',
    state: 'VA',
    zip: 24293,
    telephone: '(276) 328-0100',
    population: 2269,
    county: 'WISE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uvawise.edu/',
  },
  {
    name: 'SOUTHWESTERN ASSEMBLIES OF GOD UNIVERSITY',
    address: '1200 SYCAMORE',
    city: 'WAXAHACHIE',
    state: 'TX',
    zip: 75165,
    telephone: '(888) 937-7248',
    population: 2273,
    county: 'ELLIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sagu.edu/',
  },
  {
    name: 'WILLIAM JESSUP UNIVERSITY',
    address: '2121 UNIVERSITY AVENUE',
    city: 'ROCKLIN',
    state: 'CA',
    zip: 95765,
    telephone: '(916) 577-2200',
    population: 2275,
    county: 'PLACER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jessup.edu/',
  },
  {
    name: 'METHODIST UNIVERSITY',
    address: '5400 RAMSEY ST',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28311,
    telephone: '(910) 630-7000',
    population: 2276,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.methodist.edu/',
  },
  {
    name: 'KENYON COLLEGE',
    address: 'KENYON COLLEGE',
    city: 'GAMBIER',
    state: 'OH',
    zip: 43022,
    telephone: '(740) 427-5000',
    population: 2276,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kenyon.edu/',
  },
  {
    name: 'STRATFORD UNIVERSITY',
    address: '2900 EISENHOWER AVENUE',
    city: 'ALEXANDRIA',
    state: 'VA',
    zip: 22314,
    telephone: '(703) 539-6890',
    population: 2277,
    county: 'ALEXANDRIA CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stratford.edu/',
  },
  {
    name: 'GROVE CITY COLLEGE',
    address: '100 CAMPUS DR',
    city: 'GROVE CITY',
    state: 'PA',
    zip: 16127,
    telephone: '(724) 458-2000',
    population: 2277,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcc.edu/',
  },
  {
    name: 'ADRIAN COLLEGE',
    address: '110 S MADISON ST',
    city: 'ADRIAN',
    state: 'MI',
    zip: 49221,
    telephone: '(517) 265-5161',
    population: 2285,
    county: 'LENAWEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.adrian.edu/',
  },
  {
    name: 'UNITED STATES UNIVERSITY',
    address: '7675 MISSION VALLEY ROAD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92108,
    telephone: '(619) 876-4250',
    population: 2286,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usuniversity.edu/',
  },
  {
    name: 'HOPKINSVILLE COMMUNITY COLLEGE',
    address: '720 NORTH DR.',
    city: 'HOPKINSVILLE',
    state: 'KY',
    zip: 42240,
    telephone: '(270) 707-3700',
    population: 2286,
    county: 'CHRISTIAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://hopkinsville.kctcs.edu/index.aspx',
  },
  {
    name: 'TOURO UNIVERSITY WORLDWIDE',
    address: '10601 CALLE LEE #179',
    city: 'LOS ALAMITOS',
    state: 'CA',
    zip: 90720,
    telephone: '(818) 575-6800',
    population: 2290,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tuw.edu/',
  },
  {
    name: 'LAKE SUPERIOR STATE UNIVERSITY',
    address: '650 W EASTERDAY AVE',
    city: 'SAULT STE MARIE',
    state: 'MI',
    zip: 49783,
    telephone: '(906) 632-6841',
    population: 2291,
    county: 'CHIPPEWA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lssu.edu/',
  },
  {
    name: 'POMONA COLLEGE',
    address: '550 N COLLEGE AVE',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8131',
    population: 2296,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pomona.edu/',
  },
  {
    name: 'UNIVERSITY OF MOBILE',
    address: '5735 COLLEGE PARKWAY',
    city: 'MOBILE',
    state: 'AL',
    zip: 36613,
    telephone: '(251) 675-5990',
    population: 2299,
    county: 'MOBILE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umobile.edu/',
  },
  {
    name: 'VIRGINIA HIGHLANDS COMMUNITY COLLEGE',
    address: '100 VHCC DRIVE',
    city: 'ABINGDON',
    state: 'VA',
    zip: 24212,
    telephone: '(276) 739-2400',
    population: 2301,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vhcc.edu/',
  },
  {
    name: 'CALIFORNIA COLLEGE OF THE ARTS',
    address: '1111 EIGHTH STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94107,
    telephone: '(510) 594-3600',
    population: 2311,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cca.edu/',
  },
  {
    name: 'MARYMOUNT MANHATTAN COLLEGE',
    address: '221 E 71ST ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10021,
    telephone: '(212) 517-0400',
    population: 2311,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mmm.edu/',
  },
  {
    name: 'GRINNELL COLLEGE',
    address: '1121 PARK STREET',
    city: 'GRINNELL',
    state: 'IA',
    zip: 50112,
    telephone: '(641) 269-4000',
    population: 2313,
    county: 'POWESHIEK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.grinnell.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-OLIVE-HARVEY COLLEGE',
    address: '10001 S WOODLAWN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60628,
    telephone: '(773) 291-6100',
    population: 2318,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ccc.edu/colleges/olive-harvey/pages/default.aspx',
  },
  {
    name: 'FLETCHER TECHNICAL COMMUNITY COLLEGE',
    address: '1407 HIGHWAY 311',
    city: 'SCHRIEVER',
    state: 'LA',
    zip: 70395,
    telephone: '(985) 448-7900',
    population: 2318,
    county: 'TERREBONNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fletcher.edu/',
  },
  {
    name: 'ALVERNO COLLEGE',
    address: '3400 S 43RD ST',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53234,
    telephone: '(414) 382-6000',
    population: 2319,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.alverno.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW MEXICO-GALLUP CAMPUS',
    address: '705 GURLEY AVE.',
    city: 'GALLUP',
    state: 'NM',
    zip: 87301,
    telephone: '(505) 863-7500',
    population: 2321,
    county: 'MCKINLEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gallup.unm.edu/',
  },
  {
    name: 'CORNERSTONE UNIVERSITY',
    address: '1001 E BELTLINE AVE NE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49525,
    telephone: '(616) 949-5300',
    population: 2322,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cornerstone.edu/',
  },
  {
    name: 'GALVESTON COLLEGE',
    address: '4015 AVE Q',
    city: 'GALVESTON',
    state: 'TX',
    zip: 77550,
    telephone: '(409) 944-1220',
    population: 2323,
    county: 'GALVESTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gc.edu/',
  },
  {
    name: 'COLLEGE OF EASTERN IDAHO',
    address: '1600 S 25TH E',
    city: 'IDAHO FALLS',
    state: 'ID',
    zip: 83404,
    telephone: '(208) 535-3000 EXT 3371',
    population: 2323,
    county: 'BONNEVILLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cei.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-KENNEDY-KING COLLEGE',
    address: '6301 S HALSTED ST',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60621,
    telephone: '(773) 602-5000',
    population: 2326,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccc.edu/colleges/kennedy/pages/default.aspx',
  },
  {
    name: 'FIDM-FASHION INSTITUTE OF DESIGN & MERCHANDISING-LOS ANGELES',
    address: '919 S GRAND AVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90015,
    telephone: '(213) 624-1200',
    population: 2327,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fidm.edu/',
  },
  {
    name: 'HILLSDALE COLLEGE',
    address: '33 E COLLEGE ST',
    city: 'HILLSDALE',
    state: 'MI',
    zip: 49242,
    telephone: '(517) 437-7341',
    population: 2327,
    county: 'HILLSDALE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hillsdale.edu/',
  },
  {
    name: 'ALLEN COUNTY COMMUNITY COLLEGE',
    address: '1801 N COTTONWOOD',
    city: 'IOLA',
    state: 'KS',
    zip: 66749,
    telephone: '(620) 365-5116 EXT 100',
    population: 2329,
    county: 'ALLEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.allencc.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE',
    address: '11600 COLUMBIA COLLEGE DR',
    city: 'SONORA',
    state: 'CA',
    zip: 95370,
    telephone: '(209) 588-5100',
    population: 2330,
    county: 'TUOLUMNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gocolumbia.edu/',
  },
  {
    name: 'NUNEZ COMMUNITY COLLEGE',
    address: '3710 PARIS RD',
    city: 'CHALMETTE',
    state: 'LA',
    zip: 70043,
    telephone: '(504) 278-6200',
    population: 2332,
    county: 'ST. BERNARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nunez.edu/',
  },
  {
    name: 'MIDDLESEX COMMUNITY COLLEGE',
    address: '100 TRAINING HILL RD',
    city: 'MIDDLETOWN',
    state: 'CT',
    zip: 6457,
    telephone: '(860) 343-5701',
    population: 2332,
    county: 'MIDDLESEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mxcc.edu/',
  },
  {
    name: 'LUTHER COLLEGE',
    address: '700 COLLEGE DRIVE',
    city: 'DECORAH',
    state: 'IA',
    zip: 52101,
    telephone: '(563) 387-2000',
    population: 2337,
    county: 'WINNESHIEK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.luther.edu/',
  },
  {
    name: 'MEREDITH COLLEGE',
    address: '3800 HILLSBOROUGH ST',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27607,
    telephone: '(919) 760-8600',
    population: 2340,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.meredith.edu/',
  },
  {
    name: 'FLATHEAD VALLEY COMMUNITY COLLEGE',
    address: '777 GRANDVIEW DR',
    city: 'KALISPELL',
    state: 'MT',
    zip: 59901,
    telephone: '(406) 756-3822',
    population: 2340,
    county: 'FLATHEAD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fvcc.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA BEAUFORT',
    address: '1 UNIVERSITY BOULEVARD',
    city: 'BLUFFTON',
    state: 'SC',
    zip: 29909,
    telephone: '(843) 208-8000',
    population: 2346,
    county: 'BEAUFORT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uscb.edu/',
  },
  {
    name: 'WABASH VALLEY COLLEGE',
    address: '2200 COLLEGE DRIVE',
    city: 'MOUNT CARMEL',
    state: 'IL',
    zip: 62863,
    telephone: '(618) 393-2982',
    population: 2346,
    county: 'WABASH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iecc.edu/wvc',
  },
  {
    name: 'CHRISTIAN BROTHERS UNIVERSITY',
    address: '650 EAST PARKWAY SOUTH',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38104,
    telephone: '(901) 321-3000',
    population: 2347,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cbu.edu/',
  },
  {
    name: 'PATRICK HENRY COMMUNITY COLLEGE',
    address: '645 PATRIOT AVENUE',
    city: 'MARTINSVILLE',
    state: 'VA',
    zip: 24112,
    telephone: '(276) 656-0200',
    population: 2350,
    county: 'HENRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.patrickhenry.edu/',
  },
  {
    name: 'EMMANUEL COLLEGE',
    address: '400 THE FENWAY',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 735-9715',
    population: 2351,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emmanuel.edu/',
  },
  {
    name: 'THOMAS MORE UNIVERSITY',
    address: '333 THOMAS MORE PARKWAY',
    city: 'CRESTVIEW HILLS',
    state: 'KY',
    zip: 41017,
    telephone: '(859) 341-5800',
    population: 2351,
    county: 'KENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.thomasmore.edu/',
  },
  {
    name: 'TECHNICAL COLLEGE OF THE LOWCOUNTRY',
    address: '921 RIBAUT ROAD',
    city: 'BEAUFORT',
    state: 'SC',
    zip: 29901,
    telephone: '(800) 768-8252',
    population: 2354,
    county: 'BEAUFORT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tcl.edu/',
  },
  {
    name: 'UNIVERSITY OF CONNECTICUT-STAMFORD',
    address: 'ONE UNIVERSITY PLACE',
    city: 'STAMFORD',
    state: 'CT',
    zip: 6901,
    telephone: '(203) 251-8400',
    population: 2354,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'stamford.uconn.edu/',
  },
  {
    name: 'CLAREMONT GRADUATE UNIVERSITY',
    address: '150 E TENTH ST',
    city: 'CLAREMONT',
    state: 'CA',
    zip: 91711,
    telephone: '(909) 621-8000',
    population: 2355,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cgu.edu/',
  },
  {
    name: 'BUENA VISTA UNIVERSITY',
    address: '610 W 4TH ST',
    city: 'STORM LAKE',
    state: 'IA',
    zip: 50588,
    telephone: '(712) 749-2400',
    population: 2355,
    county: 'BUENA VISTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bvu.edu/',
  },
  {
    name: 'VIRGINIA MILITARY INSTITUTE',
    address: 'VMI PARADE',
    city: 'LEXINGTON',
    state: 'VA',
    zip: 24450,
    telephone: '(540) 464-7207',
    population: 2355,
    county: 'LEXINGTON CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vmi.edu/',
  },
  {
    name: 'MARION TECHNICAL COLLEGE',
    address: '1467 MOUNT VERNON AVE',
    city: 'MARION',
    state: 'OH',
    zip: 43302,
    telephone: '(740) 389-4636',
    population: 2362,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mtc.edu/',
  },
  {
    name: 'NYACK COLLEGE',
    address: '2 WASHINGTON STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10004,
    telephone: '(212) 625-0500',
    population: 2365,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyack.edu/consumerinfo',
  },
  {
    name: 'SETON HILL UNIVERSITY',
    address: '1 SETON HILL DRIVE',
    city: 'GREENSBURG',
    state: 'PA',
    zip: 15601,
    telephone: '(724) 834-2200',
    population: 2366,
    county: 'WESTMORELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.setonhill.edu/',
  },
  {
    name: 'DOMINICAN UNIVERSITY OF CALIFORNIA',
    address: '50 ACACIA AVE',
    city: 'SAN RAFAEL',
    state: 'CA',
    zip: 94901,
    telephone: '(415) 457-4440',
    population: 2369,
    county: 'MARIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.dominican.edu/',
  },
  {
    name: 'BEREA COLLEGE',
    address: '101 CHESTNUT STREET',
    city: 'BEREA',
    state: 'KY',
    zip: 40404,
    telephone: '(859) 985-3000',
    population: 2371,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.berea.edu/',
  },
  {
    name: 'LANGSTON UNIVERSITY',
    address: '102 PAGE HALL',
    city: 'LANGSTON',
    state: 'OK',
    zip: 73050,
    telephone: '(405) 466-3428',
    population: 2374,
    county: 'LOGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.langston.edu/',
  },
  {
    name: 'NEBRASKA WESLEYAN UNIVERSITY',
    address: '5000 ST PAUL AVE',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68504,
    telephone: '(402) 466-2371',
    population: 2374,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nebrwesleyan.edu/',
  },
  {
    name: 'CENTRAL LOUISIANA TECHNICAL COMMUNITY COLLEGE',
    address: '516 MURRAY STREET',
    city: 'ALEXANDRIA',
    state: 'LA',
    zip: 71301,
    telephone: '(318) 487-5443',
    population: 2379,
    county: 'RAPIDES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cltcc.edu/',
  },
  {
    name: 'MAHARISHI INTERNATIONAL UNIVERSITY',
    address: '1000 NORTH 4TH STREET',
    city: 'FAIRFIELD',
    state: 'IA',
    zip: 52557,
    telephone: '(641) 472-7000 EXT 5514',
    population: 2382,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mum.edu/',
  },
  {
    name: 'EVANGEL UNIVERSITY',
    address: '1111 N GLENSTONE',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65802,
    telephone: '(417) 865-2815',
    population: 2387,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.evangel.edu/',
  },
  {
    name: 'MISSISSIPPI DELTA COMMUNITY COLLEGE',
    address: 'HWY 3 AND CHERRY ST',
    city: 'MOORHEAD',
    state: 'MS',
    zip: 38761,
    telephone: '(662) 246-6322',
    population: 2388,
    county: 'SUNFLOWER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.msdelta.edu/',
  },
  {
    name: 'BRYN MAWR COLLEGE',
    address: '101 N MERION AVENUE',
    city: 'BRYN MAWR',
    state: 'PA',
    zip: 19010,
    telephone: '(610) 526-5000',
    population: 2389,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brynmawr.edu/',
  },
  {
    name: 'ELIZABETH CITY STATE UNIVERSITY',
    address: '1704 WEEKSVILLE RD',
    city: 'ELIZABETH CITY',
    state: 'NC',
    zip: 27909,
    telephone: '(252) 335-3400',
    population: 2390,
    county: 'PASQUOTANK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ecsu.edu/',
  },
  {
    name: 'TERRA STATE COMMUNITY COLLEGE',
    address: '2830 NAPOLEON RD',
    city: 'FREMONT',
    state: 'OH',
    zip: 43420,
    telephone: '(419) 334-8400',
    population: 2395,
    county: 'SANDUSKY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.terra.edu/',
  },
  {
    name: 'ZANE STATE COLLEGE',
    address: '1555 NEWARK RD',
    city: 'ZANESVILLE',
    state: 'OH',
    zip: 43701,
    telephone: '(740) 588-5000',
    population: 2395,
    county: 'MUSKINGUM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.zanestate.edu/',
  },
  {
    name: 'POINT UNIVERSITY',
    address: '507 WEST 10TH STREET',
    city: 'WEST POINT',
    state: 'GA',
    zip: 31833,
    telephone: '(706) 385-1000',
    population: 2397,
    county: 'TROUP',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'point.edu/',
  },
  {
    name: 'LA SIERRA UNIVERSITY',
    address: '4500 RIVERWALK PARKWAY',
    city: 'RIVERSIDE',
    state: 'CA',
    zip: 92505,
    telephone: '(951) 785-2000',
    population: 2397,
    county: 'RIVERSIDE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://lasierra.edu/',
  },
  {
    name: 'DEPAUW UNIVERSITY',
    address: '313 S LOCUST ST',
    city: 'GREENCASTLE',
    state: 'IN',
    zip: 46135,
    telephone: '(765) 658-4800',
    population: 2399,
    county: 'PUTNAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.depauw.edu/',
  },
  {
    name: 'RICHARD BLAND COLLEGE',
    address: '11301 JOHNSON ROAD',
    city: 'SOUTH PRINCE GEORGE',
    state: 'VA',
    zip: 23805,
    telephone: '(804) 862-6100',
    population: 2403,
    county: 'DINWIDDIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rbc.edu/',
  },
  {
    name: 'HONDROS COLLEGE OF NURSING',
    address: '4140 EXECUTIVE PARKWAY',
    city: 'WESTERVILLE',
    state: 'OH',
    zip: 43081,
    telephone: '(855) 906-8773',
    population: 2409,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hondros.edu/',
  },
  {
    name: 'HOBART WILLIAM SMITH COLLEGES',
    address: '337 PULTENEY STREET',
    city: 'GENEVA',
    state: 'NY',
    zip: 14456,
    telephone: '(315) 781-3000',
    population: 2410,
    county: 'ONTARIO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hws.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT TRUMBULL',
    address: '4314 MAHONING AVE N.W.',
    city: 'WARREN',
    state: 'OH',
    zip: 44483,
    telephone: '(330) 847-0571',
    population: 2410,
    county: 'TRUMBULL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/trumbull',
  },
  {
    name: 'RHODES COLLEGE',
    address: '2000 NORTH PARKWAY',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38112,
    telephone: '(901) 843-3000',
    population: 2411,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rhodes.edu/',
  },
  {
    name: 'UNIVERSITY OF ALASKA SOUTHEAST',
    address: '11066 AUKE LAKE WAY',
    city: 'JUNEAU',
    state: 'AK',
    zip: 99801,
    telephone: '(877) 465-4827',
    population: 2413,
    county: 'JUNEAU CITY AND BOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uas.alaska.edu/',
  },
  {
    name: 'MILLIKIN UNIVERSITY',
    address: '1184 W MAIN ST',
    city: 'DECATUR',
    state: 'IL',
    zip: 62522,
    telephone: '(217) 424-6211',
    population: 2414,
    county: 'MACON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://millikin.edu/',
  },
  {
    name: 'KETTERING UNIVERSITY',
    address: '1700 UNIVERSITY AVENUE',
    city: 'FLINT',
    state: 'MI',
    zip: 48504,
    telephone: '(800) 955-4464',
    population: 2415,
    county: 'GENESEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kettering.edu/',
  },
  {
    name: 'NEWMAN UNIVERSITY',
    address: '3100 MCCORMICK AVE',
    city: 'WICHITA',
    state: 'KS',
    zip: 67213,
    telephone: '(316) 942-4291',
    population: 2416,
    county: 'SEDGWICK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newmanu.edu/',
  },
  {
    name: 'ELIZABETHTOWN COLLEGE',
    address: 'ONE ALPHA DRIVE',
    city: 'ELIZABETHTOWN',
    state: 'PA',
    zip: 17022,
    telephone: '(717) 361-1000',
    population: 2419,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.etown.edu/',
  },
  {
    name: 'COLLEGE OF MICRONESIA-FSM',
    address: 'KOLONIA',
    city: 'POHNPEI',
    state: 'FM',
    zip: 96941,
    telephone: '(691) 320-2480 EXT 100',
    population: 2419,
    county: 'NOT AVAILABLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.comfsm.fm/',
  },
  {
    name: 'LASELL UNIVERSITY',
    address: '1844 COMMONWEALTH AVENUE',
    city: 'NEWTON',
    state: 'MA',
    zip: 2466,
    telephone: '(617) 243-2000',
    population: 2420,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lasell.edu/',
  },
  {
    name: 'ISOTHERMAL COMMUNITY COLLEGE',
    address: '286 ICC LOOP ROAD',
    city: 'SPINDALE',
    state: 'NC',
    zip: 28160,
    telephone: '(828) 286-3636',
    population: 2427,
    county: 'RUTHERFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.isothermal.edu/',
  },
  {
    name: 'MURRAY STATE COLLEGE',
    address: 'ONE MURRAY CAMPUS',
    city: 'TISHOMINGO',
    state: 'OK',
    zip: 73460,
    telephone: '(580) 387-7000',
    population: 2429,
    county: 'JOHNSTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mscok.edu/',
  },
  {
    name: 'RANGER COLLEGE',
    address: '1100 COLLEGE CIRCLE',
    city: 'RANGER',
    state: 'TX',
    zip: 76470,
    telephone: '(254) 647-3234',
    population: 2431,
    county: 'EASTLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rangercollege.edu/',
  },
  {
    name: 'WYTHEVILLE COMMUNITY COLLEGE',
    address: '1000 E MAIN STREET',
    city: 'WYTHEVILLE',
    state: 'VA',
    zip: 24382,
    telephone: '(276) 223-4700',
    population: 2432,
    county: 'WYTHE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wcc.vccs.edu/',
  },
  {
    name: "SAINT JOSEPH'S COLLEGE OF MAINE",
    address: '278 WHITES BRIDGE RD',
    city: 'STANDISH',
    state: 'ME',
    zip: 4084,
    telephone: '(207) 892-6766',
    population: 2434,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjcme.edu/',
  },
  {
    name: 'HOOD COLLEGE',
    address: '401 ROSEMONT AVE',
    city: 'FREDERICK',
    state: 'MD',
    zip: 21701,
    telephone: '(301) 663-3131',
    population: 2435,
    county: 'FREDERICK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hood.edu/',
  },
  {
    name: 'SIENA HEIGHTS UNIVERSITY',
    address: '1247 E. SIENA HEIGHTS DR.',
    city: 'ADRIAN',
    state: 'MI',
    zip: 49221,
    telephone: '(517) 263-0731',
    population: 2437,
    county: 'LENAWEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sienaheights.edu/',
  },
  {
    name: 'OGEECHEE TECHNICAL COLLEGE',
    address: 'ONE JOSEPH E. KENNEDY BLVD',
    city: 'STATESBORO',
    state: 'GA',
    zip: 30458,
    telephone: '(912) 681-5500',
    population: 2437,
    county: 'BULLOCH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ogeecheetech.edu/',
  },
  {
    name: 'MASSACHUSETTS COLLEGE OF ART AND DESIGN',
    address: '621 HUNTINGTON AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 879-7000',
    population: 2441,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.massart.edu/',
  },
  {
    name: 'LEBANON VALLEY COLLEGE',
    address: '101 N COLLEGE AVE',
    city: 'ANNVILLE',
    state: 'PA',
    zip: 17003,
    telephone: '(717) 867-6100',
    population: 2441,
    county: 'LEBANON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lvc.edu/',
  },
  {
    name: 'CABRINI UNIVERSITY',
    address: '610 KING OF PRUSSIA RD',
    city: 'RADNOR',
    state: 'PA',
    zip: 19087,
    telephone: '(610) 902-8100',
    population: 2445,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cabrini.edu/',
  },
  {
    name: 'GORDON COLLEGE',
    address: '255 GRAPEVINE RD',
    city: 'WENHAM',
    state: 'MA',
    zip: 1984,
    telephone: '(978) 927-2300 EXT 978',
    population: 2446,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gordon.edu/',
  },
  {
    name: 'LACKAWANNA COLLEGE',
    address: '501 VINE ST',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18509,
    telephone: '(570) 961-7810',
    population: 2449,
    county: 'LACKAWANNA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lackawanna.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT TUSCARAWAS',
    address: '330 UNIVERSITY DR N.E.',
    city: 'NEW PHILADELPHIA',
    state: 'OH',
    zip: 44663,
    telephone: '(330) 339-3391',
    population: 2451,
    county: 'TUSCARAWAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/tusc',
  },
  {
    name: 'ROANOKE COLLEGE',
    address: '221 COLLEGE LANE',
    city: 'SALEM',
    state: 'VA',
    zip: 24153,
    telephone: '(540) 375-2500',
    population: 2452,
    county: 'SALEM CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.roanoke.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-CHILLICOTHE CAMPUS',
    address: '101 UNIVERSITY DRIVE',
    city: 'CHILLICOTHE',
    state: 'OH',
    zip: 45601,
    telephone: '(740) 774-7200',
    population: 2453,
    county: 'ROSS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ohio.edu/chillicothe/',
  },
  {
    name: 'UMPQUA COMMUNITY COLLEGE',
    address: '1140 UMPQUA COLLEGE RD.',
    city: 'ROSEBURG',
    state: 'OR',
    zip: 97470,
    telephone: '(541) 440-4600',
    population: 2454,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.umpqua.edu/',
  },
  {
    name: 'EDGEWOOD COLLEGE',
    address: '1000 EDGEWOOD COLLEGE DRIVE',
    city: 'MADISON',
    state: 'WI',
    zip: 53711,
    telephone: '(608) 663-4861',
    population: 2455,
    county: 'DANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edgewood.edu/',
  },
  {
    name: 'MAYO CLINIC COLLEGE OF MEDICINE AND SCIENCE',
    address: '200 1ST ST SW',
    city: 'ROCHESTER',
    state: 'MN',
    zip: 55905,
    telephone: '(507) 284-3208',
    population: 2458,
    county: 'OLMSTED',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://college.mayo.edu/',
  },
  {
    name: 'UNIVERSITY OF THE VIRGIN ISLANDS',
    address: '2 JOHN BREWERS BAY',
    city: 'CHARLOTTE AMALIE',
    state: 'VI',
    zip: 802,
    telephone: '(340) 776-9200',
    population: 2459,
    county: 'ST. THOMAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uvi.edu/',
  },
  {
    name: 'DANVILLE AREA COMMUNITY COLLEGE',
    address: '2000 E MAIN ST',
    city: 'DANVILLE',
    state: 'IL',
    zip: 61832,
    telephone: '(217) 443-3222',
    population: 2460,
    county: 'VERMILION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dacc.edu/',
  },
  {
    name: 'LAKE AREA TECHNICAL COLLEGE',
    address: '1201 ARROW AVENUE',
    city: 'WATERTOWN',
    state: 'SD',
    zip: 57201,
    telephone: '(605) 882-5284',
    population: 2461,
    county: 'CODINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lakeareatech.edu/',
  },
  {
    name: 'SWARTHMORE COLLEGE',
    address: '500 COLLEGE AVE',
    city: 'SWARTHMORE',
    state: 'PA',
    zip: 19081,
    telephone: '(610) 328-8000',
    population: 2466,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.swarthmore.edu/',
  },
  {
    name: 'BISHOP STATE COMMUNITY COLLEGE',
    address: '351 NORTH BROAD STREET',
    city: 'MOBILE',
    state: 'AL',
    zip: 36603,
    telephone: '(251) 405-7000',
    population: 2466,
    county: 'MOBILE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bishop.edu/',
  },
  {
    name: 'CARLOW UNIVERSITY',
    address: '3333 FIFTH AVE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15213,
    telephone: '(412) 578-6000',
    population: 2467,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.carlow.edu/',
  },
  {
    name: 'NORTHERN VERMONT UNIVERSITY',
    address: '337 COLLEGE HILL',
    city: 'JOHNSON',
    state: 'VT',
    zip: 5656,
    telephone: '(802) 635-2356',
    population: 2468,
    county: 'LAMOILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northernvermont.edu/',
  },
  {
    name: 'CHARTER COLLEGE',
    address: '17200 S.E. MILL PLAIN BOULEVARD, SUITE 100',
    city: 'VANCOUVER',
    state: 'WA',
    zip: 98683,
    telephone: '(360) 448-2000',
    population: 2468,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chartercollege.edu/',
  },
  {
    name: 'OKLAHOMA CHRISTIAN UNIVERSITY',
    address: '2501 E MEMORIAL RD',
    city: 'EDMOND',
    state: 'OK',
    zip: 73013,
    telephone: '(405) 425-5000',
    population: 2470,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oc.edu/',
  },
  {
    name: 'LINCOLN UNIVERSITY',
    address: '820 CHESTNUT STREET',
    city: 'JEFFERSON CITY',
    state: 'MO',
    zip: 65101,
    telephone: '(573) 681-5000',
    population: 2476,
    county: 'COLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lincolnu.edu/',
  },
  {
    name: 'AUGUSTANA UNIVERSITY',
    address: '2001 S SUMMIT AVE',
    city: 'SIOUX FALLS',
    state: 'SD',
    zip: 57197,
    telephone: '(605) 274-5516',
    population: 2476,
    county: 'MINNEHAHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.augie.edu/',
  },
  {
    name: 'GALEN COLLEGE OF NURSING-TAMPA BAY',
    address: '10200 DR. MARTIN LUTHER KING JR. STREET N',
    city: 'SAINT PETERSBURG',
    state: 'FL',
    zip: 33716,
    telephone: '(727) 577-1497',
    population: 2476,
    county: 'PINELLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.galencollege.edu/tampabay',
  },
  {
    name: 'HERKIMER COUNTY COMMUNITY COLLEGE',
    address: '100 RESERVOIR RD',
    city: 'HERKIMER',
    state: 'NY',
    zip: 13350,
    telephone: '(315) 866-0300',
    population: 2478,
    county: 'HERKIMER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.herkimer.edu/',
  },
  {
    name: 'KENNEBEC VALLEY COMMUNITY COLLEGE',
    address: '92 WESTERN AVE',
    city: 'FAIRFIELD',
    state: 'ME',
    zip: 4937,
    telephone: '(207) 453-5000',
    population: 2480,
    county: 'SOMERSET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kvcc.me.edu/',
  },
  {
    name: 'RICHLAND COMMUNITY COLLEGE',
    address: 'ONE COLLEGE PARK',
    city: 'DECATUR',
    state: 'IL',
    zip: 62521,
    telephone: '(217) 875-7200 EXT 6302',
    population: 2485,
    county: 'MACON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.richland.edu/',
  },
  {
    name: 'UTA MESIVTA OF KIRYAS JOEL',
    address: '48 BAKERTOWN RD SUITE 501',
    city: 'MONROE',
    state: 'NY',
    zip: 10950,
    telephone: '(845) 783-9901 EXT 106',
    population: 2486,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'utam.edu/',
  },
  {
    name: 'EASTERN VIRGINIA MEDICAL SCHOOL',
    address: '700W. OLNEY',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23507,
    telephone: '(757) 446-8422',
    population: 2486,
    county: 'NORFOLK CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.evms.edu/',
  },
  {
    name: 'CLAFLIN UNIVERSITY',
    address: '400 MAGNOLIA STREET',
    city: 'ORANGEBURG',
    state: 'SC',
    zip: 29115,
    telephone: '(803) 535-5000',
    population: 2489,
    county: 'ORANGEBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.claflin.edu/',
  },
  {
    name: 'NORTHWEST NAZARENE UNIVERSITY',
    address: '623 S. UNIVERSITY BLVD.',
    city: 'NAMPA',
    state: 'ID',
    zip: 83686,
    telephone: '(208) 467-8011',
    population: 2490,
    county: 'CANYON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nnu.edu/',
  },
  {
    name: 'CONNECTICUT COLLEGE',
    address: '270 MOHEGAN AVENUE',
    city: 'NEW LONDON',
    state: 'CT',
    zip: 6320,
    telephone: '(860) 447-1911',
    population: 2493,
    county: 'NEW LONDON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.conncoll.edu/',
  },
  {
    name: 'CECIL COLLEGE',
    address: 'ONE SEAHAWK DRIVE',
    city: 'NORTH EAST',
    state: 'MD',
    zip: 21901,
    telephone: '(410) 287-1000',
    population: 2496,
    county: 'CECIL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cecil.edu/',
  },
  {
    name: 'FRANKLIN PIERCE UNIVERSITY',
    address: '40 UNIVERSITY DRIVE',
    city: 'RINDGE',
    state: 'NH',
    zip: 3461,
    telephone: '(603) 899-4000',
    population: 2498,
    county: 'CHESHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.franklinpierce.edu/',
  },
  {
    name: 'WILLIAM WOODS UNIVERSITY',
    address: 'ONE UNIVERSITY AVENUE',
    city: 'FULTON',
    state: 'MO',
    zip: 65251,
    telephone: '(573) 642-2251',
    population: 2498,
    county: 'CALLAWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.williamwoods.edu/',
  },
  {
    name: 'MOUNTAIN EMPIRE COMMUNITY COLLEGE',
    address: '3441 MOUNTAIN EMPIRE ROAD',
    city: 'BIG STONE GAP',
    state: 'VA',
    zip: 24219,
    telephone: '(276) 523-2400',
    population: 2501,
    county: 'WISE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mecc.edu/',
  },
  {
    name: 'TEXAS A&M UNIVERSITY-TEXARKANA',
    address: '7101 UNIVERSITY AVENUE',
    city: 'TEXARKANA',
    state: 'TX',
    zip: 75503,
    telephone: '(903) 223-3000',
    population: 2506,
    county: 'BOWIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tamut.edu/',
  },
  {
    name: 'COLUMBIA INTERNATIONAL UNIVERSITY',
    address: '7435 MONTICELLO RD',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29203,
    telephone: '(800) 777-2227',
    population: 2509,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ciu.edu/',
  },
  {
    name: 'WILLAMETTE UNIVERSITY',
    address: '900 STATE ST',
    city: 'SALEM',
    state: 'OR',
    zip: 97301,
    telephone: '(503) 370-6300',
    population: 2511,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.willamette.edu/',
  },
  {
    name: 'EDWARD WATERS COLLEGE',
    address: '1658 KINGS RD',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32209,
    telephone: '(904) 470-8000',
    population: 2511,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ewc.edu/',
  },
  {
    name: 'WINDWARD COMMUNITY COLLEGE',
    address: '45-720 KEAAHALA RD',
    city: 'KANEOHE',
    state: 'HI',
    zip: 96744,
    telephone: '(808) 235-7400',
    population: 2512,
    county: 'HONOLULU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://windward.hawaii.edu/',
  },
  {
    name: 'LINCOLN UNIVERSITY',
    address: '1570 BALTIMORE PIKE',
    city: 'LINCOLN UNIVERSITY',
    state: 'PA',
    zip: 19352,
    telephone: '(484) 365-8000',
    population: 2514,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lincoln.edu/',
  },
  {
    name: 'HARDIN-SIMMONS UNIVERSITY',
    address: '2200 HICKORY',
    city: 'ABILENE',
    state: 'TX',
    zip: 79698,
    telephone: '(325) 670-1000',
    population: 2515,
    county: 'TAYLOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hsutx.edu/',
  },
  {
    name: 'NEW MEXICO INSTITUTE OF MINING AND TECHNOLOGY',
    address: '801 LEROY PLACE',
    city: 'SOCORRO',
    state: 'NM',
    zip: 87801,
    telephone: '(800) 428-8324',
    population: 2517,
    county: 'SOCORRO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nmt.edu/',
  },
  {
    name: 'JOHNSON & WALES UNIVERSITY-ONLINE',
    address: '8 ABBOTT PARK PL',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2903,
    telephone: '(401) 598-1000',
    population: 2519,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://online.jwu.edu/?_ga=2.244666885.1432107725.1502198571-1382828486.1499961993',
  },
  {
    name: 'GOUCHER COLLEGE',
    address: '1021 DULANEY VALLEY RD',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21204,
    telephone: '(410) 337-6000',
    population: 2520,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.goucher.edu/',
  },
  {
    name: 'ORANGEBURG CALHOUN TECHNICAL COLLEGE',
    address: '3250 SAINT MATTHEWS RD',
    city: 'ORANGEBURG',
    state: 'SC',
    zip: 29118,
    telephone: '(803) 536-0311',
    population: 2528,
    county: 'ORANGEBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.octech.edu/',
  },
  {
    name: 'SOUTHEASTERN COMMUNITY COLLEGE',
    address: '1500 WEST AGENCY ROAD',
    city: 'WEST BURLINGTON',
    state: 'IA',
    zip: 52655,
    telephone: '(319) 752-2731',
    population: 2528,
    county: 'DES MOINES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.scciowa.edu/',
  },
  {
    name: 'MEDAILLE COLLEGE',
    address: '18 AGASSIZ CIRCLE',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14214,
    telephone: '(716) 880-2000',
    population: 2530,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.medaille.edu/',
  },
  {
    name: 'MOUNT SAINT JOSEPH UNIVERSITY',
    address: '5701 DELHI RD',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45233,
    telephone: '(513) 244-4200',
    population: 2535,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msj.edu/',
  },
  {
    name: 'CITY UNIVERSITY OF SEATTLE',
    address: '521 WALL STREET, SUITE 100',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98121,
    telephone: '(888) 422-4898',
    population: 2545,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cityu.edu/',
  },
  {
    name: 'TEXAS TECH UNIVERSITY HEALTH SCIENCES CENTER-EL PASO',
    address: '5001 EL PASO DRIVE',
    city: 'EL PASO',
    state: 'TX',
    zip: 79905,
    telephone: '(915) 215-8000',
    population: 2547,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'elpaso.ttuhsc.edu/',
  },
  {
    name: 'RIVIER UNIVERSITY',
    address: '420 SOUTH MAIN ST',
    city: 'NASHUA',
    state: 'NH',
    zip: 3060,
    telephone: '(603) 888-1311',
    population: 2552,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rivier.edu/',
  },
  {
    name: 'ROSE-HULMAN INSTITUTE OF TECHNOLOGY',
    address: '5500 WABASH AVENUE',
    city: 'TERRE HAUTE',
    state: 'IN',
    zip: 47803,
    telephone: '(812) 877-1511',
    population: 2552,
    county: 'VIGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rose-hulman.edu/',
  },
  {
    name: 'CLOVIS COMMUNITY COLLEGE',
    address: '417 SCHEPPS BLVD',
    city: 'CLOVIS',
    state: 'NM',
    zip: 88101,
    telephone: '(800) 769-1409',
    population: 2554,
    county: 'CURRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clovis.edu/',
  },
  {
    name: 'OCCIDENTAL COLLEGE',
    address: '1600 CAMPUS RD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90041,
    telephone: '(323) 259-2500',
    population: 2556,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.oxy.edu/',
  },
  {
    name: 'OHIO CHRISTIAN UNIVERSITY',
    address: '1476 LANCASTER PIKE',
    city: 'CIRCLEVILLE',
    state: 'OH',
    zip: 43113,
    telephone: '(740) 474-8896',
    population: 2560,
    county: 'PICKAWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ohiochristian.edu/',
  },
  {
    name: 'LAMAR STATE COLLEGE-ORANGE',
    address: '410 FRONT ST',
    city: 'ORANGE',
    state: 'TX',
    zip: 77630,
    telephone: '(409) 883-7750',
    population: 2562,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lsco.edu/',
  },
  {
    name: 'SUNY COLLEGE OF AGRICULTURE AND TECHNOLOGY AT COBLESKILL',
    address: 'STATE ROUTE 7',
    city: 'COBLESKILL',
    state: 'NY',
    zip: 12043,
    telephone: '(518) 255-5525',
    population: 2563,
    county: 'SCHOHARIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cobleskill.edu/',
  },
  {
    name: 'MONROE COUNTY COMMUNITY COLLEGE',
    address: '1555 SOUTH RAISINVILLE ROAD',
    city: 'MONROE',
    state: 'MI',
    zip: 48161,
    telephone: '(734) 242-7300',
    population: 2566,
    county: 'MONROE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.monroeccc.edu/',
  },
  {
    name: 'MID-AMERICA CHRISTIAN UNIVERSITY',
    address: '3500 SW 119TH ST',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73170,
    telephone: '(405) 691-3800',
    population: 2569,
    county: 'CLEVELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.macu.edu/',
  },
  {
    name: 'SAMUEL MERRITT UNIVERSITY',
    address: '3100 TELEGRAPH AVENUE',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94609,
    telephone: '(800) 607-6377',
    population: 2569,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.samuelmerritt.edu/',
  },
  {
    name: 'RICHMOND COMMUNITY COLLEGE',
    address: '1042 W HAMLET AVE',
    city: 'HAMLET',
    state: 'NC',
    zip: 28345,
    telephone: '(910) 410-1700',
    population: 2569,
    county: 'RICHMOND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.richmondcc.edu/',
  },
  {
    name: 'MOREHOUSE COLLEGE',
    address: '830 WESTVIEW DR SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30314,
    telephone: '(470) 639-0999',
    population: 2573,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.morehouse.edu/',
  },
  {
    name: 'DAKOTA COUNTY TECHNICAL COLLEGE',
    address: '1300 145TH STREET EAST',
    city: 'ROSEMOUNT',
    state: 'MN',
    zip: 55068,
    telephone: '(651) 423-8301',
    population: 2576,
    county: 'DAKOTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dctc.edu/',
  },
  {
    name: 'FULLER THEOLOGICAL SEMINARY',
    address: '135 N OAKLAND AVE',
    city: 'PASADENA',
    state: 'CA',
    zip: 91182,
    telephone: '(626) 584-5200',
    population: 2578,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fuller.edu/',
  },
  {
    name: 'FREED-HARDEMAN UNIVERSITY',
    address: '158 E MAIN ST',
    city: 'HENDERSON',
    state: 'TN',
    zip: 38340,
    telephone: '(800) 348-3481',
    population: 2578,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fhu.edu/',
  },
  {
    name: 'MISSISSIPPI VALLEY STATE UNIVERSITY',
    address: '14000 HIGHWAY 82 WEST',
    city: 'ITTA BENA',
    state: 'MS',
    zip: 38941,
    telephone: '(662) 254-9041',
    population: 2580,
    county: 'LEFLORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mvsu.edu/',
  },
  {
    name: 'LANCASTER BIBLE COLLEGE',
    address: '901 EDEN RD',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17601,
    telephone: '(717) 569-7071',
    population: 2580,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lbc.edu/',
  },
  {
    name: 'MANCHESTER COMMUNITY COLLEGE',
    address: '1066 FRONT ST',
    city: 'MANCHESTER',
    state: 'NH',
    zip: 3102,
    telephone: '(603) 206-8000',
    population: 2584,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mccnh.edu/',
  },
  {
    name: 'SUNY COLLEGE OF ENVIRONMENTAL SCIENCE AND FORESTRY',
    address: 'ONE FORESTRY DR.',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13210,
    telephone: '(315) 470-6500',
    population: 2585,
    county: 'ONONDAGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.esf.edu/',
  },
  {
    name: 'CENTRALIA COLLEGE',
    address: '600 CENTRALIA COLLEGE BLVD.',
    city: 'CENTRALIA',
    state: 'WA',
    zip: 98531,
    telephone: '(360) 736-9391',
    population: 2585,
    county: 'LEWIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.centralia.edu/',
  },
  {
    name: 'MCKENDREE UNIVERSITY',
    address: '701 COLLEGE RD',
    city: 'LEBANON',
    state: 'IL',
    zip: 62254,
    telephone: '(618) 537-4481',
    population: 2588,
    county: 'ST. CLAIR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mckendree.edu/',
  },
  {
    name: 'NEW YORK MEDICAL COLLEGE',
    address: 'ADMINISTRATION BUILDING',
    city: 'VALHALLA',
    state: 'NY',
    zip: 10595,
    telephone: '(914) 594-4000',
    population: 2593,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nymc.edu/',
  },
  {
    name: 'THE UNIVERSITY OF THE SOUTH',
    address: '735 UNIVERSITY AVENUE',
    city: 'SEWANEE',
    state: 'TN',
    zip: 37383,
    telephone: '(931) 598-1000',
    population: 2593,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sewanee.edu/',
  },
  {
    name: 'SAINT NORBERT COLLEGE',
    address: '100 GRANT ST',
    city: 'DE PERE',
    state: 'WI',
    zip: 54115,
    telephone: '(920) 337-3181',
    population: 2594,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.snc.edu/',
  },
  {
    name: 'LAKE TAHOE COMMUNITY COLLEGE',
    address: 'ONE COLLEGE DRIVE',
    city: 'SOUTH LAKE TAHOE',
    state: 'CA',
    zip: 96150,
    telephone: '(530) 541-4660',
    population: 2595,
    county: 'EL DORADO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ltcc.edu/',
  },
  {
    name: 'CHAMINADE UNIVERSITY OF HONOLULU',
    address: '3140 WAIALAE AVENUE',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96816,
    telephone: '(808) 735-4711',
    population: 2598,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chaminade.edu/',
  },
  {
    name: 'NEW ENGLAND INSTITUTE OF TECHNOLOGY',
    address: 'ONE NEW ENGLAND TECH BOULEVARD',
    city: 'EAST GREENWICH',
    state: 'RI',
    zip: 2818,
    telephone: '(401) 739-5000',
    population: 2600,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neit.edu/',
  },
  {
    name: 'SOUTHERN UNIVERSITY AT NEW ORLEANS',
    address: '6400 PRESS DRIVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70126,
    telephone: '(504) 286-5000',
    population: 2601,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.suno.edu/',
  },
  {
    name: 'WESTMINSTER COLLEGE',
    address: '1840 SOUTH 1300 EAST',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84105,
    telephone: '(801) 484-7651',
    population: 2605,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westminstercollege.edu/',
  },
  {
    name: 'NOTRE DAME OF MARYLAND UNIVERSITY',
    address: '4701 N CHARLES ST',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21210,
    telephone: '(410) 435-0100',
    population: 2606,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ndm.edu/',
  },
  {
    name: 'SOUTHWEST VIRGINIA COMMUNITY COLLEGE',
    address: '369 COLLEGE ROAD US RT. 19, 6 MILES S. CLAYPOOL HILL',
    city: 'CEDAR BLUFF',
    state: 'VA',
    zip: 24609,
    telephone: '(276) 964-2555',
    population: 2609,
    county: 'TAZEWELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sw.edu/',
  },
  {
    name: 'TAYLOR UNIVERSITY',
    address: '236 W READE AVE',
    city: 'UPLAND',
    state: 'IN',
    zip: 46989,
    telephone: '(765) 998-2751',
    population: 2610,
    county: 'GRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.taylor.edu/',
  },
  {
    name: 'CASTLETON UNIVERSITY',
    address: '62 ALUMNI DR',
    city: 'CASTLETON',
    state: 'VT',
    zip: 5735,
    telephone: '(802) 468-5611',
    population: 2613,
    county: 'RUTLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.castleton.edu/',
  },
  {
    name: 'PALMER COLLEGE OF CHIROPRACTIC',
    address: '1000 BRADY ST',
    city: 'DAVENPORT',
    state: 'IA',
    zip: 52803,
    telephone: '(563) 884-5000',
    population: 2615,
    county: 'SCOTT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.palmer.edu/',
  },
  {
    name: 'UNIVERSIDAD ANA G. MENDEZ-ONLINE CAMPUS',
    address: 'CARRETERA PR-176, KM 0.5, SECTOR EL CINCO',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 926,
    telephone: '(787) 288-1118',
    population: 2618,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'online.uagm.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-LANCASTER CAMPUS',
    address: '1570 GRANVILLE PIKE',
    city: 'LANCASTER',
    state: 'OH',
    zip: 43130,
    telephone: '(740) 654-6711',
    population: 2621,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ohio.edu/lancaster/',
  },
  {
    name: 'MUSKINGUM UNIVERSITY',
    address: '10 COLLEGE DRIVE',
    city: 'NEW CONCORD',
    state: 'OH',
    zip: 43762,
    telephone: '(740) 826-8211',
    population: 2622,
    county: 'MUSKINGUM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.muskingum.edu/',
  },
  {
    name: 'BENEDICTINE COLLEGE',
    address: '1020 N 2ND ST',
    city: 'ATCHISON',
    state: 'KS',
    zip: 66002,
    telephone: '(913) 367-5340',
    population: 2628,
    county: 'ATCHISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.benedictine.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT GEAUGA',
    address: '14111 CLARIDON-TROY RD',
    city: 'BURTON',
    state: 'OH',
    zip: 44021,
    telephone: '(440) 834-4187',
    population: 2629,
    county: 'GEAUGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/geauga',
  },
  {
    name: 'MOUNT SAINT MARY COLLEGE',
    address: '330 POWELL AVENUE',
    city: 'NEWBURGH',
    state: 'NY',
    zip: 12550,
    telephone: '(845) 561-0800',
    population: 2634,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msmc.edu/',
  },
  {
    name: 'IOWA LAKES COMMUNITY COLLEGE',
    address: '19 S 7TH ST',
    city: 'ESTHERVILLE',
    state: 'IA',
    zip: 51334,
    telephone: '(712) 362-2601',
    population: 2636,
    county: 'EMMET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iowalakes.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-SOUTHERN CAMPUS',
    address: '1804 LIBERTY AVE',
    city: 'IRONTON',
    state: 'OH',
    zip: 45638,
    telephone: '(740) 533-4600',
    population: 2639,
    county: 'LAWRENCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ohio.edu/southern/',
  },
  {
    name: 'UNIVERSITY OF PITTSBURGH-JOHNSTOWN',
    address: '450 SCHOOLHOUSE ROAD',
    city: 'JOHNSTOWN',
    state: 'PA',
    zip: 15904,
    telephone: '(814) 269-7000',
    population: 2641,
    county: 'CAMBRIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upj.pitt.edu/',
  },
  {
    name: 'PENNSYLVANIA HIGHLANDS COMMUNITY COLLEGE',
    address: '101 COMMUNITY COLLEGE WAY',
    city: 'JOHNSTOWN',
    state: 'PA',
    zip: 15904,
    telephone: '(814) 262-6400',
    population: 2642,
    county: 'CAMBRIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pennhighlands.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY TEXAS',
    address: '11400 CONCORDIA UNIVERSITY DRIVE',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78726,
    telephone: '(512) 313-3000',
    population: 2644,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.concordia.edu/',
  },
  {
    name: 'CONCORDIA COLLEGE AT MOORHEAD',
    address: '901 S 8TH ST',
    city: 'MOORHEAD',
    state: 'MN',
    zip: 56562,
    telephone: '(218) 299-4200',
    population: 2644,
    county: 'CLAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.concordiacollege.edu/',
  },
  {
    name: 'DANVILLE COMMUNITY COLLEGE',
    address: '1008 S MAIN ST',
    city: 'DANVILLE',
    state: 'VA',
    zip: 24541,
    telephone: '(434) 797-2222',
    population: 2644,
    county: 'DANVILLE CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.danville.edu/',
  },
  {
    name: 'SOUTHERN NAZARENE UNIVERSITY',
    address: '6729 NW 39TH EXPY',
    city: 'BETHANY',
    state: 'OK',
    zip: 73008,
    telephone: '(405) 789-6400',
    population: 2647,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'snu.edu/',
  },
  {
    name: 'KANKAKEE COMMUNITY COLLEGE',
    address: '100 COLLEGE DRIVE',
    city: 'KANKAKEE',
    state: 'IL',
    zip: 60901,
    telephone: '(815) 802-8100',
    population: 2650,
    county: 'KANKAKEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kcc.edu/',
  },
  {
    name: 'THE COLLEGE OF WOOSTER',
    address: '1189 BEALL AVENUE',
    city: 'WOOSTER',
    state: 'OH',
    zip: 44691,
    telephone: '(330) 263-2000',
    population: 2651,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wooster.edu/',
  },
  {
    name: 'UNIVERSITY OF PIKEVILLE',
    address: '147 SYCAMORE ST',
    city: 'PIKEVILLE',
    state: 'KY',
    zip: 41501,
    telephone: '(606) 218-5250',
    population: 2651,
    county: 'PIKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upike.edu/',
  },
  {
    name: 'BERKELEY COLLEGE-NEW YORK',
    address: '3 EAST 43 STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10017,
    telephone: '(212) 986-4343',
    population: 2657,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://berkeleycollege.edu/',
  },
  {
    name: 'SUSSEX COUNTY COMMUNITY COLLEGE',
    address: 'ONE COLLEGE HILL ROAD',
    city: 'NEWTON',
    state: 'NJ',
    zip: 7860,
    telephone: '(973) 300-2100',
    population: 2659,
    county: 'SUSSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sussex.edu/',
  },
  {
    name: 'CHADRON STATE COLLEGE',
    address: '1000 MAIN ST',
    city: 'CHADRON',
    state: 'NE',
    zip: 69337,
    telephone: '(308) 432-6000',
    population: 2664,
    county: 'DAWES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csc.edu/',
  },
  {
    name: 'TEXAS A&M UNIVERSITY-CENTRAL TEXAS',
    address: '1001 LEADERSHIP PLACE',
    city: 'KILLEEN',
    state: 'TX',
    zip: 76549,
    telephone: '(254) 519-5400',
    population: 2670,
    county: 'BELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'tamuct.edu/',
  },
  {
    name: 'ASHLAND COMMUNITY AND TECHNICAL COLLEGE',
    address: '1400 COLLEGE DRIVE',
    city: 'ASHLAND',
    state: 'KY',
    zip: 41101,
    telephone: '(606) 326-2000',
    population: 2670,
    county: 'BOYD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://ashland.kctcs.edu/',
  },
  {
    name: 'EAST GEORGIA STATE COLLEGE',
    address: '131 COLLEGE CIR',
    city: 'SWAINSBORO',
    state: 'GA',
    zip: 30401,
    telephone: '(478) 289-2000',
    population: 2675,
    county: 'EMANUEL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ega.edu/',
  },
  {
    name: 'LAMAR STATE COLLEGE-PORT ARTHUR',
    address: '1500 PROCTOR ST',
    city: 'PORT ARTHUR',
    state: 'TX',
    zip: 77640,
    telephone: '(409) 984-6342',
    population: 2686,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lamarpa.edu/',
  },
  {
    name: 'GEORGIAN COURT UNIVERSITY',
    address: '900 LAKEWOOD AVE',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 987-2200',
    population: 2688,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://georgian.edu/',
  },
  {
    name: 'SAINT ANSELM COLLEGE',
    address: '100 SAINT ANSELM DRIVE',
    city: 'MANCHESTER',
    state: 'NH',
    zip: 3102,
    telephone: '(603) 641-7000',
    population: 2690,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.anselm.edu/',
  },
  {
    name: 'EVERGLADES UNIVERSITY',
    address: '5002 T-REX AVENUE, SUITE 100',
    city: 'BOCA RATON',
    state: 'FL',
    zip: 33431,
    telephone: '(561) 912-1211',
    population: 2692,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.evergladesuniversity.edu/',
  },
  {
    name: 'BERRY COLLEGE',
    address: '2277 MARTHA BERRY HWY NW',
    city: 'MOUNT BERRY',
    state: 'GA',
    zip: 30149,
    telephone: '(706) 232-5374',
    population: 2693,
    county: 'FLOYD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.berry.edu/',
  },
  {
    name: 'MID-PLAINS COMMUNITY COLLEGE',
    address: '1101 HALLIGAN DRIVE',
    city: 'NORTH PLATTE',
    state: 'NE',
    zip: 69101,
    telephone: '(800) 658-4308',
    population: 2698,
    county: 'LINCOLN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mpcc.edu/',
  },
  {
    name: 'OKLAHOMA STATE UNIVERSITY INSTITUTE OF TECHNOLOGY',
    address: '1801 E 4TH ST',
    city: 'OKMULGEE',
    state: 'OK',
    zip: 74447,
    telephone: '(918) 293-4678',
    population: 2702,
    county: 'OKMULGEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://osuit.edu/',
  },
  {
    name: 'SOUTHEAST TECHNICAL COLLEGE',
    address: '2320 N CAREER AVE',
    city: 'SIOUX FALLS',
    state: 'SD',
    zip: 57107,
    telephone: '(605) 367-6175',
    population: 2703,
    county: 'MINNEHAHA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southeasttech.edu/',
  },
  {
    name: 'DREW UNIVERSITY',
    address: '36 MADISON AVE',
    city: 'MADISON',
    state: 'NJ',
    zip: 7940,
    telephone: '(973) 408-3000',
    population: 2707,
    county: 'MORRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.drew.edu/',
  },
  {
    name: 'UNIVERSITY OF DUBUQUE',
    address: '2000 UNIVERSITY AVE',
    city: 'DUBUQUE',
    state: 'IA',
    zip: 52001,
    telephone: '(563) 589-3000',
    population: 2711,
    county: 'DUBUQUE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dbq.edu/',
  },
  {
    name: 'HAWAII COMMUNITY COLLEGE',
    address: '1175 MANONO STREET',
    city: 'HILO',
    state: 'HI',
    zip: 96720,
    telephone: '(808) 934-2500',
    population: 2712,
    county: 'HAWAII',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hawaii.hawaii.edu/',
  },
  {
    name: 'UNIVERSITY OF MOUNT UNION',
    address: '1972 CLARK AVE.',
    city: 'ALLIANCE',
    state: 'OH',
    zip: 44601,
    telephone: '(800) 992-6682',
    population: 2716,
    county: 'STARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mountunion.edu/',
  },
  {
    name: 'VANGUARD UNIVERSITY OF SOUTHERN CALIFORNIA',
    address: '55 FAIR DR',
    city: 'COSTA MESA',
    state: 'CA',
    zip: 92626,
    telephone: '(714) 556-3610',
    population: 2717,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.vanguard.edu/',
  },
  {
    name: 'CLEVELAND COMMUNITY COLLEGE',
    address: '137 S POST RD',
    city: 'SHELBY',
    state: 'NC',
    zip: 28152,
    telephone: '(704) 669-4081',
    population: 2719,
    county: 'CLEVELAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clevelandcc.edu/',
  },
  {
    name: 'BARSTOW COMMUNITY COLLEGE',
    address: '2700 BARSTOW ROAD',
    city: 'BARSTOW',
    state: 'CA',
    zip: 92311,
    telephone: '(760) 252-2411',
    population: 2720,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.barstow.edu/',
  },
  {
    name: 'MARY BALDWIN UNIVERSITY',
    address: '318 PROSPECT STREET',
    city: 'STAUNTON',
    state: 'VA',
    zip: 24401,
    telephone: '(540) 887-7019',
    population: 2722,
    county: 'STAUNTON CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.marybaldwin.edu/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-ILLINOIS',
    address: '6000 EAST STATE STREET, 4TH FLOOR',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61108,
    telephone: '(815) 316-4800',
    population: 2722,
    county: 'WINNEBAGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'FRONTIER NURSING UNIVERSITY',
    address: '2050 LEXINGTON ROAD',
    city: 'VERSAILLES',
    state: 'KY',
    zip: 40383,
    telephone: '(859) 251-4700',
    population: 2723,
    county: 'WOODFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.frontier.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-LOS ANGELES',
    address: '12215 VICTORY BOULEVARD',
    city: 'NORTH HOLLYWOOD',
    state: 'CA',
    zip: 91606,
    telephone: '(818) 299-5500',
    population: 2725,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'CALDWELL UNIVERSITY',
    address: '120 BLOOMFIELD AVENUE',
    city: 'CALDWELL',
    state: 'NJ',
    zip: 7006,
    telephone: '(973) 618-3000',
    population: 2728,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caldwell.edu/',
  },
  {
    name: 'EAST CENTRAL COMMUNITY COLLEGE',
    address: '15738 HIGHWAY 15',
    city: 'DECATUR',
    state: 'MS',
    zip: 39327,
    telephone: '(601) 635-2111',
    population: 2729,
    county: 'NEWTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.eccc.edu/',
  },
  {
    name: 'ILLINOIS VALLEY COMMUNITY COLLEGE',
    address: '815 N ORLANDO SMITH ROAD',
    city: 'OGLESBY',
    state: 'IL',
    zip: 61348,
    telephone: '(815) 224-2720',
    population: 2731,
    county: 'LASALLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ivcc.edu/',
  },
  {
    name: 'ALEXANDRIA TECHNICAL & COMMUNITY COLLEGE',
    address: '1601 JEFFERSON STREEET',
    city: 'ALEXANDRIA',
    state: 'MN',
    zip: 56308,
    telephone: '(320) 762-0221',
    population: 2733,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alextech.edu/',
  },
  {
    name: 'HAMILTON COLLEGE',
    address: '198 COLLEGE HILL RD',
    city: 'CLINTON',
    state: 'NY',
    zip: 13323,
    telephone: '(315) 859-4011',
    population: 2738,
    county: 'ONEIDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hamilton.edu/',
  },
  {
    name: 'DALLAS THEOLOGICAL SEMINARY',
    address: '3909 SWISS AVE',
    city: 'DALLAS',
    state: 'TX',
    zip: 75204,
    telephone: '(214) 887-5000',
    population: 2739,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dts.edu/',
  },
  {
    name: 'LAKESHORE TECHNICAL COLLEGE',
    address: '1290 NORTH AVENUE',
    city: 'CLEVELAND',
    state: 'WI',
    zip: 53015,
    telephone: '(920) 693-1000 EXT 1192',
    population: 2743,
    county: 'MANITOWOC',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gotoltc.edu/',
  },
  {
    name: 'LOWER COLUMBIA COLLEGE',
    address: '1600 MAPLE STREET',
    city: 'LONGVIEW',
    state: 'WA',
    zip: 98632,
    telephone: '(360) 442-2311',
    population: 2744,
    county: 'COWLITZ',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://lowercolumbia.edu/',
  },
  {
    name: 'MACALESTER COLLEGE',
    address: '1600 GRAND AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55105,
    telephone: '(651) 696-6000',
    population: 2751,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.macalester.edu/',
  },
  {
    name: 'RUSSELL SAGE COLLEGE',
    address: '65 1ST STREET',
    city: 'TROY',
    state: 'NY',
    zip: 12180,
    telephone: '(518) 244-2000',
    population: 2752,
    county: 'RENSSELAER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sage.edu/',
  },
  {
    name: 'BATES COLLEGE',
    address: '2 ANDREWS ROAD',
    city: 'LEWISTON',
    state: 'ME',
    zip: 4240,
    telephone: '(207) 786-6000',
    population: 2752,
    county: 'ANDROSCOGGIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bates.edu/',
  },
  {
    name: 'MIAMI UNIVERSITY-HAMILTON',
    address: '1601 UNIVERSITY BLVD',
    city: 'HAMILTON',
    state: 'OH',
    zip: 45011,
    telephone: '(513) 785-3000',
    population: 2755,
    county: 'BUTLER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'miamioh.edu/regionals/',
  },
  {
    name: 'BIG SANDY COMMUNITY AND TECHNICAL COLLEGE',
    address: '1 BERT COMBS DR',
    city: 'PRESTONSBURG',
    state: 'KY',
    zip: 41653,
    telephone: '(606) 886-3863 EXT 0',
    population: 2759,
    county: 'FLOYD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://bigsandy.kctcs.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-MARYLAND',
    address: '5110 AUTH WAY',
    city: 'SUITLAND',
    state: 'MD',
    zip: 20746,
    telephone: '(877) 445-7180',
    population: 2760,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/maryland/prince-georges',
  },
  {
    name: 'BAKER UNIVERSITY',
    address: '615 DEARBORN STREET',
    city: 'BALDWIN CITY',
    state: 'KS',
    zip: 66006,
    telephone: '(785) 594-6451',
    population: 2760,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bakeru.edu/',
  },
  {
    name: 'ALBIZU UNIVERSITY-SAN JUAN',
    address: '151 TANCA ST, CORNER SAN FRANCISCO ST, OLD SAN JUAN',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 902,
    telephone: '(787) 725-6500',
    population: 2760,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.albizu.edu/',
  },
  {
    name: 'BLACKHAWK TECHNICAL COLLEGE',
    address: '6004 SOUTH COUNTY ROAD G',
    city: 'JANESVILLE',
    state: 'WI',
    zip: 53547,
    telephone: '(608) 758-6900',
    population: 2760,
    county: 'ROCK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.blackhawk.edu/',
  },
  {
    name: 'JOHN BROWN UNIVERSITY',
    address: '2000 W UNIVERSITY ST',
    city: 'SILOAM SPRINGS',
    state: 'AR',
    zip: 72761,
    telephone: '(479) 524-9500',
    population: 2761,
    county: 'BENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jbu.edu/',
  },
  {
    name: 'PLATT COLLEGE-MILLER-MOTTE-WILMINGTON',
    address: '5000 MARKET STREET',
    city: 'WILMINGTON',
    state: 'NC',
    zip: 28405,
    telephone: '(910) 392-4660',
    population: 2761,
    county: 'NEW HANOVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.miller-motte.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-PONCE',
    address: '2151 SANTIAGO DE LOS CABALLEROS AVENUE',
    city: 'PONCE',
    state: 'PR',
    zip: 716,
    telephone: '(787) 844-8181',
    population: 2762,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprp.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-ONTARIO',
    address: '2855 E. GUASTI RD',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91761,
    telephone: '(909) 467-6100',
    population: 2765,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'AMHERST COLLEGE',
    address: 'BOLTWOOD AVENUE',
    city: 'AMHERST',
    state: 'MA',
    zip: 1002,
    telephone: '(413) 542-2000',
    population: 2767,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amherst.edu/',
  },
  {
    name: 'NORTH GREENVILLE UNIVERSITY',
    address: '7801 N. TIGERVILLE ROAD',
    city: 'TIGERVILLE',
    state: 'SC',
    zip: 29688,
    telephone: '(864) 977-7000',
    population: 2767,
    county: 'GREENVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ngu.edu/',
  },
  {
    name: 'TEXAS WESLEYAN UNIVERSITY',
    address: '1201 WESLEYAN ST',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76105,
    telephone: '(817) 531-4444',
    population: 2769,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.txwes.edu/',
  },
  {
    name: 'SUL ROSS STATE UNIVERSITY',
    address: 'HWY 90 EAST',
    city: 'ALPINE',
    state: 'TX',
    zip: 79832,
    telephone: '(432) 837-8011',
    population: 2769,
    county: 'BREWSTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sulross.edu/',
  },
  {
    name: 'MINERAL AREA COLLEGE',
    address: '5270 FLAT RIVER ROAD',
    city: 'PARK HILLS',
    state: 'MO',
    zip: 63601,
    telephone: '(573) 431-4593',
    population: 2771,
    county: 'ST. FRANCOIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://mineralarea.edu/',
  },
  {
    name: 'DICKINSON COLLEGE',
    address: 'COLLEGE AND LOUTHER STREETS',
    city: 'CARLISLE',
    state: 'PA',
    zip: 17013,
    telephone: '(717) 243-5121',
    population: 2772,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.dickinson.edu/',
  },
  {
    name: 'HOCKING COLLEGE',
    address: '3301 HOCKING PARKWAY',
    city: 'NELSONVILLE',
    state: 'OH',
    zip: 45764,
    telephone: '(740) 753-3591',
    population: 2774,
    county: 'ATHENS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hocking.edu/',
  },
  {
    name: 'DELAWARE VALLEY UNIVERSITY',
    address: '700 E BUTLER AVE',
    city: 'DOYLESTOWN',
    state: 'PA',
    zip: 18901,
    telephone: '(215) 345-1500',
    population: 2775,
    county: 'BUCKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.delval.edu/',
  },
  {
    name: 'ALFRED UNIVERSITY',
    address: 'ONE SAXON DRIVE',
    city: 'ALFRED',
    state: 'NY',
    zip: 14802,
    telephone: '(607) 871-2111',
    population: 2776,
    county: 'ALLEGANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alfred.edu/',
  },
  {
    name: 'SOUTHEAST KENTUCKY COMMUNITY',
    address: '700 COLLEGE RD',
    city: 'CUMBERLAND',
    state: 'KY',
    zip: 40823,
    telephone: '(606) 589-2145',
    population: 2779,
    county: 'HARLAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://southeast.kctcs.edu/',
  },
  {
    name: 'CARLETON COLLEGE',
    address: 'ONE NORTH COLLEGE STREET',
    city: 'NORTHFIELD',
    state: 'MN',
    zip: 55057,
    telephone: '(507) 222-4000',
    population: 2780,
    county: 'RICE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.carleton.edu/',
  },
  {
    name: 'COWLEY COUNTY COMMUNITY COLLEGE',
    address: '125 S 2ND ST',
    city: 'ARKANSAS CITY',
    state: 'KS',
    zip: 67005,
    telephone: '(620) 442-0430',
    population: 2781,
    county: 'COWLEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cowley.edu/',
  },
  {
    name: 'SUSQUEHANNA UNIVERSITY',
    address: '514 UNIVERSITY AVE',
    city: 'SELINSGROVE',
    state: 'PA',
    zip: 17870,
    telephone: '(570) 374-0101',
    population: 2785,
    county: 'SNYDER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.susqu.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-AGUADILLA',
    address: 'BELT ST. RAMEY BASE',
    city: 'AGUADILLA',
    state: 'PR',
    zip: 604,
    telephone: '(787) 890-2681 EXT 2207',
    population: 2790,
    county: 'AGUADILLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uprag.edu/',
  },
  {
    name: 'BOWDOIN COLLEGE',
    address: '255 MAINE STREET',
    city: 'BRUNSWICK',
    state: 'ME',
    zip: 4011,
    telephone: '(207) 725-3000',
    population: 2794,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bowdoin.edu/',
  },
  {
    name: 'UNIVERSITY OF MINNESOTA-CROOKSTON',
    address: '2900 UNIVERSITY AVE',
    city: 'CROOKSTON',
    state: 'MN',
    zip: 56716,
    telephone: '(800) 862-6466',
    population: 2799,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.crk.umn.edu/',
  },
  {
    name: 'UNIVERSITY OF SAINT FRANCIS-FORT WAYNE',
    address: '2701 SPRING ST',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46808,
    telephone: '(260) 399-7700',
    population: 2800,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sf.edu/',
  },
  {
    name: 'PANOLA COLLEGE',
    address: '1109 W PANOLA STREET',
    city: 'CARTHAGE',
    state: 'TX',
    zip: 75633,
    telephone: '(903) 693-2000',
    population: 2802,
    county: 'PANOLA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.panola.edu/',
  },
  {
    name: 'KENTUCKY STATE UNIVERSITY',
    address: '400 EAST MAIN STREET',
    city: 'FRANKFORT',
    state: 'KY',
    zip: 40601,
    telephone: '(502) 597-6000',
    population: 2805,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kysu.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-SOUTH CAROLINA',
    address: '777 LOWNDES HILL ROAD',
    city: 'GREENVILLE',
    state: 'SC',
    zip: 29607,
    telephone: '(877) 445-7180',
    population: 2806,
    county: 'GREENVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/south-carolina/greenville',
  },
  {
    name: 'MOUNT VERNON NAZARENE UNIVERSITY',
    address: '800 MARTINSBURG RD',
    city: 'MOUNT VERNON',
    state: 'OH',
    zip: 43050,
    telephone: '(740) 392-6868',
    population: 2810,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mvnu.edu/',
  },
  {
    name: 'DOANE UNIVERSITY',
    address: '1014 BOSWELL AVENUE',
    city: 'CRETE',
    state: 'NE',
    zip: 68333,
    telephone: '(402) 826-2161',
    population: 2810,
    county: 'SALINE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.doane.edu/',
  },
  {
    name: 'WAGNER COLLEGE',
    address: 'ONE CAMPUS RD',
    city: 'STATEN ISLAND',
    state: 'NY',
    zip: 10301,
    telephone: '(718) 390-3100',
    population: 2814,
    county: 'RICHMOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wagner.edu/',
  },
  {
    name: 'NEW ORLEANS BAPTIST THEOLOGICAL SEMINARY',
    address: '3939 GENTILLY BLVD',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70126,
    telephone: '(504) 282-4455',
    population: 2818,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nobts.edu/',
  },
  {
    name: 'BLUE RIDGE COMMUNITY COLLEGE',
    address: '180 WEST CAMPUS DRIVE',
    city: 'FLAT ROCK',
    state: 'NC',
    zip: 28731,
    telephone: '(828) 694-1700',
    population: 2826,
    county: 'HENDERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.blueridge.edu/',
  },
  {
    name: 'SOUTHWESTERN COMMUNITY COLLEGE',
    address: '447 COLLEGE DRIVE',
    city: 'SYLVA',
    state: 'NC',
    zip: 28779,
    telephone: '(828) 339-4000',
    population: 2831,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southwesterncc.edu/',
  },
  {
    name: 'GALEN COLLEGE OF NURSING-SAN ANTONIO',
    address: '7411 JOHN SMITH DRIVE, SUITE 300',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78229,
    telephone: '(210) 733-3056',
    population: 2831,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.galencollege.edu/sanantonio/',
  },
  {
    name: 'SPELMAN COLLEGE',
    address: '350 SPELMAN LANE SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30314,
    telephone: '(404) 681-3643',
    population: 2834,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.spelman.edu/',
  },
  {
    name: 'LENOIR COMMUNITY COLLEGE',
    address: '231 HIGHWAY 58 SOUTH',
    city: 'KINSTON',
    state: 'NC',
    zip: 28502,
    telephone: '(252) 527-6223',
    population: 2839,
    county: 'LENOIR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lenoircc.edu/',
  },
  {
    name: 'CASCADIA COLLEGE',
    address: '18345 CAMPUS WAY NE',
    city: 'BOTHELL',
    state: 'WA',
    zip: 98011,
    telephone: '(425) 352-8000',
    population: 2842,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cascadia.edu/',
  },
  {
    name: 'LAKE MICHIGAN COLLEGE',
    address: '2755 EAST NAPIER AVENUE',
    city: 'BENTON HARBOR',
    state: 'MI',
    zip: 49022,
    telephone: '(269) 927-8100',
    population: 2844,
    county: 'BERRIEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lakemichigancollege.edu/',
  },
  {
    name: 'NORTHEAST ALABAMA COMMUNITY COLLEGE',
    address: '138 HIGHWAY 35',
    city: 'RAINSVILLE',
    state: 'AL',
    zip: 35986,
    telephone: '(256) 638-4418 EXT 2201',
    population: 2846,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nacc.edu/',
  },
  {
    name: 'SOUTHWEST WISCONSIN TECHNICAL COLLEGE',
    address: '1800 BRONSON BLVD',
    city: 'FENNIMORE',
    state: 'WI',
    zip: 53809,
    telephone: '(608) 822-3262',
    population: 2851,
    county: 'GRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.swtc.edu/',
  },
  {
    name: 'SONORAN DESERT INSTITUTE',
    address: '1555 W UNIVERSITY DR',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85281,
    telephone: '(480) 314-2012',
    population: 2857,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sdi.edu/',
  },
  {
    name: 'MORNINGSIDE COLLEGE',
    address: '1501 MORNINGSIDE AVE',
    city: 'SIOUX CITY',
    state: 'IA',
    zip: 51106,
    telephone: '(712) 274-5000',
    population: 2863,
    county: 'WOODBURY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.morningside.edu/',
  },
  {
    name: 'MUHLENBERG COLLEGE',
    address: '2400 CHEW STREET',
    city: 'ALLENTOWN',
    state: 'PA',
    zip: 18104,
    telephone: '(484) 664-3100',
    population: 2870,
    county: 'LEHIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.muhlenberg.edu/',
  },
  {
    name: "THE MASTER'S UNIVERSITY AND SEMINARY",
    address: '21726 PLACERITA CANYON ROAD',
    city: 'SANTA CLARITA',
    state: 'CA',
    zip: 91321,
    telephone: '(661) 259-3540',
    population: 2878,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.masters.edu/',
  },
  {
    name: 'UNIVERSITY OF MOUNT OLIVE',
    address: '634 HENDERSON ST',
    city: 'MOUNT OLIVE',
    state: 'NC',
    zip: 28365,
    telephone: '(919) 658-2502',
    population: 2880,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.umo.edu/',
  },
  {
    name: 'QUEENS UNIVERSITY OF CHARLOTTE',
    address: '1900 SELWYN AVE',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28274,
    telephone: '(704) 337-2200',
    population: 2881,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.queens.edu/',
  },
  {
    name: 'PIEDMONT UNIVERSITY',
    address: '1021 CENTRAL AVE',
    city: 'DEMOREST',
    state: 'GA',
    zip: 30535,
    telephone: '(706) 778-3000',
    population: 2883,
    county: 'HABERSHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.piedmont.edu/',
  },
  {
    name: 'MOUNT HOLYOKE COLLEGE',
    address: '50 COLLEGE STREET',
    city: 'SOUTH HADLEY',
    state: 'MA',
    zip: 1075,
    telephone: '(413) 538-2000',
    population: 2883,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mtholyoke.edu/',
  },
  {
    name: 'NORTH GEORGIA TECHNICAL COLLEGE',
    address: '1500 GEORGIA HWY 197 N',
    city: 'CLARKESVILLE',
    state: 'GA',
    zip: 30523,
    telephone: '(706) 754-7700',
    population: 2887,
    county: 'HABERSHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://northgatech.edu/',
  },
  {
    name: 'NEUMANN UNIVERSITY',
    address: 'ONE NEUMANN DRIVE',
    city: 'ASTON',
    state: 'PA',
    zip: 19014,
    telephone: '(610) 459-0905',
    population: 2891,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neumann.edu/',
  },
  {
    name: 'WEST VIRGINIA UNIVERSITY AT PARKERSBURG',
    address: '300 CAMPUS DRIVE',
    city: 'PARKERSBURG',
    state: 'WV',
    zip: 26104,
    telephone: '(304) 424-8000',
    population: 2891,
    county: 'WOOD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvup.edu/',
  },
  {
    name: 'GUSTAVUS ADOLPHUS COLLEGE',
    address: '800 WEST COLLEGE AVENUE',
    city: 'SAINT PETER',
    state: 'MN',
    zip: 56082,
    telephone: '(507) 933-8000',
    population: 2892,
    county: 'NICOLLET',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'gustavus.edu/',
  },
  {
    name: 'STANLY COMMUNITY COLLEGE',
    address: '141 COLLEGE DRIVE',
    city: 'ALBEMARLE',
    state: 'NC',
    zip: 28001,
    telephone: '(704) 982-0121',
    population: 2892,
    county: 'STANLY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stanly.edu/',
  },
  {
    name: 'WEST LIBERTY UNIVERSITY',
    address: '208 UNIVERSITY DRIVE',
    city: 'WEST LIBERTY',
    state: 'WV',
    zip: 26074,
    telephone: '(304) 336-5000',
    population: 2897,
    county: 'OHIO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westliberty.edu/',
  },
  {
    name: 'UNIVERSITY OF EVANSVILLE',
    address: '1800 LINCOLN AVENUE',
    city: 'EVANSVILLE',
    state: 'IN',
    zip: 47722,
    telephone: '(812) 488-2000',
    population: 2905,
    county: 'VANDERBURGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.evansville.edu/',
  },
  {
    name: 'UNION COLLEGE',
    address: '807 UNION STREET',
    city: 'SCHENECTADY',
    state: 'NY',
    zip: 12308,
    telephone: '(518) 388-6000',
    population: 2907,
    county: 'SCHENECTADY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.union.edu/',
  },
  {
    name: 'COPPIN STATE UNIVERSITY',
    address: '2500 WEST NORTH AVENUE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21216,
    telephone: '(410) 951-3000',
    population: 2908,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coppin.edu/',
  },
  {
    name: 'SOUTH CAROLINA STATE UNIVERSITY',
    address: '300 COLLEGE ST NE',
    city: 'ORANGEBURG',
    state: 'SC',
    zip: 29117,
    telephone: '(803) 536-7000',
    population: 2908,
    county: 'ORANGEBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scsu.edu/',
  },
  {
    name: 'RAPPAHANNOCK COMMUNITY COLLEGE',
    address: '12745 COLLEGE DRIVE',
    city: 'GLENNS',
    state: 'VA',
    zip: 23149,
    telephone: '(804) 758-6700',
    population: 2909,
    county: 'GLOUCESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rappahannock.edu/',
  },
  {
    name: 'DAVIDSON COLLEGE',
    address: '405 N. MAIN STREET',
    city: 'DAVIDSON',
    state: 'NC',
    zip: 28035,
    telephone: '(704) 894-2000',
    population: 2910,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://davidson.edu/',
  },
  {
    name: "KING'S COLLEGE",
    address: '133 N RIVER ST',
    city: 'WILKES-BARRE',
    state: 'PA',
    zip: 18711,
    telephone: '(570) 208-5900',
    population: 2912,
    county: 'LUZERNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kings.edu/',
  },
  {
    name: 'SOUTH DAKOTA SCHOOL OF MINES AND TECHNOLOGY',
    address: '501 E SAINT JOSEPH ST',
    city: 'RAPID CITY',
    state: 'SD',
    zip: 57701,
    telephone: '(605) 394-2511',
    population: 2920,
    county: 'PENNINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sdsmt.edu/',
  },
  {
    name: 'TRINITY COLLEGE',
    address: '300 SUMMIT ST',
    city: 'HARTFORD',
    state: 'CT',
    zip: 6106,
    telephone: '(860) 297-2000',
    population: 2921,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.trincoll.edu/',
  },
  {
    name: 'HAZARD COMMUNITY AND TECHNICAL COLLEGE',
    address: 'ONE COMMUNITY COLLEGE DRIVE',
    city: 'HAZARD',
    state: 'KY',
    zip: 41701,
    telephone: '(606) 487-3503',
    population: 2921,
    county: 'PERRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://hazard.kctcs.edu/',
  },
  {
    name: 'UNIVERSITY OF PUGET SOUND',
    address: '1500 N. WARNER STREET',
    city: 'TACOMA',
    state: 'WA',
    zip: 98416,
    telephone: '(253) 879-3100',
    population: 2925,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pugetsound.edu/',
  },
  {
    name: 'EAST CENTRAL COLLEGE',
    address: '1964 PRAIRIE DELL RD',
    city: 'UNION',
    state: 'MO',
    zip: 63084,
    telephone: '(636) 584-6500',
    population: 2934,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eastcentral.edu/',
  },
  {
    name: 'GOLDEN GATE UNIVERSITY-SAN FRANCISCO',
    address: '536 MISSION STREET',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94105,
    telephone: '(415) 442-7800',
    population: 2940,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ggu.edu/',
  },
  {
    name: 'THE EVERGREEN STATE COLLEGE',
    address: '2700 EVERGREEN PKWY NW',
    city: 'OLYMPIA',
    state: 'WA',
    zip: 98505,
    telephone: '(360) 867-6170',
    population: 2941,
    county: 'THURSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.evergreen.edu/',
  },
  {
    name: 'DYERSBURG STATE COMMUNITY COLLEGE',
    address: '1510 LAKE RD',
    city: 'DYERSBURG',
    state: 'TN',
    zip: 38024,
    telephone: '(731) 286-3200',
    population: 2943,
    county: 'DYER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dscc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-SUPERIOR',
    address: '1605 CATLIN AVE',
    city: 'SUPERIOR',
    state: 'WI',
    zip: 54880,
    telephone: '(715) 394-8101',
    population: 2945,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwsuper.edu/',
  },
  {
    name: 'SOUTH CENTRAL COLLEGE',
    address: '1920 LEE BLVD',
    city: 'NORTH MANKATO',
    state: 'MN',
    zip: 56003,
    telephone: '(507) 389-7200',
    population: 2946,
    county: 'NICOLLET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southcentral.edu/',
  },
  {
    name: 'JEFFERSON COMMUNITY COLLEGE',
    address: '1220 COFFEEN ST',
    city: 'WATERTOWN',
    state: 'NY',
    zip: 13601,
    telephone: '(315) 786-2200',
    population: 2946,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sunyjefferson.edu/',
  },
  {
    name: 'OGDEN-WEBER TECHNICAL COLLEGE',
    address: '200 N WASHINGTON BLVD',
    city: 'OGDEN',
    state: 'UT',
    zip: 84404,
    telephone: '(801) 627-8300',
    population: 2949,
    county: 'WEBER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.otech.edu/',
  },
  {
    name: 'KISHWAUKEE COLLEGE',
    address: '21193 MALTA RD',
    city: 'MALTA',
    state: 'IL',
    zip: 60150,
    telephone: '(815) 825-2086',
    population: 2950,
    county: 'DEKALB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kish.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-CAROLINA',
    address: 'CARRETERA 887 BO SAN ANTON',
    city: 'CAROLINA',
    state: 'PR',
    zip: 984,
    telephone: '(787) 257-0000 EXT 3262',
    population: 2951,
    county: 'CAROLINA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprc.edu/',
  },
  {
    name: 'ROSALIND FRANKLIN UNIVERSITY OF MEDICINE AND SCIENCE',
    address: '3333 GREEN BAY ROAD',
    city: 'NORTH CHICAGO',
    state: 'IL',
    zip: 60064,
    telephone: '(847) 578-3000',
    population: 2952,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rosalindfranklin.edu/',
  },
  {
    name: 'MISERICORDIA UNIVERSITY',
    address: '301 LAKE ST',
    city: 'DALLAS',
    state: 'PA',
    zip: 18612,
    telephone: '(570) 674-6400',
    population: 2955,
    county: 'LUZERNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.misericordia.edu/',
  },
  {
    name: 'RIVER PARISHES COMMUNITY COLLEGE',
    address: '925 WEST EDENBORNE PARKWAY',
    city: 'GONZALES',
    state: 'LA',
    zip: 70737,
    telephone: '(225) 743-8500',
    population: 2957,
    county: 'ASCENSION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rpcc.edu/',
  },
  {
    name: 'CHATHAM UNIVERSITY',
    address: 'WOODLAND ROAD, OFFICE OF INSTITUTIONAL RESEARCH',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15232,
    telephone: '(412) 365-1292',
    population: 2959,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.chatham.edu/',
  },
  {
    name: 'UNIVERSITY OF DALLAS',
    address: '1845 E NORTHGATE DRIVE',
    city: 'IRVING',
    state: 'TX',
    zip: 75062,
    telephone: '(972) 721-5000',
    population: 2962,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.udallas.edu/',
  },
  {
    name: 'COLORADO COLLEGE',
    address: '14. E CACHE LA POUDRE ST.',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80903,
    telephone: '(719) 389-6000',
    population: 2964,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coloradocollege.edu/',
  },
  {
    name: 'AMERICAN SENTINEL UNIVERSITY',
    address: '10065 E. HARVARD AVE',
    city: 'DENVER',
    state: 'CO',
    zip: 80231,
    telephone: '(303) 991-1575',
    population: 2973,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.americansentinel.edu/',
  },
  {
    name: 'COLBY COLLEGE',
    address: '4000 MAYFLOWER HILL DRIVE',
    city: 'WATERVILLE',
    state: 'ME',
    zip: 4901,
    telephone: '(207) 859-4000',
    population: 2976,
    county: 'KENNEBEC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.colby.edu/',
  },
  {
    name: 'ASSUMPTION UNIVERSITY',
    address: '500 SALISBURY ST',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1609,
    telephone: '(508) 767-7000',
    population: 2978,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.assumption.edu/',
  },
  {
    name: 'ART CENTER COLLEGE OF DESIGN',
    address: '1700 LIDA ST',
    city: 'PASADENA',
    state: 'CA',
    zip: 91103,
    telephone: '(626) 396-2200',
    population: 2981,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.artcenter.edu/',
  },
  {
    name: 'ALVERNIA UNIVERSITY',
    address: '400 SAINT BERNARDINE ST',
    city: 'READING',
    state: 'PA',
    zip: 19607,
    telephone: '(610) 796-8200',
    population: 2984,
    county: 'BERKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.alvernia.edu/',
  },
  {
    name: 'SOUTHWESTERN BAPTIST THEOLOGICAL SEMINARY',
    address: '2001 W. SEMINARY DR.',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76115,
    telephone: '(817) 923-1921',
    population: 2986,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'swbts.edu',
  },
  {
    name: 'UNIVERSITY OF THE SCIENCES',
    address: '600 SOUTH 43RD STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19104,
    telephone: '(215) 596-8800',
    population: 2987,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usciences.edu/',
  },
  {
    name: 'MANHATTANVILLE COLLEGE',
    address: '2900 PURCHASE ST',
    city: 'PURCHASE',
    state: 'NY',
    zip: 10577,
    telephone: '(914) 694-2200',
    population: 2987,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mville.edu/',
  },
  {
    name: 'MARYLAND INSTITUTE COLLEGE OF ART',
    address: '1300 MOUNT ROYAL AVENUE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21217,
    telephone: '(410) 669-9200',
    population: 2988,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mica.edu/',
  },
  {
    name: 'CURRY COLLEGE',
    address: '1071 BLUE HILL AVE',
    city: 'MILTON',
    state: 'MA',
    zip: 2186,
    telephone: '(617) 333-0500',
    population: 2989,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.curry.edu/',
  },
  {
    name: 'MID-STATE TECHNICAL COLLEGE',
    address: '500 32ND ST N',
    city: 'WISCONSIN RAPIDS',
    state: 'WI',
    zip: 54494,
    telephone: '(715) 422-5300',
    population: 2989,
    county: 'WOOD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mstc.edu/',
  },
  {
    name: 'ALBERT EINSTEIN COLLEGE OF MEDICINE',
    address: '1300 MORRIS PARK AVENUE',
    city: 'BRONX',
    state: 'NY',
    zip: 10461,
    telephone: '(718) 430-2000',
    population: 2990,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.einsteinmed.org/',
  },
  {
    name: 'IMMACULATA UNIVERSITY',
    address: '1145 KING ROAD',
    city: 'IMMACULATA',
    state: 'PA',
    zip: 19345,
    telephone: '(610) 647-4400',
    population: 2992,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.immaculata.edu/',
  },
  {
    name: 'ALLEGANY COLLEGE OF MARYLAND',
    address: '12401 WILLOWBROOK RD SE',
    city: 'CUMBERLAND',
    state: 'MD',
    zip: 21502,
    telephone: '(301) 784-5000',
    population: 2992,
    county: 'ALLEGANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.allegany.edu/',
  },
  {
    name: 'CUMBERLAND COUNTY COLLEGE',
    address: '3322 COLLEGE DRIVE',
    city: 'VINELAND',
    state: 'NJ',
    zip: 8362,
    telephone: '(856) 691-8600',
    population: 3009,
    county: 'CUMBERLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rcsj.edu/',
  },
  {
    name: 'VITERBO UNIVERSITY',
    address: '900 VITERBO DRIVE',
    city: 'LA CROSSE',
    state: 'WI',
    zip: 54601,
    telephone: '(608) 796-3001',
    population: 3012,
    county: 'LA CROSSE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www4.viterbo.edu/',
  },
  {
    name: 'NORTH CENTRAL STATE COLLEGE',
    address: '2441 KENWOOD CIRCLE',
    city: 'MANSFIELD',
    state: 'OH',
    zip: 44901,
    telephone: '(419) 755-4800',
    population: 3013,
    county: 'RICHLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ncstatecollege.edu/',
  },
  {
    name: 'SUNY MORRISVILLE',
    address: '80 EATON STREET',
    city: 'MORRISVILLE',
    state: 'NY',
    zip: 13408,
    telephone: '(315) 684-6000',
    population: 3021,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.morrisville.edu/',
  },
  {
    name: 'COLLEGE OF THE ALBEMARLE',
    address: '1208 N ROAD ST',
    city: 'ELIZABETH CITY',
    state: 'NC',
    zip: 27906,
    telephone: '(252) 335-0821 EXT 0',
    population: 3022,
    county: 'PASQUOTANK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.albemarle.edu/',
  },
  {
    name: 'UNIVERSITY OF SAINT JOSEPH',
    address: '1678 ASYLUM AVENUE',
    city: 'WEST HARTFORD',
    state: 'CT',
    zip: 6117,
    telephone: '(860) 232-4571',
    population: 3027,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usj.edu/',
  },
  {
    name: 'CAPITAL COMMUNITY COLLEGE',
    address: '950 MAIN STREET',
    city: 'HARTFORD',
    state: 'CT',
    zip: 6103,
    telephone: '(860) 906-5000',
    population: 3034,
    county: 'HARTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccc.commnet.edu/',
  },
  {
    name: 'THE COLLEGE OF HEALTH CARE PROFESSIONS-NORTHWEST',
    address: '240 NORTHWEST MALL',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77092,
    telephone: '(713) 425-3100',
    population: 3041,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chcp.edu/',
  },
  {
    name: 'AUGUSTANA COLLEGE',
    address: '639 38TH ST',
    city: 'ROCK ISLAND',
    state: 'IL',
    zip: 61201,
    telephone: '(309) 794-7000',
    population: 3047,
    county: 'ROCK ISLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.augustana.edu/',
  },
  {
    name: 'FELICIAN UNIVERSITY',
    address: '262 S MAIN ST',
    city: 'LODI',
    state: 'NJ',
    zip: 7644,
    telephone: '(201) 559-6000',
    population: 3050,
    county: 'BERGEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.felician.edu/',
  },
  {
    name: 'HIGHLAND COMMUNITY COLLEGE',
    address: '606 W MAIN',
    city: 'HIGHLAND',
    state: 'KS',
    zip: 66035,
    telephone: '(785) 442-6000',
    population: 3050,
    county: 'DONIPHAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.highlandcc.edu/',
  },
  {
    name: 'NORTH IOWA AREA COMMUNITY COLLEGE',
    address: '500 COLLEGE DR',
    city: 'MASON CITY',
    state: 'IA',
    zip: 50401,
    telephone: '(641) 423-1264',
    population: 3051,
    county: 'CERRO GORDO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.niacc.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS AT MONTICELLO',
    address: 'HIGHWAY 425 SOUTH',
    city: 'MONTICELLO',
    state: 'AR',
    zip: 71656,
    telephone: '(870) 367-6811',
    population: 3059,
    county: 'DREW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uamont.edu/',
  },
  {
    name: 'VERNON COLLEGE',
    address: '4400 COLLEGE DR.',
    city: 'VERNON',
    state: 'TX',
    zip: 76384,
    telephone: '(940) 552-6291',
    population: 3061,
    county: 'WILBARGER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vernoncollege.edu/',
  },
  {
    name: 'THREE RIVERS COLLEGE',
    address: '2080 THREE RIVERS BLVD',
    city: 'POPLAR BLUFF',
    state: 'MO',
    zip: 63901,
    telephone: '(573) 840-9600',
    population: 3064,
    county: 'BUTLER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://trcc.edu/',
  },
  {
    name: 'DAEMEN COLLEGE',
    address: '4380 MAIN ST',
    city: 'AMHERST',
    state: 'NY',
    zip: 14226,
    telephone: '(716) 839-3600',
    population: 3075,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.daemen.edu/',
  },
  {
    name: 'DENISON UNIVERSITY',
    address: '100 WEST COLLEGE STREET',
    city: 'GRANVILLE',
    state: 'OH',
    zip: 43023,
    telephone: '(740) 587-0810',
    population: 3082,
    county: 'LICKING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.denison.edu/',
  },
  {
    name: 'KASKASKIA COLLEGE',
    address: '27210 COLLEGE RD',
    city: 'CENTRALIA',
    state: 'IL',
    zip: 62801,
    telephone: '(618) 545-3000',
    population: 3084,
    county: 'CLINTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.kaskaskia.edu/',
  },
  {
    name: 'NORTHLAND PIONEER COLLEGE',
    address: '2251 E. NAVAJO BLVD.',
    city: 'HOLBROOK',
    state: 'AZ',
    zip: 86025,
    telephone: '(800) 266-7845',
    population: 3085,
    county: 'NAVAJO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.npc.edu/',
  },
  {
    name: 'ST LAWRENCE UNIVERSITY',
    address: '23 ROMODA DRIVE',
    city: 'CANTON',
    state: 'NY',
    zip: 13617,
    telephone: '(315) 229-5011',
    population: 3086,
    county: 'ST. LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stlawu.edu/',
  },
  {
    name: 'CUMBERLAND UNIVERSITY',
    address: '1 CUMBERLAND SQUARE',
    city: 'LEBANON',
    state: 'TN',
    zip: 37087,
    telephone: '(615) 444-2562 EXT 1222',
    population: 3095,
    county: 'WILSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cumberland.edu/',
  },
  {
    name: 'HERZING UNIVERSITY-MADISON',
    address: '5218 E. TERRACE DR.',
    city: 'MADISON',
    state: 'WI',
    zip: 53718,
    telephone: '(800) 582-1227',
    population: 3097,
    county: 'DANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.herzing.edu/',
  },
  {
    name: 'ALBANY MEDICAL COLLEGE',
    address: '47 NEW SCOTLAND AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12208,
    telephone: '(518) 262-3125',
    population: 3103,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.amc.edu/',
  },
  {
    name: 'WILKES COMMUNITY COLLEGE',
    address: '1328 SOUTH COLLEGIATE DR',
    city: 'WILKESBORO',
    state: 'NC',
    zip: 28697,
    telephone: '(336) 838-6100',
    population: 3106,
    county: 'WILKES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wilkescc.edu/',
  },
  {
    name: 'WOR-WIC COMMUNITY COLLEGE',
    address: '32000 CAMPUS DRIVE',
    city: 'SALISBURY',
    state: 'MD',
    zip: 21804,
    telephone: '(410) 334-2800',
    population: 3106,
    county: 'WICOMICO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.worwic.edu/',
  },
  {
    name: 'MOUNT ALOYSIUS COLLEGE',
    address: '7373 ADMIRAL PEARY HWY',
    city: 'CRESSON',
    state: 'PA',
    zip: 16630,
    telephone: '(814) 886-4131',
    population: 3111,
    county: 'CAMBRIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtaloy.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY-NEWARK CAMPUS',
    address: '1179 UNIVERSITY DR',
    city: 'NEWARK',
    state: 'OH',
    zip: 43055,
    telephone: '(740) 366-3321',
    population: 3115,
    county: 'LICKING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'newark.osu.edu/',
  },
  {
    name: 'MISSISSIPPI UNIVERSITY FOR WOMEN',
    address: '1100 COLLEGE STREET',
    city: 'COLUMBUS',
    state: 'MS',
    zip: 39701,
    telephone: '(662) 329-4750',
    population: 3117,
    county: 'LOWNDES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.muw.edu/',
  },
  {
    name: 'WALSH UNIVERSITY',
    address: '2020 EAST MAPLE ST',
    city: 'NORTH CANTON',
    state: 'OH',
    zip: 44720,
    telephone: '(330) 499-7090',
    population: 3121,
    county: 'STARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.walsh.edu/',
  },
  {
    name: 'RANDOLPH COMMUNITY COLLEGE',
    address: '629 INDUSTRIAL PARK AVE',
    city: 'ASHEBORO',
    state: 'NC',
    zip: 27205,
    telephone: '(336) 633-0200',
    population: 3129,
    county: 'RANDOLPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.randolph.edu/',
  },
  {
    name: 'SOUTH FLORIDA STATE COLLEGE',
    address: '600 W COLLEGE DR',
    city: 'AVON PARK',
    state: 'FL',
    zip: 33825,
    telephone: '(863) 453-6661',
    population: 3132,
    county: 'HIGHLANDS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southflorida.edu/',
  },
  {
    name: 'BERKELEY COLLEGE-WOODLAND PARK',
    address: '44 RIFLE CAMP RD',
    city: 'WOODLAND PARK',
    state: 'NJ',
    zip: 7424,
    telephone: '(973) 278-5400',
    population: 3136,
    county: 'PASSAIC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://berkeleycollege.edu/',
  },
  {
    name: 'NORTHEAST TEXAS COMMUNITY COLLEGE',
    address: '2886 FM 1735',
    city: 'MOUNT PLEASANT',
    state: 'TX',
    zip: 75455,
    telephone: '(903) 434-8100',
    population: 3138,
    county: 'TITUS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ntcc.edu/',
  },
  {
    name: 'CRAVEN COMMUNITY COLLEGE',
    address: '800 COLLEGE CT',
    city: 'NEW BERN',
    state: 'NC',
    zip: 28562,
    telephone: '(252) 638-7200',
    population: 3143,
    county: 'CRAVEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cravencc.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-DISTRICT OF COLUMBIA',
    address: '1133 15TH ST NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20005,
    telephone: '(877) 445-7180',
    population: 3148,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/district-columbia/washington',
  },
  {
    name: 'UNIVERSITY OF MONTEVALLO',
    address: 'STATION 6001',
    city: 'MONTEVALLO',
    state: 'AL',
    zip: 35115,
    telephone: '(205) 665-6155',
    population: 3153,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.montevallo.edu/',
  },
  {
    name: 'LAKELAND UNIVERSITY',
    address: 'W3718 SOUTH DRIVE',
    city: 'PLYMOUTH',
    state: 'WI',
    zip: 53073,
    telephone: '(920) 565-1000',
    population: 3154,
    county: 'SHEBOYGAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lakeland.edu/',
  },
  {
    name: 'LENOIR-RHYNE UNIVERSITY',
    address: '625 7TH AVENUE NE',
    city: 'HICKORY',
    state: 'NC',
    zip: 28601,
    telephone: '(828) 328-1741',
    population: 3159,
    county: 'CATAWBA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lr.edu/',
  },
  {
    name: 'ST BONAVENTURE UNIVERSITY',
    address: '3261 W. STATE ROAD',
    city: 'SAINT BONAVENTURE',
    state: 'NY',
    zip: 14778,
    telephone: '(716) 375-2000',
    population: 3160,
    county: 'CATTARAUGUS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sbu.edu/',
  },
  {
    name: 'MORAINE PARK TECHNICAL COLLEGE',
    address: '235 N NATIONAL AVENUE',
    city: 'FOND DU LAC',
    state: 'WI',
    zip: 54936,
    telephone: '(920) 929-2483',
    population: 3162,
    county: 'FOND DU LAC',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.morainepark.edu/',
  },
  {
    name: "MOUNT ST. MARY'S UNIVERSITY",
    address: '16300 OLD EMMITSBURG ROAD',
    city: 'EMMITSBURG',
    state: 'MD',
    zip: 21727,
    telephone: '(301) 447-6122',
    population: 3169,
    county: 'FREDERICK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://msmary.edu/',
  },
  {
    name: 'GEORGIA PIEDMONT TECHNICAL COLLEGE',
    address: '495 N INDIAN CREEK DR',
    city: 'CLARKSTON',
    state: 'GA',
    zip: 30021,
    telephone: '(404) 297-9522 EXT 1282',
    population: 3169,
    county: 'DEKALB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gptc.edu/',
  },
  {
    name: 'FRANKLIN AND MARSHALL COLLEGE',
    address: 'COLLEGE AVE',
    city: 'LANCASTER',
    state: 'PA',
    zip: 17604,
    telephone: '(717) 358-3911',
    population: 3173,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fandm.edu/',
  },
  {
    name: 'LAWSON STATE COMMUNITY COLLEGE',
    address: '3060 WILSON RD SW',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35221,
    telephone: '(205) 925-2515',
    population: 3174,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lawsonstate.edu/',
  },
  {
    name: 'NASH COMMUNITY COLLEGE',
    address: '522 N. OLD CARRIAGE ROAD',
    city: 'ROCKY MOUNT',
    state: 'NC',
    zip: 27804,
    telephone: '(252) 443-4011',
    population: 3176,
    county: 'NASH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nashcc.edu/',
  },
  {
    name: 'PRAIRIE STATE COLLEGE',
    address: '202 SOUTH HALSTED STREET',
    city: 'CHICAGO HEIGHTS',
    state: 'IL',
    zip: 60411,
    telephone: '(708) 709-3500',
    population: 3177,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.prairiestate.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-CALIFORNIA',
    address: '3110 EAST GUASTI ROAD',
    city: 'ONTARIO',
    state: 'CA',
    zip: 91761,
    telephone: '(866) 766-0766',
    population: 3179,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'THE CHICAGO SCHOOL OF PROFESSIONAL PSYCHOLOGY AT LOS ANGELES',
    address: '707 WILSHIRE BOULEVARD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90017,
    telephone: '(213) 627-7200',
    population: 3186,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.thechicagoschool.edu/los-angeles/',
  },
  {
    name: 'MILWAUKEE SCHOOL OF ENGINEERING',
    address: '1025 N BROADWAY',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53202,
    telephone: '(800) 332-6763',
    population: 3196,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msoe.edu/',
  },
  {
    name: 'NORTHLAND COMMUNITY AND TECHNICAL COLLEGE',
    address: '1101 HWY ONE EAST',
    city: 'THIEF RIVER FALLS',
    state: 'MN',
    zip: 56701,
    telephone: '(218) 793-2800',
    population: 3198,
    county: 'PENNINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northlandcollege.edu/',
  },
  {
    name: 'FLAGLER COLLEGE',
    address: '74 KING STREET',
    city: 'SAINT AUGUSTINE',
    state: 'FL',
    zip: 32084,
    telephone: '(904) 829-6481',
    population: 3204,
    county: 'ST. JOHNS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.flagler.edu/',
  },
  {
    name: 'CAPE COD COMMUNITY COLLEGE',
    address: '2240 IYANNOUGH RD',
    city: 'WEST BARNSTABLE',
    state: 'MA',
    zip: 2668,
    telephone: '(508) 362-2131 EXT 4311',
    population: 3204,
    county: 'BARNSTABLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.capecod.edu/',
  },
  {
    name: 'WASHINGTON AND LEE UNIVERSITY',
    address: '204 WEST WASHINGTON STREET',
    city: 'LEXINGTON',
    state: 'VA',
    zip: 24450,
    telephone: '(540) 458-8400',
    population: 3205,
    county: 'LEXINGTON CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wlu.edu/',
  },
  {
    name: 'WHATCOM COMMUNITY COLLEGE',
    address: '237 W KELLOGG RD',
    city: 'BELLINGHAM',
    state: 'WA',
    zip: 98226,
    telephone: '(360) 383-3000',
    population: 3208,
    county: 'WHATCOM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'whatcom.edu/',
  },
  {
    name: 'SOUTHERN ADVENTIST UNIVERSITY',
    address: '4881 TAYLOR CIR',
    city: 'COLLEGEDALE',
    state: 'TN',
    zip: 37315,
    telephone: '(423) 236-2000',
    population: 3212,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southern.edu/',
  },
  {
    name: 'LINDSEY WILSON COLLEGE',
    address: '210 LINDSEY WILSON ST',
    city: 'COLUMBIA',
    state: 'KY',
    zip: 42728,
    telephone: '(270) 384-2126',
    population: 3216,
    county: 'ADAIR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lindsey.edu/',
  },
  {
    name: 'SOWELA TECHNICAL COMMUNITY COLLEGE',
    address: '3820 SENATOR J. BENNETT JOHNSTON AVE',
    city: 'LAKE CHARLES',
    state: 'LA',
    zip: 70615,
    telephone: '(337) 421-6565',
    population: 3216,
    county: 'CALCASIEU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sowela.edu/',
  },
  {
    name: 'STONEHILL COLLEGE',
    address: '320 WASHINGTON STREET',
    city: 'EASTON',
    state: 'MA',
    zip: 2357,
    telephone: '(508) 565-1000',
    population: 3217,
    county: 'BRISTOL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stonehill.edu/',
  },
  {
    name: 'GALEN COLLEGE OF NURSING-LOUISVILLE',
    address: '1031 ZORN AVENUE',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40207,
    telephone: '(502) 410-6200',
    population: 3220,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.galencollege.edu/louisville',
  },
  {
    name: 'COLLEGE OF MOUNT SAINT VINCENT',
    address: '6301 RIVERDALE AVE',
    city: 'BRONX',
    state: 'NY',
    zip: 10471,
    telephone: '(718) 405-3200',
    population: 3222,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mountsaintvincent.edu/',
  },
  {
    name: 'NORTHWOOD UNIVERSITY',
    address: '4000 WHITING DR',
    city: 'MIDLAND',
    state: 'MI',
    zip: 48640,
    telephone: '(800) 622-9000',
    population: 3222,
    county: 'MIDLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northwood.edu/',
  },
  {
    name: 'CENTRAL CAROLINA TECHNICAL COLLEGE',
    address: '506 N GUIGNARD DR',
    city: 'SUMTER',
    state: 'SC',
    zip: 29150,
    telephone: '(803) 778-1961',
    population: 3224,
    county: 'SUMTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cctech.edu/',
  },
  {
    name: 'TRUETT MCCONNELL UNIVERSITY',
    address: '100 ALUMNI DR',
    city: 'CLEVELAND',
    state: 'GA',
    zip: 30528,
    telephone: '(706) 865-2134',
    population: 3226,
    county: 'WHITE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://truett.edu/',
  },
  {
    name: 'COPIAH-LINCOLN COMMUNITY COLLEGE',
    address: '1001 CO-LIN LANE',
    city: 'WESSON',
    state: 'MS',
    zip: 39191,
    telephone: '(601) 643-5101',
    population: 3228,
    county: 'COPIAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.colin.edu/',
  },
  {
    name: 'ATHENS STATE UNIVERSITY',
    address: '300 N BEATY ST',
    city: 'ATHENS',
    state: 'AL',
    zip: 35611,
    telephone: '(256) 233-8100',
    population: 3229,
    county: 'LIMESTONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.athens.edu/',
  },
  {
    name: 'CAYUGA COUNTY COMMUNITY COLLEGE',
    address: '197 FRANKLIN STREET',
    city: 'AUBURN',
    state: 'NY',
    zip: 13021,
    telephone: '(315) 255-1743',
    population: 3230,
    county: 'CAYUGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cayuga-cc.edu/',
  },
  {
    name: "D'YOUVILLE COLLEGE",
    address: '320 PORTER AVE',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14201,
    telephone: '(716) 829-8000',
    population: 3231,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dyc.edu/',
  },
  {
    name: 'OTTERBEIN UNIVERSITY',
    address: '1 SOUTH GROVE STREET',
    city: 'WESTERVILLE',
    state: 'OH',
    zip: 43081,
    telephone: '(614) 890-3000',
    population: 3244,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.otterbein.edu/',
  },
  {
    name: 'INDIANA INSTITUTE OF TECHNOLOGY',
    address: '1600 E WASHINGTON BLVD',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46803,
    telephone: '(800) 937-2448',
    population: 3246,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.indianatech.edu/',
  },
  {
    name: 'UNIVERSITY OF HAWAII MAUI COLLEGE',
    address: '310 W KAAHUMANU AVE',
    city: 'KAHULUI',
    state: 'HI',
    zip: 96732,
    telephone: '(808) 984-3500',
    population: 3248,
    county: 'MAUI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'maui.hawaii.edu/',
  },
  {
    name: 'OKLAHOMA CITY UNIVERSITY',
    address: '2501 N BLACKWELDER',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73106,
    telephone: '(405) 208-5000',
    population: 3263,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.okcu.edu/',
  },
  {
    name: 'UPSTATE MEDICAL UNIVERSITY',
    address: '750 E ADAMS ST',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13210,
    telephone: '(315) 464-5540',
    population: 3269,
    county: 'ONONDAGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upstate.edu/',
  },
  {
    name: 'MARYWOOD UNIVERSITY',
    address: '2300 ADAMS AVE',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18509,
    telephone: '(570) 348-6211',
    population: 3274,
    county: 'LACKAWANNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marywood.edu/',
  },
  {
    name: 'NORTH DAKOTA STATE COLLEGE OF SCIENCE',
    address: '800 N 6TH ST',
    city: 'WAHPETON',
    state: 'ND',
    zip: 58076,
    telephone: '(701) 671-2403',
    population: 3274,
    county: 'RICHLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ndscs.edu/',
  },
  {
    name: 'MADONNA UNIVERSITY',
    address: '36600 SCHOOLCRAFT RD',
    city: 'LIVONIA',
    state: 'MI',
    zip: 48150,
    telephone: '(734) 432-5300',
    population: 3276,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.madonna.edu/',
  },
  {
    name: 'CARTHAGE COLLEGE',
    address: '2001 ALFORD PARK DR',
    city: 'KENOSHA',
    state: 'WI',
    zip: 53140,
    telephone: '(262) 551-8500',
    population: 3277,
    county: 'KENOSHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.carthage.edu/',
  },
  {
    name: 'MERCYHURST UNIVERSITY',
    address: '501 E 38TH ST',
    city: 'ERIE',
    state: 'PA',
    zip: 16546,
    telephone: '(814) 824-2000',
    population: 3281,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mercyhurst.edu/',
  },
  {
    name: 'EASTERN OREGON UNIVERSITY',
    address: 'ONE UNIVERSITY BLVD',
    city: 'LA GRANDE',
    state: 'OR',
    zip: 97850,
    telephone: '(541) 962-3672',
    population: 3285,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eou.edu/',
  },
  {
    name: 'WILLIAMS COLLEGE',
    address: '880 MAIN ST',
    city: 'WILLIAMSTOWN',
    state: 'MA',
    zip: 1267,
    telephone: '(413) 597-3131',
    population: 3295,
    county: 'BERKSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.williams.edu/',
  },
  {
    name: 'LIFE UNIVERSITY',
    address: '1269 BARCLAY CIRCLE',
    city: 'MARIETTA',
    state: 'GA',
    zip: 30060,
    telephone: '(800) 543-3202',
    population: 3301,
    county: 'COBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.life.edu/',
  },
  {
    name: 'CHICAGO STATE UNIVERSITY',
    address: '9501 S. KING DRIVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60628,
    telephone: '(773) 995-2000',
    population: 3303,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csu.edu/',
  },
  {
    name: 'MORAVIAN COLLEGE',
    address: '1200 MAIN ST',
    city: 'BETHLEHEM',
    state: 'PA',
    zip: 18018,
    telephone: '(610) 861-1360',
    population: 3311,
    county: 'NORTHAMPTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.moravian.edu/',
  },
  {
    name: 'WESTERN WYOMING COMMUNITY COLLEGE',
    address: '2500 COLLEGE DR',
    city: 'ROCK SPRINGS',
    state: 'WY',
    zip: 82901,
    telephone: '(307) 382-1600',
    population: 3315,
    county: 'SWEETWATER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.westernwyoming.edu/',
  },
  {
    name: 'BRENAU UNIVERSITY',
    address: '500 WASHINGTON STREET SE',
    city: 'GAINESVILLE',
    state: 'GA',
    zip: 30501,
    telephone: '(770) 534-6299',
    population: 3316,
    county: 'HALL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brenau.edu/',
  },
  {
    name: 'BETHUNE-COOKMAN UNIVERSITY',
    address: '640 DR MARY MCLEOD BETHUNE BLVD',
    city: 'DAYTONA BEACH',
    state: 'FL',
    zip: 32114,
    telephone: '(386) 481-2000',
    population: 3317,
    county: 'VOLUSIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cookman.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS AT PINE BLUFF',
    address: '1200 N UNIVERSITY MAIL SLOT 4789',
    city: 'PINE BLUFF',
    state: 'AR',
    zip: 71601,
    telephone: '(870) 575-8000',
    population: 3327,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uapb.edu/',
  },
  {
    name: 'SAINT FRANCIS UNIVERSITY',
    address: '117 EVERGREEN DR',
    city: 'LORETTO',
    state: 'PA',
    zip: 15940,
    telephone: '(814) 472-3000',
    population: 3330,
    county: 'CAMBRIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.francis.edu/',
  },
  {
    name: 'SALVE REGINA UNIVERSITY',
    address: '100 OCHRE POINT AVENUE',
    city: 'NEWPORT',
    state: 'RI',
    zip: 2840,
    telephone: '(401) 847-6650',
    population: 3331,
    county: 'NEWPORT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.salve.edu/',
  },
  {
    name: 'ST FRANCIS COLLEGE',
    address: '180 REMSEN STREET',
    city: 'BROOKLYN HEIGHTS',
    state: 'NY',
    zip: 11201,
    telephone: '(718) 522-2300',
    population: 3332,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfc.edu/',
  },
  {
    name: 'NEW MEXICO HIGHLANDS UNIVERSITY',
    address: '803 UNIVERSITY AVE',
    city: 'LAS VEGAS',
    state: 'NM',
    zip: 87701,
    telephone: '(505) 425-7511',
    population: 3337,
    county: 'SAN MIGUEL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nmhu.edu/',
  },
  {
    name: 'CENTRAL OHIO TECHNICAL COLLEGE',
    address: '1179 UNIVERSITY DRIVE',
    city: 'NEWARK',
    state: 'OH',
    zip: 43055,
    telephone: '(740) 366-1351',
    population: 3337,
    county: 'LICKING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cotc.edu/',
  },
  {
    name: 'COLUMBUS TECHNICAL COLLEGE',
    address: '928 MANCHESTER EXPY',
    city: 'COLUMBUS',
    state: 'GA',
    zip: 31904,
    telephone: '(706) 649-1800',
    population: 3341,
    county: 'MUSCOGEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.columbustech.edu/',
  },
  {
    name: 'OUR LADY OF THE LAKE UNIVERSITY',
    address: '411 SW 24TH ST.',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78207,
    telephone: '(210) 434-6711',
    population: 3344,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ollusa.edu/',
  },
  {
    name: 'WARREN COUNTY COMMUNITY COLLEGE',
    address: '475 ROUTE 57 W',
    city: 'WASHINGTON',
    state: 'NJ',
    zip: 7882,
    telephone: '(908) 835-9222',
    population: 3350,
    county: 'WARREN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.warren.edu/',
  },
  {
    name: 'VANCE-GRANVILLE COMMUNITY COLLEGE',
    address: '200 COMMUNITY COLLEGE ROAD',
    city: 'HENDERSON',
    state: 'NC',
    zip: 27537,
    telephone: '(252) 492-2061',
    population: 3350,
    county: 'VANCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vgcc.edu/',
  },
  {
    name: 'SOUTHERN UNIVERSITY AT SHREVEPORT',
    address: '3050 MARTIN LUTHER KING DR',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71107,
    telephone: '(318) 670-6000',
    population: 3351,
    county: 'CADDO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.susla.edu/',
  },
  {
    name: 'WALLA WALLA COMMUNITY COLLEGE',
    address: '500 TAUSICK WAY',
    city: 'WALLA WALLA',
    state: 'WA',
    zip: 99362,
    telephone: '(509) 522-2500',
    population: 3353,
    county: 'WALLA WALLA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wwcc.edu/',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY-BEEBE',
    address: '1000 IOWA STREET',
    city: 'BEEBE',
    state: 'AR',
    zip: 72012,
    telephone: '(501) 882-3600',
    population: 3354,
    county: 'WHITE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asub.edu/',
  },
  {
    name: 'FLORIDA GATEWAY COLLEGE',
    address: 'HIGHWAY 90 EAST',
    city: 'LAKE CITY',
    state: 'FL',
    zip: 32025,
    telephone: '(386) 752-1822',
    population: 3356,
    county: 'COLUMBIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fgc.edu/',
  },
  {
    name: 'GWYNEDD MERCY UNIVERSITY',
    address: '1325 SUMNEYTOWN PIKE',
    city: 'GWYNEDD VALLEY',
    state: 'PA',
    zip: 19437,
    telephone: '(215) 646-7300',
    population: 3357,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gmercyu.edu/',
  },
  {
    name: 'GETTYSBURG COLLEGE',
    address: '300 N WASHINGTON ST',
    city: 'GETTYSBURG',
    state: 'PA',
    zip: 17325,
    telephone: '(717) 337-6300',
    population: 3357,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gettysburg.edu/',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY-EUNICE',
    address: '2048 JOHNSON HWY',
    city: 'EUNICE',
    state: 'LA',
    zip: 70535,
    telephone: '(337) 457-7311',
    population: 3360,
    county: 'ACADIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lsue.edu/',
  },
  {
    name: 'UNITED TALMUDICAL SEMINARY',
    address: '191 RODNEY ST.',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11211,
    telephone: '(718) 963-9770',
    population: 3361,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'utsny.edu/',
  },
  {
    name: 'CARSON-NEWMAN UNIVERSITY',
    address: '1646 S RUSSELL AVE',
    city: 'JEFFERSON CITY',
    state: 'TN',
    zip: 37760,
    telephone: '(865) 471-2000',
    population: 3369,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cn.edu/',
  },
  {
    name: 'WAYNE COMMUNITY COLLEGE',
    address: '3000 WAYNE MEMORIAL DR',
    city: 'GOLDSBORO',
    state: 'NC',
    zip: 27534,
    telephone: '(919) 735-5151',
    population: 3371,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.waynecc.edu/',
  },
  {
    name: 'CENTRAL MAINE COMMUNITY COLLEGE',
    address: '1250 TURNER STREET',
    city: 'AUBURN',
    state: 'ME',
    zip: 4210,
    telephone: '(207) 755-5100',
    population: 3372,
    county: 'ANDROSCOGGIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cmcc.edu/',
  },
  {
    name: 'TIFFIN UNIVERSITY',
    address: '155 MIAMI STREET',
    city: 'TIFFIN',
    state: 'OH',
    zip: 44883,
    telephone: '(800) 968-6446',
    population: 3375,
    county: 'SENECA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tiffin.edu/',
  },
  {
    name: 'WALDORF UNIVERSITY',
    address: '106 S SIXTH ST',
    city: 'FOREST CITY',
    state: 'IA',
    zip: 50436,
    telephone: '(641) 585-2450',
    population: 3384,
    county: 'WINNEBAGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.waldorf.edu/',
  },
  {
    name: 'WHITWORTH UNIVERSITY',
    address: '300 W HAWTHORNE RD',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99251,
    telephone: '(509) 777-1000',
    population: 3385,
    county: 'SPOKANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.whitworth.edu/',
  },
  {
    name: 'BARD COLLEGE',
    address: 'ANNANDALE ROAD',
    city: 'ANNANDALE-ON-HUDSON',
    state: 'NY',
    zip: 12504,
    telephone: '(845) 758-6822',
    population: 3385,
    county: 'DUTCHESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bard.edu/',
  },
  {
    name: 'QUINCY COLLEGE',
    address: '1250 HANCOCK STREET',
    city: 'QUINCY',
    state: 'MA',
    zip: 2169,
    telephone: '(800) 698-1700',
    population: 3390,
    county: 'NORFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.quincycollege.edu/',
  },
  {
    name: 'OHIO NORTHERN UNIVERSITY',
    address: '525 S. MAIN ST',
    city: 'ADA',
    state: 'OH',
    zip: 45810,
    telephone: '(419) 772-2000',
    population: 3392,
    county: 'HARDIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.onu.edu/',
  },
  {
    name: 'SUNY ADIRONDACK',
    address: '640 BAY RD',
    city: 'QUEENSBURY',
    state: 'NY',
    zip: 12804,
    telephone: '(518) 743-2200',
    population: 3395,
    county: 'WARREN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunyacc.edu/',
  },
  {
    name: 'SOUTHSIDE VIRGINIA COMMUNITY COLLEGE',
    address: '109 CAMPUS DRIVE',
    city: 'ALBERTA',
    state: 'VA',
    zip: 23821,
    telephone: '(888) 220-7822',
    population: 3396,
    county: 'BRUNSWICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.southside.edu/',
  },
  {
    name: 'WESTERN NEW MEXICO UNIVERSITY',
    address: '1000 W. COLLEGE AVE',
    city: 'SILVER CITY',
    state: 'NM',
    zip: 88061,
    telephone: '(505) 538-6336',
    population: 3398,
    county: 'GRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wnmu.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-TEXAS',
    address: '8501 N. MOPAC EXPRESSWAY',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78759,
    telephone: '(877) 445-7180',
    population: 3401,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/texas/north-austin',
  },
  {
    name: 'MADISONVILLE COMMUNITY COLLEGE',
    address: '2000 COLLEGE DRIVE',
    city: 'MADISONVILLE',
    state: 'KY',
    zip: 42431,
    telephone: '(270) 821-2250',
    population: 3401,
    county: 'HOPKINS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://madisonville.kctcs.edu/',
  },
  {
    name: 'CANISIUS COLLEGE',
    address: '2001 MAIN STREET',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14208,
    telephone: '(716) 888-2200',
    population: 3403,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.canisius.edu/',
  },
  {
    name: 'MINOT STATE UNIVERSITY',
    address: '500 UNIVERSITY AVE W',
    city: 'MINOT',
    state: 'ND',
    zip: 58707,
    telephone: '(701) 858-3000',
    population: 3403,
    county: 'WARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.minotstateu.edu/',
  },
  {
    name: 'CLEVELAND STATE COMMUNITY COLLEGE',
    address: '3535 ADKISSON DRIVE',
    city: 'CLEVELAND',
    state: 'TN',
    zip: 37312,
    telephone: '(423) 472-7141',
    population: 3404,
    county: 'BRADLEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clevelandstatecc.edu/',
  },
  {
    name: 'LAFAYETTE COLLEGE',
    address: 'HIGH ST',
    city: 'EASTON',
    state: 'PA',
    zip: 18042,
    telephone: '(610) 330-5000',
    population: 3407,
    county: 'NORTHAMPTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lafayette.edu/',
  },
  {
    name: 'UNIVERSITY OF MARYLAND EASTERN SHORE',
    address: 'J.T. WILLIAMS HALL',
    city: 'PRINCESS ANNE',
    state: 'MD',
    zip: 21853,
    telephone: '(410) 651-2200',
    population: 3411,
    county: 'SOMERSET',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umes.edu/',
  },
  {
    name: 'WENATCHEE VALLEY COLLEGE',
    address: '1300 FIFTH ST',
    city: 'WENATCHEE',
    state: 'WA',
    zip: 98801,
    telephone: '(509) 682-6800',
    population: 3414,
    county: 'CHELAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wvc.edu/',
  },
  {
    name: 'FAULKNER UNIVERSITY',
    address: '5345 ATLANTA HWY',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36109,
    telephone: '(334) 272-5820',
    population: 3415,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.faulkner.edu/',
  },
  {
    name: 'MOODY BIBLE INSTITUTE',
    address: '820 N LASALLE BLVD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60610,
    telephone: '(312) 329-4000',
    population: 3417,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.moody.edu/',
  },
  {
    name: 'ULSTER COUNTY COMMUNITY COLLEGE',
    address: '491 COTTEKILL RD',
    city: 'STONE RIDGE',
    state: 'NY',
    zip: 12484,
    telephone: '(845) 687-5000',
    population: 3417,
    county: 'ULSTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunyulster.edu/',
  },
  {
    name: 'AMERICAN INTERNATIONAL COLLEGE',
    address: '1000 STATE STREET',
    city: 'SPRINGFIELD',
    state: 'MA',
    zip: 1109,
    telephone: '(413) 737-7000',
    population: 3419,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aic.edu/',
  },
  {
    name: 'SOUTH PIEDMONT COMMUNITY COLLEGE',
    address: '680 HIGHWAY 74 WEST',
    city: 'POLKTON',
    state: 'NC',
    zip: 28135,
    telephone: '(704) 272-5300',
    population: 3421,
    county: 'ANSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.spcc.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTHWESTERN OHIO',
    address: '1441 N CABLE RD',
    city: 'LIMA',
    state: 'OH',
    zip: 45805,
    telephone: '(419) 227-3141',
    population: 3424,
    county: 'ALLEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.unoh.edu/',
  },
  {
    name: 'UNIVERSITY OF CHARLESTON',
    address: '2300 MACCORKLE AVENUE, SE',
    city: 'CHARLESTON',
    state: 'WV',
    zip: 25304,
    telephone: '(800) 995-4682',
    population: 3427,
    county: 'KANAWHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucwv.edu/',
  },
  {
    name: 'RHODE ISLAND SCHOOL OF DESIGN',
    address: '2 COLLEGE ST',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2903,
    telephone: '(401) 454-6100',
    population: 3428,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.risd.edu/',
  },
  {
    name: 'UNIVERSITY OF LYNCHBURG',
    address: '1501 LAKESIDE DR',
    city: 'LYNCHBURG',
    state: 'VA',
    zip: 24501,
    telephone: '(434) 544-8100',
    population: 3430,
    county: 'LYNCHBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lynchburg.edu/',
  },
  {
    name: 'LAWRENCE TECHNOLOGICAL UNIVERSITY',
    address: '21000 WEST TEN MILE ROAD',
    city: 'SOUTHFIELD',
    state: 'MI',
    zip: 48075,
    telephone: '(248) 204-4000',
    population: 3432,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ltu.edu/',
  },
  {
    name: 'CAMBRIDGE COLLEGE',
    address: '500 RUTHERFORD AVENUE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2129,
    telephone: '(617) 868-1000',
    population: 3436,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cambridgecollege.edu/',
  },
  {
    name: 'ALBANY TECHNICAL COLLEGE',
    address: '1704 SOUTH SLAPPEY BOULEVARD',
    city: 'ALBANY',
    state: 'GA',
    zip: 31701,
    telephone: '(229) 430-3500',
    population: 3436,
    county: 'DOUGHERTY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.albanytech.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-CAYEY',
    address: '205 ANTONIO R. BARCELO AVE.',
    city: 'CAYEY',
    state: 'PR',
    zip: 737,
    telephone: '(787) 738-2161',
    population: 3440,
    county: 'CAYEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cayey.upr.edu/',
  },
  {
    name: 'MERIDIAN COMMUNITY COLLEGE',
    address: '910 HWY 19 N',
    city: 'MERIDIAN',
    state: 'MS',
    zip: 39307,
    telephone: '(601) 483-8241',
    population: 3441,
    county: 'LAUDERDALE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.meridiancc.edu/',
  },
  {
    name: 'WELLESLEY COLLEGE',
    address: '106 CENTRAL ST',
    city: 'WELLESLEY',
    state: 'MA',
    zip: 2481,
    telephone: '(781) 283-1000',
    population: 3457,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wellesley.edu/',
  },
  {
    name: "MOUNT SAINT MARY'S UNIVERSITY",
    address: '12001 CHALON RD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90049,
    telephone: '(310) 954-4000',
    population: 3458,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.msmu.edu/',
  },
  {
    name: 'NORTH CENTRAL COLLEGE',
    address: '30 N BRAINARD ST',
    city: 'NAPERVILLE',
    state: 'IL',
    zip: 60540,
    telephone: '(630) 637-5100',
    population: 3481,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'northcentralcollege.edu/',
  },
  {
    name: 'RIDGEWATER COLLEGE',
    address: '2101 15TH AVE NW',
    city: 'WILLMAR',
    state: 'MN',
    zip: 56201,
    telephone: '(800) 722-1151',
    population: 3487,
    county: 'KANDIYOHI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ridgewater.edu/',
  },
  {
    name: 'MINNESOTA WEST COMMUNITY AND TECHNICAL COLLEGE',
    address: '1593 11TH AVE',
    city: 'GRANITE FALLS',
    state: 'MN',
    zip: 56241,
    telephone: '(800) 658-2330',
    population: 3490,
    county: 'YELLOW MEDICINE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mnwest.edu/',
  },
  {
    name: 'ATLANTA TECHNICAL COLLEGE',
    address: '1560 METROPOLITAN PKWY SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30310,
    telephone: '(404) 225-4400',
    population: 3491,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.atlantatech.edu/',
  },
  {
    name: 'THREE RIVERS COMMUNITY COLLEGE',
    address: '574 NEW LONDON TURNPIKE',
    city: 'NORWICH',
    state: 'CT',
    zip: 6360,
    telephone: '(860) 215-9000',
    population: 3493,
    county: 'NEW LONDON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.threerivers.edu/',
  },
  {
    name: 'VISTA COLLEGE',
    address: '6101 MONTANA AVE',
    city: 'EL PASO',
    state: 'TX',
    zip: 79925,
    telephone: '(915) 779-8031',
    population: 3496,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'vistacollege.edu/',
  },
  {
    name: 'BUTLER COUNTY COMMUNITY COLLEGE',
    address: '107 COLLEGE DRIVE',
    city: 'BUTLER',
    state: 'PA',
    zip: 16002,
    telephone: '(724) 287-8711',
    population: 3509,
    county: 'BUTLER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bc3.edu/',
  },
  {
    name: 'TUSKEGEE UNIVERSITY',
    address: 'KRESGE CENTER, 3RD FLOOR',
    city: 'TUSKEGEE',
    state: 'AL',
    zip: 36088,
    telephone: '(334) 727-8011',
    population: 3514,
    county: 'MACON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tuskegee.edu/',
  },
  {
    name: 'EMBRY-RIDDLE AERONAUTICAL UNIVERSITY-PRESCOTT',
    address: '3700 WILLOW CREEK ROAD',
    city: 'PRESCOTT',
    state: 'AZ',
    zip: 86301,
    telephone: '(928) 777-6600',
    population: 3522,
    county: 'YAVAPAI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'prescott.erau.edu/',
  },
  {
    name: 'UNIVERSITY OF HAWAII-WEST OAHU',
    address: '91-1001 FARRINGTON HIGHWAY',
    city: 'KAPOLEI',
    state: 'HI',
    zip: 96707,
    telephone: '(808) 689-2800',
    population: 3526,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://westoahu.hawaii.edu/',
  },
  {
    name: 'FURMAN UNIVERSITY',
    address: '3300 POINSETT HIGHWAY',
    city: 'GREENVILLE',
    state: 'SC',
    zip: 29613,
    telephone: '(864) 294-2000',
    population: 3527,
    county: 'GREENVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.furman.edu/',
  },
  {
    name: 'NAZARETH COLLEGE',
    address: '4245 EAST AVE',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14618,
    telephone: '(585) 389-2525',
    population: 3529,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www2.naz.edu/',
  },
  {
    name: 'MID MICHIGAN COLLEGE',
    address: '1375 S CLARE AVE',
    city: 'HARRISON',
    state: 'MI',
    zip: 48625,
    telephone: '(989) 386-6622',
    population: 3531,
    county: 'CLARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.midmich.edu/',
  },
  {
    name: 'SUNY POLYTECHNIC INSTITUTE',
    address: '100 SEYMOUR RD',
    city: 'UTICA',
    state: 'NY',
    zip: 13502,
    telephone: '(315) 792-7100',
    population: 3533,
    county: 'ONEIDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sunypoly.edu/',
  },
  {
    name: 'CISCO COLLEGE',
    address: '101 COLLEGE HEIGHTS',
    city: 'CISCO',
    state: 'TX',
    zip: 76437,
    telephone: '(254) 442-5000',
    population: 3535,
    county: 'EASTLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cisco.edu/',
  },
  {
    name: 'GORDON STATE COLLEGE',
    address: '419 COLLEGE DR',
    city: 'BARNESVILLE',
    state: 'GA',
    zip: 30204,
    telephone: '(678) 359-5555',
    population: 3547,
    county: 'LAMAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.gordonstate.edu/',
  },
  {
    name: 'GEORGIA SOUTHWESTERN STATE UNIVERSITY',
    address: '800 GEORGIA SOUTHWESTERN STATE UNIVERSITY DR.',
    city: 'AMERICUS',
    state: 'GA',
    zip: 31709,
    telephone: '(877) 871-4594',
    population: 3548,
    county: 'SUMTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://gsw.edu/',
  },
  {
    name: 'SOUTHWEST BAPTIST UNIVERSITY',
    address: '1600 UNIVERSITY AVE',
    city: 'BOLIVAR',
    state: 'MO',
    zip: 65613,
    telephone: '(800) 526-5859',
    population: 3548,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sbuniv.edu/',
  },
  {
    name: 'DAKOTA STATE UNIVERSITY',
    address: '820 N WASHINGTON AVE',
    city: 'MADISON',
    state: 'SD',
    zip: 57042,
    telephone: '(605) 256-5111',
    population: 3551,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://dsu.edu/',
  },
  {
    name: 'SAINT AMBROSE UNIVERSITY',
    address: '518 W LOCUST ST',
    city: 'DAVENPORT',
    state: 'IA',
    zip: 52803,
    telephone: '(563) 333-6000',
    population: 3558,
    county: 'SCOTT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sau.edu/',
  },
  {
    name: "NHTI-CONCORD'S COMMUNITY COLLEGE",
    address: '31 COLLEGE DRIVE',
    city: 'CONCORD',
    state: 'NH',
    zip: 3301,
    telephone: '(603) 271-6484',
    population: 3566,
    county: 'MERRIMACK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nhti.edu/',
  },
  {
    name: 'COCONINO COMMUNITY COLLEGE',
    address: '2800 S. LONE TREE RD.',
    city: 'FLAGSTAFF',
    state: 'AZ',
    zip: 86005,
    telephone: '(928) 527-1222',
    population: 3572,
    county: 'COCONINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coconino.edu/',
  },
  {
    name: 'SURRY COMMUNITY COLLEGE',
    address: '630 S. MAIN ST.',
    city: 'DOBSON',
    state: 'NC',
    zip: 27017,
    telephone: '(336) 386-8121 EXT 3264',
    population: 3578,
    county: 'SURRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://surry.edu/',
  },
  {
    name: 'RENTON TECHNICAL COLLEGE',
    address: '3000 NE FOURTH ST',
    city: 'RENTON',
    state: 'WA',
    zip: 98056,
    telephone: '(425) 235-2352',
    population: 3579,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rtc.edu/',
  },
  {
    name: 'TRINITY UNIVERSITY',
    address: 'ONE TRINITY PLACE',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78212,
    telephone: '(210) 999-7011',
    population: 3581,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://new.trinity.edu/',
  },
  {
    name: 'CARROLL COMMUNITY COLLEGE',
    address: '1601 WASHINGTON RD',
    city: 'WESTMINSTER',
    state: 'MD',
    zip: 21157,
    telephone: '(410) 386-8000',
    population: 3582,
    county: 'CARROLL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.carrollcc.edu/',
  },
  {
    name: 'NORTH PARK UNIVERSITY',
    address: '3225 W FOSTER AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60625,
    telephone: '(773) 244-6200',
    population: 3583,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northpark.edu/',
  },
  {
    name: 'WESTERN COLORADO UNIVERSITY',
    address: '1 WESTERN WAY',
    city: 'GUNNISON',
    state: 'CO',
    zip: 81231,
    telephone: '(970) 943-2119',
    population: 3590,
    county: 'GUNNISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.western.edu/',
  },
  {
    name: 'SKIDMORE COLLEGE',
    address: '815 N BROADWAY',
    city: 'SARATOGA SPRINGS',
    state: 'NY',
    zip: 12866,
    telephone: '(518) 580-5000',
    population: 3596,
    county: 'SARATOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.skidmore.edu/',
  },
  {
    name: 'VASSAR COLLEGE',
    address: '124 RAYMOND AVE',
    city: 'POUGHKEEPSIE',
    state: 'NY',
    zip: 12604,
    telephone: '(845) 437-7000',
    population: 3598,
    county: 'DUTCHESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vassar.edu/',
  },
  {
    name: 'SUNY COLLEGE OF TECHNOLOGY AT DELHI',
    address: '454 DELHI DRIVE',
    city: 'DELHI',
    state: 'NY',
    zip: 13753,
    telephone: '(607) 746-4000',
    population: 3605,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.delhi.edu/',
  },
  {
    name: 'HENDERSON STATE UNIVERSITY',
    address: '1100 HENDERSON STREET',
    city: 'ARKADELPHIA',
    state: 'AR',
    zip: 71999,
    telephone: '(870) 230-5000',
    population: 3607,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hsu.edu/',
  },
  {
    name: 'PHILADELPHIA COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '4170 CITY AVE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19131,
    telephone: '(215) 871-6770',
    population: 3610,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pcom.edu/',
  },
  {
    name: 'SUNY COLLEGE OF TECHNOLOGY AT CANTON',
    address: '34 CORNELL DRIVE',
    city: 'CANTON',
    state: 'NY',
    zip: 13617,
    telephone: '(315) 386-7011',
    population: 3614,
    county: 'ST. LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.canton.edu/',
  },
  {
    name: 'ST CLAIR COUNTY COMMUNITY COLLEGE',
    address: '323 ERIE STREET',
    city: 'PORT HURON',
    state: 'MI',
    zip: 48061,
    telephone: '(810) 984-3881',
    population: 3618,
    county: 'ST. CLAIR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sc4.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-NEBRASKA',
    address: '800 N COLUMBIA AVE',
    city: 'SEWARD',
    state: 'NE',
    zip: 68434,
    telephone: '(800) 535-5494',
    population: 3620,
    county: 'SEWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cune.edu/',
  },
  {
    name: 'NORTHEAST MISSISSIPPI COMMUNITY COLLEGE',
    address: '101 CUNNINGHAM BLVD',
    city: 'BOONEVILLE',
    state: 'MS',
    zip: 38829,
    telephone: '(662) 728-7751',
    population: 3622,
    county: 'PRENTISS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nemcc.edu/',
  },
  {
    name: 'CENTRAL METHODIST UNIVERSITY-COLLEGE OF GRADUATE AND EXTENDED STUDIES',
    address: '411 CENTRAL METHODIST SQUARE',
    city: 'FAYETTE',
    state: 'MO',
    zip: 65248,
    telephone: '(660) 248-3391',
    population: 3623,
    county: 'HOWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centralmethodist.edu/',
  },
  {
    name: 'JAMES A RHODES STATE COLLEGE',
    address: '4240 CAMPUS DR',
    city: 'LIMA',
    state: 'OH',
    zip: 45804,
    telephone: '(419) 995-8320',
    population: 3623,
    county: 'ALLEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rhodesstate.edu/',
  },
  {
    name: 'CAPITAL UNIVERSITY',
    address: '1 COLLEGE AND MAIN',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43209,
    telephone: '(614) 236-6011',
    population: 3625,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.capital.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-KOKOMO',
    address: '2300 S WASHINGTON ST',
    city: 'KOKOMO',
    state: 'IN',
    zip: 46902,
    telephone: '(765) 453-2000',
    population: 3627,
    county: 'HOWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iuk.edu/',
  },
  {
    name: 'SPRING ARBOR UNIVERSITY',
    address: '106 E. MAIN ST',
    city: 'SPRING ARBOR',
    state: 'MI',
    zip: 49283,
    telephone: '(517) 750-1200',
    population: 3628,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arbor.edu/',
  },
  {
    name: 'LETOURNEAU UNIVERSITY',
    address: '2100 S MOBBERLY AVE',
    city: 'LONGVIEW',
    state: 'TX',
    zip: 75602,
    telephone: '(903) 233-3000',
    population: 3630,
    county: 'GREGG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.letu.edu/',
  },
  {
    name: 'FLORENCE-DARLINGTON TECHNICAL COLLEGE',
    address: '2715 W. LUCAS STREET',
    city: 'FLORENCE',
    state: 'SC',
    zip: 29501,
    telephone: '(843) 661-8324',
    population: 3630,
    county: 'FLORENCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fdtc.edu/',
  },
  {
    name: 'DELTA STATE UNIVERSITY',
    address: '1003 W SUNFLOWER ROAD',
    city: 'CLEVELAND',
    state: 'MS',
    zip: 38733,
    telephone: '(662) 846-3000',
    population: 3631,
    county: 'BOLIVAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.deltastate.edu/',
  },
  {
    name: 'BATES TECHNICAL COLLEGE',
    address: '1101 S YAKIMA AVE',
    city: 'TACOMA',
    state: 'WA',
    zip: 98405,
    telephone: '(253) 680-7000',
    population: 3634,
    county: 'PIERCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.batestech.edu/',
  },
  {
    name: 'MIDWESTERN UNIVERSITY-DOWNERS GROVE',
    address: '555 31ST STREET',
    city: 'DOWNERS GROVE',
    state: 'IL',
    zip: 60515,
    telephone: '(630) 969-4400',
    population: 3647,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.midwestern.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-HUMACAO',
    address: 'CALL BOX 860',
    city: 'HUMACAO',
    state: 'PR',
    zip: 792,
    telephone: '(787) 850-0000',
    population: 3654,
    county: 'HUMACAO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upr.edu/humacao/',
  },
  {
    name: 'MENDOCINO COLLEGE',
    address: '1000 HENSLEY CREEK ROAD',
    city: 'UKIAH',
    state: 'CA',
    zip: 95482,
    telephone: '(707) 468-3000',
    population: 3654,
    county: 'MENDOCINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mendocino.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH TEXAS HEALTH SCIENCE CENTER',
    address: '3500 CAMP BOWIE BLVD',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76107,
    telephone: '(817) 735-2000',
    population: 3657,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unthsc.edu/',
  },
  {
    name: 'HOLY FAMILY UNIVERSITY',
    address: '9801 FRANKFORD AVENUE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19114,
    telephone: '(215) 637-7700',
    population: 3660,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.holyfamily.edu/',
  },
  {
    name: 'LOCK HAVEN UNIVERSITY',
    address: '401 NORTH FAIRVIEW STREET',
    city: 'LOCK HAVEN',
    state: 'PA',
    zip: 17745,
    telephone: '(570) 484-2011',
    population: 3661,
    county: 'CLINTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lockhaven.edu/',
  },
  {
    name: 'ADAMS STATE UNIVERSITY',
    address: '208 EDGEMONT BLVD',
    city: 'ALAMOSA',
    state: 'CO',
    zip: 81101,
    telephone: '(719) 587-7011',
    population: 3664,
    county: 'ALAMOSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.adams.edu/',
  },
  {
    name: 'SHEPHERD UNIVERSITY',
    address: '301 NORTH KING ST',
    city: 'SHEPHERDSTOWN',
    state: 'WV',
    zip: 25443,
    telephone: '(304) 876-5000',
    population: 3665,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shepherd.edu/',
  },
  {
    name: 'OBERLIN COLLEGE',
    address: '70 N PROFESSOR ST',
    city: 'OBERLIN',
    state: 'OH',
    zip: 44074,
    telephone: '(440) 775-8411',
    population: 3669,
    county: 'LORAIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oberlin.edu/',
  },
  {
    name: 'WESTCLIFF UNIVERSITY',
    address: '17877 VON KARMAN AVE, SUITE 400',
    city: 'IRVINE',
    state: 'CA',
    zip: 92614,
    telephone: '(888) 491-8686',
    population: 3679,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westcliff.edu/',
  },
  {
    name: 'FORT VALLEY STATE UNIVERSITY',
    address: '1005 STATE UNIVERSITY DR',
    city: 'FORT VALLEY',
    state: 'GA',
    zip: 31030,
    telephone: '(478) 825-6211',
    population: 3692,
    county: 'PEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fvsu.edu/',
  },
  {
    name: 'PACIFIC LUTHERAN UNIVERSITY',
    address: '12180 PARK AVE SOUTH',
    city: 'TACOMA',
    state: 'WA',
    zip: 98447,
    telephone: '(253) 535-8145',
    population: 3692,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plu.edu/',
  },
  {
    name: 'BARNARD COLLEGE',
    address: '3009 BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 854-5262',
    population: 3696,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.barnard.edu/',
  },
  {
    name: 'NORTHERN OKLAHOMA COLLEGE',
    address: '1220 E GRAND AVE',
    city: 'TONKAWA',
    state: 'OK',
    zip: 74653,
    telephone: '(580) 628-6200',
    population: 3697,
    county: 'KAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.noc.edu/',
  },
  {
    name: 'WISCONSIN INDIANHEAD TECHNICAL COLLEGE',
    address: '505 PINE RIDGE DRIVE',
    city: 'SHELL LAKE',
    state: 'WI',
    zip: 54871,
    telephone: '(715) 468-2815',
    population: 3702,
    county: 'WASHBURN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.witc.edu/',
  },
  {
    name: "SAINT PETER'S UNIVERSITY",
    address: '2641 KENNEDY BLVD',
    city: 'JERSEY CITY',
    state: 'NJ',
    zip: 7306,
    telephone: '(201) 761-7400',
    population: 3707,
    county: 'HUDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.saintpeters.edu/',
  },
  {
    name: 'UNION UNIVERSITY',
    address: '1050 UNION UNIVERSITY DR',
    city: 'JACKSON',
    state: 'TN',
    zip: 38305,
    telephone: '(731) 668-1818',
    population: 3713,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uu.edu/',
  },
  {
    name: 'HAMLINE UNIVERSITY',
    address: '1536 HEWITT AVENUE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55104,
    telephone: '(651) 523-2800',
    population: 3724,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hamline.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-ARECIBO',
    address: 'HWY 2 KM 80.4, BO SAN DANIEL SECTOR LAS CANELAS',
    city: 'ARECIBO',
    state: 'PR',
    zip: 614,
    telephone: '(787) 878-5475 EXT 3268',
    population: 3725,
    county: 'ARECIBO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.arecibo.inter.edu/',
  },
  {
    name: 'BRIGHAM YOUNG UNIVERSITY-HAWAII',
    address: '55-220 KULANUI STREET',
    city: 'LAIE',
    state: 'HI',
    zip: 96762,
    telephone: '(808) 675-3211',
    population: 3728,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.byuh.edu/',
  },
  {
    name: 'CENTRAL VIRGINIA COMMUNITY COLLEGE',
    address: '3506 WARDS RD',
    city: 'LYNCHBURG',
    state: 'VA',
    zip: 24502,
    telephone: '(434) 832-7600',
    population: 3728,
    county: 'LYNCHBURG CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.centralvirginia.edu/',
  },
  {
    name: 'UNIVERSITY OF HAWAII AT HILO',
    address: '200 W KAWILI ST',
    city: 'HILO',
    state: 'HI',
    zip: 96720,
    telephone: '(808) 932-7446',
    population: 3729,
    county: 'HAWAII',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://hilo.hawaii.edu/',
  },
  {
    name: 'HONOLULU COMMUNITY COLLEGE',
    address: '874 DILLINGHAM BLVD',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96817,
    telephone: '(808) 845-9211',
    population: 3731,
    county: 'HONOLULU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.honolulu.hawaii.edu/',
  },
  {
    name: 'LAKE WASHINGTON INSTITUTE OF TECHNOLOGY',
    address: '11605 132ND AVE NE',
    city: 'KIRKLAND',
    state: 'WA',
    zip: 98034,
    telephone: '(425) 739-8100',
    population: 3732,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lwtech.edu/',
  },
  {
    name: 'MAYSVILLE COMMUNITY AND TECHNICAL COLLEGE',
    address: '1755 U.S. HWY 68',
    city: 'MAYSVILLE',
    state: 'KY',
    zip: 41056,
    telephone: '(606) 759-7141',
    population: 3735,
    county: 'MASON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://maysville.kctcs.edu/',
  },
  {
    name: 'JOHN A LOGAN COLLEGE',
    address: '700 LOGAN COLLEGE DRIVE',
    city: 'CARTERVILLE',
    state: 'IL',
    zip: 62918,
    telephone: '(618) 985-3741',
    population: 3735,
    county: 'WILLIAMSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.jalc.edu/',
  },
  {
    name: 'RIVERLAND COMMUNITY COLLEGE',
    address: '1900 8TH AVE NW',
    city: 'AUSTIN',
    state: 'MN',
    zip: 55912,
    telephone: '(507) 433-0600',
    population: 3741,
    county: 'MOWER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.riverland.edu/',
  },
  {
    name: 'ROLLINS COLLEGE',
    address: '1000 HOLT AVENUE',
    city: 'WINTER PARK',
    state: 'FL',
    zip: 32789,
    telephone: '(407) 646-2000',
    population: 3747,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rollins.edu/',
  },
  {
    name: 'TUNXIS COMMUNITY COLLEGE',
    address: '271 SCOTT SWAMP ROAD',
    city: 'FARMINGTON',
    state: 'CT',
    zip: 6032,
    telephone: '(860) 773-1300',
    population: 3764,
    county: 'HARTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tunxis.edu/',
  },
  {
    name: 'MIDWESTERN BAPTIST THEOLOGICAL SEMINARY',
    address: '5001 N. OAK TRAFFICWAY',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64118,
    telephone: '(816) 414-3700',
    population: 3770,
    county: 'CLAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mbts.edu/',
  },
  {
    name: 'ST OLAF COLLEGE',
    address: '1520 ST OLAF AVE',
    city: 'NORTHFIELD',
    state: 'MN',
    zip: 55057,
    telephone: '(507) 786-2222',
    population: 3772,
    county: 'RICE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'wp.stolaf.edu/',
  },
  {
    name: 'BLUE RIDGE COMMUNITY COLLEGE',
    address: '1 COLLEGE LANE',
    city: 'WEYERS CAVE',
    state: 'VA',
    zip: 24486,
    telephone: '(540) 234-9261',
    population: 3773,
    county: 'AUGUSTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.brcc.edu/',
  },
  {
    name: 'SMITH COLLEGE',
    address: 'ELM ST',
    city: 'NORTHAMPTON',
    state: 'MA',
    zip: 1063,
    telephone: '(413) 584-2700',
    population: 3780,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smith.edu/',
  },
  {
    name: 'COLLEGE OF COASTAL GEORGIA',
    address: 'ONE COLLEGE DRIVE',
    city: 'BRUNSWICK',
    state: 'GA',
    zip: 31520,
    telephone: '(912) 279-5700',
    population: 3781,
    county: 'GLYNN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccga.edu/',
  },
  {
    name: 'UNITEK COLLEGE',
    address: '4670 AUTO MALL PKWY',
    city: 'FREMONT',
    state: 'CA',
    zip: 94538,
    telephone: '(510) 249-1060',
    population: 3782,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'unitekcollege.edu/',
  },
  {
    name: 'NAVAL POSTGRADUATE SCHOOL',
    address: '1 UNIVERSITY CIRCLE',
    city: 'MONTEREY',
    state: 'CA',
    zip: 93943,
    telephone: '(831) 656-2442',
    population: 3784,
    county: 'MONTEREY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nps.edu/',
  },
  {
    name: 'SOUTHEASTERN BAPTIST THEOLOGICAL SEMINARY',
    address: '120 S. WINGATE STREET',
    city: 'WAKE FOREST',
    state: 'NC',
    zip: 27587,
    telephone: '(919) 761-2100',
    population: 3790,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sebts.edu/',
  },
  {
    name: 'ASA COLLEGE',
    address: '151 LAWRENCE STREET',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11201,
    telephone: '(718) 522-9073',
    population: 3795,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.asa.edu/',
  },
  {
    name: 'SUNY COLLEGE AT POTSDAM',
    address: '44 PIERREPONT AVE',
    city: 'POTSDAM',
    state: 'NY',
    zip: 13676,
    telephone: '(315) 267-2000',
    population: 3799,
    county: 'ST. LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.potsdam.edu/',
  },
  {
    name: 'NORTHSHORE TECHNICAL COMMUNITY COLLEGE',
    address: '65556 CENTERPOINT BLVD.',
    city: 'LACOMBE',
    state: 'LA',
    zip: 70445,
    telephone: '(985) 545-1500',
    population: 3807,
    county: 'ST. TAMMANY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'northshorecollege.edu/',
  },
  {
    name: 'ROGERS STATE UNIVERSITY',
    address: '1701 W WILL ROGERS BLVD',
    city: 'CLAREMORE',
    state: 'OK',
    zip: 74017,
    telephone: '(918) 343-7777',
    population: 3809,
    county: 'ROGERS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rsu.edu/',
  },
  {
    name: 'NORTHERN STATE UNIVERSITY',
    address: '1200 S JAY ST',
    city: 'ABERDEEN',
    state: 'SD',
    zip: 57401,
    telephone: '(605) 626-3011',
    population: 3810,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northern.edu/',
  },
  {
    name: 'GOODWIN UNIVERSITY',
    address: 'ONE RIVERSIDE DRIVE',
    city: 'EAST HARTFORD',
    state: 'CT',
    zip: 6118,
    telephone: '(860) 528-4111',
    population: 3811,
    county: 'HARTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.goodwin.edu/',
  },
  {
    name: 'NORTHWEST-SHOALS COMMUNITY COLLEGE',
    address: '800 GEORGE WALLACE BLVD',
    city: 'MUSCLE SHOALS',
    state: 'AL',
    zip: 35661,
    telephone: '(256) 331-5200',
    population: 3812,
    county: 'COLBERT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nwscc.edu/',
  },
  {
    name: 'MCDANIEL COLLEGE',
    address: '2 COLLEGE HILL',
    city: 'WESTMINSTER',
    state: 'MD',
    zip: 21157,
    telephone: '(410) 848-7000',
    population: 3815,
    county: 'CARROLL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mcdaniel.edu/',
  },
  {
    name: 'SPRINGFIELD COLLEGE',
    address: '263 ALDEN ST',
    city: 'SPRINGFIELD',
    state: 'MA',
    zip: 1109,
    telephone: '(413) 748-3116',
    population: 3820,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.springfield.edu/',
  },
  {
    name: 'MITCHELL COMMUNITY COLLEGE',
    address: '500 W BROAD STREET',
    city: 'STATESVILLE',
    state: 'NC',
    zip: 28677,
    telephone: '(704) 878-3200',
    population: 3821,
    county: 'IREDELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://mitchellcc.edu/',
  },
  {
    name: 'FRANCISCAN UNIVERSITY OF STEUBENVILLE',
    address: '1235 UNIVERSITY BLVD',
    city: 'STEUBENVILLE',
    state: 'OH',
    zip: 43952,
    telephone: '(740) 283-3771',
    population: 3822,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.franciscan.edu/',
  },
  {
    name: 'CULINARY INSTITUTE OF AMERICA',
    address: '1946 CAMPUS DRIVE',
    city: 'HYDE PARK',
    state: 'NY',
    zip: 12538,
    telephone: '(845) 452-9600',
    population: 3830,
    county: 'DUTCHESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ciachef.edu/',
  },
  {
    name: 'BOB JONES UNIVERSITY',
    address: '1700 WADE HAMPTON BOULAVARD',
    city: 'GREENVILLE',
    state: 'SC',
    zip: 29614,
    telephone: '(864) 242-5100',
    population: 3830,
    county: 'GREENVILLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bju.edu/',
  },
  {
    name: 'BEVILL STATE COMMUNITY COLLEGE',
    address: '1411 INDIANA AVENUE',
    city: 'JASPER',
    state: 'AL',
    zip: 35501,
    telephone: '(205) 387-0511',
    population: 3844,
    county: 'WALKER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bscc.edu/',
  },
  {
    name: 'INDIANA INSTITUTE OF TECHNOLOGY-COLLEGE OF PROFESSIONAL STUDIES',
    address: '1600 E. WASHINGTON BLVD.',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46803,
    telephone: '(260) 422-5561',
    population: 3846,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cps.indianatech.edu/',
  },
  {
    name: 'SOUTH SUBURBAN COLLEGE',
    address: '15800 SOUTH STATE STREET',
    city: 'SOUTH HOLLAND',
    state: 'IL',
    zip: 60473,
    telephone: '(708) 596-2000',
    population: 3846,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ssc.edu/',
  },
  {
    name: 'WHEATON COLLEGE',
    address: '501 COLLEGE AVE',
    city: 'WHEATON',
    state: 'IL',
    zip: 60187,
    telephone: '(630) 752-5000',
    population: 3852,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wheaton.edu/',
  },
  {
    name: 'MIDDLEBURY COLLEGE',
    address: 'OLD CHAPEL',
    city: 'MIDDLEBURY',
    state: 'VT',
    zip: 5753,
    telephone: '(802) 443-5000',
    population: 3859,
    county: 'ADDISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.middlebury.edu/',
  },
  {
    name: 'JERSEY COLLEGE',
    address: '546 U.S. HIGHWAY 46',
    city: 'TETERBORO',
    state: 'NJ',
    zip: 7608,
    telephone: '(201) 489-5836',
    population: 3860,
    county: 'BERGEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.jerseycollege.edu/',
  },
  {
    name: 'COCHISE COUNTY COMMUNITY COLLEGE DISTRICT',
    address: '901 N COLOMBO AVE',
    city: 'SIERRA VISTA',
    state: 'AZ',
    zip: 85635,
    telephone: '(520) 515-0500',
    population: 3860,
    county: 'COCHISE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cochise.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-AGUADILLA',
    address: 'CARR. 459 INT. 463, BARRIO CORRALES SECTOR CALERO',
    city: 'AGUADILLA',
    state: 'PR',
    zip: 603,
    telephone: '(787) 891-0925 EXT 2100',
    population: 3862,
    county: 'AGUADILLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'aguadilla.inter.edu/',
  },
  {
    name: 'TAFT COLLEGE',
    address: '29 COUGAR COURT',
    city: 'TAFT',
    state: 'CA',
    zip: 93268,
    telephone: '(661) 763-7700',
    population: 3865,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.taftcollege.edu/',
  },
  {
    name: 'SUNY DOWNSTATE HEALTH SCIENCES UNIVERSITY',
    address: '450 CLARKSON AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11203,
    telephone: '(718) 270-2187',
    population: 3868,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.downstate.edu/',
  },
  {
    name: 'MARYMOUNT UNIVERSITY',
    address: '2807 N GLEBE RD',
    city: 'ARLINGTON',
    state: 'VA',
    zip: 22207,
    telephone: '(703) 522-5600',
    population: 3876,
    county: 'ARLINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.marymount.edu/',
  },
  {
    name: 'HAGERSTOWN COMMUNITY COLLEGE',
    address: '11400 ROBINWOOD DR',
    city: 'HAGERSTOWN',
    state: 'MD',
    zip: 21742,
    telephone: '(240) 500-2530',
    population: 3881,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hagerstowncc.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-EAST',
    address: '2325 CHESTER BLVD',
    city: 'RICHMOND',
    state: 'IN',
    zip: 47374,
    telephone: '(765) 973-8200',
    population: 3882,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iue.edu/',
  },
  {
    name: 'SULLIVAN UNIVERSITY',
    address: '3101 BARDSTOWN RD',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40205,
    telephone: '(502) 456-6504',
    population: 3897,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sullivan.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-ARECIBO',
    address: 'FINCA LAS DUNAS CARR 653 RUTA 129 KM 8',
    city: 'ARECIBO',
    state: 'PR',
    zip: 614,
    telephone: '(787) 815-0000 EXT 1000',
    population: 3897,
    county: 'ARECIBO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upra.edu/',
  },
  {
    name: 'DOMINICAN UNIVERSITY',
    address: '7900 W DIVISION STREET',
    city: 'RIVER FOREST',
    state: 'IL',
    zip: 60305,
    telephone: '(708) 366-2490',
    population: 3900,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dom.edu/',
  },
  {
    name: 'MUSKEGON COMMUNITY COLLEGE',
    address: '221 S QUARTERLINE RD',
    city: 'MUSKEGON',
    state: 'MI',
    zip: 49442,
    telephone: '(231) 773-9131',
    population: 3900,
    county: 'MUSKEGON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.muskegoncc.edu/',
  },
  {
    name: 'COASTAL PINES TECHNICAL COLLEGE',
    address: '1701 CARSWELL AVE',
    city: 'WAYCROSS',
    state: 'GA',
    zip: 31503,
    telephone: '(912) 287-5818',
    population: 3905,
    county: 'WARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coastalpines.edu/',
  },
  {
    name: 'JAMESTOWN COMMUNITY COLLEGE',
    address: '525 FALCONER ST',
    city: 'JAMESTOWN',
    state: 'NY',
    zip: 14701,
    telephone: '(716) 338-1000',
    population: 3906,
    county: 'CHAUTAUQUA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunyjcc.edu/',
  },
  {
    name: 'CLOVER PARK TECHNICAL COLLEGE',
    address: '4500 STEILACOOM BLVD SW',
    city: 'LAKEWOOD',
    state: 'WA',
    zip: 98499,
    telephone: '(253) 589-5800',
    population: 3909,
    county: 'PIERCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cptc.edu/',
  },
  {
    name: 'NORTHWESTERN MICHIGAN COLLEGE',
    address: '1701 E FRONT ST',
    city: 'TRAVERSE CITY',
    state: 'MI',
    zip: 49686,
    telephone: '(231) 995-1000',
    population: 3915,
    county: 'GRAND TRAVERSE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nmc.edu/',
  },
  {
    name: 'VALPARAISO UNIVERSITY',
    address: 'US HIGHWAY 30 AND STURDY ROAD',
    city: 'VALPARAISO',
    state: 'IN',
    zip: 46383,
    telephone: '(219) 464-5000',
    population: 3919,
    county: 'PORTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.valpo.edu/',
  },
  {
    name: 'KEENE STATE COLLEGE',
    address: '229 MAIN STREET',
    city: 'KEENE',
    state: 'NH',
    zip: 3435,
    telephone: '(603) 352-1909',
    population: 3934,
    county: 'CHESHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.keene.edu/',
  },
  {
    name: 'ALCORN STATE UNIVERSITY',
    address: '1000 ASU DR STE 359',
    city: 'ALCORN STATE',
    state: 'MS',
    zip: 39096,
    telephone: '(601) 877-6100',
    population: 3934,
    county: 'CLAIBORNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alcorn.edu/',
  },
  {
    name: 'INDIAN HILLS COMMUNITY COLLEGE',
    address: '525 GRANDVIEW AVE',
    city: 'OTTUMWA',
    state: 'IA',
    zip: 52501,
    telephone: '(641) 683-5111',
    population: 3934,
    county: 'WAPELLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.indianhills.edu/',
  },
  {
    name: 'CHARLESTON SOUTHERN UNIVERSITY',
    address: '9200 UNIVERSITY BLVD',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29406,
    telephone: '(843) 863-7000',
    population: 3935,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.charlestonsouthern.edu/',
  },
  {
    name: 'BAY PATH UNIVERSITY',
    address: '588 LONGMEADOW STREET',
    city: 'LONGMEADOW',
    state: 'MA',
    zip: 1106,
    telephone: '(413) 565-1000',
    population: 3937,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baypath.edu/',
  },
  {
    name: 'LYNN UNIVERSITY',
    address: '3601 N. MILITARY TRAIL',
    city: 'BOCA RATON',
    state: 'FL',
    zip: 33431,
    telephone: '(800) 888-5966',
    population: 3941,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lynn.edu/',
  },
  {
    name: 'EAST MISSISSIPPI COMMUNITY COLLEGE',
    address: '1512 KEMPER STREET',
    city: 'SCOOBA',
    state: 'MS',
    zip: 39358,
    telephone: '(662) 476-5000',
    population: 3944,
    county: 'KEMPER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eastms.edu/',
  },
  {
    name: 'HOPE COLLEGE',
    address: '100 E. 8TH STREET, SUITE 260',
    city: 'HOLLAND',
    state: 'MI',
    zip: 49422,
    telephone: '(616) 395-7000',
    population: 3947,
    county: 'OTTAWA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hope.edu/',
  },
  {
    name: 'NORTHWEST STATE COMMUNITY COLLEGE',
    address: '22600 STATE ROUTE 34',
    city: 'ARCHBOLD',
    state: 'OH',
    zip: 43502,
    telephone: '(419) 267-5511',
    population: 3948,
    county: 'HENRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://northweststate.edu/',
  },
  {
    name: 'SOUTH MOUNTAIN COMMUNITY COLLEGE',
    address: '7050 S 24TH ST',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85042,
    telephone: '(602) 243-8135',
    population: 3963,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southmountaincc.edu/',
  },
  {
    name: 'WESTERN NEVADA COLLEGE',
    address: '2201 WEST COLLEGE PARKWAY',
    city: 'CARSON CITY',
    state: 'NV',
    zip: 89703,
    telephone: '(775) 445-3000',
    population: 3965,
    county: 'CARSON CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wnc.edu/',
  },
  {
    name: 'ANDREWS UNIVERSITY',
    address: '4150 ADMINISTRATION DRIVE, ROOM 136',
    city: 'BERRIEN SPRINGS',
    state: 'MI',
    zip: 49104,
    telephone: '(800) 253-2874',
    population: 3967,
    county: 'BERRIEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.andrews.edu/',
  },
  {
    name: 'VICTORIA COLLEGE',
    address: '2200 E RED RIVER',
    city: 'VICTORIA',
    state: 'TX',
    zip: 77901,
    telephone: '(361) 573-3291',
    population: 3968,
    county: 'VICTORIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.victoriacollege.edu/',
  },
  {
    name: 'JOHN CARROLL UNIVERSITY',
    address: '1 JOHN CARROLL BOULEVARD',
    city: 'UNIVERSITY HEIGHTS',
    state: 'OH',
    zip: 44118,
    telephone: '(888) 388-2977',
    population: 3973,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'jcu.edu/',
  },
  {
    name: 'SANTA FE COMMUNITY COLLEGE',
    address: '6401 RICHARDS AVE',
    city: 'SANTA FE',
    state: 'NM',
    zip: 87508,
    telephone: '(505) 428-1000',
    population: 3973,
    county: 'SANTA FE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sfcc.edu/',
  },
  {
    name: 'WEST VIRGINIA STATE UNIVERSITY',
    address: 'RTE 25',
    city: 'INSTITUTE',
    state: 'WV',
    zip: 25112,
    telephone: '(304) 766-3000',
    population: 3980,
    county: 'KANAWHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvstateu.edu/',
  },
  {
    name: 'DESALES UNIVERSITY',
    address: '2755 STATION AVENUE',
    city: 'CENTER VALLEY',
    state: 'PA',
    zip: 18034,
    telephone: '(610) 282-1100',
    population: 3985,
    county: 'LEHIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.desales.edu/',
  },
  {
    name: 'SAVANNAH STATE UNIVERSITY',
    address: '3219 COLLEGE STREET',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31404,
    telephone: '(912) 675-6265',
    population: 4001,
    county: 'CHATHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.savannahstate.edu/',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY-ALEXANDRIA',
    address: '8100 HWY 71 SOUTH',
    city: 'ALEXANDRIA',
    state: 'LA',
    zip: 71302,
    telephone: '(318) 445-3672',
    population: 4011,
    county: 'RAPIDES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lsua.edu/',
  },
  {
    name: 'FAIRLEIGH DICKINSON UNIVERSITY-FLORHAM CAMPUS',
    address: '285 MADISON AVE',
    city: 'MADISON',
    state: 'NJ',
    zip: 7940,
    telephone: '(973) 443-8500',
    population: 4013,
    county: 'MORRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fdu.edu/',
  },
  {
    name: 'LEWIS & CLARK COLLEGE',
    address: '615 S PALATINE HILL RD',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97219,
    telephone: '(503) 768-7000',
    population: 4020,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lclark.edu/',
  },
  {
    name: 'MORTON COLLEGE',
    address: '3801 S CENTRAL AVE',
    city: 'CICERO',
    state: 'IL',
    zip: 60804,
    telephone: '(708) 656-8000',
    population: 4022,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.morton.edu/',
  },
  {
    name: 'ALLIANT INTERNATIONAL UNIVERSITY-SAN DIEGO',
    address: '10455 POMERADO ROAD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92131,
    telephone: '(866) 825-5426',
    population: 4023,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.alliant.edu/',
  },
  {
    name: 'AUGSBURG UNIVERSITY',
    address: '2211 RIVERSIDE AVE',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55454,
    telephone: '(612) 330-1000',
    population: 4025,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.augsburg.edu/',
  },
  {
    name: 'PALO VERDE COLLEGE',
    address: 'ONE COLLEGE DRIVE',
    city: 'BLYTHE',
    state: 'CA',
    zip: 92225,
    telephone: '(760) 921-5500',
    population: 4035,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.paloverde.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-BAYAMON',
    address: 'ROAD 174 #170 MINILLAS INDUSTRIAL PARK',
    city: 'BAYAMON',
    state: 'PR',
    zip: 959,
    telephone: '(787) 993-0000 EXT 3026',
    population: 4039,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprb.edu/',
  },
  {
    name: 'REGIS COLLEGE',
    address: '235 WELLESLEY ST',
    city: 'WESTON',
    state: 'MA',
    zip: 2493,
    telephone: '(781) 768-7000',
    population: 4044,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.regiscollege.edu/',
  },
  {
    name: 'COLLEGE OF THE HOLY CROSS',
    address: 'ONE COLLEGE STREET',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1610,
    telephone: '(508) 793-2011',
    population: 4053,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.holycross.edu/',
  },
  {
    name: 'UNIVERSITY OF ST FRANCIS',
    address: '500 N WILCOX ST',
    city: 'JOLIET',
    state: 'IL',
    zip: 60435,
    telephone: '(815) 740-3400',
    population: 4062,
    county: 'WILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stfrancis.edu/',
  },
  {
    name: 'CALVIN UNIVERSITY',
    address: '3201 BURTON STREET SE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49546,
    telephone: '(616) 526-6000',
    population: 4066,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calvin.edu/',
  },
  {
    name: 'LE MOYNE COLLEGE',
    address: '1419 SALT SPRINGS RD',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13214,
    telephone: '(315) 445-4100',
    population: 4066,
    county: 'ONONDAGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lemoyne.edu/',
  },
  {
    name: 'WESLEYAN UNIVERSITY',
    address: '45 WYLLYS AVENUE',
    city: 'MIDDLETOWN',
    state: 'CT',
    zip: 6459,
    telephone: '(860) 685-2000',
    population: 4068,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wesleyan.edu/',
  },
  {
    name: 'WIREGRASS GEORGIA TECHNICAL COLLEGE',
    address: '4089 VAL TECH RD',
    city: 'VALDOSTA',
    state: 'GA',
    zip: 31602,
    telephone: '(229) 333-2100',
    population: 4068,
    county: 'LOWNDES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wiregrass.edu/',
  },
  {
    name: 'BLACK HILLS STATE UNIVERSITY',
    address: '1200 UNIVERSITY ST',
    city: 'SPEARFISH',
    state: 'SD',
    zip: 57799,
    telephone: '(800) 255-2478',
    population: 4072,
    county: 'LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bhsu.edu/',
  },
  {
    name: 'SHAWNEE STATE UNIVERSITY',
    address: '940 SECOND ST',
    city: 'PORTSMOUTH',
    state: 'OH',
    zip: 45662,
    telephone: '(740) 354-3205',
    population: 4081,
    county: 'SCIOTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.shawnee.edu/',
  },
  {
    name: 'FORT LEWIS COLLEGE',
    address: '1000 RIM DRIVE',
    city: 'DURANGO',
    state: 'CO',
    zip: 81301,
    telephone: '(970) 247-7010',
    population: 4085,
    county: 'LA PLATA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'fortlewis.edu/',
  },
  {
    name: 'SAVANNAH TECHNICAL COLLEGE',
    address: '5717 WHITE BLUFF RD',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31405,
    telephone: '(912) 443-5700',
    population: 4085,
    county: 'CHATHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.savannahtech.edu/',
  },
  {
    name: 'BELLARMINE UNIVERSITY',
    address: '2001 NEWBURG RD',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40205,
    telephone: '(502) 272-8263',
    population: 4087,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bellarmine.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-TENNESSEE',
    address: '2620 THOUSAND OAKS BLVD STE 1100',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38118,
    telephone: '(877) 445-7180',
    population: 4102,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/tennessee/thousand-oaks',
  },
  {
    name: 'HOWARD COLLEGE',
    address: '1001 BIRDWELL LANE',
    city: 'BIG SPRING',
    state: 'TX',
    zip: 79720,
    telephone: '(432) 264-5000',
    population: 4108,
    county: 'HOWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.howardcollege.edu/',
  },
  {
    name: 'EAST CENTRAL UNIVERSITY',
    address: '1100 E. 14TH STREET',
    city: 'ADA',
    state: 'OK',
    zip: 74820,
    telephone: '(580) 332-8000',
    population: 4109,
    county: 'PONTOTOC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ecok.edu/',
  },
  {
    name: 'MOHAVE COMMUNITY COLLEGE',
    address: '1971 JAGERSON AVE',
    city: 'KINGMAN',
    state: 'AZ',
    zip: 86409,
    telephone: '(928) 757-4331',
    population: 4110,
    county: 'MOHAVE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mohave.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA AT ASHEVILLE',
    address: 'ONE UNIVERSITY HEIGHTS',
    city: 'ASHEVILLE',
    state: 'NC',
    zip: 28804,
    telephone: '(828) 251-6600',
    population: 4117,
    county: 'BUNCOMBE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unca.edu/',
  },
  {
    name: 'GEORGE C WALLACE COMMUNITY COLLEGE-DOTHAN',
    address: '1141 WALLACE DRIVE',
    city: 'DOTHAN',
    state: 'AL',
    zip: 36303,
    telephone: '(334) 983-3521',
    population: 4117,
    county: 'DALE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wallace.edu/',
  },
  {
    name: 'ELMHURST UNIVERSITY',
    address: '190 PROSPECT AVE',
    city: 'ELMHURST',
    state: 'IL',
    zip: 60126,
    telephone: '(630) 279-4100',
    population: 4120,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.elmhurst.edu/',
  },
  {
    name: 'COLGATE UNIVERSITY',
    address: '13 OAK DRIVE',
    city: 'HAMILTON',
    state: 'NY',
    zip: 13346,
    telephone: '(315) 228-1000',
    population: 4120,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.colgate.edu/',
  },
  {
    name: 'MOUNT WACHUSETT COMMUNITY COLLEGE',
    address: '444 GREEN ST',
    city: 'GARDNER',
    state: 'MA',
    zip: 1440,
    telephone: '(978) 632-6600',
    population: 4124,
    county: 'WORCESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'mwcc.edu/',
  },
  {
    name: 'KELLOGG COMMUNITY COLLEGE',
    address: '450 NORTH AVE',
    city: 'BATTLE CREEK',
    state: 'MI',
    zip: 49017,
    telephone: '(269) 965-3931',
    population: 4135,
    county: 'CALHOUN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kellogg.edu/',
  },
  {
    name: 'CASPER COLLEGE',
    address: '125 COLLEGE DRIVE',
    city: 'CASPER',
    state: 'WY',
    zip: 82601,
    telephone: '(307) 268-2100',
    population: 4137,
    county: 'NATRONA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.caspercollege.edu/',
  },
  {
    name: 'TEXARKANA COLLEGE',
    address: '2500 N ROBISON RD',
    city: 'TEXARKANA',
    state: 'TX',
    zip: 75599,
    telephone: '(903) 823-3456',
    population: 4149,
    county: 'BOWIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.texarkanacollege.edu/',
  },
  {
    name: 'XAVIER UNIVERSITY OF LOUISIANA',
    address: '1 DREXEL DRIVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70125,
    telephone: '(504) 486-7411',
    population: 4152,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.xula.edu/',
  },
  {
    name: 'SHELTON STATE COMMUNITY COLLEGE',
    address: '9500 OLD GREENSBORO RD',
    city: 'TUSCALOOSA',
    state: 'AL',
    zip: 35405,
    telephone: '(205) 391-2211',
    population: 4153,
    county: 'TUSCALOOSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sheltonstate.edu/',
  },
  {
    name: 'TRINE UNIVERSITY',
    address: '1 UNIVERSITY AVE',
    city: 'ANGOLA',
    state: 'IN',
    zip: 46703,
    telephone: '(260) 665-4100',
    population: 4155,
    county: 'STEUBEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.trine.edu/',
  },
  {
    name: 'ROCKHURST UNIVERSITY',
    address: '1100 ROCKHURST RD',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64110,
    telephone: '(816) 501-4000',
    population: 4159,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rockhurst.edu/',
  },
  {
    name: 'COASTAL CAROLINA COMMUNITY COLLEGE',
    address: '444 WESTERN BLVD',
    city: 'JACKSONVILLE',
    state: 'NC',
    zip: 28546,
    telephone: '(910) 455-1221',
    population: 4160,
    county: 'ONSLOW',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coastalcarolina.edu/',
  },
  {
    name: 'GARDNER-WEBB UNIVERSITY',
    address: 'MAIN ST',
    city: 'BOILING SPRINGS',
    state: 'NC',
    zip: 28017,
    telephone: '(704) 406-2361',
    population: 4166,
    county: 'CLEVELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gardner-webb.edu/',
  },
  {
    name: 'EASTERN UNIVERSITY',
    address: '1300 EAGLE RD',
    city: 'SAINT DAVIDS',
    state: 'PA',
    zip: 19087,
    telephone: '(610) 341-5800',
    population: 4167,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eastern.edu/about/student-consumer-information',
  },
  {
    name: 'FLORIDA SOUTHERN COLLEGE',
    address: '111 LAKE HOLLINGSWORTH DR',
    city: 'LAKELAND',
    state: 'FL',
    zip: 33801,
    telephone: '(863) 680-4111',
    population: 4169,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.flsouthern.edu/',
  },
  {
    name: "ST. MARY'S UNIVERSITY",
    address: 'ONE CAMINO SANTA MARIA',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78228,
    telephone: '(210) 436-3011',
    population: 4170,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stmarytx.edu/',
  },
  {
    name: 'WEST HILLS COLLEGE-LEMOORE',
    address: '555 COLLEGE AVENUE',
    city: 'LEMOORE',
    state: 'CA',
    zip: 93245,
    telephone: '(559) 925-3000',
    population: 4177,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.westhillscollege.com/lemoore/',
  },
  {
    name: 'SCHOOL OF THE ART INSTITUTE OF CHICAGO',
    address: '36 S WABASH',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60603,
    telephone: '(312) 629-6118',
    population: 4179,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.saic.edu/',
  },
  {
    name: 'NORTHERN WYOMING COMMUNITY COLLEGE DISTRICT',
    address: '1 WHITNEY WAY',
    city: 'SHERIDAN',
    state: 'WY',
    zip: 82801,
    telephone: '(307) 675-0505 EXT 0',
    population: 4184,
    county: 'SHERIDAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sheridan.edu/',
  },
  {
    name: 'JEFFERSON COLLEGE',
    address: '1000 VIKING DRIVE',
    city: 'HILLSBORO',
    state: 'MO',
    zip: 63050,
    telephone: '(636) 797-3000',
    population: 4185,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jeffco.edu/',
  },
  {
    name: 'UNIVERSITY OF GUAM',
    address: '303 UNIVERSITY DRIVE, UOG STATION',
    city: 'MANGILAO',
    state: 'GU',
    zip: 96923,
    telephone: '(671) 735-2900',
    population: 4186,
    county: 'GUAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uog.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-SAN GERMAN',
    address: 'RD. 102 KM. 30.6',
    city: 'SAN GERMAN',
    state: 'PR',
    zip: 683,
    telephone: '(787) 264-1912 EXT 7243',
    population: 4187,
    county: 'SAN GERMÁN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sg.inter.edu/',
  },
  {
    name: 'BLACK HAWK COLLEGE',
    address: '6600-34TH AVENUE',
    city: 'MOLINE',
    state: 'IL',
    zip: 61265,
    telephone: '(309) 796-5000',
    population: 4191,
    county: 'ROCK ISLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bhc.edu/',
  },
  {
    name: 'LANDER UNIVERSITY',
    address: '320 STANLEY AVENUE',
    city: 'GREENWOOD',
    state: 'SC',
    zip: 29649,
    telephone: '(864) 388-8000',
    population: 4193,
    county: 'GREENWOOD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lander.edu/',
  },
  {
    name: 'RELAY GRADUATE SCHOOL OF EDUCATION',
    address: '25 BROADWAY, 3RD FL',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10004,
    telephone: '(212) 228-1888',
    population: 4199,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.relay.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTHWESTERN-ST PAUL',
    address: '3003 SNELLING AVE N',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55113,
    telephone: '(651) 631-5100',
    population: 4204,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unwsp.edu/',
  },
  {
    name: 'CARROLL UNIVERSITY',
    address: '100 N EAST AVE',
    city: 'WAUKESHA',
    state: 'WI',
    zip: 53186,
    telephone: '(262) 547-1211',
    population: 4205,
    county: 'WAUKESHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.carrollu.edu/',
  },
  {
    name: 'LOUISIANA DELTA COMMUNITY COLLEGE',
    address: '7500 MILLHAVEN RD',
    city: 'MONROE',
    state: 'LA',
    zip: 71203,
    telephone: '(866) 500-5322',
    population: 4208,
    county: 'OUACHITA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ladelta.edu/',
  },
  {
    name: 'BISMARCK STATE COLLEGE',
    address: '1500 EDWARDS AVE.',
    city: 'BISMARCK',
    state: 'ND',
    zip: 58506,
    telephone: '(701) 224-5400',
    population: 4210,
    county: 'BURLEIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://bismarckstate.edu/',
  },
  {
    name: 'BLUE RIDGE COMMUNITY AND TECHNICAL COLLEGE',
    address: '13650 APPLE HARVEST DRIVE',
    city: 'MARTINSBURG',
    state: 'WV',
    zip: 25403,
    telephone: '(304) 260-4380',
    population: 4214,
    county: 'BERKELEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.blueridgectc.edu/',
  },
  {
    name: 'GREAT BASIN COLLEGE',
    address: '1500 COLLEGE PARKWAY',
    city: 'ELKO',
    state: 'NV',
    zip: 89801,
    telephone: '(775) 738-8493',
    population: 4215,
    county: 'ELKO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gbcnv.edu/',
  },
  {
    name: 'HOUSATONIC COMMUNITY COLLEGE',
    address: '900 LAFAYETTE BLVD',
    city: 'BRIDGEPORT',
    state: 'CT',
    zip: 6604,
    telephone: '(203) 332-5000',
    population: 4216,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hcc.commnet.edu/',
  },
  {
    name: 'MOUNTAINLAND TECHNICAL COLLEGE',
    address: '2301 WEST ASHTON BLVD.',
    city: 'LEHI',
    state: 'UT',
    zip: 84043,
    telephone: '(801) 753-4100',
    population: 4219,
    county: 'UTAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://mtec.edu/',
  },
  {
    name: 'BABSON COLLEGE',
    address: '231 FOREST STREET',
    city: 'WELLESLEY',
    state: 'MA',
    zip: 2457,
    telephone: '(781) 235-1200',
    population: 4222,
    county: 'NORFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.babson.edu/',
  },
  {
    name: 'HUSSON UNIVERSITY',
    address: '1 COLLEGE CIRCLE',
    city: 'BANGOR',
    state: 'ME',
    zip: 4401,
    telephone: '(207) 941-7000',
    population: 4229,
    county: 'PENOBSCOT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.husson.edu/',
  },
  {
    name: 'MESSIAH UNIVERSITY',
    address: 'ONE UNIVERSITY AVENUE',
    city: 'MECHANICSBURG',
    state: 'PA',
    zip: 17055,
    telephone: '(717) 766-2511',
    population: 4234,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.messiah.edu/',
  },
  {
    name: 'PORTERVILLE COLLEGE',
    address: '100 E COLLEGE AVE',
    city: 'PORTERVILLE',
    state: 'CA',
    zip: 93257,
    telephone: '(559) 791-2200',
    population: 4234,
    county: 'TULARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.portervillecollege.edu/',
  },
  {
    name: 'ST CLOUD TECHNICAL AND COMMUNITY COLLEGE',
    address: '1540 NORTHWAY DRIVE',
    city: 'SAINT CLOUD',
    state: 'MN',
    zip: 56303,
    telephone: '(320) 308-5000',
    population: 4240,
    county: 'STEARNS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sctcc.edu/',
  },
  {
    name: 'SIENA COLLEGE',
    address: '515 LOUDON RD',
    city: 'LOUDONVILLE',
    state: 'NY',
    zip: 12211,
    telephone: '(518) 783-2300',
    population: 4252,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.siena.edu/',
  },
  {
    name: 'AUGUSTA TECHNICAL COLLEGE',
    address: '3200 AUGUSTA TECH DRIVE',
    city: 'AUGUSTA',
    state: 'GA',
    zip: 30906,
    telephone: '(706) 771-4000',
    population: 4256,
    county: 'RICHMOND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.augustatech.edu/',
  },
  {
    name: 'ARCADIA UNIVERSITY',
    address: '450 S EASTON RD',
    city: 'GLENSIDE',
    state: 'PA',
    zip: 19038,
    telephone: '(215) 572-2900',
    population: 4257,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arcadia.edu/',
  },
  {
    name: 'CAMERON UNIVERSITY',
    address: '2800 WEST GORE BLVD',
    city: 'LAWTON',
    state: 'OK',
    zip: 73505,
    telephone: '(580) 581-2200',
    population: 4263,
    county: 'COMANCHE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cameron.edu/',
  },
  {
    name: 'DAVIS TECHNICAL COLLEGE',
    address: '550 E 300 S',
    city: 'KAYSVILLE',
    state: 'UT',
    zip: 84037,
    telephone: '(801) 593-2500',
    population: 4266,
    county: 'DAVIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.davistech.edu/',
  },
  {
    name: 'OWENSBORO COMMUNITY AND TECHNICAL COLLEGE',
    address: '4800 NEW HARTFORD RD',
    city: 'OWENSBORO',
    state: 'KY',
    zip: 42303,
    telephone: '(270) 686-4400',
    population: 4268,
    county: 'DAVIESS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://owensboro.kctcs.edu/',
  },
  {
    name: 'UPPER IOWA UNIVERSITY',
    address: '605 WASHINGTON ST',
    city: 'FAYETTE',
    state: 'IA',
    zip: 52142,
    telephone: '(563) 425-5200',
    population: 4275,
    county: 'FAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uiu.edu/',
  },
  {
    name: 'HAMPTON UNIVERSITY',
    address: '200 WILLIAM R. HARVEY WAY',
    city: 'HAMPTON',
    state: 'VA',
    zip: 23668,
    telephone: '(757) 727-5000',
    population: 4283,
    county: 'HAMPTON CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hamptonu.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-PONCE',
    address: '104 TURPEAUX INDUSTRIAL PARK RD1',
    city: 'MERCEDITA',
    state: 'PR',
    zip: 715,
    telephone: '(787) 284-1912',
    population: 4284,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ponce.inter.edu/',
  },
  {
    name: 'STEVENSON UNIVERSITY',
    address: '1525 GREENSPRING VALLEY RD',
    city: 'STEVENSON',
    state: 'MD',
    zip: 21153,
    telephone: '(410) 486-7000',
    population: 4290,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevenson.edu/',
  },
  {
    name: 'BALDWIN WALLACE UNIVERSITY',
    address: '275 EASTLAND RD',
    city: 'BEREA',
    state: 'OH',
    zip: 44017,
    telephone: '(440) 826-2900',
    population: 4293,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bw.edu/',
  },
  {
    name: "SAINT EDWARD'S UNIVERSITY",
    address: '3001 S CONGRESS AVE',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78704,
    telephone: '(512) 448-8400',
    population: 4300,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stedwards.edu/',
  },
  {
    name: 'SUNY COLLEGE OF TECHNOLOGY AT ALFRED',
    address: '10 UPPER COLLEGE DRIVE',
    city: 'ALFRED',
    state: 'NY',
    zip: 14802,
    telephone: '(800) 425-3733',
    population: 4303,
    county: 'ALLEGANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alfredstate.edu/',
  },
  {
    name: 'CLARK UNIVERSITY',
    address: '950 MAIN ST',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1610,
    telephone: '(508) 793-7711',
    population: 4304,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.clarku.edu/',
  },
  {
    name: 'IONA COLLEGE',
    address: '715 NORTH AVE',
    city: 'NEW ROCHELLE',
    state: 'NY',
    zip: 10801,
    telephone: '(914) 633-2000',
    population: 4310,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iona.edu/',
  },
  {
    name: 'DAVIDSON COUNTY COMMUNITY COLLEGE',
    address: '297 DCCC ROAD',
    city: 'THOMASVILLE',
    state: 'NC',
    zip: 27360,
    telephone: '(336) 249-8186',
    population: 4314,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.davidsonccc.edu/',
  },
  {
    name: 'LEWIS-CLARK STATE COLLEGE',
    address: '500 8TH AVE',
    city: 'LEWISTON',
    state: 'ID',
    zip: 83501,
    telephone: '(208) 792-5272',
    population: 4315,
    county: 'NEZ PERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lcsc.edu/',
  },
  {
    name: 'PALM BEACH ATLANTIC UNIVERSITY',
    address: '901 S. FLAGLER DRIVE',
    city: 'WEST PALM BEACH',
    state: 'FL',
    zip: 33401,
    telephone: '(561) 803-2000',
    population: 4315,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pba.edu/',
  },
  {
    name: 'UNIVERSITY OF ST THOMAS',
    address: '3800 MONTROSE BLVD',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77006,
    telephone: '(713) 522-7911',
    population: 4319,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stthom.edu/',
  },
  {
    name: 'ROGUE COMMUNITY COLLEGE',
    address: '3345 REDWOOD HWY',
    city: 'GRANTS PASS',
    state: 'OR',
    zip: 97527,
    telephone: '(541) 956-7501',
    population: 4319,
    county: 'JOSEPHINE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.roguecc.edu/',
  },
  {
    name: 'MASSACHUSETTS BAY COMMUNITY COLLEGE',
    address: '50 OAKLAND ST',
    city: 'WELLESLEY HILLS',
    state: 'MA',
    zip: 2481,
    telephone: '(781) 239-3000',
    population: 4320,
    county: 'NORFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.massbay.edu/',
  },
  {
    name: 'NIAGARA UNIVERSITY',
    address: 'LEWISTON ROAD',
    city: 'NIAGARA UNIVERSITY',
    state: 'NY',
    zip: 14109,
    telephone: '(716) 285-1212',
    population: 4324,
    county: 'NIAGARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.niagara.edu/',
  },
  {
    name: 'COLLEGE OF THE REDWOODS',
    address: '7351 TOMPKINS HILL RD',
    city: 'EUREKA',
    state: 'CA',
    zip: 95501,
    telephone: '(707) 476-4100',
    population: 4331,
    county: 'HUMBOLDT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.redwoods.edu/',
  },
  {
    name: 'UNIVERSITY OF MARY',
    address: '7500 UNIVERSITY DR',
    city: 'BISMARCK',
    state: 'ND',
    zip: 58504,
    telephone: '(701) 255-7500',
    population: 4355,
    county: 'BURLEIGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.umary.edu/',
  },
  {
    name: 'READING AREA COMMUNITY COLLEGE',
    address: '10 S SECOND ST',
    city: 'READING',
    state: 'PA',
    zip: 19603,
    telephone: '(610) 372-4721',
    population: 4369,
    county: 'BERKS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.racc.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-NORTHWEST',
    address: '3400 BROADWAY',
    city: 'GARY',
    state: 'IN',
    zip: 46408,
    telephone: '(219) 980-6501',
    population: 4370,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iun.edu/',
  },
  {
    name: 'SUNY CORNING COMMUNITY COLLEGE',
    address: '1 ACADEMIC DR',
    city: 'CORNING',
    state: 'NY',
    zip: 14830,
    telephone: '(607) 962-9011',
    population: 4370,
    county: 'STEUBEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.corning-cc.edu/',
  },
  {
    name: 'SCHENECTADY COUNTY COMMUNITY COLLEGE',
    address: '78 WASHINGTON AVENUE',
    city: 'SCHENECTADY',
    state: 'NY',
    zip: 12305,
    telephone: '(518) 381-1200',
    population: 4378,
    county: 'SCHENECTADY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'sunysccc.edu/',
  },
  {
    name: 'INVER HILLS COMMUNITY COLLEGE',
    address: '2500 80TH ST E',
    city: 'INVER GROVE HEIGHTS',
    state: 'MN',
    zip: 55076,
    telephone: '(651) 450-3000',
    population: 4379,
    county: 'DAKOTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.inverhills.edu/',
  },
  {
    name: 'HILL COLLEGE',
    address: '112 LAMAR DR',
    city: 'HILLSBORO',
    state: 'TX',
    zip: 76645,
    telephone: '(254) 659-7500',
    population: 4384,
    county: 'HILL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hillcollege.edu/',
  },
  {
    name: 'STATE FAIR COMMUNITY COLLEGE',
    address: '3201 W 16TH STREET',
    city: 'SEDALIA',
    state: 'MO',
    zip: 65301,
    telephone: '(877) 311-7322',
    population: 4398,
    county: 'PETTIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sfccmo.edu/',
  },
  {
    name: 'SOUTHERN UNION STATE COMMUNITY COLLEGE',
    address: '750 ROBERTS ST',
    city: 'WADLEY',
    state: 'AL',
    zip: 36276,
    telephone: '(256) 395-2211',
    population: 4399,
    county: 'RANDOLPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.suscc.edu/',
  },
  {
    name: 'WINGATE UNIVERSITY',
    address: '301 E. WILSON STREET',
    city: 'WINGATE',
    state: 'NC',
    zip: 28174,
    telephone: '(704) 233-8000',
    population: 4400,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wingate.edu/',
  },
  {
    name: 'JACKSON COLLEGE',
    address: '2111 EMMONS RD',
    city: 'JACKSON',
    state: 'MI',
    zip: 49201,
    telephone: '(517) 787-0800',
    population: 4404,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jccmi.edu/',
  },
  {
    name: 'WEST HILLS COLLEGE-COALINGA',
    address: '300 CHERRY LANE',
    city: 'COALINGA',
    state: 'CA',
    zip: 93210,
    telephone: '(559) 934-2000',
    population: 4409,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.westhillscollege.com/coalinga/',
  },
  {
    name: 'SAINT XAVIER UNIVERSITY',
    address: '3700 W 103RD ST',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60655,
    telephone: '(773) 298-3000',
    population: 4411,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sxu.edu/',
  },
  {
    name: 'NEW RIVER COMMUNITY COLLEGE',
    address: '5251 COLLEGE DRIVE',
    city: 'DUBLIN',
    state: 'VA',
    zip: 24084,
    telephone: '(540) 674-3600',
    population: 4412,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nr.edu/',
  },
  {
    name: 'SAINT JOHN FISHER COLLEGE',
    address: '3690 EAST AVE',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14618,
    telephone: '(585) 385-8000',
    population: 4418,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sjfc.edu/',
  },
  {
    name: 'MARIAN UNIVERSITY',
    address: '3200 COLD SPRING RD',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46222,
    telephone: '(317) 955-6000',
    population: 4419,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marian.edu/',
  },
  {
    name: 'POINT PARK UNIVERSITY',
    address: '201 WOOD ST',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15222,
    telephone: '(412) 391-4100',
    population: 4423,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pointpark.edu/',
  },
  {
    name: 'FAIRMONT STATE UNIVERSITY',
    address: '1201 LOCUST AVE',
    city: 'FAIRMONT',
    state: 'WV',
    zip: 26554,
    telephone: '(304) 367-4000',
    population: 4426,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fairmontstate.edu/',
  },
  {
    name: 'THE COLLEGE OF SAINT SCHOLASTICA',
    address: '1200 KENWOOD AVE',
    city: 'DULUTH',
    state: 'MN',
    zip: 55811,
    telephone: '(218) 723-6000',
    population: 4428,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.css.edu/',
  },
  {
    name: 'TREVECCA NAZARENE UNIVERSITY',
    address: '333 MURFREESBORO RD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37210,
    telephone: '(615) 248-1200',
    population: 4441,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.trevecca.edu/',
  },
  {
    name: 'BENEDICTINE UNIVERSITY',
    address: '5700 COLLEGE RD',
    city: 'LISLE',
    state: 'IL',
    zip: 60532,
    telephone: '(630) 829-6000',
    population: 4446,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ben.edu/',
  },
  {
    name: 'SEATTLE PACIFIC UNIVERSITY',
    address: '3307 3RD AVE W',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98119,
    telephone: '(206) 281-2000',
    population: 4452,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://spu.edu/',
  },
  {
    name: 'LAKE LAND COLLEGE',
    address: '5001 LAKE LAND BLVD',
    city: 'MATTOON',
    state: 'IL',
    zip: 61938,
    telephone: '(217) 234-5253',
    population: 4452,
    county: 'COLES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lakelandcollege.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-BAYAMON',
    address: '500 CARR. DR. JOHN WILL HARRIS',
    city: 'BAYAMON',
    state: 'PR',
    zip: 957,
    telephone: '(787) 279-1912 EXT 2085',
    population: 4453,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'bayamon.inter.edu/',
  },
  {
    name: 'COASTAL BEND COLLEGE',
    address: '3800 CHARCO RD',
    city: 'BEEVILLE',
    state: 'TX',
    zip: 78102,
    telephone: '(361) 354-2200',
    population: 4453,
    county: 'BEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coastalbend.edu/',
  },
  {
    name: 'YAKIMA VALLEY COLLEGE',
    address: 'SOUTH 16TH AVE. & NOB HILL BLVD.',
    city: 'YAKIMA',
    state: 'WA',
    zip: 98907,
    telephone: '(509) 574-4600',
    population: 4456,
    county: 'YAKIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.yvcc.edu/',
  },
  {
    name: 'HARRISBURG UNIVERSITY OF SCIENCE AND TECHNOLOGY',
    address: '326 MARKET STREET',
    city: 'HARRISBURG',
    state: 'PA',
    zip: 17101,
    telephone: '(717) 901-5152',
    population: 4460,
    county: 'DAUPHIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.harrisburgu.edu/',
  },
  {
    name: 'CALDWELL COMMUNITY COLLEGE AND TECHNICAL INSTITUTE',
    address: '2855 HICKORY BOULEVARD',
    city: 'HUDSON',
    state: 'NC',
    zip: 28638,
    telephone: '(828) 726-2200',
    population: 4460,
    county: 'CALDWELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cccti.edu/',
  },
  {
    name: 'WESTERN NEW ENGLAND UNIVERSITY',
    address: '1215 WILBRAHAM RD',
    city: 'SPRINGFIELD',
    state: 'MA',
    zip: 1119,
    telephone: '(413) 782-3111',
    population: 4461,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www1.wne.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA AIKEN',
    address: '471 UNIVERSITY PKWY',
    city: 'AIKEN',
    state: 'SC',
    zip: 29801,
    telephone: '(803) 648-6851',
    population: 4461,
    county: 'AIKEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usca.edu/',
  },
  {
    name: 'CLARK ATLANTA UNIVERSITY',
    address: '223 JAMES P BRAWLEY DRIVE, SW',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30314,
    telephone: '(404) 880-8000',
    population: 4465,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cau.edu/',
  },
  {
    name: 'BRAZOSPORT COLLEGE',
    address: '500 COLLEGE DR',
    city: 'LAKE JACKSON',
    state: 'TX',
    zip: 77566,
    telephone: '(979) 230-3000',
    population: 4470,
    county: 'BRAZORIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.brazosport.edu/',
  },
  {
    name: 'LARAMIE COUNTY COMMUNITY COLLEGE',
    address: '1400 E COLLEGE DR',
    city: 'CHEYENNE',
    state: 'WY',
    zip: 82007,
    telephone: '(307) 778-5222 EXT 1357',
    population: 4470,
    county: 'LARAMIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lccc.wy.edu/',
  },
  {
    name: 'ABRAHAM BALDWIN AGRICULTURAL COLLEGE',
    address: '2802 MOORE HWY',
    city: 'TIFTON',
    state: 'GA',
    zip: 31793,
    telephone: '(229) 391-5001',
    population: 4473,
    county: 'TIFT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.abac.edu/',
  },
  {
    name: 'BRYANT UNIVERSITY',
    address: '1150 DOUGLAS PIKE',
    city: 'SMITHFIELD',
    state: 'RI',
    zip: 2917,
    telephone: '(401) 232-6000',
    population: 4476,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bryant.edu/',
  },
  {
    name: 'CITADEL MILITARY COLLEGE OF SOUTH CAROLINA',
    address: '171 MOULTRIE ST',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29409,
    telephone: '(843) 225-3294',
    population: 4484,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.citadel.edu/',
  },
  {
    name: 'HENNEPIN TECHNICAL COLLEGE',
    address: '9000 BROOKLYN BLVD',
    city: 'BROOKLYN PARK',
    state: 'MN',
    zip: 55445,
    telephone: '(952) 995-1300',
    population: 4486,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hennepintech.edu/',
  },
  {
    name: 'CENTRAL STATE UNIVERSITY',
    address: '1400 BRUSH ROW RD',
    city: 'WILBERFORCE',
    state: 'OH',
    zip: 45384,
    telephone: '(937) 376-6011',
    population: 4493,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centralstate.edu/',
  },
  {
    name: 'EDISON STATE COMMUNITY COLLEGE',
    address: '1973 EDISON DR',
    city: 'PIQUA',
    state: 'OH',
    zip: 45356,
    telephone: '(937) 778-8600',
    population: 4498,
    county: 'MIAMI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.edisonohio.edu/',
  },
  {
    name: 'MONTANA STATE UNIVERSITY BILLINGS',
    address: '1500 UNIVERSITY DRIVE',
    city: 'BILLINGS',
    state: 'MT',
    zip: 59101,
    telephone: '(406) 657-2011',
    population: 4499,
    county: 'YELLOWSTONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msubillings.edu/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-MINNESOTA',
    address: '226 PARK AVENUE SOUTH',
    city: 'ST. CLOUD',
    state: 'MN',
    zip: 56301,
    telephone: '(320) 251-5600',
    population: 4500,
    county: 'STEARNS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'SOUTHCENTRAL KENTUCKY COMMUNITY AND TECHNICAL COLLEGE',
    address: '1845 LOOP DR',
    city: 'BOWLING GREEN',
    state: 'KY',
    zip: 42101,
    telephone: '(270) 901-1000',
    population: 4506,
    county: 'WARREN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://southcentral.kctcs.edu/',
  },
  {
    name: 'HOUSTON BAPTIST UNIVERSITY',
    address: '7502 FONDREN RD',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77074,
    telephone: '(281) 649-3000',
    population: 4508,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hbu.edu/',
  },
  {
    name: 'THE COLLEGE OF SAINT ROSE',
    address: '432 WESTERN AVE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12203,
    telephone: '(518) 454-5111',
    population: 4522,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strose.edu/',
  },
  {
    name: 'GADSDEN STATE COMMUNITY COLLEGE',
    address: '1001 GEORGE WALLACE DR',
    city: 'GADSDEN',
    state: 'AL',
    zip: 35903,
    telephone: '(256) 549-8200',
    population: 4531,
    county: 'ETOWAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gadsdenstate.edu/',
  },
  {
    name: 'UNIVERSITY OF MARY HARDIN-BAYLOR',
    address: '900 COLLEGE ST',
    city: 'BELTON',
    state: 'TX',
    zip: 76513,
    telephone: '(800) 727-8642',
    population: 4537,
    county: 'BELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://go.umhb.edu/',
  },
  {
    name: 'OLIVET NAZARENE UNIVERSITY',
    address: 'ONE UNIVERSITY AVENUE',
    city: 'BOURBONNAIS',
    state: 'IL',
    zip: 60914,
    telephone: '(815) 939-5011',
    population: 4542,
    county: 'KANKAKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.olivet.edu/',
  },
  {
    name: 'BARTON COUNTY COMMUNITY COLLEGE',
    address: '245 NE 30TH ROAD',
    city: 'GREAT BEND',
    state: 'KS',
    zip: 67530,
    telephone: '(620) 792-2701',
    population: 4548,
    county: 'BARTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bartonccc.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-MEDICAL SCIENCES',
    address: 'RIO PIEDRAS MEDICAL CENTER, AMERICO MIRANDA AVENUE',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 936,
    telephone: '(787) 758-2525 EXT 1708',
    population: 4560,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rcm.upr.edu/',
  },
  {
    name: 'FLORIDA NATIONAL UNIVERSITY-MAIN CAMPUS',
    address: '4425 WEST. JOSE REGUEIRO (20TH) AVENUE',
    city: 'HIALEAH',
    state: 'FL',
    zip: 33012,
    telephone: '(305) 821-3333',
    population: 4562,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fnu.edu/',
  },
  {
    name: 'GRAYSON COLLEGE',
    address: '6101 GRAYSON DRIVE',
    city: 'DENISON',
    state: 'TX',
    zip: 75020,
    telephone: '(903) 415-2592',
    population: 4566,
    county: 'GRAYSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'grayson.edu/',
  },
  {
    name: 'JACKSON STATE COMMUNITY COLLEGE',
    address: '2046 NORTH PKY',
    city: 'JACKSON',
    state: 'TN',
    zip: 38301,
    telephone: '(731) 424-3520',
    population: 4580,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jscc.edu/',
  },
  {
    name: 'BETHEL UNIVERSITY',
    address: '325 CHERRY AVE',
    city: 'MCKENZIE',
    state: 'TN',
    zip: 38201,
    telephone: '(731) 352-4000',
    population: 4623,
    county: 'CARROLL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bethelu.edu/',
  },
  {
    name: 'YORK TECHNICAL COLLEGE',
    address: '452 S ANDERSON RD',
    city: 'ROCK HILL',
    state: 'SC',
    zip: 29730,
    telephone: '(803) 327-8000',
    population: 4636,
    county: 'YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.yorktech.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-IRVINE',
    address: '1530 CONCORDIA WEST',
    city: 'IRVINE',
    state: 'CA',
    zip: 92612,
    telephone: '(949) 854-8002',
    population: 4639,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cui.edu/',
  },
  {
    name: "SAINT MARY'S COLLEGE OF CALIFORNIA",
    address: '1928 SAINT MARYS ROAD',
    city: 'MORAGA',
    state: 'CA',
    zip: 94575,
    telephone: '(925) 631-4000',
    population: 4655,
    county: 'CONTRA COSTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stmarys-ca.edu/',
  },
  {
    name: 'SUNY AT PURCHASE COLLEGE',
    address: '735 ANDERSON HILL RD',
    city: 'PURCHASE',
    state: 'NY',
    zip: 10577,
    telephone: '(914) 251-6000',
    population: 4657,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.purchase.edu/',
  },
  {
    name: 'SPARTANBURG COMMUNITY COLLEGE',
    address: '107 COMMUNITY COLLEGE DRIVE',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29303,
    telephone: '(864) 592-4500',
    population: 4662,
    county: 'SPARTANBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sccsc.edu/',
  },
  {
    name: 'UNIVERSITY OF MAINE AT AUGUSTA',
    address: '46 UNIVERSITY DR',
    city: 'AUGUSTA',
    state: 'ME',
    zip: 4330,
    telephone: '(207) 621-3000',
    population: 4665,
    county: 'KENNEBEC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uma.edu/',
  },
  {
    name: 'UNIVERSITY OF FLORIDA-ONLINE',
    address: '341 TIGERT HALL 300 SW 13TH ST',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32611,
    telephone: '(352) 392-1202',
    population: 4667,
    county: 'ALACHUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ufonline.ufl.edu/',
  },
  {
    name: 'SOUTHERN REGIONAL TECHNICAL COLLEGE',
    address: '15689 US HWY 19 NORTH',
    city: 'THOMASVILLE',
    state: 'GA',
    zip: 31792,
    telephone: '(229) 225-4096',
    population: 4668,
    county: 'THOMAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'southernregional.edu/',
  },
  {
    name: 'UNITED STATES AIR FORCE ACADEMY',
    address: '2304 CADET DRIVE, SUITE 3800',
    city: 'USAF ACADEMY',
    state: 'CO',
    zip: 80840,
    telephone: '(719) 333-1818',
    population: 4673,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usafa.edu/',
  },
  {
    name: 'WAYNE STATE COLLEGE',
    address: '1111 MAIN ST',
    city: 'WAYNE',
    state: 'NE',
    zip: 68787,
    telephone: '(402) 375-7000',
    population: 4676,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wsc.edu/',
  },
  {
    name: 'BETHEL UNIVERSITY',
    address: '3900 BETHEL DR',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55112,
    telephone: '(651) 638-6400',
    population: 4693,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bethel.edu/',
  },
  {
    name: 'ANGELINA COLLEGE',
    address: '3500 SOUTH FIRST',
    city: 'LUFKIN',
    state: 'TX',
    zip: 75902,
    telephone: '(936) 639-1301',
    population: 4695,
    county: 'ANGELINA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.angelina.edu/',
  },
  {
    name: 'GATEWAY COMMUNITY AND TECHNICAL COLLEGE',
    address: '500 TECHNOLOGY WAY',
    city: 'FLORENCE',
    state: 'KY',
    zip: 41042,
    telephone: '(859) 441-4500',
    population: 4695,
    county: 'BOONE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://gateway.kctcs.edu/index.aspx',
  },
  {
    name: 'ALAMANCE COMMUNITY COLLEGE',
    address: '1247 JIMMIE KERR ROAD',
    city: 'GRAHAM',
    state: 'NC',
    zip: 27253,
    telephone: '(336) 578-2002',
    population: 4699,
    county: 'ALAMANCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alamancecc.edu/',
  },
  {
    name: 'SANDHILLS COMMUNITY COLLEGE',
    address: '3395 AIRPORT RD',
    city: 'PINEHURST',
    state: 'NC',
    zip: 28374,
    telephone: '(910) 692-6185',
    population: 4700,
    county: 'MOORE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sandhills.edu/',
  },
  {
    name: 'CENTRAL ARIZONA COLLEGE',
    address: '8470 N OVERFIELD RD',
    city: 'COOLIDGE',
    state: 'AZ',
    zip: 85128,
    telephone: '(520) 494-5444',
    population: 4701,
    county: 'PINAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.centralaz.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH TEXAS AT DALLAS',
    address: '7300 UNIVERSITY HILLS DRIVE',
    city: 'DALLAS',
    state: 'TX',
    zip: 75241,
    telephone: '(972) 780-3600',
    population: 4714,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'untdallas.edu/',
  },
  {
    name: 'SKAGIT VALLEY COLLEGE',
    address: '2405 E. COLLEGE WAY',
    city: 'MOUNT VERNON',
    state: 'WA',
    zip: 98273,
    telephone: '(360) 416-7600',
    population: 4717,
    county: 'SKAGIT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.skagit.edu/',
  },
  {
    name: 'WAYLAND BAPTIST UNIVERSITY',
    address: '1900 W 7TH ST.',
    city: 'PLAINVIEW',
    state: 'TX',
    zip: 79072,
    telephone: '(806) 291-1000',
    population: 4728,
    county: 'HALE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wbu.edu/',
  },
  {
    name: 'DALLAS BAPTIST UNIVERSITY',
    address: '3000 MOUNTAIN CREEK PARKWAY',
    city: 'DALLAS',
    state: 'TX',
    zip: 75211,
    telephone: '(214) 333-7100',
    population: 4730,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.dbu.edu/',
  },
  {
    name: 'PACIFIC UNIVERSITY',
    address: '2043 COLLEGE WAY',
    city: 'FOREST GROVE',
    state: 'OR',
    zip: 97116,
    telephone: '(877) 722-8648',
    population: 4731,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pacificu.edu/',
  },
  {
    name: 'LAMAR INSTITUTE OF TECHNOLOGY',
    address: '855 E LAVACA',
    city: 'BEAUMONT',
    state: 'TX',
    zip: 77705,
    telephone: '(409) 880-8321',
    population: 4733,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lit.edu/',
  },
  {
    name: 'WEST COAST UNIVERSITY-ORANGE COUNTY',
    address: '1477 S MANCHESTER AVE',
    city: 'ANAHEIM',
    state: 'CA',
    zip: 92802,
    telephone: '(714) 782-1700',
    population: 4734,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'westcoastuniversity.edu/',
  },
  {
    name: 'JACKSONVILLE UNIVERSITY',
    address: '2800 UNIVERSITY BLVD N',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32211,
    telephone: '(904) 256-8000',
    population: 4740,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ju.edu/index.php',
  },
  {
    name: 'PARIS JUNIOR COLLEGE',
    address: '2400 CLARKSVILLE ST',
    city: 'PARIS',
    state: 'TX',
    zip: 75460,
    telephone: '(903) 785-7661',
    population: 4740,
    county: 'LAMAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.parisjc.edu/',
  },
  {
    name: 'SPOKANE FALLS COMMUNITY COLLEGE',
    address: '3410 W FORT GEORGE WRIGHT DR',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99224,
    telephone: '(509) 533-3500',
    population: 4746,
    county: 'SPOKANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://sfcc.spokane.edu/',
  },
  {
    name: 'ANDERSON UNIVERSITY',
    address: '316 BOULEVARD',
    city: 'ANDERSON',
    state: 'SC',
    zip: 29621,
    telephone: '(864) 231-2000',
    population: 4760,
    county: 'ANDERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.andersonuniversity.edu/',
  },
  {
    name: 'FRANCIS MARION UNIVERSITY',
    address: '4822 EAST PALMETTO STREET',
    city: 'FLORENCE',
    state: 'SC',
    zip: 29506,
    telephone: '(843) 661-1362',
    population: 4764,
    county: 'FLORENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fmarion.edu/',
  },
  {
    name: 'UNIVERSIDAD POLITECNICA DE PUERTO RICO',
    address: '377 PONCE DE LEON AVE',
    city: 'HATO REY',
    state: 'PR',
    zip: 919,
    telephone: '(787) 622-8000',
    population: 4772,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pupr.edu/',
  },
  {
    name: 'CENTRAL LAKES COLLEGE-BRAINERD',
    address: '501 WEST COLLEGE DRIVE',
    city: 'BRAINERD',
    state: 'MN',
    zip: 56401,
    telephone: '(218) 855-8000',
    population: 4772,
    county: 'CROW WING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clcmn.edu/',
  },
  {
    name: 'BALTIMORE CITY COMMUNITY COLLEGE',
    address: '2901 LIBERTY HEIGHTS AVENUE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21215,
    telephone: '(410) 462-8300',
    population: 4785,
    county: 'BALTIMORE CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bccc.edu/',
  },
  {
    name: 'CROWDER COLLEGE',
    address: '601 LACLEDE AVE',
    city: 'NEOSHO',
    state: 'MO',
    zip: 64850,
    telephone: '(417) 451-3223',
    population: 4789,
    county: 'NEWTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.crowder.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-VIRGINIA',
    address: '2121 15TH STREET N',
    city: 'ARLINGTON',
    state: 'VA',
    zip: 22201,
    telephone: '(877) 445-7180',
    population: 4797,
    county: 'ARLINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/virginia/arlington',
  },
  {
    name: 'ATHENS TECHNICAL COLLEGE',
    address: '800 U.S. HWY 29 NORTH',
    city: 'ATHENS',
    state: 'GA',
    zip: 30601,
    telephone: '(706) 355-5000',
    population: 4800,
    county: 'CLARKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.athenstech.edu/',
  },
  {
    name: 'CHAMPLAIN COLLEGE',
    address: '163 S WILLARD ST',
    city: 'BURLINGTON',
    state: 'VT',
    zip: 5401,
    telephone: '(802) 860-2700',
    population: 4801,
    county: 'CHITTENDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.champlain.edu/',
  },
  {
    name: 'CENTRAL OREGON COMMUNITY COLLEGE',
    address: '2600 NW COLLEGE WAY',
    city: 'BEND',
    state: 'OR',
    zip: 97703,
    telephone: '(541) 383-7500',
    population: 4801,
    county: 'DESCHUTES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cocc.edu/',
  },
  {
    name: 'WOODLAND COMMUNITY COLLEGE',
    address: '2300 E GIBSON RD',
    city: 'WOODLAND',
    state: 'CA',
    zip: 95776,
    telephone: '(530) 661-5700',
    population: 4807,
    county: 'YOLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://wcc.yccd.edu/',
  },
  {
    name: 'UNIVERSITY OF BRIDGEPORT',
    address: '126 PARK AVENUE',
    city: 'BRIDGEPORT',
    state: 'CT',
    zip: 6604,
    telephone: '(203) 576-4000',
    population: 4811,
    county: 'FAIRFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bridgeport.edu/',
  },
  {
    name: 'NORWICH UNIVERSITY',
    address: '158 HARMON DRIVE',
    city: 'NORTHFIELD',
    state: 'VT',
    zip: 5663,
    telephone: '(802) 485-2000',
    population: 4817,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.norwich.edu/',
  },
  {
    name: 'NORWALK COMMUNITY COLLEGE',
    address: '188 RICHARDS AVENUE',
    city: 'NORWALK',
    state: 'CT',
    zip: 6854,
    telephone: '(203) 857-7000',
    population: 4818,
    county: 'FAIRFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://norwalk.edu/',
  },
  {
    name: 'HAWAII PACIFIC UNIVERSITY',
    address: '1 ALOHA TOWER DRIVE',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96813,
    telephone: '(808) 544-0200',
    population: 4842,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.hpu.edu/',
  },
  {
    name: 'COLLEGE OF THE MAINLAND',
    address: '1200 AMBURN ROAD',
    city: 'TEXAS CITY',
    state: 'TX',
    zip: 77591,
    telephone: '(409) 938-1211',
    population: 4854,
    county: 'GALVESTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.com.edu/',
  },
  {
    name: 'MANHATTAN COLLEGE',
    address: '4513 MANHATTAN COLLEGE PARKWAY',
    city: 'RIVERDALE',
    state: 'NY',
    zip: 10471,
    telephone: '(718) 862-7597',
    population: 4863,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.manhattan.edu/',
  },
  {
    name: 'UNIVERSITY OF THE DISTRICT OF COLUMBIA',
    address: '4200 CONNECTICUT AVE NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20008,
    telephone: '(202) 274-5000',
    population: 4864,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.udc.edu/',
  },
  {
    name: 'ROBERT MORRIS UNIVERSITY',
    address: '6001 UNIVERSITY BOULEVARD',
    city: 'MOON TOWNSHIP',
    state: 'PA',
    zip: 15108,
    telephone: '(412) 397-3000',
    population: 4867,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rmu.edu/',
  },
  {
    name: 'YORK COLLEGE OF PENNSYLVANIA',
    address: '441 COUNTRY CLUB RD',
    city: 'YORK',
    state: 'PA',
    zip: 17403,
    telephone: '(717) 846-7788',
    population: 4870,
    county: 'YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ycp.edu/',
  },
  {
    name: 'SUNY AT FREDONIA',
    address: '280 CENTRAL AVE',
    city: 'FREDONIA',
    state: 'NY',
    zip: 14063,
    telephone: '(716) 673-3111',
    population: 4883,
    county: 'CHAUTAUQUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fredonia.edu/',
  },
  {
    name: 'CLARKSON UNIVERSITY',
    address: '8 CLARKSON AVE',
    city: 'POTSDAM',
    state: 'NY',
    zip: 13699,
    telephone: '(315) 268-6400',
    population: 4891,
    county: 'ST. LAWRENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.clarkson.edu/',
  },
  {
    name: 'GAVILAN COLLEGE',
    address: '5055 SANTA TERESA BLVD',
    city: 'GILROY',
    state: 'CA',
    zip: 95020,
    telephone: '(408) 848-4800',
    population: 4892,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.gavilan.edu/',
  },
  {
    name: 'SOUTHERN ARKANSAS UNIVERSITY MAIN CAMPUS',
    address: '100 E. UNIVERSITY',
    city: 'MAGNOLIA',
    state: 'AR',
    zip: 71753,
    telephone: '(870) 235-4000',
    population: 4894,
    county: 'COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.saumag.edu/',
  },
  {
    name: 'MIDWESTERN UNIVERSITY-GLENDALE',
    address: '19555 N 59TH AVE',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85308,
    telephone: '(623) 572-3200',
    population: 4895,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.midwestern.edu/',
  },
  {
    name: 'EDINBORO UNIVERSITY OF PENNSYLVANIA',
    address: '219 MEADVILLE STREET',
    city: 'EDINBORO',
    state: 'PA',
    zip: 16444,
    telephone: '(814) 732-2000',
    population: 4904,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.edinboro.edu/',
  },
  {
    name: 'NORTHEAST IOWA COMMUNITY COLLEGE',
    address: '1625 HWY 150',
    city: 'CALMAR',
    state: 'IA',
    zip: 52132,
    telephone: '(844) 642-2338',
    population: 4905,
    county: 'WINNESHIEK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nicc.edu/',
  },
  {
    name: 'WESTMORELAND COUNTY COMMUNITY COLLEGE',
    address: '145 PAVILION LANE',
    city: 'YOUNGWOOD',
    state: 'PA',
    zip: 15697,
    telephone: '(724) 925-4077',
    population: 4909,
    county: 'WESTMORELAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://westmoreland.edu/',
  },
  {
    name: 'ATLANTIC CAPE COMMUNITY COLLEGE',
    address: '5100 BLACK HORSE PIKE',
    city: 'MAYS LANDING',
    state: 'NJ',
    zip: 8330,
    telephone: '(609) 625-1111',
    population: 4911,
    county: 'ATLANTIC',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.atlantic.edu/',
  },
  {
    name: 'JONES COUNTY JUNIOR COLLEGE',
    address: '900 SOUTH COURT STREET',
    city: 'ELLISVILLE',
    state: 'MS',
    zip: 39437,
    telephone: '(601) 477-4000',
    population: 4916,
    county: 'JONES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jcjc.edu/',
  },
  {
    name: 'GULF COAST STATE COLLEGE',
    address: '5230 WEST U.S. HIGHWAY 98',
    city: 'PANAMA CITY',
    state: 'FL',
    zip: 32401,
    telephone: '(850) 769-1551',
    population: 4921,
    county: 'BAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.gulfcoast.edu/default.htm',
  },
  {
    name: 'UNIVERSITY OF BALTIMORE',
    address: 'CHARLES AT MOUNT ROYAL',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21201,
    telephone: '(410) 837-4200',
    population: 4930,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ubalt.edu/',
  },
  {
    name: 'CALIFORNIA LUTHERAN UNIVERSITY',
    address: '60 W OLSEN RD',
    city: 'THOUSAND OAKS',
    state: 'CA',
    zip: 91360,
    telephone: '(805) 492-2411',
    population: 4942,
    county: 'VENTURA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.callutheran.edu/',
  },
  {
    name: 'THE SOUTHERN BAPTIST THEOLOGICAL SEMINARY',
    address: '2825 LEXINGTON RD',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40280,
    telephone: '(800) 626-5525',
    population: 4949,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sbts.edu/',
  },
  {
    name: 'HEARTLAND COMMUNITY COLLEGE',
    address: '1500 WEST RAAB ROAD',
    city: 'NORMAL',
    state: 'IL',
    zip: 61761,
    telephone: '(309) 268-8000',
    population: 4961,
    county: 'MCLEAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.heartland.edu/',
  },
  {
    name: 'MANCHESTER COMMUNITY COLLEGE',
    address: 'GREAT PATH',
    city: 'MANCHESTER',
    state: 'CT',
    zip: 6040,
    telephone: '(860) 512-3000',
    population: 4969,
    county: 'HARTFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.manchestercc.edu/',
  },
  {
    name: 'HOLYOKE COMMUNITY COLLEGE',
    address: '303 HOMESTEAD AVE',
    city: 'HOLYOKE',
    state: 'MA',
    zip: 1040,
    telephone: '(413) 552-2000',
    population: 4969,
    county: 'HAMPDEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hcc.edu/',
  },
  {
    name: 'NIAGARA COUNTY COMMUNITY COLLEGE',
    address: '3111 SAUNDERS SETTLEMENT RD',
    city: 'SANBORN',
    state: 'NY',
    zip: 14132,
    telephone: '(716) 614-6222',
    population: 4974,
    county: 'NIAGARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.niagaracc.suny.edu/',
  },
  {
    name: 'ALABAMA STATE UNIVERSITY',
    address: '915 S JACKSON STREET',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36104,
    telephone: '(334) 229-4100',
    population: 4991,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.alasu.edu/',
  },
  {
    name: 'JOHNSTON COMMUNITY COLLEGE',
    address: '245 COLLEGE ROAD',
    city: 'SMITHFIELD',
    state: 'NC',
    zip: 27577,
    telephone: '(919) 934-3051',
    population: 4991,
    county: 'JOHNSTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.johnstoncc.edu/',
  },
  {
    name: 'COLLEGE OF MARIN',
    address: '835 COLLEGE AVE',
    city: 'KENTFIELD',
    state: 'CA',
    zip: 94904,
    telephone: '(415) 457-8811',
    population: 4992,
    county: 'MARIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.marin.edu/',
  },
  {
    name: 'EASTERN ARIZONA COLLEGE',
    address: '615 N. STADIUM AVE.',
    city: 'THATCHER',
    state: 'AZ',
    zip: 85552,
    telephone: '(928) 428-8272',
    population: 4996,
    county: 'GRAHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eac.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-PARKSIDE',
    address: '900 WOOD RD',
    city: 'KENOSHA',
    state: 'WI',
    zip: 53144,
    telephone: '(262) 595-2345',
    population: 4999,
    county: 'KENOSHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwp.edu/',
  },
  {
    name: 'UNIVERSITY OF ILLINOIS SPRINGFIELD',
    address: 'ONE UNIVERSITY PLAZA',
    city: 'SPRINGFIELD',
    state: 'IL',
    zip: 62703,
    telephone: '(217) 206-6600',
    population: 5004,
    county: 'SANGAMON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uis.edu/',
  },
  {
    name: 'LUZERNE COUNTY COMMUNITY COLLEGE',
    address: '1333 SOUTH PROSPECT STREET',
    city: 'NANTICOKE',
    state: 'PA',
    zip: 18634,
    telephone: '(570) 740-0200',
    population: 5019,
    county: 'LUZERNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.luzerne.edu/',
  },
  {
    name: 'VIRGINIA STATE UNIVERSITY',
    address: '1 HAYDEN DRIVE',
    city: 'PETERSBURG',
    state: 'VA',
    zip: 23806,
    telephone: '(804) 524-5000',
    population: 5023,
    county: 'CHESTERFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vsu.edu/',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY HEALTH SCIENCES CENTER-NEW ORLEANS',
    address: '433 BOLIVAR ST',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70112,
    telephone: '(504) 568-4808',
    population: 5025,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lsuhsc.edu/',
  },
  {
    name: 'UNIVERSITY OF PORTLAND',
    address: '5000 N WILLAMETTE BLVD',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97203,
    telephone: '(503) 943-8000',
    population: 5027,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.up.edu/',
  },
  {
    name: 'FRESNO PACIFIC UNIVERSITY',
    address: '1717 S CHESTNUT AVE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93702,
    telephone: '(559) 453-2000',
    population: 5038,
    county: 'FRESNO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fresno.edu/',
  },
  {
    name: 'SPRINGFIELD TECHNICAL COMMUNITY COLLEGE',
    address: '1 ARMORY SQ',
    city: 'SPRINGFIELD',
    state: 'MA',
    zip: 1105,
    telephone: '(413) 781-7822',
    population: 5038,
    county: 'HAMPDEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stcc.edu/',
  },
  {
    name: 'BUCKNELL UNIVERSITY',
    address: 'ONE DENT DRIVE',
    city: 'LEWISBURG',
    state: 'PA',
    zip: 17837,
    telephone: '(570) 577-2000',
    population: 5046,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bucknell.edu/',
  },
  {
    name: 'COMPTON COLLEGE',
    address: '1111 EAST ARTESIA BLVD.',
    city: 'COMPTON',
    state: 'CA',
    zip: 90221,
    telephone: '(310) 900-1600',
    population: 5054,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.compton.edu/',
  },
  {
    name: 'SHENANDOAH UNIVERSITY',
    address: '1460 UNIVERSITY DR',
    city: 'WINCHESTER',
    state: 'VA',
    zip: 22601,
    telephone: '(540) 665-4500',
    population: 5076,
    county: 'WINCHESTER CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.su.edu/',
  },
  {
    name: 'UNIVERSIDAD DEL SAGRADO CORAZON',
    address: 'CALLE ROSALES ESQ SAN ANTONIO PDA 26 1/2',
    city: 'SANTURCE',
    state: 'PR',
    zip: 907,
    telephone: '(787) 728-1515',
    population: 5086,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sagrado.edu/',
  },
  {
    name: 'LAKE SUPERIOR COLLEGE',
    address: '2101 TRINITY RD',
    city: 'DULUTH',
    state: 'MN',
    zip: 55811,
    telephone: '(800) 432-2884',
    population: 5104,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lsc.edu/',
  },
  {
    name: 'GANNON UNIVERSITY',
    address: '109 W SIXTH ST',
    city: 'ERIE',
    state: 'PA',
    zip: 16541,
    telephone: '(814) 871-7000',
    population: 5108,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gannon.edu/',
  },
  {
    name: 'UNIVERSITY OF TULSA',
    address: '800 SOUTH TUCKER DRIVE',
    city: 'TULSA',
    state: 'OK',
    zip: 74104,
    telephone: '(918) 631-2000',
    population: 5118,
    county: 'TULSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://utulsa.edu/',
  },
  {
    name: 'SOUTH PUGET SOUND COMMUNITY COLLEGE',
    address: '2011 MOTTMAN RD SW',
    city: 'OLYMPIA',
    state: 'WA',
    zip: 98512,
    telephone: '(360) 596-5200',
    population: 5123,
    county: 'THURSTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.spscc.edu/',
  },
  {
    name: 'LESLEY UNIVERSITY',
    address: '29 EVERETT ST',
    city: 'CAMBRIDGE',
    state: 'MA',
    zip: 2138,
    telephone: '(617) 868-9600',
    population: 5128,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lesley.edu/',
  },
  {
    name: 'GEORGE FOX UNIVERSITY',
    address: '414 N MERIDIAN ST',
    city: 'NEWBERG',
    state: 'OR',
    zip: 97132,
    telephone: '(503) 538-8383',
    population: 5128,
    county: 'YAMHILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.georgefox.edu/',
  },
  {
    name: 'CLARION UNIVERSITY OF PENNSYLVANIA',
    address: '840 WOOD STREET',
    city: 'CLARION',
    state: 'PA',
    zip: 16214,
    telephone: '(814) 393-2000',
    population: 5131,
    county: 'CLARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.clarion.edu/',
  },
  {
    name: 'BEMIDJI STATE UNIVERSITY',
    address: '1500 BIRCHMONT DR',
    city: 'BEMIDJI',
    state: 'MN',
    zip: 56601,
    telephone: '(800) 475-2001',
    population: 5137,
    county: 'BELTRAMI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bemidjistate.edu/',
  },
  {
    name: 'ORAL ROBERTS UNIVERSITY',
    address: '7777 S LEWIS AVE.',
    city: 'TULSA',
    state: 'OK',
    zip: 74171,
    telephone: '(918) 495-6161',
    population: 5137,
    county: 'TULSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'oru.edu/',
  },
  {
    name: 'LAKE ERIE COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '1858 W GRANDVIEW BLVD',
    city: 'ERIE',
    state: 'PA',
    zip: 16509,
    telephone: '(814) 866-6641',
    population: 5145,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lecom.edu/',
  },
  {
    name: 'LAKE-SUMTER STATE COLLEGE',
    address: '9501 US HWY 441',
    city: 'LEESBURG',
    state: 'FL',
    zip: 34788,
    telephone: '(352) 787-3747',
    population: 5145,
    county: 'LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lssc.edu/',
  },
  {
    name: 'GENESEE COMMUNITY COLLEGE',
    address: 'ONE COLLEGE RD',
    city: 'BATAVIA',
    state: 'NY',
    zip: 14020,
    telephone: '(585) 343-0055',
    population: 5153,
    county: 'GENESEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.genesee.edu/',
  },
  {
    name: 'TOMPKINS CORTLAND COMMUNITY COLLEGE',
    address: '170 NORTH ST',
    city: 'DRYDEN',
    state: 'NY',
    zip: 13053,
    telephone: '(607) 844-8211',
    population: 5154,
    county: 'TOMPKINS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tompkinscortland.edu/',
  },
  {
    name: 'WICHITA STATE UNIVERSITY-CAMPUS OF APPLIED SCIENCES AND TECHNOLOGY',
    address: '4004 N WEBB RD. BLDG 100',
    city: 'WICHITA',
    state: 'KS',
    zip: 67226,
    telephone: '(316) 677-9400',
    population: 5156,
    county: 'SEDGWICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wsutech.edu/',
  },
  {
    name: 'ST CATHERINE UNIVERSITY',
    address: '2004 RANDOLPH AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55105,
    telephone: '(651) 690-6000',
    population: 5163,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stkate.edu/',
  },
  {
    name: 'UNIVERSITY OF MARY WASHINGTON',
    address: '1301 COLLEGE AVE',
    city: 'FREDERICKSBURG',
    state: 'VA',
    zip: 22401,
    telephone: '(540) 654-1000',
    population: 5166,
    county: 'FREDERICKSBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umw.edu/',
  },
  {
    name: 'CEDARVILLE UNIVERSITY',
    address: '251 N. MAIN STREET',
    city: 'CEDARVILLE',
    state: 'OH',
    zip: 45314,
    telephone: '(937) 766-7700',
    population: 5166,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cedarville.edu/',
  },
  {
    name: 'PIEDMONT TECHNICAL COLLEGE',
    address: '620 NORTH EMERALD ROAD',
    city: 'GREENWOOD',
    state: 'SC',
    zip: 29646,
    telephone: '(864) 941-8324',
    population: 5183,
    county: 'GREENWOOD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ptc.edu/',
  },
  {
    name: 'CATAWBA VALLEY COMMUNITY COLLEGE',
    address: '2550 HWY 70 SE',
    city: 'HICKORY',
    state: 'NC',
    zip: 28602,
    telephone: '(828) 327-7000',
    population: 5195,
    county: 'CATAWBA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cvcc.edu/',
  },
  {
    name: 'DALTON STATE COLLEGE',
    address: '650 COLLEGE DRIVE',
    city: 'DALTON',
    state: 'GA',
    zip: 30720,
    telephone: '(706) 272-4436',
    population: 5197,
    county: 'WHITFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.daltonstate.edu/index.cms',
  },
  {
    name: 'WENTWORTH INSTITUTE OF TECHNOLOGY',
    address: '550 HUNTINGTON AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 989-4590',
    population: 5206,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://wit.edu/',
  },
  {
    name: 'PLYMOUTH STATE UNIVERSITY',
    address: '17 HIGH STREET',
    city: 'PLYMOUTH',
    state: 'NH',
    zip: 3264,
    telephone: '(603) 535-5000',
    population: 5215,
    county: 'GRAFTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plymouth.edu/',
  },
  {
    name: 'LEWIS AND CLARK COMMUNITY COLLEGE',
    address: '5800 GODFREY RD',
    city: 'GODFREY',
    state: 'IL',
    zip: 62035,
    telephone: '(618) 468-7000',
    population: 5215,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lc.edu/',
  },
  {
    name: 'INDIANA WESLEYAN UNIVERSITY-MARION',
    address: '4201 SOUTH WASHINGTON STREET',
    city: 'MARION',
    state: 'IN',
    zip: 46953,
    telephone: '(765) 674-6901',
    population: 5235,
    county: 'GRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.indwes.edu/',
  },
  {
    name: 'SCHOOL OF VISUAL ARTS',
    address: '209 E 23RD ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10010,
    telephone: '(212) 592-2000',
    population: 5247,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sva.edu/',
  },
  {
    name: 'ITAWAMBA COMMUNITY COLLEGE',
    address: '602 W HILL STREET',
    city: 'FULTON',
    state: 'MS',
    zip: 38843,
    telephone: '(601) 862-8000',
    population: 5251,
    county: 'ITAWAMBA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iccms.edu/',
  },
  {
    name: 'WESTERN TECHNICAL COLLEGE',
    address: '400 SEVENTH ST. NORTH',
    city: 'LA CROSSE',
    state: 'WI',
    zip: 54601,
    telephone: '(608) 785-9200',
    population: 5252,
    county: 'LA CROSSE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.westerntc.edu/',
  },
  {
    name: 'GEORGE C WALLACE STATE COMMUNITY COLLEGE-HANCEVILLE',
    address: '801 MAIN ST NW',
    city: 'HANCEVILLE',
    state: 'AL',
    zip: 35077,
    telephone: '(256) 352-8000',
    population: 5254,
    county: 'CULLMAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wallacestate.edu/',
  },
  {
    name: 'NORTHERN ESSEX COMMUNITY COLLEGE',
    address: '100 ELLIOTT STREET',
    city: 'HAVERHILL',
    state: 'MA',
    zip: 1830,
    telephone: '(978) 556-3000',
    population: 5282,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.necc.mass.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-SOUTHEAST',
    address: '4201 GRANT LINE RD',
    city: 'NEW ALBANY',
    state: 'IN',
    zip: 47150,
    telephone: '(812) 941-2333',
    population: 5293,
    county: 'FLOYD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ius.edu/',
  },
  {
    name: 'ENDICOTT COLLEGE',
    address: '376 HALE STREET',
    city: 'BEVERLY',
    state: 'MA',
    zip: 1915,
    telephone: '(978) 927-0585',
    population: 5294,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.endicott.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT STARK',
    address: '6000 FRANK AVE NW',
    city: 'CANTON',
    state: 'OH',
    zip: 44720,
    telephone: '(330) 499-9600',
    population: 5307,
    county: 'STARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kent.edu/stark',
  },
  {
    name: 'PIEDMONT VIRGINIA COMMUNITY COLLEGE',
    address: '501 COLLEGE DRIVE',
    city: 'CHARLOTTESVILLE',
    state: 'VA',
    zip: 22902,
    telephone: '(434) 977-3900',
    population: 5321,
    county: 'ALBEMARLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pvcc.edu/',
  },
  {
    name: 'WESTERN UNIVERSITY OF HEALTH SCIENCES',
    address: '309 E 2ND ST',
    city: 'POMONA',
    state: 'CA',
    zip: 91766,
    telephone: '(909) 623-6116',
    population: 5325,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westernu.edu/',
  },
  {
    name: 'NEW ENGLAND COLLEGE',
    address: '98 BRIDGE ST',
    city: 'HENNIKER',
    state: 'NH',
    zip: 3242,
    telephone: '(603) 428-2211',
    population: 5327,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nec.edu/',
  },
  {
    name: 'COLLEGE OF ALAMEDA',
    address: '555 RALPH APPEZZATO MEMORIAL PKY',
    city: 'ALAMEDA',
    state: 'CA',
    zip: 94501,
    telephone: '(510) 522-7221',
    population: 5329,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'alameda.peralta.edu/',
  },
  {
    name: 'TRUMAN STATE UNIVERSITY',
    address: '100 E NORMAL AVENUE',
    city: 'KIRKSVILLE',
    state: 'MO',
    zip: 63501,
    telephone: '(660) 785-4000',
    population: 5339,
    county: 'ADAIR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.truman.edu/',
  },
  {
    name: 'IOWA CENTRAL COMMUNITY COLLEGE',
    address: 'ONE TRITON CIRCLE',
    city: 'FORT DODGE',
    state: 'IA',
    zip: 50501,
    telephone: '(515) 576-7201 EXT 1148',
    population: 5345,
    county: 'WEBSTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iowacentral.edu/',
  },
  {
    name: 'UTICA COLLEGE',
    address: '1600 BURRSTONE RD',
    city: 'UTICA',
    state: 'NY',
    zip: 13502,
    telephone: '(315) 792-3111',
    population: 5353,
    county: 'ONEIDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.utica.edu/',
  },
  {
    name: 'OKLAHOMA STATE UNIVERSITY-OKLAHOMA CITY',
    address: '900 N PORTLAND',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73107,
    telephone: '(405) 947-4421',
    population: 5353,
    county: 'OKLAHOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.osuokc.edu/',
  },
  {
    name: 'WESTERN OREGON UNIVERSITY',
    address: '345 NORTH MONMOUTH AVE',
    city: 'MONMOUTH',
    state: 'OR',
    zip: 97361,
    telephone: '(503) 838-8000',
    population: 5358,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wou.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS-PULASKI TECHNICAL COLLEGE',
    address: '3000 W SCENIC DR',
    city: 'NORTH LITTLE ROCK',
    state: 'AR',
    zip: 72118,
    telephone: '(501) 812-2200',
    population: 5361,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'uaptc.edu/',
  },
  {
    name: 'LOYOLA UNIVERSITY NEW ORLEANS',
    address: '6363 SAINT CHARLES AVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70118,
    telephone: '(504) 865-2011',
    population: 5365,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.loyno.edu/',
  },
  {
    name: 'RUSH UNIVERSITY',
    address: '600 S. PAULINA ST. STE 440',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60612,
    telephone: '(312) 942-7100',
    population: 5365,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rushu.rush.edu/',
  },
  {
    name: 'MISSOURI BAPTIST UNIVERSITY',
    address: 'ONE COLLEGE PARK DR',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63141,
    telephone: '(877) 434-1115',
    population: 5365,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mobap.edu/',
  },
  {
    name: 'MOBERLY AREA COMMUNITY COLLEGE',
    address: '101 COLLEGE AVE',
    city: 'MOBERLY',
    state: 'MO',
    zip: 65270,
    telephone: '(660) 263-4100 EXT 11208',
    population: 5367,
    county: 'RANDOLPH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.macc.edu/',
  },
  {
    name: 'TEMPLE COLLEGE',
    address: '2600 S 1ST ST',
    city: 'TEMPLE',
    state: 'TX',
    zip: 76504,
    telephone: '(254) 298-8282',
    population: 5369,
    county: 'BELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.templejc.edu/',
  },
  {
    name: 'SOMERSET COMMUNITY COLLEGE',
    address: '808 MONTICELLO STREET',
    city: 'SOMERSET',
    state: 'KY',
    zip: 42501,
    telephone: '(877) 629-9722',
    population: 5370,
    county: 'PULASKI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://somerset.kctcs.edu/about/index.aspx',
  },
  {
    name: 'WEST KENTUCKY COMMUNITY AND TECHNICAL COLLEGE',
    address: '4810 ALBEN BARKLEY DRIVE',
    city: 'PADUCAH',
    state: 'KY',
    zip: 42002,
    telephone: '(270) 554-9200',
    population: 5377,
    county: 'MCCRACKEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://westkentucky.kctcs.edu/',
  },
  {
    name: 'GATEWAY COMMUNITY COLLEGE',
    address: '108 N. 40TH STREET',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85034,
    telephone: '(602) 392-5000',
    population: 5394,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gatewaycc.edu/',
  },
  {
    name: 'MISSISSIPPI COLLEGE',
    address: '200 SOUTH CAPITOL STREET',
    city: 'CLINTON',
    state: 'MS',
    zip: 39058,
    telephone: '(601) 925-3000',
    population: 5403,
    county: 'HINDS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mc.edu/',
  },
  {
    name: 'UNIVERSITY OF HOUSTON-VICTORIA',
    address: '3007 N. BEN WILSON',
    city: 'VICTORIA',
    state: 'TX',
    zip: 77901,
    telephone: '(361) 570-4848',
    population: 5416,
    county: 'VICTORIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uhv.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-RICHARD J DALEY COLLEGE',
    address: '7500 S PULASKI RD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60652,
    telephone: '(773) 838-7500',
    population: 5423,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ccc.edu/colleges/daley/pages/default.aspx',
  },
  {
    name: 'CERRO COSO COMMUNITY COLLEGE',
    address: '3000 COLLEGE HEIGHTS BLVD',
    city: 'RIDGECREST',
    state: 'CA',
    zip: 93555,
    telephone: '(760) 384-6100',
    population: 5425,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'cerrocoso.edu/',
  },
  {
    name: 'A T STILL UNIVERSITY OF HEALTH SCIENCES',
    address: '800 W JEFFERSON',
    city: 'KIRKSVILLE',
    state: 'MO',
    zip: 63501,
    telephone: '(660) 626-2121',
    population: 5433,
    county: 'ADAIR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atsu.edu/',
  },
  {
    name: 'LA SALLE UNIVERSITY',
    address: '1900 W OLNEY AVE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19141,
    telephone: '(215) 951-1000',
    population: 5440,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lasalle.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-NORTH CAROLINA',
    address: '4 COPLEY PKWY',
    city: 'MORRISVILLE',
    state: 'NC',
    zip: 27560,
    telephone: '(877) 445-7180',
    population: 5441,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations/north-carolina/research-triangle-park',
  },
  {
    name: 'MISSOURI WESTERN STATE UNIVERSITY',
    address: '4525 DOWNS DR',
    city: 'SAINT JOSEPH',
    state: 'MO',
    zip: 64507,
    telephone: '(816) 271-4200',
    population: 5448,
    county: 'BUCHANAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.missouriwestern.edu/',
  },
  {
    name: 'NAPA VALLEY COLLEGE',
    address: '2277 NAPA-VALLEJO HWY',
    city: 'NAPA',
    state: 'CA',
    zip: 94558,
    telephone: '(707) 256-7000',
    population: 5456,
    county: 'NAPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.napavalley.edu/',
  },
  {
    name: 'MIDLAND COLLEGE',
    address: '3600 N GARFIELD',
    city: 'MIDLAND',
    state: 'TX',
    zip: 79705,
    telephone: '(432) 685-4500',
    population: 5459,
    county: 'MIDLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.midland.edu/',
  },
  {
    name: 'DURHAM TECHNICAL COMMUNITY COLLEGE',
    address: '1637 LAWSON STREET',
    city: 'DURHAM',
    state: 'NC',
    zip: 27703,
    telephone: '(919) 536-7200',
    population: 5474,
    county: 'DURHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.durhamtech.edu/',
  },
  {
    name: 'STETSON UNIVERSITY',
    address: '421 N WOODLAND BLVD',
    city: 'DELAND',
    state: 'FL',
    zip: 32723,
    telephone: '(386) 822-7000',
    population: 5475,
    county: 'VOLUSIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stetson.edu/',
  },
  {
    name: 'YUBA COLLEGE',
    address: '2088 N BEALE RD',
    city: 'MARYSVILLE',
    state: 'CA',
    zip: 95901,
    telephone: '(530) 741-6700',
    population: 5477,
    county: 'YUBA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://yc.yccd.edu/',
  },
  {
    name: 'POINT LOMA NAZARENE UNIVERSITY',
    address: '3900 LOMALAND DR',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92106,
    telephone: '(619) 849-2200',
    population: 5491,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pointloma.edu/',
  },
  {
    name: 'CALIFORNIA INSTITUTE OF TECHNOLOGY',
    address: '1200 E CALIFORNIA BLVD',
    city: 'PASADENA',
    state: 'CA',
    zip: 91125,
    telephone: '(626) 395-6811',
    population: 5508,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.caltech.edu/',
  },
  {
    name: 'UNITED STATES NAVAL ACADEMY',
    address: '121 BLAKE ROAD',
    city: 'ANNAPOLIS',
    state: 'MD',
    zip: 21402,
    telephone: '(410) 293-1482',
    population: 5517,
    county: 'ANNE ARUNDEL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usna.edu/',
  },
  {
    name: 'SOUTHWESTERN OKLAHOMA STATE UNIVERSITY',
    address: '100 CAMPUS DR',
    city: 'WEATHERFORD',
    state: 'OK',
    zip: 73096,
    telephone: '(580) 772-6611',
    population: 5523,
    county: 'CUSTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.swosu.edu/',
  },
  {
    name: 'ROCHESTER COMMUNITY AND TECHNICAL COLLEGE',
    address: '851 30TH AVE SE',
    city: 'ROCHESTER',
    state: 'MN',
    zip: 55904,
    telephone: '(507) 285-7210',
    population: 5525,
    county: 'OLMSTED',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rctc.edu/',
  },
  {
    name: 'LINCOLN LAND COMMUNITY COLLEGE',
    address: '5250 SHEPHERD RD',
    city: 'SPRINGFIELD',
    state: 'IL',
    zip: 62794,
    telephone: '(217) 786-2200',
    population: 5528,
    county: 'SANGAMON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.llcc.edu/',
  },
  {
    name: 'HUTCHINSON COMMUNITY COLLEGE',
    address: '1300 N PLUM ST',
    city: 'HUTCHINSON',
    state: 'KS',
    zip: 67501,
    telephone: '(620) 665-3500',
    population: 5530,
    county: 'RENO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hutchcc.edu/',
  },
  {
    name: 'FRAMINGHAM STATE UNIVERSITY',
    address: '100 STATE STREET',
    city: 'FRAMINGHAM',
    state: 'MA',
    zip: 1701,
    telephone: '(508) 620-1220',
    population: 5540,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.framingham.edu/',
  },
  {
    name: 'CANADA COLLEGE',
    address: '4200 FARM HILL BLVD.',
    city: 'REDWOOD CITY',
    state: 'CA',
    zip: 94061,
    telephone: '(650) 306-3100',
    population: 5542,
    county: 'SAN MATEO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'canadacollege.edu/',
  },
  {
    name: 'THE UNIVERSITY OF FINDLAY',
    address: '1000 NORTH MAIN STREET',
    city: 'FINDLAY',
    state: 'OH',
    zip: 45840,
    telephone: '(419) 422-8313',
    population: 5548,
    county: 'HANCOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.findlay.edu/',
  },
  {
    name: 'PEARL RIVER COMMUNITY COLLEGE',
    address: '101 HWY 11 N',
    city: 'POPLARVILLE',
    state: 'MS',
    zip: 39470,
    telephone: '(601) 403-1000',
    population: 5565,
    county: 'PEARL RIVER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.prcc.edu/',
  },
  {
    name: 'ASHLAND UNIVERSITY',
    address: '401 COLLEGE AVENUE',
    city: 'ASHLAND',
    state: 'OH',
    zip: 44805,
    telephone: '(800) 882-1548',
    population: 5568,
    county: 'ASHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ashland.edu/',
  },
  {
    name: 'EASTERN CONNECTICUT STATE UNIVERSITY',
    address: '83 WINDHAM ST',
    city: 'WILLIMANTIC',
    state: 'CT',
    zip: 6226,
    telephone: '(860) 465-5000',
    population: 5587,
    county: 'WINDHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.easternct.edu/',
  },
  {
    name: 'HARDING UNIVERSITY',
    address: '915 E. MARKET AVE.',
    city: 'SEARCY',
    state: 'AR',
    zip: 72149,
    telephone: '(501) 279-4000',
    population: 5598,
    county: 'WHITE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.harding.edu/',
  },
  {
    name: 'LANIER TECHNICAL COLLEGE',
    address: '2535 LANIER TECH DRIVE',
    city: 'GAINESVILLE',
    state: 'GA',
    zip: 30507,
    telephone: '(770) 533-7000',
    population: 5615,
    county: 'HALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.laniertech.edu/',
  },
  {
    name: 'LOS ANGELES SOUTHWEST COLLEGE',
    address: '1600 W. IMPERIAL HWY.',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90047,
    telephone: '(323) 241-5225',
    population: 5618,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lasc.edu/',
  },
  {
    name: 'NORTH SHORE COMMUNITY COLLEGE',
    address: '1 FERNCROFT RD',
    city: 'DANVERS',
    state: 'MA',
    zip: 1923,
    telephone: '(978) 762-4000 EXT 4350',
    population: 5619,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northshore.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-SOUTH BEND',
    address: '1700 MISHAWAKA AVE',
    city: 'SOUTH BEND',
    state: 'IN',
    zip: 46615,
    telephone: '(574) 520-4872',
    population: 5635,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://iusb.edu/',
  },
  {
    name: 'NORTHEAST COMMUNITY COLLEGE',
    address: '801 E BENJAMIN',
    city: 'NORFOLK',
    state: 'NE',
    zip: 68702,
    telephone: '(402) 371-2020',
    population: 5648,
    county: 'MADISON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northeast.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF VERMONT',
    address: '660 ELM STREET',
    city: 'MONTPELIER',
    state: 'VT',
    zip: 5602,
    telephone: '(802) 828-4060',
    population: 5651,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccv.edu/',
  },
  {
    name: 'NORTHWEST FLORIDA STATE COLLEGE',
    address: '100 COLLEGE BOULEVARD',
    city: 'NICEVILLE',
    state: 'FL',
    zip: 32578,
    telephone: '(850) 678-5111',
    population: 5654,
    county: 'OKALOOSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nwfsc.edu/',
  },
  {
    name: 'DELAWARE STATE UNIVERSITY',
    address: '1200 N. DUPONT HIGHWAY',
    city: 'DOVER',
    state: 'DE',
    zip: 19901,
    telephone: '(302) 857-6060',
    population: 5657,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.desu.edu/',
  },
  {
    name: 'LONGWOOD UNIVERSITY',
    address: '201 HIGH ST',
    city: 'FARMVILLE',
    state: 'VA',
    zip: 23909,
    telephone: '(434) 395-2000',
    population: 5666,
    county: 'PRINCE EDWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.longwood.edu/',
  },
  {
    name: 'SOUTHERN CRESCENT TECHNICAL COLLEGE',
    address: '501 VARSITY RD',
    city: 'GRIFFIN',
    state: 'GA',
    zip: 30223,
    telephone: '(770) 229-3327',
    population: 5666,
    county: 'SPALDING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sctech.edu/',
  },
  {
    name: 'NORTH IDAHO COLLEGE',
    address: '1000 WEST GARDEN AVENUE',
    city: "COEUR D'ALENE",
    state: 'ID',
    zip: 83814,
    telephone: '(208) 769-3300',
    population: 5673,
    county: 'KOOTENAI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nic.edu/',
  },
  {
    name: 'GOVERNORS STATE UNIVERSITY',
    address: '1 UNIVERSITY PKY',
    city: 'UNIVERSITY PARK',
    state: 'IL',
    zip: 60484,
    telephone: '(708) 534-5000',
    population: 5685,
    county: 'WILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.govst.edu/',
  },
  {
    name: 'KILGORE COLLEGE',
    address: '1100 BROADWAY',
    city: 'KILGORE',
    state: 'TX',
    zip: 75662,
    telephone: '(903) 984-8531',
    population: 5699,
    county: 'GREGG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.kilgore.edu/',
  },
  {
    name: 'MISSOURI SOUTHERN STATE UNIVERSITY',
    address: '3950 E. NEWMAN ROAD',
    city: 'JOPLIN',
    state: 'MO',
    zip: 64801,
    telephone: '(866) 818-6778',
    population: 5711,
    county: 'JASPER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mssu.edu/',
  },
  {
    name: 'UNIVERSITY OF ST. AUGUSTINE FOR HEALTH SCIENCES',
    address: '700 WINDY POINT DRIVE',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92069,
    telephone: '(904) 826-0084',
    population: 5713,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usa.edu/',
  },
  {
    name: 'SUNY COLLEGE AT OLD WESTBURY',
    address: '223 STORE HILL RD',
    city: 'OLD WESTBURY',
    state: 'NY',
    zip: 11568,
    telephone: '(516) 876-3000',
    population: 5716,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oldwestbury.edu/',
  },
  {
    name: 'FROSTBURG STATE UNIVERSITY',
    address: '101 BRADDOCK ROAD',
    city: 'FROSTBURG',
    state: 'MD',
    zip: 21532,
    telephone: '(301) 687-4000',
    population: 5719,
    county: 'ALLEGANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.frostburg.edu/',
  },
  {
    name: 'ROOSEVELT UNIVERSITY',
    address: '430 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(312) 341-3500',
    population: 5724,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.roosevelt.edu/',
  },
  {
    name: 'WILKES UNIVERSITY',
    address: '84 WEST SOUTH STREET',
    city: 'WILKES-BARRE',
    state: 'PA',
    zip: 18766,
    telephone: '(570) 408-5000',
    population: 5729,
    county: 'LUZERNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wilkes.edu/',
  },
  {
    name: 'ROANE STATE COMMUNITY COLLEGE',
    address: '276 PATTON LANE',
    city: 'HARRIMAN',
    state: 'TN',
    zip: 37748,
    telephone: '(865) 354-3000',
    population: 5742,
    county: 'ROANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.roanestate.edu/',
  },
  {
    name: 'NORTH SEATTLE COLLEGE',
    address: '9600 COLLEGE WAY NORTH',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98103,
    telephone: '(206) 934-3600',
    population: 5745,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northseattle.edu/',
  },
  {
    name: 'PENNSYLVANIA COLLEGE OF TECHNOLOGY',
    address: 'ONE COLLEGE AVE',
    city: 'WILLIAMSPORT',
    state: 'PA',
    zip: 17701,
    telephone: '(570) 326-3761',
    population: 5754,
    county: 'LYCOMING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.pct.edu/',
  },
  {
    name: 'LINN-BENTON COMMUNITY COLLEGE',
    address: '6500 PACIFIC BLVD SW',
    city: 'ALBANY',
    state: 'OR',
    zip: 97321,
    telephone: '(541) 917-4999',
    population: 5755,
    county: 'LINN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.linnbenton.edu/',
  },
  {
    name: 'BELHAVEN UNIVERSITY',
    address: '1500 PEACHTREE ST',
    city: 'JACKSON',
    state: 'MS',
    zip: 39202,
    telephone: '(601) 968-5940',
    population: 5756,
    county: 'HINDS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.belhaven.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS MEDICAL BRANCH AT GALVESTON',
    address: '301 UNIVERSITY BLVD',
    city: 'GALVESTON',
    state: 'TX',
    zip: 77555,
    telephone: '(409) 772-1011',
    population: 5759,
    county: 'GALVESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.utmb.edu/',
  },
  {
    name: 'RIDER UNIVERSITY',
    address: '2083 LAWRENCE ROAD',
    city: 'LAWRENCEVILLE',
    state: 'NJ',
    zip: 8648,
    telephone: '(609) 896-5000',
    population: 5766,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rider.edu/',
  },
  {
    name: 'SOUTH SEATTLE COLLEGE',
    address: '6000 16TH AVE SW',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98106,
    telephone: '(206) 934-5300',
    population: 5771,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'southseattle.edu/',
  },
  {
    name: 'NAUGATUCK VALLEY COMMUNITY COLLEGE',
    address: '750 CHASE PARKWAY',
    city: 'WATERBURY',
    state: 'CT',
    zip: 6708,
    telephone: '(203) 575-8000',
    population: 5779,
    county: 'NEW HAVEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://nv.edu/',
  },
  {
    name: 'SUNY COLLEGE AT GENESEO',
    address: '1 COLLEGE CIRCLE',
    city: 'GENESEO',
    state: 'NY',
    zip: 14454,
    telephone: '(585) 245-5000',
    population: 5782,
    county: 'LIVINGSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.geneseo.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-HARRY S TRUMAN COLLEGE',
    address: '1145 W WILSON AVE.',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60640,
    telephone: '(773) 907-4000',
    population: 5784,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ccc.edu/colleges/truman/pages/default.aspx',
  },
  {
    name: 'UNIVERSITY OF REDLANDS',
    address: '1200 E. COLTON AVE',
    city: 'REDLANDS',
    state: 'CA',
    zip: 92373,
    telephone: '(909) 793-2121',
    population: 5788,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.redlands.edu/',
  },
  {
    name: 'SOUTHERN OREGON UNIVERSITY',
    address: '1250 SISKIYOU BLVD',
    city: 'ASHLAND',
    state: 'OR',
    zip: 97520,
    telephone: '(541) 552-7672',
    population: 5813,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sou.edu/',
  },
  {
    name: 'EASTERN NEW MEXICO UNIVERSITY-MAIN CAMPUS',
    address: 'ENMU STATION 2, 1500 S AVE K',
    city: 'PORTALES',
    state: 'NM',
    zip: 88130,
    telephone: '(575) 562-1011',
    population: 5825,
    county: 'ROOSEVELT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.enmu.edu/',
  },
  {
    name: 'KANSAS CITY KANSAS COMMUNITY COLLEGE',
    address: '7250 STATE AVE',
    city: 'KANSAS CITY',
    state: 'KS',
    zip: 66112,
    telephone: '(913) 334-1100',
    population: 5857,
    county: 'WYANDOTTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kckcc.edu/',
  },
  {
    name: 'ROGER WILLIAMS UNIVERSITY',
    address: 'ONE OLD FERRY ROAD',
    city: 'BRISTOL',
    state: 'RI',
    zip: 2809,
    telephone: '(401) 253-1040',
    population: 5862,
    county: 'BRISTOL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rwu.edu/',
  },
  {
    name: 'GRAMBLING STATE UNIVERSITY',
    address: '403 MAIN STREET',
    city: 'GRAMBLING',
    state: 'LA',
    zip: 71245,
    telephone: '(318) 247-3811',
    population: 5883,
    county: 'LINCOLN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gram.edu/',
  },
  {
    name: 'HAWKEYE COMMUNITY COLLEGE',
    address: '1501 E ORANGE RD',
    city: 'WATERLOO',
    state: 'IA',
    zip: 50701,
    telephone: '(319) 296-2320',
    population: 5901,
    county: 'BLACK HAWK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hawkeyecollege.edu/',
  },
  {
    name: 'OREGON INSTITUTE OF TECHNOLOGY',
    address: '3201 CAMPUS DRIVE',
    city: 'KLAMATH FALLS',
    state: 'OR',
    zip: 97601,
    telephone: '(541) 885-1000',
    population: 5904,
    county: 'KLAMATH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.oit.edu/',
  },
  {
    name: 'CLARK STATE COMMUNITY COLLEGE',
    address: '570 E LEFFEL LN',
    city: 'SPRINGFIELD',
    state: 'OH',
    zip: 45501,
    telephone: '(937) 325-0691',
    population: 5913,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.clarkstate.edu/',
  },
  {
    name: 'TEACHERS COLLEGE AT COLUMBIA UNIVERSITY',
    address: '525 W 120TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 678-3000',
    population: 5922,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tc.columbia.edu/',
  },
  {
    name: 'PROVIDENCE COLLEGE',
    address: '1 CUNNINGHAM SQUARE',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2918,
    telephone: '(401) 865-1000',
    population: 5923,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.providence.edu/',
  },
  {
    name: 'NORTHEAST STATE COMMUNITY COLLEGE',
    address: '2425 HWY 75',
    city: 'BLOUNTVILLE',
    state: 'TN',
    zip: 37617,
    telephone: '(423) 323-3191',
    population: 5938,
    county: 'SULLIVAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northeaststate.edu/',
  },
  {
    name: 'UNIVERSITY OF RICHMOND',
    address: '410 WESTHAMPTON WAY',
    city: 'UNIVERSITY OF RICHMOND',
    state: 'VA',
    zip: 23173,
    telephone: '(804) 289-8000',
    population: 5945,
    county: 'RICHMOND CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.richmond.edu/',
  },
  {
    name: 'DRAKE UNIVERSITY',
    address: '2507 UNIVERSITY AVENUE',
    city: 'DES MOINES',
    state: 'IA',
    zip: 50311,
    telephone: '(515) 271-2011',
    population: 5952,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.drake.edu/',
  },
  {
    name: 'LOMA LINDA UNIVERSITY',
    address: '11139 ANDERSON STREET',
    city: 'LOMA LINDA',
    state: 'CA',
    zip: 92350,
    telephone: '(909) 558-1000',
    population: 5959,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.llu.edu/index.html',
  },
  {
    name: 'SHORELINE COMMUNITY COLLEGE',
    address: '16101 GREENWOOD AVE N',
    city: 'SHORELINE',
    state: 'WA',
    zip: 98133,
    telephone: '(206) 546-4101',
    population: 5965,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.shoreline.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF FINANCIAL SERVICES',
    address: '630 ALLENDALE RD',
    city: 'KING OF PRUSSIA',
    state: 'PA',
    zip: 19406,
    telephone: '(610) 526-1000',
    population: 5969,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.theamericancollege.edu/',
  },
  {
    name: 'AUBURN UNIVERSITY AT MONTGOMERY',
    address: '7440 EAST DRIVE',
    city: 'MONTGOMERY',
    state: 'AL',
    zip: 36117,
    telephone: '(334) 244-3000',
    population: 5986,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aum.edu/',
  },
  {
    name: 'PRATT INSTITUTE-MAIN',
    address: '200 WILLOUGHBY AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11205,
    telephone: '(718) 636-3600',
    population: 5990,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pratt.edu/',
  },
  {
    name: 'LIPSCOMB UNIVERSITY',
    address: 'ONE UNIVERSITY PARK DRIVE',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37204,
    telephone: '(615) 966-1000',
    population: 6007,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lipscomb.edu/',
  },
  {
    name: 'CENTRAL CAROLINA COMMUNITY COLLEGE',
    address: '1105 KELLY DR',
    city: 'SANFORD',
    state: 'NC',
    zip: 27330,
    telephone: '(919) 775-5401',
    population: 6013,
    county: 'LEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cccc.edu/',
  },
  {
    name: "SAINT MARY'S UNIVERSITY OF MINNESOTA",
    address: '700 TERRACE HEIGHTS',
    city: 'WINONA',
    state: 'MN',
    zip: 55987,
    telephone: '(507) 457-1600',
    population: 6015,
    county: 'WINONA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smumn.edu/',
  },
  {
    name: 'UNIVERSITY OF SCRANTON',
    address: '800 LINDEN STREET',
    city: 'SCRANTON',
    state: 'PA',
    zip: 18510,
    telephone: '(570) 941-7400',
    population: 6017,
    county: 'LACKAWANNA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scranton.edu/',
  },
  {
    name: 'SUNY COLLEGE AT PLATTSBURGH',
    address: '101 BROAD STREET',
    city: 'PLATTSBURGH',
    state: 'NY',
    zip: 12901,
    telephone: '(518) 564-2000',
    population: 6024,
    county: 'CLINTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.plattsburgh.edu/',
  },
  {
    name: 'SUNY BROOME COMMUNITY COLLEGE',
    address: '907 UPPER FRONT STREET',
    city: 'BINGHAMTON',
    state: 'NY',
    zip: 13901,
    telephone: '(607) 778-5000',
    population: 6031,
    county: 'BROOME',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunybroome.edu/',
  },
  {
    name: 'WEATHERFORD COLLEGE',
    address: '225 COLLEGE PARK DRIVE',
    city: 'WEATHERFORD',
    state: 'TX',
    zip: 76086,
    telephone: '(800) 287-5471',
    population: 6045,
    county: 'PARKER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wc.edu/',
  },
  {
    name: 'CHRISTOPHER NEWPORT UNIVERSITY',
    address: '1 AVENUE OF THE ARTS',
    city: 'NEWPORT NEWS',
    state: 'VA',
    zip: 23606,
    telephone: '(757) 594-7000',
    population: 6051,
    county: 'NEWPORT NEWS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cnu.edu/',
  },
  {
    name: "ST. JOSEPH'S COLLEGE-NEW YORK",
    address: '245 CLINTON AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11205,
    telephone: '(718) 940-5300',
    population: 6051,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjcny.edu/',
  },
  {
    name: 'UNIVERSITY OF WASHINGTON-TACOMA CAMPUS',
    address: '1900 COMMERCE ST',
    city: 'TACOMA',
    state: 'WA',
    zip: 98402,
    telephone: '(253) 692-4400',
    population: 6056,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tacoma.uw.edu/',
  },
  {
    name: 'CUNY MEDGAR EVERS COLLEGE',
    address: '1650 BEDFORD AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11225,
    telephone: '(718) 270-4900',
    population: 6059,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ares.mec.cuny.edu/',
  },
  {
    name: 'HOLMES COMMUNITY COLLEGE',
    address: '#1 HILL ST',
    city: 'GOODMAN',
    state: 'MS',
    zip: 39079,
    telephone: '(662) 472-2312',
    population: 6064,
    county: 'HOLMES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.holmescc.edu/',
  },
  {
    name: 'HARFORD COMMUNITY COLLEGE',
    address: '401 THOMAS RUN RD',
    city: 'BEL AIR',
    state: 'MD',
    zip: 21015,
    telephone: '(443) 412-2000',
    population: 6070,
    county: 'HARFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.harford.edu/',
  },
  {
    name: 'LAKELAND COMMUNITY COLLEGE',
    address: '7700 CLOCKTOWER DRIVE',
    city: 'KIRTLAND',
    state: 'OH',
    zip: 44094,
    telephone: '(440) 525-7000',
    population: 6071,
    county: 'LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lakelandcc.edu/',
  },
  {
    name: 'PUEBLO COMMUNITY COLLEGE',
    address: '900 W ORMAN AVE',
    city: 'PUEBLO',
    state: 'CO',
    zip: 81004,
    telephone: '(719) 549-3200',
    population: 6072,
    county: 'PUEBLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pueblocc.edu/',
  },
  {
    name: 'WESTERN IOWA TECH COMMUNITY COLLEGE',
    address: '4647 STONE AVE',
    city: 'SIOUX CITY',
    state: 'IA',
    zip: 51102,
    telephone: '(712) 274-6400 EXT 1731',
    population: 6080,
    county: 'WOODBURY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.witcc.edu/',
  },
  {
    name: 'GASTON COLLEGE',
    address: '201 HWY 321 S',
    city: 'DALLAS',
    state: 'NC',
    zip: 28034,
    telephone: '(704) 922-6200',
    population: 6080,
    county: 'GASTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gaston.edu/',
  },
  {
    name: 'FINGER LAKES COMMUNITY COLLEGE',
    address: '3325 MARVIN SANDS DRIVE',
    city: 'CANANDAIGUA',
    state: 'NY',
    zip: 14424,
    telephone: '(585) 394-3500',
    population: 6116,
    county: 'ONTARIO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.flcc.edu/',
  },
  {
    name: 'WINSTON-SALEM STATE UNIVERSITY',
    address: '601 MARTIN LUTHER KING JR DR',
    city: 'WINSTON-SALEM',
    state: 'NC',
    zip: 27110,
    telephone: '(336) 750-2000',
    population: 6120,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wssu.edu/',
  },
  {
    name: 'NORTH HENNEPIN COMMUNITY COLLEGE',
    address: '7411 85TH AVE N',
    city: 'BROOKLYN PARK',
    state: 'MN',
    zip: 55445,
    telephone: '(763) 488-0391',
    population: 6141,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nhcc.edu/',
  },
  {
    name: 'SOUTHEASTERN OKLAHOMA STATE UNIVERSITY',
    address: '425 W UNIVERSITY BLVD',
    city: 'DURANT',
    state: 'OK',
    zip: 74701,
    telephone: '(580) 745-2000',
    population: 6164,
    county: 'BRYAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.se.edu/',
  },
  {
    name: 'MINNESOTA STATE COMMUNITY AND TECHNICAL COLLEGE',
    address: '1414 COLLEGE WAY',
    city: 'FERGUS FALLS',
    state: 'MN',
    zip: 56537,
    telephone: '(218) 736-1500',
    population: 6164,
    county: 'OTTER TAIL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.minnesota.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-SAINT PAUL',
    address: '1282 CONCORDIA AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55104,
    telephone: '(651) 641-8278',
    population: 6166,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csp.edu/',
  },
  {
    name: 'LOS ANGELES FILM SCHOOL',
    address: '6363 SUNSET BLVD',
    city: 'HOLLYWOOD',
    state: 'CA',
    zip: 90028,
    telephone: '(877) 952-3456',
    population: 6169,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lafilm.edu/',
  },
  {
    name: 'LINCOLN MEMORIAL UNIVERSITY',
    address: '6965 CUMBERLAND GAP PKWY',
    city: 'HARROGATE',
    state: 'TN',
    zip: 37752,
    telephone: '(423) 869-3611',
    population: 6171,
    county: 'CLAIBORNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lmunet.edu/',
  },
  {
    name: 'LEE UNIVERSITY',
    address: '1120 N OCOEE ST',
    city: 'CLEVELAND',
    state: 'TN',
    zip: 37311,
    telephone: '(423) 614-8000',
    population: 6180,
    county: 'BRADLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.leeuniversity.edu/',
  },
  {
    name: 'OLYMPIC COLLEGE',
    address: '1600 CHESTER AVE',
    city: 'BREMERTON',
    state: 'WA',
    zip: 98337,
    telephone: '(360) 792-6050',
    population: 6182,
    county: 'KITSAP',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.olympic.edu/',
  },
  {
    name: 'TRINITY VALLEY COMMUNITY COLLEGE',
    address: '100 CARDINAL DRIVE',
    city: 'ATHENS',
    state: 'TX',
    zip: 75751,
    telephone: '(903) 675-6200',
    population: 6188,
    county: 'HENDERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tvcc.edu/',
  },
  {
    name: 'GEORGIA HIGHLANDS COLLEGE',
    address: '3175 CEDARTOWN HIGHWAY, S.E.',
    city: 'ROME',
    state: 'GA',
    zip: 30161,
    telephone: '(800) 332-2406',
    population: 6195,
    county: 'FLOYD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.highlands.edu/',
  },
  {
    name: 'SAN JUAN COLLEGE',
    address: '4601 COLLEGE BLVD',
    city: 'FARMINGTON',
    state: 'NM',
    zip: 87402,
    telephone: '(505) 326-3311',
    population: 6203,
    county: 'SAN JUAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sanjuancollege.edu/',
  },
  {
    name: 'UNIVERSITY OF DETROIT MERCY',
    address: '4001 W MCNICHOLS RD',
    city: 'DETROIT',
    state: 'MI',
    zip: 48221,
    telephone: '(313) 993-1000',
    population: 6207,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.udmercy.edu/',
  },
  {
    name: 'BENTLEY UNIVERSITY',
    address: '175 FOREST ST',
    city: 'WALTHAM',
    state: 'MA',
    zip: 2452,
    telephone: '(781) 891-2000',
    population: 6212,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bentley.edu/',
  },
  {
    name: 'MINNESOTA STATE UNIVERSITY MOORHEAD',
    address: '1104 SEVENTH AVENUE SOUTH',
    city: 'MOORHEAD',
    state: 'MN',
    zip: 56563,
    telephone: '(800) 593-7246',
    population: 6222,
    county: 'CLAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mnstate.edu/',
  },
  {
    name: 'WESTERN CONNECTICUT STATE UNIVERSITY',
    address: '181 WHITE STREET',
    city: 'DANBURY',
    state: 'CT',
    zip: 6810,
    telephone: '(203) 837-8200',
    population: 6225,
    county: 'FAIRFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wcsu.edu/',
  },
  {
    name: 'COLORADO MOUNTAIN COLLEGE',
    address: '802 GRAND AVE.',
    city: 'GLENWOOD SPRINGS',
    state: 'CO',
    zip: 81601,
    telephone: '(800) 621-8559',
    population: 6230,
    county: 'GARFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'coloradomtn.edu/',
  },
  {
    name: 'WILLIAM CAREY UNIVERSITY',
    address: '710 WILLIAM CAREY PARKWAY',
    city: 'HATTIESBURG',
    state: 'MS',
    zip: 39401,
    telephone: '(601) 318-6051',
    population: 6244,
    county: 'FORREST',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wmcarey.edu/',
  },
  {
    name: 'VIRGINIA WESTERN COMMUNITY COLLEGE',
    address: '3094 COLONIAL AVE',
    city: 'ROANOKE',
    state: 'VA',
    zip: 24015,
    telephone: '(540) 857-8922',
    population: 6245,
    county: 'ROANOKE CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'virginiawestern.edu/',
  },
  {
    name: 'TRI-COUNTY TECHNICAL COLLEGE',
    address: '7900 U.S. HWY 76',
    city: 'PENDLETON',
    state: 'SC',
    zip: 29670,
    telephone: '(864) 646-8282',
    population: 6250,
    county: 'ANDERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.tctc.edu/',
  },
  {
    name: 'SAINT PAUL COLLEGE',
    address: '235 MARSHALL AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55102,
    telephone: '(651) 846-1600',
    population: 6259,
    county: 'RAMSEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.saintpaul.edu/',
  },
  {
    name: 'BRYANT & STRATTON COLLEGE-ONLINE',
    address: '200 REDTAIL RD',
    city: 'ORCHARD PARK',
    state: 'NY',
    zip: 14127,
    telephone: '(800) 836-5627',
    population: 6266,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.bryantstratton.edu/',
  },
  {
    name: 'SOUTH COLLEGE',
    address: '3904 LONAS ROAD',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37909,
    telephone: '(865) 251-1800',
    population: 6267,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.south.edu/',
  },
  {
    name: 'EDWARD VIA COLLEGE OF OSTEOPATHIC MEDICINE',
    address: '2265 KRAFT DR',
    city: 'BLACKSBURG',
    state: 'VA',
    zip: 24060,
    telephone: '(540) 231-4000',
    population: 6272,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vcom.edu/',
  },
  {
    name: 'ELIZABETHTOWN COMMUNITY AND TECHNICAL COLLEGE',
    address: '600 COLLEGE STREET RD',
    city: 'ELIZABETHTOWN',
    state: 'KY',
    zip: 42701,
    telephone: '(270) 769-2371',
    population: 6275,
    county: 'HARDIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://elizabethtown.kctcs.edu/',
  },
  {
    name: 'MERRIMACK COLLEGE',
    address: '315 TURNPIKE ST',
    city: 'NORTH ANDOVER',
    state: 'MA',
    zip: 1845,
    telephone: '(978) 837-5000',
    population: 6291,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.merrimack.edu/',
  },
  {
    name: 'MOLLOY COLLEGE',
    address: '1000 HEMPSTEAD AVE',
    city: 'ROCKVILLE CENTRE',
    state: 'NY',
    zip: 11571,
    telephone: '(516) 323-3000',
    population: 6297,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.molloy.edu/',
  },
  {
    name: 'CLACKAMAS COMMUNITY COLLEGE',
    address: '19600 MOLALLA AVE',
    city: 'OREGON CITY',
    state: 'OR',
    zip: 97045,
    telephone: '(503) 594-6000',
    population: 6318,
    county: 'CLACKAMAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clackamas.edu/',
  },
  {
    name: 'UNIVERSITY OF WEST ALABAMA',
    address: 'STATION ONE',
    city: 'LIVINGSTON',
    state: 'AL',
    zip: 35470,
    telephone: '(205) 652-3400',
    population: 6322,
    county: 'SUMTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwa.edu/',
  },
  {
    name: 'EMERSON COLLEGE',
    address: '120 BOYLSTON STREET',
    city: 'BOSTON',
    state: 'MA',
    zip: 2116,
    telephone: '(617) 824-8500',
    population: 6324,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emerson.edu/',
  },
  {
    name: 'ABILENE CHRISTIAN UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'ABILENE',
    state: 'TX',
    zip: 79699,
    telephone: '(325) 674-2000',
    population: 6335,
    county: 'TAYLOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.acu.edu/',
  },
  {
    name: 'WALTERS STATE COMMUNITY COLLEGE',
    address: '500 SOUTH DAVY CROCKETT PARKWAY',
    city: 'MORRISTOWN',
    state: 'TN',
    zip: 37813,
    telephone: '(423) 585-2600',
    population: 6347,
    county: 'HAMBLEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ws.edu/',
  },
  {
    name: 'MOHAWK VALLEY COMMUNITY COLLEGE',
    address: '1101 SHERMAN DR',
    city: 'UTICA',
    state: 'NY',
    zip: 13501,
    telephone: '(315) 792-5400',
    population: 6357,
    county: 'ONEIDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mvcc.edu/',
  },
  {
    name: 'PASSAIC COUNTY COMMUNITY COLLEGE',
    address: 'ONE COLLEGE BLVD',
    city: 'PATERSON',
    state: 'NJ',
    zip: 7505,
    telephone: '(973) 684-6800',
    population: 6359,
    county: 'PASSAIC',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pccc.edu/',
  },
  {
    name: 'SOUTH LOUISIANA COMMUNITY COLLEGE',
    address: '1101 BERTRAND DRIVE',
    city: 'LAFAYETTE',
    state: 'LA',
    zip: 70506,
    telephone: '(337) 521-9000',
    population: 6366,
    county: 'LAFAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.solacc.edu/',
  },
  {
    name: 'BERKELEY CITY COLLEGE',
    address: '2050 CENTER SREET',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94704,
    telephone: '(510) 981-2800',
    population: 6368,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.berkeleycitycollege.edu/wp/',
  },
  {
    name: 'MEDICAL UNIVERSITY OF SOUTH CAROLINA',
    address: '179 ASHLEY AVE',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29425,
    telephone: '(843) 792-2300',
    population: 6371,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://web.musc.edu/',
  },
  {
    name: 'SOUTHERN MAINE COMMUNITY COLLEGE',
    address: '2 FORT ROAD',
    city: 'SOUTH PORTLAND',
    state: 'ME',
    zip: 4106,
    telephone: '(207) 741-5500',
    population: 6388,
    county: 'CUMBERLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.smccme.edu/',
  },
  {
    name: 'LOYOLA UNIVERSITY MARYLAND',
    address: '4501 N CHARLES ST',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21210,
    telephone: '(410) 617-2000',
    population: 6416,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.loyola.edu/',
  },
  {
    name: 'WESTFIELD STATE UNIVERSITY',
    address: '577 WESTERN AVE',
    city: 'WESTFIELD',
    state: 'MA',
    zip: 1086,
    telephone: '(413) 572-5300',
    population: 6420,
    county: 'HAMPDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westfield.ma.edu/',
  },
  {
    name: 'COLUMBIA STATE COMMUNITY COLLEGE',
    address: '1665 HAMPSHIRE PIKE',
    city: 'COLUMBIA',
    state: 'TN',
    zip: 38401,
    telephone: '(931) 540-2730',
    population: 6421,
    county: 'MAURY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.columbiastate.edu/',
  },
  {
    name: 'PARKLAND COLLEGE',
    address: '2400 W BRADLEY AVE',
    city: 'CHAMPAIGN',
    state: 'IL',
    zip: 61821,
    telephone: '(217) 351-2200',
    population: 6422,
    county: 'CHAMPAIGN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.parkland.edu/',
  },
  {
    name: 'SNOW COLLEGE',
    address: '150 E COLLEGE AVE',
    city: 'EPHRAIM',
    state: 'UT',
    zip: 84627,
    telephone: '(435) 283-7000',
    population: 6441,
    county: 'SANPETE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.snow.edu/',
  },
  {
    name: 'UNITED STATES MILITARY ACADEMY',
    address: '646 SWIFT RD (ATTN: MASG)',
    city: 'WEST POINT',
    state: 'NY',
    zip: 10996,
    telephone: '(845) 938-4011',
    population: 6454,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westpoint.edu/',
  },
  {
    name: 'SOUTH UNIVERSITY-SAVANNAH ONLINE',
    address: '709 MALL BLVD',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31406,
    telephone: '(888) 444-3404',
    population: 6463,
    county: 'CHATHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southuniversity.edu/online#location=Online Programs',
  },
  {
    name: 'ROCK VALLEY COLLEGE',
    address: '3301 N MULFORD RD',
    city: 'ROCKFORD',
    state: 'IL',
    zip: 61114,
    telephone: '(815) 921-7821',
    population: 6476,
    county: 'WINNEBAGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rockvalleycollege.edu/',
  },
  {
    name: 'NORTHCENTRAL TECHNICAL COLLEGE',
    address: '1000 CAMPUS DR',
    city: 'WAUSAU',
    state: 'WI',
    zip: 54401,
    telephone: '(715) 675-3331',
    population: 6476,
    county: 'MARATHON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ntc.edu/',
  },
  {
    name: 'HIGHLINE COLLEGE',
    address: '2400 S 240TH ST',
    city: 'DES MOINES',
    state: 'WA',
    zip: 98198,
    telephone: '(206) 878-3710',
    population: 6486,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.highline.edu/',
  },
  {
    name: 'EAST STROUDSBURG UNIVERSITY OF PENNSYLVANIA',
    address: '200 PROSPECT STREET',
    city: 'EAST STROUDSBURG',
    state: 'PA',
    zip: 18301,
    telephone: '(570) 422-3117',
    population: 6488,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.esu.edu/',
  },
  {
    name: 'UNIVERSITY OF MASSACHUSETTS MEDICAL SCHOOL WORCESTER',
    address: '55 LAKE AVE NORTH',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1655,
    telephone: '(508) 856-8989',
    population: 6492,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umassmed.edu/',
  },
  {
    name: 'ALVIN COMMUNITY COLLEGE',
    address: '3110 MUSTANG RD',
    city: 'ALVIN',
    state: 'TX',
    zip: 77511,
    telephone: '(281) 756-3500',
    population: 6493,
    county: 'BRAZORIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alvincollege.edu/',
  },
  {
    name: 'BOSSIER PARISH COMMUNITY COLLEGE',
    address: '6220 EAST TEXAS',
    city: 'BOSSIER CITY',
    state: 'LA',
    zip: 71111,
    telephone: '(318) 678-6000',
    population: 6511,
    county: 'BOSSIER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bpcc.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS-FORT SMITH',
    address: '5210 GRAND AVE',
    city: 'FORT SMITH',
    state: 'AR',
    zip: 72913,
    telephone: '(479) 788-7000',
    population: 6533,
    county: 'SEBASTIAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uafs.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS PERMIAN BASIN',
    address: '4901 E UNIVERSITY',
    city: 'ODESSA',
    state: 'TX',
    zip: 79762,
    telephone: '(432) 552-2020',
    population: 6536,
    county: 'ECTOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utpb.edu/',
  },
  {
    name: 'CRAFTON HILLS COLLEGE',
    address: '11711 SAND CANYON ROAD',
    city: 'YUCAIPA',
    state: 'CA',
    zip: 92339,
    telephone: '(909) 794-2161',
    population: 6540,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.craftonhills.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-WISCONSIN',
    address: '12800 N LAKE SHORE DR',
    city: 'MEQUON',
    state: 'WI',
    zip: 53097,
    telephone: '(262) 243-5700',
    population: 6549,
    county: 'OZAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cuw.edu/',
  },
  {
    name: 'ST. THOMAS UNIVERSITY',
    address: '16401 NW 37TH AVE',
    city: 'MIAMI GARDENS',
    state: 'FL',
    zip: 33054,
    telephone: '(305) 625-6000',
    population: 6558,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stu.edu/',
  },
  {
    name: 'MERRITT COLLEGE',
    address: '12500 CAMPUS DR',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94619,
    telephone: '(510) 531-4911',
    population: 6562,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.merritt.edu/',
  },
  {
    name: 'EMPORIA STATE UNIVERSITY',
    address: '1 KELLOGG CIRCLE',
    city: 'EMPORIA',
    state: 'KS',
    zip: 66801,
    telephone: '(620) 341-1200',
    population: 6575,
    county: 'LYON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emporia.edu/',
  },
  {
    name: 'HIGH POINT UNIVERSITY',
    address: 'ONE UNIVERSITY PARKWAY',
    city: 'HIGH POINT',
    state: 'NC',
    zip: 27268,
    telephone: '(336) 841-9000',
    population: 6596,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.highpoint.edu/',
  },
  {
    name: 'WORCESTER STATE UNIVERSITY',
    address: '486 CHANDLER ST',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1602,
    telephone: '(508) 929-8000',
    population: 6599,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.worcester.edu/',
  },
  {
    name: 'IOWA WESTERN COMMUNITY COLLEGE',
    address: '2700 COLLEGE RD',
    city: 'COUNCIL BLUFFS',
    state: 'IA',
    zip: 51503,
    telephone: '(712) 325-3200',
    population: 6601,
    county: 'POTTAWATTAMIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.iwcc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-RIVER FALLS',
    address: '410 S 3RD ST',
    city: 'RIVER FALLS',
    state: 'WI',
    zip: 54022,
    telephone: '(715) 425-3911',
    population: 6602,
    county: 'PIERCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwrf.edu/',
  },
  {
    name: 'WINTHROP UNIVERSITY',
    address: '701 OAKLAND AVE',
    city: 'ROCK HILL',
    state: 'SC',
    zip: 29733,
    telephone: '(803) 323-2211',
    population: 6610,
    county: 'YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.winthrop.edu/',
  },
  {
    name: 'MOTT COMMUNITY COLLEGE',
    address: '1401 E COURT ST',
    city: 'FLINT',
    state: 'MI',
    zip: 48503,
    telephone: '(810) 762-0200',
    population: 6619,
    county: 'GENESEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mcc.edu/',
  },
  {
    name: 'MIDWESTERN STATE UNIVERSITY',
    address: '3410 TAFT BLVD',
    city: 'WICHITA FALLS',
    state: 'TX',
    zip: 76308,
    telephone: '(940) 397-4000',
    population: 6622,
    county: 'WICHITA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msutexas.edu/',
  },
  {
    name: 'GATEWAY COMMUNITY COLLEGE',
    address: '20 CHURCH STREET',
    city: 'NEW HAVEN',
    state: 'CT',
    zip: 6510,
    telephone: '(203) 285-2000',
    population: 6631,
    county: 'NEW HAVEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gatewayct.edu/',
  },
  {
    name: 'YAVAPAI COLLEGE',
    address: '1100 E SHELDON ST',
    city: 'PRESCOTT',
    state: 'AZ',
    zip: 86301,
    telephone: '(928) 445-7300',
    population: 6633,
    county: 'YAVAPAI',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.yc.edu/',
  },
  {
    name: 'CONTRA COSTA COLLEGE',
    address: '2600 MISSION BELL DR',
    city: 'SAN PABLO',
    state: 'CA',
    zip: 94806,
    telephone: '(510) 235-7800',
    population: 6645,
    county: 'CONTRA COSTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.contracosta.edu/',
  },
  {
    name: 'UNIVERSITY OF INDIANAPOLIS',
    address: '1400 E HANNA AVE',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46227,
    telephone: '(317) 788-3368',
    population: 6647,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uindy.edu/',
  },
  {
    name: 'MASSASOIT COMMUNITY COLLEGE',
    address: 'ONE MASSASOIT BOULEVARD',
    city: 'BROCKTON',
    state: 'MA',
    zip: 2302,
    telephone: '(508) 588-9100',
    population: 6647,
    county: 'PLYMOUTH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.massasoit.edu/',
  },
  {
    name: 'SEATTLE CENTRAL COLLEGE',
    address: '1701 BROADWAY AVENUE',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98122,
    telephone: '(206) 934-3800',
    population: 6656,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.seattlecentral.edu/',
  },
  {
    name: 'WHARTON COUNTY JUNIOR COLLEGE',
    address: '911 BOLING HWY',
    city: 'WHARTON',
    state: 'TX',
    zip: 77488,
    telephone: '(979) 532-4560',
    population: 6659,
    county: 'WHARTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wcjc.edu/',
  },
  {
    name: 'ROCKLAND COMMUNITY COLLEGE',
    address: '145 COLLEGE RD',
    city: 'SUFFERN',
    state: 'NY',
    zip: 10901,
    telephone: '(845) 574-4000',
    population: 6669,
    county: 'ROCKLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunyrockland.edu/',
  },
  {
    name: 'FAIRFIELD UNIVERSITY',
    address: '1073 N BENSON RD',
    city: 'FAIRFIELD',
    state: 'CT',
    zip: 6824,
    telephone: '(203) 254-4000',
    population: 6685,
    county: 'FAIRFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'fairfield.edu/',
  },
  {
    name: 'COLORADO STATE UNIVERSITY PUEBLO',
    address: '2200 BONFORTE BLVD',
    city: 'PUEBLO',
    state: 'CO',
    zip: 81001,
    telephone: '(719) 549-2100',
    population: 6718,
    county: 'PUEBLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csupueblo.edu/',
  },
  {
    name: 'FREDERICK COMMUNITY COLLEGE',
    address: '7932 OPOSSUMTOWN PIKE',
    city: 'FREDERICK',
    state: 'MD',
    zip: 21702,
    telephone: '(301) 846-2400',
    population: 6718,
    county: 'FREDERICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.frederick.edu/',
  },
  {
    name: 'ST CHARLES COMMUNITY COLLEGE',
    address: '4601 MID RIVERS MALL DR',
    city: 'COTTLEVILLE',
    state: 'MO',
    zip: 63376,
    telephone: '(636) 922-8000',
    population: 6721,
    county: 'ST. CHARLES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.stchas.edu/',
  },
  {
    name: 'RED ROCKS COMMUNITY COLLEGE',
    address: '13300 W SIXTH AVE',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80228,
    telephone: '(303) 914-6600',
    population: 6723,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rrcc.edu/',
  },
  {
    name: 'ITHACA COLLEGE',
    address: '953 DANBY ROAD',
    city: 'ITHACA',
    state: 'NY',
    zip: 14850,
    telephone: '(607) 274-3011',
    population: 6727,
    county: 'TOMPKINS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ithaca.edu/',
  },
  {
    name: 'CENTRAL COMMUNITY COLLEGE',
    address: '3134 WEST HWY 34',
    city: 'GRAND ISLAND',
    state: 'NE',
    zip: 68802,
    telephone: '(308) 398-4222',
    population: 6772,
    county: 'HALL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cccneb.edu/',
  },
  {
    name: 'TACOMA COMMUNITY COLLEGE',
    address: '6501 S 19TH ST',
    city: 'TACOMA',
    state: 'WA',
    zip: 98466,
    telephone: '(253) 566-5000',
    population: 6787,
    county: 'PIERCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.tacomacc.edu/',
  },
  {
    name: 'AIMS COMMUNITY COLLEGE',
    address: '5401 W. 20TH ST.',
    city: 'GREELEY',
    state: 'CO',
    zip: 80634,
    telephone: '(970) 330-8008',
    population: 6798,
    county: 'WELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aims.edu/',
  },
  {
    name: 'LEEWARD COMMUNITY COLLEGE',
    address: '96-045 ALA IKE',
    city: 'PEARL CITY',
    state: 'HI',
    zip: 96782,
    telephone: '(808) 455-0011',
    population: 6798,
    county: 'HONOLULU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.leeward.hawaii.edu/',
  },
  {
    name: 'BUTLER UNIVERSITY',
    address: '4600 SUNSET AVE',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46208,
    telephone: '(317) 940-8000',
    population: 6816,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.butler.edu/',
  },
  {
    name: 'BIOLA UNIVERSITY',
    address: '13800 BIOLA AVE',
    city: 'LA MIRADA',
    state: 'CA',
    zip: 90639,
    telephone: '(562) 903-6000',
    population: 6819,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.biola.edu/',
  },
  {
    name: 'COLLEGE OF CENTRAL FLORIDA',
    address: '3001 SW COLLEGE RD',
    city: 'OCALA',
    state: 'FL',
    zip: 34474,
    telephone: '(352) 873-5800',
    population: 6829,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cf.edu/',
  },
  {
    name: 'LEHIGH CARBON COMMUNITY COLLEGE',
    address: '4525 EDUCATION PARK DR',
    city: 'SCHNECKSVILLE',
    state: 'PA',
    zip: 18078,
    telephone: '(610) 799-2121',
    population: 6831,
    county: 'LEHIGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lccc.edu/',
  },
  {
    name: 'WASHBURN UNIVERSITY',
    address: '1700 SW COLLEGE AVENUE',
    city: 'TOPEKA',
    state: 'KS',
    zip: 66621,
    telephone: '(785) 670-1010',
    population: 6833,
    county: 'SHAWNEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.washburn.edu/',
  },
  {
    name: 'THOMAS NELSON COMMUNITY COLLEGE',
    address: '99 THOMAS NELSON DRIVE',
    city: 'HAMPTON',
    state: 'VA',
    zip: 23666,
    telephone: '(757) 825-2700',
    population: 6834,
    county: 'HAMPTON CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://tncc.edu/',
  },
  {
    name: 'JOHNSON & WALES UNIVERSITY-PROVIDENCE',
    address: '8 ABBOTT PARK PLACE',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2903,
    telephone: '(401) 598-1000',
    population: 6862,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jwu.edu/campuses/providence/index.html',
  },
  {
    name: 'BRADLEY UNIVERSITY',
    address: '1501 W BRADLEY AVE',
    city: 'PEORIA',
    state: 'IL',
    zip: 61625,
    telephone: '(309) 676-7611',
    population: 6869,
    county: 'PEORIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bradley.edu/',
  },
  {
    name: 'KAPIOLANI COMMUNITY COLLEGE',
    address: '4303 DIAMOND HEAD ROAD',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96816,
    telephone: '(808) 734-9000',
    population: 6879,
    county: 'HONOLULU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.kapiolani.hawaii.edu/',
  },
  {
    name: 'ORANGE COUNTY COMMUNITY COLLEGE',
    address: '115 SOUTH ST',
    city: 'MIDDLETOWN',
    state: 'NY',
    zip: 10940,
    telephone: '(845) 344-6222',
    population: 6881,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://sunyorange.edu/',
  },
  {
    name: 'LORD FAIRFAX COMMUNITY COLLEGE',
    address: '173 SKIRMISHER LANE',
    city: 'MIDDLETOWN',
    state: 'VA',
    zip: 22645,
    telephone: '(800) 906-5322',
    population: 6894,
    county: 'FREDERICK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lfcc.edu/',
  },
  {
    name: 'ALABAMA A & M UNIVERSITY',
    address: '4900 MERIDIAN STREET',
    city: 'NORMAL',
    state: 'AL',
    zip: 35762,
    telephone: '(256) 372-5000',
    population: 6895,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aamu.edu/',
  },
  {
    name: 'SAMFORD UNIVERSITY',
    address: '800 LAKESHORE DRIVE',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35229,
    telephone: '(205) 726-2011',
    population: 6898,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.samford.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-UPSTATE',
    address: '800 UNIVERSITY WAY',
    city: 'SPARTANBURG',
    state: 'SC',
    zip: 29303,
    telephone: '(864) 503-5000',
    population: 6908,
    county: 'SPARTANBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uscupstate.edu/',
  },
  {
    name: 'SHIPPENSBURG UNIVERSITY OF PENNSYLVANIA',
    address: '1871 OLD MAIN DRIVE',
    city: 'SHIPPENSBURG',
    state: 'PA',
    zip: 17257,
    telephone: '(717) 477-7447',
    population: 6921,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ship.edu/',
  },
  {
    name: 'MINNEAPOLIS COMMUNITY AND TECHNICAL COLLEGE',
    address: '1501 HENNEPIN AVE',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55403,
    telephone: '(612) 659-6000',
    population: 6927,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.minneapolis.edu/',
  },
  {
    name: 'SOUTHWEST TEXAS JUNIOR COLLEGE',
    address: '2401 GARNER FIELD RD',
    city: 'UVALDE',
    state: 'TX',
    zip: 78801,
    telephone: '(830) 278-4401',
    population: 6939,
    county: 'UVALDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.swtjc.net/',
  },
  {
    name: 'MISSION COLLEGE',
    address: '3000 MISSION COLLEGE BLVD',
    city: 'SANTA CLARA',
    state: 'CA',
    zip: 95054,
    telephone: '(408) 855-5007',
    population: 6946,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.missioncollege.edu/',
  },
  {
    name: 'RAMAPO COLLEGE OF NEW JERSEY',
    address: '505 RAMAPO VALLEY RD',
    city: 'MAHWAH',
    state: 'NJ',
    zip: 7430,
    telephone: '(201) 684-7500 EXT 7500',
    population: 6947,
    county: 'BERGEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ramapo.edu/',
  },
  {
    name: 'HORRY-GEORGETOWN TECHNICAL COLLEGE',
    address: '2050 HIGHWAY 501 EAST',
    city: 'CONWAY',
    state: 'SC',
    zip: 29526,
    telephone: '(843) 347-3186',
    population: 6966,
    county: 'HORRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hgtc.edu/',
  },
  {
    name: 'ROWAN COLLEGE OF SOUTH JERSEY GLOUCESTER CAMPUS',
    address: '1400 TANYARD ROAD',
    city: 'SEWELL',
    state: 'NJ',
    zip: 8080,
    telephone: '(856) 468-5000',
    population: 6971,
    county: 'GLOUCESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rcsj.edu/',
  },
  {
    name: 'GRANTHAM UNIVERSITY',
    address: '16025 WEST 113TH STREET',
    city: 'LENEXA',
    state: 'KS',
    zip: 66219,
    telephone: '(800) 955-2527',
    population: 6988,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.grantham.edu/',
  },
  {
    name: 'NORTHEAST LAKEVIEW COLLEGE',
    address: '1201 KITTY HAWK RD',
    city: 'UNIVERSAL CITY',
    state: 'TX',
    zip: 78145,
    telephone: '(210) 486-5000',
    population: 6990,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alamo.edu/nlc',
  },
  {
    name: 'COLLEGE OF SOUTHERN MARYLAND',
    address: '8730 MITCHELL RD',
    city: 'LA PLATA',
    state: 'MD',
    zip: 20646,
    telephone: '(301) 934-2251',
    population: 7002,
    county: 'CHARLES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.csmd.edu/',
  },
  {
    name: 'UNIVERSITY OF WASHINGTON-BOTHELL CAMPUS',
    address: '18115 CAMPUS WAY NE',
    city: 'BOTHELL',
    state: 'WA',
    zip: 98011,
    telephone: '(425) 352-5000',
    population: 7023,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwb.edu/',
  },
  {
    name: 'NORFOLK STATE UNIVERSITY',
    address: '700 PARK AVENUE',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23504,
    telephone: '(757) 823-8600',
    population: 7038,
    county: 'NORFOLK CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nsu.edu/',
  },
  {
    name: 'ESSEX COUNTY COLLEGE',
    address: '303 UNIVERSITY AVE',
    city: 'NEWARK',
    state: 'NJ',
    zip: 7102,
    telephone: '(973) 877-3000',
    population: 7043,
    county: 'ESSEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.essex.edu/',
  },
  {
    name: 'WEST GEORGIA TECHNICAL COLLEGE',
    address: '176 MURPHY CAMPUS BLVD.',
    city: 'WACO',
    state: 'GA',
    zip: 30182,
    telephone: '(770) 537-6000',
    population: 7057,
    county: 'HARALSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.westgatech.edu/',
  },
  {
    name: 'YESHIVA UNIVERSITY',
    address: '500 W 185TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10033,
    telephone: '(212) 960-5400',
    population: 7063,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.yu.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-HAROLD WASHINGTON COLLEGE',
    address: '30 E LAKE ST',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60601,
    telephone: '(312) 553-5600',
    population: 7092,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccc.edu/colleges/washington/Pages/default.aspx',
  },
  {
    name: 'MONMOUTH UNIVERSITY',
    address: '400 CEDAR AVE',
    city: 'WEST LONG BRANCH',
    state: 'NJ',
    zip: 7764,
    telephone: '(732) 571-3400',
    population: 7096,
    county: 'MONMOUTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.monmouth.edu/',
  },
  {
    name: 'MOTLOW STATE COMMUNITY COLLEGE',
    address: '6015 LEDFORD MILL ROAD',
    city: 'TULLAHOMA',
    state: 'TN',
    zip: 37388,
    telephone: '(931) 393-1500',
    population: 7109,
    county: 'MOORE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mscc.edu/',
  },
  {
    name: 'AURORA UNIVERSITY',
    address: '347 S GLADSTONE AVE',
    city: 'AURORA',
    state: 'IL',
    zip: 60506,
    telephone: '(630) 892-6431',
    population: 7131,
    county: 'KANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://aurora.edu/',
  },
  {
    name: 'UNIVERSITY OF NEBRASKA AT KEARNEY',
    address: '2504 9TH AVENUE',
    city: 'KEARNEY',
    state: 'NE',
    zip: 68849,
    telephone: '(308) 865-8441',
    population: 7139,
    county: 'BUFFALO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unk.edu/',
  },
  {
    name: 'DAVENPORT UNIVERSITY',
    address: '6191 KRAFT AVENUE S.E.',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49512,
    telephone: '(616) 698-7111',
    population: 7148,
    county: 'KENT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.davenport.edu/',
  },
  {
    name: 'MERCER COUNTY COMMUNITY COLLEGE',
    address: '1200 OLD TRENTON RD',
    city: 'WEST WINDSOR',
    state: 'NJ',
    zip: 8550,
    telephone: '(609) 586-4800',
    population: 7166,
    county: 'MERCER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mccc.edu/',
  },
  {
    name: 'CONCORDIA UNIVERSITY-CHICAGO',
    address: '7400 AUGUSTA',
    city: 'RIVER FOREST',
    state: 'IL',
    zip: 60305,
    telephone: '(708) 771-8300',
    population: 7174,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cuchicago.edu/',
  },
  {
    name: 'BOWIE STATE UNIVERSITY',
    address: '14000 JERICHO PARK RD',
    city: 'BOWIE',
    state: 'MD',
    zip: 20715,
    telephone: '(301) 860-4000',
    population: 7183,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bowiestate.edu/',
  },
  {
    name: 'THE CATHOLIC UNIVERSITY OF AMERICA',
    address: '620 MICHIGAN AVENUE, NE',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20064,
    telephone: '(202) 319-5000',
    population: 7186,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.catholic.edu/',
  },
  {
    name: 'BRISTOL COMMUNITY COLLEGE',
    address: '777 ELSBREE ST',
    city: 'FALL RIVER',
    state: 'MA',
    zip: 2720,
    telephone: '(774) 357-2811',
    population: 7190,
    county: 'BRISTOL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bristolcc.edu/',
  },
  {
    name: 'CUNY HOSTOS COMMUNITY COLLEGE',
    address: '500 GRAND CONCOURSE',
    city: 'BRONX',
    state: 'NY',
    zip: 10451,
    telephone: '(718) 518-4444',
    population: 7194,
    county: 'BRONX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hostos.cuny.edu/',
  },
  {
    name: 'GEORGIA NORTHWESTERN TECHNICAL COLLEGE',
    address: 'ONE MAURICE CULBERSON DRIVE',
    city: 'ROME',
    state: 'GA',
    zip: 30161,
    telephone: '(706) 295-6963',
    population: 7200,
    county: 'FLOYD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gntc.edu/',
  },
  {
    name: 'ALBANY STATE UNIVERSITY',
    address: '504 COLLEGE DRIVE',
    city: 'ALBANY',
    state: 'GA',
    zip: 31705,
    telephone: '(229) 500-3500',
    population: 7260,
    county: 'DOUGHERTY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.asurams.edu/',
  },
  {
    name: 'FRANKLIN UNIVERSITY',
    address: '201 S GRANT AVE',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43215,
    telephone: '(614) 797-4700',
    population: 7272,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.franklin.edu/',
  },
  {
    name: 'COLUMBIA BASIN COLLEGE',
    address: '2600 N 20TH AVE',
    city: 'PASCO',
    state: 'WA',
    zip: 99301,
    telephone: '(509) 547-0511',
    population: 7296,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.columbiabasin.edu/',
  },
  {
    name: 'CAMPBELL UNIVERSITY',
    address: '143 MAIN STREET',
    city: 'BUIES CREEK',
    state: 'NC',
    zip: 27506,
    telephone: '(800) 334-4111',
    population: 7300,
    county: 'HARNETT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.campbell.edu/',
  },
  {
    name: 'ARIZONA WESTERN COLLEGE',
    address: '2020 S. AVENUE 8E',
    city: 'YUMA',
    state: 'AZ',
    zip: 85365,
    telephone: '(928) 317-6000',
    population: 7317,
    county: 'YUMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.azwestern.edu/',
  },
  {
    name: 'OXNARD COLLEGE',
    address: '4000 S ROSE AVE',
    city: 'OXNARD',
    state: 'CA',
    zip: 93033,
    telephone: '(805) 986-5800',
    population: 7342,
    county: 'VENTURA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oxnardcollege.edu/',
  },
  {
    name: 'EDMONDS COLLEGE',
    address: '20000 68TH AVE W',
    city: 'LYNNWOOD',
    state: 'WA',
    zip: 98036,
    telephone: '(425) 640-1459',
    population: 7345,
    county: 'SNOHOMISH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.edcc.edu/',
  },
  {
    name: 'LEWIS UNIVERSITY',
    address: 'ONE UNIVERSITY PARKWAY',
    city: 'ROMEOVILLE',
    state: 'IL',
    zip: 60446,
    telephone: '(815) 838-0500',
    population: 7352,
    county: 'WILL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lewisu.edu/',
  },
  {
    name: 'PITTSBURG STATE UNIVERSITY',
    address: '1701 S BROADWAY',
    city: 'PITTSBURG',
    state: 'KS',
    zip: 66762,
    telephone: '(620) 231-7000',
    population: 7361,
    county: 'CRAWFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pittstate.edu/',
  },
  {
    name: 'REEDLEY COLLEGE',
    address: '995 N REED AVE',
    city: 'REEDLEY',
    state: 'CA',
    zip: 93654,
    telephone: '(559) 638-0300',
    population: 7365,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.reedleycollege.edu/',
  },
  {
    name: 'COASTAL ALABAMA COMMUNITY COLLEGE',
    address: '1900 U S HIGHWAY 31 SOUTH',
    city: 'BAY MINETTE',
    state: 'AL',
    zip: 36507,
    telephone: '(251) 580-2100',
    population: 7395,
    county: 'BALDWIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coastalalabama.edu/',
  },
  {
    name: 'MONROE COLLEGE',
    address: '2501 JEROME AVENUE',
    city: 'BRONX',
    state: 'NY',
    zip: 10468,
    telephone: '(718) 933-6700',
    population: 7410,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.monroecollege.edu/',
  },
  {
    name: 'ROSE STATE COLLEGE',
    address: '6420 S E 15TH',
    city: 'MIDWEST CITY',
    state: 'OK',
    zip: 73110,
    telephone: '(405) 733-7673',
    population: 7420,
    county: 'OKLAHOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rose.edu/',
  },
  {
    name: 'BRANDEIS UNIVERSITY',
    address: '415 SOUTH ST',
    city: 'WALTHAM',
    state: 'MA',
    zip: 2454,
    telephone: '(781) 736-2000',
    population: 7425,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.brandeis.edu/',
  },
  {
    name: 'PONTIFICAL CATHOLIC UNIVERSITY OF PUERTO RICO-PONCE',
    address: '2250 BOULEVARD LUIS A. FERRE AGUAYO SUITE 608',
    city: 'PONCE',
    state: 'PR',
    zip: 717,
    telephone: '(787) 841-2000 EXT 1002',
    population: 7430,
    county: 'PONCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pucpr.edu/',
  },
  {
    name: 'PARADISE VALLEY COMMUNITY COLLEGE',
    address: '18401 N 32ND ST',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85032,
    telephone: '(602) 787-6500',
    population: 7431,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.paradisevalley.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-GEORGIA',
    address: '3355 NORTHEAST EXPWY, STE 100',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30341,
    telephone: '(877) 445-7180',
    population: 7441,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/campus-locations',
  },
  {
    name: 'WIDENER UNIVERSITY',
    address: 'ONE UNIVERSITY PLACE',
    city: 'CHESTER',
    state: 'PA',
    zip: 19013,
    telephone: '(610) 499-4000',
    population: 7444,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.widener.edu/',
  },
  {
    name: 'COUNTY COLLEGE OF MORRIS',
    address: '214 CENTER GROVE RD',
    city: 'RANDOLPH',
    state: 'NJ',
    zip: 7869,
    telephone: '(973) 328-5000',
    population: 7445,
    county: 'MORRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccm.edu/',
  },
  {
    name: 'MT HOOD COMMUNITY COLLEGE',
    address: '26000 SE STARK ST',
    city: 'GRESHAM',
    state: 'OR',
    zip: 97030,
    telephone: '(503) 491-6422',
    population: 7459,
    county: 'MULTNOMAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mhcc.edu/',
  },
  {
    name: 'BETH MEDRASH GOVOHA',
    address: '617 6TH ST',
    city: 'LAKEWOOD',
    state: 'NJ',
    zip: 8701,
    telephone: '(732) 367-1060',
    population: 7460,
    county: 'OCEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'yeshivanotices.org/',
  },
  {
    name: 'TEXAS A&M UNIVERSITY-SAN ANTONIO',
    address: 'ONE UNIVERSITY WAY',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78224,
    telephone: '(210) 784-1000',
    population: 7479,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tamusa.edu/',
  },
  {
    name: 'SAINT JOHNS RIVER STATE COLLEGE',
    address: '5001 SAINT JOHNS AVE',
    city: 'PALATKA',
    state: 'FL',
    zip: 32177,
    telephone: '(386) 312-4200',
    population: 7492,
    county: 'PUTNAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjrstate.edu/',
  },
  {
    name: 'SIMMONS UNIVERSITY',
    address: '300 THE FENWAY',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 521-2000',
    population: 7499,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.simmons.edu/',
  },
  {
    name: 'FITCHBURG STATE UNIVERSITY',
    address: '160 PEARL ST',
    city: 'FITCHBURG',
    state: 'MA',
    zip: 1420,
    telephone: '(978) 345-2151',
    population: 7506,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fitchburgstate.edu/',
  },
  {
    name: 'NICHOLLS STATE UNIVERSITY',
    address: 'UNIVERSITY STATION LA HWY 1',
    city: 'THIBODAUX',
    state: 'LA',
    zip: 70310,
    telephone: '(877) 642-4655',
    population: 7509,
    county: 'LAFOURCHE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nicholls.edu/',
  },
  {
    name: 'BAKER COLLEGE',
    address: '1020 S WASHINGTON ST',
    city: 'OWOSSO',
    state: 'MI',
    zip: 48867,
    telephone: '(989) 729-3500',
    population: 7519,
    county: 'SHIAWASSEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baker.edu/',
  },
  {
    name: 'REGIS UNIVERSITY',
    address: '3333 REGIS BLVD',
    city: 'DENVER',
    state: 'CO',
    zip: 80221,
    telephone: '(800) 388-2366 EXT 2111',
    population: 7538,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.regis.edu/',
  },
  {
    name: 'FAYETTEVILLE STATE UNIVERSITY',
    address: '1200 MURCHISON RD',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28301,
    telephone: '(910) 672-1111',
    population: 7590,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uncfsu.edu/',
  },
  {
    name: 'IMPERIAL VALLEY COLLEGE',
    address: '380 E. ATEN ROAD',
    city: 'IMPERIAL',
    state: 'CA',
    zip: 92251,
    telephone: '(760) 352-8320',
    population: 7590,
    county: 'IMPERIAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.imperial.edu/',
  },
  {
    name: 'ASHEVILLE-BUNCOMBE TECHNICAL COMMUNITY COLLEGE',
    address: '340 VICTORIA RD',
    city: 'ASHEVILLE',
    state: 'NC',
    zip: 28801,
    telephone: '(828) 254-1921',
    population: 7594,
    county: 'BUNCOMBE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.abtech.edu/',
  },
  {
    name: 'MEDICAL COLLEGE OF WISCONSIN',
    address: '8701 WATERTOWN PLANK ROAD',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53226,
    telephone: '(414) 955-8296',
    population: 7616,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mcw.edu/',
  },
  {
    name: 'ILLINOIS INSTITUTE OF TECHNOLOGY',
    address: '10 WEST 35TH STREET',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60616,
    telephone: '(312) 567-3000',
    population: 7629,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'web.iit.edu/',
  },
  {
    name: 'CALIFORNIA UNIVERSITY OF PENNSYLVANIA',
    address: '250 UNIVERSITY AVE',
    city: 'CALIFORNIA',
    state: 'PA',
    zip: 15419,
    telephone: '(724) 938-4400',
    population: 7640,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calu.edu/',
  },
  {
    name: 'MIDDLESEX COMMUNITY COLLEGE',
    address: '591 SPRINGS RD',
    city: 'BEDFORD',
    state: 'MA',
    zip: 1730,
    telephone: '(978) 656-3370',
    population: 7641,
    county: 'MIDDLESEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.middlesex.mass.edu/',
  },
  {
    name: 'NEW MEXICO STATE UNIVERSITY-DONA ANA',
    address: '2800 N. SONOMA RANCH BLVD.',
    city: 'LAS CRUCES',
    state: 'NM',
    zip: 88011,
    telephone: '(575) 528-7000',
    population: 7671,
    county: 'DOÑA ANA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'dacc.nmsu.edu/',
  },
  {
    name: 'NASHVILLE STATE COMMUNITY COLLEGE',
    address: '120 WHITE BRIDGE RD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37209,
    telephone: '(615) 353-3333',
    population: 7675,
    county: 'DAVIDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nscc.edu/',
  },
  {
    name: 'INTER AMERICAN UNIVERSITY OF PUERTO RICO-METRO',
    address: 'HIGHWAY #1 KM 16 3 CORNER FRANCISCO SEIN ST',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 919,
    telephone: '(787) 250-1912 EXT 2132',
    population: 7680,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.metro.inter.edu/',
  },
  {
    name: 'ODESSA COLLEGE',
    address: '201 W UNIVERSITY BLVD',
    city: 'ODESSA',
    state: 'TX',
    zip: 79764,
    telephone: '(432) 335-6400',
    population: 7684,
    county: 'ECTOR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.odessa.edu/',
  },
  {
    name: 'MONTEREY PENINSULA COLLEGE',
    address: '980 FREMONT ST',
    city: 'MONTEREY',
    state: 'CA',
    zip: 93940,
    telephone: '(831) 646-4000',
    population: 7685,
    county: 'MONTEREY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mpc.edu/',
  },
  {
    name: 'UNIVERSITY OF CINCINNATI-BLUE ASH COLLEGE',
    address: '9555 PLAINFIELD RD',
    city: 'BLUE ASH',
    state: 'OH',
    zip: 45236,
    telephone: '(513) 745-5600',
    population: 7691,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ucblueash.edu/',
  },
  {
    name: 'SOUTHWEST MINNESOTA STATE UNIVERSITY',
    address: '1501 STATE ST',
    city: 'MARSHALL',
    state: 'MN',
    zip: 56258,
    telephone: '(507) 537-7678',
    population: 7698,
    county: 'LYON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.smsu.edu/',
  },
  {
    name: 'KALAMAZOO VALLEY COMMUNITY COLLEGE',
    address: '6767 WEST O AVE',
    city: 'KALAMAZOO',
    state: 'MI',
    zip: 49003,
    telephone: '(269) 488-4100',
    population: 7704,
    county: 'KALAMAZOO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.kvcc.edu/',
  },
  {
    name: 'HUMBOLDT STATE UNIVERSITY',
    address: '1 HARPST STREET',
    city: 'ARCATA',
    state: 'CA',
    zip: 95521,
    telephone: '(707) 826-3011',
    population: 7705,
    county: 'HUMBOLDT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.humboldt.edu/',
  },
  {
    name: 'EASTERN IOWA COMMUNITY COLLEGE DISTRICT',
    address: '101 W THIRD STREET',
    city: 'DAVENPORT',
    state: 'IA',
    zip: 52801,
    telephone: '(563) 336-3300',
    population: 7766,
    county: 'SCOTT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.eicc.edu/',
  },
  {
    name: 'SUNY ONEONTA',
    address: '108 RAVINE PARKWAY',
    city: 'ONEONTA',
    state: 'NY',
    zip: 13820,
    telephone: '(607) 436-3500',
    population: 7770,
    county: 'OTSEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://suny.oneonta.edu/',
  },
  {
    name: 'DELTA COLLEGE',
    address: '1961 DELTA ROAD',
    city: 'UNIVERSITY CENTER',
    state: 'MI',
    zip: 48710,
    telephone: '(989) 686-9000',
    population: 7773,
    county: 'BAY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.delta.edu/',
  },
  {
    name: 'CINCINNATI STATE TECHNICAL AND COMMUNITY COLLEGE',
    address: '3520 CENTRAL PARKWAY',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45223,
    telephone: '(513) 569-1500',
    population: 7780,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cincinnatistate.edu/',
  },
  {
    name: 'NAVARRO COLLEGE',
    address: '3200 W 7TH AVENUE',
    city: 'CORSICANA',
    state: 'TX',
    zip: 75110,
    telephone: '(903) 874-6501',
    population: 7781,
    county: 'NAVARRO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.navarrocollege.edu/',
  },
  {
    name: 'UNIVERSITY OF MICHIGAN-FLINT',
    address: '303 E. KEARSLEY STREET',
    city: 'FLINT',
    state: 'MI',
    zip: 48502,
    telephone: '(810) 762-3000',
    population: 7793,
    county: 'GENESEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umflint.edu/',
  },
  {
    name: 'MARIST COLLEGE',
    address: '3399 NORTH RD',
    city: 'POUGHKEEPSIE',
    state: 'NY',
    zip: 12601,
    telephone: '(845) 575-3000',
    population: 7797,
    county: 'DUTCHESS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marist.edu/',
  },
  {
    name: 'SOUTHWESTERN ILLINOIS COLLEGE',
    address: '2500 CARLYLE AVE',
    city: 'BELLEVILLE',
    state: 'IL',
    zip: 62221,
    telephone: '(618) 235-2700',
    population: 7807,
    county: 'ST. CLAIR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.swic.edu/',
  },
  {
    name: 'NORTHWEST MISSISSIPPI COMMUNITY COLLEGE',
    address: '4975 HWY 51 N',
    city: 'SENATOBIA',
    state: 'MS',
    zip: 38668,
    telephone: '(662) 562-3200',
    population: 7815,
    county: 'TATE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northwestms.edu/',
  },
  {
    name: 'FLORIDA INSTITUTE OF TECHNOLOGY',
    address: '150 WEST UNIVERSITY BOULEVARD',
    city: 'MELBOURNE',
    state: 'FL',
    zip: 32901,
    telephone: '(321) 674-8000',
    population: 7838,
    county: 'BREVARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fit.edu/',
  },
  {
    name: 'RARITAN VALLEY COMMUNITY COLLEGE',
    address: '118 LAMINGTON ROAD',
    city: 'BRANCHBURG',
    state: 'NJ',
    zip: 8876,
    telephone: '(908) 526-1200',
    population: 7839,
    county: 'SOMERSET',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.raritanval.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF DENVER',
    address: '1111 W. COLFAX AVE.',
    city: 'DENVER',
    state: 'CO',
    zip: 80204,
    telephone: '(303) 556-2600',
    population: 7843,
    county: 'DENVER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccd.edu/',
  },
  {
    name: 'CLAYTON STATE UNIVERSITY',
    address: '2000 CLAYTON STATE BOULEVARD',
    city: 'MORROW',
    state: 'GA',
    zip: 30260,
    telephone: '(678) 466-4000',
    population: 7863,
    county: 'CLAYTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.clayton.edu/',
  },
  {
    name: 'BUTLER COMMUNITY COLLEGE',
    address: '901 S HAVERHILL RD',
    city: 'EL DORADO',
    state: 'KS',
    zip: 67042,
    telephone: '(316) 321-2222',
    population: 7877,
    county: 'BUTLER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.butlercc.edu/',
  },
  {
    name: 'UNIVERSITY OF CINCINNATI-CLERMONT COLLEGE',
    address: '4200 CLERMONT COLLEGE DR',
    city: 'BATAVIA',
    state: 'OH',
    zip: 45103,
    telephone: '(513) 732-5200',
    population: 7896,
    county: 'CLERMONT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ucclermont.edu/',
  },
  {
    name: 'TEXAS A & M UNIVERSITY-KINGSVILLE',
    address: '955 UNIVERSITY BLVD',
    city: 'KINGSVILLE',
    state: 'TX',
    zip: 78363,
    telephone: '(361) 593-2111',
    population: 7900,
    county: 'KLEBERG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tamuk.edu/',
  },
  {
    name: 'NEVADA STATE COLLEGE',
    address: '1125 NEVADA STATE DRIVE',
    city: 'HENDERSON',
    state: 'NV',
    zip: 89002,
    telephone: '(702) 992-2000',
    population: 7908,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'nsc.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-MALCOLM X COLLEGE',
    address: '1900 W JACKSON BLVD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60612,
    telephone: '(312) 850-7000',
    population: 7915,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccc.edu/colleges/malcolm-x/pages/default.aspx',
  },
  {
    name: 'BATON ROUGE COMMUNITY COLLEGE',
    address: '201 COMMUNITY COLLEGE DRIVE',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70806,
    telephone: '(866) 217-9823',
    population: 7918,
    county: 'EAST BATON ROUGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mybrcc.edu/',
  },
  {
    name: 'QUINSIGAMOND COMMUNITY COLLEGE',
    address: '670 WEST BOYLSTON STREET',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1606,
    telephone: '(508) 853-2300',
    population: 7929,
    county: 'WORCESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.qcc.edu/',
  },
  {
    name: 'GEORGIA COLLEGE & STATE UNIVERSITY',
    address: '231 W HANCOCK STREET',
    city: 'MILLEDGEVILLE',
    state: 'GA',
    zip: 31061,
    telephone: '(800) 342-0471',
    population: 7935,
    county: 'BALDWIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcsu.edu/',
  },
  {
    name: 'HUDSON COUNTY COMMUNITY COLLEGE',
    address: '70 SIP AVENUE',
    city: 'JERSEY CITY',
    state: 'NJ',
    zip: 7306,
    telephone: '(201) 714-7100',
    population: 7938,
    county: 'HUDSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hccc.edu/',
  },
  {
    name: "SAINT JOSEPH'S UNIVERSITY",
    address: '5600 CITY AVENUE',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19131,
    telephone: '(610) 660-1000',
    population: 7940,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sju.edu/',
  },
  {
    name: 'WAUKESHA COUNTY TECHNICAL COLLEGE',
    address: '800 MAIN STREET',
    city: 'PEWAUKEE',
    state: 'WI',
    zip: 53072,
    telephone: '(262) 691-5566',
    population: 7944,
    county: 'WAUKESHA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.wctc.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS FOR MEDICAL SCIENCES',
    address: '4301 W MARKHAM',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72205,
    telephone: '(501) 296-1275',
    population: 7949,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uams.edu/',
  },
  {
    name: 'UNIVERSITY OF LA VERNE',
    address: '1950 THIRD ST',
    city: 'LA VERNE',
    state: 'CA',
    zip: 91750,
    telephone: '(909) 593-3511',
    population: 7953,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.laverne.edu/',
  },
  {
    name: 'UNIVERSITY OF HARTFORD',
    address: '200 BLOOMFIELD AVE',
    city: 'WEST HARTFORD',
    state: 'CT',
    zip: 6117,
    telephone: '(860) 768-4100',
    population: 7965,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hartford.edu/',
  },
  {
    name: 'COLLEGE OF SAN MATEO',
    address: '1700 W HILLSDALE BLVD',
    city: 'SAN MATEO',
    state: 'CA',
    zip: 94402,
    telephone: '(650) 574-6161',
    population: 7987,
    county: 'SAN MATEO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.collegeofsanmateo.edu/',
  },
  {
    name: 'WEST VALLEY COLLEGE',
    address: '14000 FRUITVALE AVE',
    city: 'SARATOGA',
    state: 'CA',
    zip: 95070,
    telephone: '(408) 867-2200',
    population: 8023,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.westvalley.edu/',
  },
  {
    name: 'BUCKS COUNTY COMMUNITY COLLEGE',
    address: '275 SWAMP RD',
    city: 'NEWTOWN',
    state: 'PA',
    zip: 18940,
    telephone: '(215) 968-8000',
    population: 8027,
    county: 'BUCKS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bucks.edu/',
  },
  {
    name: 'MCNEESE STATE UNIVERSITY',
    address: '4205 RYAN ST',
    city: 'LAKE CHARLES',
    state: 'LA',
    zip: 70605,
    telephone: '(337) 475-5000',
    population: 8043,
    county: 'CALCASIEU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mcneese.edu/',
  },
  {
    name: 'NORTHWEST MISSOURI STATE UNIVERSITY',
    address: '800 UNIVERSITY DRIVE',
    city: 'MARYVILLE',
    state: 'MO',
    zip: 64468,
    telephone: '(660) 562-1212',
    population: 8049,
    county: 'NODAWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nwmissouri.edu/',
  },
  {
    name: 'ROWAN-CABARRUS COMMUNITY COLLEGE',
    address: '1333 JAKE ALEXANDER BLVD, SOUTH',
    city: 'SALISBURY',
    state: 'NC',
    zip: 28146,
    telephone: '(704) 216-7222',
    population: 8053,
    county: 'ROWAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.rccc.edu/',
  },
  {
    name: 'SOUTHERN UNIVERSITY AND A & M COLLEGE',
    address: 'P.O. BOX 9374, HARDING BLVD',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70813,
    telephone: '(225) 771-4500',
    population: 8076,
    county: 'EAST BATON ROUGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.subr.edu/',
  },
  {
    name: 'SUNY CORTLAND',
    address: 'MILLER BUILDING',
    city: 'CORTLAND',
    state: 'NY',
    zip: 13045,
    telephone: '(607) 753-2011',
    population: 8078,
    county: 'CORTLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www2.cortland.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TENNESSEE-MARTIN',
    address: '554 UNIVERSITY STREET',
    city: 'MARTIN',
    state: 'TN',
    zip: 38238,
    telephone: '(731) 881-7000',
    population: 8082,
    county: 'WEAKLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utm.edu/',
  },
  {
    name: 'WINONA STATE UNIVERSITY',
    address: '175 WEST MARK STREET',
    city: 'WINONA',
    state: 'MN',
    zip: 55987,
    telephone: '(507) 457-5000',
    population: 8084,
    county: 'WINONA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.winona.edu/',
  },
  {
    name: 'JACKSON STATE UNIVERSITY',
    address: '1400 JOHN R. LYNCH STREET',
    city: 'JACKSON',
    state: 'MS',
    zip: 39217,
    telephone: '(601) 979-2121',
    population: 8089,
    county: 'HINDS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.jsums.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW HAVEN',
    address: '300 BOSTON POST ROAD',
    city: 'WEST HAVEN',
    state: 'CT',
    zip: 6516,
    telephone: '(203) 932-7000',
    population: 8096,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newhaven.edu/',
  },
  {
    name: 'CHIPPEWA VALLEY TECHNICAL COLLEGE',
    address: '620 W CLAIREMONT AVE',
    city: 'EAU CLAIRE',
    state: 'WI',
    zip: 54701,
    telephone: '(715) 833-6200',
    population: 8098,
    county: 'EAU CLAIRE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cvtc.edu/',
  },
  {
    name: 'SUFFOLK UNIVERSITY',
    address: '73 TREMONT ST.',
    city: 'BOSTON',
    state: 'MA',
    zip: 2108,
    telephone: '(617) 573-8754',
    population: 8115,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.suffolk.edu/',
  },
  {
    name: 'COLLEGE OF SOUTHERN IDAHO',
    address: '315 FALLS AVE.',
    city: 'TWIN FALLS',
    state: 'ID',
    zip: 83301,
    telephone: '(208) 733-9554',
    population: 8143,
    county: 'TWIN FALLS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.csi.edu/',
  },
  {
    name: 'COLORADO SCHOOL OF MINES',
    address: '1500 ILLINOIS ST',
    city: 'GOLDEN',
    state: 'CO',
    zip: 80401,
    telephone: '(303) 273-3000',
    population: 8161,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mines.edu/',
  },
  {
    name: 'LEE COLLEGE',
    address: '511 S WHITING',
    city: 'BAYTOWN',
    state: 'TX',
    zip: 77520,
    telephone: '(281) 427-5611',
    population: 8162,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lee.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE CHICAGO',
    address: '600 SOUTH MICHIGAN',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60605,
    telephone: '(312) 369-1000',
    population: 8166,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.colum.edu/',
  },
  {
    name: 'NORTHWEST ARKANSAS COMMUNITY COLLEGE',
    address: 'ONE COLLEGE DRIVE',
    city: 'BENTONVILLE',
    state: 'AR',
    zip: 72712,
    telephone: '(479) 986-4000',
    population: 8174,
    county: 'BENTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nwacc.edu/',
  },
  {
    name: 'RHODE ISLAND COLLEGE',
    address: '600 MOUNT PLEASANT AVE',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2908,
    telephone: '(401) 456-8000',
    population: 8190,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ric.edu/',
  },
  {
    name: 'WORCESTER POLYTECHNIC INSTITUTE',
    address: '100 INSTITUTE ROAD',
    city: 'WORCESTER',
    state: 'MA',
    zip: 1609,
    telephone: '(508) 831-5000',
    population: 8203,
    county: 'WORCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wpi.edu/',
  },
  {
    name: 'BERKLEE COLLEGE OF MUSIC',
    address: '1140 BOYLSTON ST',
    city: 'BOSTON',
    state: 'MA',
    zip: 2215,
    telephone: '(617) 747-2222',
    population: 8208,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.berklee.edu/',
  },
  {
    name: 'SPOKANE COMMUNITY COLLEGE',
    address: '1810 NORTH GREENE STREET',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99217,
    telephone: '(509) 533-7000',
    population: 8209,
    county: 'SPOKANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://scc.spokane.edu/',
  },
  {
    name: 'UNIVERSITY OF THE PACIFIC',
    address: '3601 PACIFIC AVE',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95211,
    telephone: '(209) 946-2011',
    population: 8214,
    county: 'SAN JOAQUIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pacific.edu/',
  },
  {
    name: 'ROWAN COLLEGE AT BURLINGTON COUNTY',
    address: '900 COLLEGE CIRCLE',
    city: 'MOUNT LAUREL',
    state: 'NJ',
    zip: 8054,
    telephone: '(856) 222-9311',
    population: 8226,
    county: 'BURLINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rcbc.edu/',
  },
  {
    name: 'GREEN RIVER COLLEGE',
    address: '12401 SE 320TH ST',
    city: 'AUBURN',
    state: 'WA',
    zip: 98092,
    telephone: '(253) 833-9111',
    population: 8227,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.greenriver.edu/',
  },
  {
    name: 'GERMANNA COMMUNITY COLLEGE',
    address: '2130 GERMANNA HWY',
    city: 'LOCUST GROVE',
    state: 'VA',
    zip: 22508,
    telephone: '(540) 423-9030',
    population: 8244,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.germanna.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TENNESSEE HEALTH SCIENCE CENTER',
    address: 'NOT AVAILABLE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38163,
    telephone: '(901) 448-5500',
    population: 8256,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uthsc.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF AURORA',
    address: '16000 E CENTRETECH PKY',
    city: 'AURORA',
    state: 'CO',
    zip: 80011,
    telephone: '(303) 360-4700',
    population: 8281,
    county: 'ARAPAHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ccaurora.edu/',
  },
  {
    name: 'OAKTON COMMUNITY COLLEGE',
    address: '1600 E GOLF RD.',
    city: 'DES PLAINES',
    state: 'IL',
    zip: 60016,
    telephone: '(847) 635-1600',
    population: 8290,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.oakton.edu/',
  },
  {
    name: 'SOUTHWEST TENNESSEE COMMUNITY COLLEGE',
    address: '737 UNION AVENUE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38103,
    telephone: '(901) 333-5000',
    population: 8293,
    county: 'SHELBY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southwest.tn.edu/',
  },
  {
    name: 'NORTHEASTERN STATE UNIVERSITY',
    address: '600 N GRAND',
    city: 'TAHLEQUAH',
    state: 'OK',
    zip: 74464,
    telephone: '(918) 456-5511',
    population: 8322,
    county: 'CHEROKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nsuok.edu/',
  },
  {
    name: 'NORTHEASTERN ILLINOIS UNIVERSITY',
    address: '5500 N SAINT LOUIS AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60625,
    telephone: '(773) 583-4050',
    population: 8323,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.neiu.edu/',
  },
  {
    name: 'RUTGERS UNIVERSITY-CAMDEN',
    address: '406 PENN',
    city: 'CAMDEN',
    state: 'NJ',
    zip: 8102,
    telephone: '(856) 225-1766',
    population: 8332,
    county: 'CAMDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.camden.rutgers.edu/',
  },
  {
    name: 'MCHENRY COUNTY COLLEGE',
    address: '8900 US HWY 14',
    city: 'CRYSTAL LAKE',
    state: 'IL',
    zip: 60012,
    telephone: '(815) 455-3700',
    population: 8348,
    county: 'MCHENRY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mchenry.edu/',
  },
  {
    name: 'TEXAS SOUTHERN UNIVERSITY',
    address: '3100 CLEBURNE ST',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77004,
    telephone: '(713) 313-7011',
    population: 8357,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tsu.edu/',
  },
  {
    name: 'FAIRLEIGH DICKINSON UNIVERSITY-METROPOLITAN CAMPUS',
    address: '1000 RIVER RD',
    city: 'TEANECK',
    state: 'NJ',
    zip: 7666,
    telephone: '(201) 692-2000',
    population: 8376,
    county: 'BERGEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fdu.edu/',
  },
  {
    name: 'CHATTANOOGA STATE COMMUNITY COLLEGE',
    address: '4501 AMNICOLA HWY',
    city: 'CHATTANOOGA',
    state: 'TN',
    zip: 37406,
    telephone: '(423) 697-4400',
    population: 8378,
    county: 'HAMILTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.chattanoogastate.edu/',
  },
  {
    name: 'EVERETT COMMUNITY COLLEGE',
    address: '2000 TOWER STREET',
    city: 'EVERETT',
    state: 'WA',
    zip: 98201,
    telephone: '(425) 388-9100',
    population: 8378,
    county: 'SNOHOMISH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.everettcc.edu/',
  },
  {
    name: 'NORTHERN MICHIGAN UNIVERSITY',
    address: '1401 PRESQUE ISLE AVENUE',
    city: 'MARQUETTE',
    state: 'MI',
    zip: 49855,
    telephone: '(906) 227-2650',
    population: 8388,
    county: 'MARQUETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nmu.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-CHANNEL ISLANDS',
    address: 'ONE UNIVERSITY DR',
    city: 'CAMARILLO',
    state: 'CA',
    zip: 93012,
    telephone: '(805) 437-8400',
    population: 8392,
    county: 'VENTURA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csuci.edu/',
  },
  {
    name: 'MICHIGAN TECHNOLOGICAL UNIVERSITY',
    address: '1400 TOWNSEND DRIVE',
    city: 'HOUGHTON',
    state: 'MI',
    zip: 49931,
    telephone: '(906) 487-1885',
    population: 8392,
    county: 'HOUGHTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mtu.edu/',
  },
  {
    name: 'NEW YORK INSTITUTE OF TECHNOLOGY',
    address: 'NORTHERN BLVD',
    city: 'OLD WESTBURY',
    state: 'NY',
    zip: 11568,
    telephone: '(800) 345-6948',
    population: 8409,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyit.edu/',
  },
  {
    name: 'STEVENS INSTITUTE OF TECHNOLOGY',
    address: 'CASTLE POINT ON HUDSON',
    city: 'HOBOKEN',
    state: 'NJ',
    zip: 7030,
    telephone: '(201) 216-5000',
    population: 8411,
    county: 'HUDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stevens.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-MONTEREY BAY',
    address: '100 CAMPUS CENTER',
    city: 'SEASIDE',
    state: 'CA',
    zip: 93955,
    telephone: '(831) 582-3000',
    population: 8415,
    county: 'MONTEREY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csumb.edu/',
  },
  {
    name: 'MILLERSVILLE UNIVERSITY OF PENNSYLVANIA',
    address: '1 SOUTH GEORGE STREET, LYLE HALL',
    city: 'MILLERSVILLE',
    state: 'PA',
    zip: 17551,
    telephone: '(717) 871-4636',
    population: 8421,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.millersville.edu/',
  },
  {
    name: 'XAVIER UNIVERSITY',
    address: '3800 VICTORY PARKWAY',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45207,
    telephone: '(513) 745-3000',
    population: 8455,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.xavier.edu/',
  },
  {
    name: 'SCOTTSDALE COMMUNITY COLLEGE',
    address: '9000 E CHAPARRAL RD',
    city: 'SCOTTSDALE',
    state: 'AZ',
    zip: 85256,
    telephone: '(480) 423-6000',
    population: 8478,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.scottsdalecc.edu/',
  },
  {
    name: 'OWENS COMMUNITY COLLEGE',
    address: '30335 OREGON RD',
    city: 'PERRYSBURG',
    state: 'OH',
    zip: 43551,
    telephone: '(567) 661-7000',
    population: 8485,
    county: 'WOOD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.owens.edu/',
  },
  {
    name: 'NATIONAL LOUIS UNIVERSITY',
    address: '122 S MICHIGAN AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60603,
    telephone: '(800) 443-5522',
    population: 8486,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nl.edu/',
  },
  {
    name: 'LAS POSITAS COLLEGE',
    address: '3000 CAMPUS HILL DRIVE',
    city: 'LIVERMORE',
    state: 'CA',
    zip: 94551,
    telephone: '(925) 424-1000',
    population: 8488,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.laspositascollege.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW ENGLAND',
    address: '11 HILLS BEACH RD',
    city: 'BIDDEFORD',
    state: 'ME',
    zip: 4005,
    telephone: '(207) 283-0171',
    population: 8505,
    county: 'YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.une.edu/',
  },
  {
    name: 'LANE COMMUNITY COLLEGE',
    address: '4000 E 30TH AVE',
    city: 'EUGENE',
    state: 'OR',
    zip: 97405,
    telephone: '(541) 463-3000',
    population: 8508,
    county: 'LANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lanecc.edu/',
  },
  {
    name: 'AMERICAN COLLEGE OF EDUCATION',
    address: '101 WEST OHIO STREET, SUITE 1200',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46204,
    telephone: '(800) 280-0307',
    population: 8517,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ace.edu/',
  },
  {
    name: 'SALEM STATE UNIVERSITY',
    address: '352 LAFAYETTE ST',
    city: 'SALEM',
    state: 'MA',
    zip: 1970,
    telephone: '(978) 542-6000',
    population: 8518,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.salemstate.edu/',
  },
  {
    name: 'CITY COLLEGES OF CHICAGO-WILBUR WRIGHT COLLEGE',
    address: '4300 N NARRAGANSETT',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60634,
    telephone: '(773) 777-7900',
    population: 8521,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'ccc.edu/colleges/wright/pages/default.aspx',
  },
  {
    name: 'J SARGEANT REYNOLDS COMMUNITY COLLEGE',
    address: '1651 EAST PARHAM ROAD',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23228,
    telephone: '(804) 371-3000',
    population: 8524,
    county: 'HENRICO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.reynolds.edu/',
  },
  {
    name: 'MCLENNAN COMMUNITY COLLEGE',
    address: '1400 COLLEGE DR',
    city: 'WACO',
    state: 'TX',
    zip: 76708,
    telephone: '(254) 299-8622',
    population: 8536,
    county: 'MCLENNAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mclennan.edu/',
  },
  {
    name: 'OCEAN COUNTY COLLEGE',
    address: 'COLLEGE DRIVE',
    city: 'TOMS RIVER',
    state: 'NJ',
    zip: 8754,
    telephone: '(732) 255-0400',
    population: 8540,
    county: 'OCEAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ocean.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-PLATTEVILLE',
    address: '1 UNIVERSITY PLAZA',
    city: 'PLATTEVILLE',
    state: 'WI',
    zip: 53818,
    telephone: '(608) 342-1491',
    population: 8557,
    county: 'GRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwplatt.edu/',
  },
  {
    name: 'METROPOLITAN STATE UNIVERSITY',
    address: '700 EAST SEVENTH STREET',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55106,
    telephone: '(651) 793-1300',
    population: 8566,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.metrostate.edu/',
  },
  {
    name: 'WAUBONSEE COMMUNITY COLLEGE',
    address: 'RTE 47 AT WAUBONSEE DRIVE',
    city: 'SUGAR GROVE',
    state: 'IL',
    zip: 60554,
    telephone: '(630) 466-7900 EXT 2255',
    population: 8569,
    county: 'KANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.waubonsee.edu/',
  },
  {
    name: 'LOS ANGELES HARBOR COLLEGE',
    address: '1111 FIGUEROA PLACE',
    city: 'WILMINGTON',
    state: 'CA',
    zip: 90744,
    telephone: '(310) 233-4000',
    population: 8570,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lahc.edu/',
  },
  {
    name: 'SEATTLE UNIVERSITY',
    address: '900 BROADWAY',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98122,
    telephone: '(206) 296-6000',
    population: 8581,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.seattleu.edu/',
  },
  {
    name: 'ILLINOIS CENTRAL COLLEGE',
    address: '1 COLLEGE DRIVE',
    city: 'EAST PEORIA',
    state: 'IL',
    zip: 61635,
    telephone: '(309) 694-5422',
    population: 8598,
    county: 'TAZEWELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'icc.edu/',
  },
  {
    name: 'GATEWAY TECHNICAL COLLEGE',
    address: '3520 30TH AVE',
    city: 'KENOSHA',
    state: 'WI',
    zip: 53144,
    telephone: '(262) 564-2200',
    population: 8626,
    county: 'KENOSHA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.gtc.edu/',
  },
  {
    name: 'GEORGIA MILITARY COLLEGE',
    address: '201 E GREENE ST',
    city: 'MILLEDGEVILLE',
    state: 'GA',
    zip: 31061,
    telephone: '(478) 387-4900',
    population: 8678,
    county: 'BALDWIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gmc.edu/index.cms',
  },
  {
    name: 'LINDENWOOD UNIVERSITY',
    address: '209 S KINGSHIGHWAY',
    city: 'SAINT CHARLES',
    state: 'MO',
    zip: 63301,
    telephone: '(636) 949-2000',
    population: 8698,
    county: 'ST. CHARLES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lindenwood.edu/',
  },
  {
    name: 'ELON UNIVERSITY',
    address: '100 CAMPUS DRIVE',
    city: 'ELON',
    state: 'NC',
    zip: 27244,
    telephone: '(336) 278-2000',
    population: 8707,
    county: 'ALAMANCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.elon.edu/',
  },
  {
    name: 'UNIVERSITY OF NEBRASKA MEDICAL CENTER',
    address: '42ND & DEWEY AVE',
    city: 'OMAHA',
    state: 'NE',
    zip: 68198,
    telephone: '(402) 559-4000',
    population: 8723,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unmc.edu/',
  },
  {
    name: 'DUTCHESS COMMUNITY COLLEGE',
    address: '53 PENDELL RD',
    city: 'POUGHKEEPSIE',
    state: 'NY',
    zip: 12601,
    telephone: '(845) 431-8000',
    population: 8726,
    county: 'DUTCHESS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunydutchess.edu/',
  },
  {
    name: 'BARRY UNIVERSITY',
    address: '11300 NE 2ND AVE',
    city: 'MIAMI',
    state: 'FL',
    zip: 33161,
    telephone: '(800) 756-6000',
    population: 8728,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.barry.edu/',
  },
  {
    name: 'WESTERN ILLINOIS UNIVERSITY',
    address: '1 UNIVERSITY CIRCLE',
    city: 'MACOMB',
    state: 'IL',
    zip: 61455,
    telephone: '(309) 295-1414',
    population: 8770,
    county: 'MCDONOUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wiu.edu/',
  },
  {
    name: 'SHASTA COLLEGE',
    address: '11555 OLD OREGON TRAIL',
    city: 'REDDING',
    state: 'CA',
    zip: 96003,
    telephone: '(530) 242-7500',
    population: 8774,
    county: 'SHASTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.shastacollege.edu/',
  },
  {
    name: 'STATE UNIVERSITY OF NEW YORK AT NEW PALTZ',
    address: '1 HAWK DRIVE',
    city: 'NEW PALTZ',
    state: 'NY',
    zip: 12561,
    telephone: '(877) 696-7411',
    population: 8794,
    county: 'ULSTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.newpaltz.edu/',
  },
  {
    name: 'KUTZTOWN UNIVERSITY OF PENNSYLVANIA',
    address: '15200 KUTZTOWN RD',
    city: 'KUTZTOWN',
    state: 'PA',
    zip: 19530,
    telephone: '(610) 683-4000',
    population: 8799,
    county: 'BERKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kutztown.edu/',
  },
  {
    name: 'CUNY YORK COLLEGE',
    address: '94-20 GUY R. BREWER BLVD',
    city: 'JAMAICA',
    state: 'NY',
    zip: 11451,
    telephone: '(718) 262-2000',
    population: 8801,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.york.cuny.edu/',
  },
  {
    name: 'CENTURY COLLEGE',
    address: '3300 CENTURY AVE N',
    city: 'WHITE BEAR LAKE',
    state: 'MN',
    zip: 55110,
    telephone: '(651) 770-3200',
    population: 8824,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.century.edu/',
  },
  {
    name: 'UNIVERSIDAD ANA G. MENDEZ-CAROLINA CAMPUS',
    address: 'CARR. # 190 ESQ. CALLE 220 BO. SABANA ABAJO',
    city: 'CAROLINA',
    state: 'PR',
    zip: 985,
    telephone: '(787) 257-7373',
    population: 8826,
    county: 'CAROLINA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'carolina.uagm.edu/',
  },
  {
    name: 'SAN JOSE CITY COLLEGE',
    address: '2100 MOORPARK AVE',
    city: 'SAN JOSE',
    state: 'CA',
    zip: 95128,
    telephone: '(408) 298-2181',
    population: 8855,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sjcc.edu/',
  },
  {
    name: 'NEW JERSEY CITY UNIVERSITY',
    address: '2039 KENNEDY BLVD',
    city: 'JERSEY CITY',
    state: 'NJ',
    zip: 7305,
    telephone: '(201) 200-2000',
    population: 8871,
    county: 'HUDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.njcu.edu/',
  },
  {
    name: 'SUNY COLLEGE AT OSWEGO',
    address: '7060 STATE ROUTE 104',
    city: 'OSWEGO',
    state: 'NY',
    zip: 13126,
    telephone: '(315) 312-2500',
    population: 8877,
    county: 'OSWEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.oswego.edu/',
  },
  {
    name: 'SUNY BROCKPORT',
    address: '350 NEW CAMPUS DR',
    city: 'BROCKPORT',
    state: 'NY',
    zip: 14420,
    telephone: '(585) 395-2361',
    population: 8887,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.brockport.edu/',
  },
  {
    name: 'PITT COMMUNITY COLLEGE',
    address: '1986 PITT TECH ROAD',
    city: 'WINTERVILLE',
    state: 'NC',
    zip: 28590,
    telephone: '(252) 493-7200',
    population: 8887,
    county: 'PITT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pittcc.edu/',
  },
  {
    name: 'CLARK COLLEGE',
    address: '1933 FORT VANCOUVER WAY',
    city: 'VANCOUVER',
    state: 'WA',
    zip: 98663,
    telephone: '(360) 992-2000',
    population: 8888,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clark.edu/',
  },
  {
    name: 'ELGIN COMMUNITY COLLEGE',
    address: '1700 SPARTAN DRIVE',
    city: 'ELGIN',
    state: 'IL',
    zip: 60123,
    telephone: '(847) 697-1000',
    population: 8894,
    county: 'KANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.elgin.edu/',
  },
  {
    name: 'MISSOURI UNIVERSITY OF SCIENCE AND TECHNOLOGY',
    address: '300 W.13TH STREET',
    city: 'ROLLA',
    state: 'MO',
    zip: 65409,
    telephone: '(573) 341-4111',
    population: 8898,
    county: 'PHELPS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mst.edu/',
  },
  {
    name: 'COLORADO CHRISTIAN UNIVERSITY',
    address: '8787 WEST ALAMEDA AVENUE',
    city: 'LAKEWOOD',
    state: 'CO',
    zip: 80226,
    telephone: '(303) 963-3000',
    population: 8900,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ccu.edu/',
  },
  {
    name: 'GONZAGA UNIVERSITY',
    address: 'E 502 BOONE AVE',
    city: 'SPOKANE',
    state: 'WA',
    zip: 99258,
    telephone: '(509) 328-4220',
    population: 8902,
    county: 'SPOKANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gonzaga.edu/',
  },
  {
    name: 'LEHIGH UNIVERSITY',
    address: '27 MEMORIAL DRIVE WEST',
    city: 'BETHLEHEM',
    state: 'PA',
    zip: 18015,
    telephone: '(610) 758-3000',
    population: 8928,
    county: 'NORTHAMPTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lehigh.edu/',
  },
  {
    name: 'SCHOOLCRAFT COLLEGE',
    address: '18600 HAGGERTY ROAD',
    city: 'LIVONIA',
    state: 'MI',
    zip: 48152,
    telephone: '(734) 462-4400',
    population: 8930,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.schoolcraft.edu/',
  },
  {
    name: 'MCPHS UNIVERSITY',
    address: '179 LONGWOOD AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 732-2800',
    population: 8938,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mcphs.edu/',
  },
  {
    name: 'ANOKA-RAMSEY COMMUNITY COLLEGE',
    address: '11200 MISSISSIPPI BLVD NW',
    city: 'COON RAPIDS',
    state: 'MN',
    zip: 55433,
    telephone: '(763) 433-1100',
    population: 8964,
    county: 'ANOKA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.anokaramsey.edu/',
  },
  {
    name: 'TENNESSEE STATE UNIVERSITY',
    address: '3500 JOHN A. MERRITT BLVD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37209,
    telephone: '(615) 963-5000',
    population: 8978,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tnstate.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH ALABAMA',
    address: 'ONE HARRISON PLAZA',
    city: 'FLORENCE',
    state: 'AL',
    zip: 35632,
    telephone: '(256) 765-4100',
    population: 8986,
    county: 'LAUDERDALE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.una.edu/',
  },
  {
    name: 'LOS MEDANOS COLLEGE',
    address: '2700 EAST LELAND ROAD',
    city: 'PITTSBURG',
    state: 'CA',
    zip: 94565,
    telephone: '(925) 439-2181',
    population: 8995,
    county: 'CONTRA COSTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.losmedanos.edu/',
  },
  {
    name: 'UNIVERSITY OF ALASKA FAIRBANKS',
    address: '1731 SOUTH CHANDALAR DRIVE',
    city: 'FAIRBANKS',
    state: 'AK',
    zip: 99775,
    telephone: '(907) 474-7034',
    population: 9015,
    county: 'FAIRBANKS NORTH STAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uaf.edu/',
  },
  {
    name: 'WEILL MEDICAL COLLEGE OF CORNELL UNIVERSITY',
    address: '1300 YORK AVENUE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10065,
    telephone: '(212) 746-1050',
    population: 9025,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://weill.cornell.edu/',
  },
  {
    name: 'JOHN C CALHOUN STATE COMMUNITY COLLEGE',
    address: '6250 U S HIGHWAY 31 N',
    city: 'TANNER',
    state: 'AL',
    zip: 35671,
    telephone: '(256) 306-2500',
    population: 9032,
    county: 'LIMESTONE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://calhoun.edu/',
  },
  {
    name: 'CENTRAL GEORGIA TECHNICAL COLLEGE',
    address: '80 COHEN WALKER DRIVE',
    city: 'WARNER ROBINS',
    state: 'GA',
    zip: 31088,
    telephone: '(478) 757-3400',
    population: 9038,
    county: 'HOUSTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.centralgatech.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-STOUT',
    address: '712 S BROADWAY ST',
    city: 'MENOMONIE',
    state: 'WI',
    zip: 54751,
    telephone: '(715) 232-1122',
    population: 9046,
    county: 'DUNN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwstout.edu/',
  },
  {
    name: 'CAMDEN COUNTY COLLEGE',
    address: '200 COLLEGE DRIVE',
    city: 'BLACKWOOD',
    state: 'NJ',
    zip: 8012,
    telephone: '(856) 227-7200',
    population: 9065,
    county: 'CAMDEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.camdencc.edu/',
  },
  {
    name: 'SAGINAW VALLEY STATE UNIVERSITY',
    address: '7400 BAY RD',
    city: 'UNIVERSITY CENTER',
    state: 'MI',
    zip: 48710,
    telephone: '(989) 964-4000',
    population: 9073,
    county: 'SAGINAW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.svsu.edu/',
  },
  {
    name: 'UNIVERSITY OF MASSACHUSETTS-DARTMOUTH',
    address: '285 OLD WESTPORT RD',
    city: 'NORTH DARTMOUTH',
    state: 'MA',
    zip: 2747,
    telephone: '(508) 999-8000',
    population: 9075,
    county: 'BRISTOL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umassd.edu/',
  },
  {
    name: 'PIERCE COLLEGE DISTRICT',
    address: '9401 FARWEST DR SW',
    city: 'LAKEWOOD',
    state: 'WA',
    zip: 98498,
    telephone: '(253) 964-6500',
    population: 9084,
    county: 'PIERCE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pierce.ctc.edu/',
  },
  {
    name: 'FORSYTH TECHNICAL COMMUNITY COLLEGE',
    address: '2100 SILAS CREEK PKY',
    city: 'WINSTON-SALEM',
    state: 'NC',
    zip: 27103,
    telephone: '(336) 723-0371',
    population: 9084,
    county: 'FORSYTH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.forsythtech.edu/',
  },
  {
    name: 'EVERGREEN VALLEY COLLEGE',
    address: '3095 YERBA BUENA RD',
    city: 'SAN JOSE',
    state: 'CA',
    zip: 95135,
    telephone: '(408) 274-7900',
    population: 9156,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.evc.edu/',
  },
  {
    name: 'RENSSELAER POLYTECHNIC INSTITUTE',
    address: '110 8TH ST',
    city: 'TROY',
    state: 'NY',
    zip: 12180,
    telephone: '(518) 276-6000',
    population: 9174,
    county: 'RENSSELAER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rpi.edu/',
  },
  {
    name: 'ULTIMATE MEDICAL ACADEMY',
    address: '1255 CLEVELAND ST',
    city: 'CLEARWATER',
    state: 'FL',
    zip: 33755,
    telephone: '(727) 298-8685',
    population: 9206,
    county: 'PINELLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ultimatemedical.edu/about/',
  },
  {
    name: 'HARTNELL COLLEGE',
    address: '411 CENTRAL AVENUE',
    city: 'SALINAS',
    state: 'CA',
    zip: 93901,
    telephone: '(831) 755-6700',
    population: 9212,
    county: 'MONTEREY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hartnell.edu/',
  },
  {
    name: 'UNIVERSITY OF OKLAHOMA-HEALTH SCIENCES CENTER',
    address: '1105 STONEWALL AVENUE',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73117,
    telephone: '(405) 271-2332',
    population: 9216,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ouhsc.edu/',
  },
  {
    name: 'CHEMEKETA COMMUNITY COLLEGE',
    address: '4000 LANCASTER DR NE',
    city: 'SALEM',
    state: 'OR',
    zip: 97305,
    telephone: '(503) 399-5000',
    population: 9226,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chemeketa.edu/',
  },
  {
    name: 'JEFFERSON STATE COMMUNITY COLLEGE',
    address: '2601 CARSON RD',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35215,
    telephone: '(205) 853-1200',
    population: 9228,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jeffersonstate.edu/',
  },
  {
    name: 'CLOVIS COMMUNITY COLLEGE',
    address: '10309 NORTH WILLOW AVENUE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93730,
    telephone: '(559) 325-5200',
    population: 9237,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cloviscollege.edu/',
  },
  {
    name: 'SKYLINE COLLEGE',
    address: '3300 COLLEGE DR',
    city: 'SAN BRUNO',
    state: 'CA',
    zip: 94066,
    telephone: '(650) 738-4100',
    population: 9240,
    county: 'SAN MATEO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'skylinecollege.edu/',
  },
  {
    name: 'CUYAMACA COLLEGE',
    address: '900 RANCHO SAN DIEGO PKY',
    city: 'EL CAJON',
    state: 'CA',
    zip: 92019,
    telephone: '(619) 660-4000',
    population: 9249,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cuyamaca.edu/',
  },
  {
    name: 'SONOMA STATE UNIVERSITY',
    address: '1801 E COTATI AVE',
    city: 'ROHNERT PARK',
    state: 'CA',
    zip: 94928,
    telephone: '(707) 664-2880',
    population: 9259,
    county: 'SONOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sonoma.edu/',
  },
  {
    name: 'MIDDLE GEORGIA STATE UNIVERSITY',
    address: '100 UNIVERSITY PARKWAY',
    city: 'MACON',
    state: 'GA',
    zip: 31206,
    telephone: '(478) 471-2700',
    population: 9261,
    county: 'BIBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mga.edu/',
  },
  {
    name: 'UNION COUNTY COLLEGE',
    address: '1033 SPRINGFIELD AVENUE',
    city: 'CRANFORD',
    state: 'NJ',
    zip: 7016,
    telephone: '(908) 709-7000',
    population: 9265,
    county: 'UNION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ucc.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA AT PEMBROKE',
    address: 'ONE UNIVERSITY DRIVE',
    city: 'PEMBROKE',
    state: 'NC',
    zip: 28372,
    telephone: '(910) 521-6000',
    population: 9277,
    county: 'ROBESON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uncp.edu/',
  },
  {
    name: 'COASTLINE COMMUNITY COLLEGE',
    address: '11460 WARNER AVE.',
    city: 'FOUNTAIN VALLEY',
    state: 'CA',
    zip: 92708,
    telephone: '(714) 546-7600',
    population: 9284,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.coastline.edu/',
  },
  {
    name: 'ADELPHI UNIVERSITY',
    address: 'SOUTH AVE',
    city: 'GARDEN CITY',
    state: 'NY',
    zip: 11530,
    telephone: '(516) 877-3000',
    population: 9312,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.adelphi.edu/',
  },
  {
    name: 'TEXAS SOUTHMOST COLLEGE',
    address: '80 FORT BROWN',
    city: 'BROWNSVILLE',
    state: 'TX',
    zip: 78520,
    telephone: '(956) 295-3600',
    population: 9341,
    county: 'CAMERON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tsc.edu/',
  },
  {
    name: 'TEXAS A & M INTERNATIONAL UNIVERSITY',
    address: '5201 UNIVERSITY BLVD',
    city: 'LAREDO',
    state: 'TX',
    zip: 78041,
    telephone: '(956) 326-2001',
    population: 9351,
    county: 'WEBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tamiu.edu/',
  },
  {
    name: 'COLUMBIA COLLEGE',
    address: '1001 ROGERS STREET',
    city: 'COLUMBIA',
    state: 'MO',
    zip: 65216,
    telephone: '(800) 231-2391',
    population: 9384,
    county: 'BOONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccis.edu/',
  },
  {
    name: 'PURDUE UNIVERSITY FORT WAYNE',
    address: '2101 E COLISEUM BLVD',
    city: 'FORT WAYNE',
    state: 'IN',
    zip: 46805,
    telephone: '(260) 481-4739',
    population: 9389,
    county: 'ALLEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pfw.edu/',
  },
  {
    name: 'MORGAN STATE UNIVERSITY',
    address: '1700 EAST COLD SPRING LANE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21251,
    telephone: '(443) 885-3333',
    population: 9402,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.morgan.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-STEVENS POINT',
    address: '2100 MAIN ST',
    city: 'STEVENS POINT',
    state: 'WI',
    zip: 54481,
    telephone: '(715) 346-0123',
    population: 9429,
    county: 'PORTAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwsp.edu/',
  },
  {
    name: 'THE COLLEGE OF NEW JERSEY',
    address: '2000 PENNINGTON ROAD',
    city: 'EWING',
    state: 'NJ',
    zip: 8628,
    telephone: '(609) 771-1855',
    population: 9439,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tcnj.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW ORLEANS',
    address: '2000 LAKESHORE DRIVE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70148,
    telephone: '(888) 514-4275',
    population: 9447,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'new.uno.edu/',
  },
  {
    name: 'NORTH CENTRAL TEXAS COLLEGE',
    address: '1525 W CALIFORNIA STREET',
    city: 'GAINESVILLE',
    state: 'TX',
    zip: 76240,
    telephone: '(940) 668-7731',
    population: 9449,
    county: 'COOKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.nctc.edu/',
  },
  {
    name: 'BLOOMSBURG UNIVERSITY OF PENNSYLVANIA',
    address: '400 E SECOND ST',
    city: 'BLOOMSBURG',
    state: 'PA',
    zip: 17815,
    telephone: '(570) 389-4000',
    population: 9466,
    county: 'COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bloomu.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS HEALTH SCIENCE CENTER AT SAN ANTONIO',
    address: '7703 FLOYD CURL DR',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78229,
    telephone: '(210) 567-2620',
    population: 9476,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uthscsa.edu/',
  },
  {
    name: 'COLUMBUS STATE UNIVERSITY',
    address: '4225 UNIVERSITY AVE',
    city: 'COLUMBUS',
    state: 'GA',
    zip: 31907,
    telephone: '(706) 507-8800',
    population: 9481,
    county: 'MUSCOGEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbusstate.edu/',
  },
  {
    name: 'NORTH CAROLINA CENTRAL UNIVERSITY',
    address: '1801 FAYETTEVILLE STREET',
    city: 'DURHAM',
    state: 'NC',
    zip: 27707,
    telephone: '(919) 530-6100',
    population: 9482,
    county: 'DURHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.nccu.edu/',
  },
  {
    name: 'UNIVERSITY OF THE INCARNATE WORD',
    address: '4301 BROADWAY',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78209,
    telephone: '(210) 829-6000',
    population: 9512,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uiw.edu/',
  },
  {
    name: 'GWINNETT TECHNICAL COLLEGE',
    address: '5150 SUGARLOAF PARKWAY',
    city: 'LAWRENCEVILLE',
    state: 'GA',
    zip: 30043,
    telephone: '(770) 962-7580 EXT 0',
    population: 9585,
    county: 'GWINNETT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.gwinnetttech.edu/',
  },
  {
    name: 'ESTRELLA MOUNTAIN COMMUNITY COLLEGE',
    address: '3000 N DYSART RD',
    city: 'AVONDALE',
    state: 'AZ',
    zip: 85392,
    telephone: '(623) 935-8000',
    population: 9589,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.estrellamountain.edu/',
  },
  {
    name: 'MISSISSIPPI GULF COAST COMMUNITY COLLEGE',
    address: '51 MAIN STREET',
    city: 'PERKINSTON',
    state: 'MS',
    zip: 39573,
    telephone: '(866) 735-1122',
    population: 9591,
    county: 'STONE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.mgccc.edu/',
  },
  {
    name: 'VOLUNTEER STATE COMMUNITY COLLEGE',
    address: '1480 NASHVILLE PIKE',
    city: 'GALLATIN',
    state: 'TN',
    zip: 37066,
    telephone: '(615) 452-8600',
    population: 9629,
    county: 'SUMNER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.volstate.edu/',
  },
  {
    name: 'LANEY COLLEGE',
    address: '900 FALLON SREET',
    city: 'OAKLAND',
    state: 'CA',
    zip: 94607,
    telephone: '(510) 834-5740',
    population: 9658,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'laney.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTHERN MAINE',
    address: '96 FALMOUTH ST',
    city: 'PORTLAND',
    state: 'ME',
    zip: 4103,
    telephone: '(207) 780-4141',
    population: 9663,
    county: 'CUMBERLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usm.maine.edu/',
  },
  {
    name: 'OHLONE COLLEGE',
    address: '43600 MISSION BLVD',
    city: 'FREMONT',
    state: 'CA',
    zip: 94539,
    telephone: '(510) 659-6000',
    population: 9668,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ohlone.edu/',
  },
  {
    name: 'SANTIAGO CANYON COLLEGE',
    address: '8045 E CHAPMAN',
    city: 'ORANGE',
    state: 'CA',
    zip: 92869,
    telephone: '(714) 628-4900',
    population: 9673,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sccollege.edu/Pages/default.aspx',
  },
  {
    name: 'WEBSTER UNIVERSITY',
    address: '470 E LOCKWOOD AVE.',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63119,
    telephone: '(314) 968-6900',
    population: 9692,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.webster.edu/',
  },
  {
    name: 'BELMONT UNIVERSITY',
    address: '1900 BELMONT BLVD',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37212,
    telephone: '(615) 460-6000',
    population: 9699,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.belmont.edu/',
  },
  {
    name: 'SALISBURY UNIVERSITY',
    address: '1101 CAMDEN AVE',
    city: 'SALISBURY',
    state: 'MD',
    zip: 21801,
    telephone: '(410) 543-6000',
    population: 9718,
    county: 'WICOMICO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.salisbury.edu/',
  },
  {
    name: 'CUNY BRONX COMMUNITY COLLEGE',
    address: '2155 UNIVERSITY AVENUE',
    city: 'BRONX',
    state: 'NY',
    zip: 10453,
    telephone: '(718) 289-5100',
    population: 9718,
    county: 'BRONX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bcc.cuny.edu/',
  },
  {
    name: 'SOUTH PLAINS COLLEGE',
    address: '1401 S. COLLEGE AVE',
    city: 'LEVELLAND',
    state: 'TX',
    zip: 79336,
    telephone: '(806) 894-9611 EXT 2542',
    population: 9724,
    county: 'HOCKLEY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southplainscollege.edu/',
  },
  {
    name: 'ONONDAGA COMMUNITY COLLEGE',
    address: '4585 WEST SENECA TURNPIKE',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13215,
    telephone: '(315) 498-2622',
    population: 9744,
    county: 'ONONDAGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunyocc.edu/',
  },
  {
    name: 'MORENO VALLEY COLLEGE',
    address: '16130 LASSELLE ST',
    city: 'MORENO VALLEY',
    state: 'CA',
    zip: 92551,
    telephone: '(951) 571-6100',
    population: 9754,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mvc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-GREEN BAY',
    address: '2420 NICOLET DR',
    city: 'GREEN BAY',
    state: 'WI',
    zip: 54311,
    telephone: '(920) 465-2111',
    population: 9769,
    county: 'BROWN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwgb.edu/',
  },
  {
    name: 'SOLANO COMMUNITY COLLEGE',
    address: '4000 SUISUN VALLEY RD',
    city: 'FAIRFIELD',
    state: 'CA',
    zip: 94534,
    telephone: '(707) 864-7000',
    population: 9772,
    county: 'SOLANO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.solano.edu/',
  },
  {
    name: 'UNIVERSITY OF MICHIGAN-DEARBORN',
    address: '4901 EVERGREEN RD',
    city: 'DEARBORN',
    state: 'MI',
    zip: 48128,
    telephone: '(313) 593-5000',
    population: 9796,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://umdearborn.edu/',
  },
  {
    name: 'MIDLANDS TECHNICAL COLLEGE',
    address: '1260 LEXINGTON DRIVE',
    city: 'WEST COLUMBIA',
    state: 'SC',
    zip: 29170,
    telephone: '(803) 738-8324',
    population: 9800,
    county: 'LEXINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.midlandstech.edu/',
  },
  {
    name: 'SLIPPERY ROCK UNIVERSITY OF PENNSYLVANIA',
    address: '1 MORROW WAY',
    city: 'SLIPPERY ROCK',
    state: 'PA',
    zip: 16057,
    telephone: '(724) 738-9000',
    population: 9801,
    county: 'BUTLER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sru.edu/',
  },
  {
    name: 'FASHION INSTITUTE OF TECHNOLOGY',
    address: '227 W 27TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10001,
    telephone: '(212) 217-7999',
    population: 9843,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fitnyc.edu/',
  },
  {
    name: 'HUDSON VALLEY COMMUNITY COLLEGE',
    address: '80 VANDENBURGH AVE',
    city: 'TROY',
    state: 'NY',
    zip: 12180,
    telephone: '(518) 629-4822',
    population: 9843,
    county: 'RENSSELAER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hvcc.edu/',
  },
  {
    name: 'EASTERN ILLINOIS UNIVERSITY',
    address: '600 LINCOLN AVENUE',
    city: 'CHARLESTON',
    state: 'IL',
    zip: 61920,
    telephone: '(217) 581-5000',
    population: 9861,
    county: 'COLES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.eiu.edu/',
  },
  {
    name: 'TRITON COLLEGE',
    address: '2000 5TH AVE',
    city: 'RIVER GROVE',
    state: 'IL',
    zip: 60171,
    telephone: '(708) 456-0300',
    population: 9862,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.triton.edu/',
  },
  {
    name: 'UNIVERSITY OF HOUSTON-CLEAR LAKE',
    address: '2700 BAY AREA BLVD',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77058,
    telephone: '(281) 283-7600',
    population: 9873,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uhcl.edu/',
  },
  {
    name: 'UNIVERSITY OF LOUISIANA AT MONROE',
    address: '700 UNIVERSITY AVENUE',
    city: 'MONROE',
    state: 'LA',
    zip: 71209,
    telephone: '(318) 342-1000',
    population: 9908,
    county: 'OUACHITA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ulm.edu/',
  },
  {
    name: 'UNIVERSIDAD ANA G. MENDEZ-CUPEY CAMPUS',
    address: '1399 AVE. ANA G. MENDEZ',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 926,
    telephone: '(787) 766-1717 EXT 6400',
    population: 9913,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'cupey.uagm.edu/',
  },
  {
    name: 'SUNY BUFFALO STATE',
    address: '1300 ELMWOOD AVE',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14222,
    telephone: '(716) 878-4000',
    population: 9915,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'suny.buffalostate.edu/',
  },
  {
    name: 'LOS ANGELES MISSION COLLEGE',
    address: '13356 ELDRIDGE AVENUE',
    city: 'SYLMAR',
    state: 'CA',
    zip: 91342,
    telephone: '(818) 364-7600',
    population: 9947,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lamission.edu/',
  },
  {
    name: 'FOLSOM LAKE COLLEGE',
    address: '10 COLLEGE PARKWAY',
    city: 'FOLSOM',
    state: 'CA',
    zip: 95630,
    telephone: '(916) 608-6572',
    population: 9978,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.flc.losrios.edu/',
  },
  {
    name: 'PENSACOLA STATE COLLEGE',
    address: '1000 COLLEGE BLVD',
    city: 'PENSACOLA',
    state: 'FL',
    zip: 32504,
    telephone: '(850) 484-1000',
    population: 10002,
    county: 'ESCAMBIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pensacolastate.edu/',
  },
  {
    name: 'STATE COLLEGE OF FLORIDA-MANATEE-SARASOTA',
    address: '5840 26TH ST W',
    city: 'BRADENTON',
    state: 'FL',
    zip: 34207,
    telephone: '(941) 752-5000',
    population: 10026,
    county: 'MANATEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.scf.edu/',
  },
  {
    name: 'NORMANDALE COMMUNITY COLLEGE',
    address: '9700 FRANCE AVE S',
    city: 'BLOOMINGTON',
    state: 'MN',
    zip: 55431,
    telephone: '(952) 358-8200',
    population: 10027,
    county: 'HENNEPIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.normandale.edu/',
  },
  {
    name: 'AMARILLO COLLEGE',
    address: '2011 S. WASHINGTON',
    city: 'AMARILLO',
    state: 'TX',
    zip: 79109,
    telephone: '(806) 371-5000',
    population: 10034,
    county: 'POTTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.actx.edu/',
  },
  {
    name: 'JOHN TYLER COMMUNITY COLLEGE',
    address: '13101 JEFFERSON DAVIS HWY',
    city: 'CHESTER',
    state: 'VA',
    zip: 23831,
    telephone: '(804) 796-4000',
    population: 10070,
    county: 'CHESTERFIELD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://jtcc.edu/',
  },
  {
    name: 'ERIE COMMUNITY COLLEGE',
    address: '121 ELLICOTT ST',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14203,
    telephone: '(716) 851-1000',
    population: 10082,
    county: 'ERIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ecc.edu/',
  },
  {
    name: 'ASPEN UNIVERSITY',
    address: '1660 SOUTH ALBION STREET, SUITE 525',
    city: 'DENVER',
    state: 'CO',
    zip: 80222,
    telephone: '(303) 333-4224',
    population: 10113,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aspen.edu/',
  },
  {
    name: 'COLORADO MESA UNIVERSITY',
    address: '1100 NORTH AVENUE',
    city: 'GRAND JUNCTION',
    state: 'CO',
    zip: 81501,
    telephone: '(970) 248-1020',
    population: 10137,
    county: 'MESA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coloradomesa.edu/',
  },
  {
    name: 'LAREDO COLLEGE',
    address: 'WEST END WASHINGTON ST',
    city: 'LAREDO',
    state: 'TX',
    zip: 78040,
    telephone: '(956) 721-5140',
    population: 10149,
    county: 'WEBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.laredo.edu/',
  },
  {
    name: 'TEXAS TECH UNIVERSITY HEALTH SCIENCES CENTER',
    address: '3601 4TH STREET',
    city: 'LUBBOCK',
    state: 'TX',
    zip: 79430,
    telephone: '(806) 743-1000',
    population: 10184,
    county: 'LUBBOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ttuhsc.edu/',
  },
  {
    name: 'CHATTAHOOCHEE TECHNICAL COLLEGE',
    address: '980 S COBB DRIVE DR SE',
    city: 'MARIETTA',
    state: 'GA',
    zip: 30060,
    telephone: '(770) 528-4545',
    population: 10229,
    county: 'COBB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chattahoocheetech.edu/',
  },
  {
    name: 'CAPE FEAR COMMUNITY COLLEGE',
    address: '411 NORTH FRONT STREET',
    city: 'WILMINGTON',
    state: 'NC',
    zip: 28401,
    telephone: '(910) 362-7000',
    population: 10231,
    county: 'NEW HANOVER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cfcc.edu/',
  },
  {
    name: 'DARTMOUTH COLLEGE',
    address: '207 PARKHURST HALL',
    city: 'HANOVER',
    state: 'NH',
    zip: 3755,
    telephone: '(603) 646-1110',
    population: 10253,
    county: 'GRAFTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.dartmouth.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS AT LITTLE ROCK',
    address: '2801 S UNIVERSITY AVE',
    city: 'LITTLE ROCK',
    state: 'AR',
    zip: 72204,
    telephone: '(501) 569-3000',
    population: 10287,
    county: 'PULASKI',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ualr.edu/www/',
  },
  {
    name: 'PELLISSIPPI STATE COMMUNITY COLLEGE',
    address: '10915 HARDIN VALLEY ROAD',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37933,
    telephone: '(865) 694-6400 EXT 6526',
    population: 10318,
    county: 'KNOX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pstcc.edu/',
  },
  {
    name: 'BUTTE COLLEGE',
    address: '3536 BUTTE CAMPUS DRIVE',
    city: 'OROVILLE',
    state: 'CA',
    zip: 95965,
    telephone: '(530) 895-2511',
    population: 10345,
    county: 'BUTTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.butte.edu/',
  },
  {
    name: 'MOREHEAD STATE UNIVERSITY',
    address: 'UNIVERSITY BLVD',
    city: 'MOREHEAD',
    state: 'KY',
    zip: 40351,
    telephone: '(606) 783-2000',
    population: 10349,
    county: 'ROWAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.moreheadstate.edu/',
  },
  {
    name: 'JACKSONVILLE STATE UNIVERSITY',
    address: '700 PELHAM ROAD NORTH',
    city: 'JACKSONVILLE',
    state: 'AL',
    zip: 36265,
    telephone: '(256) 782-5781',
    population: 10356,
    county: 'CALHOUN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jsu.edu/',
  },
  {
    name: 'EMBRY-RIDDLE AERONAUTICAL UNIVERSITY-DAYTONA BEACH',
    address: '1 AEROSPACE BLVD.',
    city: 'DAYTONA BEACH',
    state: 'FL',
    zip: 32114,
    telephone: '(386) 226-6000',
    population: 10365,
    county: 'VOLUSIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'daytonabeach.erau.edu/',
  },
  {
    name: 'SOUTHEASTERN UNIVERSITY',
    address: '1000 LONGFELLOW BLVD',
    city: 'LAKELAND',
    state: 'FL',
    zip: 33801,
    telephone: '(863) 667-5000',
    population: 10410,
    county: 'POLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.seu.edu/',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY-SHREVEPORT',
    address: 'ONE UNIVERSITY PLACE',
    city: 'SHREVEPORT',
    state: 'LA',
    zip: 71115,
    telephone: '(318) 797-5000',
    population: 10422,
    county: 'CADDO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lsus.edu/',
  },
  {
    name: 'SOUTHEAST COMMUNITY COLLEGE AREA',
    address: '301 SOUTH 68TH STREET PLACE',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68510,
    telephone: '(402) 471-3333',
    population: 10433,
    county: 'LANCASTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.southeast.edu/',
  },
  {
    name: 'STRAYER UNIVERSITY-GLOBAL REGION',
    address: '1133 15TH ST NW, SUITE 200',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20005,
    telephone: '(877) 445-7180',
    population: 10457,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.strayer.edu/',
  },
  {
    name: 'SANTA CLARA UNIVERSITY',
    address: '500 EL CAMINO REAL',
    city: 'SANTA CLARA',
    state: 'CA',
    zip: 95053,
    telephone: '(408) 554-4000',
    population: 10459,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scu.edu/',
  },
  {
    name: 'UNIVERSITY OF TEXAS SOUTHWESTERN MEDICAL CENTER',
    address: '5323 HARRY HINES BLVD',
    city: 'DALLAS',
    state: 'TX',
    zip: 75390,
    telephone: '(214) 648-3606',
    population: 10487,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utsouthwestern.edu/',
  },
  {
    name: 'BAYLOR COLLEGE OF MEDICINE',
    address: 'ONE BAYLOR PLAZA',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77030,
    telephone: '(713) 798-4951',
    population: 10496,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bcm.edu/',
  },
  {
    name: 'PURDUE UNIVERSITY NORTHWEST',
    address: '2200 169TH STREET',
    city: 'HAMMOND',
    state: 'IN',
    zip: 46323,
    telephone: '(219) 989-2400',
    population: 10505,
    county: 'LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pnw.edu/',
  },
  {
    name: 'ACADEMY OF ART UNIVERSITY',
    address: '79 NEW MONTGOMERY',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94105,
    telephone: '(800) 544-2787',
    population: 10505,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.academyart.edu/',
  },
  {
    name: 'PRAIRIE VIEW A & M UNIVERSITY',
    address: 'FM 1098 ROAD & UNIVERSITY DRIVE',
    city: 'PRAIRIE VIEW',
    state: 'TX',
    zip: 77446,
    telephone: '(936) 261-3311',
    population: 10518,
    county: 'WALLER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pvamu.edu/',
  },
  {
    name: 'RASMUSSEN UNIVERSITY-FLORIDA',
    address: '4755 SOUTHWEST 46TH COURT',
    city: 'OCALA',
    state: 'FL',
    zip: 34474,
    telephone: '(352) 629-1941',
    population: 10519,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://rasmussen.edu/',
  },
  {
    name: 'CABRILLO COLLEGE',
    address: '6500 SOQUEL DR',
    city: 'APTOS',
    state: 'CA',
    zip: 95003,
    telephone: '(831) 479-6100',
    population: 10545,
    county: 'SANTA CRUZ',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cabrillo.edu/',
  },
  {
    name: 'PASCO-HERNANDO STATE COLLEGE',
    address: '10230 RIDGE ROAD',
    city: 'NEW PORT RICHEY',
    state: 'FL',
    zip: 34654,
    telephone: '(727) 847-2727',
    population: 10631,
    county: 'PASCO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.phsc.edu/',
  },
  {
    name: 'MURRAY STATE UNIVERSITY',
    address: '218 WELLS HALL',
    city: 'MURRAY',
    state: 'KY',
    zip: 42071,
    telephone: '(270) 809-3011',
    population: 10745,
    county: 'CALLOWAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.murraystate.edu/',
  },
  {
    name: 'NORCO COLLEGE',
    address: '2001 THIRD ST',
    city: 'NORCO',
    state: 'CA',
    zip: 92860,
    telephone: '(951) 372-7000',
    population: 10748,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.norcocollege.edu/Pages/index.aspx',
  },
  {
    name: 'HOWARD COMMUNITY COLLEGE',
    address: '10901 LITTLE PATUXENT PKWY',
    city: 'COLUMBIA',
    state: 'MD',
    zip: 21044,
    telephone: '(443) 518-1000',
    population: 10755,
    county: 'HOWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.howardcc.edu/',
  },
  {
    name: 'NORTHAMPTON COUNTY AREA COMMUNITY COLLEGE',
    address: '3835 GREEN POND RD',
    city: 'BETHLEHEM',
    state: 'PA',
    zip: 18020,
    telephone: '(610) 861-5300',
    population: 10770,
    county: 'NORTHAMPTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.northampton.edu/',
  },
  {
    name: 'CUESTA COLLEGE',
    address: 'HIGHWAY 1',
    city: 'SAN LUIS OBISPO',
    state: 'CA',
    zip: 93403,
    telephone: '(805) 546-3100',
    population: 10780,
    county: 'SAN LUIS OBISPO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cuesta.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-MERCED',
    address: '5200 NORTH LAKE ROAD',
    city: 'MERCED',
    state: 'CA',
    zip: 95343,
    telephone: '(209) 228-4400',
    population: 10802,
    county: 'MERCED',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ucmerced.edu/',
  },
  {
    name: 'THOMAS EDISON STATE UNIVERSITY',
    address: '111 W STATE ST',
    city: 'TRENTON',
    state: 'NJ',
    zip: 8608,
    telephone: '(609) 984-1100 EXT 2025',
    population: 10804,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tesu.edu/',
  },
  {
    name: 'PHOENIX COLLEGE',
    address: '1202 W THOMAS RD',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85013,
    telephone: '(602) 264-2492',
    population: 10841,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.phoenixcollege.edu/',
  },
  {
    name: 'BUNKER HILL COMMUNITY COLLEGE',
    address: '250 NEW RUTHERFORD AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2129,
    telephone: '(617) 228-2000',
    population: 10853,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bhcc.mass.edu/',
  },
  {
    name: 'POLK STATE COLLEGE',
    address: '999 AVENUE H NE',
    city: 'WINTER HAVEN',
    state: 'FL',
    zip: 33881,
    telephone: '(863) 297-1000',
    population: 10892,
    county: 'POLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.polk.edu/',
  },
  {
    name: 'SACRED HEART UNIVERSITY',
    address: '5151 PARK AVE',
    city: 'FAIRFIELD',
    state: 'CT',
    zip: 6825,
    telephone: '(203) 371-7999',
    population: 10896,
    county: 'FAIRFIELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sacredheart.edu/',
  },
  {
    name: 'MONTGOMERY COUNTY COMMUNITY COLLEGE',
    address: '340 DEKALB PIKE',
    city: 'BLUE BELL',
    state: 'PA',
    zip: 19422,
    telephone: '(215) 641-6300',
    population: 10900,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mc3.edu/',
  },
  {
    name: 'DUQUESNE UNIVERSITY',
    address: 'ADMINISTRATION BLDG 600 FORBES AVE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15282,
    telephone: '(412) 396-6000',
    population: 10939,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.duq.edu/',
  },
  {
    name: 'INDIANA WESLEYAN UNIVERSITY-NATIONAL & GLOBAL',
    address: '1900 WEST 50TH STREET',
    city: 'MARION',
    state: 'IN',
    zip: 46953,
    telephone: '(765) 677-2870',
    population: 10944,
    county: 'GRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.indwes.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TAMPA',
    address: '401 W KENNEDY BLVD',
    city: 'TAMPA',
    state: 'FL',
    zip: 33606,
    telephone: '(813) 253-3333',
    population: 10960,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ut.edu/',
  },
  {
    name: 'DELAWARE COUNTY COMMUNITY COLLEGE',
    address: '901 S MEDIA LINE RD',
    city: 'MEDIA',
    state: 'PA',
    zip: 19063,
    telephone: '(610) 359-5000',
    population: 10961,
    county: 'DELAWARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dccc.edu/',
  },
  {
    name: 'WEST TEXAS A & M UNIVERSITY',
    address: '2501 4TH AVE',
    city: 'CANYON',
    state: 'TX',
    zip: 79016,
    telephone: '(806) 651-0000',
    population: 10964,
    county: 'RANDALL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wtamu.edu/',
  },
  {
    name: 'MERCER UNIVERSITY',
    address: '1501 MERCER UNIVERSITY DRIVE',
    city: 'MACON',
    state: 'GA',
    zip: 31207,
    telephone: '(478) 301-2700',
    population: 10965,
    county: 'BIBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mercer.edu/',
  },
  {
    name: 'AZUSA PACIFIC UNIVERSITY',
    address: '901 E ALOSTA',
    city: 'AZUSA',
    state: 'CA',
    zip: 91702,
    telephone: '(626) 969-3434',
    population: 10969,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.apu.edu/',
  },
  {
    name: 'CREIGHTON UNIVERSITY',
    address: '2500 CALIFORNIA PLAZA',
    city: 'OMAHA',
    state: 'NE',
    zip: 68178,
    telephone: '(402) 280-2700',
    population: 11004,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.creighton.edu/',
  },
  {
    name: 'FLORIDA AGRICULTURAL AND MECHANICAL UNIVERSITY',
    address: '1500 S MARTIN LUTHER KING JR BLVD',
    city: 'TALLAHASSEE',
    state: 'FL',
    zip: 32307,
    telephone: '(850) 599-3000',
    population: 11014,
    county: 'LEON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.famu.edu/',
  },
  {
    name: 'CUNY GRADUATE SCHOOL AND UNIVERSITY CENTER',
    address: '365 FIFTH AVE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10016,
    telephone: '(212) 817-7000',
    population: 11015,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gc.cuny.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH DAKOTA',
    address: '414 E CLARK ST',
    city: 'VERMILLION',
    state: 'SD',
    zip: 57069,
    telephone: '(605) 658-6200',
    population: 11026,
    county: 'CLAY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usd.edu/',
  },
  {
    name: 'MERCY COLLEGE',
    address: '555 BROADWAY',
    city: 'DOBBS FERRY',
    state: 'NY',
    zip: 10522,
    telephone: '(800) 637-2969',
    population: 11039,
    county: 'WESTCHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.mercy.edu/',
  },
  {
    name: 'SOUTHERN CONNECTICUT STATE UNIVERSITY',
    address: '501 CRESCENT STREET',
    city: 'NEW HAVEN',
    state: 'CT',
    zip: 6515,
    telephone: '(203) 392-5200',
    population: 11055,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southernct.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT TYLER',
    address: '3900 UNIVERSITY BLVD',
    city: 'TYLER',
    state: 'TX',
    zip: 75799,
    telephone: '(903) 566-7000',
    population: 11071,
    county: 'SMITH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uttyler.edu/',
  },
  {
    name: 'ALLAN HANCOCK COLLEGE',
    address: '800 SOUTH COLLEGE DRIVE',
    city: 'SANTA MARIA',
    state: 'CA',
    zip: 93454,
    telephone: '(805) 922-6966',
    population: 11085,
    county: 'SANTA BARBARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hancockcollege.edu/',
  },
  {
    name: 'REGENT UNIVERSITY',
    address: '1000 REGENT UNIVERSITY DR',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23464,
    telephone: '(757) 352-4127',
    population: 11143,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.regent.edu/',
  },
  {
    name: 'TRUCKEE MEADOWS COMMUNITY COLLEGE',
    address: '7000 DANDINI BLVD',
    city: 'RENO',
    state: 'NV',
    zip: 89512,
    telephone: '(775) 673-7000',
    population: 11172,
    county: 'WASHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tmcc.edu/',
  },
  {
    name: 'RICE UNIVERSITY',
    address: '6100 S MAIN ST',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77005,
    telephone: '(713) 348-0000',
    population: 11186,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rice.edu/',
  },
  {
    name: 'SOUTHEAST MISSOURI STATE UNIVERSITY',
    address: 'ONE UNIVERSITY PLAZA, MS2025',
    city: 'CAPE GIRARDEAU',
    state: 'MO',
    zip: 63701,
    telephone: '(573) 651-2000',
    population: 11205,
    county: 'CAPE GIRARDEAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.semo.edu/',
  },
  {
    name: 'LORAIN COUNTY COMMUNITY COLLEGE',
    address: '1005 NORTH ABBE RD',
    city: 'ELYRIA',
    state: 'OH',
    zip: 44035,
    telephone: '(440) 365-5222',
    population: 11208,
    county: 'LORAIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lorainccc.edu/',
  },
  {
    name: 'BLUEGRASS COMMUNITY AND TECHNICAL COLLEGE',
    address: '470 COOPER DRIVE',
    city: 'LEXINGTON',
    state: 'KY',
    zip: 40506,
    telephone: '(859) 246-6200',
    population: 11216,
    county: 'FAYETTE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://bluegrass.kctcs.edu/',
  },
  {
    name: 'UNIVERSITY OF SAN DIEGO',
    address: '5998 ALCALA PARK',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92110,
    telephone: '(619) 260-4600',
    population: 11226,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sandiego.edu/',
  },
  {
    name: 'UNIVERSITY OF CENTRAL MISSOURI',
    address: '108 W SOUTH STREET',
    city: 'WARRENSBURG',
    state: 'MO',
    zip: 64093,
    telephone: '(660) 543-4111',
    population: 11236,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ucmo.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTHERN IOWA',
    address: '1227 W 27TH ST',
    city: 'CEDAR FALLS',
    state: 'IA',
    zip: 50614,
    telephone: '(319) 273-2311',
    population: 11264,
    county: 'BLACK HAWK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uni.edu/',
  },
  {
    name: 'MIDDLESEX COUNTY COLLEGE',
    address: '2600 WOODBRIDGE AVENUE',
    city: 'EDISON',
    state: 'NJ',
    zip: 8818,
    telephone: '(732) 548-6000',
    population: 11266,
    county: 'MIDDLESEX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.middlesexcc.edu/',
  },
  {
    name: 'BROOKDALE COMMUNITY COLLEGE',
    address: '765 NEWMAN SPRINGS RD',
    city: 'LINCROFT',
    state: 'NJ',
    zip: 7738,
    telephone: '(732) 224-2345',
    population: 11294,
    county: 'MONMOUTH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.brookdalecc.edu/',
  },
  {
    name: 'SUNY WESTCHESTER COMMUNITY COLLEGE',
    address: '75 GRASSLANDS ROAD',
    city: 'VALHALLA',
    state: 'NY',
    zip: 10595,
    telephone: '(914) 606-6600',
    population: 11296,
    county: 'WESTCHESTER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sunywcc.edu/',
  },
  {
    name: 'SAINT LEO UNIVERSITY',
    address: '33701 STATE ROAD 52',
    city: 'SAINT LEO',
    state: 'FL',
    zip: 33574,
    telephone: '(352) 588-8200',
    population: 11331,
    county: 'PASCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.saintleo.edu/',
  },
  {
    name: 'MERCED COLLEGE',
    address: '3600 M ST',
    city: 'MERCED',
    state: 'CA',
    zip: 95348,
    telephone: '(209) 384-6000',
    population: 11476,
    county: 'MERCED',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mccd.edu/',
  },
  {
    name: 'STOCKTON UNIVERSITY',
    address: '101 VERA KING FARRIS DRIVE',
    city: 'GALLOWAY',
    state: 'NJ',
    zip: 8205,
    telephone: '(609) 652-1776',
    population: 11479,
    county: 'ATLANTIC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stockton.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTHERN INDIANA',
    address: '8600 UNIVERSITY BLVD',
    city: 'EVANSVILLE',
    state: 'IN',
    zip: 47712,
    telephone: '(812) 464-8600',
    population: 11480,
    county: 'VANDERBURGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usi.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY OF PENNSYLVANIA-MAIN CAMPUS',
    address: '1011 SOUTH DR 201 SUTTON HALL',
    city: 'INDIANA',
    state: 'PA',
    zip: 15705,
    telephone: '(724) 357-2100',
    population: 11480,
    county: 'INDIANA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iup.edu/',
  },
  {
    name: 'MONROE COMMUNITY COLLEGE',
    address: '1000 E HENRIETTA RD',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14623,
    telephone: '(585) 292-2000',
    population: 11482,
    county: 'MONROE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.monroecc.edu/',
  },
  {
    name: 'FARMINGDALE STATE COLLEGE',
    address: '2350 BROADHOLLOW ROAD',
    city: 'FARMINGDALE',
    state: 'NY',
    zip: 11735,
    telephone: '(934) 420-2000',
    population: 11492,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.farmingdale.edu/',
  },
  {
    name: 'PARK UNIVERSITY',
    address: '8700 NW RIVER PARK DR',
    city: 'PARKVILLE',
    state: 'MO',
    zip: 64152,
    telephone: '(816) 741-2000',
    population: 11508,
    county: 'PLATTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.park.edu/',
  },
  {
    name: 'WILLIAM PATERSON UNIVERSITY OF NEW JERSEY',
    address: '300 POMPTON RD',
    city: 'WAYNE',
    state: 'NJ',
    zip: 7470,
    telephone: '(973) 720-2000',
    population: 11518,
    county: 'PASSAIC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wpunj.edu/',
  },
  {
    name: 'TENNESSEE TECHNOLOGICAL UNIVERSITY',
    address: '1 WILLIAM L. JONES DRIVE',
    city: 'COOKEVILLE',
    state: 'TN',
    zip: 38505,
    telephone: '(931) 372-3101',
    population: 11533,
    county: 'PUTNAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tntech.edu/',
  },
  {
    name: 'QUINNIPIAC UNIVERSITY',
    address: 'MT CARMEL AVE',
    city: 'HAMDEN',
    state: 'CT',
    zip: 6518,
    telephone: '(203) 582-8200',
    population: 11564,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.qu.edu/',
  },
  {
    name: 'UNIVERSITY OF ST THOMAS',
    address: '2115 SUMMIT AVE',
    city: 'SAINT PAUL',
    state: 'MN',
    zip: 55105,
    telephone: '(651) 962-5000',
    population: 11572,
    county: 'RAMSEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stthomas.edu/',
  },
  {
    name: 'VICTOR VALLEY COLLEGE',
    address: '18422 BEAR VALLEY RD',
    city: 'VICTORVILLE',
    state: 'CA',
    zip: 92395,
    telephone: '(760) 245-4271 EXT 2395',
    population: 11577,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.vvc.edu/',
  },
  {
    name: 'UNIVERSITY OF ALABAMA IN HUNTSVILLE',
    address: '301 SPARKMAN DR',
    city: 'HUNTSVILLE',
    state: 'AL',
    zip: 35899,
    telephone: '(256) 824-6120',
    population: 11591,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uah.edu/',
  },
  {
    name: 'STARK STATE COLLEGE',
    address: '6200 FRANK AVE NW',
    city: 'NORTH CANTON',
    state: 'OH',
    zip: 44720,
    telephone: '(330) 494-6170',
    population: 11594,
    county: 'STARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.starkstate.edu/',
  },
  {
    name: 'SETON HALL UNIVERSITY',
    address: '400 S ORANGE AVE',
    city: 'SOUTH ORANGE',
    state: 'NJ',
    zip: 7079,
    telephone: '(973) 761-9000',
    population: 11614,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.shu.edu/',
  },
  {
    name: 'COASTAL CAROLINA UNIVERSITY',
    address: '103 TOM TROUT DRIVE',
    city: 'CONWAY',
    state: 'SC',
    zip: 29526,
    telephone: '(843) 347-3161',
    population: 11621,
    county: 'HORRY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coastal.edu/',
  },
  {
    name: 'PEPPERDINE UNIVERSITY',
    address: '24255 PACIFIC COAST HWY',
    city: 'MALIBU',
    state: 'CA',
    zip: 90263,
    telephone: '(310) 506-4000',
    population: 11626,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pepperdine.edu/',
  },
  {
    name: 'AUSTIN PEAY STATE UNIVERSITY',
    address: '601 COLLEGE ST',
    city: 'CLARKSVILLE',
    state: 'TN',
    zip: 37044,
    telephone: '(931) 221-7011',
    population: 11626,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.apsu.edu/',
  },
  {
    name: 'COLLEGE OF WESTERN IDAHO',
    address: '5500 EAST OPPORTUNITY DRIVE',
    city: 'NAMPA',
    state: 'ID',
    zip: 83687,
    telephone: '(208) 562-3000',
    population: 11643,
    county: 'CANYON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://cwi.edu/',
  },
  {
    name: 'CENTRAL TEXAS COLLEGE',
    address: '6200 WEST CENTRAL TEXAS EXPRESSWAY',
    city: 'KILLEEN',
    state: 'TX',
    zip: 76549,
    telephone: '(254) 526-7161',
    population: 11681,
    county: 'CORYELL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ctcd.edu/',
  },
  {
    name: 'JOLIET JUNIOR COLLEGE',
    address: '1215 HOUBOLT RD',
    city: 'JOLIET',
    state: 'IL',
    zip: 60431,
    telephone: '(815) 729-9020',
    population: 11692,
    county: 'WILL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jjc.edu/',
  },
  {
    name: 'ANGELO STATE UNIVERSITY',
    address: '2601 W. AVENUE N',
    city: 'SAN ANGELO',
    state: 'TX',
    zip: 76909,
    telephone: '(325) 942-2555',
    population: 11732,
    county: 'TOM GREEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.angelo.edu/',
  },
  {
    name: 'COLLEGE OF THE DESERT',
    address: '43-500 MONTEREY AVE',
    city: 'PALM DESERT',
    state: 'CA',
    zip: 92260,
    telephone: '(760) 346-8041',
    population: 11741,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.collegeofthedesert.edu/',
  },
  {
    name: 'WILLIAM & MARY',
    address: '200 RICHMOND ROAD',
    city: 'WILLIAMSBURG',
    state: 'VA',
    zip: 23187,
    telephone: '(757) 221-4000',
    population: 11750,
    county: 'WILLIAMSBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wm.edu/',
  },
  {
    name: 'PALO ALTO COLLEGE',
    address: '1400 W VILLARET BLVD',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78224,
    telephone: '(210) 486-3000',
    population: 11760,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'alamo.edu/pac/',
  },
  {
    name: 'GREENVILLE TECHNICAL COLLEGE',
    address: '506 S PLEASANTBURG DR',
    city: 'GREENVILLE',
    state: 'SC',
    zip: 29606,
    telephone: '(864) 250-8000',
    population: 11796,
    county: 'GREENVILLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gvltec.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-LA CROSSE',
    address: '1725 STATE ST',
    city: 'LA CROSSE',
    state: 'WI',
    zip: 54601,
    telephone: '(608) 785-8000',
    population: 11808,
    county: 'LA CROSSE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwlax.edu/',
  },
  {
    name: 'WAYNE COUNTY COMMUNITY COLLEGE DISTRICT',
    address: '801 W. FORT STREET',
    city: 'DETROIT',
    state: 'MI',
    zip: 48226,
    telephone: '(313) 496-2600',
    population: 11826,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wcccd.edu/',
  },
  {
    name: 'NORTHEAST WISCONSIN TECHNICAL COLLEGE',
    address: '2740 W MASON ST',
    city: 'GREEN BAY',
    state: 'WI',
    zip: 54307,
    telephone: '(920) 498-5400',
    population: 11851,
    county: 'BROWN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nwtc.edu/',
  },
  {
    name: 'UNIVERSITY OF MINNESOTA-DULUTH',
    address: '515 DARLAND ADMINISTRATION BLDG',
    city: 'DULUTH',
    state: 'MN',
    zip: 55812,
    telephone: '(218) 726-8000',
    population: 11858,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.d.umn.edu/',
  },
  {
    name: 'LOYOLA MARYMOUNT UNIVERSITY',
    address: 'ONE LMU DRIVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90045,
    telephone: '(310) 338-2700',
    population: 11878,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.lmu.edu/',
  },
  {
    name: 'SUNY EMPIRE STATE COLLEGE',
    address: 'TWO UNION AVE',
    city: 'SARATOGA SPRINGS',
    state: 'NY',
    zip: 12866,
    telephone: '(518) 587-2100',
    population: 11890,
    county: 'SARATOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.esc.edu/',
  },
  {
    name: 'UNIVERSITY OF CENTRAL ARKANSAS',
    address: '201 DONAGHEY AVE',
    city: 'CONWAY',
    state: 'AR',
    zip: 72035,
    telephone: '(501) 450-5000',
    population: 11890,
    county: 'FAULKNER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uca.edu/',
  },
  {
    name: 'CHAPMAN UNIVERSITY',
    address: 'ONE UNIVERSITY DR.',
    city: 'ORANGE',
    state: 'CA',
    zip: 92866,
    telephone: '(714) 997-6815',
    population: 11951,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chapman.edu/',
  },
  {
    name: 'ARKANSAS TECH UNIVERSITY',
    address: 'ADMINISTRATION BLDG 200, 1509 N BOULDER AVE',
    city: 'RUSSELLVILLE',
    state: 'AR',
    zip: 72801,
    telephone: '(844) 804-2628',
    population: 11954,
    county: 'POPE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.atu.edu/',
  },
  {
    name: 'LOS ANGELES TRADE TECHNICAL COLLEGE',
    address: '400 W WASHINGTON BLVD',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90015,
    telephone: '(213) 763-7000',
    population: 12014,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lattc.edu/',
  },
  {
    name: 'THE UNIVERSITY OF MONTANA',
    address: 'MISSOULA, MONTANA',
    city: 'MISSOULA',
    state: 'MT',
    zip: 59812,
    telephone: '(406) 243-0211',
    population: 12017,
    county: 'MISSOULA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umt.edu/',
  },
  {
    name: 'GUILFORD TECHNICAL COMMUNITY COLLEGE',
    address: '601 E. MAIN STREET',
    city: 'JAMESTOWN',
    state: 'NC',
    zip: 27282,
    telephone: '(336) 334-4822',
    population: 12017,
    county: 'GUILFORD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gtcc.edu/',
  },
  {
    name: 'GOLDEN WEST COLLEGE',
    address: '15744 GOLDENWEST ST.',
    city: 'HUNTINGTON BEACH',
    state: 'CA',
    zip: 92647,
    telephone: '(714) 892-7711',
    population: 12031,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.goldenwestcollege.edu/',
  },
  {
    name: 'WEST LOS ANGELES COLLEGE',
    address: '9000 OVERLAND AVENUE',
    city: 'CULVER CITY',
    state: 'CA',
    zip: 90230,
    telephone: '(310) 287-4200',
    population: 12061,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wlac.edu/',
  },
  {
    name: 'THE NEW SCHOOL',
    address: '66 WEST 12TH STREET',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10011,
    telephone: '(212) 229-5600',
    population: 12064,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.newschool.edu/',
  },
  {
    name: 'UNIVERSITY OF SAN FRANCISCO',
    address: '2130 FULTON ST',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94117,
    telephone: '(415) 422-5555',
    population: 12077,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usfca.edu/',
  },
  {
    name: 'DEL MAR COLLEGE',
    address: '101 BALDWIN BLVD.',
    city: 'CORPUS CHRISTI',
    state: 'TX',
    zip: 78404,
    telephone: '(361) 698-1200',
    population: 12096,
    county: 'NUECES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.delmar.edu/',
  },
  {
    name: 'BRIDGEWATER STATE UNIVERSITY',
    address: '131 SUMMER STREET',
    city: 'BRIDGEWATER',
    state: 'MA',
    zip: 2325,
    telephone: '(508) 531-1000',
    population: 12164,
    county: 'PLYMOUTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bridgew.edu/',
  },
  {
    name: 'TEXAS STATE TECHNICAL COLLEGE',
    address: '3801 CAMPUS DRIVE',
    city: 'WACO',
    state: 'TX',
    zip: 76705,
    telephone: '(800) 792-8784',
    population: 12178,
    county: 'MCLENNAN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tstc.edu/',
  },
  {
    name: 'MORAINE VALLEY COMMUNITY COLLEGE',
    address: '9000 W. COLLEGE PARKWAY',
    city: 'PALOS HILLS',
    state: 'IL',
    zip: 60465,
    telephone: '(708) 974-4300',
    population: 12182,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.morainevalley.edu/',
  },
  {
    name: 'CENTRAL CONNECTICUT STATE UNIVERSITY',
    address: '1615 STANLEY ST',
    city: 'NEW BRITAIN',
    state: 'CT',
    zip: 6050,
    telephone: '(860) 832-2278',
    population: 12196,
    county: 'HARTFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www2.ccsu.edu/',
  },
  {
    name: 'LANSING COMMUNITY COLLEGE',
    address: '610 N CAPITOL AVE',
    city: 'LANSING',
    state: 'MI',
    zip: 48933,
    telephone: '(517) 483-1957',
    population: 12207,
    county: 'INGHAM',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.lcc.edu/',
  },
  {
    name: 'COLLEGE OF CHARLESTON',
    address: '66 GEORGE ST',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29424,
    telephone: '(843) 953-5500',
    population: 12242,
    county: 'CHARLESTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cofc.edu/',
  },
  {
    name: 'FAYETTEVILLE TECHNICAL COMMUNITY COLLEGE',
    address: '2201 HULL RD',
    city: 'FAYETTEVILLE',
    state: 'NC',
    zip: 28303,
    telephone: '(910) 678-8400',
    population: 12266,
    county: 'CUMBERLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.faytechcc.edu/',
  },
  {
    name: 'HENRY FORD COLLEGE',
    address: '5101 EVERGREEN RD',
    city: 'DEARBORN',
    state: 'MI',
    zip: 48128,
    telephone: '(313) 845-9600',
    population: 12290,
    county: 'WAYNE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hfcc.edu/',
  },
  {
    name: 'TEXAS A & M UNIVERSITY-CORPUS CHRISTI',
    address: '6300 OCEAN DR.',
    city: 'CORPUS CHRISTI',
    state: 'TX',
    zip: 78412,
    telephone: '(361) 825-5700',
    population: 12293,
    county: 'NUECES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tamucc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-EAU CLAIRE',
    address: '105 GARFIELD AVE',
    city: 'EAU CLAIRE',
    state: 'WI',
    zip: 54701,
    telephone: '(715) 836-4636',
    population: 12300,
    county: 'EAU CLAIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwec.edu/',
  },
  {
    name: 'WASHTENAW COMMUNITY COLLEGE',
    address: '4800 E HURON RIVER DR',
    city: 'ANN ARBOR',
    state: 'MI',
    zip: 48105,
    telephone: '(734) 973-3300',
    population: 12355,
    county: 'WASHTENAW',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.wccnet.edu/',
  },
  {
    name: 'VENTURA COLLEGE',
    address: '4667 TELEGRAPH RD',
    city: 'VENTURA',
    state: 'CA',
    zip: 93003,
    telephone: '(805) 654-6400',
    population: 12365,
    county: 'VENTURA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.venturacollege.edu/',
  },
  {
    name: 'RADFORD UNIVERSITY',
    address: '801 EAST MAIN ST.',
    city: 'RADFORD',
    state: 'VA',
    zip: 24142,
    telephone: '(540) 831-5000',
    population: 12399,
    county: 'RADFORD CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.radford.edu/',
  },
  {
    name: 'BRANDMAN UNIVERSITY',
    address: '16355 LAGUNA CANYON ROAD',
    city: 'IRVINE',
    state: 'CA',
    zip: 92618,
    telephone: '(949) 341-9800',
    population: 12399,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brandman.edu/',
  },
  {
    name: 'MARYVILLE UNIVERSITY OF SAINT LOUIS',
    address: '650 MARYVILLE UNIVERSITY DRIVE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63141,
    telephone: '(800) 627-9855',
    population: 12436,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.maryville.edu/',
  },
  {
    name: 'LOUISIANA TECH UNIVERSITY',
    address: '1310 WEST RAILROAD AVENUE',
    city: 'RUSTON',
    state: 'LA',
    zip: 71272,
    telephone: '(318) 257-2000',
    population: 12449,
    county: 'LINCOLN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.latech.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-STANISLAUS',
    address: 'ONE UNIVERSITY CIRCLE',
    city: 'TURLOCK',
    state: 'CA',
    zip: 95382,
    telephone: '(209) 667-3122',
    population: 12452,
    county: 'STANISLAUS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csustan.edu/',
  },
  {
    name: 'NORTHWESTERN STATE UNIVERSITY OF LOUISIANA',
    address: '175 SAM SIBLEY DRIVE',
    city: 'NATCHITOCHES',
    state: 'LA',
    zip: 71497,
    telephone: '(318) 357-6011',
    population: 12460,
    county: 'NATCHITOCHES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nsula.edu/',
  },
  {
    name: 'BERGEN COMMUNITY COLLEGE',
    address: '400 PARAMUS RD',
    city: 'PARAMUS',
    state: 'NJ',
    zip: 7652,
    telephone: '(201) 447-7200',
    population: 12569,
    county: 'BERGEN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.bergen.edu/',
  },
  {
    name: 'NORTHEASTERN UNIVERSITY LIFELONG LEARNING NETWORK',
    address: '360 HUNTINGTON AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 373-2000',
    population: 12592,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.northeastern.edu/learnforlife/',
  },
  {
    name: 'INDEPENDENCE UNIVERSITY',
    address: '4021 S 700 E STE 400',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84107,
    telephone: '(800) 972-5149',
    population: 12602,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.independence.edu/',
  },
  {
    name: 'INDIANA STATE UNIVERSITY',
    address: '210 N 7TH ST',
    city: 'TERRE HAUTE',
    state: 'IN',
    zip: 47809,
    telephone: '(812) 237-6311',
    population: 12614,
    county: 'VIGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.indstate.edu/',
  },
  {
    name: 'CITRUS COLLEGE',
    address: '1000 W FOOTHILL BLVD',
    city: 'GLENDORA',
    state: 'CA',
    zip: 91741,
    telephone: '(626) 963-0323',
    population: 12619,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.citruscollege.edu/',
  },
  {
    name: 'CHABOT COLLEGE',
    address: '25555 HESPERIAN BLVD',
    city: 'HAYWARD',
    state: 'CA',
    zip: 94545,
    telephone: '(510) 723-6600',
    population: 12626,
    county: 'ALAMEDA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.chabotcollege.edu/',
  },
  {
    name: 'GEORGIA GWINNETT COLLEGE',
    address: '1000 UNIVERSITY CENTER LANE',
    city: 'LAWRENCEVILLE',
    state: 'GA',
    zip: 30043,
    telephone: '(678) 407-5000',
    population: 12641,
    county: 'GWINNETT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ggc.edu/',
  },
  {
    name: 'TRIDENT TECHNICAL COLLEGE',
    address: '7000 RIVERS AVENUE',
    city: 'CHARLESTON',
    state: 'SC',
    zip: 29423,
    telephone: '(843) 574-6111',
    population: 12684,
    county: 'CHARLESTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.tridenttech.edu/',
  },
  {
    name: 'TALLAHASSEE COMMUNITY COLLEGE',
    address: '444 APPLEYARD DR',
    city: 'TALLAHASSEE',
    state: 'FL',
    zip: 32304,
    telephone: '(850) 201-6200',
    population: 12688,
    county: 'LEON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tcc.fl.edu/',
  },
  {
    name: 'CENTRAL WASHINGTON UNIVERSITY',
    address: '400 EAST UNIVERSITY WAY',
    city: 'ELLENSBURG',
    state: 'WA',
    zip: 98926,
    telephone: '(509) 963-1111',
    population: 12717,
    county: 'KITTITAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cwu.edu/',
  },
  {
    name: 'HINDS COMMUNITY COLLEGE',
    address: '608 HINDS BOULEVARD',
    city: 'RAYMOND',
    state: 'MS',
    zip: 39154,
    telephone: '(601) 857-5261',
    population: 12718,
    county: 'HINDS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hindscc.edu/',
  },
  {
    name: 'ARAPAHOE COMMUNITY COLLEGE',
    address: '5900 S. SANTA FE DR.',
    city: 'LITTLETON',
    state: 'CO',
    zip: 80160,
    telephone: '(303) 797-4222',
    population: 12727,
    county: 'ARAPAHOE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.arapahoe.edu/',
  },
  {
    name: 'FERRIS STATE UNIVERSITY',
    address: '1201 S STATE ST',
    city: 'BIG RAPIDS',
    state: 'MI',
    zip: 49307,
    telephone: '(231) 591-2000',
    population: 12733,
    county: 'MECOSTA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ferris.edu/',
  },
  {
    name: 'CALIFORNIA BAPTIST UNIVERSITY',
    address: '8432 MAGNOLIA AVE',
    city: 'RIVERSIDE',
    state: 'CA',
    zip: 92504,
    telephone: '(877) 228-3615',
    population: 12757,
    county: 'RIVERSIDE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calbaptist.edu/',
  },
  {
    name: 'OREGON HEALTH & SCIENCE UNIVERSITY',
    address: '3181 SW SAM JACKSON PARK RD',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97239,
    telephone: '(503) 494-7800',
    population: 12791,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ohsu.edu/',
  },
  {
    name: 'HOFSTRA UNIVERSITY',
    address: '100 HOFSTRA UNIVERSITY',
    city: 'HEMPSTEAD',
    state: 'NY',
    zip: 11549,
    telephone: '(516) 463-6600',
    population: 12873,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hofstra.edu/',
  },
  {
    name: 'WRIGHT STATE UNIVERSITY-MAIN CAMPUS',
    address: '3640 COLONEL GLENN HIGHWAY',
    city: 'DAYTON',
    state: 'OH',
    zip: 45435,
    telephone: '(937) 775-1000',
    population: 12881,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wright.edu/',
  },
  {
    name: 'OZARKS TECHNICAL COMMUNITY COLLEGE',
    address: '1001 E. CHESTNUT EXPRESSWAY',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65802,
    telephone: '(417) 447-7500',
    population: 12883,
    county: 'GREENE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.otc.edu/',
  },
  {
    name: 'JEFFERSON COMMUNITY AND TECHNICAL COLLEGE',
    address: '101 W BROADWAY',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40202,
    telephone: '(502) 213-2200',
    population: 12931,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://jefferson.kctcs.edu/',
  },
  {
    name: 'OKLAHOMA CITY COMMUNITY COLLEGE',
    address: '7777 S MAY AVE',
    city: 'OKLAHOMA CITY',
    state: 'OK',
    zip: 73159,
    telephone: '(405) 682-1611',
    population: 12935,
    county: 'OKLAHOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.occc.edu/',
  },
  {
    name: "PRINCE GEORGE'S COMMUNITY COLLEGE",
    address: '301 LARGO RD',
    city: 'LARGO',
    state: 'MD',
    zip: 20774,
    telephone: '(301) 546-7422',
    population: 12968,
    county: "PRINCE GEORGE'S",
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pgcc.edu/',
  },
  {
    name: 'IRVINE VALLEY COLLEGE',
    address: '5500 IRVINE CENTER DRIVE',
    city: 'IRVINE',
    state: 'CA',
    zip: 92618,
    telephone: '(949) 451-5100',
    population: 12968,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ivc.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTHERN COLORADO',
    address: 'CARTER HALL - RM 4000',
    city: 'GREELEY',
    state: 'CO',
    zip: 80639,
    telephone: '(970) 351-1890',
    population: 12990,
    county: 'WELD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unco.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-BAKERSFIELD',
    address: '9001 STOCKDALE HWY',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93311,
    telephone: '(661) 654-2782',
    population: 13040,
    county: 'KERN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csub.edu/',
  },
  {
    name: 'TYLER JUNIOR COLLEGE',
    address: '1400 EAST FIFTH STREET',
    city: 'TYLER',
    state: 'TX',
    zip: 75701,
    telephone: '(903) 510-2200',
    population: 13048,
    county: 'SMITH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tjc.edu/',
  },
  {
    name: 'FOX VALLEY TECHNICAL COLLEGE',
    address: '1825 N BLUEMOUND DR',
    city: 'APPLETON',
    state: 'WI',
    zip: 54912,
    telephone: '(920) 735-5600',
    population: 13060,
    county: 'OUTAGAMIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.fvtc.edu/',
  },
  {
    name: 'SAINT CLOUD STATE UNIVERSITY',
    address: '720 FOURTH AVE. SOUTH',
    city: 'SAINT CLOUD',
    state: 'MN',
    zip: 56301,
    telephone: '(320) 308-0121',
    population: 13081,
    county: 'STEARNS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stcloudstate.edu/',
  },
  {
    name: 'NORTHCENTRAL UNIVERSITY',
    address: '11355 N. TORREY PINES ROAD',
    city: 'LA JOLLA',
    state: 'CA',
    zip: 92037,
    telephone: '(888) 327-2877',
    population: 13097,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ncu.edu/',
  },
  {
    name: 'UNIVERSITY OF IDAHO',
    address: '875 PERIMETER DRIVE MS 2282',
    city: 'MOSCOW',
    state: 'ID',
    zip: 83844,
    telephone: '(888) 884-3246',
    population: 13185,
    county: 'LATAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uidaho.edu/',
  },
  {
    name: 'GRAND RAPIDS COMMUNITY COLLEGE',
    address: '143 BOSTWICK AVE NE',
    city: 'GRAND RAPIDS',
    state: 'MI',
    zip: 49503,
    telephone: '(616) 234-4000',
    population: 13191,
    county: 'KENT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.grcc.edu/',
  },
  {
    name: 'ANTELOPE VALLEY COLLEGE',
    address: '3041 WEST AVE K',
    city: 'LANCASTER',
    state: 'CA',
    zip: 93536,
    telephone: '(661) 722-6300',
    population: 13223,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.avc.edu/',
  },
  {
    name: 'SAN BERNARDINO VALLEY COLLEGE',
    address: '701 SOUTH MOUNT VERNON AVENUE',
    city: 'SAN BERNARDINO',
    state: 'CA',
    zip: 92410,
    telephone: '(909) 384-4400',
    population: 13244,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.valleycollege.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-WHITEWATER',
    address: '800 W MAIN ST',
    city: 'WHITEWATER',
    state: 'WI',
    zip: 53190,
    telephone: '(262) 472-1234',
    population: 13246,
    county: 'WALWORTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uww.edu/',
  },
  {
    name: 'SOUTH DAKOTA STATE UNIVERSITY',
    address: '1004 CAMPANILE AVE',
    city: 'BROOKINGS',
    state: 'SD',
    zip: 57007,
    telephone: '(800) 952-3541',
    population: 13288,
    county: 'BROOKINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.sdstate.edu/',
  },
  {
    name: 'COLLEGE OF LAKE COUNTY',
    address: '19351 W WASHINGTON ST.',
    city: 'GRAYSLAKE',
    state: 'IL',
    zip: 60030,
    telephone: '(847) 543-2000',
    population: 13288,
    county: 'LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.clcillinois.edu/',
  },
  {
    name: 'DIXIE STATE UNIVERSITY',
    address: '225 S UNIVERSITY AVENUE',
    city: 'SAINT GEORGE',
    state: 'UT',
    zip: 84770,
    telephone: '(435) 652-7500',
    population: 13327,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'dixie.edu/',
  },
  {
    name: 'YOUNGSTOWN STATE UNIVERSITY',
    address: 'ONE UNIVERSITY PLAZA',
    city: 'YOUNGSTOWN',
    state: 'OH',
    zip: 44555,
    telephone: '(877) 468-6978',
    population: 13335,
    county: 'MAHONING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ysu.edu/',
  },
  {
    name: 'COLORADO STATE UNIVERSITY-GLOBAL CAMPUS',
    address: '585 SALIDA WAY',
    city: 'AURORA',
    state: 'CO',
    zip: 80011,
    telephone: '(800) 920-6723',
    population: 13341,
    county: 'ARAPAHOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://csuglobal.edu/',
  },
  {
    name: 'COLLEGE OF THE SEQUOIAS',
    address: '915 S. MOONEY BLVD',
    city: 'VISALIA',
    state: 'CA',
    zip: 93277,
    telephone: '(559) 730-3700',
    population: 13379,
    county: 'TULARE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cos.edu/',
  },
  {
    name: 'BELLEVUE COLLEGE',
    address: '3000 LANDERHOLM CIR SE',
    city: 'BELLEVUE',
    state: 'WA',
    zip: 98007,
    telephone: '(425) 564-1000',
    population: 13400,
    county: 'KING',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://bellevuecollege.edu/',
  },
  {
    name: 'SANTA BARBARA CITY COLLEGE',
    address: '721 CLIFF DRIVE',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93109,
    telephone: '(805) 965-0581',
    population: 13444,
    county: 'SANTA BARBARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sbcc.edu/',
  },
  {
    name: 'NEW JERSEY INSTITUTE OF TECHNOLOGY',
    address: 'UNIVERSITY HEIGHTS',
    city: 'NEWARK',
    state: 'NJ',
    zip: 7102,
    telephone: '(973) 596-3000',
    population: 13482,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.njit.edu/',
  },
  {
    name: 'TEXAS A & M UNIVERSITY-COMMERCE',
    address: '2600 SOUTH NEAL STREET',
    city: 'COMMERCE',
    state: 'TX',
    zip: 75428,
    telephone: '(888) 868-2682',
    population: 13510,
    county: 'HUNT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tamuc.edu/',
  },
  {
    name: "ST PHILIP'S COLLEGE",
    address: '1801 MARTIN LUTHER KING DR',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78203,
    telephone: '(210) 486-2000',
    population: 13532,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alamo.edu/spc/',
  },
  {
    name: 'ANNE ARUNDEL COMMUNITY COLLEGE',
    address: '101 COLLEGE PKY',
    city: 'ARNOLD',
    state: 'MD',
    zip: 21012,
    telephone: '(410) 777-2222',
    population: 13538,
    county: 'ANNE ARUNDEL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.aacc.edu/',
  },
  {
    name: 'PIKES PEAK COMMUNITY COLLEGE',
    address: '5675 S ACADEMY BLVD',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80906,
    telephone: '(719) 502-2000',
    population: 13558,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ppcc.edu/',
  },
  {
    name: 'VALDOSTA STATE UNIVERSITY',
    address: '1500 N PATTERSON ST',
    city: 'VALDOSTA',
    state: 'GA',
    zip: 31698,
    telephone: '(229) 333-5800',
    population: 13567,
    county: 'LOWNDES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.valdosta.edu/',
  },
  {
    name: 'WILLIAM RAINEY HARPER COLLEGE',
    address: '1200 W ALGONQUIN RD',
    city: 'PALATINE',
    state: 'IL',
    zip: 60067,
    telephone: '(847) 925-6000',
    population: 13604,
    county: 'COOK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.harpercollege.edu/index.php',
  },
  {
    name: 'HOWARD UNIVERSITY',
    address: '2400 SIXTH ST NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20059,
    telephone: '(202) 806-6100',
    population: 13635,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.howard.edu/',
  },
  {
    name: 'IDAHO STATE UNIVERSITY',
    address: '921 S 8TH AVE',
    city: 'POCATELLO',
    state: 'ID',
    zip: 83209,
    telephone: '(208) 282-2700',
    population: 13645,
    county: 'BANNOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.isu.edu/',
  },
  {
    name: 'KIRKWOOD COMMUNITY COLLEGE',
    address: '6301 KIRKWOOD BLVD SW',
    city: 'CEDAR RAPIDS',
    state: 'IA',
    zip: 52406,
    telephone: '(319) 398-5411',
    population: 13689,
    county: 'LINN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kirkwood.edu/',
  },
  {
    name: 'EASTERN WASHINGTON UNIVERSITY',
    address: '526 5TH STREET',
    city: 'CHENEY',
    state: 'WA',
    zip: 99004,
    telephone: '(509) 359-6200',
    population: 13716,
    county: 'SPOKANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ewu.edu/',
  },
  {
    name: 'MIRACOSTA COLLEGE',
    address: 'ONE BARNARD DRIVE',
    city: 'OCEANSIDE',
    state: 'CA',
    zip: 92056,
    telephone: '(760) 757-2121',
    population: 13753,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.miracosta.edu/',
  },
  {
    name: 'SANTA FE COLLEGE',
    address: '3000 NORTHWEST 83RD STREET',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32606,
    telephone: '(352) 395-5000',
    population: 13753,
    county: 'ALACHUA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sfcollege.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TENNESSEE-CHATTANOOGA',
    address: '615 MCCALLIE AVE',
    city: 'CHATTANOOGA',
    state: 'TN',
    zip: 37403,
    telephone: '(423) 425-4111',
    population: 13754,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utc.edu/',
  },
  {
    name: 'SOUTHERN UTAH UNIVERSITY',
    address: '351 WEST UNIVERSITY BLVD',
    city: 'CEDAR CITY',
    state: 'UT',
    zip: 84720,
    telephone: '(435) 586-7700',
    population: 13780,
    county: 'IRON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.suu.edu/',
  },
  {
    name: 'CAMPBELLSVILLE UNIVERSITY',
    address: '1 UNIVERSITY DR',
    city: 'CAMPBELLSVILLE',
    state: 'KY',
    zip: 42718,
    telephone: '(270) 789-5000 EXT 5000',
    population: 13821,
    county: 'TAYLOR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.campbellsville.edu/',
  },
  {
    name: 'MARSHALL UNIVERSITY',
    address: '1 JOHN MARSHALL DR',
    city: 'HUNTINGTON',
    state: 'WV',
    zip: 25755,
    telephone: '(304) 696-3170',
    population: 13921,
    county: 'CABELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.marshall.edu/',
  },
  {
    name: 'UNIVERSITY OF ALASKA ANCHORAGE',
    address: '3211 PROVIDENCE DRIVE',
    city: 'ANCHORAGE',
    state: 'AK',
    zip: 99508,
    telephone: '(907) 786-1800',
    population: 13923,
    county: 'ANCHORAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uaa.alaska.edu/',
  },
  {
    name: 'THOMAS JEFFERSON UNIVERSITY',
    address: '1020 WALNUT STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19107,
    telephone: '(215) 955-6000',
    population: 13939,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jefferson.edu/',
  },
  {
    name: 'VILLANOVA UNIVERSITY',
    address: '800 LANCASTER AVENUE',
    city: 'VILLANOVA',
    state: 'PA',
    zip: 19085,
    telephone: '(610) 519-4500',
    population: 13968,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.villanova.edu/',
  },
  {
    name: 'UNIVERSITY OF COLORADO COLORADO SPRINGS',
    address: '1420 AUSTIN BLUFFS PARKWAY',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80918,
    telephone: '(719) 255-3000',
    population: 13971,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uccs.edu/',
  },
  {
    name: 'CUNY QUEENSBOROUGH COMMUNITY COLLEGE',
    address: '222-05 56TH AVE',
    city: 'BAYSIDE',
    state: 'NY',
    zip: 11364,
    telephone: '(718) 631-6262',
    population: 13996,
    county: 'QUEENS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.qcc.cuny.edu/',
  },
  {
    name: 'SAN DIEGO MIRAMAR COLLEGE',
    address: '10440 BLACK MOUNTAIN RD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92126,
    telephone: '(619) 388-7800',
    population: 14026,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sdmiramar.edu/',
  },
  {
    name: 'GLENDALE COMMUNITY COLLEGE',
    address: '1500 N VERDUGO RD',
    city: 'GLENDALE',
    state: 'CA',
    zip: 91208,
    telephone: '(818) 240-1000',
    population: 14045,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.glendale.edu/',
  },
  {
    name: 'WESTERN CAROLINA UNIVERSITY',
    address: 'HIGHWAY 107',
    city: 'CULLOWHEE',
    state: 'NC',
    zip: 28723,
    telephone: '(828) 227-7100',
    population: 14067,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wcu.edu/',
  },
  {
    name: 'TEXAS CHRISTIAN UNIVERSITY',
    address: '2800 S UNIVERSITY DR',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76129,
    telephone: '(817) 257-7000',
    population: 14068,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tcu.edu/',
  },
  {
    name: 'DAYTONA STATE COLLEGE',
    address: '1200 W. INTERNATIONAL SPEEDWAY BLVD.',
    city: 'DAYTONA BEACH',
    state: 'FL',
    zip: 32114,
    telephone: '(386) 506-3000',
    population: 14124,
    county: 'VOLUSIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.daytonastate.edu/',
  },
  {
    name: 'TOURO COLLEGE',
    address: '500 7TH AVENUE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10018,
    telephone: '(646) 565-6000',
    population: 14139,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.touro.edu/',
  },
  {
    name: 'ICAHN SCHOOL OF MEDICINE AT MOUNT SINAI',
    address: 'ONE GUSTAVE L LEVY PLACE, BOX 1217',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10029,
    telephone: '(212) 241-6500',
    population: 14219,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'icahn.mssm.edu/',
  },
  {
    name: 'UNIVERSITY OF MAINE',
    address: '168 COLLEGE AVENUE',
    city: 'ORONO',
    state: 'ME',
    zip: 4469,
    telephone: '(207) 581-1865',
    population: 14221,
    county: 'PENOBSCOT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umaine.edu/',
  },
  {
    name: 'STEPHEN F AUSTIN STATE UNIVERSITY',
    address: '2008 ALUMNI DRIVE, RUSK 206',
    city: 'NACOGDOCHES',
    state: 'TX',
    zip: 75961,
    telephone: '(936) 468-2011',
    population: 14301,
    county: 'NACOGDOCHES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfasu.edu/',
  },
  {
    name: 'MARQUETTE UNIVERSITY',
    address: '1250 W WISCONSIN AVENUE',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53233,
    telephone: '(414) 288-7710',
    population: 14361,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.marquette.edu/',
  },
  {
    name: 'UNIVERSITY OF MARYLAND, BALTIMORE',
    address: '620 WEST LEXINGTON ST',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21201,
    telephone: '(410) 706-3100',
    population: 14456,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umaryland.edu/',
  },
  {
    name: 'CHANDLER-GILBERT COMMUNITY COLLEGE',
    address: '2626 E PECOS RD',
    city: 'CHANDLER',
    state: 'AZ',
    zip: 85225,
    telephone: '(480) 732-7000',
    population: 14479,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cgc.maricopa.edu/',
  },
  {
    name: 'DELAWARE TECHNICAL COMMUNITY COLLEGE-TERRY',
    address: '100 CAMPUS DRIVE',
    city: 'DOVER',
    state: 'DE',
    zip: 19901,
    telephone: '(302) 857-1000',
    population: 14512,
    county: 'KENT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.dtcc.edu/',
  },
  {
    name: 'DELGADO COMMUNITY COLLEGE',
    address: '615 CITY PARK AVENUE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70119,
    telephone: '(504) 671-5000',
    population: 14531,
    county: 'ORLEANS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dcc.edu/',
  },
  {
    name: 'BELLEVUE UNIVERSITY',
    address: '1000 GALVIN RD S',
    city: 'BELLEVUE',
    state: 'NE',
    zip: 68005,
    telephone: '(402) 291-8100',
    population: 14569,
    county: 'SARPY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bellevue.edu/',
  },
  {
    name: 'COLLEGE OF STATEN ISLAND CUNY',
    address: '2800 VICTORY BLVD',
    city: 'STATEN ISLAND',
    state: 'NY',
    zip: 10314,
    telephone: '(718) 982-2000',
    population: 14598,
    county: 'RICHMOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csi.cuny.edu/',
  },
  {
    name: 'BROWN UNIVERSITY',
    address: 'ONE PROSPECT STREET',
    city: 'PROVIDENCE',
    state: 'RI',
    zip: 2912,
    telephone: '(401) 863-1000',
    population: 14602,
    county: 'PROVIDENCE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brown.edu/',
  },
  {
    name: 'MILWAUKEE AREA TECHNICAL COLLEGE',
    address: '700 W STATE ST',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53233,
    telephone: '(414) 297-6370',
    population: 14607,
    county: 'MILWAUKEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'matc.edu/',
  },
  {
    name: 'AUGUSTA UNIVERSITY',
    address: '1120 15TH ST',
    city: 'AUGUSTA',
    state: 'GA',
    zip: 30912,
    telephone: '(706) 721-0211',
    population: 14608,
    county: 'RICHMOND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.augusta.edu/',
  },
  {
    name: 'UNIVERSITY OF DAYTON',
    address: '300 COLLEGE PARK',
    city: 'DAYTON',
    state: 'OH',
    zip: 45469,
    telephone: '(937) 229-1000',
    population: 14723,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://udayton.edu/',
  },
  {
    name: 'UNIVERSITY OF WYOMING',
    address: 'CORNER OF NINTH AND IVINSON',
    city: 'LARAMIE',
    state: 'WY',
    zip: 82071,
    telephone: '(307) 766-1121',
    population: 14737,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uwyo.edu/',
  },
  {
    name: 'NORTH CAROLINA A & T STATE UNIVERSITY',
    address: '1601 E MARKET ST',
    city: 'GREENSBORO',
    state: 'NC',
    zip: 27411,
    telephone: '(336) 334-7500',
    population: 14746,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ncat.edu/',
  },
  {
    name: 'UNIVERSIDAD ANA G. MENDEZ-GURABO CAMPUS',
    address: 'CARR. # 189 KM 3.3',
    city: 'GURABO',
    state: 'PR',
    zip: 778,
    telephone: '(787) 743-7979 EXT 4000',
    population: 14764,
    county: 'GURABO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'gurabo.uagm.edu/',
  },
  {
    name: 'EMBRY-RIDDLE AERONAUTICAL UNIVERSITY-WORLDWIDE',
    address: '1 AEROSPACE BLVD.',
    city: 'DAYTONA BEACH',
    state: 'FL',
    zip: 32114,
    telephone: '(800) 522-6787',
    population: 14797,
    county: 'VOLUSIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'worldwide.erau.edu/',
  },
  {
    name: 'THE UNIVERSITY OF WEST FLORIDA',
    address: '11000 UNIVERSITY PARKWAY',
    city: 'PENSACOLA',
    state: 'FL',
    zip: 32514,
    telephone: '(850) 474-2000',
    population: 14804,
    county: 'ESCAMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uwf.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF RHODE ISLAND',
    address: '400 EAST AVE',
    city: 'WARWICK',
    state: 'RI',
    zip: 2886,
    telephone: '(401) 825-1000',
    population: 14821,
    county: 'KENT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccri.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF PHILADELPHIA',
    address: '1700 SPRING GARDEN ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19130,
    telephone: '(215) 751-8000',
    population: 14837,
    county: 'PHILADELPHIA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccp.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF ALLEGHENY COUNTY',
    address: '800 ALLEGHENY AVE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15233,
    telephone: '(412) 323-2323',
    population: 14888,
    county: 'ALLEGHENY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.ccac.edu/',
  },
  {
    name: 'PRINCETON UNIVERSITY',
    address: '1 NASSAU HALL',
    city: 'PRINCETON',
    state: 'NJ',
    zip: 8544,
    telephone: '(609) 258-3000',
    population: 14959,
    county: 'MERCER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.princeton.edu/',
  },
  {
    name: 'MOORPARK COLLEGE',
    address: '7075 CAMPUS RD',
    city: 'MOORPARK',
    state: 'CA',
    zip: 93021,
    telephone: '(805) 378-1400',
    population: 15005,
    county: 'VENTURA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.moorparkcollege.edu/index.shtml',
  },
  {
    name: 'MADISON AREA TECHNICAL COLLEGE',
    address: '1701 WRIGHT STREET',
    city: 'MADISON',
    state: 'WI',
    zip: 53704,
    telephone: '(608) 246-6100',
    population: 15018,
    county: 'DANE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'madisoncollege.edu/',
  },
  {
    name: 'METROPOLITAN COMMUNITY COLLEGE AREA',
    address: '30 & FORT STREET',
    city: 'OMAHA',
    state: 'NE',
    zip: 68111,
    telephone: '(531) 622-2400',
    population: 15025,
    county: 'DOUGLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mccneb.edu/',
  },
  {
    name: 'ARKANSAS STATE UNIVERSITY',
    address: '2105 E. AGGIE ROAD',
    city: 'JONESBORO',
    state: 'AR',
    zip: 72401,
    telephone: '(870) 972-2100',
    population: 15053,
    county: 'CRAIGHEAD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.astate.edu/',
  },
  {
    name: 'UNIVERSITY OF WEST GEORGIA',
    address: '1601 MAPLE ST',
    city: 'CARROLLTON',
    state: 'GA',
    zip: 30118,
    telephone: '(678) 839-5000',
    population: 15073,
    county: 'CARROLL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.westga.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-MAYAGUEZ',
    address: '259 BOULEVARD ALFONSO VALDEZ',
    city: 'MAYAGUEZ',
    state: 'PR',
    zip: 681,
    telephone: '(787) 832-4040',
    population: 15150,
    county: 'MAYAGÜEZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uprm.edu/',
  },
  {
    name: 'RUTGERS UNIVERSITY-NEWARK',
    address: '249 UNIVERSITY AVENUE, BLUMENTHAL HALL',
    city: 'NEWARK',
    state: 'NJ',
    zip: 7102,
    telephone: '(973) 353-1766',
    population: 15191,
    county: 'ESSEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.newark.rutgers.edu/',
  },
  {
    name: 'SOUTHERN METHODIST UNIVERSITY',
    address: '6425 BOAZ ST',
    city: 'DALLAS',
    state: 'TX',
    zip: 75275,
    telephone: '(214) 768-2000',
    population: 15204,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.smu.edu/',
  },
  {
    name: 'FOOTHILL COLLEGE',
    address: '12345 EL MONTE RD',
    city: 'LOS ALTOS HILLS',
    state: 'CA',
    zip: 94022,
    telephone: '(650) 949-7777',
    population: 15286,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://foothill.edu/',
  },
  {
    name: 'COSUMNES RIVER COLLEGE',
    address: '8401 CENTER PARKWAY',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95823,
    telephone: '(916) 688-7344',
    population: 15287,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.crc.losrios.edu/',
  },
  {
    name: 'TARLETON STATE UNIVERSITY',
    address: '1333 W. WASHINGTON',
    city: 'STEPHENVILLE',
    state: 'TX',
    zip: 76401,
    telephone: '(254) 968-9000',
    population: 15301,
    county: 'ERATH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.tarleton.edu/',
  },
  {
    name: 'SOUTHERN ILLINOIS UNIVERSITY-EDWARDSVILLE',
    address: 'IL STATE RTE 157',
    city: 'EDWARDSVILLE',
    state: 'IL',
    zip: 62026,
    telephone: '(888) 328-5168',
    population: 15303,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.siue.edu/',
  },
  {
    name: 'NORTH DAKOTA STATE UNIVERSITY-MAIN CAMPUS',
    address: '1301 12TH AVENUE NORTH',
    city: 'FARGO',
    state: 'ND',
    zip: 58108,
    telephone: '(701) 231-8011',
    population: 15380,
    county: 'CASS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ndsu.edu/',
  },
  {
    name: 'EASTERN FLORIDA STATE COLLEGE',
    address: '1519 CLEARLAKE RD',
    city: 'COCOA',
    state: 'FL',
    zip: 32922,
    telephone: '(321) 632-1111',
    population: 15391,
    county: 'BREVARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.easternflorida.edu/',
  },
  {
    name: 'MT SAN JACINTO COMMUNITY COLLEGE DISTRICT',
    address: '1499 N. STATE ST.',
    city: 'SAN JACINTO',
    state: 'CA',
    zip: 92583,
    telephone: '(951) 487-6752',
    population: 15396,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.msjc.edu/',
  },
  {
    name: 'UNIVERSITY OF MISSOURI-ST LOUIS',
    address: 'ONE UNIVERSITY BOULEVARD',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63121,
    telephone: '(314) 516-5000',
    population: 15528,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umsl.edu/',
  },
  {
    name: 'SAN DIEGO CITY COLLEGE',
    address: '1313 PARK BOULEVARD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92101,
    telephone: '(619) 388-3400',
    population: 15561,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sdcity.edu/',
  },
  {
    name: 'POST UNIVERSITY',
    address: '800 COUNTRY CLUB RD',
    city: 'WATERBURY',
    state: 'CT',
    zip: 6723,
    telephone: '(800) 345-2562',
    population: 15603,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.post.edu/',
  },
  {
    name: 'LOS ANGELES CITY COLLEGE',
    address: '855 N VERMONT AVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90029,
    telephone: '(323) 953-4000',
    population: 15605,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lacitycollege.edu/',
  },
  {
    name: 'OAKLAND COMMUNITY COLLEGE',
    address: '2480 OPDYKE RD',
    city: 'BLOOMFIELD HILLS',
    state: 'MI',
    zip: 48304,
    telephone: '(248) 341-2000',
    population: 15662,
    county: 'OAKLAND',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.oaklandcc.edu/',
  },
  {
    name: 'NASSAU COMMUNITY COLLEGE',
    address: 'ONE EDUCATION DR',
    city: 'GARDEN CITY',
    state: 'NY',
    zip: 11530,
    telephone: '(516) 572-7501',
    population: 15664,
    county: 'NASSAU',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ncc.edu/',
  },
  {
    name: 'UNIVERSITY OF MARYLAND-BALTIMORE COUNTY',
    address: '1000 HILLTOP CIRCLE',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21250,
    telephone: '(410) 455-1000',
    population: 15909,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'umbc.edu/',
  },
  {
    name: 'GLENDALE COMMUNITY COLLEGE',
    address: '6000 W OLIVE AVE',
    city: 'GLENDALE',
    state: 'AZ',
    zip: 85302,
    telephone: '(623) 845-3000',
    population: 15926,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.gccaz.edu/',
  },
  {
    name: 'SOUTHEASTERN LOUISIANA UNIVERSITY',
    address: '548 NED MCGEHEE AVE.',
    city: 'HAMMOND',
    state: 'LA',
    zip: 70402,
    telephone: '(985) 549-2000',
    population: 15949,
    county: 'TANGIPAHOA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southeastern.edu/',
  },
  {
    name: 'KEAN UNIVERSITY',
    address: '1000 MORRIS AVENUE',
    city: 'UNION',
    state: 'NJ',
    zip: 7083,
    telephone: '(908) 737-5326',
    population: 15950,
    county: 'UNION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.kean.edu/',
  },
  {
    name: 'UNIVERSITY OF CENTRAL OKLAHOMA',
    address: '100 N UNIVERSITY DR',
    city: 'EDMOND',
    state: 'OK',
    zip: 73034,
    telephone: '(405) 974-2000',
    population: 15970,
    county: 'OKLAHOMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uco.edu/',
  },
  {
    name: 'METROPOLITAN COMMUNITY COLLEGE-KANSAS CITY',
    address: '3200 BROADWAY',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64111,
    telephone: '(816) 604-1000',
    population: 15983,
    county: 'JACKSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mcckc.edu/',
  },
  {
    name: 'PACE UNIVERSITY',
    address: '1 PACE PLAZA',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10038,
    telephone: '(212) 346-1200',
    population: 16030,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pace.edu/',
  },
  {
    name: 'CASE WESTERN RESERVE UNIVERSITY',
    address: '10900 EUCLID AVE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44106,
    telephone: '(216) 368-2000',
    population: 16040,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.case.edu/',
  },
  {
    name: 'JOHNSON COUNTY COMMUNITY COLLEGE',
    address: '12345 COLLEGE BLVD',
    city: 'OVERLAND PARK',
    state: 'KS',
    zip: 66210,
    telephone: '(913) 469-8500',
    population: 16048,
    county: 'JOHNSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.jccc.edu/',
  },
  {
    name: 'SAVANNAH COLLEGE OF ART AND DESIGN',
    address: '342 BULL ST',
    city: 'SAVANNAH',
    state: 'GA',
    zip: 31402,
    telephone: '(912) 525-5000',
    population: 16051,
    county: 'CHATHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.scad.edu/',
  },
  {
    name: 'ECPI UNIVERSITY',
    address: '5555 GREENWICH RD',
    city: 'VIRGINIA BEACH',
    state: 'VA',
    zip: 23462,
    telephone: '(757) 490-9090',
    population: 16127,
    county: 'VIRGINIA BEACH CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ecpi.edu/',
  },
  {
    name: 'SOUTHERN ILLINOIS UNIVERSITY-CARBONDALE',
    address: 'LINCOLN DRIVE',
    city: 'CARBONDALE',
    state: 'IL',
    zip: 62901,
    telephone: '(618) 453-2121',
    population: 16170,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.siu.edu/',
  },
  {
    name: 'WAKE FOREST UNIVERSITY',
    address: '1834 WAKE FOREST ROAD',
    city: 'WINSTON-SALEM',
    state: 'NC',
    zip: 27106,
    telephone: '(336) 758-5000',
    population: 16188,
    county: 'FORSYTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wfu.edu/',
  },
  {
    name: 'CYPRESS COLLEGE',
    address: '9200 VALLEY VIEW',
    city: 'CYPRESS',
    state: 'CA',
    zip: 90630,
    telephone: '(714) 484-7000',
    population: 16203,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cypresscollege.edu/',
  },
  {
    name: 'EAST TENNESSEE STATE UNIVERSITY',
    address: '1276 GILBREATH DRIVE',
    city: 'JOHNSON CITY',
    state: 'TN',
    zip: 37614,
    telephone: '(423) 439-1000',
    population: 16253,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.etsu.edu/',
  },
  {
    name: 'UNIVERSITY OF PUERTO RICO-RIO PIEDRAS',
    address: '39 AVENIDA PONCE DE LEON',
    city: 'SAN JUAN',
    state: 'PR',
    zip: 931,
    telephone: '(787) 764-0000',
    population: 16329,
    county: 'SAN JUAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uprrp.edu/',
  },
  {
    name: 'MINNESOTA STATE UNIVERSITY-MANKATO',
    address: 'SOUTH RD AND ELLIS AVE',
    city: 'MANKATO',
    state: 'MN',
    zip: 56001,
    telephone: '(507) 389-1866',
    population: 16365,
    county: 'BLUE EARTH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://mankato.mnsu.edu/',
  },
  {
    name: 'GROSSMONT COLLEGE',
    address: '8800 GROSSMONT COLLEGE DR',
    city: 'EL CAJON',
    state: 'CA',
    zip: 92020,
    telephone: '(619) 644-7000',
    population: 16406,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.grossmont.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS HEALTH SCIENCE CENTER AT HOUSTON',
    address: '7000 FANNIN',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77030,
    telephone: '(713) 500-4472',
    population: 16413,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uth.edu/',
  },
  {
    name: 'FORT HAYS STATE UNIVERSITY',
    address: '600 PARK ST',
    city: 'HAYS',
    state: 'KS',
    zip: 67601,
    telephone: '(785) 628-4000',
    population: 16425,
    county: 'ELLIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fhsu.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH DAKOTA',
    address: '264 CENTENNIAL DRIVE, STOP 8193',
    city: 'GRAND FORKS',
    state: 'ND',
    zip: 58202,
    telephone: '(800) 225-5863',
    population: 16446,
    county: 'GRAND FORKS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://und.edu/',
  },
  {
    name: 'FLORIDA SOUTHWESTERN STATE COLLEGE',
    address: '8099 COLLEGE PARKWAY',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33919,
    telephone: '(239) 489-9300',
    population: 16502,
    county: 'LEE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fsw.edu/',
  },
  {
    name: 'RIO HONDO COLLEGE',
    address: '3600 WORKMAN MILL RD',
    city: 'WHITTIER',
    state: 'CA',
    zip: 90601,
    telephone: '(562) 692-0921',
    population: 16576,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.riohondo.edu/',
  },
  {
    name: 'UNIVERSITY OF HOUSTON-DOWNTOWN',
    address: '1 MAIN STREET',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77002,
    telephone: '(713) 221-8000',
    population: 16610,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uhd.edu/',
  },
  {
    name: 'INDIAN RIVER STATE COLLEGE',
    address: '3209 VIRGINIA AVE',
    city: 'FORT PIERCE',
    state: 'FL',
    zip: 34981,
    telephone: '(772) 462-4772',
    population: 16681,
    county: 'ST. LUCIE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.irsc.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH ALABAMA',
    address: '307 N UNIVERSITY BLVD',
    city: 'MOBILE',
    state: 'AL',
    zip: 36688,
    telephone: '(251) 460-6101',
    population: 16692,
    county: 'MOBILE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.southalabama.edu/',
  },
  {
    name: 'LONG ISLAND UNIVERSITY',
    address: '720 NORTHERN BLVD',
    city: 'BROOKVILLE',
    state: 'NY',
    zip: 11548,
    telephone: '(516) 299-2900',
    population: 16703,
    county: 'NASSAU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.liu.edu/',
  },
  {
    name: 'CUNY KINGSBOROUGH COMMUNITY COLLEGE',
    address: '2001 ORIENTAL BLVD',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11235,
    telephone: '(718) 368-5000',
    population: 16728,
    county: 'KINGS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.kbcc.cuny.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-OSHKOSH',
    address: '800 ALGOMA BLVD',
    city: 'OSHKOSH',
    state: 'WI',
    zip: 54901,
    telephone: '(920) 424-1234',
    population: 16731,
    county: 'WINNEBAGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uwosh.edu/',
  },
  {
    name: 'LOS ANGELES VALLEY COLLEGE',
    address: '5800 FULTON AVENUE',
    city: 'VALLEY GLEN',
    state: 'CA',
    zip: 91401,
    telephone: '(818) 947-2600',
    population: 16790,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lavc.edu/',
  },
  {
    name: 'EASTERN KENTUCKY UNIVERSITY',
    address: '521 LANCASTER AVE',
    city: 'RICHMOND',
    state: 'KY',
    zip: 40475,
    telephone: '(859) 622-1000',
    population: 16828,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.eku.edu/',
  },
  {
    name: 'WILMINGTON UNIVERSITY',
    address: '320 DUPONT HWY',
    city: 'NEW CASTLE',
    state: 'DE',
    zip: 19720,
    telephone: '(877) 967-5464',
    population: 16867,
    county: 'NEW CASTLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wilmu.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-SAN FRANCISCO',
    address: '500 PARNASSUS AVE',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94143,
    telephone: '(415) 476-9000',
    population: 16914,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ucsf.edu/',
  },
  {
    name: 'CUNY LEHMAN COLLEGE',
    address: '250 BEDFORD PARK BLVD WEST',
    city: 'BRONX',
    state: 'NY',
    zip: 10468,
    telephone: '(718) 960-8000',
    population: 16943,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lehman.edu/',
  },
  {
    name: 'AMERICAN INTERCONTINENTAL UNIVERSITY',
    address: '2200 E GERMANN RD',
    city: 'CHANDLER',
    state: 'AZ',
    zip: 85286,
    telephone: '(877) 701-3800',
    population: 17069,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.aiuniv.edu/',
  },
  {
    name: 'FLORIDA GULF COAST UNIVERSITY',
    address: '10501 FGCU BLVD S',
    city: 'FORT MYERS',
    state: 'FL',
    zip: 33965,
    telephone: '(239) 590-1000',
    population: 17084,
    county: 'LEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fgcu.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTHERN MISSISSIPPI',
    address: '118 COLLEGE DRIVE # 0001',
    city: 'HATTIESBURG',
    state: 'MS',
    zip: 39406,
    telephone: '(601) 266-1000',
    population: 17101,
    county: 'FORREST',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.usm.edu/',
  },
  {
    name: 'TUFTS UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'MEDFORD',
    state: 'MA',
    zip: 2155,
    telephone: '(617) 628-5000',
    population: 17113,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tufts.edu/',
  },
  {
    name: 'UNIVERSITY OF DENVER',
    address: '2199 S. UNIVERSITY BLVD',
    city: 'DENVER',
    state: 'CO',
    zip: 80208,
    telephone: '(303) 871-2000',
    population: 17194,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.du.edu/',
  },
  {
    name: 'MODESTO JUNIOR COLLEGE',
    address: '435 COLLEGE AVE',
    city: 'MODESTO',
    state: 'CA',
    zip: 95350,
    telephone: '(209) 575-6550',
    population: 17222,
    county: 'STANISLAUS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mjc.edu/',
  },
  {
    name: 'SAINT LOUIS COMMUNITY COLLEGE',
    address: '3221 MCKELVEY ROAD',
    city: 'BRIDGETON',
    state: 'MO',
    zip: 63044,
    telephone: '(314) 539-5305',
    population: 17233,
    county: 'ST. LOUIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.stlcc.edu/',
  },
  {
    name: 'TULSA COMMUNITY COLLEGE',
    address: '6111 E SKELLY DR',
    city: 'TULSA',
    state: 'OK',
    zip: 74135,
    telephone: '(918) 595-7000',
    population: 17348,
    county: 'TULSA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tulsacc.edu/',
  },
  {
    name: 'WESTERN WASHINGTON UNIVERSITY',
    address: '516 HIGH STREET',
    city: 'BELLINGHAM',
    state: 'WA',
    zip: 98225,
    telephone: '(360) 650-3000',
    population: 17351,
    county: 'WHATCOM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'wwu.edu/',
  },
  {
    name: 'NEW MEXICO STATE UNIVERSITY-MAIN CAMPUS',
    address: '2850 WEDDELL STREET',
    city: 'LAS CRUCES',
    state: 'NM',
    zip: 88003,
    telephone: '(575) 646-0111',
    population: 17389,
    county: 'DOÑA ANA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nmsu.edu/',
  },
  {
    name: 'UNIVERSITY OF VERMONT',
    address: '85 S PROSPECT ST',
    city: 'BURLINGTON',
    state: 'VT',
    zip: 5405,
    telephone: '(802) 656-3131',
    population: 17417,
    county: 'CHITTENDEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uvm.edu/',
  },
  {
    name: 'SAINT LOUIS UNIVERSITY',
    address: 'ONE NORTH GRAND BLVD',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63103,
    telephone: '(314) 977-2222',
    population: 17516,
    county: 'ST. LOUIS CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.slu.edu/',
  },
  {
    name: 'AMERICAN UNIVERSITY',
    address: '4400 MASSACHUSETTS AVE NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20016,
    telephone: '(202) 885-1000',
    population: 17561,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.american.edu/',
  },
  {
    name: 'CLEVELAND STATE UNIVERSITY',
    address: '2121 EUCLID AVENUE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44115,
    telephone: '(216) 687-2000',
    population: 17600,
    county: 'CUYAHOGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csuohio.edu/',
  },
  {
    name: 'WICHITA STATE UNIVERSITY',
    address: '1845 N. FAIRMOUNT',
    city: 'WICHITA',
    state: 'KS',
    zip: 67260,
    telephone: '(316) 978-3456',
    population: 17612,
    county: 'SEDGWICK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wichita.edu/',
  },
  {
    name: 'SEMINOLE STATE COLLEGE OF FLORIDA',
    address: '100 WELDON BLVD',
    city: 'SANFORD',
    state: 'FL',
    zip: 32773,
    telephone: '(407) 708-4722',
    population: 17635,
    county: 'SEMINOLE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.seminolestate.edu/',
  },
  {
    name: 'CUNY NEW YORK CITY COLLEGE OF TECHNOLOGY',
    address: '300 JAY ST',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11201,
    telephone: '(718) 260-5500',
    population: 17642,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.citytech.cuny.edu/',
  },
  {
    name: 'VINCENNES UNIVERSITY',
    address: '1002 N FIRST ST',
    city: 'VINCENNES',
    state: 'IN',
    zip: 47591,
    telephone: '(812) 888-8888',
    population: 17687,
    county: 'KNOX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.vinu.edu/',
  },
  {
    name: 'HARRISBURG AREA COMMUNITY COLLEGE',
    address: '1 HACC DR.',
    city: 'HARRISBURG',
    state: 'PA',
    zip: 17110,
    telephone: '(717) 780-2300',
    population: 17705,
    county: 'DAUPHIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hacc.edu/',
  },
  {
    name: 'CUNY JOHN JAY COLLEGE OF CRIMINAL JUSTICE',
    address: '524 W 59TH ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10019,
    telephone: '(212) 237-8000',
    population: 17769,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jjay.cuny.edu/',
  },
  {
    name: 'CUNY CITY COLLEGE',
    address: '160 CONVENT AVE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10031,
    telephone: '(212) 650-7000',
    population: 17805,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ccny.cuny.edu/',
  },
  {
    name: 'PIMA COMMUNITY COLLEGE',
    address: '4905C EAST BROADWAY BLVD.',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85709,
    telephone: '(520) 206-4500',
    population: 17915,
    county: 'PIMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pima.edu/',
  },
  {
    name: 'UNIVERSITY OF NEBRASKA AT OMAHA',
    address: '6001 DODGE ST',
    city: 'OMAHA',
    state: 'NE',
    zip: 68182,
    telephone: '(402) 554-2800',
    population: 17931,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unomaha.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-EAST BAY',
    address: '25800 CARLOS BEE BLVD',
    city: 'HAYWARD',
    state: 'CA',
    zip: 94542,
    telephone: '(510) 885-3000',
    population: 18010,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csueastbay.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-SAN MARCOS',
    address: '333 S TWIN OAKS VALLEY RD',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92096,
    telephone: '(760) 750-4000',
    population: 18014,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csusm.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW HAMPSHIRE-MAIN CAMPUS',
    address: '105 MAIN ST., THOMPSON HALL',
    city: 'DURHAM',
    state: 'NH',
    zip: 3824,
    telephone: '(603) 862-1234',
    population: 18021,
    county: 'STRAFFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unh.edu/',
  },
  {
    name: 'LAMAR UNIVERSITY',
    address: '4400 MLK BLVD',
    city: 'BEAUMONT',
    state: 'TX',
    zip: 77705,
    telephone: '(409) 880-7011',
    population: 18057,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lamar.edu/',
  },
  {
    name: "TEXAS WOMAN'S UNIVERSITY",
    address: '304 ADMINISTRATION DR',
    city: 'DENTON',
    state: 'TX',
    zip: 76204,
    telephone: '(940) 898-2000',
    population: 18115,
    county: 'DENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.twu.edu/',
  },
  {
    name: 'MACOMB COMMUNITY COLLEGE',
    address: '14500 E TWELVE MILE RD',
    city: 'WARREN',
    state: 'MI',
    zip: 48088,
    telephone: '(586) 445-7999',
    population: 18177,
    county: 'MACOMB',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.macomb.edu/',
  },
  {
    name: 'NORTHERN KENTUCKY UNIVERSITY',
    address: 'NUNN DRIVE',
    city: 'HIGHLAND HEIGHTS',
    state: 'KY',
    zip: 41099,
    telephone: '(859) 572-5100',
    population: 18182,
    county: 'CAMPBELL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nku.edu/',
  },
  {
    name: 'GEORGIA STATE UNIVERSITY-PERIMETER COLLEGE',
    address: '33 GILMER ST.',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30303,
    telephone: '(404) 413-2000',
    population: 18294,
    county: 'FULTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'perimeter.gsu.edu/',
  },
  {
    name: 'SANTA ROSA JUNIOR COLLEGE',
    address: '1501 MENDOCINO AVENUE',
    city: 'SANTA ROSA',
    state: 'CA',
    zip: 95401,
    telephone: '(707) 527-4011',
    population: 18300,
    county: 'SONOMA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.santarosa.edu/',
  },
  {
    name: 'EASTERN MICHIGAN UNIVERSITY',
    address: '900 OAKWOOD ST.',
    city: 'YPSILANTI',
    state: 'MI',
    zip: 48197,
    telephone: '(734) 487-1849',
    population: 18301,
    county: 'WASHTENAW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emich.edu/',
  },
  {
    name: 'UNIVERSITY OF MASSACHUSETTS-BOSTON',
    address: '100 MORRISSEY BOULEVARD',
    city: 'BOSTON',
    state: 'MA',
    zip: 2125,
    telephone: '(617) 287-5000',
    population: 18381,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umb.edu/',
  },
  {
    name: 'TIDEWATER COMMUNITY COLLEGE',
    address: '121 COLLEGE PLACE',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23510,
    telephone: '(757) 822-1122',
    population: 18408,
    county: 'NORFOLK CITY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tcc.edu/',
  },
  {
    name: 'LOS ANGELES PIERCE COLLEGE',
    address: '6201 WINNETKA AVE',
    city: 'WOODLAND HILLS',
    state: 'CA',
    zip: 91371,
    telephone: '(818) 719-6401',
    population: 18464,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.piercecollege.edu/',
  },
  {
    name: 'UNIVERSITY OF AKRON MAIN CAMPUS',
    address: '302 BUCHTEL COMMON',
    city: 'AKRON',
    state: 'OH',
    zip: 44325,
    telephone: '(330) 972-7111',
    population: 18608,
    county: 'SUMMIT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uakron.edu/',
  },
  {
    name: 'UNIVERSITY OF LOUISIANA AT LAFAYETTE',
    address: '104 UNIVERSITY CIRCLE',
    city: 'LAFAYETTE',
    state: 'LA',
    zip: 70503,
    telephone: '(377) 482-1000',
    population: 18627,
    county: 'LAFAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.louisiana.edu/',
  },
  {
    name: 'SIERRA COLLEGE',
    address: '5100 SIERRA COLLEGE BLVD',
    city: 'ROCKLIN',
    state: 'CA',
    zip: 95677,
    telephone: '(916) 624-3333',
    population: 18642,
    county: 'PLACER',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sierracollege.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-CHICO',
    address: 'FIRST AND NORMAL STS',
    city: 'CHICO',
    state: 'CA',
    zip: 95929,
    telephone: '(530) 898-6116',
    population: 18659,
    county: 'BUTTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csuchico.edu/',
  },
  {
    name: 'RIO SALADO COLLEGE',
    address: '2323 W 14TH ST',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85281,
    telephone: '(480) 517-8000',
    population: 18769,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rio.maricopa.edu/',
  },
  {
    name: 'MESA COMMUNITY COLLEGE',
    address: '1833 W SOUTHERN AVE',
    city: 'MESA',
    state: 'AZ',
    zip: 85202,
    telephone: '(480) 461-7000',
    population: 18794,
    county: 'MARICOPA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mesacc.edu/',
  },
  {
    name: 'TROY UNIVERSITY',
    address: 'UNIVERSITY AVENUE',
    city: 'TROY',
    state: 'AL',
    zip: 36082,
    telephone: '(334) 670-3100',
    population: 18836,
    county: 'PIKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.troy.edu/',
  },
  {
    name: 'SOUTHWESTERN COLLEGE',
    address: '900 OTAY LAKES RD.',
    city: 'CHULA VISTA',
    state: 'CA',
    zip: 91910,
    telephone: '(619) 421-6700',
    population: 18957,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.swccd.edu/',
  },
  {
    name: 'UNIVERSITY OF NOTRE DAME',
    address: '400 MAIN BUILDING',
    city: 'NOTRE DAME',
    state: 'IN',
    zip: 46556,
    telephone: '(574) 631-5000',
    population: 19035,
    county: 'ST. JOSEPH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nd.edu/',
  },
  {
    name: 'SAN JOAQUIN DELTA COLLEGE',
    address: '5151 PACIFIC AVE',
    city: 'STOCKTON',
    state: 'CA',
    zip: 95207,
    telephone: '(209) 954-5151',
    population: 19036,
    county: 'SAN JOAQUIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.deltacollege.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH FLORIDA',
    address: '1 UNF DRIVE',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32224,
    telephone: '(904) 620-1000',
    population: 19108,
    county: 'DUVAL',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.unf.edu/',
  },
  {
    name: 'BOSTON COLLEGE',
    address: '140 COMMONWEALTH AVENUE',
    city: 'CHESTNUT HILL',
    state: 'MA',
    zip: 2467,
    telephone: '(617) 552-8000',
    population: 19123,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bc.edu/',
  },
  {
    name: 'CUNY LAGUARDIA COMMUNITY COLLEGE',
    address: '31-10 THOMSON AVE',
    city: 'LONG ISLAND CITY',
    state: 'NY',
    zip: 11101,
    telephone: '(718) 482-7200',
    population: 19132,
    county: 'QUEENS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lagcc.cuny.edu/',
  },
  {
    name: 'UNIVERSITY OF MISSOURI-KANSAS CITY',
    address: '5000 HOLMES ST.',
    city: 'KANSAS CITY',
    state: 'MO',
    zip: 64110,
    telephone: '(816) 235-1000',
    population: 19161,
    county: 'JACKSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.umkc.edu/',
  },
  {
    name: 'ORANGE COAST COLLEGE',
    address: '2701 FAIRVIEW ROAD',
    city: 'COSTA MESA',
    state: 'CA',
    zip: 92626,
    telephone: '(714) 432-5072',
    population: 19219,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.orangecoastcollege.edu/',
  },
  {
    name: 'CENTRAL PIEDMONT COMMUNITY COLLEGE',
    address: '1201 ELIZABETH AVENUE',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28204,
    telephone: '(704) 330-2722',
    population: 19271,
    county: 'MECKLENBURG',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cpcc.edu/',
  },
  {
    name: 'CARNEGIE MELLON UNIVERSITY',
    address: '5000 FORBES AVENUE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15213,
    telephone: '(412) 268-2000',
    population: 19307,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cmu.edu/',
  },
  {
    name: 'VANDERBILT UNIVERSITY',
    address: '2101 WEST END AVENUE',
    city: 'NASHVILLE',
    state: 'TN',
    zip: 37240,
    telephone: '(615) 322-7311',
    population: 19417,
    county: 'DAVIDSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vanderbilt.edu/',
  },
  {
    name: 'NORTHWEST VISTA COLLEGE',
    address: '3535 N. ELLISON DRIVE',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78251,
    telephone: '(210) 486-4000',
    population: 19448,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'alamo.edu/nvc/',
  },
  {
    name: 'BLINN COLLEGE',
    address: '902 COLLEGE AVE',
    city: 'BRENHAM',
    state: 'TX',
    zip: 77833,
    telephone: '(979) 830-4000',
    population: 19491,
    county: 'WASHINGTON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.blinn.edu/',
  },
  {
    name: 'TULANE UNIVERSITY OF LOUISIANA',
    address: '6823 ST. CHARLES AVENUE',
    city: 'NEW ORLEANS',
    state: 'LA',
    zip: 70118,
    telephone: '(504) 865-5000',
    population: 19524,
    county: 'ORLEANS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://tulane.edu/',
  },
  {
    name: 'COLUMBIA SOUTHERN UNIVERSITY',
    address: '21982 UNIVERSITY LANE',
    city: 'ORANGE BEACH',
    state: 'AL',
    zip: 36561,
    telephone: '(251) 981-3771 EXT 1278',
    population: 19536,
    county: 'BALDWIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbiasouthern.edu/',
  },
  {
    name: 'MONTANA STATE UNIVERSITY',
    address: 'MONTANA STATE UNIVERSITY',
    city: 'BOZEMAN',
    state: 'MT',
    zip: 59717,
    telephone: '(406) 994-0211',
    population: 19554,
    county: 'GALLATIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.montana.edu/',
  },
  {
    name: 'WEST CHESTER UNIVERSITY OF PENNSYLVANIA',
    address: 'UNIVERSITY AVENUE AND HIGH STREET',
    city: 'WEST CHESTER',
    state: 'PA',
    zip: 19383,
    telephone: '(610) 436-1000',
    population: 19588,
    county: 'CHESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.wcupa.edu/',
  },
  {
    name: 'DE ANZA COLLEGE',
    address: '21250 STEVENS CREEK BLVD.',
    city: 'CUPERTINO',
    state: 'CA',
    zip: 95014,
    telephone: '(408) 864-5678',
    population: 19622,
    county: 'SANTA CLARA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.deanza.edu/',
  },
  {
    name: 'FORDHAM UNIVERSITY',
    address: '441 E FORDHAM RD',
    city: 'BRONX',
    state: 'NY',
    zip: 10458,
    telephone: '(718) 817-1000',
    population: 19631,
    county: 'BRONX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fordham.edu/',
  },
  {
    name: 'DIABLO VALLEY COLLEGE',
    address: '321 GOLF CLUB RD',
    city: 'PLEASANT HILL',
    state: 'CA',
    zip: 94523,
    telephone: '(925) 685-1230',
    population: 19715,
    county: 'CONTRA COSTA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.dvc.edu/',
  },
  {
    name: 'NORTHERN ILLINOIS UNIVERSITY',
    address: '1425 W. LINCOLN HWY.',
    city: 'DEKALB',
    state: 'IL',
    zip: 60115,
    telephone: '(800) 892-3050',
    population: 19732,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.niu.edu/',
  },
  {
    name: 'CENTRAL MICHIGAN UNIVERSITY',
    address: '106 WARRINER HALL',
    city: 'MOUNT PLEASANT',
    state: 'MI',
    zip: 48859,
    telephone: '(989) 774-4000',
    population: 19811,
    county: 'ISABELLA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.cmich.edu/',
  },
  {
    name: 'WESTERN KENTUCKY UNIVERSITY',
    address: '1906 COLLEGE HEIGHTS BLVD',
    city: 'BOWLING GREEN',
    state: 'KY',
    zip: 42101,
    telephone: '(270) 745-0111',
    population: 19864,
    county: 'WARREN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wku.edu/',
  },
  {
    name: 'UNIVERSITY OF MASSACHUSETTS-LOWELL',
    address: '1 UNIVERSITY AVE',
    city: 'LOWELL',
    state: 'MA',
    zip: 1854,
    telephone: '(978) 934-4000',
    population: 20126,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uml.edu/',
  },
  {
    name: 'CUNY BROOKLYN COLLEGE',
    address: '2900 BEDFORD AVE',
    city: 'BROOKLYN',
    state: 'NY',
    zip: 11210,
    telephone: '(718) 951-5000',
    population: 20147,
    county: 'KINGS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.brooklyn.cuny.edu/',
  },
  {
    name: 'COMMUNITY COLLEGE OF BALTIMORE COUNTY',
    address: '7201 ROSSVILLE BOULEVARD',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21237,
    telephone: '(443) 840-2222',
    population: 20170,
    county: 'BALTIMORE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccbcmd.edu/',
  },
  {
    name: 'ROCHESTER INSTITUTE OF TECHNOLOGY',
    address: '1 LOMB MEMORIAL DR',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14623,
    telephone: '(585) 475-2411',
    population: 20200,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.rit.edu/',
  },
  {
    name: 'SADDLEBACK COLLEGE',
    address: '28000 MARGUERITE PKY',
    city: 'MISSION VIEJO',
    state: 'CA',
    zip: 92692,
    telephone: '(949) 582-4500',
    population: 20211,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.saddleback.edu/',
  },
  {
    name: 'FRONT RANGE COMMUNITY COLLEGE',
    address: '3645 W 112TH AVE',
    city: 'WESTMINSTER',
    state: 'CO',
    zip: 80031,
    telephone: '(303) 404-5000',
    population: 20282,
    county: 'ADAMS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.frontrange.edu/',
  },
  {
    name: 'BOWLING GREEN STATE UNIVERSITY-MAIN CAMPUS',
    address: '220 MCFALL CTR',
    city: 'BOWLING GREEN',
    state: 'OH',
    zip: 43403,
    telephone: '(418) 372-5526',
    population: 20322,
    county: 'WOOD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bgsu.edu/',
  },
  {
    name: 'UNIVERSITY OF THE CUMBERLANDS',
    address: '6191 COLLEGE STATION DRIVE',
    city: 'WILLIAMSBURG',
    state: 'KY',
    zip: 40769,
    telephone: '(606) 549-2200',
    population: 20362,
    county: 'WHITLEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucumberlands.edu/',
  },
  {
    name: 'LOYOLA UNIVERSITY CHICAGO',
    address: '1032 W. SHERIDAN RD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60660,
    telephone: '(773) 274-3000',
    population: 20366,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.luc.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA WILMINGTON',
    address: '601 SOUTH COLLEGE ROAD',
    city: 'WILMINGTON',
    state: 'NC',
    zip: 28403,
    telephone: '(910) 962-3000',
    population: 20394,
    county: 'NEW HANOVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uncw.edu/',
  },
  {
    name: 'SAN ANTONIO COLLEGE',
    address: '1819 N. MAIN AVE.,',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78212,
    telephone: '(210) 486-0000',
    population: 20419,
    county: 'BEXAR',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.alamo.edu/sac',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-DOMINGUEZ HILLS',
    address: '1000 E VICTORIA ST',
    city: 'CARSON',
    state: 'CA',
    zip: 90747,
    telephone: '(310) 243-3696',
    population: 20426,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csudh.edu/',
  },
  {
    name: 'SINCLAIR COMMUNITY COLLEGE',
    address: '444 W. THIRD ST.',
    city: 'DAYTON',
    state: 'OH',
    zip: 45402,
    telephone: '(937) 512-3000',
    population: 20546,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sinclair.edu/',
  },
  {
    name: 'UNIVERSITY OF RHODE ISLAND',
    address: 'GREEN HALL, 35 CAMPUS AVENUE',
    city: 'KINGSTON',
    state: 'RI',
    zip: 2881,
    telephone: '(401) 874-1000',
    population: 20758,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'web.uri.edu/',
  },
  {
    name: 'SUNY AT ALBANY',
    address: '1400 WASHINGTON AVENUE',
    city: 'ALBANY',
    state: 'NY',
    zip: 12222,
    telephone: '(518) 442-3300',
    population: 20764,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.albany.edu/',
  },
  {
    name: 'BINGHAMTON UNIVERSITY',
    address: '4400 VESTAL PARKWAY EAST',
    city: 'VESTAL',
    state: 'NY',
    zip: 13850,
    telephone: '(607) 777-2000',
    population: 20959,
    county: 'BROOME',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.binghamton.edu/',
  },
  {
    name: 'SACRAMENTO CITY COLLEGE',
    address: '3835 FREEPORT BLVD',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95822,
    telephone: '(916) 558-2111',
    population: 20974,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.scc.losrios.edu/',
  },
  {
    name: 'OAKLAND UNIVERSITY',
    address: '2200 NORTH SQUIRREL ROAD',
    city: 'ROCHESTER HILLS',
    state: 'MI',
    zip: 48309,
    telephone: '(248) 370-2100',
    population: 20986,
    county: 'OAKLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.oakland.edu/',
  },
  {
    name: 'METROPOLITAN STATE UNIVERSITY OF DENVER',
    address: 'SPEER BLVD AND COLFAX AVE',
    city: 'DENVER',
    state: 'CO',
    zip: 80217,
    telephone: '(303) 556-3058',
    population: 21004,
    county: 'DENVER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.msudenver.edu/',
  },
  {
    name: 'RIVERSIDE CITY COLLEGE',
    address: '4800 MAGNOLIA AVENUE',
    city: 'RIVERSIDE',
    state: 'CA',
    zip: 92506,
    telephone: '(951) 222-8000 EXT 8979',
    population: 21112,
    county: 'RIVERSIDE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.rcc.edu/riverside/',
  },
  {
    name: 'SANTA ANA COLLEGE',
    address: '1530 W. 17TH STREET',
    city: 'SANTA ANA',
    state: 'CA',
    zip: 92706,
    telephone: '(714) 564-6000',
    population: 21321,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sac.edu/',
  },
  {
    name: 'UNIVERSITY OF ROCHESTER',
    address: 'WILSON BLVD. - WALLIS HALL',
    city: 'ROCHESTER',
    state: 'NY',
    zip: 14627,
    telephone: '(585) 275-3221',
    population: 21328,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rochester.edu/',
  },
  {
    name: 'CHAFFEY COLLEGE',
    address: '5885 HAVEN AVE',
    city: 'RANCHO CUCAMONGA',
    state: 'CA',
    zip: 91737,
    telephone: '(909) 652-6000',
    population: 21404,
    county: 'SAN BERNARDINO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.chaffey.edu/',
  },
  {
    name: 'NATIONAL UNIVERSITY',
    address: '11255 NORTH TORREY PINES ROAD',
    city: 'LA JOLLA',
    state: 'CA',
    zip: 92037,
    telephone: '(800) 628-8648',
    population: 21431,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nu.edu/',
  },
  {
    name: 'CITY COLLEGE OF SAN FRANCISCO',
    address: '50 FRIDA KAHLO DRIVE',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94112,
    telephone: '(415) 239-3000',
    population: 21493,
    county: 'SAN FRANCISCO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ccsf.edu/',
  },
  {
    name: 'CERRITOS COLLEGE',
    address: '11110 ALONDRA BLVD',
    city: 'NORWALK',
    state: 'CA',
    zip: 90650,
    telephone: '(562) 860-2451',
    population: 21584,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cerritos.edu/',
  },
  {
    name: 'UNIVERSITY OF TOLEDO',
    address: '2801 W BANCROFT',
    city: 'TOLEDO',
    state: 'OH',
    zip: 43606,
    telephone: '(800) 586-5336',
    population: 21610,
    county: 'LUCAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utoledo.edu/',
  },
  {
    name: 'SAN DIEGO MESA COLLEGE',
    address: '7250 MESA COLLEGE DR',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92111,
    telephone: '(619) 388-2600',
    population: 21616,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sdmesa.edu/',
  },
  {
    name: 'EL CAMINO COMMUNITY COLLEGE DISTRICT',
    address: '16007 CRENSHAW BLVD',
    city: 'TORRANCE',
    state: 'CA',
    zip: 90506,
    telephone: '(310) 532-3670',
    population: 21680,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.elcamino.edu/',
  },
  {
    name: 'HILLSBOROUGH COMMUNITY COLLEGE',
    address: '39 COLUMBIA DRIVE',
    city: 'TAMPA',
    state: 'FL',
    zip: 33606,
    telephone: '(813) 253-7000',
    population: 21688,
    county: 'HILLSBOROUGH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.hccfl.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-SAN BERNARDINO',
    address: '5500 UNIVERSITY PARKWAY',
    city: 'SAN BERNARDINO',
    state: 'CA',
    zip: 92407,
    telephone: '(909) 537-5000',
    population: 21777,
    county: 'SAN BERNARDINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csusb.edu/',
  },
  {
    name: 'COLLEGE OF THE CANYONS',
    address: '26455 ROCKWELL CANYON RD',
    city: 'SANTA CLARITA',
    state: 'CA',
    zip: 91355,
    telephone: '(661) 259-7800',
    population: 21813,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.canyons.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH GEORGIA',
    address: '82 COLLEGE CIRCLE',
    city: 'DAHLONEGA',
    state: 'GA',
    zip: 30597,
    telephone: '(706) 864-1400',
    population: 21923,
    county: 'LUMPKIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ung.edu/',
  },
  {
    name: 'CUYAHOGA COMMUNITY COLLEGE DISTRICT',
    address: '700 CARNEGIE AVE',
    city: 'CLEVELAND',
    state: 'OH',
    zip: 44115,
    telephone: '(800) 954-8742',
    population: 22007,
    county: 'CUYAHOGA',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tri-c.edu/',
  },
  {
    name: 'CUNY QUEENS COLLEGE',
    address: '65-30 KISSENA BLVD',
    city: 'QUEENS',
    state: 'NY',
    zip: 11367,
    telephone: '(718) 997-5000',
    population: 22053,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.qc.cuny.edu/',
  },
  {
    name: 'DEVRY UNIVERSITY-ILLINOIS',
    address: '3300 N. CAMPBELL AVE.',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60618,
    telephone: '(773) 929-8500',
    population: 22110,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.devry.edu/',
  },
  {
    name: 'CUNY BERNARD M BARUCH COLLEGE',
    address: 'ONE BERNARD BARUCH WAY (55 LEXINGTON AVE AT 24TH ST)',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10010,
    telephone: '(646) 312-1000',
    population: 22122,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baruch.cuny.edu/',
  },
  {
    name: 'MIAMI UNIVERSITY-OXFORD',
    address: '501 EAST HIGH ST',
    city: 'OXFORD',
    state: 'OH',
    zip: 45056,
    telephone: '(513) 529-1809',
    population: 22122,
    county: 'BUTLER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'miamioh.edu/',
  },
  {
    name: 'UNIVERSITY OF HAWAII AT MANOA',
    address: '2500 CAMPUS ROAD',
    city: 'HONOLULU',
    state: 'HI',
    zip: 96822,
    telephone: '(808) 956-8111',
    population: 22457,
    county: 'HONOLULU',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://manoa.hawaii.edu/',
  },
  {
    name: 'PALOMAR COLLEGE',
    address: '1140 W. MISSION',
    city: 'SAN MARCOS',
    state: 'CA',
    zip: 92069,
    telephone: '(760) 744-1150',
    population: 22506,
    county: 'SAN DIEGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www2.palomar.edu/',
  },
  {
    name: "ST. JOHN'S UNIVERSITY-NEW YORK",
    address: '8000 UTOPIA PKY',
    city: 'QUEENS',
    state: 'NY',
    zip: 11439,
    telephone: '(718) 990-6161',
    population: 22603,
    county: 'QUEENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stjohns.edu/',
  },
  {
    name: 'WESTERN MICHIGAN UNIVERSITY',
    address: '1903 W MICHIGAN AVE',
    city: 'KALAMAZOO',
    state: 'MI',
    zip: 49008,
    telephone: '(269) 387-1000',
    population: 22608,
    county: 'KALAMAZOO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://wmich.edu/',
  },
  {
    name: 'FULLERTON COLLEGE',
    address: '321 E CHAPMAN AVENUE',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92832,
    telephone: '(714) 992-7000',
    population: 22647,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fullcoll.edu/',
  },
  {
    name: 'BAYLOR UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'WACO',
    state: 'TX',
    zip: 76798,
    telephone: '(254) 710-1011',
    population: 22706,
    county: 'MCLENNAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.baylor.edu/',
  },
  {
    name: 'MONTGOMERY COLLEGE',
    address: '51 MANNAKEE STREET',
    city: 'ROCKVILLE',
    state: 'MD',
    zip: 20850,
    telephone: '(240) 567-5000',
    population: 22779,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.montgomerycollege.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA AT GREENSBORO',
    address: '1400 SPRING GARDEN ST',
    city: 'GREENSBORO',
    state: 'NC',
    zip: 27402,
    telephone: '(336) 334-5000',
    population: 22811,
    county: 'GUILFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uncg.edu/',
  },
  {
    name: 'EXCELSIOR COLLEGE',
    address: '7 COLUMBIA CIR',
    city: 'ALBANY',
    state: 'NY',
    zip: 12203,
    telephone: '(518) 464-8500',
    population: 23067,
    county: 'ALBANY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.excelsior.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-SANTA CRUZ',
    address: '1156 HIGH ST',
    city: 'SANTA CRUZ',
    state: 'CA',
    zip: 95064,
    telephone: '(831) 459-0111',
    population: 23091,
    county: 'SANTA CRUZ',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucsc.edu/',
  },
  {
    name: 'COLLEGE OF DUPAGE',
    address: '425 FAWELL BLVD.',
    city: 'GLEN ELLYN',
    state: 'IL',
    zip: 60137,
    telephone: '(630) 942-2800',
    population: 23225,
    county: 'DUPAGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cod.edu/',
  },
  {
    name: 'APPALACHIAN STATE UNIVERSITY',
    address: '287 RIVERS ST',
    city: 'BOONE',
    state: 'NC',
    zip: 28608,
    telephone: '(828) 262-2000',
    population: 23259,
    county: 'WATAUGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.appstate.edu/',
  },
  {
    name: 'CENTRAL NEW MEXICO COMMUNITY COLLEGE',
    address: '525 BUENA VISTA DR SE',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87106,
    telephone: '(505) 224-3000',
    population: 23292,
    county: 'BERNALILLO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.cnm.edu/',
  },
  {
    name: 'ROWAN UNIVERSITY',
    address: '201 MULLICA HILL ROAD',
    city: 'GLASSBORO',
    state: 'NJ',
    zip: 8028,
    telephone: '(856) 256-4000',
    population: 23638,
    county: 'GLOUCESTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.rowan.edu/',
  },
  {
    name: 'FRESNO CITY COLLEGE',
    address: '1101 E. UNIVERSITY AVE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93741,
    telephone: '(559) 442-4600',
    population: 23680,
    county: 'FRESNO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fresnocitycollege.edu/',
  },
  {
    name: 'WAKE TECHNICAL COMMUNITY COLLEGE',
    address: '9101 FAYETTEVILLE ROAD',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27603,
    telephone: '(919) 866-5000',
    population: 23872,
    county: 'WAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.waketech.edu/',
  },
  {
    name: 'KEISER UNIVERSITY-FT LAUDERDALE',
    address: '1500 NW 49TH ST.',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33309,
    telephone: '(954) 776-4476',
    population: 23904,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.keiseruniversity.edu/',
  },
  {
    name: 'MONTCLAIR STATE UNIVERSITY',
    address: '1 NORMAL AVENUE',
    city: 'MONTCLAIR',
    state: 'NJ',
    zip: 7043,
    telephone: '(973) 655-4000',
    population: 24106,
    county: 'PASSAIC',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.montclair.edu/',
  },
  {
    name: 'ILLINOIS STATE UNIVERSITY',
    address: 'NORTH AND SCHOOL STREETS',
    city: 'NORMAL',
    state: 'IL',
    zip: 61790,
    telephone: '(309) 438-2111',
    population: 24258,
    county: 'MCLEAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'illinoisstate.edu/',
  },
  {
    name: 'SAM HOUSTON STATE UNIVERSITY',
    address: '1806 AVE J',
    city: 'HUNTSVILLE',
    state: 'TX',
    zip: 77340,
    telephone: '(936) 294-1111',
    population: 24407,
    county: 'WALKER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.shsu.edu/',
  },
  {
    name: 'FLORIDA STATE COLLEGE AT JACKSONVILLE',
    address: '501 W STATE ST',
    city: 'JACKSONVILLE',
    state: 'FL',
    zip: 32202,
    telephone: '(904) 633-8100',
    population: 24422,
    county: 'DUVAL',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.fscj.edu/',
  },
  {
    name: 'DES MOINES AREA COMMUNITY COLLEGE',
    address: '2006 ANKENY BLVD',
    city: 'ANKENY',
    state: 'IA',
    zip: 50023,
    telephone: '(515) 964-6200',
    population: 24575,
    county: 'POLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dmacc.edu/',
  },
  {
    name: 'MIDDLE TENNESSEE STATE UNIVERSITY',
    address: '1301 EAST MAIN STREET',
    city: 'MURFREESBORO',
    state: 'TN',
    zip: 37132,
    telephone: '(615) 898-2300',
    population: 24652,
    county: 'RUTHERFORD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.mtsu.edu/',
  },
  {
    name: 'SUFFOLK COUNTY COMMUNITY COLLEGE',
    address: '533 COLLEGE RD',
    city: 'SELDEN',
    state: 'NY',
    zip: 11784,
    telephone: '(631) 451-4110',
    population: 24716,
    county: 'SUFFOLK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.sunysuffolk.edu/',
  },
  {
    name: 'LONG BEACH CITY COLLEGE',
    address: '4901 E. CARSON ST.',
    city: 'LONG BEACH',
    state: 'CA',
    zip: 90808,
    telephone: '(562) 938-4111',
    population: 24729,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lbcc.edu/',
  },
  {
    name: 'UNIVERSITY OF NEVADA-RENO',
    address: 'NORTH VIRGINIA STREET',
    city: 'RENO',
    state: 'NV',
    zip: 89557,
    telephone: '(775) 784-1110',
    population: 25000,
    county: 'WASHOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unr.edu/',
  },
  {
    name: 'TOWSON UNIVERSITY',
    address: '8000 YORK RD',
    city: 'TOWSON',
    state: 'MD',
    zip: 21252,
    telephone: '(410) 704-2000',
    population: 25129,
    county: 'BALTIMORE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.towson.edu/',
  },
  {
    name: 'BALL STATE UNIVERSITY',
    address: '2000 UNIVERSITY AVE',
    city: 'MUNCIE',
    state: 'IN',
    zip: 47306,
    telephone: '(765) 289-1241',
    population: 25208,
    county: 'DELAWARE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bsu.edu/',
  },
  {
    name: 'CALIFORNIA POLYTECHNIC STATE UNIVERSITY-SAN LUIS OBISPO',
    address: '1 GRAND AVE.',
    city: 'SAN LUIS OBISPO',
    state: 'CA',
    zip: 93407,
    telephone: '(805) 756-1111',
    population: 25254,
    county: 'SAN LUIS OBISPO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'calpoly.edu/',
  },
  {
    name: 'CUNY BOROUGH OF MANHATTAN COMMUNITY COLLEGE',
    address: '199 CHAMBERS ST',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10007,
    telephone: '(212) 220-8000',
    population: 25263,
    county: 'NEW YORK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bmcc.cuny.edu/',
  },
  {
    name: 'MASSACHUSETTS INSTITUTE OF TECHNOLOGY',
    address: '77 MASSACHUSETTS AVENUE',
    city: 'CAMBRIDGE',
    state: 'MA',
    zip: 2139,
    telephone: '(617) 253-1000',
    population: 25286,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'web.mit.edu/',
  },
  {
    name: 'DEPAUL UNIVERSITY',
    address: '1 E JACKSON BLVD',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60604,
    telephone: '(312) 362-8000',
    population: 25295,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.depaul.edu/',
  },
  {
    name: 'JAMES MADISON UNIVERSITY',
    address: '800 SOUTH MAIN STREET',
    city: 'HARRISONBURG',
    state: 'VA',
    zip: 22807,
    telephone: '(540) 568-6211',
    population: 25330,
    county: 'HARRISONBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jmu.edu/',
  },
  {
    name: 'NOVA SOUTHEASTERN UNIVERSITY',
    address: '3301 COLLEGE AVE',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33314,
    telephone: '(954) 262-7300',
    population: 25444,
    county: 'BROWARD',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nova.edu/',
  },
  {
    name: 'UNIVERSITY OF MEMPHIS',
    address: 'SOUTHERN AVENUE',
    city: 'MEMPHIS',
    state: 'TN',
    zip: 38152,
    telephone: '(901) 678-2000',
    population: 25467,
    county: 'SHELBY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.memphis.edu/',
  },
  {
    name: 'PORTLAND COMMUNITY COLLEGE',
    address: '12000 SW 49TH AVENUE',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97219,
    telephone: '(971) 722-6111',
    population: 25631,
    county: 'MULTNOMAH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.pcc.edu/',
  },
  {
    name: 'KANSAS STATE UNIVERSITY',
    address: '919 MID-CAMPUS DRIVE, ANDERSON HALL',
    city: 'MANHATTAN',
    state: 'KS',
    zip: 66506,
    telephone: '(785) 532-6011',
    population: 25635,
    county: 'RILEY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.k-state.edu/',
  },
  {
    name: 'GEORGETOWN UNIVERSITY',
    address: '37TH AND O ST NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20057,
    telephone: '(202) 687-0100',
    population: 25662,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.georgetown.edu/',
  },
  {
    name: 'BAKERSFIELD COLLEGE',
    address: '1801 PANORAMA DR',
    city: 'BAKERSFIELD',
    state: 'CA',
    zip: 93305,
    telephone: '(661) 395-4011',
    population: 25966,
    county: 'KERN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.bakersfieldcollege.edu/',
  },
  {
    name: 'GRAND VALLEY STATE UNIVERSITY',
    address: '1 CAMPUS DR',
    city: 'ALLENDALE',
    state: 'MI',
    zip: 49401,
    telephone: '(616) 331-2020',
    population: 26284,
    county: 'OTTAWA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gvsu.edu/',
  },
  {
    name: 'MISSOURI STATE UNIVERSITY-SPRINGFIELD',
    address: '901 S NATIONAL AVENUE',
    city: 'SPRINGFIELD',
    state: 'MO',
    zip: 65897,
    telephone: '(417) 836-5000',
    population: 26289,
    county: 'GREENE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.missouristate.edu/',
  },
  {
    name: 'PASADENA CITY COLLEGE',
    address: '1570 E COLORADO BLVD.',
    city: 'PASADENA',
    state: 'CA',
    zip: 91106,
    telephone: '(626) 585-7123',
    population: 26551,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'pasadena.edu/',
  },
  {
    name: 'AMERICAN RIVER COLLEGE',
    address: '4700 COLLEGE OAK DR',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95841,
    telephone: '(916) 484-8011',
    population: 26654,
    county: 'SACRAMENTO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.arc.losrios.edu/',
  },
  {
    name: 'UNIVERSITY OF OREGON',
    address: '110 JOHNSON HALL',
    city: 'EUGENE',
    state: 'OR',
    zip: 97403,
    telephone: '(541) 346-1000',
    population: 26681,
    county: 'LANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uoregon.edu/',
  },
  {
    name: 'PORTLAND STATE UNIVERSITY',
    address: '724 SW HARRISON',
    city: 'PORTLAND',
    state: 'OR',
    zip: 97201,
    telephone: '(503) 725-3000',
    population: 26783,
    county: 'MULTNOMAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pdx.edu/',
  },
  {
    name: 'FULL SAIL UNIVERSITY',
    address: '3300 UNIVERSITY BLVD',
    city: 'WINTER PARK',
    state: 'FL',
    zip: 32792,
    telephone: '(407) 679-0100',
    population: 26899,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fullsail.edu/',
  },
  {
    name: 'SYRACUSE UNIVERSITY',
    address: '900 SOUTH CROUSE AVE.',
    city: 'SYRACUSE',
    state: 'NY',
    zip: 13244,
    telephone: '(315) 443-1870',
    population: 26900,
    county: 'ONONDAGA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.syracuse.edu/',
  },
  {
    name: 'EMORY UNIVERSITY',
    address: '201 DOWMAN DRIVE',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30322,
    telephone: '(404) 727-6123',
    population: 26950,
    county: 'DEKALB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.emory.edu/',
  },
  {
    name: 'CUNY HUNTER COLLEGE',
    address: '695 PARK AVE',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10065,
    telephone: '(212) 772-4000',
    population: 27203,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.hunter.cuny.edu/',
  },
  {
    name: 'BOISE STATE UNIVERSITY',
    address: '1910 UNIVERSITY DR',
    city: 'BOISE',
    state: 'ID',
    zip: 83725,
    telephone: '(208) 426-1000',
    population: 27272,
    county: 'ADA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.boisestate.edu/',
  },
  {
    name: 'OLD DOMINION UNIVERSITY',
    address: '5115 HAMPTON BLVD',
    city: 'NORFOLK',
    state: 'VA',
    zip: 23529,
    telephone: '(757) 683-3000',
    population: 27526,
    county: 'NORFOLK CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.odu.edu/',
  },
  {
    name: 'SANTA MONICA COLLEGE',
    address: '1900 PICO BLVD',
    city: 'SANTA MONICA',
    state: 'CA',
    zip: 90405,
    telephone: '(310) 434-4000',
    population: 27716,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.smc.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT EL PASO',
    address: '500 W. UNIVERSITY AVE',
    city: 'EL PASO',
    state: 'TX',
    zip: 79968,
    telephone: '(915) 747-5000',
    population: 27843,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utep.edu/',
  },
  {
    name: 'NORTHEASTERN UNIVERSITY',
    address: '360 HUNTINGTON AVE',
    city: 'BOSTON',
    state: 'MA',
    zip: 2115,
    telephone: '(617) 373-2000',
    population: 27955,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northeastern.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-FRESNO',
    address: '5241 N MAPLE AVE',
    city: 'FRESNO',
    state: 'CA',
    zip: 93740,
    telephone: '(559) 278-4240',
    population: 27985,
    county: 'FRESNO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fresnostate.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-MILWAUKEE',
    address: '2200 E KENWOOD BLVD',
    city: 'MILWAUKEE',
    state: 'WI',
    zip: 53211,
    telephone: '(414) 229-1122',
    population: 28132,
    county: 'MILWAUKEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uwm.edu/',
  },
  {
    name: 'MISSISSIPPI STATE UNIVERSITY',
    address: 'LEE BOULEVARD',
    city: 'MISSISSIPPI STATE',
    state: 'MS',
    zip: 39762,
    telephone: '(662) 325-2323',
    population: 28202,
    county: 'OKTIBBEHA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.msstate.edu/',
  },
  {
    name: 'EL PASO COMMUNITY COLLEGE',
    address: '9050 VISCOUNT BLVD',
    city: 'EL PASO',
    state: 'TX',
    zip: 79925,
    telephone: '(915) 831-2000',
    population: 28306,
    county: 'EL PASO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.epcc.edu/',
  },
  {
    name: 'DREXEL UNIVERSITY',
    address: '3141 CHESTNUT ST',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19104,
    telephone: '(215) 895-2000',
    population: 28508,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://drexel.edu/',
  },
  {
    name: 'UNIVERSITY OF DELAWARE',
    address: '104 HULLIHEN HALL',
    city: 'NEWARK',
    state: 'DE',
    zip: 19716,
    telephone: '(302) 831-2000',
    population: 28522,
    county: 'NEW CASTLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.udel.edu/',
  },
  {
    name: 'NUC UNIVERSITY',
    address: 'CARR. #2 EDIFICIO NATIONAL COLLEGE PLAZA',
    city: 'BAYAMON',
    state: 'PR',
    zip: 960,
    telephone: '(787) 982-3000 EXT 1140',
    population: 28719,
    county: 'BAYAMÓN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nuc.edu/',
  },
  {
    name: 'PALM BEACH STATE COLLEGE',
    address: '4200 CONGRESS AVE',
    city: 'LAKE WORTH',
    state: 'FL',
    zip: 33461,
    telephone: '(561) 967-7222',
    population: 28781,
    county: 'PALM BEACH',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.palmbeachstate.edu/',
  },
  {
    name: 'YALE UNIVERSITY',
    address: 'WOODBRIDGE HALL',
    city: 'NEW HAVEN',
    state: 'CT',
    zip: 6520,
    telephone: '(203) 432-4771',
    population: 28878,
    county: 'NEW HAVEN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.yale.edu/',
  },
  {
    name: 'ST PETERSBURG COLLEGE',
    address: '6021 142ND AVE N',
    city: 'CLEARWATER',
    state: 'FL',
    zip: 33760,
    telephone: '(727) 341-4772',
    population: 29046,
    county: 'PINELLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.spcollege.edu/',
  },
  {
    name: 'UNIVERSITY OF NEW MEXICO-MAIN CAMPUS',
    address: '1700 LOMAS BLVD NE',
    city: 'ALBUQUERQUE',
    state: 'NM',
    zip: 87106,
    telephone: '(505) 277-0111',
    population: 29086,
    county: 'BERNALILLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unm.edu/',
  },
  {
    name: 'UNIVERSITY OF LOUISVILLE',
    address: '2301 S 3RD ST',
    city: 'LOUISVILLE',
    state: 'KY',
    zip: 40292,
    telephone: '(502) 852-5555',
    population: 29210,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.louisville.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-LOS ANGELES',
    address: '5151 STATE UNIVERSITY DR',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90032,
    telephone: '(323) 343-3000',
    population: 29389,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.calstatela.edu/',
  },
  {
    name: 'OHIO UNIVERSITY-MAIN CAMPUS',
    address: '020 CHUBB HALL',
    city: 'ATHENS',
    state: 'OH',
    zip: 45701,
    telephone: '(740) 593-1000',
    population: 29401,
    county: 'ATHENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.ohio.edu/',
  },
  {
    name: 'CHAMBERLAIN UNIVERSITY-ILLINOIS',
    address: '1221 N. SWIFT ROAD',
    city: 'ADDISON',
    state: 'IL',
    zip: 60101,
    telephone: '(630) 953-3660',
    population: 29481,
    county: 'DUPAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.chamberlain.edu/',
  },
  {
    name: 'COLUMBUS STATE COMMUNITY COLLEGE',
    address: '550 E SPRING ST',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43215,
    telephone: '(614) 287-5353',
    population: 29945,
    county: 'FRANKLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.cscc.edu/',
  },
  {
    name: 'UNIVERSITY OF MIAMI',
    address: 'UNIVERSITY OF MIAMI',
    city: 'CORAL GABLES',
    state: 'FL',
    zip: 33146,
    telephone: '(305) 284-2211',
    population: 29973,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.miami.edu/',
  },
  {
    name: 'OKLAHOMA STATE UNIVERSITY-MAIN CAMPUS',
    address: '107 WHITEHURST',
    city: 'STILLWATER',
    state: 'OK',
    zip: 74078,
    telephone: '(405) 744-5000',
    population: 30037,
    county: 'PAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.okstate.edu/',
  },
  {
    name: 'GEORGIA SOUTHERN UNIVERSITY',
    address: '1332 SOUTHERN DRIVE',
    city: 'STATESBORO',
    state: 'GA',
    zip: 30460,
    telephone: '(912) 478-5391',
    population: 30116,
    county: 'BULLOCH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.georgiasouthern.edu/',
  },
  {
    name: 'MT SAN ANTONIO COLLEGE',
    address: '1100 N GRAND AVE',
    city: 'WALNUT',
    state: 'CA',
    zip: 91789,
    telephone: '(909) 274-7500',
    population: 30125,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mtsac.edu/',
  },
  {
    name: 'UNIVERSITY OF CHICAGO',
    address: '5801 S ELLIS AVE',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60637,
    telephone: '(773) 702-1234',
    population: 30198,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uchicago.edu/',
  },
  {
    name: 'COLORADO TECHNICAL UNIVERSITY-COLORADO SPRINGS',
    address: '4435 N CHESTNUT STREET',
    city: 'COLORADO SPRINGS',
    state: 'CO',
    zip: 80907,
    telephone: '(719) 598-0200',
    population: 30267,
    county: 'EL PASO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.coloradotech.edu/Colorado-Springs',
  },
  {
    name: 'SOUTH TEXAS COLLEGE',
    address: '3201 W PECAN',
    city: 'MCALLEN',
    state: 'TX',
    zip: 78502,
    telephone: '(956) 872-8311',
    population: 30440,
    county: 'HIDALGO',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.southtexascollege.edu/',
  },
  {
    name: 'SAN FRANCISCO STATE UNIVERSITY',
    address: '1600 HOLLOWAY AVE',
    city: 'SAN FRANCISCO',
    state: 'CA',
    zip: 94132,
    telephone: '(415) 338-1111',
    population: 30596,
    county: 'SAN FRANCISCO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sfsu.edu/',
  },
  {
    name: 'KENT STATE UNIVERSITY AT KENT',
    address: 'EXECUTIVE OFFICE, 2ND FLOOR LIBRARY',
    city: 'KENT',
    state: 'OH',
    zip: 44242,
    telephone: '(330) 672-3000',
    population: 30612,
    county: 'PORTAGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kent.edu/',
  },
  {
    name: 'SALT LAKE COMMUNITY COLLEGE',
    address: '4600 S REDWOOD RD',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84123,
    telephone: '(801) 957-4111',
    population: 30721,
    county: 'SALT LAKE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.slcc.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-RIVERSIDE',
    address: '900 UNIVERSITY AVE',
    city: 'RIVERSIDE',
    state: 'CA',
    zip: 92521,
    telephone: '(951) 827-1012',
    population: 30913,
    county: 'RIVERSIDE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucr.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-SANTA BARBARA',
    address: '5221 CHEADLE HALL',
    city: 'SANTA BARBARA',
    state: 'CA',
    zip: 93106,
    telephone: '(805) 893-8000',
    population: 31335,
    county: 'SANTA BARBARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucsb.edu/',
  },
  {
    name: 'UTAH STATE UNIVERSITY',
    address: 'OLD MAIN HILL',
    city: 'LOGAN',
    state: 'UT',
    zip: 84322,
    telephone: '(435) 797-1000',
    population: 31436,
    county: 'CACHE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usu.edu/',
  },
  {
    name: 'UNIVERSITY OF NEBRASKA-LINCOLN',
    address: '1400 R STREET',
    city: 'LINCOLN',
    state: 'NE',
    zip: 68588,
    telephone: '(402) 472-7211',
    population: 31540,
    county: 'LANCASTER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unl.edu/',
  },
  {
    name: 'WEBER STATE UNIVERSITY',
    address: '3850 DIXON PARKWAY DR. DEPT. 1031',
    city: 'OGDEN',
    state: 'UT',
    zip: 84408,
    telephone: '(801) 626-6000',
    population: 31688,
    county: 'WEBER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.weber.edu/',
  },
  {
    name: 'CLEMSON UNIVERSITY',
    address: '201 SIKES HALL',
    city: 'CLEMSON',
    state: 'SC',
    zip: 29634,
    telephone: '(864) 656-4636',
    population: 31991,
    county: 'PICKENS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.clemson.edu/',
  },
  {
    name: 'STONY BROOK UNIVERSITY',
    address: '310 ADMINISTRATION BUILDING',
    city: 'STONY BROOK',
    state: 'NY',
    zip: 11794,
    telephone: '(631) 632-6000',
    population: 32161,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.stonybrook.edu/',
  },
  {
    name: 'WASHINGTON UNIVERSITY IN ST LOUIS',
    address: 'ONE BROOKINGS DRIVE',
    city: 'SAINT LOUIS',
    state: 'MO',
    zip: 63130,
    telephone: '(314) 935-5000',
    population: 32351,
    county: 'ST. LOUIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wustl.edu/',
  },
  {
    name: 'COLLEGE OF SOUTHERN NEVADA',
    address: '6375 W. CHARLESTON BLVD.',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89146,
    telephone: '(702) 651-5000',
    population: 32365,
    county: 'CLARK',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.csn.edu/',
  },
  {
    name: 'WAYNE STATE UNIVERSITY',
    address: '656 WEST KIRBY STREET',
    city: 'DETROIT',
    state: 'MI',
    zip: 48202,
    telephone: '(313) 577-2424',
    population: 32539,
    county: 'WAYNE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wayne.edu/',
  },
  {
    name: 'WEST VIRGINIA UNIVERSITY',
    address: 'PO BOX 6201',
    city: 'MORGANTOWN',
    state: 'WV',
    zip: 26506,
    telephone: '(304) 293-0111',
    population: 32612,
    county: 'MONONGALIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wvu.edu/',
  },
  {
    name: 'STANFORD UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'STANFORD',
    state: 'CA',
    zip: 94305,
    telephone: '(650) 723-2300',
    population: 32626,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.stanford.edu/',
  },
  {
    name: 'CALIFORNIA STATE POLYTECHNIC UNIVERSITY-POMONA',
    address: '3801 W TEMPLE AVENUE',
    city: 'POMONA',
    state: 'CA',
    zip: 91768,
    telephone: '(909) 869-7659',
    population: 32636,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cpp.edu/',
  },
  {
    name: 'UNIVERSITY OF ALABAMA AT BIRMINGHAM',
    address: 'ADMINISTRATION BLDG SUITE 1070',
    city: 'BIRMINGHAM',
    state: 'AL',
    zip: 35294,
    telephone: '(205) 934-4011',
    population: 32656,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uab.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT DALLAS',
    address: '800 WEST CAMPBELL ROAD',
    city: 'RICHARDSON',
    state: 'TX',
    zip: 75080,
    telephone: '(972) 883-2111',
    population: 32772,
    county: 'DALLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utdallas.edu/',
  },
  {
    name: 'UNIVERSITY OF ARKANSAS',
    address: 'ADMINISTRATION BLDG 425',
    city: 'FAYETTEVILLE',
    state: 'AR',
    zip: 72701,
    telephone: '(479) 575-2000',
    population: 32804,
    county: 'WASHINGTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uark.edu/',
  },
  {
    name: 'NORTHWESTERN UNIVERSITY',
    address: '633 CLARK ST',
    city: 'EVANSTON',
    state: 'IL',
    zip: 60208,
    telephone: '(847) 491-3741',
    population: 33041,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.northwestern.edu/',
  },
  {
    name: 'NORTHERN ARIZONA UNIVERSITY',
    address: '1900 S KNOLES DR, BABBITT ADMINISTRATIVE CENTER, ROOM 200',
    city: 'FLAGSTAFF',
    state: 'AZ',
    zip: 86011,
    telephone: '(928) 523-9011',
    population: 33051,
    county: 'COCONINO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://nau.edu/',
  },
  {
    name: 'GEORGE WASHINGTON UNIVERSITY',
    address: '1918 F STREET, NW',
    city: 'WASHINGTON',
    state: 'DC',
    zip: 20052,
    telephone: '(202) 994-1000',
    population: 33278,
    county: 'DISTRICT OF COLUMBIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.gwu.edu/',
  },
  {
    name: 'UNIVERSITY OF OKLAHOMA-NORMAN CAMPUS',
    address: '660 PARRINGTON OVAL',
    city: 'NORMAN',
    state: 'OK',
    zip: 73019,
    telephone: '(405) 325-0311',
    population: 33395,
    county: 'CLEVELAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ou.edu/',
  },
  {
    name: 'SAN JACINTO COMMUNITY COLLEGE',
    address: '8060 SPENCER HWY',
    city: 'PASADENA',
    state: 'TX',
    zip: 77505,
    telephone: '(281) 998-6150',
    population: 33424,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.sanjac.edu/',
  },
  {
    name: 'ASHFORD UNIVERSITY',
    address: '8620 SPECTRUM CENTER BOULEVARD',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92123,
    telephone: '(866) 711-1700',
    population: 33440,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ashford.edu/',
  },
  {
    name: 'UNIVERSITY OF MISSISSIPPI',
    address: 'OXFORD, MISSISSIPPI',
    city: 'UNIVERSITY',
    state: 'MS',
    zip: 38677,
    telephone: '(662) 915-7211',
    population: 34161,
    county: 'LAFAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.olemiss.edu/',
  },
  {
    name: 'FLORIDA ATLANTIC UNIVERSITY',
    address: '777 GLADES RD, ADMINISTRATION BLDG., ROOM 339',
    city: 'BOCA RATON',
    state: 'FL',
    zip: 33431,
    telephone: '(561) 297-3000',
    population: 34297,
    county: 'PALM BEACH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fau.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA AT CHARLOTTE',
    address: '9201 UNIVERSITY CITY BLVD',
    city: 'CHARLOTTE',
    state: 'NC',
    zip: 28223,
    telephone: '(704) 687-2000',
    population: 34319,
    county: 'MECKLENBURG',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uncc.edu/',
  },
  {
    name: 'EAST CAROLINA UNIVERSITY',
    address: 'EAST 5TH STREET',
    city: 'GREENVILLE',
    state: 'NC',
    zip: 27858,
    telephone: '(252) 328-6131',
    population: 34648,
    county: 'PITT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ecu.edu/',
  },
  {
    name: 'CORNELL UNIVERSITY',
    address: '300 DAY HALL',
    city: 'ITHACA',
    state: 'NY',
    zip: 14853,
    telephone: '(607) 255-2000',
    population: 34682,
    county: 'TOMPKINS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.cornell.edu/',
  },
  {
    name: 'EAST LOS ANGELES COLLEGE',
    address: '1301 AVENIDA CESAR CHAVEZ',
    city: 'MONTEREY PARK',
    state: 'CA',
    zip: 91754,
    telephone: '(323) 265-8650',
    population: 34752,
    county: 'LOS ANGELES',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.elac.edu/',
  },
  {
    name: 'DUKE UNIVERSITY',
    address: '103 ALLEN BLDG',
    city: 'DURHAM',
    state: 'NC',
    zip: 27708,
    telephone: '(919) 684-8111',
    population: 35280,
    county: 'DURHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.duke.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-SACRAMENTO',
    address: '6000 J ST',
    city: 'SACRAMENTO',
    state: 'CA',
    zip: 95819,
    telephone: '(916) 278-6011',
    population: 35463,
    county: 'SACRAMENTO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csus.edu/',
  },
  {
    name: 'UNIVERSITY OF KANSAS',
    address: 'STRONG HALL, 1450 JAYHAWK BLVD, ROOM 230',
    city: 'LAWRENCE',
    state: 'KS',
    zip: 66045,
    telephone: '(785) 864-2700',
    population: 35685,
    county: 'DOUGLAS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://ku.edu/',
  },
  {
    name: 'UNIVERSITY OF VIRGINIA-MAIN CAMPUS',
    address: '1827 UNIVERSITY AVENUE',
    city: 'CHARLOTTESVILLE',
    state: 'VA',
    zip: 22903,
    telephone: '(434) 924-0311',
    population: 35689,
    county: 'ALBEMARLE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.virginia.edu/',
  },
  {
    name: 'BROWARD COLLEGE',
    address: '111 EAST LAS OLAS BLVD',
    city: 'FORT LAUDERDALE',
    state: 'FL',
    zip: 33301,
    telephone: '(954) 201-7350',
    population: 35889,
    county: 'BROWARD',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.broward.edu/',
  },
  {
    name: 'VIRGINIA COMMONWEALTH UNIVERSITY',
    address: '910 W FRANKLIN ST',
    city: 'RICHMOND',
    state: 'VA',
    zip: 23284,
    telephone: '(804) 828-0100',
    population: 36171,
    county: 'RICHMOND CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.vcu.edu/',
  },
  {
    name: 'UNIVERSITY OF NEVADA-LAS VEGAS',
    address: '4505 S MARYLAND PKY',
    city: 'LAS VEGAS',
    state: 'NV',
    zip: 89154,
    telephone: '(702) 895-3011',
    population: 36573,
    county: 'CLARK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unlv.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS RIO GRANDE VALLEY',
    address: '1201 W UNIVERSITY DR',
    city: 'EDINBURG',
    state: 'TX',
    zip: 78539,
    telephone: '(956) 665-2011',
    population: 36826,
    county: 'HIDALGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utrgv.edu/',
  },
  {
    name: 'AUBURN UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'AUBURN',
    state: 'AL',
    zip: 36849,
    telephone: '(334) 844-4000',
    population: 37259,
    county: 'LEE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.auburn.edu/',
  },
  {
    name: 'UNIVERSITY OF MASSACHUSETTS-AMHERST',
    address: '374 WHITMORE BUILDING 181 PRESIDENTS DRIVE',
    city: 'AMHERST',
    state: 'MA',
    zip: 1003,
    telephone: '(413) 545-0111',
    population: 37327,
    county: 'HAMPSHIRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umass.edu/',
  },
  {
    name: 'UNIVERSITY OF CONNECTICUT',
    address: '352 MANSFIELD ROAD',
    city: 'STORRS',
    state: 'CT',
    zip: 6269,
    telephone: '(860) 486-2000',
    population: 37449,
    county: 'TOLLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uconn.edu/',
  },
  {
    name: 'UNIVERSITY OF COLORADO DENVER/ANSCHUTZ MEDICAL CAMPUS',
    address: '1380 LAWRENCE STREET, LAWRENCE STREET CENTER, SUITE 1400',
    city: 'DENVER',
    state: 'CO',
    zip: 80217,
    telephone: '(303) 556-5600',
    population: 37536,
    county: 'ADAMS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucdenver.edu/',
  },
  {
    name: 'UNIVERSITY AT BUFFALO',
    address: '12 CAPEN HALL',
    city: 'BUFFALO',
    state: 'NY',
    zip: 14260,
    telephone: '(716) 645-2000',
    population: 37642,
    county: 'ERIE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.buffalo.edu/',
  },
  {
    name: 'WASHINGTON STATE UNIVERSITY',
    address: 'FRENCH ADMINISTRATION BUILDING',
    city: 'PULLMAN',
    state: 'WA',
    zip: 99164,
    telephone: '(509) 335-3564',
    population: 37811,
    county: 'WHITMAN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'wsu.edu/',
  },
  {
    name: 'COLLIN COUNTY COMMUNITY COLLEGE DISTRICT',
    address: '3452 SPUR 399',
    city: 'MCKINNEY',
    state: 'TX',
    zip: 75069,
    telephone: '(972) 881-5790',
    population: 38157,
    county: 'COLLIN',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.collin.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT SAN ANTONIO',
    address: 'ONE UTSA CIRCLE',
    city: 'SAN ANTONIO',
    state: 'TX',
    zip: 78249,
    telephone: '(210) 458-4011',
    population: 38396,
    county: 'BEXAR',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utsa.edu/',
  },
  {
    name: 'OREGON STATE UNIVERSITY',
    address: '1500 SW JEFFERSON AVENUE',
    city: 'CORVALLIS',
    state: 'OR',
    zip: 97331,
    telephone: '(541) 737-0123',
    population: 38551,
    county: 'BENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://oregonstate.edu/',
  },
  {
    name: 'IOWA STATE UNIVERSITY',
    address: '1750 BEARDSHEAR HALL',
    city: 'AMES',
    state: 'IA',
    zip: 50011,
    telephone: '(515) 294-4111',
    population: 38575,
    county: 'STORY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iastate.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-PURDUE UNIVERSITY-INDIANAPOLIS',
    address: '420 UNIVERSITY BLVD',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46202,
    telephone: '(317) 274-5555',
    population: 38885,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.iupui.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TENNESSEE-KNOXVILLE',
    address: '527 ANDY HOLT TOWER',
    city: 'KNOXVILLE',
    state: 'TN',
    zip: 37996,
    telephone: '(865) 974-1000',
    population: 39517,
    county: 'KNOX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utk.edu/',
  },
  {
    name: 'SAN JOSE STATE UNIVERSITY',
    address: 'ONE WASHINGTON SQUARE',
    city: 'SAN JOSE',
    state: 'CA',
    zip: 95192,
    telephone: '(408) 924-1000',
    population: 39794,
    county: 'SANTA CLARA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sjsu.edu/',
  },
  {
    name: 'SAN DIEGO STATE UNIVERSITY',
    address: '5500 CAMPANILE DR',
    city: 'SAN DIEGO',
    state: 'CA',
    zip: 92182,
    telephone: '(619) 594-5200',
    population: 40053,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sdsu.edu/',
  },
  {
    name: 'COLORADO STATE UNIVERSITY-FORT COLLINS',
    address: '102 ADMINISTRATION BUILDING',
    city: 'FORT COLLINS',
    state: 'CO',
    zip: 80523,
    telephone: '(970) 491-1101',
    population: 40148,
    county: 'LARIMER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'colostate.edu/',
  },
  {
    name: 'CAPELLA UNIVERSITY',
    address: '225 SOUTH 6TH STREET, 9TH FLOOR',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55402,
    telephone: '(866) 808-4080',
    population: 40828,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.capella.edu/',
  },
  {
    name: 'LOUISIANA STATE UNIVERSITY AND AGRICULTURAL & MECHANICAL COLLEGE',
    address: '156 THOMAS BOYD HALL',
    city: 'BATON ROUGE',
    state: 'LA',
    zip: 70803,
    telephone: '(225) 578-3202',
    population: 40896,
    county: 'EAST BATON ROUGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.lsu.edu/',
  },
  {
    name: 'UNIVERSITY OF MISSOURI-COLUMBIA',
    address: '105 JESSE HALL',
    city: 'COLUMBIA',
    state: 'MO',
    zip: 65211,
    telephone: '(573) 882-2121',
    population: 41145,
    county: 'BOONE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://missouri.edu/',
  },
  {
    name: 'UNIVERSITY OF IOWA',
    address: '101 JESSUP HALL',
    city: 'IOWA CITY',
    state: 'IA',
    zip: 52242,
    telephone: '(319) 335-3500',
    population: 41273,
    county: 'JOHNSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uiowa.edu/',
  },
  {
    name: 'EASTERN GATEWAY COMMUNITY COLLEGE',
    address: '110 JOHN SCOTT HIGHWAY',
    city: 'STEUBENVILLE',
    state: 'OH',
    zip: 43952,
    telephone: '(740) 264-5591',
    population: 41628,
    county: 'JEFFERSON',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.egcc.edu/',
  },
  {
    name: 'BRIGHAM YOUNG UNIVERSITY',
    address: 'MAIN CAMPUS',
    city: 'PROVO',
    state: 'UT',
    zip: 84602,
    telephone: '(801) 422-4636',
    population: 41705,
    county: 'UTAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.byu.edu/',
  },
  {
    name: 'TEXAS STATE UNIVERSITY',
    address: '601 UNIVERSITY DR',
    city: 'SAN MARCOS',
    state: 'TX',
    zip: 78666,
    telephone: '(512) 245-2111',
    population: 41737,
    county: 'HAYS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.txstate.edu/',
  },
  {
    name: 'GEORGIA STATE UNIVERSITY',
    address: '33 GILMER ST',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30303,
    telephone: '(404) 413-2000',
    population: 41786,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gsu.edu/',
  },
  {
    name: 'UNIVERSITY OF KENTUCKY',
    address: 'SOUTH LIMESTONE',
    city: 'LEXINGTON',
    state: 'KY',
    zip: 40506,
    telephone: '(859) 257-9000',
    population: 42216,
    county: 'FAYETTE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uky.edu/',
  },
  {
    name: 'BOSTON UNIVERSITY',
    address: 'ONE SILBER WAY',
    city: 'BOSTON',
    state: 'MA',
    zip: 2215,
    telephone: '(617) 353-2000',
    population: 43124,
    county: 'SUFFOLK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.bu.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH CAROLINA-COLUMBIA',
    address: 'COLUMBIA-CAMPUS',
    city: 'COLUMBIA',
    state: 'SC',
    zip: 29208,
    telephone: '(803) 777-7000',
    population: 43203,
    county: 'RICHLAND',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.sc.edu/',
  },
  {
    name: 'AUSTIN COMMUNITY COLLEGE DISTRICT',
    address: '5930 MIDDLE FISKVILLE RD',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78752,
    telephone: '(512) 223-7000',
    population: 43414,
    county: 'TRAVIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.austincc.edu/',
  },
  {
    name: 'UNIVERSITY OF THE PEOPLE',
    address: '595 E COLORADO BLVD SUITE 623',
    city: 'PASADENA',
    state: 'CA',
    zip: 91101,
    telephone: '(626) 264-8880',
    population: 43748,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'uopeople.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-NORTHRIDGE',
    address: '18111 NORDHOFF ST',
    city: 'NORTHRIDGE',
    state: 'CA',
    zip: 91330,
    telephone: '(818) 677-1200',
    population: 44089,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.csun.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-LONG BEACH',
    address: '1250 BELLFLOWER BLVD',
    city: 'LONG BEACH',
    state: 'CA',
    zip: 90840,
    telephone: '(562) 985-4111',
    population: 44120,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.csulb.edu/',
  },
  {
    name: 'GEORGE MASON UNIVERSITY',
    address: '4400 UNIVERSITY DR',
    city: 'FAIRFAX',
    state: 'VA',
    zip: 22030,
    telephone: '(703) 993-1000',
    population: 44275,
    county: 'FAIRFAX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www2.gmu.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH CAROLINA AT CHAPEL HILL',
    address: '103 SOUTH BLDG CB 9100',
    city: 'CHAPEL HILL',
    state: 'NC',
    zip: 27599,
    telephone: '(919) 962-2211',
    population: 44496,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unc.edu/',
  },
  {
    name: 'THE UNIVERSITY OF ALABAMA',
    address: '739 UNIVERSITY BLVD',
    city: 'TUSCALOOSA',
    state: 'AL',
    zip: 35487,
    telephone: '(205) 348-6010',
    population: 44760,
    county: 'TUSCALOOSA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ua.edu/',
  },
  {
    name: 'UTAH VALLEY UNIVERSITY',
    address: '800 W UNIVERSITY PARKWAY',
    city: 'OREM',
    state: 'UT',
    zip: 84058,
    telephone: '(801) 863-8000',
    population: 44797,
    county: 'UTAH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uvu.edu/',
  },
  {
    name: 'UNIVERSITY OF NORTH TEXAS',
    address: '1501 W.CHESTNUT AVE.',
    city: 'DENTON',
    state: 'TX',
    zip: 76203,
    telephone: '(940) 565-2000',
    population: 45026,
    county: 'DENTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.unt.edu/',
  },
  {
    name: 'KENNESAW STATE UNIVERSITY',
    address: '1000 CHASTAIN RD',
    city: 'KENNESAW',
    state: 'GA',
    zip: 30144,
    telephone: '(470) 578-6000',
    population: 45452,
    county: 'COBB',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.kennesaw.edu/',
  },
  {
    name: 'UNIVERSITY OF PITTSBURGH-PITTSBURGH CAMPUS',
    address: '4200 FIFTH AVENUE',
    city: 'PITTSBURGH',
    state: 'PA',
    zip: 15260,
    telephone: '(412) 624-4141',
    population: 45541,
    county: 'ALLEGHENY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.pitt.edu/',
  },
  {
    name: 'TEXAS TECH UNIVERSITY',
    address: 'BROADWAY AND UNIVERSITY AVENUE',
    city: 'LUBBOCK',
    state: 'TX',
    zip: 79409,
    telephone: '(806) 742-2011',
    population: 45569,
    county: 'LUBBOCK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ttu.edu/',
  },
  {
    name: 'VIRGINIA POLYTECHNIC INSTITUTE AND STATE UNIVERSITY',
    address: '210 BURRUSS HALL, 800 DRILLFIELD DR.',
    city: 'BLACKSBURG',
    state: 'VA',
    zip: 24061,
    telephone: '(540) 231-6994',
    population: 45631,
    county: 'MONTGOMERY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.vt.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-IRVINE',
    address: '501 ALDRICH HALL',
    city: 'IRVINE',
    state: 'CA',
    zip: 92697,
    telephone: '(949) 824-5011',
    population: 45633,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uci.edu/',
  },
  {
    name: 'CALIFORNIA STATE UNIVERSITY-FULLERTON',
    address: '800 N STATE COLLEGE BLVD',
    city: 'FULLERTON',
    state: 'CA',
    zip: 92831,
    telephone: '(657) 278-2593',
    population: 45670,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fullerton.edu/',
  },
  {
    name: 'NORTH CAROLINA STATE UNIVERSITY AT RALEIGH',
    address: '2101 HILLSBOROUGH STREET',
    city: 'RALEIGH',
    state: 'NC',
    zip: 27695,
    telephone: '(919) 515-2011',
    population: 45678,
    county: 'WAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ncsu.edu/',
  },
  {
    name: 'PURDUE UNIVERSITY GLOBAL',
    address: '2550 NORTHWESTERN AVENUE, SUITE 1100',
    city: 'WEST LAFAYETTE',
    state: 'IN',
    zip: 47906,
    telephone: '(866) 522-7747',
    population: 45975,
    county: 'MARION',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.purdueglobal.edu/',
  },
  {
    name: 'UNIVERSITY OF PENNSYLVANIA',
    address: '34TH & SPRUCE STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19104,
    telephone: '(215) 898-5000',
    population: 46008,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.upenn.edu/',
  },
  {
    name: 'TEMPLE UNIVERSITY',
    address: '1801 NORTH BROAD STREET',
    city: 'PHILADELPHIA',
    state: 'PA',
    zip: 19122,
    telephone: '(215) 204-7000',
    population: 46015,
    county: 'PHILADELPHIA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.temple.edu/',
  },
  {
    name: 'TARRANT COUNTY COLLEGE DISTRICT',
    address: '1500 HOUSTON ST',
    city: 'FORT WORTH',
    state: 'TX',
    zip: 76102,
    telephone: '(817) 515-8223',
    population: 46780,
    county: 'TARRANT',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.tccd.edu/',
  },
  {
    name: 'UNIVERSITY OF COLORADO BOULDER',
    address: 'REGENT DRIVE AT BROADWAY',
    city: 'BOULDER',
    state: 'CO',
    zip: 80309,
    telephone: '(303) 492-1411',
    population: 46885,
    county: 'BOULDER',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.colorado.edu/',
  },
  {
    name: 'UNIVERSITY OF ILLINOIS CHICAGO',
    address: '601 S MORGAN',
    city: 'CHICAGO',
    state: 'IL',
    zip: 60607,
    telephone: '(312) 996-7000',
    population: 47263,
    county: 'COOK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uic.edu/',
  },
  {
    name: 'UNIVERSITY OF UTAH',
    address: '201 PRESIDENTS CIRCLE, ROOM 201',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84112,
    telephone: '(801) 581-7200',
    population: 47336,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.utah.edu/',
  },
  {
    name: 'BRIGHAM YOUNG UNIVERSITY-IDAHO',
    address: '525 S CENTER',
    city: 'REXBURG',
    state: 'ID',
    zip: 83460,
    telephone: '(208) 496-1411',
    population: 48110,
    county: 'MADISON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.byui.edu/',
  },
  {
    name: 'JOHNS HOPKINS UNIVERSITY',
    address: '3400 N CHARLES ST',
    city: 'BALTIMORE',
    state: 'MD',
    zip: 21218,
    telephone: '(410) 516-8000',
    population: 48359,
    county: 'BALTIMORE CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.jhu.edu/',
  },
  {
    name: 'GEORGIA INSTITUTE OF TECHNOLOGY-MAIN CAMPUS',
    address: '225 NORTH AVE',
    city: 'ATLANTA',
    state: 'GA',
    zip: 30332,
    telephone: '(404) 894-2000',
    population: 48378,
    county: 'FULTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gatech.edu/',
  },
  {
    name: 'UNIVERSITY OF CINCINNATI-MAIN CAMPUS',
    address: '2624 CLIFTON AVENUE',
    city: 'CINCINNATI',
    state: 'OH',
    zip: 45221,
    telephone: '(513) 556-6000',
    population: 48594,
    county: 'HAMILTON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uc.edu/',
  },
  {
    name: 'HARVARD UNIVERSITY',
    address: 'MASSACHUSETTS HALL',
    city: 'CAMBRIDGE',
    state: 'MA',
    zip: 2138,
    telephone: '(617) 495-1000',
    population: 49569,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.harvard.edu/',
  },
  {
    name: 'VALENCIA COLLEGE',
    address: '1768 PARK CENTER DRIVE',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32835,
    telephone: '(407) 299-2187',
    population: 50078,
    county: 'ORANGE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'valenciacollege.edu/',
  },
  {
    name: 'UNIVERSITY OF MARYLAND-COLLEGE PARK',
    address: 'NOT AVAILABLE',
    city: 'COLLEGE PARK',
    state: 'MD',
    zip: 20742,
    telephone: '(301) 405-1000',
    population: 50709,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umd.edu/',
  },
  {
    name: 'FLORIDA STATE UNIVERSITY',
    address: '222 S. COPELAND STREET',
    city: 'TALLAHASSEE',
    state: 'FL',
    zip: 32306,
    telephone: '(850) 644-2525',
    population: 50842,
    county: 'LEON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.fsu.edu/',
  },
  {
    name: 'UNIVERSITY OF GEORGIA',
    address: 'ADMINISTRATION BUILDING',
    city: 'ATHENS',
    state: 'GA',
    zip: 30602,
    telephone: '(706) 542-3000',
    population: 50880,
    county: 'CLARKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uga.edu/',
  },
  {
    name: 'COLUMBIA UNIVERSITY IN THE CITY OF NEW YORK',
    address: 'WEST 116 ST AND BROADWAY',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10027,
    telephone: '(212) 854-1754',
    population: 50996,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.columbia.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT ARLINGTON',
    address: '701 S. NEDDERMAN DR.',
    city: 'ARLINGTON',
    state: 'TX',
    zip: 76013,
    telephone: '(817) 272-2011',
    population: 52044,
    county: 'TARRANT',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.uta.edu/',
  },
  {
    name: 'INDIANA UNIVERSITY-BLOOMINGTON',
    address: '107 SOUTH INDIANA AVE.',
    city: 'BLOOMINGTON',
    state: 'IN',
    zip: 47405,
    telephone: '(812) 855-4848',
    population: 52280,
    county: 'MONROE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.indiana.edu/',
  },
  {
    name: 'AMERICAN PUBLIC UNIVERSITY SYSTEM',
    address: '111 W CONGRESS ST',
    city: 'CHARLES TOWN',
    state: 'WV',
    zip: 25414,
    telephone: '(877) 468-6268',
    population: 52455,
    county: 'JEFFERSON',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.apus.edu/',
  },
  {
    name: 'UNIVERSITY OF HOUSTON',
    address: '212 E. CULLEN BUILDING',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77204,
    telephone: '(713) 743-1000',
    population: 52610,
    county: 'HARRIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.uh.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-DAVIS',
    address: 'ONE SHIELDS AVENUE',
    city: 'DAVIS',
    state: 'CA',
    zip: 95616,
    telephone: '(530) 752-1011',
    population: 52829,
    county: 'YOLO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'ucdavis.edu/',
  },
  {
    name: 'HOUSTON COMMUNITY COLLEGE',
    address: '3100 MAIN STREET',
    city: 'HOUSTON',
    state: 'TX',
    zip: 77002,
    telephone: '(877) 422-6111',
    population: 53508,
    county: 'HARRIS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.hccs.edu/',
  },
  {
    name: 'WALDEN UNIVERSITY',
    address: '100 WASHINGTON AVENUE SOUTH, SUITE 900',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55401,
    telephone: '(866) 492-5336',
    population: 54019,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.waldenu.edu/',
  },
  {
    name: 'MIAMI DADE COLLEGE',
    address: '300 NE 2ND AVENUE',
    city: 'MIAMI',
    state: 'FL',
    zip: 33132,
    telephone: '(305) 237-8888',
    population: 54356,
    county: 'MIAMI-DADE',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.mdc.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-BERKELEY',
    address: '200 CALIFORNIA HALL',
    city: 'BERKELEY',
    state: 'CA',
    zip: 94720,
    telephone: '(510) 642-6000',
    population: 54449,
    county: 'ALAMEDA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.berkeley.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-SAN DIEGO',
    address: '9500 GILMAN DR',
    city: 'LA JOLLA',
    state: 'CA',
    zip: 92093,
    telephone: '(858) 534-2230',
    population: 55842,
    county: 'SAN DIEGO',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucsd.edu/',
  },
  {
    name: 'NORTHERN VIRGINIA COMMUNITY COLLEGE',
    address: '4001 WAKEFIELD CHAPEL RD',
    city: 'ANNANDALE',
    state: 'VA',
    zip: 22003,
    telephone: '(703) 323-3000',
    population: 55897,
    county: 'FAIRFAX',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'https://www.nvcc.edu/',
  },
  {
    name: 'ARIZONA STATE UNIVERSITY DIGITAL IMMERSION',
    address: '1475 N SCOTTSDALE RD',
    city: 'SCOTTSDALE',
    state: 'AZ',
    zip: 85257,
    telephone: '(855) 278-5080',
    population: 55938,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asu.edu/',
  },
  {
    name: 'PURDUE UNIVERSITY-MAIN CAMPUS',
    address: 'HOVDE HALL OF ADMINISTRATION',
    city: 'WEST LAFAYETTE',
    state: 'IN',
    zip: 47907,
    telephone: '(765) 494-4600',
    population: 58024,
    county: 'TIPPECANOE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.purdue.edu/',
  },
  {
    name: 'UNIVERSITY OF ARIZONA',
    address: '1401 E UNIVERSITY',
    city: 'TUCSON',
    state: 'AZ',
    zip: 85721,
    telephone: '(520) 621-2211',
    population: 58335,
    county: 'PIMA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.arizona.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTH FLORIDA',
    address: '4202 EAST FOWLER AVE',
    city: 'TAMPA',
    state: 'FL',
    zip: 33620,
    telephone: '(813) 974-2011',
    population: 59916,
    county: 'HILLSBOROUGH',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usf.edu/',
  },
  {
    name: 'MICHIGAN STATE UNIVERSITY',
    address: 'NOT AVAILABLE',
    city: 'EAST LANSING',
    state: 'MI',
    zip: 48824,
    telephone: '(517) 355-1855',
    population: 62325,
    county: 'INGHAM',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.msu.edu/',
  },
  {
    name: 'UNIVERSITY OF SOUTHERN CALIFORNIA',
    address: 'UNIVERSITY PARK',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90089,
    telephone: '(213) 740-2311',
    population: 62935,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.usc.edu/',
  },
  {
    name: 'UNIVERSITY OF WISCONSIN-MADISON',
    address: '500 LINCOLN DR',
    city: 'MADISON',
    state: 'WI',
    zip: 53706,
    telephone: '(608) 263-2400',
    population: 63654,
    county: 'DANE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wisc.edu/',
  },
  {
    name: 'UNIVERSITY OF MARYLAND GLOBAL CAMPUS',
    address: '3501 UNIVERSITY BLVD EAST',
    city: 'ADELPHI',
    state: 'MD',
    zip: 20783,
    telephone: '(301) 985-7000',
    population: 64103,
    county: "PRINCE GEORGE'S",
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.umgc.edu/',
  },
  {
    name: 'UNIVERSITY OF ILLINOIS URBANA-CHAMPAIGN',
    address: '601 E JOHN STREET',
    city: 'CHAMPAIGN',
    state: 'IL',
    zip: 61820,
    telephone: '(217) 333-1000',
    population: 65110,
    county: 'CHAMPAIGN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.illinois.edu/',
  },
  {
    name: 'FLORIDA INTERNATIONAL UNIVERSITY',
    address: '11200 S. W. 8 STREET',
    city: 'MIAMI',
    state: 'FL',
    zip: 33199,
    telephone: '(305) 348-2000',
    population: 65410,
    county: 'MIAMI-DADE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.fiu.edu/',
  },
  {
    name: 'THE UNIVERSITY OF TEXAS AT AUSTIN',
    address: '110 INNER CAMPUS DRIVE',
    city: 'AUSTIN',
    state: 'TX',
    zip: 78705,
    telephone: '(512) 471-3434',
    population: 67083,
    county: 'TRAVIS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.utexas.edu/',
  },
  {
    name: 'UNIVERSITY OF WASHINGTON-SEATTLE CAMPUS',
    address: '1400 NE CAMPUS PARKWAY',
    city: 'SEATTLE',
    state: 'WA',
    zip: 98195,
    telephone: '(206) 543-2100',
    population: 68838,
    county: 'KING',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.washington.edu/',
  },
  {
    name: 'UNIVERSITY OF FLORIDA',
    address: 'TIGERT HALL',
    city: 'GAINESVILLE',
    state: 'FL',
    zip: 32611,
    telephone: '(352) 392-3261',
    population: 69252,
    county: 'ALACHUA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ufl.edu/',
  },
  {
    name: 'RUTGERS UNIVERSITY-NEW BRUNSWICK',
    address: '83 SOMERSET ST',
    city: 'NEW BRUNSWICK',
    state: 'NJ',
    zip: 8901,
    telephone: '(848) 445-4636',
    population: 69755,
    county: 'MIDDLESEX',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://newbrunswick.rutgers.edu/',
  },
  {
    name: 'UNIVERSITY OF CALIFORNIA-LOS ANGELES',
    address: '405 HILGARD AVE',
    city: 'LOS ANGELES',
    state: 'CA',
    zip: 90095,
    telephone: '(310) 825-4321',
    population: 69845,
    county: 'LOS ANGELES',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucla.edu/',
  },
  {
    name: 'UNIVERSITY OF MINNESOTA-TWIN CITIES',
    address: '100 CHURCH STREET SE',
    city: 'MINNEAPOLIS',
    state: 'MN',
    zip: 55455,
    telephone: '(612) 625-5000',
    population: 70641,
    county: 'HENNEPIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://twin-cities.umn.edu/',
  },
  {
    name: 'IVY TECH COMMUNITY COLLEGE',
    address: '50 W. FALL CREEK PARKWAY N. DRIVE',
    city: 'INDIANAPOLIS',
    state: 'IN',
    zip: 46208,
    telephone: '(317) 921-4800',
    population: 70690,
    county: 'MARION',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.ivytech.edu/',
  },
  {
    name: 'UNIVERSITY OF MICHIGAN-ANN ARBOR',
    address: '503 THOMPSON STREET',
    city: 'ANN ARBOR',
    state: 'MI',
    zip: 48109,
    telephone: '(734) 764-1817',
    population: 72512,
    county: 'WASHTENAW',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://umich.edu/',
  },
  {
    name: 'NEW YORK UNIVERSITY',
    address: '70 WASHINGTON SQ SOUTH',
    city: 'NEW YORK',
    state: 'NY',
    zip: 10012,
    telephone: '(212) 998-1212',
    population: 76559,
    county: 'NEW YORK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.nyu.edu/',
  },
  {
    name: 'LONE STAR COLLEGE SYSTEM',
    address: '5000 RESEARCH FOREST DRIVE',
    city: 'THE WOODLANDS',
    state: 'TX',
    zip: 77381,
    telephone: '(832) 813-6500',
    population: 77117,
    county: 'MONTGOMERY',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.lonestar.edu/',
  },
  {
    name: 'UNIVERSITY OF CENTRAL FLORIDA',
    address: '4000 CENTRAL FLORIDA BLVD',
    city: 'ORLANDO',
    state: 'FL',
    zip: 32816,
    telephone: '(407) 823-2000',
    population: 77982,
    county: 'ORANGE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.ucf.edu/',
  },
  {
    name: 'DALLAS COLLEGE',
    address: '1601 SOUTH LAMAR',
    city: 'DALLAS',
    state: 'TX',
    zip: 75215,
    telephone: '(214) 378-1824',
    population: 80335,
    county: 'DALLAS',
    naics_desc: 'JUNIOR COLLEGES',
    website: 'www.dcccd.edu/pages/default.aspx',
  },
  {
    name: 'TEXAS A & M UNIVERSITY-COLLEGE STATION',
    address: 'JKW ADMINISTRATION BUILDING, SUITE 200',
    city: 'COLLEGE STATION',
    state: 'TX',
    zip: 77843,
    telephone: '(979) 845-3211',
    population: 81678,
    county: 'BRAZOS',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.tamu.edu/',
  },
  {
    name: 'ARIZONA STATE UNIVERSITY CAMPUS IMMERSION',
    address: 'UNIVERSITY DRIVE AND MILL AVENUE',
    city: 'TEMPE',
    state: 'AZ',
    zip: 85287,
    telephone: '(855) 278-5080',
    population: 87678,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.asu.edu/',
  },
  {
    name: 'OHIO STATE UNIVERSITY-MAIN CAMPUS',
    address: '190 N. OVAL MALL',
    city: 'COLUMBUS',
    state: 'OH',
    zip: 43210,
    telephone: '(614) 292-6446',
    population: 96399,
    county: 'FRANKLIN',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.osu.edu/',
  },
  {
    name: 'UNIVERSITY OF PHOENIX-ARIZONA',
    address: '4035 SOUTH RIVERPOINT PARKWAY',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85040,
    telephone: '(866) 766-0766',
    population: 97248,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.phoenix.edu/',
  },
  {
    name: 'LIBERTY UNIVERSITY',
    address: '1971 UNIVERSITY BLVD',
    city: 'LYNCHBURG',
    state: 'VA',
    zip: 24515,
    telephone: '(434) 582-2000',
    population: 100674,
    county: 'LYNCHBURG CITY',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.liberty.edu/',
  },
  {
    name: 'GRAND CANYON UNIVERSITY',
    address: '3300 W CAMELBACK RD',
    city: 'PHOENIX',
    state: 'AZ',
    zip: 85017,
    telephone: '(800) 800-9776',
    population: 110404,
    county: 'MARICOPA',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.gcu.edu/',
  },
  {
    name: 'THE PENNSYLVANIA STATE UNIVERSITY',
    address: '201 OLD MAIN',
    city: 'UNIVERSITY PARK',
    state: 'PA',
    zip: 16802,
    telephone: '(814) 865-4700',
    population: 112931,
    county: 'CENTRE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'https://www.psu.edu/',
  },
  {
    name: 'SOUTHERN NEW HAMPSHIRE UNIVERSITY',
    address: '2500 NORTH RIVER ROAD',
    city: 'MANCHESTER',
    state: 'NH',
    zip: 3106,
    telephone: '(603) 668-2211',
    population: 144645,
    county: 'MERRIMACK',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.snhu.edu/',
  },
  {
    name: 'WESTERN GOVERNORS UNIVERSITY',
    address: '4001 SOUTH 700 EAST SUITE 700',
    city: 'SALT LAKE CITY',
    state: 'UT',
    zip: 84107,
    telephone: '(801) 274-3280',
    population: 154991,
    county: 'SALT LAKE',
    naics_desc: 'COLLEGES, UNIVERSITIES, AND PROFESSIONAL SCHOOLS',
    website: 'www.wgu.edu/',
  },
];

export const socialMediaOptions = [
  { key: 'youtube', label: 'YouTube' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'linkedin', label: 'LinkedIn' },
  { key: 'snapchat', label: 'Snapchat' },
  { key: 'pinterest', label: 'Pinterest' },
  { key: 'reddit', label: 'Reddit' },
  { key: 'clubhouse', label: 'Clubhouse' },
  { key: 'discord', label: 'Discord' },
  { key: 'twitch', label: 'Twitch' },
  { key: 'soundcloud', label: 'Soundcloud' },
  { key: 'hive social', label: 'Hive Social' },
  { key: 'flickr', label: 'Flickr' },
  { key: 'mixcloud', label: 'MixCloud' },
  { key: 'vimeo', label: 'Vimeo' },
  { key: 'other', label: 'Other' },
];

// Array of US States
export const US_STATES = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const positionsOptions = [
  {
    sport: "Men's Baseball",
    position: 'Pitcher',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Catcher',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'First Baseman',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Second Baseman',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Third Baseman',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Shortstop',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Left Fielder',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Center Fielder',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Right Fielder',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Baseball",
    position: 'Designated Hitter',
    parentSport: 'mens-baseball',
  },
  {
    sport: "Men's Basketball",
    position: 'Point Guard',
    parentSport: 'mens-basketball',
  },
  {
    sport: "Men's Basketball",
    position: 'Shooting Guard',
    parentSport: 'mens-basketball',
  },
  {
    sport: "Men's Basketball",
    position: 'Small Forward',
    parentSport: 'mens-basketball',
  },
  {
    sport: "Men's Basketball",
    position: 'Power Forward',
    parentSport: 'mens-basketball',
  },
  {
    sport: "Men's Basketball",
    position: 'Center',
    parentSport: 'mens-basketball',
  },
  {
    sport: "Men's Cross Country",
    position: 'Runner',
    parentSport: 'mens-cross-country',
  },
  {
    sport: "Men's Fencing",
    position: 'Foil',
    parentSport: 'mens-fencing',
  },
  {
    sport: "Men's Fencing",
    position: 'Epee',
    parentSport: 'mens-fencing',
  },
  {
    sport: "Men's Fencing",
    position: 'Sabre',
    parentSport: 'mens-fencing',
  },
  {
    sport: "Men's Football",
    position: 'Quarterback',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Running Back',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Wide Receiver',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Tight End',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Offensive Lineman',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Defensive Lineman',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Linebacker',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Cornerback',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Safety',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Kicker',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Football",
    position: 'Punter',
    parentSport: 'mens-football',
  },
  {
    sport: "Men's Golf",
    position: 'Golfer',
    parentSport: 'mens-golf',
  },
  {
    sport: "Men's Gymnastics",
    position: 'All-Around',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Floor Exercise',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Pommel Horse',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Still Rings',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Vault',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Parallel Bars',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Gymnastics",
    position: 'Horizontal Bar',
    parentSport: 'mens-gymnastics',
  },
  {
    sport: "Men's Ice Hockey",
    position: 'Center',
    parentSport: 'mens-ice-hockey',
  },
  {
    sport: "Men's Ice Hockey",
    position: 'Left Wing',
    parentSport: 'mens-ice-hockey',
  },
  {
    sport: "Men's Ice Hockey",
    position: 'Right Wing',
    parentSport: 'mens-ice-hockey',
  },
  {
    sport: "Men's Ice Hockey",
    position: 'Defenseman',
    parentSport: 'mens-ice-hockey',
  },
  {
    sport: "Men's Ice Hockey",
    position: 'Goaltender',
    parentSport: 'mens-ice-hockey',
  },
  {
    sport: "Men's Lacrosse",
    position: 'Attack',
    parentSport: 'mens-lacrosse',
  },
  {
    sport: "Men's Lacrosse",
    position: 'Midfield',
    parentSport: 'mens-lacrosse',
  },
  {
    sport: "Men's Lacrosse",
    position: 'Defense',
    parentSport: 'mens-lacrosse',
  },
  {
    sport: "Men's Lacrosse",
    position: 'Goalie',
    parentSport: 'mens-lacrosse',
  },
  {
    sport: "Men's Lacrosse",
    position: 'Faceoff Specialist',
    parentSport: 'mens-lacrosse',
  },
  {
    sport: "Men's Rifle",
    position: 'Smallbore',
    parentSport: 'mens-rifle',
  },
  {
    sport: "Men's Rifle",
    position: 'Air Rifle',
    parentSport: 'mens-rifle',
  },
  {
    sport: "Men's Rowing",
    position: 'Coxswain',
    parentSport: 'mens-rowing',
  },
  {
    sport: "Men's Rowing",
    position: 'Stroke',
    parentSport: 'mens-rowing',
  },
  {
    sport: "Men's Rowing",
    position: 'Bow',
    parentSport: 'mens-rowing',
  },
  {
    sport: "Men's Rowing",
    position: 'Sculler',
    parentSport: 'mens-rowing',
  },
  {
    sport: "Men's Rowing",
    position: 'Sweep Rower',
    parentSport: 'mens-rowing',
  },
  {
    sport: "Men's Skiing",
    position: 'Alpine Skier',
    parentSport: 'mens-skiing',
  },
  {
    sport: "Men's Skiing",
    position: 'Nordic Skier',
    parentSport: 'mens-skiing',
  },
  {
    sport: "Men's Skiing",
    position: 'Freestyle Skier',
    parentSport: 'mens-skiing',
  },
  {
    sport: "Men's Soccer",
    position: 'Goalkeeper',
    parentSport: 'mens-soccer',
  },
  {
    sport: "Men's Soccer",
    position: 'Defender',
    parentSport: 'mens-soccer',
  },
  {
    sport: "Men's Soccer",
    position: 'Midfielder',
    parentSport: 'mens-soccer',
  },
  {
    sport: "Men's Soccer",
    position: 'Forward',
    parentSport: 'mens-soccer',
  },
  {
    sport: "Men's Swimming & Diving",
    position: 'Freestyle Swimmer',
    parentSport: 'mens-swimming-and-diving',
  },
  {
    sport: "Men's Swimming & Diving",
    position: 'Backstroke Swimmer',
    parentSport: 'mens-swimming-and-diving',
  },
  {
    sport: "Men's Swimming & Diving",
    position: 'Breaststroke Swimmer',
    parentSport: 'mens-swimming-and-diving',
  },
  {
    sport: "Men's Swimming & Diving",
    position: 'Butterfly Swimmer',
    parentSport: 'mens-swimming-and-diving',
  },
  {
    sport: "Men's Swimming & Diving",
    position: 'Diver',
    parentSport: 'mens-swimming-and-diving',
  },
  {
    sport: "Men's Tennis",
    position: 'Singles Player',
    parentSport: 'mens-tennis',
  },
  {
    sport: "Men's Tennis",
    position: 'Doubles Player',
    parentSport: 'mens-tennis',
  },
  {
    sport: "Men's Track and Field",
    position: 'Sprinter',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Distance Runner',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Hurdler',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Pole Vaulter',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Long Jumper',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'High Jumper',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Shot Putter',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Discus Thrower',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Track and Field",
    position: 'Javelin Thrower',
    parentSport: 'mens-track-and-field',
  },
  {
    sport: "Men's Volleyball",
    position: 'Outside Hitter',
    parentSport: 'mens-volleyball',
  },
  {
    sport: "Men's Volleyball",
    position: 'Opposite Hitter',
    parentSport: 'mens-volleyball',
  },
  {
    sport: "Men's Volleyball",
    position: 'Middle Blocker',
    parentSport: 'mens-volleyball',
  },
  {
    sport: "Men's Volleyball",
    position: 'Setter',
    parentSport: 'mens-volleyball',
  },
  {
    sport: "Men's Volleyball",
    position: 'Libero',
    parentSport: 'mens-volleyball',
  },
  {
    sport: "Men's Water Polo",
    position: 'Goalkeeper',
    parentSport: 'mens-water-polo',
  },
  {
    sport: "Men's Water Polo",
    position: 'Center Forward',
    parentSport: 'mens-water-polo',
  },
  {
    sport: "Men's Water Polo",
    position: 'Center Defender',
    parentSport: 'mens-water-polo',
  },
  {
    sport: "Men's Water Polo",
    position: 'Driver',
    parentSport: 'mens-water-polo',
  },
  {
    sport: "Men's Water Polo",
    position: 'Winger',
    parentSport: 'mens-water-polo',
  },
  {
    sport: "Men's Wrestling",
    position: 'Freestyle Wrestler',
    parentSport: 'mens-wrestling',
  },
  {
    sport: "Men's Wrestling",
    position: 'Greco-Roman Wrestler',
    parentSport: 'mens-wrestling',
  },
  {
    sport: "Women's Basketball",
    position: 'Point Guard',
    parentSport: 'womens-basketball',
  },
  {
    sport: "Women's Basketball",
    position: 'Shooting Guard',
    parentSport: 'womens-basketball',
  },
  {
    sport: "Women's Basketball",
    position: 'Small Forward',
    parentSport: 'womens-basketball',
  },
  {
    sport: "Women's Basketball",
    position: 'Power Forward',
    parentSport: 'womens-basketball',
  },
  {
    sport: "Women's Basketball",
    position: 'Center',
    parentSport: 'womens-basketball',
  },
  {
    sport: "Women's Beach Volleyball",
    position: 'Blocker',
    parentSport: 'womens-beach-volleyball',
  },
  {
    sport: "Women's Beach Volleyball",
    position: 'Defender',
    parentSport: 'womens-beach-volleyball',
  },
  {
    sport: "Women's Bowling",
    position: 'Bowler',
    parentSport: 'womens-bowling',
  },
  {
    sport: "Women's Cross Country",
    position: 'Runner',
    parentSport: 'womens-cross-country',
  },
  {
    sport: "Women's Fencing",
    position: 'Foil',
    parentSport: 'womens-fencing',
  },
  {
    sport: "Women's Fencing",
    position: 'Epee',
    parentSport: 'womens-fencing',
  },
  {
    sport: "Women's Fencing",
    position: 'Sabre',
    parentSport: 'womens-fencing',
  },
  {
    sport: "Women's Field Hockey",
    position: 'Goalkeeper',
    parentSport: 'womens-field-hockey',
  },
  {
    sport: "Women's Field Hockey",
    position: 'Defender',
    parentSport: 'womens-field-hockey',
  },
  {
    sport: "Women's Field Hockey",
    position: 'Midfielder',
    parentSport: 'womens-field-hockey',
  },
  {
    sport: "Women's Field Hockey",
    position: 'Forward',
    parentSport: 'womens-field-hockey',
  },
  {
    sport: "Women's Golf",
    position: 'Golfer',
    parentSport: 'womens-golf',
  },
  {
    sport: "Women's Gymnastics",
    position: 'All-Around',
    parentSport: 'womens-gymnastics',
  },
  {
    sport: "Women's Gymnastics",
    position: 'Vault',
    parentSport: 'womens-gymnastics',
  },
  {
    sport: "Women's Gymnastics",
    position: 'Uneven Bars',
    parentSport: 'womens-gymnastics',
  },
  {
    sport: "Women's Gymnastics",
    position: 'Balance Beam',
    parentSport: 'womens-gymnastics',
  },
  {
    sport: "Women's Gymnastics",
    position: 'Floor Exercise',
    parentSport: 'womens-gymnastics',
  },
  {
    sport: "Women's Ice Hockey",
    position: 'Center',
    parentSport: 'womens-ice-hockey',
  },
  {
    sport: "Women's Ice Hockey",
    position: 'Left Wing',
    parentSport: 'womens-ice-hockey',
  },
  {
    sport: "Women's Ice Hockey",
    position: 'Right Wing',
    parentSport: 'womens-ice-hockey',
  },
  {
    sport: "Women's Ice Hockey",
    position: 'Defenseman',
    parentSport: 'womens-ice-hockey',
  },
  {
    sport: "Women's Ice Hockey",
    position: 'Goaltender',
    parentSport: 'womens-ice-hockey',
  },
  {
    sport: "Women's Lacrosse",
    position: 'Attack',
    parentSport: 'womens-lacrosse',
  },
  {
    sport: "Women's Lacrosse",
    position: 'Midfield',
    parentSport: 'womens-lacrosse',
  },
  {
    sport: "Women's Lacrosse",
    position: 'Defense',
    parentSport: 'womens-lacrosse',
  },
  {
    sport: "Women's Lacrosse",
    position: 'Goalie',
    parentSport: 'womens-lacrosse',
  },
  {
    sport: "Women's Rifle",
    position: 'Smallbore',
    parentSport: 'womens-rifle',
  },
  {
    sport: "Women's Rifle",
    position: 'Air Rifle',
    parentSport: 'womens-rifle',
  },
  {
    sport: "Women's Rowing",
    position: 'Coxswain',
    parentSport: 'womens-rowing',
  },
  {
    sport: "Women's Rowing",
    position: 'Stroke',
    parentSport: 'womens-rowing',
  },
  {
    sport: "Women's Rowing",
    position: 'Bow',
    parentSport: 'womens-rowing',
  },
  {
    sport: "Women's Rowing",
    position: 'Sculler',
    parentSport: 'womens-rowing',
  },
  {
    sport: "Women's Rowing",
    position: 'Sweep Rower',
    parentSport: 'womens-rowing',
  },
  {
    sport: "Women's Skiing",
    position: 'Alpine Skier',
    parentSport: 'womens-skiing',
  },
  {
    sport: "Women's Skiing",
    position: 'Nordic Skier',
    parentSport: 'womens-skiing',
  },
  {
    sport: "Women's Skiing",
    position: 'Freestyle Skier',
    parentSport: 'womens-skiing',
  },
  {
    sport: "Women's Soccer",
    position: 'Goalkeeper',
    parentSport: 'womens-soccer',
  },
  {
    sport: "Women's Soccer",
    position: 'Defender',
    parentSport: 'womens-soccer',
  },
  {
    sport: "Women's Soccer",
    position: 'Midfielder',
    parentSport: 'womens-soccer',
  },
  {
    sport: "Women's Soccer",
    position: 'Forward',
    parentSport: 'womens-soccer',
  },
  {
    sport: "Women's Softball",
    position: 'Pitcher',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Catcher',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'First Baseman',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Second Baseman',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Third Baseman',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Shortstop',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Left Fielder',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Center Fielder',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Softball",
    position: 'Right Fielder',
    parentSport: 'womens-softball',
  },
  {
    sport: "Women's Swimming & Diving",
    position: 'Freestyle Swimmer',
    parentSport: 'womens-swimming-and-diving',
  },
  {
    sport: "Women's Swimming & Diving",
    position: 'Backstroke Swimmer',
    parentSport: 'womens-swimming-and-diving',
  },
  {
    sport: "Women's Swimming & Diving",
    position: 'Breaststroke Swimmer',
    parentSport: 'womens-swimming-and-diving',
  },
  {
    sport: "Women's Swimming & Diving",
    position: 'Butterfly Swimmer',
    parentSport: 'womens-swimming-and-diving',
  },
  {
    sport: "Women's Swimming & Diving",
    position: 'Diver',
    parentSport: 'womens-swimming-and-diving',
  },
  {
    sport: "Women's Synchronized Swimming",
    position: 'Solo',
    parentSport: 'womens-synchronized-swimming',
  },
  {
    sport: "Women's Synchronized Swimming",
    position: 'Duet',
    parentSport: 'womens-synchronized-swimming',
  },
  {
    sport: "Women's Synchronized Swimming",
    position: 'Team',
    parentSport: 'womens-synchronized-swimming',
  },
  {
    sport: "Women's Tennis",
    position: 'Singles Player',
    parentSport: 'womens-tennis',
  },
  {
    sport: "Women's Tennis",
    position: 'Doubles Player',
    parentSport: 'womens-tennis',
  },
  {
    sport: "Women's Track and Field",
    position: 'Sprinter',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Distance Runner',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Hurdler',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Pole Vaulter',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Long Jumper',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'High Jumper',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Shot Putter',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Discus Thrower',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Track and Field",
    position: 'Javelin Thrower',
    parentSport: 'womens-track-and-field',
  },
  {
    sport: "Women's Triathlon",
    position: 'Swimmer',
    parentSport: 'womens-triathlon',
  },
  {
    sport: "Women's Triathlon",
    position: 'Cyclist',
    parentSport: 'womens-triathlon',
  },
  {
    sport: "Women's Triathlon",
    position: 'Runner',
    parentSport: 'womens-triathlon',
  },
  {
    sport: "Women's Volleyball",
    position: 'Outside Hitter',
    parentSport: 'womens-volleyball',
  },
  {
    sport: "Women's Volleyball",
    position: 'Opposite Hitter',
    parentSport: 'womens-volleyball',
  },
  {
    sport: "Women's Volleyball",
    position: 'Middle Blocker',
    parentSport: 'womens-volleyball',
  },
  {
    sport: "Women's Volleyball",
    position: 'Setter',
    parentSport: 'womens-volleyball',
  },
  {
    sport: "Women's Volleyball",
    position: 'Libero',
    parentSport: 'womens-volleyball',
  },
  {
    sport: "Women's Water Polo",
    position: 'Goalkeeper',
    parentSport: 'womens-water-polo',
  },
  {
    sport: "Women's Water Polo",
    position: 'Center Forward',
    parentSport: 'womens-water-polo',
  },
  {
    sport: "Women's Water Polo",
    position: 'Center Defender',
    parentSport: 'womens-water-polo',
  },
  {
    sport: "Women's Water Polo",
    position: 'Driver',
    parentSport: 'womens-water-polo',
  },
  {
    sport: "Women's Water Polo",
    position: 'Winger',
    parentSport: 'womens-water-polo',
  },
  {
    sport: 'Equestrian',
    position: 'Show Jumper',
    parentSport: 'equestrian',
  },
  {
    sport: 'Equestrian',
    position: 'Dressage Rider',
    parentSport: 'equestrian',
  },
  {
    sport: 'Equestrian',
    position: 'Eventer',
    parentSport: 'equestrian',
  },
  {
    sport: 'Sailing',
    position: 'Helmsman',
    parentSport: 'sailing',
  },
  {
    sport: 'Sailing',
    position: 'Crew',
    parentSport: 'sailing',
  },
  {
    sport: 'Archery',
    position: 'Recurve',
    parentSport: 'archery',
  },
  {
    sport: 'Archery',
    position: 'Compound',
    parentSport: 'archery',
  },
  {
    sport: 'Badminton',
    position: 'Singles Player',
    parentSport: 'badminton',
  },
  {
    sport: 'Badminton',
    position: 'Doubles Player',
    parentSport: 'badminton',
  },
  {
    sport: 'Bowling',
    position: 'Bowler',
    parentSport: 'bowling',
  },
  {
    sport: 'Cheerleading',
    position: 'Base',
    parentSport: 'cheerleading',
  },
  {
    sport: 'Cheerleading',
    position: 'Flyer',
    parentSport: 'cheerleading',
  },
  {
    sport: 'Cheerleading',
    position: 'Back Spot',
    parentSport: 'cheerleading',
  },
  {
    sport: 'Cycling',
    position: 'Road Cyclist',
    parentSport: 'cycling',
  },
  {
    sport: 'Cycling',
    position: 'Track Cyclist',
    parentSport: 'cycling',
  },
  {
    sport: 'Cycling',
    position: 'Mountain Biker',
    parentSport: 'cycling',
  },
  {
    sport: 'Cycling',
    position: 'BMX Rider',
    parentSport: 'cycling',
  },
  {
    sport: 'Dance',
    position: 'Ballet Dancer',
    parentSport: 'dance',
  },
  {
    sport: 'Dance',
    position: 'Jazz Dancer',
    parentSport: 'dance',
  },
  {
    sport: 'Dance',
    position: 'Hip-Hop Dancer',
    parentSport: 'dance',
  },
  {
    sport: 'Fencing',
    position: 'Foil',
    parentSport: 'fencing',
  },
  {
    sport: 'Fencing',
    position: 'Epee',
    parentSport: 'fencing',
  },
  {
    sport: 'Fencing',
    position: 'Sabre',
    parentSport: 'fencing',
  },
  {
    sport: 'Judo',
    position: 'Lightweight',
    parentSport: 'judo',
  },
  {
    sport: 'Judo',
    position: 'Middleweight',
    parentSport: 'judo',
  },
  {
    sport: 'Judo',
    position: 'Heavyweight',
    parentSport: 'judo',
  },
  {
    sport: 'Karate',
    position: 'Kata',
    parentSport: 'karate',
  },
  {
    sport: 'Karate',
    position: 'Kumite',
    parentSport: 'karate',
  },
  {
    sport: 'Racquetball',
    position: 'Singles Player',
    parentSport: 'racquetball',
  },
  {
    sport: 'Racquetball',
    position: 'Doubles Player',
    parentSport: 'racquetball',
  },
  {
    sport: 'Rock Climbing',
    position: 'Lead Climber',
    parentSport: 'rock-climbing',
  },
  {
    sport: 'Rock Climbing',
    position: 'Boulderer',
    parentSport: 'rock-climbing',
  },
  {
    sport: 'Rock Climbing',
    position: 'Speed Climber',
    parentSport: 'rock-climbing',
  },
  {
    sport: 'Rugby',
    position: 'Prop',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Hooker',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Lock',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Flanker',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Number Eight',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Scrum-half',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Fly-half',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Center',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Wing',
    parentSport: 'rugby',
  },
  {
    sport: 'Rugby',
    position: 'Fullback',
    parentSport: 'rugby',
  },
  {
    sport: 'Squash',
    position: 'Singles Player',
    parentSport: 'squash',
  },
  {
    sport: 'Squash',
    position: 'Doubles Player',
    parentSport: 'squash',
  },
  {
    sport: 'Table Tennis',
    position: 'Singles Player',
    parentSport: 'table-tennis',
  },
  {
    sport: 'Table Tennis',
    position: 'Doubles Player',
    parentSport: 'table-tennis',
  },
  {
    sport: 'Taekwondo',
    position: 'Lightweight',
    parentSport: 'taekwondo',
  },
  {
    sport: 'Taekwondo',
    position: 'Middleweight',
    parentSport: 'taekwondo',
  },
  {
    sport: 'Taekwondo',
    position: 'Heavyweight',
    parentSport: 'taekwondo',
  },
  {
    sport: 'Ultimate Frisbee',
    position: 'Handler',
    parentSport: 'ultimate-frisbee',
  },
  {
    sport: 'Ultimate Frisbee',
    position: 'Cutter',
    parentSport: 'ultimate-frisbee',
  },
  {
    sport: 'Weightlifting',
    position: 'Snatch',
    parentSport: 'weightlifting',
  },
  {
    sport: 'Weightlifting',
    position: 'Clean & Jerk',
    parentSport: 'weightlifting',
  },
  {
    sport: 'E-Sports/ Gamers',
    position: 'FPS Player',
    parentSport: 'e-sports-gamers',
  },
  {
    sport: 'E-Sports/ Gamers',
    position: 'MOBA Player',
    parentSport: 'e-sports-gamers',
  },
  {
    sport: 'E-Sports/ Gamers',
    position: 'Fighting Game Player',
    parentSport: 'e-sports-gamers',
  },
  {
    sport: 'E-Sports/ Gamers',
    position: 'Sports Player',
    parentSport: 'e-sports-gamers',
  },
  {
    sport: 'Spikeball',
    position: 'Offensive Player',
    parentSport: 'spikeball',
  },
  {
    sport: 'Spikeball',
    position: 'Defensive Player',
    parentSport: 'spikeball',
  },
  {
    sport: 'Quadball/ Quidditch',
    position: 'Chaser',
    parentSport: 'quadball-quidditch',
  },
  {
    sport: 'Quadball/ Quidditch',
    position: 'Beater',
    parentSport: 'quadball-quidditch',
  },
  {
    sport: 'Quadball/ Quidditch',
    position: 'Seeker',
    parentSport: 'quadball-quidditch',
  },
  {
    sport: 'Quadball/ Quidditch',
    position: 'Keeper',
    parentSport: 'quadball-quidditch',
  },
  {
    sport: 'Cornhole',
    position: 'Thrower',
    parentSport: 'cornhole',
  },
  {
    sport: 'Frisbee Golf (Disc Golf)',
    position: 'Putter',
    parentSport: 'frisbee-golf-(disc-golf)',
  },
  {
    sport: 'Frisbee Golf (Disc Golf)',
    position: 'Mid-Range',
    parentSport: 'frisbee-golf-(disc-golf)',
  },
  {
    sport: 'Frisbee Golf (Disc Golf)',
    position: 'Driver',
    parentSport: 'frisbee-golf-(disc-golf)',
  },
  {
    sport: 'Paddle Tennis',
    position: 'Singles Player',
    parentSport: 'paddle-tennis',
  },
  {
    sport: 'Paddle Tennis',
    position: 'Doubles Player',
    parentSport: 'paddle-tennis',
  },
  {
    sport: 'Pickleball',
    position: 'Singles Player',
    parentSport: 'pickleball',
  },
  {
    sport: 'Pickleball',
    position: 'Doubles Player',
    parentSport: 'pickleball',
  },
  {
    sport: 'Snowboarding',
    position: 'Freestyle',
    parentSport: 'snowboarding',
  },
  {
    sport: 'Snowboarding',
    position: 'Alpine',
    parentSport: 'snowboarding',
  },
  {
    sport: 'Snowboarding',
    position: 'Boardercross',
    parentSport: 'snowboarding',
  },
  {
    sport: 'Dodgeball',
    position: 'Thrower',
    parentSport: 'dodgeball',
  },
  {
    sport: 'Dodgeball',
    position: 'Catcher',
    parentSport: 'dodgeball',
  },
  {
    sport: 'Kickball',
    position: 'Pitcher',
    parentSport: 'kickball',
  },
  {
    sport: 'Kickball',
    position: 'Catcher',
    parentSport: 'kickball',
  },
  {
    sport: 'Kickball',
    position: 'Infielder',
    parentSport: 'kickball',
  },
  {
    sport: 'Kickball',
    position: 'Outfielder',
    parentSport: 'kickball',
  },
  {
    sport: 'Flag Football',
    position: 'Quarterback',
    parentSport: 'flag-football',
  },
  {
    sport: 'Flag Football',
    position: 'Wide Receiver',
    parentSport: 'flag-football',
  },
  {
    sport: 'Flag Football',
    position: 'Running Back',
    parentSport: 'flag-football',
  },
  {
    sport: 'Flag Football',
    position: 'Defensive Back',
    parentSport: 'flag-football',
  },
  {
    sport: 'Indoor Soccer',
    position: 'Goalkeeper',
    parentSport: 'indoor-soccer',
  },
  {
    sport: 'Indoor Soccer',
    position: 'Defender',
    parentSport: 'indoor-soccer',
  },
  {
    sport: 'Indoor Soccer',
    position: 'Midfielder',
    parentSport: 'indoor-soccer',
  },
  {
    sport: 'Indoor Soccer',
    position: 'Forward',
    parentSport: 'indoor-soccer',
  },
  {
    sport: '3-on-3 Basketball',
    position: 'Guard',
    parentSport: '3-on-3-basketball',
  },
  {
    sport: '3-on-3 Basketball',
    position: 'Forward',
    parentSport: '3-on-3-basketball',
  },
  {
    sport: '3-on-3 Basketball',
    position: 'Center',
    parentSport: '3-on-3-basketball',
  },
  {
    sport: 'Wiffle Ball',
    position: 'Pitcher',
    parentSport: 'wiffle-ball',
  },
  {
    sport: 'Wiffle Ball',
    position: 'Catcher',
    parentSport: 'wiffle-ball',
  },
  {
    sport: 'Wiffle Ball',
    position: 'Infielder',
    parentSport: 'wiffle-ball',
  },
  {
    sport: 'Wiffle Ball',
    position: 'Outfielder',
    parentSport: 'wiffle-ball',
  },
  {
    sport: 'Canoeing/Kayaking',
    position: 'Sprint',
    parentSport: 'canoeing-kayaking',
  },
  {
    sport: 'Canoeing/Kayaking',
    position: 'Slalom',
    parentSport: 'canoeing-kayaking',
  },
  {
    sport: 'Dragon Boat Racing',
    position: 'Paddler',
    parentSport: 'dragon-boat-racing',
  },
  {
    sport: 'Dragon Boat Racing',
    position: 'Drummer',
    parentSport: 'dragon-boat-racing',
  },
  {
    sport: 'Dragon Boat Racing',
    position: 'Steersperson',
    parentSport: 'dragon-boat-racing',
  },
  {
    sport: "Men's Boxing",
    position: 'Lightweight',
    parentSport: 'mens-boxing',
  },
  {
    sport: "Men's Boxing",
    position: 'Middleweight',
    parentSport: 'mens-boxing',
  },
  {
    sport: "Men's Boxing",
    position: 'Heavyweight',
    parentSport: 'mens-boxing',
  },
  {
    sport: "Women's Boxing",
    position: 'Lightweight',
    parentSport: 'womens-boxing',
  },
  {
    sport: "Women's Boxing",
    position: 'Middleweight',
    parentSport: 'womens-boxing',
  },
  {
    sport: "Women's Boxing",
    position: 'Heavyweight',
    parentSport: 'womens-boxing',
  },
  {
    sport: 'BMX',
    position: 'Racer',
    parentSport: 'bmx',
  },
  {
    sport: 'BMX',
    position: 'Freestyle',
    parentSport: 'bmx',
  },
  {
    sport: 'Cricket',
    position: 'Batsman',
    parentSport: 'cricket',
  },
  {
    sport: 'Cricket',
    position: 'Bowler',
    parentSport: 'cricket',
  },
  {
    sport: 'Cricket',
    position: 'Wicketkeeper',
    parentSport: 'cricket',
  },
  {
    sport: 'Cricket',
    position: 'All-Rounder',
    parentSport: 'cricket',
  },
  {
    sport: 'Curling',
    position: 'Lead',
    parentSport: 'curling',
  },
  {
    sport: 'Curling',
    position: 'Second',
    parentSport: 'curling',
  },
  {
    sport: 'Curling',
    position: 'Third',
    parentSport: 'curling',
  },
  {
    sport: 'Curling',
    position: 'Skip',
    parentSport: 'curling',
  },
];

export const proTeamsOptions = [
  { value: 'Baltimore Orioles', label: 'Baltimore Orioles' },
  { value: 'Boston Red Sox', label: 'Boston Red Sox' },
  { value: 'New York Yankees', label: 'New York Yankees' },
  { value: 'Tampa Bay Rays', label: 'Tampa Bay Rays' },
  { value: 'Toronto Blue Jays', label: 'Toronto Blue Jays' },
  { value: 'Chicago White Sox', label: 'Chicago White Sox' },
  { value: 'Cleveland Guardians', label: 'Cleveland Guardians' },
  { value: 'Detroit Tigers', label: 'Detroit Tigers' },
  { value: 'Kansas City Royals', label: 'Kansas City Royals' },
  { value: 'Minnesota Twins', label: 'Minnesota Twins' },
  { value: 'Houston Astros', label: 'Houston Astros' },
  { value: 'Los Angeles Angels', label: 'Los Angeles Angels' },
  { value: 'Oakland Athletics', label: 'Oakland Athletics' },
  { value: 'Seattle Mariners', label: 'Seattle Mariners' },
  { value: 'Texas Rangers', label: 'Texas Rangers' },
  { value: 'Atlanta Braves', label: 'Atlanta Braves' },
  { value: 'Miami Marlins', label: 'Miami Marlins' },
  { value: 'New York Mets', label: 'New York Mets' },
  { value: 'Philadelphia Phillies', label: 'Philadelphia Phillies' },
  { value: 'Washington Nationals', label: 'Washington Nationals' },
  { value: 'Chicago Cubs', label: 'Chicago Cubs' },
  { value: 'Cincinnati Reds', label: 'Cincinnati Reds' },
  { value: 'Milwaukee Brewers', label: 'Milwaukee Brewers' },
  { value: 'Pittsburgh Pirates', label: 'Pittsburgh Pirates' },
  { value: 'St. Louis Cardinals', label: 'St. Louis Cardinals' },
  { value: 'Arizona Diamondbacks', label: 'Arizona Diamondbacks' },
  { value: 'Colorado Rockies', label: 'Colorado Rockies' },
  { value: 'Los Angeles Dodgers', label: 'Los Angeles Dodgers' },
  { value: 'San Diego Padres', label: 'San Diego Padres' },
  { value: 'San Francisco Giants', label: 'San Francisco Giants' },
  { value: 'Atlanta Hawks', label: 'Atlanta Hawks' },
  { value: 'Boston Celtics', label: 'Boston Celtics' },
  { value: 'Brooklyn Nets', label: 'Brooklyn Nets' },
  { value: 'Charlotte Hornets', label: 'Charlotte Hornets' },
  { value: 'Chicago Bulls', label: 'Chicago Bulls' },
  { value: 'Cleveland Cavaliers', label: 'Cleveland Cavaliers' },
  { value: 'Dallas Mavericks', label: 'Dallas Mavericks' },
  { value: 'Denver Nuggets', label: 'Denver Nuggets' },
  { value: 'Detroit Pistons', label: 'Detroit Pistons' },
  { value: 'Golden State Warriors', label: 'Golden State Warriors' },
  { value: 'Houston Rockets', label: 'Houston Rockets' },
  { value: 'Indiana Pacers', label: 'Indiana Pacers' },
  { value: 'Los Angeles Clippers', label: 'Los Angeles Clippers' },
  { value: 'Los Angeles Lakers', label: 'Los Angeles Lakers' },
  { value: 'Memphis Grizzlies', label: 'Memphis Grizzlies' },
  { value: 'Miami Heat', label: 'Miami Heat' },
  { value: 'Milwaukee Bucks', label: 'Milwaukee Bucks' },
  { value: 'Minnesota Timberwolves', label: 'Minnesota Timberwolves' },
  { value: 'New Orleans Pelicans', label: 'New Orleans Pelicans' },
  { value: 'New York Knicks', label: 'New York Knicks' },
  { value: 'Oklahoma City Thunder', label: 'Oklahoma City Thunder' },
  { value: 'Orlando Magic', label: 'Orlando Magic' },
  { value: 'Philadelphia 76ers', label: 'Philadelphia 76ers' },
  { value: 'Phoenix Suns', label: 'Phoenix Suns' },
  { value: 'Portland Trail Blazers', label: 'Portland Trail Blazers' },
  { value: 'Sacramento Kings', label: 'Sacramento Kings' },
  { value: 'San Antonio Spurs', label: 'San Antonio Spurs' },
  { value: 'Toronto Raptors', label: 'Toronto Raptors' },
  { value: 'Utah Jazz', label: 'Utah Jazz' },
  { value: 'Washington Wizards', label: 'Washington Wizards' },
  { value: 'Arizona Cardinals', label: 'Arizona Cardinals' },
  { value: 'Atlanta Falcons', label: 'Atlanta Falcons' },
  { value: 'Baltimore Ravens', label: 'Baltimore Ravens' },
  { value: 'Buffalo Bills', label: 'Buffalo Bills' },
  { value: 'Carolina Panthers', label: 'Carolina Panthers' },
  { value: 'Chicago Bears', label: 'Chicago Bears' },
  { value: 'Cincinnati Bengals', label: 'Cincinnati Bengals' },
  { value: 'Cleveland Browns', label: 'Cleveland Browns' },
  { value: 'Dallas Cowboys', label: 'Dallas Cowboys' },
  { value: 'Denver Broncos', label: 'Denver Broncos' },
  { value: 'Detroit Lions', label: 'Detroit Lions' },
  { value: 'Green Bay Packers', label: 'Green Bay Packers' },
  { value: 'Houston Texans', label: 'Houston Texans' },
  { value: 'Indianapolis Colts', label: 'Indianapolis Colts' },
  { value: 'Jacksonville Jaguars', label: 'Jacksonville Jaguars' },
  { value: 'Kansas City Chiefs', label: 'Kansas City Chiefs' },
  { value: 'Las Vegas Raiders', label: 'Las Vegas Raiders' },
  { value: 'Los Angeles Chargers', label: 'Los Angeles Chargers' },
  { value: 'Los Angeles Rams', label: 'Los Angeles Rams' },
  { value: 'Miami Dolphins', label: 'Miami Dolphins' },
  { value: 'Minnesota Vikings', label: 'Minnesota Vikings' },
  { value: 'New England Patriots', label: 'New England Patriots' },
  { value: 'New Orleans Saints', label: 'New Orleans Saints' },
  { value: 'New York Giants', label: 'New York Giants' },
  { value: 'New York Jets', label: 'New York Jets' },
  { value: 'Philadelphia Eagles', label: 'Philadelphia Eagles' },
  { value: 'Pittsburgh Steelers', label: 'Pittsburgh Steelers' },
  { value: 'San Francisco 49ers', label: 'San Francisco 49ers' },
  { value: 'Seattle Seahawks', label: 'Seattle Seahawks' },
  { value: 'Tampa Bay Buccaneers', label: 'Tampa Bay Buccaneers' },
  { value: 'Tennessee Titans', label: 'Tennessee Titans' },
  { value: 'Washington Commanders', label: 'Washington Commanders' },
  { value: 'Anaheim Ducks', label: 'Anaheim Ducks' },
  { value: 'Arizona Coyotes', label: 'Arizona Coyotes' },
  { value: 'Boston Bruins', label: 'Boston Bruins' },
  { value: 'Buffalo Sabres', label: 'Buffalo Sabres' },
  { value: 'Calgary Flames', label: 'Calgary Flames' },
  { value: 'Carolina Hurricanes', label: 'Carolina Hurricanes' },
  { value: 'Chicago Blackhawks', label: 'Chicago Blackhawks' },
  { value: 'Colorado Avalanche', label: 'Colorado Avalanche' },
  { value: 'Columbus Blue Jackets', label: 'Columbus Blue Jackets' },
  { value: 'Dallas Stars', label: 'Dallas Stars' },
  { value: 'Detroit Red Wings', label: 'Detroit Red Wings' },
  { value: 'Edmonton Oilers', label: 'Edmonton Oilers' },
  { value: 'Florida Panthers', label: 'Florida Panthers' },
  { value: 'Los Angeles Kings', label: 'Los Angeles Kings' },
  { value: 'Minnesota Wild', label: 'Minnesota Wild' },
  { value: 'Montreal Canadiens', label: 'Montreal Canadiens' },
  { value: 'Nashville Predators', label: 'Nashville Predators' },
  { value: 'New Jersey Devils', label: 'New Jersey Devils' },
  { value: 'New York Islanders', label: 'New York Islanders' },
  { value: 'New York Rangers', label: 'New York Rangers' },
  { value: 'Ottawa Senators', label: 'Ottawa Senators' },
  { value: 'Philadelphia Flyers', label: 'Philadelphia Flyers' },
  { value: 'Pittsburgh Penguins', label: 'Pittsburgh Penguins' },
  { value: 'San Jose Sharks', label: 'San Jose Sharks' },
  { value: 'Seattle Kraken', label: 'Seattle Kraken' },
  { value: 'St. Louis Blues', label: 'St. Louis Blues' },
  { value: 'Tampa Bay Lightning', label: 'Tampa Bay Lightning' },
  { value: 'Toronto Maple Leafs', label: 'Toronto Maple Leafs' },
  { value: 'Vancouver Canucks', label: 'Vancouver Canucks' },
  { value: 'Vegas Golden Knights', label: 'Vegas Golden Knights' },
  { value: 'Washington Capitals', label: 'Washington Capitals' },
  { value: 'Winnipeg Jets', label: 'Winnipeg Jets' },
  { value: 'Atlanta United', label: 'Atlanta United' },
  { value: 'Austin FC', label: 'Austin FC' },
  { value: 'Charlotte FC', label: 'Charlotte FC' },
  { value: 'Chicago Fire', label: 'Chicago Fire' },
  { value: 'FC Cincinnati', label: 'FC Cincinnati' },
  { value: 'Colorado Rapids', label: 'Colorado Rapids' },
  { value: 'Columbus Crew', label: 'Columbus Crew' },
  { value: 'D.C. United', label: 'D.C. United' },
  { value: 'FC Dallas', label: 'FC Dallas' },
  { value: 'Houston Dynamo', label: 'Houston Dynamo' },
  { value: 'Sporting Kansas City', label: 'Sporting Kansas City' },
  { value: 'LA Galaxy', label: 'LA Galaxy' },
  { value: 'Los Angeles FC', label: 'Los Angeles FC' },
  { value: 'Inter Miami', label: 'Inter Miami' },
  { value: 'Minnesota United', label: 'Minnesota United' },
  { value: 'CF Montreal', label: 'CF Montreal' },
  { value: 'Nashville SC', label: 'Nashville SC' },
  { value: 'New England Revolution', label: 'New England Revolution' },
  { value: 'New York City FC', label: 'New York City FC' },
  { value: 'New York Red Bulls', label: 'New York Red Bulls' },
  { value: 'Orlando City', label: 'Orlando City' },
  { value: 'Philadelphia Union', label: 'Philadelphia Union' },
  { value: 'Portland Timbers', label: 'Portland Timbers' },
  { value: 'Real Salt Lake', label: 'Real Salt Lake' },
  { value: 'San Jose Earthquakes', label: 'San Jose Earthquakes' },
  { value: 'Seattle Sounders', label: 'Seattle Sounders' },
  { value: 'St. Louis City SC', label: 'St. Louis City SC' },
  { value: 'Toronto FC', label: 'Toronto FC' },
  { value: 'Vancouver Whitecaps', label: 'Vancouver Whitecaps' },
];

export const sportsPositionOptions = [
  { label: '3-on-3 Basketball', value: '3-on-3-basketball' },
  { label: 'Actors/ Actresses', value: 'actors-actresses' },
  { label: 'Archery', value: 'archery' },
  { label: 'Authors', value: 'authors' },
  { label: 'Badminton', value: 'badminton' },
  { label: 'Baseball', value: 'mens-baseball' },
  { label: 'BMX', value: 'bmx' },
  { label: 'Bowling', value: 'bowling' },
  { label: 'Business People', value: 'businesspeople' },
  { label: 'Canoeing/Kayaking', value: 'canoeing-kayaking' },
  { label: 'Car Racing', value: 'car-racing' },
  { label: 'Cheerleading', value: 'cheerleading' },
  { label: 'Coaches', value: 'coaches' },
  { label: 'Cornhole', value: 'cornhole' },
  { label: 'Cricket', value: 'cricket' },
  { label: 'Curling', value: 'curling' },
  { label: 'Cycling', value: 'cycling' },
  { label: 'Dance', value: 'dance' },
  { label: 'Darts', value: 'dart' },
  { label: 'Dodgeball', value: 'dodgeball' },
  { label: 'Dragon Boat Racing', value: 'dragon-boat-racing' },
  { label: 'E-Sports/ Gamers', value: 'e-sports-gamers' },
  { label: 'Equestrian', value: 'equestrian' },
  { label: 'Esports', value: 'esports' },
  { label: 'Fencing', value: 'fencing' },
  { label: 'Flag Football', value: 'flag-football' },
  { label: 'Frisbee Golf (Disc Golf)', value: 'frisbee-golf-disc-golf' },
  { label: 'Handball', value: 'handball' },
  { label: 'Ice Skating', value: 'ice-skating' },
  { label: 'Indoor Soccer', value: 'indoor-soccer' },
  { label: 'Influencers/ Creators', value: 'influencers-creators' },
  { label: 'Judo', value: 'judo' },
  { label: 'Karate', value: 'karate' },
  { label: 'Kickball', value: 'kickball' },
  { label: "Men's Baseball", value: 'mens-baseball' },
  { label: "Men's Basketball", value: 'mens-basketball' },
  { label: "Men's Boxing", value: 'mens-boxing' },
  { label: "Men's Cross Country", value: 'mens-cross-country' },
  { label: "Men's Fencing", value: 'mens-fencing' },
  { label: "Men's Football", value: 'mens-football' },
  { label: "Men's Golf", value: 'mens-golf' },
  { label: "Men's Gymnastics", value: 'mens-gymnastics' },
  { label: "Men's Ice Hockey", value: 'mens-ice-hockey' },
  { label: "Men's Lacrosse", value: 'mens-lacrosse' },
  { label: "Men's Rifle", value: 'mens-rifle' },
  { label: "Men's Rowing", value: 'mens-rowing' },
  { label: "Men's Skiing", value: 'mens-skiing' },
  { label: "Men's Soccer", value: 'mens-soccer' },
  { label: "Men's Swimming & Diving", value: 'mens-swimming-and-diving' },
  { label: "Men's Tennis", value: 'mens-tennis' },
  { label: "Men's Track and Field", value: 'mens-track-and-field' },
  { label: "Men's Volleyball", value: 'mens-volleyball' },
  { label: "Men's Water Polo", value: 'mens-water-polo' },
  { label: "Men's Wrestling", value: 'mens-wrestling' },
  { label: 'MMA/UFC', value: 'mma-ufc' },
  { label: 'Models', value: 'models' },
  { label: 'Motorsports', value: 'motorsports' },
  { label: 'Musicians', value: 'musicians' },
  { label: 'Paddle Tennis', value: 'paddle-tennis' },
  { label: 'Pickleball', value: 'pickleball' },
  { label: 'Politicians', value: 'politicians' },
  { label: 'Pool/Billiards', value: 'pool-billiards' },
  { label: 'Quadball/ Quidditch', value: 'quadball-quidditch' },
  { label: 'Racquetball', value: 'racquetball' },
  { label: 'Rafting', value: 'rafting' },
  { label: 'Rock Climbing', value: 'rock-climbing' },
  { label: 'Roller Derby', value: 'roller-derby' },
  { label: 'Rollerskating', value: 'rollerskating' },
  { label: 'Rugby', value: 'rugby' },
  { label: 'Sailing', value: 'sailing' },
  { label: 'Skateboarding', value: 'skateboarding' },
  { label: 'Slap Fighting', value: 'slap-fighting' },
  { label: 'Snowboarding', value: 'snowboarding' },
  { label: 'Softball', value: 'softball' },
  { label: 'Spikeball', value: 'spikeball' },
  { label: 'Squash', value: 'squash' },
  { label: 'Surfing', value: 'surfing' },
  { label: 'Synchronized Swimming', value: 'synchronized-swimming' },
  { label: 'Table Tennis', value: 'table-tennis' },
  { label: 'Taekwondo', value: 'taekwondo' },
  { label: 'Triathlon', value: 'triathlon' },
  { label: 'TV Personalities', value: 'tv-personalities' },
  { label: 'Ultimate Frisbee', value: 'ultimate-frisbee' },
  { label: 'Waterskiing', value: 'waterskiing' },
  { label: 'Weightlifting', value: 'weightlifting' },
  { label: 'Wiffle Ball', value: 'wiffle-ball' },
  { label: "Women's Basketball", value: 'womens-basketball' },
  { label: "Women's Beach Volleyball", value: 'womens-beach-volleyball' },
  { label: "Women's Bowling", value: 'womens-bowling' },
  { label: "Women's Boxing", value: 'womens-boxing' },
  { label: "Women's Cross Country", value: 'womens-cross-country' },
  { label: "Women's Fencing", value: 'womens-fencing' },
  { label: "Women's Field Hockey", value: 'womens-field-hockey' },
  { label: "Women's Golf", value: 'womens-golf' },
  { label: "Women's Gymnastics", value: 'womens-gymnastics' },
  { label: "Women's Ice Hockey", value: 'womens-ice-hockey' },
  { label: "Women's Lacrosse", value: 'womens-lacrosse' },
  { label: "Women's Rifle", value: 'womens-rifle' },
  { label: "Women's Rowing", value: 'womens-rowing' },
  { label: "Women's Skiing", value: 'womens-skiing' },
  { label: "Women's Soccer", value: 'womens-soccer' },
  { label: "Women's Softball", value: 'womens-softball' },
  { label: "Women's Swimming & Diving", value: 'womens-swimming-and-diving' },
  { label: "Women's Synchronized Swimming", value: 'womens-synchronized-swimming' },
  { label: "Women's Tennis", value: 'womens-tennis' },
  { label: "Women's Track and Field", value: 'womens-track-and-field' },
  { label: "Women's Triathlon", value: 'womens-triathlon' },
  { label: "Women's Volleyball", value: 'womens-volleyball' },
  { label: "Women's Water Polo", value: 'womens-water-polo' },
  { label: "Women's Wrestling", value: 'womens-wrestling' },
  { label: 'Writers/ Producers', value: 'writers-producers' },
];

const servicesDescription = {
  // Signature Services – Autographs
  Photo: 'Get an autographed photo from your favorite talent, perfect for any collection.',
  Poster: 'Own a signed poster featuring your favorite talent, a must-have for true fans.',
  'Trading Card': 'Collect an exclusive autographed trading card to add to your memorabilia',
  'Fan Provided Items': 'Send in your own item to be signed and personalized by the talent.',
  Custom: 'Receive a unique signed item chosen and provided by the talent.',

  // Shoutouts or Greetings
  'Birthday Shoutout':
    'Get a personalized birthday wish from the talent to make a special day even brighter!',
  'Anniversary Shoutout':
    'Celebrate love and milestones with a heartfelt anniversary message from the talent.',
  'Congratulatory Message':
    'Recognize achievements with a personalized congratulations from a star.',
  'Appreciation Shoutout': 'Show gratitude with a custom thank-you message from the talent.',
  'Holiday Shoutout':
    'Spread festive cheer with a special holiday greeting from your favorite talent.',
  'Engagement Announcement':
    'Make an engagement extra special with a heartfelt message from the talent.',
  'Retirement Congratulations': "Honor someone's career with a personalized retirement message.",
  'Motivational Message':
    'Get an inspiring message from the talent to encourage a fan, athlete, or student.',
  'Good Luck Message': 'Send someone a custom good luck shoutout before a big event or game.',
  'Wedding Shoutout': 'Surprise a couple with a wedding greeting from their favorite talent.',
  'Custom Shoutout': 'Enjoy a custom shoutout crafted by the talent in their own unique style',

  // Social Media
  'Facebook Post':
    'Get a dedicated Facebook post from the talent to showcase your brand or message.',
  'Facebook Story':
    'Feature your brand or message in a temporary yet impactful Facebook Story from the talent.',
  'Facebook 30-Minute Live Q&A':
    'Have the talent answer questions and engage with fans during a 30-minute interactive session.',
  'Instagram Post':
    'Have the talent share your brand or message in a high-visibility Instagram post.',
  'Instagram Reel':
    'Engage audiences with a creative and dynamic Instagram Reel featuring your brand or message.',
  'Instagram Reels':
    'Engage audiences with a creative and dynamic Instagram Reel featuring your brand or message.',
  'Instagram 30-Minute Live Q&A':
    'Have the talent answer questions and engage with fans during a 30-minute interactive session.',
  'Instagram Story':
    'Get noticed with a short-lived but impactful Instagram Story from the talent.',
  'Instagram Carousel Post':
    'Feature multiple images in a single Instagram post for maximum impact.',
  'Instagram Live Feature':
    'Have the talent mention or showcase your brand during an Instagram Live session.',
  'Snapchat Spotlight':
    'Reach a wider audience with a featured Snapchat Spotlight created by the talent.',
  'Snapchat Story':
    'Get your brand or message featured in an engaging Snapchat Story from the talent.',
  'YouTube Post': 'Gain exposure with a dedicated YouTube post featuring your brand or message.',
  'YouTube Shorts': 'Get a quick, engaging promotional video posted on YouTube Shorts.',
  'YouTube 30-Minute Live Q&A':
    'Have the talent answer questions and engage with fans during a 30-minute interactive session.',

  // Video/Audio/Photo Creation
  'Product Testing': 'Receive a custom video of the talent testing and reviewing your product.',
  'Photo Creation':
    'Have the talent create and share a unique photo featuring your product or brand.',
  'Video Creation with Audio':
    'Get a custom video with audio, crafted by the talent to highlight your brand or message.',
  'Audio Creation':
    'Receive a unique audio recording from the talent, perfect for branding or special projects.',
  'Unboxing Video': 'Have the talent film an engaging unboxing of your product.',
  'How-To Video':
    'Get a custom instructional video featuring the talent demonstrating a product or skill.',
  'Voiceover Recording':
    'Receive a professional voiceover recorded by the talent for your project.',
  'Podcast Clip':
    'Get a short podcast-style audio clip featuring the talent discussing a topic of choice.',
  'Behind-the-Scenes Video':
    'Have the talent create exclusive behind-the-scenes content for your brand.',
  'Fitness Demonstration Video': 'Get a workout or sports training video from the talent.',

  // TikTok
  'TikTok Post':
    'Get a custom TikTok video from the talent to engage their audience with your brand or message.',
  'TikTok Live Mention':
    'Have the talent showcase your product or brand during a TikTok Live session',
  'TikTok 30-Minute Live Q&A':
    'Have the talent answer questions and engage with fans during a 30-minute interactive session.',

  // LinkedIn
  'LinkedIn Post':
    'Have the talent share a professional LinkedIn post to highlight your brand or achievement.',
  'LinkedIn Article':
    'Have the talent publish a professional article discussing your brand or industry.',
  'LinkedIn Recommendation': 'Receive a professional endorsement from the talent on LinkedIn.',

  // Twitter
  'Twitter Post':
    'Gain visibility with a dedicated tweet from the talent featuring your brand or message.',
  'Twitter Video': 'Get a custom video tweet from the talent to maximize engagement and exposure.',
  'Twitter Spaces Feature':
    'Have the talent mention your brand or join a discussion in a Twitter Spaces session.',
  'Twitter Pinned Tweet':
    'Get your brand or message temporarily pinned to the top of the talent profile for maximum exposure.',
  'Twitter Poll': 'Have the talent create a poll featuring your brand or product for engagement.',
  'Twitter Giveaway Collaboration':
    'Run a promotional giveaway with the talent’s Twitter audience.',

  // Pinterest
  'Pinterest Pin':
    'Get your product or service featured in a dedicated Pinterest post by the talent.',
  'Pinterest Pinterest Pin':
    'Get your product or service featured in a dedicated Pinterest post by the talent.',

  // Meta (Threads)
  'Meta Threads Post':
    'Get exposure with a dedicated post from the talent on Meta’s Threads platform.',

  // Appearances
  'Meet and Greet': 'Connect with the talent for a personal and memorable interaction.',
  'Skill Demonstration': 'Watch the talent showcase their expertise in an exclusive session.',
  'Digital Interview':
    'Conduct a virtual interview with the talent for your media or content needs.',
  'In-person Interview':
    'Conduct an in-person interview with the talent for your media or content needs.',
  Speech: 'Have the talent deliver an inspiring speech at your event or gathering.',
  Podcast: 'Feature the talent as a guest on your podcast for engaging conversation and insights.',
  'Production Shoot':
    'Book the talent for a professional photo or video shoot to enhance your project.',
  'Autograph Session':
    'Host a live autograph signing event with the talent for fans and collectors.',
  'Golf Outing': 'Enjoy a round of golf with the talent for a unique and exclusive experience.',
  'Watch Party': 'Watch a game or event alongside the talent for an unforgettable experience.',
  'Game Appearance': 'Have the talent attend your game to engage with fans and create excitement.',
  'Practice Appearance':
    'Bring the talent to a practice session for motivation, mentorship, or inspiration.',
  'Camp Participation':
    'Have the talent join your camp to engage with attendees and share expertise.',
  'Virtual Classroom Visit': 'Have the talent join a classroom virtually to inspire students.',
  'Fundraising Event Appearance':
    'Boost engagement at a charity or fundraising event with a talent appearance.',
  'Halftime Appearance':
    'Feature the talent during a halftime show for an exciting fan experience.',
  'Media Day Appearance':
    'Have the talent participate in your media day for interviews and promotions.',
  'Esports Event Appearance':
    'Bring the talent to an esports competition to engage with fans and players.',

  // Enhanced Services – Exclusive Training
  '1-on-1 Coaching':
    'Get personalized training and expert guidance from the talent to enhance your skills.',
  'Group Training': 'Train alongside others in an exclusive session led by the talent.',
  'Film Breakdown Session': 'Get a detailed video analysis of gameplay or skills from the talent.',
  'Virtual Training Camp':
    'Train with the talent in an online session designed for skill development.',

  // Mentorship
  'Mentorship Discussion': 'Stay on track with regular mentorship and advice from the talent.',
  'Skill Development': 'Receive tailored guidance to refine and improve your abilities.',
  'Career Development Mentorship':
    'Get professional guidance from the talent on career growth and opportunities.',
  'Athlete Branding Consultation':
    'Learn from the talent about building a personal brand in sports.',
  'Mental Toughness Coaching':
    'Receive advice and techniques on mindset and resilience from the talent.',
  'Sponsorship Consultation':
    'Receive insights from the talent on securing sponsorships and brand partnerships.',

  // Business Development
  'Networking Sessions': 'Connect with industry professionals accompanied by the talent.',
  'Corporate Event': 'Elevate your event with a special appearance by the talent.',
  'Panel Discussion Participation':
    'Invite the talent to join a business panel to share industry insights and experiences.',

  // Content Creation
  'Custom Videos': 'Get a unique video created by the talent, tailored to your needs.',
  'Custom Articles':
    'Have the talent craft an exclusive article featuring insights or a special message.',
  'Behind-the-Scenes Documentary': 'Get a mini-documentary showcasing the talent and your brand.',
  'Q&A Video Feature': 'Have the talent answer questions about your brand, product, or industry.',

  // Social Media Enhanced Services
  'Exclusive Content': 'Access behind-the-scenes or premium content shared directly by the talent.',
  'Live Q&A': 'Interact with the talent in a live session where they answer your questions.',

  // Custom Options
  'Custom Options': 'Receive a unique experience personally designed by the talent.',
};

// Helper function to retrieve talent service description by title/key
export const getTalentServiceDescription = enumKey => {
  return servicesDescription[enumKey];
};

export const autographsOptions = [
  {
    key: 'photo',
    label: 'Photo',
    tooltip: 'Offer fans an autographed photo, perfect for their collection.',
  },
  {
    key: 'tradingCard',
    label: 'Trading Card',
  },
  {
    key: 'poster',
    label: 'Poster',
  },
  {
    key: 'showFanProvidedItems',
    label: 'Fan or Brand Provided Item',
  },
  {
    key: 'custom',
    label: 'Custom Talent Provided',
  },
];
